// IKOGNIT i18n — 19 idiomas, ~1491 claves cada uno (ES/EN fuente). Si una clave falta, fallback a inglés y luego español.

export type Locale = 'es' | 'en' | 'pt' | 'fr' | 'it' | 'de' | 'nl' | 'pl' | 'cs' | 'hu' | 'ro' | 'el' | 'ru' | 'uk' | 'zh' | 'ja' | 'ar' | 'hi' | 'ko';

export const LOCALES: Array<{ code: Locale; native: string; flag: string }> = [
  { code: 'es', native: "Español", flag: "🇪🇸" },
  { code: 'en', native: "English", flag: "🇬🇧" },
  { code: 'pt', native: "Português", flag: "🇵🇹" },
  { code: 'fr', native: "Français", flag: "🇫🇷" },
  { code: 'it', native: "Italiano", flag: "🇮🇹" },
  { code: 'de', native: "Deutsch", flag: "🇩🇪" },
  { code: 'nl', native: "Nederlands", flag: "🇳🇱" },
  { code: 'pl', native: "Polski", flag: "🇵🇱" },
  { code: 'cs', native: "Čeština", flag: "🇨🇿" },
  { code: 'hu', native: "Magyar", flag: "🇭🇺" },
  { code: 'ro', native: "Română", flag: "🇷🇴" },
  { code: 'el', native: "Ελληνικά", flag: "🇬🇷" },
  { code: 'ru', native: "Русский", flag: "🇷🇺" },
  { code: 'uk', native: "Українська", flag: "🇺🇦" },
  { code: 'zh', native: "简体中文", flag: "🇨🇳" },
  { code: 'ja', native: "日本語", flag: "🇯🇵" },
  { code: 'ar', native: "العربية", flag: "🇸🇦" },
  { code: 'hi', native: "हिन्दी", flag: "🇮🇳" },
  { code: 'ko', native: "한국어", flag: "🇰🇷" },
];

// Idiomas que se escriben de derecha a izquierda. El layout debe poner
// `dir="rtl"` en <html> cuando el locale actual sea uno de éstos. La capa
// de presentación (App.tsx / layout root) lee esta lista vía isRTL(locale).
// NOTA CSS: si el layout no aplica `dir="rtl"` al <html>, los componentes
// se verán LTR aunque el texto sea árabe. Pendiente: añadir wiring en App.tsx.
export const RTL_LOCALES: ReadonlyArray<Locale> = ['ar'];

type Catalog = Record<string, string>;

const es: Catalog = {
  "auth.verify.notSent": "No hemos podido enviarte el código. Tu cuenta está creada: pulsa «Reenviar código» en un momento.",
  "lg.rotulo": "Mensajería con espacios privados",
  "lg.btn.entrar": "Entrar",
  "lg.eyebrow": "Mensajería privada · Itrion Software",
  "lg.h1a": "Tus conversaciones de siempre.",
  "lg.h1b": "Y un sitio que solo existe cuando lo invocas.",
  "lg.lead1": "Hablas con tu familia, con tus amigos y con tu equipo, como en cualquier app. La diferencia empieza cuando abres un IKO: un espacio propio al que se entra escribiendo un secreto que solo conocéis los que estáis dentro.",
  "lg.lead2": "Mientras no lo invocas, ese espacio no está en tu dispositivo —ni en el móvil, ni en la tablet, ni en el ordenador—. No es que esté cifrado.",
  "lg.lead2b": "Es que no está.",
  "lg.pruebalo": "Pruébalo tú mismo · escribe un secreto y mira qué pasa",
  "lg.panel.plano": "Plano general",
  "lg.demo.hilos": "Familia=Mamá: ¿cenamos el domingo en casa?=19:04|Marta=te mando las fotos del sábado=17:52|Equipo=Luis: mañana a las nueve, entonces=Ayer|Javi=jajaja no me lo creo=Ayer",
  "lg.demo.mundos": "Solo nosotros dos~¿lo guardaste donde dijimos?|sí. las escrituras y el pasaporte>~Escrituras del piso.pdf=2,4 MB|Fotos privadas=214|Tarjeta · banco=Datos~~Cosas de casa~te dejo aquí el contrato del alquiler>|y la clave del router, que siempre la pierdes~Contrato de alquiler.pdf=1,1 MB|Copia del DNI=2 archivos|Claves de casa=Datos~~Mis apuntes~esto no se lo he contado a nadie>|y no hace falta que se lo cuente>~Diario=48 notas|Fotos=1.207|Cuentas del año=Datos~~Proyecto Lisboa~la oferta sale por 180|aquí la tienes, sin copias fuera>~Oferta_v4.pdf=860 KB|Contactos=12|Tarjeta de empresa=Datos~~La comida del sábado~no le digas nada a Marta todavía|tranquilo, aquí no se entera nadie>~Reserva.pdf=120 KB|Fotos del año pasado=63|Lista de invitados=Datos",
  "lg.invocaLabel": "Invoca tu IKO",
  "lg.invocaPlaceholder": "escribe un secreto cualquiera",
  "lg.invocaBtn": "Invocar",
  "lg.invocaHint": "Cada palabra lleva a un espacio distinto. Prueba con otra.",
  "lg.estela.vacio": "Escribe cualquier cosa: aquí es una demostración.",
  "lg.estela.primero": "Invocado. Existe solo mientras estás dentro.",
  "lg.estela.otro": "Otro secreto, otro espacio. Ninguno sabe de los demás.",
  "lg.estela.salida": "Se ha ido. No queda rastro en el dispositivo. Prueba con otra palabra.",
  "lg.ikoActivo": "IKO activo",
  "lg.nadaEnDispositivo": "Nada de esto está en el dispositivo",
  "lg.salirIko": "Salir del IKO",
  "lg.planos.h2a": "Un plano a la vista.",
  "lg.planos.h2b": "Debajo, los que tú invoques.",
  "lg.planos.lead": "No hay «un IKO». Hay los que abras: uno para lo de casa, otro para el trabajo, otro que solo conocéis dos personas, otro del que no le has hablado a nadie. Cada secreto lleva al suyo, y ninguno sabe de los demás.",
  "lg.planos.unoRotulo": "El plano general · uno",
  "lg.planos.unoH3": "Donde hablas con todo el mundo",
  "lg.planos.unoP": "Conversaciones, grupos, llamadas, fotos y archivos, cifrados de extremo a extremo. Lo que esperas de una app de mensajería, hecho bien. Tus chats de siempre viven aquí y se comportan como siempre.",
  "lg.planos.nRotulo": "Los IKO · los que quieras",
  "lg.planos.nH3": "Donde no llega nadie más",
  "lg.planos.nP": "Escribes un secreto y aparece el espacio que le corresponde. Dentro caben conversaciones y tus cosas. Cuando sales, se va del dispositivo sin dejar rastro. No hay lista, no hay número y nadie puede averiguar cuántos tienes, ni que exista ninguno.",
  "lg.planos.chips": "Lo de casa|El trabajo|Lo que solo sabéis dos|Lo tuyo y de nadie más|El que abriste una vez y no has vuelto a tocar|Los que decidas mañana",
  "lg.forense.h2a": "No está cifrado en tu dispositivo.",
  "lg.forense.h2b": "No está en tu dispositivo.",
  "lg.forense.lead": "Las demás apps guardan tus mensajes en el aparato y los cifran. Si alguien se lo lleva, tu privacidad depende de que ese cifrado aguante el tiempo suficiente. Aquí no hay nada que tenga que aguantar: lo que vive dentro de un IKO no se escribe en ningún dispositivo. Se invoca, se usa y se va.",
  "lg.forense.multi": "Vale para todos por igual: móvil, tablet, ordenador de casa, portátil del trabajo, Windows, Mac o el navegador de un sitio ajeno. Entras donde quieras y, al salir, ese sitio vuelve a no saber nada de ti.",
  "lg.forense.caption": "Lo que encuentra quien examina cualquiera de tus dispositivos",
  "lg.forense.filas": "Mensajes de tus IKO=0|Archivos y fotos de tus IKO=0|Secretos de IKO guardados=0|Base de datos con tus IKO=no existe|Rastro de que un IKO estuvo abierto=ninguno|Cuántos IKO tienes=indeterminable",
  "lg.escenas.h2": "Lo que de verdad te preocupa.",
  "lg.escenas.filas": "«He perdido el móvil.»=Tu privacidad no se ha perdido con él. Lo que estaba dentro de un IKO nunca estuvo en ese aparato, así que no hay nada que rescatar ni nada que temer. Lo invocas desde cualquier otro dispositivo y sigue todo donde estaba.~«Alguien ha cogido mi portátil.»=Verá tus conversaciones normales, las mismas que vería en cualquier app. De lo demás no verá el contenido, ni el nombre, ni el indicio de que exista.~«Me han examinado el ordenador.»=Un análisis forense recupera lo que está escrito en el disco, aunque esté cifrado y borrado. Aquí no hay nada escrito que recuperar. La respuesta no es «no se puede descifrar»: es que no hay nada. Y lo mismo en la tablet, en el móvil y en el navegador que usaste una tarde.",
  "lg.ciego.h2": "Ni nosotros. Ni quien aloja los servidores.",
  "lg.ciego.p1": "El servidor guarda cosas que no puede leer. No tiene tu secreto, no lo ha tenido nunca y no existe ninguna copia en ninguna parte. No es que nos neguemos a entregar lo que hay dentro de tus IKO: es que no lo tenemos, y no hay forma de que lo tengamos. Tampoco la empresa que aloja las máquinas, ni nadie que pusiera la mano encima de ellas.",
  "lg.ciego.p2": "Eso tiene su precio y es justo decirlo: si pierdes tu secreto, no hay quien te lo devuelva. La misma razón por la que nadie más puede entrar es la razón por la que nosotros tampoco podemos ayudarte a entrar.",
  "lg.guardas": "Fotos de familia|Los apuntes que no enseñas|Tarjetas y datos bancarios|Contraseñas|Documentos|Conversaciones que solo os incumben",
  "lg.nombre.esta": "está",
  "lg.nombre.noEsta": "no está",
  "lg.nombre.h2": "De ahí el nombre.",
  "lg.nombre.p": "En suajili, iko significa «está» y haiko, «no está». Un IKO está mientras lo invocas. El resto del tiempo —que es casi todo el tiempo— no está: ni en tus dispositivos, ni a la vista de nadie, ni como sospecha.",
  "lg.cierre.h2": "Empieza a hablar.",
  "lg.cierre.p": "Se usa como cualquier app de mensajería, en el móvil, en la tablet y en el ordenador. Los IKO están ahí el día que los necesites.",
  "lg.cierre.btnCrear": "Crear cuenta",
  "lg.cierre.btnEntrar": "Ya tengo cuenta",
  "lg.cierre.pago": "IKOGNIT es un producto de pago. No hay anuncios, no hay perfiles publicitarios y no hay una copia nuestra de nada: vivimos de que la app te merezca la pena, no de lo que puedas contar dentro de ella.",
  "lg.pie.ciego": "Servidor ciego",
  "auth.hola": "Hola otra vez.",
  "auth.queEs": "¿Qué es IKOGNIT?",
  "common.cancel": "Cancelar",
  "common.error.generic": "No se ha podido. Vuelve a intentarlo.",
  "common.save": "Guardar",
  "common.confirm": "Confirmar",
  "common.close": "Cerrar",
  "common.prev": "Anterior",
  "common.next": "Siguiente",
  "common.loading": "Cargando…",
  "common.add": "Añadir",
  "common.back": "Volver",
  "common.edit": "Editar",
  "common.tagline": "Soberanía digital.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "En suajili, iko es «está». Y haiko, «no está».",
  "auth.legal.age": "Confirmo que tengo la edad mínima exigida por la ley de mi país para usar IKOGNIT.",
  "auth.legal.accept": "He leído y acepto los <a href='https://ikognit.org/legal/terminos.html' target='_blank' rel='noopener'>Términos</a>, la <a href='https://ikognit.org/legal/privacidad.html' target='_blank' rel='noopener'>Política de Privacidad</a> y las <a href='https://ikognit.org/legal/normas.html' target='_blank' rel='noopener'>Normas de la Comunidad</a>.",
  "report.title": "Reportar usuario",
  "report.targetSubtitle": "Reportando a {0}",
  "report.intro": "Tu reporte se envía al equipo de moderación de IKOGNIT. Los mensajes están cifrados E2E y nunca los vemos — el reporte se basa en tu palabra, así que descríbelo con claridad.",
  "report.reasonLegend": "Motivo del reporte",
  "report.detailLabel": "Detalles (opcional)",
  "report.detailPlaceholder": "Qué pasó, cuándo, cualquier contexto que ayude a investigar.",
  "report.autoBlockNotice": "Al enviar el reporte, también bloquearás a este usuario. No podrá enviarte más mensajes.",
  "report.sending": "Enviando…",
  "report.submit": "Enviar reporte",
  "report.success": "Reporte enviado. El usuario queda bloqueado.",
  "report.reason.spam": "Spam",
  "report.reason.spam.desc": "Mensajes masivos, publicidad no solicitada, enlaces sospechosos.",
  "report.reason.harassment": "Acoso o insultos",
  "report.reason.harassment.desc": "Mensajes intimidatorios, ataques personales, hostigamiento.",
  "report.reason.hate": "Discurso de odio",
  "report.reason.hate.desc": "Contenido racista, xenófobo, sexista, homofóbico o similar.",
  "report.reason.csam": "Material de abuso infantil",
  "report.reason.csam.desc": "Cualquier contenido relacionado con menores. Máxima prioridad.",
  "report.reason.violence": "Amenazas o violencia",
  "report.reason.violence.desc": "Amenazas físicas, incitación a la violencia, autolesiones.",
  "report.reason.illegal": "Actividad ilegal",
  "report.reason.illegal.desc": "Tráfico, armas, drogas u otra conducta ilegal.",
  "report.reason.impersonation": "Suplantación",
  "report.reason.impersonation.desc": "Se hace pasar por otra persona u organización real.",
  "report.reason.other": "Otro motivo",
  "report.reason.other.desc": "Cualquier comportamiento que no encaja arriba.",
  "recovery.title": "Tu clave de recuperación",
  "recovery.intro": "Estas **24 palabras** son la única forma de recuperar tu cuenta y el historial si olvidas la contraseña o pierdes el dispositivo. **Apúntalas en papel y guárdalas en un lugar seguro.** Nadie en IKOGNIT puede recuperarlas por ti.",
  "recovery.warn": "**Anótalas OFFLINE.** No las hagas captura de pantalla. No las envíes por email ni mensajería. Quien tenga estas palabras controla tu cuenta entera.",
  "recovery.btn.show": "Mostrar palabras",
  "recovery.btn.copy": "Copiar",
  "recovery.btn.copied": "Copiado · se borra en {0}s",
  "recovery.btn.cleared": "Clipboard limpiado",
  "recovery.btn.copyAria": "Copiar la frase de recuperación al portapapeles (se borrará automáticamente)",
  "recovery.btn.download": "Descargar",
  "recovery.btn.downloadAria": "Descargar la frase como archivo de texto",
  "recovery.btn.back": "Volver a ver las palabras",
  "recovery.btn.continue": "Continuar",
  "recovery.btn.done": "He terminado",
  "recovery.btn.need3": "Escribe las 3 palabras correctas",
  "recovery.verify.intro": "Para confirmar que has guardado tu clave, escribe estas palabras. No podrás continuar sin acertarlas.",
  "recovery.verify.wordN": "Palabra #{0}",
  "recovery.verify.correct": "Correcto",
  "recovery.verify.wrong": "Incorrecto",
  "auth.error.legalRequired": "Debes aceptar los términos legales y confirmar tu edad para crear tu cuenta.",
  "auth.error.pwShort": "La contraseña debe tener al menos 10 caracteres.",
  "auth.error.pwMismatch": "Las claves maestras no coinciden.",
  "auth.error.pwWeak": "La contraseña no cumple los requisitos de seguridad.",
  "auth.field.passwordConfirm": "Repite la contraseña",
  "auth.pw.req.length": "Mínimo 10 caracteres",
  "auth.pw.req.lower": "Una letra minúscula",
  "auth.pw.req.upper": "Una letra mayúscula",
  "auth.pw.req.digit": "Un número",
  "auth.pw.req.symbol": "Un símbolo (!@#$%…)",
  "auth.pw.req.match": "Las contraseñas coinciden",
  "auth.forgot": "¿Olvidaste tu contraseña?",
  "recover.title": "Recupera tu acceso",
  "recover.intro": "Escribe tu nick o email y las 24 palabras de recuperación que se te dieron al crear la cuenta. Después elegirás una contraseña nueva.",
  "recover.field.username": "Nick o email",
  "recover.field.phrase": "Tus 24 palabras de recuperación",
  "recover.field.phrasePlaceholder": "palabra1 palabra2 palabra3 …",
  "recover.field.newPassword": "Nueva contraseña",
  "recover.field.newPasswordConfirm": "Repite la nueva contraseña",
  "recover.btn.submit": "Recuperar mi acceso",
  "recover.btn.cancel": "Volver al inicio de sesión",
  "recover.error.invalidPhrase": "Esas 24 palabras no son válidas. Revisa que sean exactamente las que te mostramos.",
  "recover.error.notFound": "No encontramos esa combinación de cuenta y palabras de recuperación.",
  "recover.error.notEnabled": "Esta cuenta no tiene recuperación activada. Entra con tu contraseña y actívala desde Ajustes.",
  "settings.legal.title": "Información legal",
  "settings.legal.hint": "Léelo dentro de la app. Funciona sin conexión una vez visto.",
  "explorer.add.paste": "Pegar del portapapeles",
  "paste.unsupported": "Pegar no está soportado en este dispositivo.",
  "paste.noImage": "No hay imagen en el portapapeles.",
  "paste.permissionDenied": "Permiso denegado para leer el portapapeles.",
  "paste.failed": "No se pudo pegar.",
  "legal.loading": "Cargando documento…",
  "legal.loadError": "No se pudo cargar el documento. Comprueba tu conexión o ábrelo en el navegador.",
  "legal.openExternal": "Abrir en el navegador",
  "legal.fromCache": "Mostrando versión en caché — actualizando…",
  "settings.legal.hub": "Centro Legal",
  "settings.legal.terms": "Términos y Condiciones",
  "settings.legal.purchase": "Condiciones de compra",
  "settings.legal.privacy": "Política de Privacidad",
  "settings.legal.rules": "Normas de la Comunidad",
  "settings.legal.report": "Denuncias y Moderación",
  "settings.legal.cookies": "Política de Cookies",
  "settings.legal.minors": "Política de Menores",
  "settings.legal.notice": "Aviso Legal",
  "settings.tab.legal": "Legal",
  "auth.loading": "Cargando…",
  "auth.savedSession": "Este dispositivo ya reconoce a su dueño.",
  "auth.tab.login": "Entrar",
  "auth.tab.register": "Crear cuenta",
  "auth.subLogin": "Entras al plano general: tus conversaciones de siempre. Tus IKO no se invocan aquí — se invocan dentro, cuando los necesites.",
  "auth.demo.enter": "Entrar en la cuenta demo (App Review)",
  "auth.demo.hint": "Acceso de un toque a una cuenta demo ya poblada (chat, archivos, Unidad y wallet). No hace falta escribir credenciales.",
  "auth.subRegister": "La cuenta queda a tu nombre. El nick es como te ven; el email solo sirve para recuperar el acceso y para avisos.",
  "auth.field.devicePin": "PIN del dispositivo",
  "dominio.suspendido.duena": "Hay un recibo pendiente. Ponlo al día y todo vuelve tal cual: aquí dentro no se ha tocado nada.",
  "dominio.suspendido.pagar": "Ir al pago",
  "comprar.enlace": "Quiero un dominio",
  "comprar.title": "Un dominio propio",
  "comprar.sub": "Un servidor con sus propios habitantes. Se paga por adelantado; se cancela cuando quieras y sigue activo hasta el final del periodo pagado.",
  "comprar.nombre": "Nombre",
  "comprar.nombrePlaceholder": "tu-casa",
  "comprar.email": "Correo de facturación",
  "comprar.libre": "libre",
  "comprar.ocupado": "ocupado",
  "comprar.formato": "minúsculas, números y guiones",
  "comprar.aviso": "El dominio se crea al confirmarse el pago. La primera cuenta que entre queda como su dueña, y solo este correo puede abrirla.",
  "comprar.periodicidad": "Cada mes, hasta que lo canceles.",
  "comprar.plan": "Plan",
  "comprar.periodo": "Cada cuánto se paga",
  "comprar.periodo.mes": "Mensual",
  "comprar.periodo.trimestre": "Trimestral",
  "comprar.periodo.ano": "Anual",
  "comprar.hastaN": "hasta {0}",
  "comprar.sinImpuestos": "Sin impuestos. El total se calcula con tu país.",
  "comprar.base": "Base",
  "comprar.impuesto": "Impuesto ({0}%)",
  "comprar.total": "Total",
  "comprar.aQuienFactura": "A nombre de quién",
  "comprar.tipo.particular": "Particular",
  "comprar.tipo.empresa": "Empresa",
  "comprar.nombreFiscal": "Nombre",
  "comprar.apellidos": "Apellidos",
  "comprar.razonSocial": "Razón social",
  "comprar.nif": "NIF o CIF",
  "comprar.nifOpcional": "opcional",
  "comprar.pais": "País",
  "comprar.paisElige": "Elige un país",
  "comprar.via": "Dirección",
  "comprar.cp": "Código postal",
  "comprar.ciudad": "Ciudad",
  "comprar.vendedor": "Vende ITRION SOFTWARE, S.L. · CIF B19913797 · Calle Francisco Silvela 110, planta 2, 28028 Madrid",
  "comprar.acepta": "He leído y acepto las <a href=\"https://ikognit.org/legal/condiciones-compra.html\" target=\"_blank\" rel=\"noopener\">condiciones de compra</a> y la <a href=\"https://ikognit.org/legal/privacidad.html\" target=\"_blank\" rel=\"noopener\">política de privacidad</a>. Pido que el servicio empiece ya y entiendo que por eso pierdo el derecho de desistimiento de 14 días.",
  "comprar.pagar": "Pagar",
  "comprar.cobrando": "Cobrando…",
  "comprar.confirmando": "Confirmando el pago…",
  "comprar.tardando": "El pago se ha hecho, pero la confirmación está tardando. Te llega la factura por correo; entra en unos minutos con el nombre del dominio.",
  "comprar.btn": "Continuar",
  "comprar.proximamente": "Próximamente.",
  "auth.field.dominio": "Dominio",
  "auth.field.dominioPlaceholder": "Vacío: IKOGNIT",
  "auth.field.invitacion": "Código de invitación",
  "auth.error.dominioSuspendido": "El dominio está suspendido. Habla con su dueño.",
  "dominio.title": "Dominio",
  "dominio.estado.activo": "Al día",
  "dominio.estado.gracia": "Hay un recibo pendiente.",
  "dominio.estado.congelado": "Suspendido",
  "dominio.gracia.aviso": "Queda un recibo por pagar. Todo sigue funcionando hasta el {0}.",
  "dominio.seccion.miembros": "Quién tiene entrada",
  "dominio.seccion.registro": "Registro",
  "dominio.seccion.invitaciones": "Invitaciones",
  "dominio.seccion.facturacion": "Facturación",  "dominio.seccion.facturas": "Facturas",
  "dominio.facturas.vacio": "Todavía no hay ninguna.",
  "dominio.facturas.hasta": "Pagado hasta el {0}.",
  "dominio.facturas.impuesto": "{0}% · {1}",
  "dominio.facturas.isp": "Inversión del sujeto pasivo",
  "dominio.facturas.sinImpuesto": "Sin impuesto",
  "dominio.facturas.metodoPago": "Cambiar la tarjeta",
  "dominio.facturas.pdf": "PDF",

  "dominio.seccion.llave": "La llave del dominio",
  "dominio.seccion.propiedad": "Propiedad",
  "dominio.miembros.alta": "Entró el {0}",
  "dominio.miembros.dueno": "Dueño",
  "dominio.miembros.retirar": "Retirar la entrada",
  "dominio.miembros.retirarConfirm": "Se le retira la entrada al instante.",
  "dominio.miembros.vacio": "Nada todavía. Los que invites aparecen aquí.",
  "dominio.registro.invitacion": "Solo por invitación",
  "dominio.registro.abierto": "Abierto",
  "dominio.registro.explica": "Con invitación, entra quien tú dejes entrar.",
  "dominio.invitaciones.nueva": "Nueva invitación",
  "dominio.invitaciones.usos": "Usos",
  "dominio.invitaciones.dias": "Días",
  "dominio.invitaciones.enlace": "Enlace",
  "dominio.invitaciones.copiar": "Copiar",
  "dominio.invitaciones.copiado": "Copiado",
  "dominio.invitaciones.gastadas": "{0} de {1} usados",
  "dominio.invitaciones.vacio": "Nada todavía.",
  "dominio.invitaciones.borrar": "Anular",
  "dominio.llave.explica": "Cada dispositivo del dominio la recibe al entrar. Guárdala tú también.",
  "dominio.llave.ver": "Ver la llave",
  "dominio.llave.copiar": "Copiar la llave",
  "dominio.transferir": "Transferir la propiedad",
  "dominio.transferir.explica": "La propiedad pasa a otro miembro. Deja de ser tuyo.",
  "dominio.transferir.confirma": "Escribe {0} para confirmar.",
  "dominio.esfumar": "Esfumar el dominio",
  "dominio.esfumar.aviso": "Esto se esfuma. No queda copia, ni rastro, ni reclamación.",
  "dominio.esfumar.palabra": "ESFUMAR",
  "dominio.limite": "Lo que este panel no puede enseñar: qué se dice, qué IKO existen, quién habla con quién, qué hay guardado. El dueño ve quién tiene entrada. Nada más.",
  "auth.field.identifier": "Email o nick",
  "auth.field.identifierPlaceholder": "tu@email.com o tu_nick",
  "auth.field.nick": "Nick",
  "auth.reg.paso1": "Empezamos por tu correo. Te enviaremos un código para comprobar que es tuyo; el resto viene después.",
  "auth.reg.enviarCodigo": "Enviarme el código",
  "auth.reg.paso3.title": "Ya casi está",
  "auth.reg.paso3.sub": "Correo verificado: {0}. Ahora elige cómo te van a ver y una contraseña.",
  "auth.field.email": "Email",
  "auth.field.nickPlaceholder": "ej. user123",
  "auth.field.emailPlaceholder": "tu@email.com",
  "auth.field.newPassword": "Nueva contraseña",
  "auth.field.password": "Contraseña",
  "auth.nick.available": "disponible",
  "auth.nick.checking": "comprobando…",
  "auth.nick.taken": "ya está ocupado",
  "auth.nick.invalid": "no válido (3-20 chars, a-z, 0-9, _)",
  "auth.error.nickTaken": "Ese nick ya está ocupado.",
  "auth.error.emailTaken": "Ya existe una cuenta con ese email.",
  "auth.error.invalidNick": "Nick no válido. Usa 3-20 caracteres: a-z, 0-9 y _ (sin empezar/acabar en _).",
  "auth.error.invalidEmail": "Email no válido.",
  "auth.error.badCode": "Código incorrecto.",
  "auth.error.codeExpired": "El código ha caducado. Pide uno nuevo.",
  "auth.error.tooManyAttempts": "Demasiados intentos. Pide un código nuevo.",
  "auth.error.noCode": "No hay código activo. Pide uno nuevo.",
  "auth.verify.title": "Verifica tu email",
  "auth.verify.sub": "Te hemos enviado un código a {0}. Introdúcelo para activar tu cuenta.",
  "auth.verify.codeLabel": "Código de 6 dígitos",
  "auth.verify.btn": "Verificar",
  "auth.verify.resend": "Reenviar código",
  "auth.forgot.title": "Recuperar contraseña",
  "auth.forgot.intro": "Te enviaremos un código de 6 dígitos a tu email para que puedas elegir una contraseña nueva.",
  "auth.forgot.btnSend": "Enviar código",
  "auth.forgot.bip39": "Tengo mi frase de recuperación",
  "auth.reset.title": "Nueva contraseña",
  "auth.reset.sub": "Introduce el código que enviamos a {0} y elige una contraseña nueva.",
  "auth.reset.btnConfirm": "Cambiar contraseña",
  "auth.reset.warnNewIdentity": "Tu cuenta sigue siendo tuya, pero recuperar por email te da una identidad nueva: los mensajes anteriores ya no podrán leerse. Si conservas tu frase de recuperación de 24 palabras, usa esa vía.",
  "recover.error.invalid": "Datos de recuperación incorrectos.",
  "auth.btn.unlock": "Entrar",
  "auth.btn.unlocking": "Entrando…",
  "auth.btn.processing": "Procesando…",
  "auth.btn.createIdentity": "Crear cuenta",
  "auth.btn.useOther": "Usar otra cuenta",
  "auth.btn.forget": "Olvidar este dispositivo",
  "auth.btn.backToUnlock": "Volver",
  "auth.confirmForget": "Este dispositivo dejará de reconocerte: se esfuma la cuenta guardada y lo que hubiera en caché. Para volver a entrar necesitarás tu contraseña.",
  "auth.error.badCreds": "Nick/email o contraseña incorrectos.",
  "auth.error.userNotFound": "Cuenta no encontrada.",
  "auth.error.cantConnect": "No se pudo conectar al servidor.",
  "auth.error.missingFields": "Faltan campos por rellenar.",
  "auth.error.usernameTooShort": "El nombre de usuario es demasiado corto.",
  "auth.error.usernameInvalid": "El nombre de usuario contiene caracteres no permitidos.",
  "auth.error.rateLimited": "Demasiados intentos. Espera unos minutos y vuelve a probar.",
  "auth.error.invalidInput": "Datos no válidos. {0}",
  "auth.sessionExpired": "La sesión se ha desvanecido. Entra otra vez.",
  "auth.locked": "Se ha desvanecido por inactividad. Entra otra vez.",
  "pods.invite.title": "Invitación a una Unidad",
  "pods.invite.view": "Podrás ver el contenido",
  "pods.invite.edit": "Podrás ver y editar",
  "pods.invite.accept": "Aceptar y conectar",
  "pods.grant.title": "Acceso a Unidad concedido",
  "pods.grant.ready": "Ya puedes abrirlo",
  "pods.accept.pending": "Solicitud de acceso enviada",
  "pods.invite.badSig": "Invitación no válida o manipulada",
  "pods.share.title": "Compartir esta Unidad",
  "pods.share.menuTitle": "Compartir una Unidad o pincho",
  "pods.share.rights": "Permisos",
  "pods.share.view": "Solo ver",
  "pods.share.edit": "Ver y editar",
  "pods.share.btn": "Compartir",
  "pods.share.sent": "Invitación enviada",
  "pods.share.noContact": "Abre un chat con la persona con la que quieres compartir la Unidad",
  "pods.share.with": "Se compartirá con {0}. Pulsa Compartir y le llegará la invitación al chat.",
  "chat.more": "Más",
  "invite.friends": "Invitar amigos",
  "invite.copied": "Enlace de invitación copiado",
  "invite.joined": "{0} se ha unido a IKOGNIT",
  "invite.welcome": "{0} te invita a IKOGNIT",
  "invite.welcomeSub": "Mensajería y espacio propios: lo que guardas aquí queda a tu nombre. Crea tu cuenta y quedaréis conectados.",
  "invite.continue": "Continuar",
  "invite.modalTitle": "Invitar a un amigo",
  "invite.modalSub": "El premio es IKOGNIT: mensajería de verdad privada. Comparte el enlace o que escaneen el código; cuando entren, quedaréis conectados.",
  "invite.scan": "Escanéalo en persona",
  "invite.share": "Compartir enlace",
  "invite.copy": "Copiar enlace",
  "invite.linkLabel": "Tu enlace de invitación",
  "invite.podFriend": "Invitar a un amigo que aún no tiene IKOGNIT",
  "dash.app.files": "Archivos",
  "dash.app.mail": "Correo",
  "dash.app.calendar": "Calendario",
  "dash.app.directory": "Directorio",
  "dash.app.vault": "Contraseñas",
  "dash.app.ikopods": "Unidades",
  "dash.w.seats.storage": "Almacenamiento: {0}",
  "dash.w.seats.manage": "Gestionar plan",
  "dash.w.ikopods.manage": "Gestionar Unidades",
  "pods.explorer.newFolder": "Nueva carpeta",
  "pods.explorer.home": "Inicio",
  "pods.explorer.rename": "Renombrar",
  "pods.explorer.title": "Pod compartido",
  "pods.explorer.files": "Archivos",
  "pods.explorer.upload": "Subir archivo",
  "pods.explorer.download": "Descargar",
  "pods.explorer.delete": "Borrar",
  "pods.explorer.empty": "Aún no hay archivos en este pod compartido",
  "pods.explorer.noBody": "El archivo no tiene contenido",
  "pods.explorer.readonly": "Solo lectura: no puedes modificar este pod",
  "pods.explorer.badCred": "Credencial del pod no válida o caducada",
  "pods.shared.section": "Compartidos conmigo",
  "pods.shared.open": "Abrir",
  "pods.owned.open": "Contenido compartido",
  "pods.owned.revoke": "Revocar acceso",
  "pods.owned.revokeConfirm": "Revocar el acceso invalida las credenciales actuales y rota la clave del pod. Los que quieras conservar deberán ser invitados de nuevo. ¿Continuar?",
  "pods.owned.revokeDone": "Acceso revocado y clave rotada. Vuelve a compartir con quien quieras conservar.",
  "pods.safety.hint": "Número de seguridad del pod: compáralo por otro canal con quien te lo comparte para descartar suplantación.",
  "auth.confirmForget.warning": "Sin la frase de recuperación de 24 palabras apuntada, esto no tiene vuelta atrás: nadie puede devolvértelo.",
  "auth.confirmForget.typeLabel": "Escribe la palabra para confirmar:",
  "auth.confirmForget.typeWord": "OLVIDAR",
  "offline.disconnected": "Sin conexión a Internet",
  "offline.reconnecting": "Reconectando…",
  "auth.error.badPin": "Clave incorrecta.",
  "auth.footnote": "Quien es dueño, responde.\nSi pierdes la contraseña,\nno hay a quién reclamar.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "IKO actual: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "IKO Personal: {0}",
  "sidebar.freqPsh": "IKO de Dominio: {0}",
  "sidebar.tune": "Activar IKO",
  "sidebar.newChat": "Nuevo chat",
  "sidebar.myContacts": "Mis contactos",
  "chats.title": "Chats",
  "chats.search": "Buscar chat",
  "chats.noResults": "Sin resultados.",
  "chats.emptyOnboard": "Aún no tienes chats. Pulsa + para añadir un contacto por su nick.",
  "newchat.hero.title": "Empieza una conversación",
  "newchat.hero.desc": "Añade a alguien por su nick para abrir un chat cifrado, o crea un grupo con los contactos que ya tengas.",
  "newchat.section.actions": "Acciones",
  "newchat.hint.newGroup": "Junta a varios contactos en una conversación.",
  "newchat.hint.noContacts": "Necesitas al menos un contacto para crear un grupo.",
  "newchat.hint.myContacts": "Ver y gestionar tus contactos guardados.",
  "newchat.addContact": "Añadir contacto",
  "sidebar.exitFreq": "Volver a IKOGNIT",
  "sidebar.notifications": "Notificaciones",
  "sidebar.remember": "Recordar dispositivo",
  "sidebar.forget": "Olvidar dispositivo",
  "sidebar.addContact": "Añadir contacto por nick",
  "sidebar.newGroup": "Nuevo grupo",
  "sidebar.settings": "Ajustes",
  "sidebar.logout": "Salir",
  "sidebar.tooltip.logout": "Cerrar sesión y borrar todo lo local",
  "sidebar.savedFreq.tooltip": "Activar {0}",
  "chat.empty": "Selecciona o añade un contacto",
  "welcome.title": "Bienvenido a IKOGNIT",
  "welcome.concept": "En IKOGNIT hablas con otros usuarios identificándote por tu nick. Cuando quieres estar aparte, invocas un IKO y apareces dentro. Si es Compartido, te encuentras con quienes invoquen el mismo. Si es Privado, dentro solo estás tú.",
  "welcome.step1": "Invoca un IKO y entra en él junto a quienes también lo conozcan.",
  "welcome.step2": "Aquí en IKOGNIT, añade un nick como contacto y empieza a hablar.",
  "welcome.step3": "Invoca un IKO personal y quédate a solas en él: ahí guardas archivos, fotos, audios, vídeos, contraseñas, notas y cartas.",
  "welcome.multidevice": "Los IKO nunca se almacenan en ningún sitio. Si olvidas un IKO, deja de existir para ti.",
  "welcome.btnFreq": "Activar IKO",
  "welcome.btnContacts": "Añadir contacto",
  "push.btnOn": "Notificaciones ON",
  "biometric.setting": "Invocación biométrica",
  "biometric.unlock": "Usar Face ID / huella",
  "biometric.failed": "Biometría no disponible o cancelada",
  "push.btnOff": "Notificaciones OFF",
  "push.btnEnable": "Notificaciones desactivadas. Pulsar para activar.",
  "push.btnDisable": "Notificaciones activadas. Pulsar para desactivar.",
  "push.introTitle": "Antes de activar las notificaciones",
  "push.introBody": "Por privacidad, las notificaciones de IKOGNIT son distintas a las de otras apps de mensajería:",
  "push.introBullet1": "No se incluye el contenido del mensaje.",
  "push.introBullet2": "No se muestra el nombre ni el ikognit_id del emisor.",
  "push.introBullet3": "Solo recibirás un aviso de \"mensaje nuevo\" para abrir la app y leerlo cifrado en tu dispositivo.",
  "push.introConfirm": "Activar notificaciones",
  "chat.placeholder": "Escribe un mensaje…",
  "chat.editPlaceholder": "Edita tu mensaje…",
  "chat.newMessages": "nuevos",
  "chat.newMessagesBadge": "Ir a {0} mensajes nuevos",
  "chat.mediaRetry": "Reintentar",
  "chat.mediaFailed": "No se pudo cargar",
  "chat.media.download": "Descargar",
  "chat.media.share": "Compartir",
  "chat.media.save": "Guardar",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.replyingTo": "Respondiendo a {0}",
  "chat.editing": "Editando mensaje",
  "chat.confirmContact": "Añadir a contactos",
  "chat.unconfirmedBanner": "Este usuario te ha escrito pero no está en tus contactos. Hasta que lo añadas, tu foto e info no le serán visibles según tus ajustes de privacidad.",
  "chat.online": "en línea",
  "chat.lastSeen": "última vez aquí {0}",
  "chat.tooltip.attach": "Adjuntar archivo",
  "chat.tooltip.shareContact": "Compartir contacto",
  "chat.tooltip.paste": "Pegar imagen del portapapeles",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Llamada de voz",
  "chat.tooltip.callVideo": "Videollamada",
  "call.err.notAllowed": "No estas en esta llamada.",
  "call.err.noRoom": "Esta llamada ya no existe.",
  "call.err.unavailable": "Las llamadas no estan disponibles ahora mismo.",
  "call.err.generic": "No se ha podido entrar en la llamada.",
  "call.addPeople": "Anadir a la llamada",
  "call.group.start": "Llamar al grupo",
  "call.launcher.start": "Llamada de equipo",
  "call.launcher.join": "Unirse a la llamada",
  "call.room.title": "Llamada cifrada extremo a extremo",
  "call.room.encrypted": "Cifrado E2E",
  "call.room.encryptedTitle": "Tu audio y vídeo viajan cifrados — solo los participantes pueden verlos.",
  "call.room.serverBlind": "Servidor ciego",
  "call.room.participants": "{0} participantes",
  "call.room.connecting": "Conectando…",
  "call.room.you": "Tú",
  "call.room.mic": "Micrófono",
  "call.room.camera": "Cámara",
  "call.room.screen": "Compartir pantalla",
  "call.room.leave": "Colgar",
  "chat.tooltip.camera": "Cámara",
  "chat.attach.photos": "Fotos",
  "chat.attach.document": "Documento",
  "chat.attach.location": "Ubicación",
  "chat.attach.contact": "Contacto",
  "stickers.modeSticker": "Stickers",
  "stickers.modeEmoji": "Emojis",
  "stickers.cat.caras": "Caras",
  "stickers.cat.corazones": "Corazones",
  "stickers.cat.trending": "Tendencias",
  "stickers.cat.animales": "Animales",
  "stickers.cat.comida": "Comida",
  "error.locationPermission": "IKOGNIT necesita permiso de ubicación. Actívalo en Ajustes.",
  "error.locationUnavailable": "No se pudo obtener tu ubicación.",
  "error.locationTimeout": "Se agotó el tiempo al buscar tu ubicación.",
  "error.locationUnsupported": "Tu navegador no soporta geolocalización.",
  "chat.btn.send": "Enviar",
  "chat.uploading": "…",
  "chat.voice.holdToRecord": "Mantén pulsado para grabar",
  "chat.voice.slideToCancel": "Desliza para cancelar",
  "chat.voice.cancel": "Cancelar grabación",
  "chat.voice.sendNow": "Enviar nota de voz",
  "chat.voice.play": "Reproducir",
  "chat.voice.pause": "Pausar",
  "chat.voice.rate": "Cambiar velocidad",
  "chat.voice.err.permission": "IKOGNIT necesita permiso de micrófono. Actívalo en Ajustes.",
  "chat.voice.err.codec": "Este navegador no permite grabar voz.",
  "chat.voice.err.noDevice": "No se ha encontrado micrófono.",
  "chat.voice.err.generic": "No se pudo iniciar la grabación.",
  "preview.image": "📷 Imagen",
  "preview.video": "🎬 Vídeo",
  "preview.audio": "🎙 Audio",
  "preview.voice": "🎙 Mensaje de voz",
  "preview.location": "📍 Ubicación",
  "preview.locationLive": "📍 Ubicación en directo",
  "location.card.title": "Ubicación",
  "location.live.liveTitle": "Ubicación en directo",
  "location.live.endedTitle": "Compartida",
  "location.live.remaining": "queda {0}",
  "location.live.endedAt": "terminó a las {0}",
  "location.live.endedExpired": "ya no se comparte",
  "location.live.stop": "Detener",
  "location.live.15min": "15 minutos",
  "location.live.1h": "1 hora",
  "location.live.8h": "8 horas",
  "location.modal.title": "Compartir ubicación",
  "location.modal.snapshot.title": "Mi ubicación actual",
  "location.modal.snapshot.sub": "Enviar una sola coordenada",
  "location.modal.live.title": "En tiempo real",
  "location.modal.live.sub": "Tu ubicación se actualizará automáticamente durante el tiempo que elijas.",
  "bubble.copy": "Copiar",
  "bubble.reply": "Responder",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Editar",
  "bubble.deleteForMe": "Eliminar para mí",
  "bubble.deleteForEveryone": "Eliminar para todos",
  "bubble.edited": "editado",
  "bubble.contact.label": "Contacto IKOGNIT",
  "chat.syncing": "Sincronizando…",
  "bubble.media.decrypting": "Descifrando…",
  "bubble.media.failed": "No se pudo descifrar el archivo.",
  "call.calling": "Llamando…",
  "call.incoming.audio": "Llamada entrante",
  "call.incoming.video": "Videollamada entrante",
  "call.connecting": "Conectando…",
  "call.ending": "Finalizando…",
  "call.accept": "Aceptar",
  "call.reject": "Rechazar",
  "call.hangup": "Colgar",
  "call.mic": "Micrófono",
  "call.camera": "Cámara",
  "call.audioOut": "Salida de audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Para llamar debes estar dentro de un IKO.",
  "error.notFound": "No se encontró el recurso.",
  "error.notInFreq": "{0} no está dentro de este IKO. Pídele por otro canal que lo active.",
  "error.push.iosTooOld": "Tu iOS es anterior a 16.4. Actualízalo para recibir notificaciones.",
  "error.push.iosNotStandalone": "Para recibir notificaciones en iPhone instala IKOGNIT en la pantalla de inicio: pulsa Compartir → Añadir a pantalla de inicio.",
  "error.expired": "Sesión caducada. Vuelve a entrar.",
  "error.gone": "El archivo ha caducado.",
  "error.invalid": "Datos no válidos.",
  "error.server": "Error del servidor. Inténtalo de nuevo.",
  "error.network": "Sin conexión con el servidor.",
  "error.cantStartCall": "No se pudo iniciar la llamada: {0}",
  "error.cantAcceptCall": "No se pudo aceptar la llamada: {0}",
  "error.cantPaste": "No se pudo acceder al portapapeles. Prueba a usar el botón de adjuntar.",
  "error.noImageInClipboard": "No hay ninguna imagen en el portapapeles.",
  "error.clipboardUnsupported": "Tu navegador no permite leer el portapapeles. Pega con Ctrl+V o usa el botón de adjuntar.",
  "error.selfContact": "No puedes añadirte a ti mismo.",
  "error.blocked": "Has bloqueado a este usuario. Desbloquéalo en Ajustes para volver a hablarle.",
  "settings.title": "Ajustes",
  "settings.close": "Cerrar",
  "settings.back": "Atrás",
  "settings.hero.noName": "Añade tu nombre",
  "settings.hero.edit": "Editar perfil",
  "settings.tab.profile": "👤 Perfil",
  "settings.tab.privacy": "🔒 Privacidad",
  "settings.tab.messages": "✉ Mensajes",
  "settings.tab.blocked": "🚫 Bloqueados",
  "settings.tab.notifications": "🔔 Notificaciones",
  "settings.tab.session": "⏱ Sesión",
  "settings.tab.account": "🆔 Cuenta",
  "settings.tab.language": "🌐 Idioma",
  "settings.tab.theme": "🎨 Tema",
  "settings.tab.about": "ℹ Acerca de",
  "settings.theme.title": "Tema visual",
  "settings.theme.hint": "Elige cómo se ve IKOGNIT en este dispositivo. La preferencia es local.",
  "settings.theme.auto": "Automático",
  "settings.theme.autoHint": "Sigue al sistema (claro de día, oscuro de noche).",
  "settings.theme.midnight": "Medianoche",
  "settings.theme.midnightHint": "Negro profundo con rojo IKOGNIT. El tema por defecto.",
  "settings.theme.dark": "Oscuro",
  "settings.theme.darkHint": "Gris neutro, menos contraste que medianoche.",
  "settings.theme.light": "Claro",
  "settings.theme.lightHint": "Fondo claro para entornos con mucha luz.",
  "settings.theme.accent": "Color de acento",
  "settings.theme.accentHint": "Aplica a botones, links y burbujas propias.",
  "settings.theme.customAccent": "Personalizado",
  "settings.theme.reset": "Restablecer tema por defecto",
  "settings.theme.fontScale": "Tamaño del texto",
  "settings.theme.fontScaleHint": "Escala toda la interfaz. Útil para mejorar la lectura.",
  "settings.theme.scale.sm": "Pequeño",
  "settings.theme.scale.md": "Normal",
  "settings.theme.scale.lg": "Grande",
  "settings.theme.scale.xl": "Muy grande",
  "settings.theme.motion": "Reducir animaciones",
  "settings.theme.motionHint": "Desactiva transiciones y efectos para mejorar accesibilidad.",
  "settings.scope.global": "Global (IKOGNIT)",
  "settings.scope.freq": "Solo en {0}",
  "settings.profile.title": "Perfil",
  "settings.profile.hintGlobal": "Estos valores se usan por defecto y se heredan en todos los IKO.",
  "settings.profile.hintFreq": "Sobreescriben el perfil global cuando estás en {0}. Si no defines algo aquí, se hereda del global.",
  "settings.profile.displayName": "Nombre mostrado",
  "settings.profile.displayNamePh.global": "(sin nombre — se mostrará tu nick)",
  "settings.profile.displayNamePh.freq": "(hereda del global)",
  "settings.profile.photo": "Foto de perfil",
  "settings.profile.changePhoto": "Cambiar foto",
  "settings.profile.removePhoto": "Quitar foto",
  "settings.profile.adjustPhoto": "Ajusta tu foto",
  "settings.profile.info": "Info / Estado",
  "settings.profile.infoPh": "Hola, uso IKOGNIT",
  "settings.profile.removeOverride": "Eliminar override de {0}",
  "settings.profile.warn": "Los cambios se enviarán al resto de tus contactos automáticamente cuando interactúes con ellos en este IKO.",
  "settings.privacy.title": "Privacidad",
  "settings.privacy.hintGlobal": "Configura quién puede ver cada información tuya por defecto.",
  "settings.privacy.hintFreq": "Sobreescribe estas reglas solo cuando estás en {0}.",
  "settings.privacy.showPhoto": "Quién ve mi foto",
  "settings.privacy.showInfo": "Quién ve mi info / estado",
  "settings.privacy.showLastSeen": "Quién ve mi última conexión",
  "settings.privacy.showOnline": "Quién ve si estoy en línea",
  "settings.privacy.whoAdds": "Quién puede añadirme a grupos",
  "settings.privacy.readReceipts": "Confirmaciones de lectura",
  "settings.privacy.readReceiptsHint": "Si lo desactivas, no se envían tics azules cuando lees mensajes. Tampoco verás los de los demás.",
  "settings.vis.all": "Todos",
  "settings.vis.contacts": "Mis contactos",
  "settings.vis.none": "Nadie",
  "settings.messages.title": "Mensajes",
  "settings.messages.ttl": "Caducidad por defecto",
  "settings.messages.ttlHint": "Los mensajes que envíes se borrarán del servidor pasado este tiempo. Puedes elegir un valor distinto al adjuntar un archivo.",
  "settings.blocked.title": "Bloqueados",
  "settings.blocked.hint": "Los usuarios bloqueados no pueden enviarte mensajes. Tampoco se les pueden enviar.",
  "settings.blocked.placeholder": "Nick a bloquear",
  "settings.blocked.btn": "Bloquear",
  "settings.blocked.unblock": "Desbloquear",
  "settings.blocked.empty": "No tienes a nadie bloqueado.",
  "settings.notif.title": "Notificaciones",
  "settings.notif.sound": "Sonido",
  "settings.notif.preview": "Mostrar preview del mensaje",
  "settings.notif.vibration": "Vibración (móvil)",
  "settings.notif.hint": "Las notificaciones push del navegador solo se emiten para mensajes en IKOGNIT general, sin contenido ni nombre del emisor (por diseño).",
  "settings.session.title": "Sesión",
  "settings.session.timeout": "Cerrar el IKO tras inactividad",
  "settings.session.timeoutHint": "Si pasas este tiempo sin tocar la app, el IKO activo se desactiva automáticamente y vuelves a IKOGNIT. \"Nunca\" mantiene el IKO hasta que cierres la app.",
  "settings.session.remember": "Recordar IKO activados",
  "settings.session.rememberHint": "Si lo activas, los IKO que activas aparecen como atajos en la barra lateral. Cualquiera que vea tu pantalla podrá saber en qué IKO has entrado, así que está desactivado por defecto. Al apagarlo se borran los que ya estaban guardados.",
  "settings.account.title": "Cuenta",
  "settings.account.nick": "Tu nick (visible a otros)",
  "settings.account.email": "Email",
  "settings.account.email.askHint": "Te enviaremos códigos al email actual y al nuevo. Hay que introducir ambos para confirmar.",
  "settings.account.email.sendCodes": "Enviar códigos",
  "settings.account.email.codesHint": "Códigos enviados a {0} (actual) y {1} (nuevo). Caducan en 10 min.",
  "settings.account.email.codeOld": "Código del email actual",
  "settings.account.email.codeNew": "Código del nuevo email",
  "settings.account.emailChanged": "Email actualizado.",
  "settings.account.nickChanged": "Nick actualizado.",
  "settings.account.viewRecovery": "Ver mi frase de recuperación (24 palabras)",
  "settings.account.recoveryNoKey": "Esta sesión se abrió con el PIN del dispositivo y no incluye la clave necesaria para descifrar la frase. Cierra sesión e inicia con contraseña para verla.",
  "settings.account.recoveryNoStorage": "Esta cuenta no tiene una frase de recuperación guardada localmente en este dispositivo.",
  "settings.account.recoveryDecryptFailed": "No se pudo descifrar la frase. La sesión actual no coincide con la que la guardó. Usa \"Regenerar mi frase\" para obtener una nueva.",
  "settings.account.regenerate": "Regenerar mi frase",
  "settings.account.regenerateConfirm": "Se generará una frase NUEVA de 24 palabras y la anterior dejará de servir para recuperar. Guarda la nueva en lugar seguro. ¿Continuar?",
  "settings.account.emailPh": "email@ejemplo.com",
  "settings.account.changePassword": "Cambiar contraseña",
  "settings.account.currentPw": "Contraseña actual",
  "settings.account.newPw": "Nueva contraseña (mín. 8)",
  "settings.account.confirmPw": "Repite la nueva",
  "settings.account.saving": "Guardando…",
  "settings.account.success": "Contraseña actualizada.",
  "settings.account.errPwBad": "La contraseña actual no es correcta.",
  "settings.account.errPwShort": "La nueva contraseña debe tener al menos 8 caracteres.",
  "settings.account.errPwMismatch": "Las contraseñas no coinciden.",
  "settings.account.delete.zone": "Zona peligrosa",
  "settings.account.delete.zoneHint": "Eliminar tu cuenta borra de forma permanente tu identidad, tu acceso y tus datos personales de nuestros servidores. No se puede deshacer.",
  "settings.account.delete.button": "Eliminar cuenta",
  "settings.account.delete.title": "Eliminar cuenta",
  "settings.account.delete.warn1": "Estás a punto de ELIMINAR tu cuenta IKOGNIT de forma permanente e irreversible.",
  "settings.account.delete.warn2": "Se borrarán tu identidad (nick y IKOGNIT ID), tu acceso, tus contactos, tus dispositivos y tus datos personales de nuestros servidores. Nadie —ni siquiera IKOGNIT— podrá restaurarlos.",
  "settings.account.delete.warn3": "Si perteneces a algún IKO, deja de aparecer en él; su contenido cifrado se destruye cuando su propietario lo disuelve o cuando expira su retención.",
  "settings.account.delete.continue": "Continuar",
  "settings.account.delete.confirmIntro": "Para confirmar, introduce tu contraseña. Te enviaremos un código de verificación a tu email.",
  "settings.account.delete.pwLabel": "Contraseña",
  "settings.account.delete.sendCode": "Enviar código",
  "settings.account.delete.sending": "Enviando…",
  "settings.account.delete.codeSent": "Código enviado a tu email.",
  "settings.account.delete.codeHint": "Introduce el código de 6 dígitos que hemos enviado a {0}.",
  "settings.account.delete.codeLabel": "Código de verificación",
  "settings.account.delete.ack": "Entiendo que esta acción es permanente e irreversible y que perderé el acceso a mi cuenta y a mis datos.",
  "settings.account.delete.deleting": "Eliminando…",
  "settings.account.delete.finalButton": "Eliminar mi cuenta para siempre",
  "settings.account.delete.errNoPw": "Introduce tu contraseña.",
  "settings.account.delete.errPwBad": "La contraseña no es correcta.",
  "settings.account.delete.errCode": "El código no es válido o ha caducado.",
  "settings.language.title": "Idioma",
  "settings.language.hint": "Elige el idioma de la interfaz. Tu preferencia se guarda en este dispositivo.",
  "settings.about.title": "Acerca de IKOGNIT",
  "settings.about.version": "Versión",
  "settings.about.tech": "Cifrado E2E con NaCl box (X25519). IKO: derivación Argon2id + HMAC determinista. Persistencia local cifrada con Argon2id sobre PIN.",
  "modal.freq.title": "Invocar un IKO",
  "modal.freq.hint": "Un IKO es a la vez el sitio y la palabra exacta que lo hace aparecer. Compartido: te encuentras con quienes invoquen el mismo. Personal: apareces donde nadie te ve, aunque otro invoque esa misma palabra.",
  "modal.freq.placeholder": "Escribe tu IKO",
  "modal.freq.activate": "Activar",
  "modal.freq.deriving": "Invocando…",
  "modal.freq.warn": "Un IKO no se guarda en ningún sitio. Si lo olvidas, deja de existir para ti.",
  "modal.freq.step2For": "Para",
  "modal.freq.changeType": "Cambiar tipo",
  "modal.freq.errShort": "El IKO debe tener al menos 8 caracteres.",
  "modal.freq.errCommon": "Ese IKO es demasiado común. Elige algo único.",
  "modal.freq.errRepeat": "No uses un solo carácter repetido.",
  "modal.freq.errSeqNum": "Evita secuencias numéricas obvias.",
  "modal.freq.errSeqAlpha": "Evita secuencias del alfabeto.",
  "billing.title": "Facturación",
  "billing.manage": "Gestionar",
  "billing.seats": "Asientos",
  "billing.renews": "Renovación",
  "billing.needsUpgrade": "Has alcanzado el límite de tu tramo. Súbelo para añadir más asientos.",
  "billing.upgradeTo": "Subir tramo ({price}/asiento)",
  "billing.portal": "Gestionar pago",
  "twofa.title": "Verificación en dos pasos (2FA)",
  "twofa.intro": "Activa una segunda capa de seguridad con app TOTP (Google Authenticator, 1Password, Authy). Algunos IKO PSH lo exigen para propietario/Admin.",
  "twofa.startSetup": "Iniciar configuración",
  "twofa.scan": "Escanea este código con tu app TOTP:",
  "twofa.orType": "O introduce este secreto manualmente",
  "twofa.enterCode": "Introduce el código de 6 cifras de tu app para confirmar:",
  "twofa.codePh": "123456",
  "twofa.activate": "Activar 2FA",
  "twofa.alreadyEnabled": "2FA está activado en tu cuenta. Para desactivar, introduce un código actual de tu app:",
  "twofa.disable": "Desactivar 2FA",
  "twofa.errCode": "El código debe tener 6 dígitos.",
  "twofa.errBadCode": "Código incorrecto o caducado. Inténtalo de nuevo.",
  "join.loginToAccept": "Iniciar sesión / Crear cuenta",
  "private.badge": "PERSONAL",
  "private.universeLabel": "IKO Personal",
  "private.welcome.title": "Tu IKO Personal",
  "private.welcome.intro": "Estás en un espacio que nadie más puede ver. Aunque otra persona escribiera un IKO parecido, llegaría a un sitio distinto. Aquí guardas lo tuyo a salvo.",
  "private.welcome.hint": "Elige una sección para empezar.",
  "private.mod.notes": "Notas",
  "private.mod.notes.desc": "Notas, cartas, diario.",
  "private.mod.files": "Archivos",
  "private.mod.files.desc": "Documentos, hojas, PDFs.",
  "private.mod.photos": "Fotos",
  "private.mod.photos.desc": "Tu galería privada.",
  "private.mod.videos": "Vídeos",
  "private.mod.videos.desc": "Tus vídeos personales.",
  "private.mod.audios": "Audios",
  "private.mod.audios.desc": "Grabaciones y notas de voz.",
  "private.mod.vault": "Contraseñas",
  "private.mod.vault.desc": "Contraseñas, tarjetas, identidades, llaves SSH y lo que necesites.",
  "private.mod.iko": "Mis IKO",
  "private.mod.iko.desc": "Tus IKO guardados, listos para activar.",
  "private.mod.explorer": "Explorador",
  "private.mod.explorer.desc": "Vista unificada: fotos, notas, contraseñas… organizado en carpetas.",
  "explorer.empty": "Tu IKO está vacío.",
  "explorer.emptyHint": "Pulsa + para añadir tu primer objeto o crea una carpeta.",
  "explorer.search": "Buscar en tu IKO…",
  "explorer.clearFilters": "Limpiar filtros",
  "explorer.noMatches": "Ningún objeto coincide con los filtros.",
  "explorer.dropHere": "Suelta para subir aquí",
  "explorer.selectMany": "Seleccionar varios",
  "trash.title": "Papelera",
  "trash.type": "ELEMENTOS ELIMINADOS",
  "trash.restore": "Restaurar",
  "trash.restored": "Elemento restaurado.",
  "trash.purge": "Eliminar definitivamente",
  "trash.purged": "Eliminado definitivamente.",
  "trash.purgeConfirmTitle": "¿Eliminar definitivamente?",
  "trash.purgeConfirmBody": "El elemento \"{name}\" se eliminará para siempre. Esta acción no se puede deshacer.",
  "trash.empty": "Vaciar papelera",
  "trash.emptied": "Papelera vaciada ({n} elementos).",
  "trash.emptyConfirmTitle": "¿Vaciar papelera?",
  "trash.emptyConfirmBody": "Se eliminarán definitivamente todos los elementos de la papelera. Esta acción no se puede deshacer.",
  "trash.empty.message": "La papelera está vacía.",
  "explorer.filter": "Filtrar",
  "explorer.apply": "Aplicar",
  "explorer.removeFilter": "Quitar filtro",
  "explorer.add": "Añadir",
  "explorer.add.photo": "Foto",
  "explorer.add.cameraPhoto": "Cámara",
  "explorer.add.recordAudio": "Grabar audio",
  "explorer.add.video": "Vídeo",
  "explorer.add.audio": "Audio",
  "explorer.add.file": "Documento",
  "explorer.add.note": "Nota",
  "explorer.add.password": "Contraseña",
  "explorer.add.card": "Tarjeta",
  "explorer.add.identity": "Identidad",
  "explorer.add.sshkey": "Llave SSH",
  "explorer.add.customVault": "Contraseñas sueltas",
  "explorer.add.savedIko": "IKO guardado",
  "explorer.add.ikoDirectory": "Agenda IKO",
  "explorer.type.iko-directory": "Agenda IKO",
  "explorer.add.diskDirectory": "Agenda de Unidades y Discos",
  "explorer.type.disk-directory": "Agenda de Unidades y Discos",
  "diskdir.untitled": "Inventario sin nombre",
  "diskdir.namePlaceholder": "Nombre del inventario (Mis discos, Trabajo…)",
  "diskdir.empty": "Aún no has dado de alta ninguna Unidad ni Disco. Pulsa Añadir.",
  "diskdir.addEntry": "Añadir Unidad o Disco",
  "diskdir.saved": "Inventario actualizado.",
  "diskdir.savedNew": "Inventario creado.",
  "diskdir.deleted": "Inventario eliminado.",
  "diskdir.deleteTitle": "¿Eliminar el inventario?",
  "diskdir.deleteBody": "Se eliminará el inventario y sus {n} entradas.",
  "diskdir.entriesCount": "entradas",
  "diskdir.field.name": "Nombre (MDisco123, MiPod…)",
  "diskdir.field.iko": "¿En qué IKO está?",
  "diskdir.field.location": "Ubicación (ruta o dónde está)",
  "diskdir.field.note": "Nota (opcional)",
  "diskdir.type.pod": "Unidad (servidor)",
  "diskdir.type.drive": "Disco / IkoDrive (físico)",
  "diskdir.podLocationNote": "Una Unidad vive en el servidor: no necesita ubicación.",
  "diskdir.errName": "Ponle un nombre.",
  "diskdir.errIko": "Indica en qué IKO está.",
  "explorer.type.vault-collection": "Carpeta mixta",
  "explorer.type.photo-album": "Álbum de fotos",
  "explorer.type.video-collection": "Colección de vídeos",
  "explorer.type.audio-playlist": "Playlist",
  "explorer.type.notebook": "Cuaderno",
  "explorer.type.doc-folder": "Carpeta de documentos",
  "explorer.section.add": "Añadir suelto",
  "explorer.section.collections": "Colecciones",
  "collection.photoAlbum": "Nuevo álbum de fotos",
  "collection.videoCollection": "Nueva colección de vídeos",
  "collection.audioPlaylist": "Nueva playlist",
  "collection.notebook": "Nuevo cuaderno",
  "collection.docFolder": "Carpeta de documentos",
  "collection.vaultCollection": "Nueva carpeta",
  "collection.created": "Colección creada.",
  "collection.incompatibleTarget": "Este destino no acepta los elementos seleccionados.",
  "collection.dropRejected": "Algunos archivos no se aceptan en esta colección.",
  "vault.coll.untitled": "Carpeta sin nombre",
  "vault.coll.namePlaceholder": "Nombre de la carpeta (Trabajo, Personal…)",
  "vault.coll.empty": "Esta carpeta aún no tiene credenciales. Pulsa Añadir.",
  "vault.coll.addEntry": "Añadir credencial",
  "vault.coll.saved": "Carpeta actualizada.",
  "vault.coll.savedNew": "Carpeta creada.",
  "vault.coll.deleted": "Carpeta eliminada.",
  "vault.coll.deleteTitle": "¿Eliminar carpeta?",
  "vault.coll.deleteBody": "Se eliminará la carpeta y sus {n} credenciales dentro.",
  "vault.coll.entriesCount": "cred.",
  "iko.dir.untitled": "Agenda sin nombre",
  "iko.dir.namePlaceholder": "Nombre de la agenda (Familiares, Amigos…)",
  "iko.dir.empty": "Esta agenda aún no tiene IKOes. Pulsa Añadir.",
  "iko.dir.addEntry": "Añadir IKO a la agenda",
  "iko.dir.entriesCount": "IKO",
  "iko.dir.saved": "Agenda actualizada.",
  "iko.dir.savedNew": "Agenda creada.",
  "iko.dir.deleted": "Agenda eliminada.",
  "iko.dir.deleteTitle": "¿Eliminar agenda?",
  "iko.dir.deleteBody": "Se eliminará la agenda y sus {n} IKO guardados dentro.",
  "iko.dir.migrationDefaultName": "Mis IKO guardados",
  "explorer.soon": "(pronto)",
  "explorer.typeComingSoon": "Tipo \"{type}\" próximamente. De momento solo media.",
  "explorer.type.photo": "Foto",
  "explorer.type.video": "Vídeo",
  "explorer.type.audio": "Audio",
  "explorer.type.file": "Documento",
  "explorer.type.note": "Nota",
  "explorer.type.password": "Contraseña",
  "explorer.type.card": "Tarjeta",
  "explorer.type.identity": "Identidad",
  "explorer.type.sshkey": "Llave SSH",
  "explorer.type.custom-vault": "Carpeta",
  "explorer.type.vault-route": "Ruta de contraseñas",
  "explorer.type.saved-iko": "IKO guardado",
  "explorer.type.folder": "Carpeta",
  "explorer.type.unknown": "Desconocido",
  "savediko.intro": "Guarda aquí los IKO que no quieras memorizar. Recuerdas uno solo y el resto viven dentro.",
  "savediko.empty": "Aún no has guardado ningún IKO.",
  "savediko.add": "Guardar un IKO",
  "savediko.activate": "Activar IKO",
  "savediko.formNew": "Guardar un IKO",
  "savediko.formEdit": "Editar IKO guardado",
  "savediko.descLabel": "Descripción",
  "savediko.descPh": "Una descripción para reconocerlo más tarde",
  "savediko.ikoLabel": "El IKO",
  "savediko.ikoPh": "Escribe el IKO",
  "savediko.errDesc": "Escribe una descripción.",
  "savediko.errIko": "Escribe el IKO.",
  "savediko.confirmDel": "¿Borrar?",
  "savediko.modeLabel": "Modo del IKO",
  "savediko.mode.shared": "Compartido",
  "savediko.mode.private": "Privado",
  "savediko.saved": "IKO guardado actualizado.",
  "savediko.savedNew": "IKO guardado.",
  "vault.new": "Nuevo elemento",
  "vault.edit": "Editar",
  "vault.delete": "Eliminar",
  "vault.save": "Guardar",
  "vault.show": "Mostrar",
  "vault.hide": "Ocultar",
  "vault.copy": "Copiar",
  "vault.copied": "Copiado ✓",
  "vault.search": "Buscar…",
  "vault.empty": "Tu carpeta está vacía. Crea tu primer elemento.",
  "vault.noMatches": "Ningún elemento coincide con la búsqueda.",
  "vault.untitled": "Sin nombre",
  "vault.startHint": "Selecciona un elemento de la izquierda o crea uno nuevo.",
  "vault.confirmDelete": "¿Eliminar este elemento? No se puede recuperar.",
  "vault.saved": "Cambios guardados.",
  "vault.savedNew": "Elemento creado.",
  "vault.deleted": "Eliminado.",
  "vault.notes": "Notas",
  "vault.sensitive": "Sensible",
  "vault.sensitiveHint": "Los campos sensibles se ocultan por defecto y se pueden copiar al portapapeles.",
  "vault.removeField": "Eliminar este campo",
  "vault.addField": "Añadir campo",
  "vault.fieldSingular": "campo",
  "vault.fieldPlural": "campos",
  "vault.type.login": "Entrada",
  "vault.type.card": "Tarjeta",
  "vault.type.identity": "Identidad",
  "vault.type.sshkey": "Llave SSH",
  "vault.type.route": "Ruta a carpeta",
  "vault.type.custom": "Personalizado",
  "vault.field.routePath": "Ruta",
  "vault.field.routeAlias": "Alias",
  "vault.field.routeIcon": "Icono",
  "vault.field.name": "Nombre",
  "vault.field.name.ph": "¿Cómo lo llamas?",
  "vault.field.labelPh": "Etiqueta del campo",
  "vault.field.newField": "Campo",
  "vault.field.username": "Usuario",
  "vault.field.password": "Contraseña",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Titular",
  "vault.field.cardBrand": "Marca",
  "vault.field.cardNumber": "Número",
  "vault.field.cardExpiry": "Caducidad (MM/AA)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Nombre",
  "vault.field.lastname": "Apellidos",
  "vault.field.dni": "DNI / NIF",
  "vault.field.address": "Dirección",
  "vault.field.city": "Ciudad",
  "vault.field.zip": "Código postal",
  "vault.field.country": "País",
  "vault.field.phone": "Teléfono",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Fecha de nacimiento",
  "vault.field.sshPrivate": "Clave privada",
  "vault.field.sshPublic": "Clave pública",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Texto",
  "vault.ft.password": "Contraseña",
  "vault.ft.textarea": "Texto largo",
  "vault.ft.date": "Fecha",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Número",
  "vault.tpl.title": "Plantillas",
  "vault.tpl.manage": "Gestionar plantillas",
  "vault.tpl.yours": "Tus plantillas",
  "vault.tpl.new": "Nueva plantilla",
  "vault.tpl.edit": "Editar plantilla",
  "vault.tpl.empty": "Aún no tienes plantillas. Crea una para definir tu propio tipo de elemento.",
  "vault.tpl.name": "Nombre de la plantilla",
  "vault.tpl.name.ph": "Ej: Wallet cripto, Reserva hotel…",
  "vault.tpl.confirmDelete": "¿Eliminar esta plantilla? Los elementos creados a partir de ella se mantienen.",
  "totp.copyCode": "Copiar código",
  "totp.copySecret": "Copiar secret",
  "totp.showSecret": "Ver secret",
  "totp.hideSecret": "Ocultar secret",
  "totp.invalid": "secret no válido",
  "private.module.coming": "Próximamente.",
  "private.module.comingHint": "Este módulo estará disponible muy pronto. La cripto del IKO Privado ya funciona — pronto podrás guardar aquí lo que necesites.",
  "notes.new": "Nueva nota",
  "notes.empty": "Aún no tienes notas en este IKO.",
  "notes.emptyPreview": "(vacía)",
  "notes.untitled": "Sin título",
  "notes.delete": "Eliminar nota",
  "notes.confirmDelete": "¿Eliminar esta nota? No se puede recuperar.",
  "notes.titlePlaceholder": "Título",
  "notes.contentPlaceholder": "Escribe lo que necesites recordar…",
  "notes.edit": "Editar nota",
  "notes.save": "Guardar",
  "notes.saved": "Nota guardada.",
  "notes.savedNew": "Nota creada.",
  "notes.deleted": "Nota eliminada.",
  "notes.title": "Título",
  "notes.content": "Contenido",
  "notes.startHint": "Sin notas en este IKO. Crea la primera.",
  "notes.autosaveHint": "Se guarda automáticamente, cifrado, solo aquí.",
  "notes.yesterday": "Ayer",
  "passwords.new": "Nueva entrada",
  "passwords.empty": "Aún no has guardado ninguna entrada en este IKO.",
  "passwords.untitled": "Sin nombre",
  "passwords.startHint": "Sin contraseñas en este IKO. Crea la primera.",
  "passwords.confirmDelete": "¿Eliminar esta entrada? No se puede recuperar.",
  "passwords.save": "Guardar",
  "passwords.edit": "Editar",
  "passwords.delete": "Eliminar",
  "passwords.copy": "Copiar",
  "passwords.copied": "Copiado ✓",
  "passwords.show": "Mostrar",
  "passwords.hide": "Ocultar",
  "passwords.field.label": "Nombre",
  "passwords.field.label.ph": "Banco, cuenta, servicio…",
  "passwords.field.username": "Usuario",
  "passwords.field.username.ph": "Email, alias, número…",
  "passwords.field.password": "Contraseña",
  "passwords.field.password.ph": "La contraseña que quieres guardar",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notas",
  "passwords.field.notes.ph": "Cualquier detalle útil",
  "media.uploading": "Subiendo…",
  "media.uploadFailed": "No se pudo subir el archivo.",
  "media.upload.file": "Subir archivo",
  "media.upload.photo": "Subir foto",
  "media.upload.video": "Subir vídeo",
  "media.upload.audio": "Subir audio",
  "media.empty.file": "Aún no hay archivos en este IKO.",
  "media.empty.photo": "Aún no hay fotos en este IKO.",
  "media.empty.video": "Aún no hay vídeos en este IKO.",
  "media.empty.audio": "Aún no hay audios en este IKO.",
  "media.play": "Reproducir",
  "media.download": "Descargar",
  "media.delete": "Eliminar",
  "media.confirmDelete": "¿Eliminar este elemento? No se puede recuperar.",
  "media.loadFailed": "No se pudo cargar el archivo. El contenido no está disponible.",
  "media.retry": "Reintentar",
  "media.tooBig": "{n} archivo(s) superan el límite de {max} MB y no se han subido.",
  "media.tooBigAfterCompress": "El vídeo sigue siendo demasiado grande después de comprimir (>{max} MB).",
  "media.compressing": "Comprimiendo…",
  "media.cameraOnlyNative": "La cámara solo está disponible en la app móvil.",
  "media.cameraFailed": "No se pudo tomar la foto.",
  "media.pickFailed": "No se pudo abrir el selector.",
  "media.textTruncated": "Archivo grande: mostrando los primeros 2 MB.",
  "media.recordOnlyNative": "El grabador solo está disponible en la app móvil.",
  "media.recordPermDenied": "Permiso de micrófono denegado.",
  "media.recordNotSupported": "Este dispositivo no permite grabar audio.",
  "media.recordFailed": "Error al grabar audio.",
  "media.recordTitle": "Grabar audio",
  "media.recordStart": "Empezar a grabar",
  "media.recordStopSave": "Detener y guardar",
  "media.recordDiscard": "Descartar",
  "media.noPreview": "Sin vista previa para este tipo de archivo.",
  "media.select": "Seleccionar",
  "media.selected": "seleccionados",
  "media.paste": "Pegar de portapapeles",
  "media.pasteHint": "Tip: copia una captura y pulsa Ctrl+V (o el botón Pegar).",
  "media.clipboardUnsupported": "Portapapeles no disponible en este navegador.",
  "media.clipboardNoImage": "No hay imagen en el portapapeles.",
  "media.clipboardDenied": "No se pudo leer el portapapeles.",
  "media.uploadedOne": "Subido a tu IKO.",
  "media.uploadedMany": "{n} elementos subidos a tu IKO.",
  "media.deletedMany": "{n} elementos eliminados.",
  "media.deleteFailed": "No se pudo eliminar.",
  "media.savedPhoto": "Imagen guardada en Fotos.",
  "media.savedVideo": "Vídeo guardado en Fotos.",
  "media.saveUpdateApp": "Actualiza TestFlight a 1.0(10)+ para Guardar.",
  "media.saveFailed": "No se pudo guardar: {reason}",
  "media.bulkDeleteTitle": "¿Eliminar elementos seleccionados?",
  "media.bulkDeleteBody": "Vas a eliminar {n} elementos. No se puede deshacer.",
  "media.newFolder": "Nueva carpeta",
  "media.folderNamePlaceholder": "Nombre de la carpeta",
  "media.folderExists": "Ya existe una carpeta con ese nombre.",
  "media.folderCreated": "Carpeta creada.",
  "media.folderCreateFailed": "No se pudo crear la carpeta.",
  "media.folderRename": "Renombrar carpeta",
  "media.folderRenamed": "Carpeta renombrada.",
  "media.folderDelete": "Eliminar carpeta",
  "media.folderDeleted": "Carpeta eliminada.",
  "media.folderDeleteTitle": "¿Eliminar carpeta?",
  "media.folderDeleteBody": "Se eliminará la carpeta \"{folder}\". Los {n} elementos que contiene volverán a la raíz.",
  "media.folderDeleteBodyV2": "Se eliminará la carpeta \"{folder}\" y todo su contenido (subcarpetas y archivos). Esta acción no se puede deshacer.",
  "media.newFolderInRoot": "Se creará en la raíz del IKO.",
  "media.newFolderIn": "Se creará dentro de \"{folder}\".",
  "media.moveTo": "Mover a…",
  "media.root": "Raíz",
  "media.movedToFolder": "{n} elementos movidos a \"{folder}\".",
  "media.movedToRoot": "{n} elementos movidos a la raíz.",
  "common.create": "Crear",
  "modal.share.title": "Compartir contacto",
  "modal.share.hint": "Elige un contacto de la lista o introduce un nick manualmente.",
  "modal.share.filter": "Filtrar contactos…",
  "modal.share.empty": "Sin contactos en este IKO",
  "modal.share.manual": "O un nick manual",
  "modal.share.btn": "Compartir",
  "modal.group.title": "Nuevo grupo",
  "modal.group.hint": "Elige un nombre y selecciona miembros entre tus contactos en este IKO.",
  "modal.group.namePh": "Nombre del grupo",
  "modal.group.selected": "{0} seleccionados",
  "modal.group.create": "Crear grupo",
  "modal.remember.title": "Recordar este dispositivo",
  "modal.remember.hint": "Se guardarán tu sesión, contactos, grupos y mensajes en este dispositivo, cifrados con un PIN que solo tú conoces. Al reabrir la app introducirás el PIN para invocar.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repite el PIN",
  "modal.remember.warn": "Si olvidas el PIN, los datos guardados no se podrán recuperar. Tendrás que entrar de nuevo con tu usuario y contraseña.",
  "modal.remember.errShort": "El PIN debe tener al menos 4 caracteres.",
  "modal.remember.errMismatch": "Los PINs no coinciden.",
  "stickers.faces": "Caras",
  "stickers.gestures": "Gestos",
  "stickers.hearts": "Corazones",
  "stickers.symbols": "Símbolos",
  "stickers.animals": "Animales",
  "stickers.food": "Comida",
  "ttl.1h": "1 hora",
  "ttl.1d": "1 día",
  "ttl.1w": "1 semana",
  "ttl.1m": "1 mes",
  "ttl.6m": "6 meses",
  "ttl.12m": "12 meses",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nunca",
  "toast.newMessage": "Mensaje nuevo",
  "toast.group": "{0} (grupo)",

  // Web 2035 — ContextPanel
  "ctx.aria": "Información y navegación del IKO",
  "ctx.section.universe": "IKO ACTUAL",
  "ctx.universe.personal": "Tu espacio personal",
  "ctx.status.serverBlind": "Servidor ciego activo",
  "ctx.status.e2e": "Cifrado de extremo a extremo",
  "ctx.section.nav": "NAVEGACIÓN",
  "ctx.nav.changeIko": "Cambiar de IKO",
  "ctx.nav.activateIko": "Activar un IKO",
  "ctx.nav.backToIkognit": "Volver a IKOGNIT",
  "ctx.section.actions": "ACCIONES",
  "ctx.action.newChat": "Nuevo chat",
  "ctx.action.newGroup": "Nuevo grupo",
  "ctx.action.contacts": "Mis contactos",
  "ctx.action.storage": "Unidades",
  "ctx.section.conversation": "CONVERSACIÓN",
  "ctx.peer.online": "en línea",
  "ctx.peer.offline": "desconectado",
  "ctx.peer.messages": "{0} mensajes",
  "ctx.peer.message": "{0} mensaje",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "IKO Personal",
  "ctx.modes.storage": "Unidad",
  "ctx.liturgy.0": "El servidor es ciego.",
  "ctx.liturgy.1": "Aquí solo lees tú.",
  "ctx.liturgy.2": "Nadie sabe que estás aquí.",
  "ctx.liturgy.3": "Un IKO es un secreto que solo tú conoces.",
  "ctx.liturgy.4": "Tu privacidad es la arquitectura.",

  // Web 2035 — ControlCenterBar
  "ccb.universe.changeOrExit": "Cambiar IKO o salir",
  "ccb.universe.activate": "Activar IKO",
  "ccb.leave.title": "Salir del IKO (volver a IKOGNIT)",
  "ccb.leave.aria": "Salir del IKO",
  "ccb.tag.cipher.title": "Cifrado simétrico activo",
  "ccb.tag.srv.title": "El servidor no puede leer el contenido",
  "ccb.tag.unread.title": "Mensajes sin leer",
  "ccb.settings.title": "Ajustes · perfil, temas, sesión",
  "ccb.settings.aria": "Ajustes",
  "ccb.identity.title": "Sesión: @{0}",
  "ccb.clock.title": "Hora local",
  "ccb.modes.personalPrefix": "PERSONAL · ",

  // Web 2035 — HolographicEmpty
  "holo.modes.shared": "IKO",
  "holo.modes.private": "IKO PERSONAL",
  "holo.modes.general": "TU NICK + CONTACTOS",
  "holo.claim.inIko": "Este IKO permanece invisible para quien no lo conoce.",
  "holo.claim.general": "Tu espacio personal en IKOGNIT. Aquí hablas con tus contactos.",
  "holo.card.conversations": "Conversaciones",
  "holo.card.contacts": "Contactos",
  "holo.card.cipher": "Cifrado",
  "holo.card.server": "Servidor",
  "holo.foot": "Elige una conversación, activa un IKO o crea un nuevo espacio.",

  // Web 2035 — IdentityBar
  "uib.modes.shared": "IKO",
  "uib.modes.private": "IKO Personal",
  "uib.context.coordTitle": "El IKO",
  "uib.context.general": "IKO general",
  "uib.e2e.title": "El servidor no puede leer tu contenido — cifrado E2E con tu llave",
  "uib.e2e.label": "Servidor ciego",
  "uib.pseudoTitle": "Tu pseudónimo en este IKO",
  "uib.nickTitle": "Tu nick",
  "uib.exitTitle": "Regresar al IKO general",
  "uib.exitLabel": "Salir",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Navegación principal",
  "chat.tab.chats": "Chats",
  "chat.tab.calls": "Llamadas",
  "chat.tab.contacts": "Contactos",
  "chat.backToIkognit.title": "Volver a IKOGNIT general",
  "chat.delete.title": "Eliminar",
  "chat.delete.aria": "Eliminar",
  "chat.call.title": "Llamar",
  "chat.videoCall.title": "Videollamada",
  "chat.videoCall.aria": "Videollamada con {0}",
  "chat.search.clear": "Limpiar búsqueda",
  "chat.filters.aria": "Filtros de chats",
  "chat.filter.all": "Todos",
  "chat.filter.unread": "No leídos",
  "chat.filter.groups": "Grupos",
  "chat.attachPending": "Adjunto pendiente",
  "chat.remove.title": "Quitar",
  "chat.cancel.title": "Cancelar",
  "chat.blocked.text": "Has bloqueado a {0}. No puedes enviarle mensajes ni llamarle.",
  "chat.unblock": "Desbloquear",
  "contacts.alias.placeholder": "Un alias para identificarle",
  "contacts.notes.placeholder": "Solo tú la ves (cifrada en el servidor).",
  "contacts.search.placeholder": "Buscar por alias o IKOGNIT ID",
  "contacts.edit.title": "Editar alias y nota",
  "contacts.edit.aria": "Editar",
  "contacts.blockBtn": "Bloquear contacto",
  "contacts.unblockBtn": "Desbloquear contacto",
  "contacts.confirmBlock.title": "Bloquear contacto",
  "contacts.confirmUnblock.title": "Desbloquear contacto",
  "contacts.confirmBlock.body": "¿Bloquear a {0}? Dejarás de recibir sus mensajes y llamadas.",
  "contacts.confirmUnblock.body": "¿Desbloquear a {0}? Volverás a recibir sus mensajes.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Categorías del IKO Personal",
  "piko.rail.head": "PERSONAL",
  "piko.cat.all": "Todo",
  "piko.cat.photos": "Fotos",
  "piko.cat.videos": "Vídeos",
  "piko.cat.audios": "Audios",
  "piko.cat.files": "Archivos",
  "piko.cat.notes": "Notas",
  "piko.cat.passwords": "Contraseñas",
  "piko.cat.cards": "Tarjetas",
  "piko.cat.identities": "Identidades",
  "piko.cat.sshkeys": "Claves SSH",
  "piko.cat.custom": "Carpeta",
  "piko.cat.agendas": "Agendas IKO",
  "piko.cat.storage": "Unidades y Discos",

  // Tick de mensajes
  "bubble.tick.read": "Leído {0}",
  "bubble.tick.delivered": "Entregado {0}",
  "bubble.tick.sent": "Enviado",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Tienes a este usuario bloqueado.",
  "chat.preview.image": "Imagen",
  "chat.preview.video": "Vídeo",
  "chat.preview.voice": "Mensaje de voz",
  "chat.preview.audio": "Audio",
  "error.push.denied": "Has denegado el permiso de notificaciones.",
  "error.push.noSw": "Este navegador no soporta service workers.",
  "error.push.noPush": "Este navegador no soporta notificaciones push.",
  "error.push.noVapid": "El servidor no entregó la clave VAPID.",
  "error.push.activateFailed": "No se pudo activar ({0}).",
  "chat.group.membersWord": "miembros",
  "chat.newCall.title": "Nueva llamada",
  "chat.newChat.title": "Nuevo chat",
  "chat.newCall.empty": "Aún no tienes contactos. Añade uno desde el + de Chats.",
  "chat.unread.aria": "mensajes sin leer",
  "chat.calls.title": "Llamadas",
  "chat.calls.empty": "Aún no hay llamadas. Inicia una desde el chat con un contacto.",
  "chat.calls.callContact": "Llamar a un contacto",
  "chat.calls.historySoon": "El historial de llamadas estará disponible próximamente.",
  "chat.deleteConv.titleOne": "Eliminar conversación",
  "chat.deleteConv.titleMany": "Eliminar {0} conversaciones",
  "chat.deleteConv.hint": "\"Para mí\" borra tu copia (todos tus dispositivos). \"Para todos\" también pide al contacto que la borre en su lado.",
  "chat.deleteConv.forMe": "Eliminar para mí",
  "chat.deleteConv.forAll": "Eliminar para todos",
  "chat.myContacts": "Mis contactos",
  "chat.contacts.noResults": "Sin resultados.",
  "chat.contacts.empty": "Aún no tienes contactos.",
  "chat.contact.badgeBlocked": "bloqueado",
  "chat.contact.badgePending": "sin confirmar",
  "chat.toast.saved": "Guardado",
  "chat.toast.videoSaved": "Vídeo guardado en Fotos",
  "chat.toast.imageSaved": "Imagen guardada en Fotos",
  "chat.toast.updateTestflight": "Actualiza TestFlight a 1.0(10)+ para Guardar.",
  "chat.toast.saveFailed": "No se pudo guardar: {0}",
  "chat.toast.saveError": "Error al guardar",
  "iko.banner.exitAria": "Salir del IKO y volver al plano general",
  "iko.liturgy.entering": "Entrando en IKO",
  "iko.liturgy.returning": "Regresando",
  "iko.liturgy.toIkognit": "a IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "IKO Personal",
  "iko.mode.storage": "IKO de Almacenamiento",
  "storage.universeLabel": "Unidad",
  "storage.state.trial": "Prueba · quedan {0} días",
  "storage.state.free": "1 GB gratis",
  "storage.state.active": "Activo hasta {0}",
  "storage.state.grace": "Solo lectura · {0} días para renovar",
  "storage.state.sealed": "Bloqueado",
  "storage.free.title": "Tu 1 GB gratis",
  "storage.free.remaining": "Te queda",
  "storage.free.add": "Añadir",
  "storage.free.adding": "Añadiendo…",
  "storage.free.note": "De tu 1 GB gratis de cuenta. Tú decides cuánto va a cada Unidad.",
  "storage.free.noteV2": "Tu cuenta tiene 1 GB gratis. Repártelo entre tus Unidades como quieras —y recupéralo cuando quieras.",
  "storage.free.all": "Todo ({0})",
  "storage.free.addLabel": "Añadir",
  "storage.free.releaseLabel": "Liberar",
  "storage.free.releasing": "Liberando…",
  "storage.free.releaseAll": "Liberar todo ({0})",
  "storage.free.releaseBlocked": "No puedes liberar tanto: bajarías de lo que ya ocupan tus archivos. Borra archivos primero.",
  "storage.note.grace": "El periodo ha vencido. Puedes descargar tus archivos o renovar; pasado el plazo de gracia, la Unidad se bloquea.",
  "storage.note.sealed": "Esta Unidad está bloqueado. Renueva para recuperar el acceso a tus archivos.",
  "storage.note.coords": "Las IKO de esta Unidad son la única llave. Si las pierdes, nadie —ni IKOGNIT— puede recuperar su contenido.",
  "storage.retention.title": "Qué pasa con tus datos",
  "storage.retention.body": "Mientras tu Unidad esté activo, tus archivos están siempre disponibles. Si vence el pago, entras en un periodo de gracia de solo lectura: puedes descargar y renovar. Si no renuevas, la Unidad se bloquea y, pasado un margen, sus datos se eliminan definitivamente —para no ocupar espacio que ya no se paga—. Renovar antes del borrado restaura el acceso. IKOGNIT nunca borra por inactividad: solo por falta de pago.",
  "storage.connector.title": "Unidad de disco",
  "storage.connector.mount": "Montar como unidad",
  "storage.connector.unmount": "Desmontar",
  "storage.connector.hint": "Abre esta Unidad como una unidad en tu equipo. Los archivos se descifran al vuelo y solo viven en memoria: al desmontar o cerrar IKOGNIT, desaparecen del disco.",
  "storage.connector.mountedHint": "Montado. Encontrarás tus archivos como una unidad más en tu equipo. Se desmonta solo al salir de la Unidad o cerrar IKOGNIT.",
  "storage.connector.webNotice": "Para abrir esta Unidad como una unidad de disco en tu equipo necesitas IKOGNIT Escritorio. Por seguridad, un navegador no puede montar unidades (igual que Dropbox: la web gestiona los archivos, la app de escritorio monta el disco). Instálala y entra en este mismo Unidad desde la app.",
  "storage.connector.webCta": "Descargar IKOGNIT Escritorio",
  "storage.files.title": "Archivos",
  "storage.files.upload": "Subir archivos",
  "storage.files.download": "Descargar",
  "storage.files.emptyTitle": "Tu Unidad está vacío",
  "storage.files.emptyHint": "Sube tu primer archivo. Se cifra en este dispositivo: el servidor solo guarda bytes opacos.",
  "storage.err.quota": "Unidad lleno. Borra archivos, súmale más de tu 1 GB gratis, o amplía con un plan.",
  "storage.err.readOnly": "Plan vencido: solo lectura. Renueva para volver a guardar.",
  "storage.err.download": "No se pudo descargar el archivo.",
  "storage.err.sealed": "Unidad bloqueado: renueva para acceder.",
  "storage.buy.title": "Plan y renovación",
  "storage.buy.titleExtend": "Ampliar capacidad",
  "storage.buy.prorateNote": "Se cobra prorrateado hasta tu vencimiento del {0}. Tu Unidad mantiene una sola fecha de renovación: el año que viene todo renueva junto.",
  "storage.buy.perYear": " /año",
  "storage.buy.qtyLabel": "Cantidad de paquetes",
  "storage.confirm.titleBuy": "Resumen de tu compra",
  "storage.confirm.titleExtend": "Resumen de tu ampliación",
  "storage.confirm.buying": "Compras",
  "storage.confirm.annualPrice": "Precio anual",
  "storage.confirm.prorated": "Quedan {0} días hasta tu vencimiento",
  "storage.confirm.fullYear": "Primer año completo",
  "storage.confirm.capacityAfter": "Capacidad de la Unidad tras la compra",
  "storage.confirm.nextRenewal": "Próxima renovación",
  "storage.confirm.payNow": "A pagar ahora",
  "storage.confirm.beforeTax": "(base, sin IVA)",
  "storage.confirm.vatNote": "El IVA se calcula en el pago según tu país. Empresas con NIF-IVA intracomunitario válido: exento (inversión del sujeto pasivo).",
  "storage.confirm.tos": "Acepto que esta es una suscripción anual renovable y que, si pierdo u olvido mi IKO, el contenido de esta Unidad deja de estar a mi alcance para siempre: nadie puede devolvérmelo.",
  "storage.confirm.tosLink": "Leer las Condiciones de compra",
  "storage.confirm.pay": "Pagar · {0}",
  "fm.root": "Inicio",
  "fm.newFolder": "Nueva carpeta",
  "fm.upload": "Subir",
  "fm.folderName": "Nombre de la carpeta",
  "fm.uploading": "Subiendo {0}…",
  "fm.emptyTitle": "Carpeta vacía",
  "fm.emptyHint": "Sube archivos o crea una carpeta para organizarlos.",
  "fm.rename": "Renombrar",
  "fm.move": "Mover",
  "fm.moveTitle": "Mover «{0}» a…",
  "fm.moveIntoSelf": "No puedes mover una carpeta dentro de sí misma.",
  "fm.confirmDeleteFolder": "¿Eliminar la carpeta «{0}» y todo su contenido? No se puede deshacer.",
  "storage.tab.files": "Archivos",
  "storage.tab.config": "Configurar",
  "storage.buy.ok": "Hecho. Tu Unidad queda activo.",
  "storage.buy.insufficient": "Saldo insuficiente. Recarga arriba y vuelve a intentarlo.",
  "storage.buy.buying": "Comprando…",
  "storage.buy.buy": "Comprar con saldo",
  "storage.buy.extend": "Extender con saldo",
  "storage.buy.blindNote": "El pago no se guarda asociado a esta Unidad: IKOGNIT registra solo que tu cuenta compró capacidad (importe y plan), nunca a qué Unidad se aplicó.",
  "storage.buy.webOnly": "Los planes se contratan desde app.ikognit.com en tu navegador.",
  "storage.buy.notConfigured": "Los pagos aún no están habilitados en este servidor.",
  "storage.buy.buyFor": "Comprar · {0}",
  "storage.buy.extendFor": "Extender · {0}",
  "storage.buy.credit": "Crédito",
  "storage.buy.awaitTitle": "Completa el pago",
  "storage.buy.awaitBody": "Termina el pago en la pestaña que se abrió. Tu compra se activará aquí automáticamente; no cierres esta página.",
  "storage.buy.activating": "Pago recibido. Activando tu compra…",
  "storage.buy.timeout": "No hemos recibido el pago a tiempo. Si lo completaste, el importe queda como crédito en tu cuenta: vuelve a pulsar Comprar y se usará.",
  "storage.buy.popupBlocked": "Tu navegador bloqueó la ventana de pago. Permite las ventanas emergentes para este sitio y vuelve a intentarlo.",
  "pay.return.okTitle": "Pago recibido ✓",
  "pay.return.okBody": "Ya puedes cerrar esta pestaña y volver a IKOGNIT: tu compra se está activando sola.",
  "pay.return.cancelTitle": "Pago cancelado",
  "pay.return.cancelBody": "No se ha cobrado nada. Puedes cerrar esta pestaña y volver a IKOGNIT.",
  "pay.return.close": "Cerrar",
  "storage.balance.label": "Saldo",
  "storage.balance.topup": "Recargar saldo:",
  "capsule.drawer.title": "Unidades",
  "capsule.generalIko": "Mi IKOGNIT (general)",
  "capsule.drawer.connected": "Unidades conectadas aquí",
  "capsule.drawer.hint": "Una Unidad es un disco cifrado tuyo que enchufas a este IKO, como un USB. El mismo Unidad puede estar conectado a varios IKO a la vez; lo que guardas se ve desde todos.",
  "capsule.drawer.emptyTitle": "No hay Unidades conectadas aquí",
  "capsule.drawer.emptyHint": "Conecta una Unidad tecleando sus IKO. Si aún no tienes ninguno, créalo desde Activar → Unidad.",
  "capsule.open": "Abrir",
  "capsule.disconnect": "Desconectar",
  "capsule.create.btn": "Crear Unidad",
  "capsule.create.first": "Crear mi primer Unidad",
  "capsule.connect.btn": "Conectar Unidad",
  "capsule.connect.title": "Conectar una Unidad",
  "capsule.connect.body": "Teclea las IKO de tu Unidad (la misma llave con la que lo creaste). Quedará enchufado a este IKO hasta que lo desconectes.",
  "capsule.connect.coords": "IKO de la Unidad",
  "capsule.connect.coordsPh": "p. ej. mi-disco-secreto",
  "capsule.connect.label": "Nombre (opcional)",
  "capsule.connect.labelPh": "p. ej. Documentos fiscales",
  "capsule.connect.connecting": "Conectando…",
  "capsule.connect.notFound": "No existe ninguna Unidad con esas IKO. Créalo primero (Activar → Unidad) y vuelve a conectarlo.",
  "capsule.about.title": "Cómo funcionan las Unidades",
  "capsule.about.body": "Los archivos de una Unidad se cifran con tu clave (propietario + IKO), así que solo tú los descifras. Puedes COMPARTIR una Unidad con quien quieras desde su chat (botón Compartir): la invitación viaja cifrada de extremo a extremo por una credencial ciega, y IKOGNIT nunca sabe que lo compartes, ni con quién, ni qué Unidades tienes. Revoca el acceso cuando quieras. Toda esa relación vive cifrada en tu IKO privado.",
  "ikopod.hint.ambient": "Las Unidades conectadas a este IKO se conectan solas mientras estás aquí; al salir, desaparecen de tus dispositivos sin dejar rastro.",
  "ikodrive.section": "IkoDrive · pinchos físicos",
  "ikodrive.hint": "Guarda archivos en una memoria USB cifrada por IKOGNIT. Solo se leen con TU usuario y DENTRO de este IKO; en cualquier otro sitio son ruido. Puedes montar varios pinchos a la vez.",
  "ikodrive.path.placeholder": "Ruta del disco .ikognit (o pulsa «Elegir archivo…»)",
  "ikodrive.pick.btn": "Elegir archivo…",
  "ikodrive.pick.new": "Crear disco nuevo…",
  "ikodrive.mount.title": "Montar un disco",
  "ikodrive.mount.btn": "Montar como unidad",
  "ikodrive.mountedAt": "Montado en {0}. Ábrelo en tu explorador de archivos.",
  "ikodrive.prepare.hint": "¿Es un pincho NUEVO, que aún no has usado con IKOGNIT? Prepáralo una vez. NO borra el USB ni lo formatea: solo crea dentro un fichero cifrado y respeta el resto de tus archivos.",
  "ikodrive.prepare.btn": "Preparar pincho nuevo",
  "ikodrive.prepare.overwrite": "⚠️ YA HAY UN IKODRIVE EN ESA RUTA. Si continúas, se BORRARÁ todo su contenido y no se podrá recuperar. ¿Seguro que quieres borrarlo y crear uno nuevo?",
  "ikodrive.prepare.kept": "Cancelado. No se ha tocado el IkoDrive existente.",
  "ikodrive.prepared": "Pincho preparado. Ahora pulsa «Montar como unidad».",
  "ikodrive.state.offline": "No conectado (recordado): conecta el pincho y pulsa Montar.",
  "ikodrive.state.error": "No se pudo montar.",
  "ikodrive.action.remount": "Montar",
  "ikodrive.action.unmount": "Desmontar",
  "ikodrive.action.forget": "Quitar",
  "ikodrive.bound": "Atado a tu usuario y a este IKO. Si cambias la contraseña, el pincho sigue funcionando; fuera de este IKO, no se abre. Al volver a este IKO, tus pinchos se vuelven a montar solos.",
  "ikodrive.err.path": "Indica la unidad del pincho.",
  "ikodrive.err.ikognitDrive": "Esa letra es una unidad de IKOGNIT (una Unidad o un IkoDrive ya montado), no tu memoria USB. Mira la letra de tu USB en el Explorador (p. ej. D:) y escribe esa.",
  "ikodrive.err.mount": "No se pudo montar el IkoDrive (¿usuario o IKO incorrecto, o pincho sin preparar?).",
  "ikodrive.err.generic": "No se pudo preparar el pincho.",
  "ikodrive.share.noContact": "Para compartir un pincho, abre este gestor desde el chat de la persona (menú ⋯ del contacto → Compartir).",
  "ikodrive.share.confirm": "¿Dar acceso a este pincho a {0}? Podrá abrirlo cuando tenga el USB. Ojo: el acceso no se puede retirar una vez lo haya abierto.",
  "ikodrive.share.already": "Compartido ✓",
  "ikodrive.share.reject": "Rechazar",
  "ikodrive.card.sent": "Compartiste un pincho cifrado",
  "ikodrive.card.recv": "Te han compartido un pincho cifrado",
  "ikodrive.card.hint": "Conéctalo y aparecerá en Unidades → IkoDrive.",
  "ikodrive.share.sent": "✓ Acceso al pincho enviado a {0}. Cuando tenga el USB, podrá abrirlo.",
  "ikodrive.share.sentLocal": "Compartiste el pincho «{0}».",
  "ikodrive.share.err": "No se pudo compartir el pincho (¿está montado?).",
  "ikodrive.shared.title": "Pinchos compartidos conmigo",
  "ikodrive.shared.hint": "Alguien te concedió acceso a su pincho. Conéctalo (o localiza el .ikognit en tu disco), pulsa «Elegir archivo…» para apuntar a TU fichero y luego «Montar como unidad». La ruta del titular no vale: el fichero está en otro sitio en tu equipo.",
  "ikopod.state.mounting": "Conectando…",
  "ikopod.state.mounted": "Conectado",
  "ikopod.state.mountedAt": "Conectado · {0}",
  "ikopod.state.inFiles": "Disponible en Archivos",
  "ikopod.state.error": "No disponible",
  "ikopod.action.openSystem": "Abrir en el sistema",
  "ikopod.action.viewHere": "Ver archivos aquí",
  "ikopod.sheet.close": "Cerrar",
  "manifest.blindServer": "El servidor es ciego.",
  "manifest.onlyYouRead": "Aquí solo lees tú.",
  "manifest.noPublicProfiles": "Sin perfiles públicos.",
  "manifest.noAdsNoClouds": "Sin publicidad. Sin nubes ajenas.",
  "manifest.keyWithYou": "La llave vive contigo.",
  "manifest.yourIkoYourSpaces": "Tus IKO. Tus espacios.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Archivos",
  "orb.mod.notes": "Notas",
  "orb.mod.photos": "Fotos",
  "orb.mod.vault": "Carpeta",
  "orb.mod.audios": "Audios",
  "orb.copy.line1": "Tus IKO.",
  "orb.copy.line2": "Tus espacios.",
  "explorer.filesNotProcessed": "Archivo(s) no procesados",
  "demo.edit": "Editar",
  "common.exit": "Salir",
  "common.more": "Más",
  "chat.tab.settings": "Ajustes",
  "chat.search.placeholder": "Buscar chat",
  "chat.presence.online": "en línea",
  "chat.action.call": "Llamar",
  "chat.action.videoCall": "Videollamada",
  "chat.attach.label": "Adjuntar",
  "chat.attach.camera": "Cámara",
  "chat.attach.voice": "Voz",
  "chat.attach.file": "Adjuntar archivo",
  "chat.composer.placeholder": "Escribe un mensaje...",
  "settings.addYourName": "Añade tu nombre",
  "settings.editProfile": "Editar perfil",
  "chat.welcome.intro": "Selecciona un chat para empezar a hablar de forma cifrada de extremo a extremo.",

  // Batch2: footer atajos web
  "web.footer.palette": "paleta",
  "web.footer.send": "enviar",
  "web.footer.line": "línea",
  "mobile.tb.ikoActivate": "Activar IKO",
  "mobile.tb.ikoExit": "Volver a IKOGNIT general",

  "chat.header.blocked": "Bloqueado",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Nota privada",
  "settings.account.newNickPlaceholder": "nuevo_nick",
  "settings.account.newEmailPlaceholder": "nuevo@email.com",


  "common.delete": "Eliminar",







  "private.module.explorer": "Mis objetos",
  "private.module.mail": "Buzón",


  "oauth.itemsSynced": "{0} elementos importados",

};

const en: Catalog = {
  "auth.verify.notSent": "We could not send you the code. Your account exists: press “Resend code” in a moment.",
  "lg.rotulo": "Messaging with private spaces",
  "lg.btn.entrar": "Sign in",
  "lg.eyebrow": "Private messaging · Itrion Software",
  "lg.h1a": "The conversations you already have.",
  "lg.h1b": "And a place that only exists when you call it up.",
  "lg.lead1": "You talk to your family, your friends and your team, like in any app. The difference starts when you open an IKO: a space of your own that you enter by writing a secret only those inside know.",
  "lg.lead2": "Until you call it up, that space is not on your device — not on the phone, not on the tablet, not on the computer. It is not that it is encrypted.",
  "lg.lead2b": "It is that it is not there.",
  "lg.pruebalo": "Try it yourself · write a secret and see what happens",
  "lg.panel.plano": "General plane",
  "lg.demo.hilos": "Family=Mum: dinner at ours on Sunday?=19:04|Marta=sending you Saturday photos=17:52|Team=Luis: tomorrow at nine then=Yesterday|Javi=haha I do not believe it=Yesterday",
  "lg.demo.mundos": "Just the two of us~did you put it where we said?|yes. the deeds and the passport>~Flat deeds.pdf=2.4 MB|Private photos=214|Card · bank=Data~~House things~leaving the tenancy agreement here>|and the router key, you always lose it~Tenancy agreement.pdf=1.1 MB|ID copy=2 files|House keys=Data~~My notes~I have told no one about this>|and there is no need to>~Diary=48 notes|Photos=1,207|This year accounts=Data~~Lisbon project~the offer comes to 180|here it is, no copies outside>~Offer_v4.pdf=860 KB|Contacts=12|Company card=Data~~Saturday lunch~do not tell Marta yet|relax, nobody finds out in here>~Booking.pdf=120 KB|Photos from last year=63|Guest list=Data",
  "lg.invocaLabel": "Call up your IKO",
  "lg.invocaPlaceholder": "write any secret",
  "lg.invocaBtn": "Call it up",
  "lg.invocaHint": "Every word leads to a different space. Try another one.",
  "lg.estela.vacio": "Write anything: this is a demonstration.",
  "lg.estela.primero": "There. It exists only while you are inside.",
  "lg.estela.otro": "Another secret, another space. Neither knows about the other.",
  "lg.estela.salida": "Gone. No trace left on the device. Try another word.",
  "lg.ikoActivo": "IKO active",
  "lg.nadaEnDispositivo": "None of this is on the device",
  "lg.salirIko": "Leave the IKO",
  "lg.planos.h2a": "One plane in plain sight.",
  "lg.planos.h2b": "Below it, the ones you call up.",
  "lg.planos.lead": "There is no such thing as “the IKO”. There are the ones you open: one for home, one for work, one only two of you know about, one you have never mentioned to anyone. Each secret leads to its own, and none knows about the others.",
  "lg.planos.unoRotulo": "The general plane · one",
  "lg.planos.unoH3": "Where you talk to everyone",
  "lg.planos.unoP": "Conversations, groups, calls, photos and files, end-to-end encrypted. What you expect from a messaging app, done properly. Your usual chats live here and behave as always.",
  "lg.planos.nRotulo": "The IKOs · as many as you want",
  "lg.planos.nH3": "Where nobody else reaches",
  "lg.planos.nP": "You write a secret and the space it belongs to appears. Conversations and your things fit inside. When you leave, it goes from the device without a trace. There is no list, no number, and nobody can work out how many you have, or that a single one exists.",
  "lg.planos.chips": "Home things|Work|What only two of you know|Yours and no one else’s|The one you opened once and never touched again|The ones you decide tomorrow",
  "lg.forense.h2a": "It is not encrypted on your device.",
  "lg.forense.h2b": "It is not on your device.",
  "lg.forense.lead": "Other apps keep your messages on the machine and encrypt them. If someone takes it, your privacy depends on that encryption holding long enough. Here there is nothing that has to hold: what lives inside an IKO is never written to any device. You call it up, you use it, it goes.",
  "lg.forense.multi": "It works the same everywhere: phone, tablet, home computer, work laptop, Windows, Mac or a browser somewhere that is not yours. Go in wherever you like and, when you leave, that place knows nothing about you again.",
  "lg.forense.caption": "What someone examining any of your devices finds",
  "lg.forense.filas": "Messages from your IKOs=0|Files and photos from your IKOs=0|Stored IKO secrets=0|Database holding your IKOs=none exists|Trace that an IKO was ever open=none|How many IKOs you have=undeterminable",
  "lg.escenas.h2": "What actually worries you.",
  "lg.escenas.filas": "“I have lost my phone.”=Your privacy did not go with it. What was inside an IKO was never on that machine, so there is nothing to rescue and nothing to fear. You call it up from any other device and everything is still where it was.~“Someone has taken my laptop.”=They will see your ordinary conversations, the same ones they would see in any app. Of the rest they will not see the content, nor the name, nor a hint that it exists.~“They have examined my computer.”=A forensic analysis recovers what is written on the disk, even encrypted and deleted. Here there is nothing written to recover. The answer is not “it cannot be decrypted”: it is that there is nothing. And the same goes for the tablet, the phone and the browser you used one afternoon.",
  "lg.ciego.h2": "Not us. Not whoever hosts the servers.",
  "lg.ciego.p1": "The server keeps things it cannot read. It does not have your secret, it has never had it, and no copy exists anywhere. It is not that we refuse to hand over what is inside your IKOs: it is that we do not have it, and there is no way for us to have it. Neither does the company hosting the machines, nor anyone who got hold of them.",
  "lg.ciego.p2": "That has a price and it is only fair to say so: if you lose your secret, there is nobody who can give it back. The very reason nobody else can get in is the reason we cannot help you get in either.",
  "lg.guardas": "Family photos|The notes you do not show|Cards and bank details|Passwords|Documents|Conversations that concern only you",
  "lg.nombre.esta": "it is there",
  "lg.nombre.noEsta": "it is not",
  "lg.nombre.h2": "Hence the name.",
  "lg.nombre.p": "In Swahili, iko means “it is there” and haiko, “it is not”. An IKO is there while you call it up. The rest of the time — which is almost all the time — it is not: not on your devices, not in anyone’s sight, not even as a suspicion.",
  "lg.cierre.h2": "Start talking.",
  "lg.cierre.p": "It works like any messaging app, on the phone, the tablet and the computer. The IKOs are there the day you need them.",
  "lg.cierre.btnCrear": "Create account",
  "lg.cierre.btnEntrar": "I already have an account",
  "lg.cierre.pago": "IKOGNIT is a paid product. No ads, no advertising profiles and no copy of anything on our side: we live off the app being worth it to you, not off whatever you might say inside it.",
  "lg.pie.ciego": "Blind server",
  "auth.hola": "Hello again.",
  "auth.queEs": "What is IKOGNIT?",
  "common.cancel": "Cancel",
  "common.error.generic": "That did not go through. Try again.",
  "common.save": "Save",
  "common.confirm": "Confirm",
  "common.close": "Close",
  "common.prev": "Previous",
  "common.next": "Next",
  "common.loading": "Loading…",
  "common.add": "Add",
  "common.back": "Back",
  "common.edit": "Edit",
  "common.tagline": "Digital sovereignty.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "In Swahili, iko means “it is there”. And haiko, “it is not”.",
  "auth.legal.age": "I confirm that I meet the minimum age required by the law of my country to use IKOGNIT.",
  "auth.legal.accept": "I have read and accept the <a href='https://ikognit.org/legal/en/terms.html' target='_blank' rel='noopener'>Terms</a>, the <a href='https://ikognit.org/legal/en/privacy.html' target='_blank' rel='noopener'>Privacy Policy</a> and the <a href='https://ikognit.org/legal/en/community-rules.html' target='_blank' rel='noopener'>Community Rules</a>.",
  "report.title": "Report user",
  "report.targetSubtitle": "Reporting {0}",
  "report.intro": "Your report goes to IKOGNIT's moderation team. Messages are E2E-encrypted and we never see them — the report relies on your word, so describe it clearly.",
  "report.reasonLegend": "Reason for reporting",
  "report.detailLabel": "Details (optional)",
  "report.detailPlaceholder": "What happened, when, any context that helps investigate.",
  "report.autoBlockNotice": "Submitting this report will also block this user. They won't be able to message you again.",
  "report.sending": "Sending…",
  "report.submit": "Submit report",
  "report.success": "Report sent. The user is now blocked.",
  "report.reason.spam": "Spam",
  "report.reason.spam.desc": "Mass messaging, unsolicited advertising, suspicious links.",
  "report.reason.harassment": "Harassment or insults",
  "report.reason.harassment.desc": "Intimidating messages, personal attacks, bullying.",
  "report.reason.hate": "Hate speech",
  "report.reason.hate.desc": "Racist, xenophobic, sexist, homophobic or similar content.",
  "report.reason.csam": "Child sexual abuse material",
  "report.reason.csam.desc": "Any content involving minors. Highest priority.",
  "report.reason.violence": "Threats or violence",
  "report.reason.violence.desc": "Physical threats, incitement to violence, self-harm.",
  "report.reason.illegal": "Illegal activity",
  "report.reason.illegal.desc": "Trafficking, weapons, drugs or other illegal conduct.",
  "report.reason.impersonation": "Impersonation",
  "report.reason.impersonation.desc": "Pretending to be another real person or organization.",
  "report.reason.other": "Other",
  "report.reason.other.desc": "Any behavior that doesn't fit above.",
  "recovery.title": "Your recovery key",
  "recovery.intro": "These **24 words** are the only way to recover your account and history if you forget your password or lose your device. **Write them on paper and keep them in a safe place.** Nobody at IKOGNIT can recover them for you.",
  "recovery.warn": "**Write them down OFFLINE.** Do not take a screenshot. Do not send them by email or messaging. Whoever has these words controls your entire account.",
  "recovery.btn.show": "Show words",
  "recovery.btn.copy": "Copy",
  "recovery.btn.copied": "Copied · clears in {0}s",
  "recovery.btn.cleared": "Clipboard cleared",
  "recovery.btn.copyAria": "Copy recovery phrase to clipboard (will auto-clear)",
  "recovery.btn.download": "Download",
  "recovery.btn.downloadAria": "Download phrase as text file",
  "recovery.btn.back": "Go back to see the words",
  "recovery.btn.continue": "Continue",
  "recovery.btn.done": "I'm done",
  "recovery.btn.need3": "Type the 3 correct words",
  "recovery.verify.intro": "To confirm you saved your key, type these words. You can't continue without getting them right.",
  "recovery.verify.wordN": "Word #{0}",
  "recovery.verify.correct": "Correct",
  "recovery.verify.wrong": "Incorrect",
  "auth.error.legalRequired": "You must accept the legal terms and confirm your age to create your account.",
  "auth.error.pwShort": "The password must be at least 10 characters.",
  "auth.error.pwMismatch": "The master keys do not match.",
  "auth.error.pwWeak": "The password does not meet the security requirements.",
  "auth.field.passwordConfirm": "Repeat the password",
  "auth.pw.req.length": "At least 10 characters",
  "auth.pw.req.lower": "A lowercase letter",
  "auth.pw.req.upper": "An uppercase letter",
  "auth.pw.req.digit": "A number",
  "auth.pw.req.symbol": "A symbol (!@#$%…)",
  "auth.pw.req.match": "The passwords match",
  "auth.forgot": "Forgot your password?",
  "recover.title": "Recover your access",
  "recover.intro": "Enter your nick or email and the 24 recovery words you were given when the account was created. Then you will choose a new password.",
  "recover.field.username": "Nick or email",
  "recover.field.phrase": "Your 24 recovery words",
  "recover.field.phrasePlaceholder": "word1 word2 word3 …",
  "recover.field.newPassword": "New password",
  "recover.field.newPasswordConfirm": "Repeat the new password",
  "recover.btn.submit": "Recover my access",
  "recover.btn.cancel": "Back to sign in",
  "recover.error.invalidPhrase": "Those 24 words are not valid. Check they are exactly the ones we showed you.",
  "recover.error.notFound": "We can't find that combination of account and recovery words.",
  "recover.error.notEnabled": "This account doesn't have recovery enabled. Sign in with your password and enable it from Settings.",
  "settings.legal.title": "Legal information",
  "settings.legal.hint": "Read inside the app. Works offline once viewed.",
  "explorer.add.paste": "Paste from clipboard",
  "paste.unsupported": "Paste isn't supported on this device.",
  "paste.noImage": "No image in clipboard.",
  "paste.permissionDenied": "Permission denied to read clipboard.",
  "paste.failed": "Could not paste.",
  "legal.loading": "Loading document…",
  "legal.loadError": "Could not load the document. Check your connection or open it in the browser.",
  "legal.openExternal": "Open in browser",
  "legal.fromCache": "Showing cached version — refreshing…",
  "settings.legal.hub": "Legal Center",
  "settings.legal.terms": "Terms and Conditions",
  "settings.legal.purchase": "Purchase Conditions",
  "settings.legal.privacy": "Privacy Policy",
  "settings.legal.rules": "Community Rules",
  "settings.legal.report": "Reporting and Moderation",
  "settings.legal.cookies": "Cookie Policy",
  "settings.legal.minors": "Minors Policy",
  "settings.legal.notice": "Legal Notice",
  "settings.tab.legal": "Legal",
  "auth.loading": "Loading…",
  "auth.savedSession": "This device already knows its owner.",
  "auth.tab.login": "Sign in",
  "auth.tab.register": "New account",
  "auth.subLogin": "You are entering the general plane: your usual conversations. Your IKOs are not called up here — they are called up inside, when you need them.",
  "auth.demo.enter": "Enter demo account (App Review)",
  "auth.demo.hint": "One-tap access to a pre-populated demo account (chat, files, Drive and wallet). No credentials to type.",
  "auth.subRegister": "The account is registered in your name. The nick is how others see you; email is only for recovering access and for notices.",
  "auth.field.devicePin": "Device PIN",
  "dominio.suspendido.duena": "A payment is due. Settle it and everything comes back as it was: nothing in here has been touched.",
  "dominio.suspendido.pagar": "Go to payment",
  "comprar.enlace": "I want a domain",
  "comprar.title": "A domain of your own",
  "comprar.sub": "A server with its own people. Paid up front; cancel any time and it stays active until the end of the paid period.",
  "comprar.nombre": "Name",
  "comprar.nombrePlaceholder": "your-place",
  "comprar.email": "Billing email",
  "comprar.libre": "available",
  "comprar.ocupado": "taken",
  "comprar.formato": "lowercase, digits and hyphens",
  "comprar.aviso": "The domain is created once payment clears. The first account to join becomes its owner, and only this email can open it.",
  "comprar.periodicidad": "Every month, until you cancel.",
  "comprar.plan": "Plan",
  "comprar.periodo": "Billing period",
  "comprar.periodo.mes": "Monthly",
  "comprar.periodo.trimestre": "Quarterly",
  "comprar.periodo.ano": "Yearly",
  "comprar.hastaN": "up to {0}",
  "comprar.sinImpuestos": "Excluding tax. The total is worked out from your country.",
  "comprar.base": "Subtotal",
  "comprar.impuesto": "Tax ({0}%)",
  "comprar.total": "Total",
  "comprar.aQuienFactura": "Bill to",
  "comprar.tipo.particular": "Individual",
  "comprar.tipo.empresa": "Company",
  "comprar.nombreFiscal": "First name",
  "comprar.apellidos": "Surname",
  "comprar.razonSocial": "Company name",
  "comprar.nif": "Tax ID",
  "comprar.nifOpcional": "optional",
  "comprar.pais": "Country",
  "comprar.paisElige": "Choose a country",
  "comprar.via": "Address",
  "comprar.cp": "Postcode",
  "comprar.ciudad": "City",
  "comprar.vendedor": "Sold by ITRION SOFTWARE, S.L. · Tax ID B19913797 · Calle Francisco Silvela 110, planta 2, 28028 Madrid, Spain",
  "comprar.acepta": "I have read and accept the <a href=\"https://ikognit.org/legal/en/purchase-terms.html\" target=\"_blank\" rel=\"noopener\">purchase terms</a> and the <a href=\"https://ikognit.org/legal/en/privacy.html\" target=\"_blank\" rel=\"noopener\">privacy policy</a>. I ask for the service to start now and I understand that this waives my 14-day right of withdrawal.",
  "comprar.pagar": "Pay",
  "comprar.cobrando": "Charging…",
  "comprar.confirmando": "Confirming payment…",
  "comprar.tardando": "The payment went through, but confirmation is taking a while. The invoice is on its way by email; sign in again in a few minutes with the domain name.",
  "comprar.btn": "Continue",
  "comprar.proximamente": "Coming soon.",
  "auth.field.dominio": "Domain",
  "auth.field.dominioPlaceholder": "Empty: IKOGNIT",
  "auth.field.invitacion": "Invitation code",
  "auth.error.dominioSuspendido": "This domain is suspended. Talk to its owner.",
  "dominio.title": "Domain",
  "dominio.estado.activo": "Up to date",
  "dominio.estado.gracia": "A payment is pending.",
  "dominio.estado.congelado": "Suspended",
  "dominio.gracia.aviso": "A payment is due. Everything keeps working until {0}.",
  "dominio.seccion.miembros": "Who has a way in",
  "dominio.seccion.registro": "Sign-up",
  "dominio.seccion.invitaciones": "Invitations",
  "dominio.seccion.facturacion": "Billing",  "dominio.seccion.facturas": "Invoices",
  "dominio.facturas.vacio": "None yet.",
  "dominio.facturas.hasta": "Paid through {0}.",
  "dominio.facturas.impuesto": "{0}% · {1}",
  "dominio.facturas.isp": "Reverse charge",
  "dominio.facturas.sinImpuesto": "No tax",
  "dominio.facturas.metodoPago": "Change card",
  "dominio.facturas.pdf": "PDF",

  "dominio.seccion.llave": "The domain key",
  "dominio.seccion.propiedad": "Ownership",
  "dominio.miembros.alta": "Joined {0}",
  "dominio.miembros.dueno": "Owner",
  "dominio.miembros.retirar": "Withdraw the way in",
  "dominio.miembros.retirarConfirm": "Their way in is withdrawn at once.",
  "dominio.miembros.vacio": "Nothing yet. Whoever you invite shows up here.",
  "dominio.registro.invitacion": "By invitation only",
  "dominio.registro.abierto": "Open",
  "dominio.registro.explica": "By invitation, whoever you let in gets in.",
  "dominio.invitaciones.nueva": "New invitation",
  "dominio.invitaciones.usos": "Uses",
  "dominio.invitaciones.dias": "Days",
  "dominio.invitaciones.enlace": "Link",
  "dominio.invitaciones.copiar": "Copy",
  "dominio.invitaciones.copiado": "Copied",
  "dominio.invitaciones.gastadas": "{0} of {1} used",
  "dominio.invitaciones.vacio": "Nothing yet.",
  "dominio.invitaciones.borrar": "Void",
  "dominio.llave.explica": "Every device in the domain gets it on the way in. Keep a copy yourself.",
  "dominio.llave.ver": "Show the key",
  "dominio.llave.copiar": "Copy the key",
  "dominio.transferir": "Transfer ownership",
  "dominio.transferir.explica": "Ownership goes to another member. It stops being yours.",
  "dominio.transferir.confirma": "Type {0} to confirm.",
  "dominio.esfumar": "Vanish the domain",
  "dominio.esfumar.aviso": "This vanishes. No copy, no trace, no claim.",
  "dominio.esfumar.palabra": "ESFUMAR",
  "dominio.limite": "What this panel cannot show: what is said, which IKOs exist, who talks to whom, what is kept. The owner sees who has a way in. Nothing else.",
  "auth.field.identifier": "Email or nick",
  "auth.field.identifierPlaceholder": "you@email.com or your_nick",
  "auth.field.nick": "Nick",
  "auth.reg.paso1": "Let's start with your email. We'll send you a code to check it's yours; the rest comes after.",
  "auth.reg.enviarCodigo": "Send me the code",
  "auth.reg.paso3.title": "Almost there",
  "auth.reg.paso3.sub": "Email verified: {0}. Now pick how people will see you, and a password.",
  "auth.field.email": "Email",
  "auth.field.nickPlaceholder": "e.g. user123",
  "auth.field.emailPlaceholder": "you@email.com",
  "auth.field.newPassword": "New password",
  "auth.field.password": "Password",
  "auth.nick.available": "available",
  "auth.nick.checking": "checking…",
  "auth.nick.taken": "already taken",
  "auth.nick.invalid": "invalid (3-20 chars, a-z, 0-9, _)",
  "auth.error.nickTaken": "That nick is already taken.",
  "auth.error.emailTaken": "An account with that email already exists.",
  "auth.error.invalidNick": "Invalid nick. Use 3-20 chars: a-z, 0-9 and _ (not starting/ending with _).",
  "auth.error.invalidEmail": "Invalid email.",
  "auth.error.badCode": "Wrong code.",
  "auth.error.codeExpired": "Code has expired. Request a new one.",
  "auth.error.tooManyAttempts": "Too many attempts. Request a new code.",
  "auth.error.noCode": "No active code. Request a new one.",
  "auth.verify.title": "Verify your email",
  "auth.verify.sub": "We sent a code to {0}. Enter it to activate your account.",
  "auth.verify.codeLabel": "6-digit code",
  "auth.verify.btn": "Verify",
  "auth.verify.resend": "Resend code",
  "auth.forgot.title": "Reset password",
  "auth.forgot.intro": "We'll send a 6-digit code to your email so you can choose a new password.",
  "auth.forgot.btnSend": "Send code",
  "auth.forgot.bip39": "I have my recovery phrase",
  "auth.reset.title": "New password",
  "auth.reset.sub": "Enter the code we sent to {0} and choose a new password.",
  "auth.reset.btnConfirm": "Change password",
  "auth.reset.warnNewIdentity": "Your account stays yours, but recovering by email gives you a new identity: earlier messages can no longer be read. If you still have your 24-word recovery phrase, use that route instead.",
  "recover.error.invalid": "Invalid recovery data.",
  "auth.btn.unlock": "Sign in",
  "auth.btn.unlocking": "Signing in…",
  "auth.btn.processing": "Processing…",
  "auth.btn.createIdentity": "Create account",
  "auth.btn.useOther": "Use another account",
  "auth.btn.forget": "Forget this device",
  "auth.btn.backToUnlock": "Back",
  "auth.confirmForget": "This device will stop recognising you: the saved account and anything cached vanish. To get back in you will need your password.",
  "auth.error.badCreds": "Wrong nick/email or password.",
  "auth.error.userNotFound": "Account not found.",
  "auth.error.cantConnect": "Couldn't connect to the server.",
  "auth.error.missingFields": "Some required fields are missing.",
  "auth.error.usernameTooShort": "The username is too short.",
  "auth.error.usernameInvalid": "The username contains characters that aren't allowed.",
  "auth.error.rateLimited": "Too many attempts. Wait a few minutes and try again.",
  "auth.error.invalidInput": "Invalid input. {0}",
  "auth.sessionExpired": "The session faded away. Come in again.",
  "auth.locked": "It faded away after inactivity. Come in again.",
  "pods.invite.title": "Drive invitation",
  "pods.invite.view": "You'll be able to view it",
  "pods.invite.edit": "You'll be able to view and edit",
  "pods.invite.accept": "Accept and connect",
  "pods.grant.title": "Drive access granted",
  "pods.grant.ready": "You can open it now",
  "pods.accept.pending": "Access request sent",
  "pods.invite.badSig": "Invalid or tampered invitation",
  "pods.share.title": "Share this Drive",
  "pods.share.menuTitle": "Share a Drive or stick",
  "pods.share.rights": "Permissions",
  "pods.share.view": "View only",
  "pods.share.edit": "View and edit",
  "pods.share.btn": "Share",
  "pods.share.sent": "Invitation sent",
  "pods.share.noContact": "Open a chat with the person you want to share the Drive with",
  "pods.share.with": "Will be shared with {0}. Tap Share and the invitation will arrive in their chat.",
  "chat.more": "More",
  "invite.friends": "Invite friends",
  "invite.copied": "Invitation link copied",
  "invite.joined": "{0} joined IKOGNIT",
  "invite.welcome": "{0} invites you to IKOGNIT",
  "invite.welcomeSub": "Messaging and a space of your own: what you keep here is registered in your name. Create your account and you will be connected.",
  "invite.continue": "Continue",
  "invite.modalTitle": "Invite a friend",
  "invite.modalSub": "The reward is IKOGNIT itself: truly private messaging. Share the link or let them scan the code; once they're in, you'll be connected.",
  "invite.scan": "Scan it in person",
  "invite.share": "Share link",
  "invite.copy": "Copy link",
  "invite.linkLabel": "Your invitation link",
  "invite.podFriend": "Invite a friend who isn't on IKOGNIT yet",
  "dash.app.files": "Files",
  "dash.app.mail": "Mail",
  "dash.app.calendar": "Calendar",
  "dash.app.directory": "Directory",
  "dash.app.vault": "Passwords",
  "dash.app.ikopods": "Drives",
  "dash.w.seats.storage": "Storage: {0}",
  "dash.w.seats.manage": "Manage plan",
  "dash.w.ikopods.manage": "Manage Drives",
  "pods.explorer.newFolder": "New folder",
  "pods.explorer.home": "Home",
  "pods.explorer.rename": "Rename",
  "pods.explorer.title": "Shared pod",
  "pods.explorer.badCred": "Invalid or expired pod credential",
  "pods.explorer.files": "Files",
  "pods.explorer.upload": "Upload file",
  "pods.explorer.download": "Download",
  "pods.explorer.delete": "Delete",
  "pods.explorer.empty": "No files in this shared pod yet",
  "pods.explorer.noBody": "The file has no content",
  "pods.explorer.readonly": "Read-only: you can't modify this pod",
  "pods.shared.section": "Shared with me",
  "pods.shared.open": "Open",
  "pods.owned.open": "Shared content",
  "pods.owned.revoke": "Revoke access",
  "pods.owned.revokeConfirm": "Revoking access invalidates the current credentials and rotates the pod key. Anyone you want to keep will need a new invite. Continue?",
  "pods.owned.revokeDone": "Access revoked and key rotated. Share again with whoever you want to keep.",
  "pods.safety.hint": "Pod safety number: compare it out of band with whoever shares it with you to rule out impersonation.",
  "auth.confirmForget.warning": "Without the 24-word recovery phrase written down, there is no way back: no one can give it back to you.",
  "auth.confirmForget.typeLabel": "Type the word to confirm:",
  "auth.confirmForget.typeWord": "FORGET",
  "offline.disconnected": "You're offline",
  "offline.reconnecting": "Reconnecting…",
  "auth.error.badPin": "Wrong key.",
  "auth.footnote": "Whoever owns it, answers for it.\nLose the password and there is\nno one to appeal to.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Current IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Personal IKO: {0}",
  "sidebar.freqPsh": "Domain IKO: {0}",
  "sidebar.tune": "Activate IKO",
  "sidebar.newChat": "New chat",
  "sidebar.myContacts": "My contacts",
  "chats.title": "Chats",
  "chats.search": "Search chat",
  "chats.noResults": "No results.",
  "chats.emptyOnboard": "You have no chats yet. Tap + to add a contact by their nick.",
  "newchat.hero.title": "Start a conversation",
  "newchat.hero.desc": "Add someone by their nick to open an encrypted chat, or create a group with the contacts you already have.",
  "newchat.section.actions": "Actions",
  "newchat.hint.newGroup": "Bring several contacts into one conversation.",
  "newchat.hint.noContacts": "You need at least one contact to create a group.",
  "newchat.hint.myContacts": "View and manage your saved contacts.",
  "newchat.addContact": "Add contact",
  "sidebar.exitFreq": "Return to IKOGNIT",
  "sidebar.notifications": "Notifications",
  "sidebar.remember": "Remember device",
  "sidebar.forget": "Forget device",
  "sidebar.addContact": "Add contact by nick",
  "sidebar.newGroup": "New group",
  "sidebar.settings": "Settings",
  "sidebar.logout": "Sign out",
  "sidebar.tooltip.logout": "Sign out and wipe everything local",
  "sidebar.savedFreq.tooltip": "Activate {0}",
  "chat.empty": "Select or add a contact",
  "welcome.title": "Welcome to IKOGNIT",
  "welcome.concept": "In IKOGNIT you talk with other users identified by your nick. When you want a separate space, you activate a IKO and enter a IKO. If it is Public, you meet those who also activate it. If it is Private, you enter a IKO where only you exist.",
  "welcome.step1": "Call up an IKO and go in alongside whoever else knows it.",
  "welcome.step2": "Here in IKOGNIT, add a nick as a contact and start talking.",
  "welcome.step3": "Call up a personal IKO and stay in it alone: that is where you keep files, photos, audio, video, passwords, notes and letters.",
  "welcome.multidevice": "IKO are never stored anywhere. If you forget a IKO, its IKO ceases to exist for you.",
  "welcome.btnFreq": "Activate IKO",
  "welcome.btnContacts": "Add contact",
  "push.btnOn": "Notifications ON",
  "biometric.setting": "Biometric invocation",
  "biometric.unlock": "Use Face ID / fingerprint",
  "biometric.failed": "Biometrics unavailable or cancelled",
  "push.btnOff": "Notifications OFF",
  "push.btnEnable": "Notifications off. Click to enable.",
  "push.btnDisable": "Notifications on. Click to disable.",
  "push.introTitle": "Before enabling notifications",
  "push.introBody": "For privacy, IKOGNIT notifications are different from those of other messaging apps:",
  "push.introBullet1": "Message content is not included.",
  "push.introBullet2": "The sender's name or nick is not shown.",
  "push.introBullet3": "You will only receive a \"new message\" alert; open the app to read it encrypted on your device.",
  "push.introConfirm": "Enable notifications",
  "chat.placeholder": "Write a message…",
  "chat.newMessages": "new",
  "chat.newMessagesBadge": "Jump to {0} new messages",
  "chat.mediaRetry": "Retry",
  "chat.mediaFailed": "Couldn't load",
  "chat.media.download": "Download",
  "chat.media.share": "Share",
  "chat.media.save": "Save",
  "chat.media.forward": "Forward",
  "chat.media.delete": "Delete",
  "chat.media.deleteConfirmTitle": "Delete photo?",
  "chat.media.deleteConfirmBody": "This action cannot be undone.",
  "chat.media.deleteForMe": "Delete for me",
  "chat.media.deleteForAll": "Delete for everyone",
  "chat.media.forwardTo": "Forward to",
  "chat.editPlaceholder": "Edit your message…",
  "chat.replyingTo": "Replying to {0}",
  "chat.editing": "Editing message",
  "chat.confirmContact": "Add to contacts",
  "chat.unconfirmedBanner": "This user has written to you but is not in your contacts. Until you add them, your photo and info will not be visible to them according to your privacy settings.",
  "chat.online": "online",
  "chat.lastSeen": "last seen {0}",
  "chat.tooltip.attach": "Attach file",
  "chat.tooltip.shareContact": "Share contact",
  "chat.tooltip.paste": "Paste image from clipboard",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Voice call",
  "chat.tooltip.callVideo": "Video call",
  "call.err.notAllowed": "You are not in this call.",
  "call.err.noRoom": "This call no longer exists.",
  "call.err.unavailable": "Calls are unavailable right now.",
  "call.err.generic": "Could not join the call.",
  "call.addPeople": "Add to call",
  "call.group.start": "Call the group",
  "call.launcher.start": "Team call",
  "call.launcher.join": "Join call",
  "call.room.title": "End-to-end encrypted call",
  "call.room.encrypted": "E2E encrypted",
  "call.room.encryptedTitle": "Your audio and video are encrypted — only participants can see them.",
  "call.room.serverBlind": "Server blind",
  "call.room.participants": "{0} participants",
  "call.room.connecting": "Connecting…",
  "call.room.you": "You",
  "call.room.mic": "Microphone",
  "call.room.camera": "Camera",
  "call.room.screen": "Share screen",
  "call.room.leave": "Hang up",
  "chat.tooltip.camera": "Camera",
  "chat.attach.photos": "Photos",
  "chat.attach.document": "Document",
  "chat.attach.location": "Location",
  "chat.attach.contact": "Contact",
  "stickers.modeSticker": "Stickers",
  "stickers.modeEmoji": "Emojis",
  "stickers.cat.caras": "Caras",
  "stickers.cat.corazones": "Corazones",
  "stickers.cat.trending": "Tendencias",
  "stickers.cat.animales": "Animales",
  "stickers.cat.comida": "Comida",
  "error.locationPermission": "IKOGNIT needs location permission. Enable it in Settings.",
  "error.locationUnavailable": "Could not get your location.",
  "error.locationTimeout": "Timed out while looking up your location.",
  "error.locationUnsupported": "Your browser does not support geolocation.",
  "chat.btn.send": "Send",
  "chat.uploading": "…",
  "chat.voice.holdToRecord": "Hold to record",
  "chat.voice.slideToCancel": "Slide to cancel",
  "chat.voice.cancel": "Cancel recording",
  "chat.voice.sendNow": "Send voice note",
  "chat.voice.play": "Play",
  "chat.voice.pause": "Pause",
  "chat.voice.rate": "Change playback speed",
  "chat.voice.err.permission": "IKOGNIT needs microphone permission. Enable it in Settings.",
  "chat.voice.err.codec": "This browser cannot record voice.",
  "chat.voice.err.noDevice": "No microphone found.",
  "chat.voice.err.generic": "Could not start recording.",
  "preview.image": "📷 Image",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "preview.voice": "🎙 Voice message",
  "preview.location": "📍 Location",
  "preview.locationLive": "📍 Live location",
  "location.card.title": "Location",
  "location.live.liveTitle": "Live location",
  "location.live.endedTitle": "Shared",
  "location.live.remaining": "{0} left",
  "location.live.endedAt": "ended at {0}",
  "location.live.endedExpired": "no longer sharing",
  "location.live.stop": "Stop",
  "location.live.15min": "15 minutes",
  "location.live.1h": "1 hour",
  "location.live.8h": "8 hours",
  "location.modal.title": "Share location",
  "location.modal.snapshot.title": "My current location",
  "location.modal.snapshot.sub": "Send a single coordinate",
  "location.modal.live.title": "In real time",
  "location.modal.live.sub": "Your location will update automatically for the chosen duration.",
  "bubble.copy": "Copy",
  "bubble.reply": "Reply",
  "bubble.forward": "Forward",
  "bubble.edit": "Edit",
  "bubble.deleteForMe": "Delete for me",
  "bubble.deleteForEveryone": "Delete for everyone",
  "bubble.edited": "edited",
  "bubble.contact.label": "IKOGNIT contact",
  "chat.syncing": "Syncing…",
  "bubble.media.decrypting": "Decrypting…",
  "bubble.media.failed": "Could not decrypt the file.",
  "call.calling": "Calling…",
  "call.incoming.audio": "Incoming call",
  "call.incoming.video": "Incoming video call",
  "call.connecting": "Connecting…",
  "call.ending": "Ending…",
  "call.accept": "Accept",
  "call.reject": "Reject",
  "call.hangup": "Hang up",
  "call.mic": "Microphone",
  "call.camera": "Camera",
  "call.audioOut": "Audio output",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "To call you must be inside a IKO.",
  "error.notFound": "Resource not found.",
  "error.notInFreq": "{0} is not in this IKO yet. Ask them through another channel to activate it.",
  "error.push.iosTooOld": "Your iOS is older than 16.4. Update it to receive notifications.",
  "error.push.iosNotStandalone": "To receive notifications on iPhone, install IKOGNIT to the home screen: tap Share → Add to Home Screen.",
  "error.expired": "Session expired. Sign in again.",
  "error.gone": "The file has expired.",
  "error.invalid": "Invalid data.",
  "error.server": "Server error. Please try again.",
  "error.network": "No connection to the server.",
  "error.cantStartCall": "Couldn't start the call: {0}",
  "error.cantAcceptCall": "Couldn't accept the call: {0}",
  "error.cantPaste": "Couldn't access the clipboard. Try using the attach button.",
  "error.noImageInClipboard": "There is no image in the clipboard.",
  "error.clipboardUnsupported": "Your browser doesn't allow clipboard reading. Paste with Ctrl+V or use the attach button.",
  "error.selfContact": "You cannot add yourself.",
  "error.blocked": "You have blocked this user. Unblock in Settings to talk again.",
  "settings.title": "Settings",
  "settings.close": "Close",
  "settings.back": "Back",
  "settings.hero.noName": "Add your name",
  "settings.hero.edit": "Edit profile",
  "settings.tab.profile": "👤 Profile",
  "settings.tab.privacy": "🔒 Privacy",
  "settings.tab.messages": "✉ Messages",
  "settings.tab.blocked": "🚫 Blocked",
  "settings.tab.notifications": "🔔 Notifications",
  "settings.tab.session": "⏱ Session",
  "settings.tab.account": "🆔 Account",
  "settings.tab.language": "🌐 Language",
  "settings.tab.theme": "🎨 Theme",
  "settings.tab.about": "ℹ About",
  "settings.theme.title": "Visual theme",
  "settings.theme.hint": "Choose how IKOGNIT looks on this device. Stored locally.",
  "settings.theme.auto": "Automatic",
  "settings.theme.autoHint": "Follow system (light by day, dark by night).",
  "settings.theme.midnight": "Midnight",
  "settings.theme.midnightHint": "Deep black with IKOGNIT red. The default.",
  "settings.theme.dark": "Dark",
  "settings.theme.darkHint": "Neutral grey, lower contrast than midnight.",
  "settings.theme.light": "Light",
  "settings.theme.lightHint": "Bright background for high-light environments.",
  "settings.theme.accent": "Accent color",
  "settings.theme.accentHint": "Applies to buttons, links and your own bubbles.",
  "settings.theme.customAccent": "Custom",
  "settings.theme.fontScale": "Text size",
  "settings.theme.fontScaleHint": "Scales the entire interface. Helps readability.",
  "settings.theme.scale.sm": "Small",
  "settings.theme.scale.md": "Normal",
  "settings.theme.scale.lg": "Large",
  "settings.theme.scale.xl": "Extra large",
  "settings.theme.motion": "Reduce motion",
  "settings.theme.motionHint": "Disables transitions and effects for accessibility.",
  "settings.theme.reset": "Reset to default theme",
  "settings.scope.global": "Global (IKOGNIT)",
  "settings.scope.freq": "Only in {0}",
  "settings.profile.title": "Profile",
  "settings.profile.hintGlobal": "These values are used by default and inherited in all IKO.",
  "settings.profile.hintFreq": "These override the global profile when you are in {0}. If you don't define something here, it inherits from global.",
  "settings.profile.displayName": "Display name",
  "settings.profile.displayNamePh.global": "(no name — your nick will be shown)",
  "settings.profile.displayNamePh.freq": "(inherits from global)",
  "settings.profile.photo": "Profile picture",
  "settings.profile.changePhoto": "Change picture",
  "settings.profile.removePhoto": "Remove picture",
  "settings.profile.adjustPhoto": "Adjust your picture",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Hi, I use IKOGNIT",
  "settings.profile.removeOverride": "Remove override for {0}",
  "settings.profile.warn": "Changes will be sent to the rest of your contacts automatically when you interact with them in this IKO.",
  "settings.privacy.title": "Privacy",
  "settings.privacy.hintGlobal": "Configure who can see each of your details by default.",
  "settings.privacy.hintFreq": "Override these rules only when you are in {0}.",
  "settings.privacy.showPhoto": "Who sees my picture",
  "settings.privacy.showInfo": "Who sees my info / status",
  "settings.privacy.showLastSeen": "Who sees my last connection",
  "settings.privacy.showOnline": "Who sees if I'm online",
  "settings.privacy.whoAdds": "Who can add me to groups",
  "settings.privacy.readReceipts": "Read receipts",
  "settings.privacy.readReceiptsHint": "If disabled, no blue ticks are sent when you read messages. You won't see others' either.",
  "settings.vis.all": "Everyone",
  "settings.vis.contacts": "My contacts",
  "settings.vis.none": "Nobody",
  "settings.messages.title": "Messages",
  "settings.messages.ttl": "Default expiration",
  "settings.messages.ttlHint": "Messages you send will be deleted from the server after this time. You can choose a different value when attaching a file.",
  "settings.blocked.title": "Blocked",
  "settings.blocked.hint": "Blocked users cannot send you messages. You can't send them messages either.",
  "settings.blocked.placeholder": "Nick to block",
  "settings.blocked.btn": "Block",
  "settings.blocked.unblock": "Unblock",
  "settings.blocked.empty": "You have nobody blocked.",
  "settings.notif.title": "Notifications",
  "settings.notif.sound": "Sound",
  "settings.notif.preview": "Show message preview",
  "settings.notif.vibration": "Vibration (mobile)",
  "settings.notif.hint": "Browser push notifications are only emitted for messages in IKOGNIT general, without content or sender name (by design).",
  "settings.session.title": "Session",
  "settings.session.timeout": "Close the IKO after inactivity",
  "settings.session.timeoutHint": "If you spend this time without touching the app, the active IKO is automatically deactivated and you return to IKOGNIT. \"Never\" keeps the IKO until you close the app.",
  "settings.session.remember": "Remember activated IKO",
  "settings.session.rememberHint": "If enabled, the IKO you activate appear as shortcuts in the sidebar. Anyone who sees your screen could know which IKO you have entered, so it is disabled by default. Turning it off erases those already saved.",
  "settings.account.title": "Account",
  "settings.account.nick": "Your nick (visible to others)",
  "settings.account.email": "Email",
  "settings.account.email.askHint": "We'll send codes to your current email and to the new one. You need both to confirm.",
  "settings.account.email.sendCodes": "Send codes",
  "settings.account.email.codesHint": "Codes sent to {0} (current) and {1} (new). They expire in 10 min.",
  "settings.account.email.codeOld": "Code from current email",
  "settings.account.email.codeNew": "Code from new email",
  "settings.account.emailChanged": "Email updated.",
  "settings.account.nickChanged": "Nick updated.",
  "settings.account.viewRecovery": "View my recovery phrase (24 words)",
  "settings.account.recoveryNoKey": "This session was opened with the device PIN and doesn't carry the key needed to decrypt the phrase. Sign out and sign in with password to view it.",
  "settings.account.recoveryNoStorage": "This account has no recovery phrase saved locally on this device.",
  "settings.account.recoveryDecryptFailed": "Could not decrypt the phrase. The current session doesn't match the one that saved it. Use \"Regenerate my phrase\" to get a new one.",
  "settings.account.regenerate": "Regenerate my phrase",
  "settings.account.regenerateConfirm": "A NEW 24-word phrase will be generated and the previous one will no longer work for recovery. Save the new one in a safe place. Continue?",
  "settings.account.emailPh": "email@example.com",
  "settings.account.changePassword": "Change password",
  "settings.account.currentPw": "Current password",
  "settings.account.newPw": "New password (min. 8)",
  "settings.account.confirmPw": "Repeat the new one",
  "settings.account.saving": "Saving…",
  "settings.account.success": "Password updated.",
  "settings.account.errPwBad": "The current password is incorrect.",
  "settings.account.errPwShort": "The new password must have at least 8 characters.",
  "settings.account.errPwMismatch": "Passwords don't match.",
  "settings.account.delete.zone": "Danger zone",
  "settings.account.delete.zoneHint": "Deleting your account permanently erases your identity, your access and your personal data from our servers. This cannot be undone.",
  "settings.account.delete.button": "Delete account",
  "settings.account.delete.title": "Delete account",
  "settings.account.delete.warn1": "You are about to PERMANENTLY and irreversibly delete your IKOGNIT account.",
  "settings.account.delete.warn2": "Your identity (nick and IKOGNIT ID), your access, your contacts, your devices and your personal data will be erased from our servers. No one — not even IKOGNIT — will be able to restore them.",
  "settings.account.delete.warn3": "If you belong to any IKO, you will no longer appear in it; its encrypted content is destroyed when its owner dissolves it or when its retention expires.",
  "settings.account.delete.continue": "Continue",
  "settings.account.delete.confirmIntro": "To confirm, enter your password. We will send a verification code to your email.",
  "settings.account.delete.pwLabel": "Password",
  "settings.account.delete.sendCode": "Send code",
  "settings.account.delete.sending": "Sending…",
  "settings.account.delete.codeSent": "Code sent to your email.",
  "settings.account.delete.codeHint": "Enter the 6-digit code we sent to {0}.",
  "settings.account.delete.codeLabel": "Verification code",
  "settings.account.delete.ack": "I understand this action is permanent and irreversible and that I will lose access to my account and my data.",
  "settings.account.delete.deleting": "Deleting…",
  "settings.account.delete.finalButton": "Delete my account forever",
  "settings.account.delete.errNoPw": "Enter your password.",
  "settings.account.delete.errPwBad": "Incorrect password.",
  "settings.account.delete.errCode": "The code is invalid or has expired.",
  "settings.language.title": "Language",
  "settings.language.hint": "Choose the interface language. Your preference is stored on this device.",
  "settings.about.title": "About IKOGNIT",
  "settings.about.version": "Version",
  "settings.about.tech": "E2E encryption with NaCl box (X25519). IKO: Argon2id derivation + deterministic HMAC. Local encrypted persistence with Argon2id over PIN.",
  "modal.freq.title": "Call up an IKO",
  "modal.freq.hint": "A IKO is the exact IKO of one of your IKO. IKO: you meet whoever writes the same IKO. Personal: you reach a IKO where you are invisible, even if another writes the same ones.",
  "modal.freq.placeholder": "Write your IKO",
  "modal.freq.activate": "Activate",
  "modal.freq.deriving": "Calling it up…",
  "modal.freq.warn": "IKO are not stored anywhere. If you forget them, that IKO ceases to exist for you.",
  "modal.freq.step2For": "For",
  "modal.freq.changeType": "Change type",
  "modal.freq.errShort": "The IKO must have at least 8 characters.",
  "modal.freq.errCommon": "That IKO is too common. Choose something unique.",
  "modal.freq.errRepeat": "Don't use a single repeated character.",
  "modal.freq.errSeqNum": "Avoid obvious numeric sequences.",
  "modal.freq.errSeqAlpha": "Avoid alphabet sequences.",
  "billing.title": "Billing",
  "billing.manage": "Manage",
  "billing.seats": "Seats",
  "billing.renews": "Renews",
  "billing.needsUpgrade": "You've hit your tier's seat limit. Upgrade to add more seats.",
  "billing.upgradeTo": "Upgrade tier ({price}/seat)",
  "billing.portal": "Manage payment",
  "twofa.title": "Two-factor authentication (2FA)",
  "twofa.intro": "Add a second security layer with a TOTP app (Google Authenticator, 1Password, Authy). Some PSH IKO require it for Owner/Admin.",
  "twofa.startSetup": "Start setup",
  "twofa.scan": "Scan this code with your TOTP app:",
  "twofa.orType": "Or enter this secret manually",
  "twofa.enterCode": "Enter the 6-digit code from your app to confirm:",
  "twofa.codePh": "123456",
  "twofa.activate": "Activate 2FA",
  "twofa.alreadyEnabled": "2FA is active on your account. To disable, enter a current code from your app:",
  "twofa.disable": "Disable 2FA",
  "twofa.errCode": "Code must be 6 digits.",
  "twofa.errBadCode": "Invalid or expired code. Try again.",
  "join.loginToAccept": "Sign in / Create account",
  "private.badge": "PERSONAL",
  "private.universeLabel": "Personal IKO",
  "private.welcome.title": "Your Personal IKO",
  "private.welcome.intro": "You are in a space nobody else can see. Even if someone wrote a similar IKO, they would land somewhere else entirely. Here you keep what is yours.",
  "private.welcome.hint": "Choose a section to start.",
  "private.mod.notes": "Notes",
  "private.mod.notes.desc": "Notes, letters, diary.",
  "private.mod.files": "Files",
  "private.mod.files.desc": "Documents, sheets, PDFs.",
  "private.mod.photos": "Photos",
  "private.mod.photos.desc": "Your private gallery.",
  "private.mod.videos": "Videos",
  "private.mod.videos.desc": "Your personal videos.",
  "private.mod.audios": "Audios",
  "private.mod.audios.desc": "Recordings and voice notes.",
  "private.mod.vault": "Passwords",
  "private.mod.vault.desc": "Passwords, cards, identities, SSH keys and whatever you need.",
  "private.mod.explorer": "Explorer",
  "private.mod.explorer.desc": "Unified view: photos, notes, passwords… organised in folders.",
  "explorer.empty": "Your IKO is empty.",
  "explorer.emptyHint": "Tap + to add your first object or create a folder.",
  "explorer.search": "Search your IKO…",
  "explorer.clearFilters": "Clear filters",
  "explorer.noMatches": "No object matches the filters.",
  "explorer.dropHere": "Drop to upload here",
  "explorer.selectMany": "Select multiple",
  "trash.title": "Trash",
  "trash.type": "DELETED ITEMS",
  "trash.restore": "Restore",
  "trash.restored": "Item restored.",
  "trash.purge": "Delete permanently",
  "trash.purged": "Deleted permanently.",
  "trash.purgeConfirmTitle": "Delete permanently?",
  "trash.purgeConfirmBody": "Item \"{name}\" will be permanently deleted. This action cannot be undone.",
  "trash.empty": "Empty trash",
  "trash.emptied": "Trash emptied ({n} items).",
  "trash.emptyConfirmTitle": "Empty trash?",
  "trash.emptyConfirmBody": "All items in trash will be permanently deleted. This action cannot be undone.",
  "trash.empty.message": "Trash is empty.",
  "explorer.filter": "Filter",
  "explorer.apply": "Apply",
  "explorer.removeFilter": "Remove filter",
  "explorer.add": "Add",
  "explorer.add.photo": "Photo",
  "explorer.add.cameraPhoto": "Camera",
  "explorer.add.recordAudio": "Record audio",
  "explorer.add.video": "Video",
  "explorer.add.audio": "Audio",
  "explorer.add.file": "Document",
  "explorer.add.note": "Note",
  "explorer.add.password": "Password",
  "explorer.add.card": "Card",
  "explorer.add.identity": "Identity",
  "explorer.add.sshkey": "SSH key",
  "explorer.add.customVault": "Loose passwords",
  "explorer.add.savedIko": "Saved IKO",
  "explorer.add.ikoDirectory": "IKO Directory",
  "explorer.type.iko-directory": "IKO Directory",
  "explorer.add.diskDirectory": "Drives & Disks inventory",
  "explorer.type.disk-directory": "Drives & Disks inventory",
  "diskdir.untitled": "Untitled inventory",
  "diskdir.namePlaceholder": "Inventory name (My disks, Work…)",
  "diskdir.empty": "You haven't added any Drive or Disk yet. Tap Add.",
  "diskdir.addEntry": "Add Drive or Disk",
  "diskdir.saved": "Inventory updated.",
  "diskdir.savedNew": "Inventory created.",
  "diskdir.deleted": "Inventory deleted.",
  "diskdir.deleteTitle": "Delete inventory?",
  "diskdir.deleteBody": "The inventory and its {n} entries will be deleted.",
  "diskdir.entriesCount": "entries",
  "diskdir.field.name": "Name (MyDisk123, MyPod…)",
  "diskdir.field.iko": "Which IKO is it in?",
  "diskdir.field.location": "Location (path or where it is)",
  "diskdir.field.note": "Note (optional)",
  "diskdir.type.pod": "Drive (server)",
  "diskdir.type.drive": "Disk / IkoDrive (physical)",
  "diskdir.podLocationNote": "A Drive lives on the server: no location needed.",
  "diskdir.errName": "Give it a name.",
  "diskdir.errIko": "Say which IKO it's in.",
  "explorer.type.vault-collection": "Mixed folder",
  "explorer.type.photo-album": "Photo album",
  "explorer.type.video-collection": "Video collection",
  "explorer.type.audio-playlist": "Playlist",
  "explorer.type.notebook": "Notebook",
  "explorer.type.doc-folder": "Documents folder",
  "explorer.section.add": "Add loose",
  "explorer.section.collections": "Collections",
  "collection.photoAlbum": "New photo album",
  "collection.videoCollection": "New video collection",
  "collection.audioPlaylist": "New playlist",
  "collection.notebook": "New notebook",
  "collection.docFolder": "Documents folder",
  "collection.vaultCollection": "New folder",
  "collection.created": "Collection created.",
  "collection.incompatibleTarget": "This destination doesn't accept the selected items.",
  "collection.dropRejected": "Some files aren't accepted in this collection.",
  "vault.coll.untitled": "Untitled folder",
  "vault.coll.namePlaceholder": "Folder name (Work, Personal…)",
  "vault.coll.empty": "This folder has no credentials yet. Tap Add.",
  "vault.coll.addEntry": "Add credential",
  "vault.coll.saved": "Folder updated.",
  "vault.coll.savedNew": "Folder created.",
  "vault.coll.deleted": "Folder deleted.",
  "vault.coll.deleteTitle": "Delete folder?",
  "vault.coll.deleteBody": "Folder and its {n} credentials inside will be deleted.",
  "vault.coll.entriesCount": "creds",
  "iko.dir.untitled": "Untitled directory",
  "iko.dir.namePlaceholder": "Directory name (Family, Friends…)",
  "iko.dir.empty": "This directory has no IKOes yet. Tap Add.",
  "iko.dir.addEntry": "Add IKO to directory",
  "iko.dir.entriesCount": "IKO",
  "iko.dir.saved": "Directory updated.",
  "iko.dir.savedNew": "Directory created.",
  "iko.dir.deleted": "Directory deleted.",
  "iko.dir.deleteTitle": "Delete directory?",
  "iko.dir.deleteBody": "Directory and its {n} saved IKOes inside will be deleted.",
  "iko.dir.migrationDefaultName": "My saved IKOes",
  "explorer.soon": "(soon)",
  "explorer.typeComingSoon": "Type \"{type}\" coming soon. Only media for now.",
  "explorer.type.photo": "Photo",
  "explorer.type.video": "Video",
  "explorer.type.audio": "Audio",
  "explorer.type.file": "Document",
  "explorer.type.note": "Note",
  "explorer.type.password": "Password",
  "explorer.type.card": "Card",
  "explorer.type.identity": "Identity",
  "explorer.type.sshkey": "SSH key",
  "explorer.type.custom-vault": "Folder",
  "explorer.type.vault-route": "Password route",
  "explorer.type.saved-iko": "Saved IKO",
  "explorer.type.folder": "Folder",
  "explorer.type.unknown": "Unknown",
  "private.mod.iko": "My IKO",
  "private.mod.iko.desc": "Your saved IKO, ready to activate.",
  "savediko.intro": "Keep here the IKOs you would rather not memorise. You remember one and the rest live inside it.",
  "savediko.empty": "You haven't saved any IKO yet.",
  "savediko.add": "Save a IKO",
  "savediko.activate": "Activate IKO",
  "savediko.formNew": "Save a IKO",
  "savediko.formEdit": "Edit saved IKO",
  "savediko.descLabel": "Description",
  "savediko.descPh": "A description to recognise it later",
  "savediko.ikoLabel": "The IKO",
  "savediko.ikoPh": "Write the IKO",
  "savediko.errDesc": "Enter a description.",
  "savediko.errIko": "Write the IKO.",
  "savediko.confirmDel": "Delete?",
  "savediko.modeLabel": "IKO mode",
  "savediko.mode.shared": "Shared",
  "savediko.mode.private": "Private",
  "savediko.saved": "Saved IKO updated.",
  "savediko.savedNew": "IKO saved.",
  "vault.new": "New item",
  "vault.edit": "Edit",
  "vault.delete": "Delete",
  "vault.save": "Save",
  "vault.show": "Show",
  "vault.hide": "Hide",
  "vault.copy": "Copy",
  "vault.copied": "Copied ✓",
  "vault.search": "Search…",
  "vault.empty": "Your folder is empty. Create your first item.",
  "vault.noMatches": "No item matches the search.",
  "vault.untitled": "Untitled",
  "vault.startHint": "Select an item from the left or create a new one.",
  "vault.confirmDelete": "Delete this item? It cannot be recovered.",
  "vault.saved": "Changes saved.",
  "vault.savedNew": "Item created.",
  "vault.deleted": "Deleted.",
  "vault.notes": "Notes",
  "vault.sensitive": "Sensitive",
  "vault.sensitiveHint": "Sensitive fields are hidden by default and can be copied to the clipboard.",
  "vault.removeField": "Remove this field",
  "vault.addField": "Add field",
  "vault.fieldSingular": "field",
  "vault.fieldPlural": "fields",
  "vault.type.login": "Login",
  "vault.type.card": "Card",
  "vault.type.identity": "Identity",
  "vault.type.sshkey": "SSH key",
  "vault.type.route": "Folder route",
  "vault.type.custom": "Custom",
  "vault.field.routePath": "Path",
  "vault.field.routeAlias": "Alias",
  "vault.field.routeIcon": "Icon",
  "vault.field.name": "Name",
  "vault.field.name.ph": "How do you call it?",
  "vault.field.labelPh": "Field label",
  "vault.field.newField": "Field",
  "vault.field.username": "Username",
  "vault.field.password": "Password",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Cardholder",
  "vault.field.cardBrand": "Brand",
  "vault.field.cardNumber": "Number",
  "vault.field.cardExpiry": "Expiry (MM/YY)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "First name",
  "vault.field.lastname": "Last name",
  "vault.field.dni": "ID / SSN",
  "vault.field.address": "Address",
  "vault.field.city": "City",
  "vault.field.zip": "ZIP code",
  "vault.field.country": "Country",
  "vault.field.phone": "Phone",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Date of birth",
  "vault.field.sshPrivate": "Private key",
  "vault.field.sshPublic": "Public key",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Text",
  "vault.ft.password": "Password",
  "vault.ft.textarea": "Long text",
  "vault.ft.date": "Date",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Number",
  "vault.tpl.title": "Templates",
  "vault.tpl.manage": "Manage templates",
  "vault.tpl.yours": "Your templates",
  "vault.tpl.new": "New template",
  "vault.tpl.edit": "Edit template",
  "vault.tpl.empty": "You don't have templates yet. Create one to define your own item type.",
  "vault.tpl.name": "Template name",
  "vault.tpl.name.ph": "E.g.: Crypto wallet, Hotel booking…",
  "vault.tpl.confirmDelete": "Delete this template? Items created from it remain.",
  "totp.copyCode": "Copy code",
  "totp.copySecret": "Copy secret",
  "totp.showSecret": "Show secret",
  "totp.hideSecret": "Hide secret",
  "totp.invalid": "invalid secret",
  "private.module.coming": "Coming soon.",
  "private.module.comingHint": "This module will be available very soon. The Private IKO crypto already works — soon you will be able to save here whatever you need.",
  "notes.new": "New note",
  "notes.empty": "You don't have notes in this IKO yet.",
  "notes.emptyPreview": "(empty)",
  "notes.untitled": "Untitled",
  "notes.delete": "Delete note",
  "notes.confirmDelete": "Delete this note? It cannot be recovered.",
  "notes.titlePlaceholder": "Title",
  "notes.contentPlaceholder": "Write whatever you need to remember…",
  "notes.edit": "Edit note",
  "notes.save": "Save",
  "notes.saved": "Note saved.",
  "notes.savedNew": "Note created.",
  "notes.deleted": "Note deleted.",
  "notes.title": "Title",
  "notes.content": "Content",
  "notes.startHint": "No notes in this IKO. Create the first one.",
  "notes.autosaveHint": "Saved automatically, encrypted, only here.",
  "notes.yesterday": "Yesterday",
  "passwords.new": "New entry",
  "passwords.empty": "You haven't saved any entry in this IKO yet.",
  "passwords.untitled": "Untitled",
  "passwords.startHint": "No passwords in this IKO. Create the first one.",
  "passwords.confirmDelete": "Delete this entry? It cannot be recovered.",
  "passwords.save": "Save",
  "passwords.edit": "Edit",
  "passwords.delete": "Delete",
  "passwords.copy": "Copy",
  "passwords.copied": "Copied ✓",
  "passwords.show": "Show",
  "passwords.hide": "Hide",
  "passwords.field.label": "Name",
  "passwords.field.label.ph": "Bank, account, service…",
  "passwords.field.username": "Username",
  "passwords.field.username.ph": "Email, alias, number…",
  "passwords.field.password": "Password",
  "passwords.field.password.ph": "The password you want to save",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notes",
  "passwords.field.notes.ph": "Any useful detail",
  "media.uploading": "Uploading…",
  "media.uploadFailed": "Could not upload the file.",
  "media.upload.file": "Upload file",
  "media.upload.photo": "Upload photo",
  "media.upload.video": "Upload video",
  "media.upload.audio": "Upload audio",
  "media.empty.file": "No files in this IKO yet.",
  "media.empty.photo": "No photos in this IKO yet.",
  "media.empty.video": "No videos in this IKO yet.",
  "media.empty.audio": "No audios in this IKO yet.",
  "media.play": "Play",
  "media.download": "Download",
  "media.delete": "Delete",
  "media.confirmDelete": "Delete this item? It cannot be recovered.",
  "media.loadFailed": "Could not load the file. Content unavailable.",
  "media.retry": "Retry",
  "media.tooBig": "{n} file(s) exceed the {max} MB limit and were not uploaded.",
  "media.tooBigAfterCompress": "Video still too large after compression (>{max} MB).",
  "media.compressing": "Compressing…",
  "media.cameraOnlyNative": "Camera is only available in the mobile app.",
  "media.cameraFailed": "Could not take photo.",
  "media.pickFailed": "Could not open file picker.",
  "media.textTruncated": "Large file: showing the first 2 MB.",
  "media.recordOnlyNative": "Recorder is only available in the mobile app.",
  "media.recordPermDenied": "Microphone permission denied.",
  "media.recordNotSupported": "This device cannot record audio.",
  "media.recordFailed": "Audio recording error.",
  "media.recordTitle": "Record audio",
  "media.recordStart": "Start recording",
  "media.recordStopSave": "Stop & save",
  "media.recordDiscard": "Discard",
  "media.noPreview": "No preview for this file type.",
  "media.select": "Select",
  "media.selected": "selected",
  "media.paste": "Paste from clipboard",
  "media.pasteHint": "Tip: copy a screenshot and press Ctrl+V (or the Paste button).",
  "media.clipboardUnsupported": "Clipboard not supported in this browser.",
  "media.clipboardNoImage": "No image found in clipboard.",
  "media.clipboardDenied": "Couldn't read clipboard.",
  "media.uploadedOne": "Uploaded to your IKO.",
  "media.uploadedMany": "{n} items uploaded to your IKO.",
  "media.deletedMany": "{n} items deleted.",
  "media.deleteFailed": "Couldn't delete.",
  "media.savedPhoto": "Image saved to Photos.",
  "media.savedVideo": "Video saved to Photos.",
  "media.saveUpdateApp": "Update TestFlight to 1.0(10)+ to Save.",
  "media.saveFailed": "Couldn't save: {reason}",
  "media.bulkDeleteTitle": "Delete selected items?",
  "media.bulkDeleteBody": "You'll delete {n} items. Cannot be undone.",
  "media.newFolder": "New folder",
  "media.folderNamePlaceholder": "Folder name",
  "media.folderExists": "A folder with that name already exists.",
  "media.folderCreated": "Folder created.",
  "media.folderCreateFailed": "Couldn't create folder.",
  "media.folderRename": "Rename folder",
  "media.folderRenamed": "Folder renamed.",
  "media.folderDelete": "Delete folder",
  "media.folderDeleted": "Folder deleted.",
  "media.folderDeleteTitle": "Delete folder?",
  "media.folderDeleteBody": "Folder \"{folder}\" will be deleted. Its {n} items will return to root.",
  "media.folderDeleteBodyV2": "Folder \"{folder}\" and all its contents (subfolders and files) will be deleted. This action cannot be undone.",
  "media.newFolderInRoot": "It will be created at the IKO root.",
  "media.newFolderIn": "It will be created inside \"{folder}\".",
  "media.moveTo": "Move to…",
  "media.root": "Root",
  "media.movedToFolder": "{n} items moved to \"{folder}\".",
  "media.movedToRoot": "{n} items moved to root.",
  "common.create": "Create",
  "modal.share.title": "Share contact",
  "modal.share.hint": "Choose a contact from the list or enter a nick manually.",
  "modal.share.filter": "Filter contacts…",
  "modal.share.empty": "No contacts in this IKO",
  "modal.share.manual": "Or a manual nick",
  "modal.share.btn": "Share",
  "modal.group.title": "New group",
  "modal.group.hint": "Choose a name and select members from your contacts in this IKO.",
  "modal.group.namePh": "Group name",
  "modal.group.selected": "{0} selected",
  "modal.group.create": "Create group",
  "modal.remember.title": "Remember this device",
  "modal.remember.hint": "Your session, contacts, groups and messages will be saved on this device, encrypted with a PIN only you know. When you reopen the app you will enter the PIN to invoke.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repeat PIN",
  "modal.remember.warn": "If you forget the PIN, the saved data cannot be recovered. You will have to sign in again with your username and password.",
  "modal.remember.errShort": "The PIN must have at least 4 characters.",
  "modal.remember.errMismatch": "PINs don't match.",
  "stickers.faces": "Faces",
  "stickers.gestures": "Gestures",
  "stickers.hearts": "Hearts",
  "stickers.symbols": "Symbols",
  "stickers.animals": "Animals",
  "stickers.food": "Food",
  "ttl.1h": "1 hour",
  "ttl.1d": "1 day",
  "ttl.1w": "1 week",
  "ttl.1m": "1 month",
  "ttl.6m": "6 months",
  "ttl.12m": "12 months",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Never",
  "toast.newMessage": "New message",
  "toast.group": "{0} (group)",

  // Web 2035 — ContextPanel
  "ctx.aria": "IKO information and navigation",
  "ctx.section.universe": "CURRENT IKO",
  "ctx.universe.personal": "Your personal space",
  "ctx.status.serverBlind": "Blind server active",
  "ctx.status.e2e": "End-to-end encryption",
  "ctx.section.nav": "NAVIGATION",
  "ctx.nav.changeIko": "Switch IKO",
  "ctx.nav.activateIko": "Activate a IKO",
  "ctx.nav.backToIkognit": "Back to IKOGNIT",
  "ctx.section.actions": "ACTIONS",
  "ctx.action.newChat": "New chat",
  "ctx.action.newGroup": "New group",
  "ctx.action.contacts": "My contacts",
  "ctx.action.storage": "Drives",
  "ctx.section.conversation": "CONVERSATION",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} messages",
  "ctx.peer.message": "{0} message",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Personal IKO",
  "ctx.modes.storage": "Drive",
  "ctx.liturgy.0": "The server is blind.",
  "ctx.liturgy.1": "Only you read here.",
  "ctx.liturgy.2": "Nobody knows you are here.",
  "ctx.liturgy.3": "A IKO is a secret only you know.",
  "ctx.liturgy.4": "Your privacy is the architecture.",

  // Web 2035 — ControlCenterBar
  "ccb.universe.changeOrExit": "Switch IKO or exit",
  "ccb.universe.activate": "Activate IKO",
  "ccb.leave.title": "Exit IKO (back to IKOGNIT)",
  "ccb.leave.aria": "Exit IKO",
  "ccb.tag.cipher.title": "Symmetric cipher active",
  "ccb.tag.srv.title": "The server cannot read your content",
  "ccb.tag.unread.title": "Unread messages",
  "ccb.settings.title": "Settings · profile, themes, session",
  "ccb.settings.aria": "Settings",
  "ccb.identity.title": "Session: @{0}",
  "ccb.clock.title": "Local time",
  "ccb.modes.personalPrefix": "PERSONAL · ",

  // Web 2035 — HolographicEmpty
  "holo.modes.shared": "IKO",
  "holo.modes.private": "PERSONAL IKO",
  "holo.modes.general": "YOUR NICK + CONTACTS",
  "holo.claim.inIko": "This IKO remains invisible to anyone who does not know it.",
  "holo.claim.general": "Your personal space in IKOGNIT. Here you talk with your contacts.",
  "holo.card.conversations": "Conversations",
  "holo.card.contacts": "Contacts",
  "holo.card.cipher": "Cipher",
  "holo.card.server": "Server",
  "holo.foot": "Pick a conversation, activate a IKO, or create a new space.",

  // Web 2035 — IdentityBar
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Personal IKO",
  "uib.context.coordTitle": "The IKO",
  "uib.context.general": "General IKO",
  "uib.e2e.title": "The server cannot read your content — E2E encryption with your key",
  "uib.e2e.label": "Blind server",
  "uib.pseudoTitle": "Your pseudonym in this IKO",
  "uib.nickTitle": "Your nick",
  "uib.exitTitle": "Return to the General IKO",
  "uib.exitLabel": "Exit",

  // Web 2035 — Chat.shared remaining
  "chat.nav.aria": "Main navigation",
  "chat.tab.chats": "Chats",
  "chat.tab.calls": "Calls",
  "chat.tab.contacts": "Contacts",
  "chat.backToIkognit.title": "Return to general IKOGNIT",
  "chat.delete.title": "Delete",
  "chat.delete.aria": "Delete",
  "chat.call.title": "Call",
  "chat.videoCall.title": "Video call",
  "chat.videoCall.aria": "Video call with {0}",
  "chat.search.clear": "Clear search",
  "chat.filters.aria": "Chat filters",
  "chat.filter.all": "All",
  "chat.filter.unread": "Unread",
  "chat.filter.groups": "Groups",
  "chat.attachPending": "Pending attachment",
  "chat.remove.title": "Remove",
  "chat.cancel.title": "Cancel",
  "chat.blocked.text": "You blocked {0}. You cannot send messages or call them.",
  "chat.unblock": "Unblock",
  "contacts.alias.placeholder": "An alias to recognise them",
  "contacts.notes.placeholder": "Only you can see it (encrypted on the server).",
  "contacts.search.placeholder": "Search by alias or IKOGNIT ID",
  "contacts.edit.title": "Edit alias and note",
  "contacts.edit.aria": "Edit",
  "contacts.blockBtn": "Block contact",
  "contacts.unblockBtn": "Unblock contact",
  "contacts.confirmBlock.title": "Block contact",
  "contacts.confirmUnblock.title": "Unblock contact",
  "contacts.confirmBlock.body": "Block {0}? You will stop receiving their messages and calls.",
  "contacts.confirmUnblock.body": "Unblock {0}? You will receive their messages again.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Personal IKO categories",
  "piko.rail.head": "PERSONAL",
  "piko.cat.all": "All",
  "piko.cat.photos": "Photos",
  "piko.cat.videos": "Videos",
  "piko.cat.audios": "Audios",
  "piko.cat.files": "Files",
  "piko.cat.notes": "Notes",
  "piko.cat.passwords": "Passwords",
  "piko.cat.cards": "Cards",
  "piko.cat.identities": "Identities",
  "piko.cat.sshkeys": "SSH keys",
  "piko.cat.custom": "Folder",
  "piko.cat.agendas": "IKO directories",
  "piko.cat.storage": "Drives & Disks",

  // Tick de mensajes
  "bubble.tick.read": "Read {0}",
  "bubble.tick.delivered": "Delivered {0}",
  "bubble.tick.sent": "Sent",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "You have blocked this user.",
  "chat.preview.image": "Image",
  "chat.preview.video": "Video",
  "chat.preview.voice": "Voice message",
  "chat.preview.audio": "Audio",
  "error.push.denied": "You denied the notifications permission.",
  "error.push.noSw": "This browser does not support service workers.",
  "error.push.noPush": "This browser does not support push notifications.",
  "error.push.noVapid": "The server did not provide the VAPID key.",
  "error.push.activateFailed": "Could not activate ({0}).",
  "chat.group.membersWord": "members",
  "chat.newCall.title": "New call",
  "chat.newChat.title": "New chat",
  "chat.newCall.empty": "No contacts yet. Add one from the + in Chats.",
  "chat.unread.aria": "unread messages",
  "chat.calls.title": "Calls",
  "chat.calls.empty": "No calls yet. Start one from a chat with a contact.",
  "chat.calls.callContact": "Call a contact",
  "chat.calls.historySoon": "Call history will be available soon.",
  "chat.deleteConv.titleOne": "Delete conversation",
  "chat.deleteConv.titleMany": "Delete {0} conversations",
  "chat.deleteConv.hint": "\"For me\" deletes your copy (all your devices). \"For everyone\" also asks the contact to delete it on their side.",
  "chat.deleteConv.forMe": "Delete for me",
  "chat.deleteConv.forAll": "Delete for everyone",
  "chat.myContacts": "My contacts",
  "chat.contacts.noResults": "No results.",
  "chat.contacts.empty": "No contacts yet.",
  "chat.contact.badgeBlocked": "blocked",
  "chat.contact.badgePending": "unconfirmed",
  "chat.toast.saved": "Saved",
  "chat.toast.videoSaved": "Video saved to Photos",
  "chat.toast.imageSaved": "Image saved to Photos",
  "chat.toast.updateTestflight": "Update TestFlight to 1.0(10)+ to Save.",
  "chat.toast.saveFailed": "Could not save: {0}",
  "chat.toast.saveError": "Save error",
  "iko.banner.exitAria": "Leave the IKO and go back to the general plane",
  "iko.liturgy.entering": "Entering IKO",
  "iko.liturgy.returning": "Returning",
  "iko.liturgy.toIkognit": "to IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Personal IKO",
  "iko.mode.storage": "Storage IKO",
  "storage.universeLabel": "Drive",
  "storage.state.trial": "Trial · {0} days left",
  "storage.state.free": "1 GB free",
  "storage.state.active": "Active until {0}",
  "storage.state.grace": "Read-only · {0} days to renew",
  "storage.state.sealed": "Locked",
  "storage.free.title": "Your free 1 GB",
  "storage.free.remaining": "You have",
  "storage.free.add": "Add",
  "storage.free.adding": "Adding…",
  "storage.free.note": "From your free 1 GB account quota. You decide how much goes to each Drive.",
  "storage.free.noteV2": "Your account has 1 GB free. Split it across your Drives however you like —and take it back whenever you want.",
  "storage.free.all": "All ({0})",
  "storage.free.addLabel": "Add",
  "storage.free.releaseLabel": "Release",
  "storage.free.releasing": "Releasing…",
  "storage.free.releaseAll": "Release all ({0})",
  "storage.free.releaseBlocked": "You can't release that much: you'd go below what your files already use. Delete files first.",
  "storage.note.grace": "The period has ended. You can download your files or renew; after the grace period the Drive is locked.",
  "storage.note.sealed": "This Drive is locked. Renew to regain access to your files.",
  "storage.note.coords": "This Drive's IKO are the only key. If you lose them, no one — not even IKOGNIT — can recover its contents.",
  "storage.retention.title": "What happens to your data",
  "storage.retention.body": "While your Drive is active, your files are always available. If payment lapses, you enter a read-only grace period: you can still download and renew. If you don't renew, the Drive is locked and, after a margin, its data is permanently deleted — so you're not charged for space you no longer pay for. Renewing before deletion restores access. IKOGNIT never deletes for inactivity: only for non-payment.",
  "storage.connector.title": "Disk drive",
  "storage.connector.mount": "Mount as drive",
  "storage.connector.unmount": "Unmount",
  "storage.connector.hint": "Open this Drive as a drive on your computer. Files are decrypted on the fly and only live in memory: when you unmount or close IKOGNIT, they vanish from disk.",
  "storage.connector.mountedHint": "Mounted. Your files appear as a drive on your computer. It unmounts automatically when you leave the Drive or close IKOGNIT.",
  "storage.connector.webNotice": "To open this Drive as a disk drive on your computer you need IKOGNIT Desktop. For security reasons, a browser cannot mount drives (just like Dropbox: the web manages files, the desktop app mounts the drive). Install it and open this same Drive from the app.",
  "storage.connector.webCta": "Download IKOGNIT Desktop",
  "storage.files.title": "Files",
  "storage.files.upload": "Upload files",
  "storage.files.download": "Download",
  "storage.files.emptyTitle": "Your Drive is empty",
  "storage.files.emptyHint": "Upload your first file. It is encrypted on this device: the server only stores opaque bytes.",
  "storage.err.quota": "Drive full. Delete files, add more of your free 1 GB, or upgrade with a plan.",
  "storage.err.readOnly": "Plan expired: read-only. Renew to save again.",
  "storage.err.download": "The file could not be downloaded.",
  "storage.err.sealed": "Drive locked: renew to access.",
  "storage.buy.title": "Plan & renewal",
  "storage.buy.titleExtend": "Add capacity",
  "storage.buy.prorateNote": "Charged pro-rata until your renewal date of {0}. Your Drive keeps a single renewal date: next year everything renews together.",
  "storage.buy.perYear": " /yr",
  "storage.buy.qtyLabel": "Number of packs",
  "storage.confirm.titleBuy": "Your purchase summary",
  "storage.confirm.titleExtend": "Your upgrade summary",
  "storage.confirm.buying": "You buy",
  "storage.confirm.annualPrice": "Annual price",
  "storage.confirm.prorated": "{0} days left until your renewal",
  "storage.confirm.fullYear": "First full year",
  "storage.confirm.capacityAfter": "Drive capacity after purchase",
  "storage.confirm.nextRenewal": "Next renewal",
  "storage.confirm.payNow": "To pay now",
  "storage.confirm.beforeTax": "(net, before VAT)",
  "storage.confirm.vatNote": "VAT is calculated at checkout based on your country. Businesses with a valid EU VAT number: exempt (reverse charge).",
  "storage.confirm.tos": "I accept that this is an annual auto-renewing subscription and that, if I lose or forget my IKO, the contents of this Drive are out of reach for good: nobody can give them back.",
  "storage.confirm.tosLink": "Read the Purchase Conditions",
  "storage.confirm.pay": "Pay · {0}",
  "fm.root": "Home",
  "fm.newFolder": "New folder",
  "fm.upload": "Upload",
  "fm.folderName": "Folder name",
  "fm.uploading": "Uploading {0}…",
  "fm.emptyTitle": "Empty folder",
  "fm.emptyHint": "Upload files or create a folder to organize them.",
  "fm.rename": "Rename",
  "fm.move": "Move",
  "fm.moveTitle": "Move “{0}” to…",
  "fm.moveIntoSelf": "You can't move a folder into itself.",
  "fm.confirmDeleteFolder": "Delete folder “{0}” and all its contents? This can't be undone.",
  "storage.tab.files": "Files",
  "storage.tab.config": "Settings",
  "storage.buy.ok": "Done. Your Drive is active.",
  "storage.buy.insufficient": "Insufficient balance. Top up above and try again.",
  "storage.buy.buying": "Buying…",
  "storage.buy.buy": "Buy with balance",
  "storage.buy.extend": "Extend with balance",
  "storage.buy.blindNote": "The payment is not stored against this Drive: IKOGNIT records only that your account bought capacity (amount and plan), never which Drive it was applied to.",
  "storage.buy.webOnly": "Plans are purchased from app.ikognit.com in your browser.",
  "storage.buy.notConfigured": "Payments are not enabled on this server yet.",
  "storage.buy.buyFor": "Buy · {0}",
  "storage.buy.extendFor": "Extend · {0}",
  "storage.buy.credit": "Credit",
  "storage.buy.awaitTitle": "Complete the payment",
  "storage.buy.awaitBody": "Finish paying in the tab that opened. Your purchase will activate here automatically; don't close this page.",
  "storage.buy.activating": "Payment received. Activating your purchase…",
  "storage.buy.timeout": "We didn't receive the payment in time. If you completed it, the amount stays as credit on your account: press Buy again and it'll be used.",
  "storage.buy.popupBlocked": "Your browser blocked the payment window. Allow pop-ups for this site and try again.",
  "pay.return.okTitle": "Payment received ✓",
  "pay.return.okBody": "You can close this tab and go back to IKOGNIT: your purchase is activating on its own.",
  "pay.return.cancelTitle": "Payment cancelled",
  "pay.return.cancelBody": "Nothing was charged. You can close this tab and go back to IKOGNIT.",
  "pay.return.close": "Close",
  "storage.balance.label": "Balance",
  "storage.balance.topup": "Top up balance:",
  "capsule.drawer.title": "Drives",
  "capsule.generalIko": "My IKOGNIT (general)",
  "capsule.drawer.connected": "Drives connected here",
  "capsule.drawer.hint": "A Drive is an encrypted disk of yours that you plug into this IKO, like a USB stick. The same Drive can be connected to several IKO at once; whatever you save shows up in all of them.",
  "capsule.drawer.emptyTitle": "No Drives connected here",
  "capsule.drawer.emptyHint": "Connect a Drive by typing its IKO. If you don't have one yet, create it from Activate → Drive.",
  "capsule.open": "Open",
  "capsule.disconnect": "Disconnect",
  "capsule.create.btn": "Create Drive",
  "capsule.create.first": "Create my first Drive",
  "capsule.connect.btn": "Connect Drive",
  "capsule.connect.title": "Connect a Drive",
  "capsule.connect.body": "Type your Drive's IKO (the same key you created it with). It will stay plugged into this IKO until you disconnect it.",
  "capsule.connect.coords": "Drive IKO",
  "capsule.connect.coordsPh": "e.g. my-secret-disk",
  "capsule.connect.label": "Name (optional)",
  "capsule.connect.labelPh": "e.g. Tax documents",
  "capsule.connect.connecting": "Connecting…",
  "capsule.connect.notFound": "No Drive exists with those IKO. Create it first (Activate → Drive), then connect it.",
  "capsule.about.title": "How Drives work",
  "capsule.about.body": "A Drive's files are encrypted with your key (owner + IKO), so only you can decrypt them. You can SHARE a Drive with anyone from their chat (Share button): the invitation travels end-to-end encrypted via a blind credential, and IKOGNIT never knows that you share it, with whom, or which Drives you have. Revoke access whenever you want. That whole relationship lives encrypted in your private IKO.",
  "ikopod.hint.ambient": "The Drives connected to this IKO come online by themselves while you're here; when you leave, they vanish from your devices without a trace.",
  "ikodrive.section": "IkoDrive · physical USB",
  "ikodrive.hint": "Store files on a USB stick encrypted by IKOGNIT. They can only be read with YOUR user and INSIDE this IKO; anywhere else they're noise. You can mount several sticks at once.",
  "ikodrive.path.placeholder": "Path to the .ikognit disk (or press “Choose file…”)",
  "ikodrive.pick.btn": "Choose file…",
  "ikodrive.pick.new": "Create new disk…",
  "ikodrive.mount.title": "Mount a disk",
  "ikodrive.mount.btn": "Mount as drive",
  "ikodrive.mountedAt": "Mounted at {0}. Open it in your file explorer.",
  "ikodrive.prepare.hint": "Is this a NEW stick you haven't used with IKOGNIT yet? Prepare it once. It does NOT erase or format the USB: it just creates an encrypted file inside and leaves the rest of your files untouched.",
  "ikodrive.prepare.btn": "Prepare new stick",
  "ikodrive.prepare.overwrite": "⚠️ THERE'S ALREADY A IKODRIVE AT THAT PATH. If you continue, all its contents will be ERASED and cannot be recovered. Are you sure you want to erase it and create a new one?",
  "ikodrive.prepare.kept": "Cancelled. The existing IkoDrive was left untouched.",
  "ikodrive.prepared": "Stick prepared. Now press “Mount as drive”.",
  "ikodrive.state.offline": "Not connected (remembered): plug the stick in and press Mount.",
  "ikodrive.state.error": "Couldn't mount.",
  "ikodrive.action.remount": "Mount",
  "ikodrive.action.unmount": "Unmount",
  "ikodrive.action.forget": "Remove",
  "ikodrive.bound": "Bound to your user and this IKO. If you change your password, the stick still works; outside this IKO, it won't open. When you return to this IKO, your sticks are mounted again automatically.",
  "ikodrive.err.path": "Enter the USB drive.",
  "ikodrive.err.ikognitDrive": "That letter is a IKOGNIT drive (a Drive or an already-mounted IkoDrive), not your USB stick. Check your USB's letter in the file explorer (e.g. D:) and enter that.",
  "ikodrive.err.mount": "Couldn't mount the IkoDrive (wrong user/IKO, or the stick isn't prepared?).",
  "ikodrive.err.generic": "Couldn't prepare the stick.",
  "ikodrive.share.noContact": "To share a stick, open this manager from the person's chat (contact ⋯ menu → Share).",
  "ikodrive.share.confirm": "Give {0} access to this stick? They can open it once they have the USB. Note: access can't be revoked once they've opened it.",
  "ikodrive.share.already": "Shared ✓",
  "ikodrive.share.reject": "Reject",
  "ikodrive.card.sent": "You shared an encrypted stick",
  "ikodrive.card.recv": "An encrypted stick was shared with you",
  "ikodrive.card.hint": "Plug it in and open it in Drives → IkoDrive.",
  "ikodrive.share.sent": "✓ Stick access sent to {0}. Once they have the USB, they can open it.",
  "ikodrive.share.sentLocal": "You shared the stick “{0}”.",
  "ikodrive.share.err": "Couldn't share the stick (is it mounted?).",
  "ikodrive.shared.title": "Sticks shared with me",
  "ikodrive.shared.hint": "Someone granted you access to their stick. Plug it in (or find the .ikognit on your disk), press “Choose file…” to point to YOUR file, then “Mount as drive”. The owner's path won't work: the file is elsewhere on your machine.",
  "ikopod.state.mounting": "Connecting…",
  "ikopod.state.mounted": "Connected",
  "ikopod.state.mountedAt": "Connected · {0}",
  "ikopod.state.inFiles": "Available in Files",
  "ikopod.state.error": "Unavailable",
  "ikopod.action.openSystem": "Open in system",
  "ikopod.action.viewHere": "View files here",
  "ikopod.sheet.close": "Close",
  "manifest.blindServer": "The server is blind.",
  "manifest.onlyYouRead": "Only you read here.",
  "manifest.noPublicProfiles": "No public profiles.",
  "manifest.noAdsNoClouds": "No ads. No outside clouds.",
  "manifest.keyWithYou": "The key lives with you.",
  "manifest.yourIkoYourSpaces": "Your IKO. Your spaces.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Files",
  "orb.mod.notes": "Notes",
  "orb.mod.photos": "Photos",
  "orb.mod.vault": "Folder",
  "orb.mod.audios": "Audios",
  "orb.copy.line1": "Your IKO.",
  "orb.copy.line2": "Your spaces.",
  "explorer.filesNotProcessed": "Unprocessed file(s)",
  "demo.edit": "Edit",
  "common.exit": "Exit",
  "common.more": "More",
  "chat.tab.settings": "Settings",
  "chat.search.placeholder": "Search chat",
  "chat.presence.online": "online",
  "chat.action.call": "Call",
  "chat.action.videoCall": "Video call",
  "chat.attach.label": "Attach",
  "chat.attach.camera": "Camera",
  "chat.attach.voice": "Voice",
  "chat.attach.file": "Attach file",
  "chat.composer.placeholder": "Type a message...",
  "settings.addYourName": "Add your name",
  "settings.editProfile": "Edit profile",
  "chat.welcome.intro": "Select a chat to start talking with end-to-end encryption.",

  // Batch2: footer atajos web
  "web.footer.palette": "palette",
  "web.footer.send": "send",
  "web.footer.line": "line",
  "mobile.tb.ikoActivate": "Activate IKO",
  "mobile.tb.ikoExit": "Back to general IKOGNIT",

  "chat.header.blocked": "Blocked",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Private note",
  "settings.account.newNickPlaceholder": "new_nick",
  "settings.account.newEmailPlaceholder": "new@email.com",


  "common.delete": "Delete",







  "private.module.explorer": "My objects",
  "private.module.mail": "Mailbox",


  "oauth.itemsSynced": "{0} items imported",

};

const pt: Catalog = {
  "auth.verify.notSent": "Não conseguimos enviar-te o código. A tua conta está criada: carrega em «Reenviar código» daqui a pouco.",
  "lg.rotulo": "Mensagens com espaços privados",
  "lg.btn.entrar": "Entrar",
  "lg.eyebrow": "Mensagens privadas · Itrion Software",
  "lg.h1a": "As conversas de sempre.",
  "lg.h1b": "E um sítio que só existe quando o invocas.",
  "lg.lead1": "Falas com a tua família, com os teus amigos e com a tua equipa, como em qualquer app. A diferença começa quando abres um IKO: um espaço teu onde se entra escrevendo um segredo que só conhece quem está lá dentro.",
  "lg.lead2": "Enquanto não o invocas, esse espaço não está no teu dispositivo — nem no telemóvel, nem no tablet, nem no computador. Não é que esteja cifrado.",
  "lg.lead2b": "É que não está.",
  "lg.pruebalo": "Experimenta · escreve um segredo e vê o que acontece",
  "lg.panel.plano": "Plano geral",
  "lg.demo.hilos": "Família=Mãe: jantamos no domingo cá em casa?=19:04|Marta=mando-te as fotos de sábado=17:52|Equipa=Luís: amanhã às nove, então=Ontem|Javi=ahah não acredito=Ontem",
  "lg.demo.mundos": "Só nós os dois~guardaste onde combinámos?|sim. as escrituras e o passaporte>~Escrituras do apartamento.pdf=2,4 MB|Fotos privadas=214|Cartão · banco=Dados~~Coisas de casa~deixo-te aqui o contrato de arrendamento>|e a chave do router, que a perdes sempre~Contrato de arrendamento.pdf=1,1 MB|Cópia do cartão de cidadão=2 ficheiros|Chaves de casa=Dados~~Os meus apontamentos~isto não contei a ninguém>|e não é preciso contar>~Diário=48 notas|Fotos=1.207|Contas do ano=Dados~~Projeto Lisboa~a proposta fica em 180|aqui está, sem cópias lá fora>~Proposta_v4.pdf=860 KB|Contactos=12|Cartão da empresa=Dados~~O almoço de sábado~não digas nada à Marta ainda|descansa, aqui não sabe ninguém>~Reserva.pdf=120 KB|Fotos do ano passado=63|Lista de convidados=Dados",
  "lg.invocaLabel": "Invoca o teu IKO",
  "lg.invocaPlaceholder": "escreve um segredo qualquer",
  "lg.invocaBtn": "Invocar",
  "lg.invocaHint": "Cada palavra leva a um espaço diferente. Experimenta outra.",
  "lg.estela.vacio": "Escreve o que quiseres: isto é uma demonstração.",
  "lg.estela.primero": "Invocado. Só existe enquanto lá estiveres.",
  "lg.estela.otro": "Outro segredo, outro espaço. Nenhum sabe dos outros.",
  "lg.estela.salida": "Foi-se. Não ficou rasto no dispositivo. Experimenta outra palavra.",
  "lg.ikoActivo": "IKO ativo",
  "lg.nadaEnDispositivo": "Nada disto está no dispositivo",
  "lg.salirIko": "Sair do IKO",
  "lg.planos.h2a": "Um plano à vista.",
  "lg.planos.h2b": "Por baixo, os que tu invocares.",
  "lg.planos.lead": "Não existe «o IKO». Existem os que abrires: um para as coisas de casa, outro para o trabalho, outro que só duas pessoas conhecem, outro de que nunca falaste a ninguém. Cada segredo leva ao seu, e nenhum sabe dos outros.",
  "lg.planos.unoRotulo": "O plano geral · um",
  "lg.planos.unoH3": "Onde falas com toda a gente",
  "lg.planos.unoP": "Conversas, grupos, chamadas, fotos e ficheiros, cifrados de ponta a ponta. O que esperas de uma app de mensagens, bem feito. As tuas conversas de sempre vivem aqui e comportam-se como sempre.",
  "lg.planos.nRotulo": "Os IKO · os que quiseres",
  "lg.planos.nH3": "Onde não chega mais ninguém",
  "lg.planos.nP": "Escreves um segredo e aparece o espaço que lhe corresponde. Lá dentro cabem conversas e as tuas coisas. Quando sais, desaparece do dispositivo sem deixar rasto. Não há lista, não há número e ninguém pode descobrir quantos tens, nem que exista algum.",
  "lg.planos.chips": "As coisas de casa|O trabalho|O que só dois sabem|O teu e de mais ninguém|Aquele que abriste uma vez e nunca mais|Os que decidires amanhã",
  "lg.forense.h2a": "Não está cifrado no teu dispositivo.",
  "lg.forense.h2b": "Não está no teu dispositivo.",
  "lg.forense.lead": "As outras apps guardam as tuas mensagens no aparelho e cifram-nas. Se alguém o levar, a tua privacidade depende de essa cifra aguentar tempo suficiente. Aqui não há nada que tenha de aguentar: o que vive dentro de um IKO não se escreve em nenhum dispositivo. Invoca-se, usa-se e vai-se.",
  "lg.forense.multi": "Vale para todos por igual: telemóvel, tablet, computador de casa, portátil do trabalho, Windows, Mac ou o navegador de um sítio que não é teu. Entras onde quiseres e, ao sair, esse sítio volta a não saber nada de ti.",
  "lg.forense.caption": "O que encontra quem examinar qualquer um dos teus dispositivos",
  "lg.forense.filas": "Mensagens dos teus IKO=0|Ficheiros e fotos dos teus IKO=0|Segredos de IKO guardados=0|Base de dados com os teus IKO=não existe|Rasto de que um IKO esteve aberto=nenhum|Quantos IKO tens=indeterminável",
  "lg.escenas.h2": "O que a sério te preocupa.",
  "lg.escenas.filas": "«Perdi o telemóvel.»=A tua privacidade não se perdeu com ele. O que estava dentro de um IKO nunca esteve nesse aparelho, por isso não há nada a resgatar nem nada a temer. Invocas a partir de qualquer outro dispositivo e está tudo onde estava.~«Levaram-me o portátil.»=Vão ver as tuas conversas normais, as mesmas que veriam em qualquer app. Do resto não verão o conteúdo, nem o nome, nem o indício de que exista.~«Examinaram-me o computador.»=Uma análise forense recupera o que está escrito no disco, mesmo cifrado e apagado. Aqui não há nada escrito para recuperar. A resposta não é «não se consegue decifrar»: é que não há nada. E o mesmo no tablet, no telemóvel e no navegador que usaste uma tarde.",
  "lg.ciego.h2": "Nem nós. Nem quem aloja os servidores.",
  "lg.ciego.p1": "O servidor guarda coisas que não consegue ler. Não tem o teu segredo, nunca o teve e não existe nenhuma cópia em lado nenhum. Não é que nos recusemos a entregar o que está dentro dos teus IKO: é que não o temos, e não há maneira de o termos. Nem a empresa que aloja as máquinas, nem ninguém que lhes deitasse a mão.",
  "lg.ciego.p2": "Isso tem um preço e é justo dizê-lo: se perderes o teu segredo, não há quem to devolva. A mesma razão pela qual mais ninguém consegue entrar é a razão pela qual nós também não te podemos ajudar a entrar.",
  "lg.guardas": "Fotos de família|Os apontamentos que não mostras|Cartões e dados bancários|Palavras-passe|Documentos|Conversas que só vos dizem respeito",
  "lg.nombre.esta": "está",
  "lg.nombre.noEsta": "não está",
  "lg.nombre.h2": "Daí o nome.",
  "lg.nombre.p": "Em suaíli, iko significa «está» e haiko, «não está». Um IKO está enquanto o invocas. O resto do tempo — que é quase todo o tempo — não está: nem nos teus dispositivos, nem à vista de ninguém, nem como suspeita.",
  "lg.cierre.h2": "Começa a falar.",
  "lg.cierre.p": "Usa-se como qualquer app de mensagens, no telemóvel, no tablet e no computador. Os IKO estão lá no dia em que precisares deles.",
  "lg.cierre.btnCrear": "Criar conta",
  "lg.cierre.btnEntrar": "Já tenho conta",
  "lg.cierre.pago": "O IKOGNIT é um produto pago. Não há anúncios, não há perfis publicitários e não há uma cópia nossa de nada: vivemos de a app te valer a pena, não do que possas dizer lá dentro.",
  "lg.pie.ciego": "Servidor cego",
  "auth.hola": "Olá outra vez.",
  "auth.queEs": "O que é o IKOGNIT?",
  "common.cancel": "Cancelar",
  "common.error.generic": "Não foi possível. Tenta outra vez.",
  "common.save": "Guardar",
  "common.confirm": "Confirmar",
  "common.close": "Fechar",
  "common.add": "Adicionar",
  "common.back": "Voltar",
  "common.tagline": "Soberania digital.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "Em suaíli, iko é «está». E haiko, «não está».",
  "auth.legal.age": "Confirmo que tenho a idade mínima exigida pela lei do meu país para usar IKOGNIT.",
  "auth.legal.accept": "Li e aceito os <a href='https://ikognit.org/legal/pt/termos.html' target='_blank' rel='noopener'>Termos</a>, a <a href='https://ikognit.org/legal/pt/privacidade.html' target='_blank' rel='noopener'>Política de Privacidade</a> e as <a href='https://ikognit.org/legal/pt/normas-comunidade.html' target='_blank' rel='noopener'>Normas da Comunidade</a>.",
  "recovery.title": "A tua chave de recuperação",
  "recovery.intro": "Estas **24 palavras** são a única forma de recuperares a tua conta e o histórico se esqueceres a palavra-passe ou perderes o dispositivo. **Anota-as em papel e guarda-as num local seguro.** Ninguém na IKOGNIT as pode recuperar por ti.",
  "recovery.warn": "**Anota-as OFFLINE.** Não faças captura de ecrã. Não as envies por email ou mensagens. Quem tiver estas palavras controla a tua conta inteira.",
  "recovery.btn.show": "Mostrar palavras",
  "recovery.btn.copy": "Copiar",
  "recovery.btn.copied": "Copiado · apaga-se em {0}s",
  "recovery.btn.cleared": "Área de transferência limpa",
  "recovery.btn.copyAria": "Copiar a frase de recuperação para a área de transferência (apaga-se automaticamente)",
  "recovery.btn.download": "Transferir",
  "recovery.btn.downloadAria": "Transferir a frase como ficheiro de texto",
  "recovery.btn.back": "Voltar a ver as palavras",
  "recovery.btn.continue": "Continuar",
  "recovery.btn.done": "Terminei",
  "recovery.btn.need3": "Escreve as 3 palavras corretas",
  "recovery.verify.intro": "Para confirmar que guardaste a tua chave, escreve estas palavras. Não podes continuar sem acertar.",
  "recovery.verify.wordN": "Palavra #{0}",
  "recovery.verify.correct": "Correto",
  "recovery.verify.wrong": "Incorreto",
  "auth.error.legalRequired": "Tens de aceitar os termos legais e confirmar a tua idade para criar um IKOGNIT ID.",
  "settings.legal.title": "Informação legal",
  "settings.legal.hub": "Centro Legal",
  "settings.legal.terms": "Termos e Condições",
  "settings.legal.privacy": "Política de Privacidade",
  "settings.legal.rules": "Normas da Comunidade",
  "settings.legal.report": "Denúncias e Moderação",
  "settings.legal.cookies": "Política de Cookies",
  "settings.legal.minors": "Política de Menores",
  "settings.legal.notice": "Aviso Legal",
  "settings.tab.legal": "Legal",
  "auth.loading": "A carregar…",
  "auth.savedSession": "Este dispositivo já reconhece o seu dono.",
  "auth.locked": "Desvaneceu-se por inatividade. Entra outra vez.",
  "auth.sessionExpired": "A sessão desvaneceu-se. Entra outra vez.",
  "auth.tab.login": "Entrar",
  "auth.tab.register": "Novo IKOGNIT ID",
  "auth.subLogin": "Entras no plano geral: as tuas conversas de sempre. Os teus IKO não se invocam aqui — invocam-se lá dentro, quando precisares.",
  "auth.subRegister": "A conta fica em teu nome. O nick é como te veem; o email serve apenas para recuperar o acesso e para avisos.",
  "auth.field.devicePin": "Chave mestra",
  "auth.field.password": "Chave mestra",
  "auth.btn.unlock": "Entrar",
  "auth.btn.unlocking": "A entrar…",
  "auth.btn.processing": "A processar…",
  "auth.btn.createIdentity": "Criar IKOGNIT ID",
  "auth.btn.useOther": "Usar outro IKOGNIT ID",
  "auth.btn.forget": "Esquecer este dispositivo",
  "auth.btn.backToUnlock": "Voltar",
  "auth.confirmForget": "Este dispositivo deixará de te reconhecer: esfuma-se a conta guardada e o que estiver em cache. Para voltar a entrar precisarás da tua palavra-passe.",
  "auth.confirmForget.warning": "Sem a frase de recuperação de 24 palavras anotada, isto não tem volta: ninguém to pode devolver.",
  "invite.welcomeSub": "Mensagens e um espaço teu: o que guardas aqui fica em teu nome. Cria a tua conta e ficarão ligados.",
  "auth.reset.warnNewIdentity": "A tua conta continua a ser tua, mas recuperar por email dá-te uma identidade nova: as mensagens anteriores deixam de poder ser lidas. Se ainda tens a frase de recuperação de 24 palavras, usa essa via.",
  "recover.intro": "Escreve o teu nick ou email e as 24 palavras de recuperação que te foram dadas ao criar a conta. Depois escolherás uma palavra-passe nova.",
  "auth.error.badCreds": "IKOGNIT ID ou chave incorretos.",
  "auth.error.userNotFound": "IKOGNIT ID não encontrado.",
  "auth.error.cantConnect": "Não foi possível ligar ao servidor.",
  "auth.error.badPin": "Chave incorreta.",
  "auth.footnote": "Quem é dono, responde.\nSe perderes a palavra-passe,\nnão há a quem reclamar.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "IKO atual: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "IKO Pessoal: {0}",
  "sidebar.freqPsh": "IKO de Domínio: {0}",
  "sidebar.tune": "Ativar IKO",
  "sidebar.exitFreq": "Regressar a IKOGNIT",
  "sidebar.notifications": "Notificações",
  "sidebar.remember": "Lembrar dispositivo",
  "sidebar.forget": "Esquecer dispositivo",
  "sidebar.addContact": "Adicionar contacto por nick",
  "sidebar.newGroup": "Novo grupo",
  "sidebar.settings": "Definições",
  "sidebar.logout": "Sair",
  "sidebar.tooltip.logout": "Terminar sessão e apagar tudo o que é local",
  "sidebar.savedFreq.tooltip": "Ativar {0}",
  "chat.empty": "Seleciona ou adiciona um contacto",
  "welcome.title": "Bem-vindo ao IKOGNIT",
  "welcome.concept": "Em IKOGNIT falas com outros utilizadores identificando-te pelo teu nick. Quando quiseres um espaço à parte, ativas um IKO e entras num IKO. Se for Público, encontras-te com quem também o ativar. Se for Privado, entras num IKO onde apenas estás tu.",
  "welcome.step1": "Ativa um IKO e entra num IKO com quem também o conhecer.",
  "welcome.step2": "Aqui em IKOGNIT, adiciona um nick como contacto e começa a falar.",
  "welcome.step3": "Ativa um IKO Pessoal e abre um IKO só para ti, onde guardas ficheiros, fotos, áudios, vídeos, palavras-passe, notas e cartas.",
  "welcome.multidevice": "Os IKO nunca são armazenados em lado nenhum. Se esqueceres um IKO, o seu IKO deixa de existir para ti.",
  "welcome.btnFreq": "Ativar IKO",
  "welcome.btnContacts": "Adicionar contacto",
  "push.btnOn": "Notificações ON",
  "push.btnOff": "Notificações OFF",
  "push.btnEnable": "Notificações desativadas. Clica para ativar.",
  "push.btnDisable": "Notificações ativadas. Clica para desativar.",
  "push.introTitle": "Antes de ativar as notificações",
  "push.introBody": "Por privacidade, as notificações do IKOGNIT são diferentes das de outras apps de mensagens:",
  "push.introBullet1": "O conteúdo da mensagem não é incluído.",
  "push.introBullet2": "O nome e o IKOGNIT ID do remetente não são mostrados.",
  "push.introBullet3": "Apenas receberás um aviso de \"nova mensagem\"; abre a app para a leres cifrada no teu dispositivo.",
  "push.introConfirm": "Ativar notificações",
  "chat.placeholder": "Escreve uma mensagem…",
  "chat.newMessages": "novas",
  "chat.newMessagesBadge": "Ir para {0} novas mensagens",
  "chat.mediaRetry": "Tentar de novo",
  "chat.mediaFailed": "Não foi possível carregar",
  "chat.media.download": "Transferir",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Edita a tua mensagem…",
  "chat.replyingTo": "A responder a {0}",
  "chat.editing": "A editar mensagem",
  "chat.confirmContact": "Adicionar aos contactos",
  "chat.unconfirmedBanner": "Este utilizador escreveu-te mas não está nos teus contactos. Até o adicionares, a tua foto e info não lhe serão visíveis conforme as tuas definições de privacidade.",
  "chat.online": "online",
  "chat.lastSeen": "última vez aqui {0}",
  "chat.tooltip.attach": "Anexar ficheiro",
  "chat.tooltip.shareContact": "Partilhar contacto",
  "chat.tooltip.paste": "Colar imagem da área de transferência",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Chamada de voz",
  "chat.tooltip.callVideo": "Videochamada",
  "chat.btn.send": "Enviar",
  "chat.uploading": "…",
  "preview.image": "📷 Imagem",
  "preview.video": "🎬 Vídeo",
  "preview.audio": "🎙 Áudio",
  "bubble.reply": "Responder",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Editar",
  "bubble.deleteForMe": "Eliminar para mí",
  "bubble.deleteForEveryone": "Eliminar para todos",
  "bubble.edited": "editado",
  "bubble.contact.label": "Contacto IKOGNIT",
  "chat.syncing": "Sincronizando…",
  "bubble.media.decrypting": "A decifrar…",
  "bubble.media.failed": "Não foi possível decifrar o ficheiro.",
  "call.calling": "A chamar…",
  "call.incoming.audio": "Chamada recebida",
  "call.incoming.video": "Videochamada recebida",
  "call.connecting": "A ligar…",
  "call.ending": "A terminar…",
  "call.accept": "Aceitar",
  "call.reject": "Rejeitar",
  "call.hangup": "Desligar",
  "call.mic": "Microfone",
  "call.camera": "Câmara",
  "call.audioOut": "Saída de áudio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Para chamar tens de estar dentro de um IKO.",
  "error.notFound": "Recurso não encontrado.",
  "error.notInFreq": "{0} ainda não está neste IKO. Pede-lhe por outro canal que o ative.",
  "error.push.iosTooOld": "O teu iOS é anterior a 16.4. Atualiza para receber notificações.",
  "error.push.iosNotStandalone": "Para receber notificações no iPhone, instala IKOGNIT no ecrã principal: toca em Partilhar → Adicionar ao ecrã principal.",
  "error.expired": "Sessão expirada. Entra de novo.",
  "error.gone": "O ficheiro expirou.",
  "error.invalid": "Dados inválidos.",
  "error.server": "Erro do servidor. Tenta novamente.",
  "error.network": "Sem ligação ao servidor.",
  "error.cantStartCall": "Não foi possível iniciar a chamada: {0}",
  "error.cantAcceptCall": "Não foi possível aceitar a chamada: {0}",
  "error.cantPaste": "Não foi possível aceder à área de transferência. Tenta usar o botão de anexar.",
  "error.noImageInClipboard": "Não há nenhuma imagem na área de transferência.",
  "error.clipboardUnsupported": "O teu navegador não permite ler a área de transferência. Cola com Ctrl+V ou usa o botão de anexar.",
  "error.selfContact": "Não te podes adicionar a ti próprio.",
  "error.blocked": "Bloqueaste este utilizador. Desbloqueia em Definições para voltar a falar.",
  "settings.title": "Definições",
  "settings.close": "Fechar",
  "settings.tab.profile": "👤 Perfil",
  "settings.tab.privacy": "🔒 Privacidade",
  "settings.tab.messages": "✉ Mensagens",
  "settings.tab.blocked": "🚫 Bloqueados",
  "settings.tab.notifications": "🔔 Notificações",
  "settings.tab.session": "⏱ Sessão",
  "settings.tab.account": "🆔 Conta",
  "settings.tab.language": "🌐 Idioma",
  "settings.tab.about": "ℹ Sobre",
  "settings.scope.global": "Global (IKOGNIT)",
  "settings.scope.freq": "Só em {0}",
  "settings.profile.title": "Perfil",
  "settings.profile.hintGlobal": "Estes valores são usados por defeito e herdados em todos os IKO.",
  "settings.profile.hintFreq": "Sobrepõem o perfil global quando estás em {0}. Se não definires algo aqui, é herdado do global.",
  "settings.profile.displayName": "Nome a mostrar",
  "settings.profile.displayNamePh.global": "(sem nome — será mostrado o teu nick)",
  "settings.profile.displayNamePh.freq": "(herda do global)",
  "settings.profile.photo": "Foto de perfil",
  "settings.profile.changePhoto": "Mudar foto",
  "settings.profile.removePhoto": "Remover foto",
  "settings.profile.adjustPhoto": "Ajusta a tua foto",
  "settings.profile.info": "Info / Estado",
  "settings.profile.infoPh": "Olá, uso IKOGNIT",
  "settings.profile.removeOverride": "Remover override de {0}",
  "settings.profile.warn": "As alterações serão enviadas ao resto dos teus contactos automaticamente quando interagires com eles neste IKO.",
  "settings.privacy.title": "Privacidade",
  "settings.privacy.hintGlobal": "Configura quem pode ver cada informação tua por defeito.",
  "settings.privacy.hintFreq": "Sobrepõe estas regras só quando estás em {0}.",
  "settings.privacy.showPhoto": "Quem vê a minha foto",
  "settings.privacy.showInfo": "Quem vê a minha info / estado",
  "settings.privacy.showLastSeen": "Quem vê a minha última ligação",
  "settings.privacy.showOnline": "Quem vê se estou online",
  "settings.privacy.whoAdds": "Quem me pode adicionar a grupos",
  "settings.privacy.readReceipts": "Confirmações de leitura",
  "settings.privacy.readReceiptsHint": "Se desativares, não são enviados ticks azuis quando lês mensagens. Também não verás os dos outros.",
  "settings.vis.all": "Toda a gente",
  "settings.vis.contacts": "Os meus contactos",
  "settings.vis.none": "Ninguém",
  "settings.messages.title": "Mensagens",
  "settings.messages.ttl": "Caducidade por defeito",
  "settings.messages.ttlHint": "As mensagens que enviares serão apagadas do servidor após este tempo. Podes escolher um valor diferente ao anexar um ficheiro.",
  "settings.blocked.title": "Bloqueados",
  "settings.blocked.hint": "Os utilizadores bloqueados não te podem enviar mensagens. Também não lhes podes enviar.",
  "settings.blocked.placeholder": "IKOGNIT ID a bloquear",
  "settings.blocked.btn": "Bloquear",
  "settings.blocked.unblock": "Desbloquear",
  "settings.blocked.empty": "Não tens ninguém bloqueado.",
  "settings.notif.title": "Notificações",
  "settings.notif.sound": "Som",
  "settings.notif.preview": "Mostrar preview da mensagem",
  "settings.notif.vibration": "Vibração (móvel)",
  "settings.notif.hint": "As notificações push do navegador só são emitidas para mensagens em IKOGNIT geral, sem conteúdo nem nome do remetente (por design).",
  "settings.session.title": "Sessão",
  "settings.session.timeout": "Fechar o IKO após inatividade",
  "settings.session.timeoutHint": "Se passares este tempo sem tocar na app, o IKO ativo é desativado automaticamente e voltas a IKOGNIT. \"Nunca\" mantém o IKO até fechares a app.",
  "settings.session.remember": "Lembrar IKO ativados",
  "settings.session.rememberHint": "Se ativares, os IKO que ativaste aparecem como atalhos na barra lateral. Quem vir o teu ecrã poderá saber em que IKO entraste, por isso está desativado por defeito. Ao desligar apagam-se os já guardados.",
  "settings.account.title": "Conta",
  "settings.account.email": "Email opcional (só usado para recuperação, nunca publicado)",
  "settings.account.emailPh": "email@exemplo.com",
  "settings.account.changePassword": "Mudar palavra-passe",
  "settings.account.currentPw": "Palavra-passe atual",
  "settings.account.newPw": "Nova palavra-passe (mín. 8)",
  "settings.account.confirmPw": "Repete a nova",
  "settings.account.saving": "A guardar…",
  "settings.account.success": "Palavra-passe atualizada.",
  "settings.account.errPwBad": "A palavra-passe atual não está correta.",
  "settings.account.errPwShort": "A nova palavra-passe deve ter pelo menos 8 caracteres.",
  "settings.account.errPwMismatch": "As palavras-passe não coincidem.",
  "settings.language.title": "Idioma",
  "settings.language.hint": "Escolhe o idioma da interface. A tua preferência é guardada neste dispositivo.",
  "settings.about.title": "Sobre o IKOGNIT",
  "settings.about.version": "Versão",
  "settings.about.tech": "Cifragem E2E com NaCl box (X25519). IKO: derivação Argon2id + HMAC determinístico. Persistência local cifrada com Argon2id sobre PIN.",
  "modal.freq.title": "Ativar IKO",
  "modal.freq.hint": "Um IKO são as IKO exatas de um dos teus IKO. Público: encontras quem escrever as mesmas. Privado: chegas a um IKO onde és invisível, mesmo que outra pessoa escreva as mesmas IKO.",
  "modal.freq.placeholder": "Escreve as tuas IKO",
  "modal.freq.activate": "Ativar",
  "modal.freq.deriving": "A calcular IKO…",
  "modal.freq.warn": "As IKO não são guardadas em lado nenhum. Se as esqueceres, esse IKO deixa de existir para ti.",
  "modal.freq.errShort": "O IKO deve ter pelo menos 8 caracteres.",
  "modal.freq.errCommon": "Esse IKO é demasiado comum. Escolhe algo único.",
  "modal.freq.errRepeat": "Não uses um único carácter repetido.",
  "modal.freq.errSeqNum": "Evita sequências numéricas óbvias.",
  "modal.freq.errSeqAlpha": "Evita sequências do alfabeto.",
  "billing.title": "Faturação",
  "billing.manage": "Gerir",
  "billing.seats": "Lugares",
  "billing.renews": "Renovação",
  "billing.needsUpgrade": "Atingiste o limite do teu escalão. Sobe de escalão para adicionar mais lugares.",
  "billing.upgradeTo": "Subir escalão ({price}/lugar)",
  "billing.portal": "Gerir pagamento",
  "join.loginToAccept": "Iniciar sessão / Criar conta",
  "private.badge": "PRIVADO",
  "private.welcome.title": "O teu IKO Privado",
  "private.welcome.intro": "Estás em IKO onde ninguém te pode ver. Mesmo que outra pessoa escrevesse o mesmo IKO, chegaria a um IKO diferente. Aqui guardas o que é teu em segurança.",
  "private.welcome.hint": "Escolhe uma secção para começar.",
  "private.mod.notes": "Notas",
  "private.mod.notes.desc": "Notas, cartas, diário.",
  "private.mod.files": "Ficheiros",
  "private.mod.files.desc": "Documentos, folhas, PDFs.",
  "private.mod.photos": "Fotos",
  "private.mod.photos.desc": "A tua galeria privada.",
  "private.mod.videos": "Vídeos",
  "private.mod.videos.desc": "Os teus vídeos pessoais.",
  "private.mod.audios": "Áudios",
  "private.mod.audios.desc": "Gravações e notas de voz.",
  "private.mod.vault": "Palavras-passe",
  "private.mod.vault.desc": "Palavras-passe, cartões, identidades, chaves SSH e o que precisares.",
  "private.mod.iko": "Os meus IKO",
  "private.mod.iko.desc": "Os teus IKO guardados, prontos a ativar.",
  "savediko.intro": "Guarda aqui os IKO que não queiras memorizar. Lembras-te de um só e os restantes vivem lá dentro.",
  "savediko.empty": "Ainda não guardaste nenhum IKO.",
  "savediko.add": "Guardar um IKO",
  "savediko.activate": "Ativar IKO",
  "savediko.formNew": "Guardar um IKO",
  "savediko.formEdit": "Editar IKO guardado",
  "savediko.descLabel": "Descrição",
  "savediko.descPh": "Uma descrição para reconhecê-lo mais tarde",
  "savediko.ikoLabel": "O IKO",
  "savediko.ikoPh": "Escreve o IKO",
  "savediko.errDesc": "Escreve uma descrição.",
  "savediko.errIko": "Escreve o IKO.",
  "savediko.confirmDel": "Apagar?",
  "vault.new": "Novo elemento",
  "vault.edit": "Editar",
  "vault.delete": "Eliminar",
  "vault.save": "Guardar",
  "vault.show": "Mostrar",
  "vault.hide": "Ocultar",
  "vault.copy": "Copiar",
  "vault.copied": "Copiado ✓",
  "vault.search": "Pesquisar…",
  "vault.empty": "O teu pasta está vazio. Cria o primeiro elemento.",
  "vault.noMatches": "Nenhum elemento corresponde à pesquisa.",
  "vault.untitled": "Sem nome",
  "vault.startHint": "Seleciona um elemento à esquerda ou cria um novo.",
  "vault.confirmDelete": "Eliminar este elemento? Não pode ser recuperado.",
  "vault.notes": "Notas",
  "vault.sensitive": "Sensível",
  "vault.sensitiveHint": "Os campos sensíveis são ocultos por defeito e podem ser copiados para a área de transferência.",
  "vault.removeField": "Eliminar este campo",
  "vault.addField": "Adicionar campo",
  "vault.fieldSingular": "campo",
  "vault.fieldPlural": "campos",
  "vault.type.login": "Login",
  "vault.type.card": "Cartão",
  "vault.type.identity": "Identidade",
  "vault.type.sshkey": "Chave SSH",
  "vault.type.custom": "Personalizado",
  "vault.field.name": "Nome",
  "vault.field.name.ph": "Como lhe chamas?",
  "vault.field.labelPh": "Etiqueta do campo",
  "vault.field.newField": "Campo",
  "vault.field.username": "Utilizador",
  "vault.field.password": "Palavra-passe",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Titular",
  "vault.field.cardBrand": "Marca",
  "vault.field.cardNumber": "Número",
  "vault.field.cardExpiry": "Validade (MM/AA)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Nome",
  "vault.field.lastname": "Apelidos",
  "vault.field.dni": "BI / NIF",
  "vault.field.address": "Morada",
  "vault.field.city": "Cidade",
  "vault.field.zip": "Código postal",
  "vault.field.country": "País",
  "vault.field.phone": "Telefone",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Data de nascimento",
  "vault.field.sshPrivate": "Chave privada",
  "vault.field.sshPublic": "Chave pública",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Texto",
  "vault.ft.password": "Palavra-passe",
  "vault.ft.textarea": "Texto longo",
  "vault.ft.date": "Data",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Número",
  "vault.tpl.title": "Modelos",
  "vault.tpl.manage": "Gerir modelos",
  "vault.tpl.yours": "Os teus modelos",
  "vault.tpl.new": "Novo modelo",
  "vault.tpl.edit": "Editar modelo",
  "vault.tpl.empty": "Ainda não tens modelos. Cria um para definir o teu próprio tipo de elemento.",
  "vault.tpl.name": "Nome do modelo",
  "vault.tpl.name.ph": "Ex: Carteira cripto, Reserva de hotel…",
  "vault.tpl.confirmDelete": "Eliminar este modelo? Os elementos criados a partir dele mantêm-se.",
  "totp.copyCode": "Copiar código",
  "totp.copySecret": "Copiar secret",
  "totp.showSecret": "Ver secret",
  "totp.hideSecret": "Ocultar secret",
  "totp.invalid": "secret inválido",
  "private.module.coming": "Em breve.",
  "private.module.comingHint": "Este módulo estará disponível muito em breve. A criptografia do IKO Privado já funciona — em breve poderás guardar aqui o que precisares.",
  "notes.new": "Nova nota",
  "notes.empty": "Ainda não tens notas neste IKO.",
  "notes.emptyPreview": "(vazia)",
  "notes.untitled": "Sem título",
  "notes.delete": "Eliminar nota",
  "notes.confirmDelete": "Eliminar esta nota? Não pode ser recuperada.",
  "notes.titlePlaceholder": "Título",
  "notes.contentPlaceholder": "Escreve o que precisas de lembrar…",
  "notes.startHint": "Sem notas neste IKO. Cria a primeira.",
  "notes.autosaveHint": "Guardada automaticamente, cifrada, só aqui.",
  "notes.yesterday": "Ontem",
  "passwords.new": "Nova entrada",
  "passwords.empty": "Ainda não guardaste nenhuma entrada neste IKO.",
  "passwords.untitled": "Sem nome",
  "passwords.startHint": "Sem palavras-passe neste IKO. Cria a primeira.",
  "passwords.confirmDelete": "Eliminar esta entrada? Não pode ser recuperada.",
  "passwords.save": "Guardar",
  "passwords.edit": "Editar",
  "passwords.delete": "Eliminar",
  "passwords.copy": "Copiar",
  "passwords.copied": "Copiado ✓",
  "passwords.show": "Mostrar",
  "passwords.hide": "Ocultar",
  "passwords.field.label": "Nome",
  "passwords.field.label.ph": "Banco, conta, serviço…",
  "passwords.field.username": "Utilizador",
  "passwords.field.username.ph": "Email, alias, número…",
  "passwords.field.password": "Palavra-passe",
  "passwords.field.password.ph": "A palavra-passe que queres guardar",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notas",
  "passwords.field.notes.ph": "Qualquer detalhe útil",
  "media.uploading": "A enviar…",
  "media.uploadFailed": "Não foi possível enviar o ficheiro.",
  "media.upload.file": "Enviar ficheiro",
  "media.upload.photo": "Enviar foto",
  "media.upload.video": "Enviar vídeo",
  "media.upload.audio": "Enviar áudio",
  "media.empty.file": "Ainda não há ficheiros neste IKO.",
  "media.empty.photo": "Ainda não há fotos neste IKO.",
  "media.empty.video": "Ainda não há vídeos neste IKO.",
  "media.empty.audio": "Ainda não há áudios neste IKO.",
  "media.play": "Reproduzir",
  "media.download": "Descarregar",
  "media.delete": "Eliminar",
  "media.confirmDelete": "Eliminar este elemento? Não pode ser recuperado.",
  "media.noPreview": "Sem pré-visualização para este tipo de ficheiro.",
  "modal.share.title": "Partilhar contacto",
  "modal.share.hint": "Escolhe um contacto da lista ou introduz um IKOGNIT ID manualmente.",
  "modal.share.filter": "Filtrar contactos…",
  "modal.share.empty": "Sem contactos neste IKO",
  "modal.share.manual": "Ou um IKOGNIT ID manual",
  "modal.share.btn": "Partilhar",
  "modal.group.title": "Novo grupo",
  "modal.group.hint": "Escolhe um nome e seleciona membros entre os teus contactos neste IKO.",
  "modal.group.namePh": "Nome do grupo",
  "modal.group.selected": "{0} selecionados",
  "modal.group.create": "Criar grupo",
  "modal.remember.title": "Lembrar este dispositivo",
  "modal.remember.hint": "A tua sessão, contactos, grupos e mensagens serão guardados neste dispositivo, cifrados com um PIN que só tu conheces. Ao reabrir a app introduzirás o PIN para invocar.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repete o PIN",
  "modal.remember.warn": "Se esqueceres o PIN, os dados guardados não poderão ser recuperados. Terás de entrar de novo com o teu utilizador e palavra-passe.",
  "modal.remember.errShort": "O PIN deve ter pelo menos 4 caracteres.",
  "modal.remember.errMismatch": "Os PINs não coincidem.",
  "stickers.faces": "Caras",
  "stickers.gestures": "Gestos",
  "stickers.hearts": "Corações",
  "stickers.symbols": "Símbolos",
  "stickers.animals": "Animais",
  "stickers.food": "Comida",
  "ttl.1h": "1 hora",
  "ttl.1d": "1 dia",
  "ttl.1w": "1 semana",
  "ttl.1m": "1 mês",
  "ttl.6m": "6 meses",
  "ttl.12m": "12 meses",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nunca",
  "toast.newMessage": "Nova mensagem",
  "toast.group": "{0} (grupo)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informações e navegação do IKO",
  "ctx.section.universe": "IKO ATUAL",
  "ctx.universe.personal": "O teu espaço pessoal",
  "ctx.status.serverBlind": "Servidor cego ativo",
  "ctx.status.e2e": "Cifragem de ponta a ponta",
  "ctx.section.nav": "NAVEGAÇÃO",
  "ctx.nav.changeIko": "Mudar de IKO",
  "ctx.nav.activateIko": "Ativar um IKO",
  "ctx.nav.backToIkognit": "Voltar ao IKOGNIT",
  "ctx.section.actions": "AÇÕES",
  "ctx.action.newChat": "Novo chat",
  "ctx.action.newGroup": "Novo grupo",
  "ctx.action.contacts": "Os meus contactos",
  "ctx.section.conversation": "CONVERSA",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} mensagens",
  "ctx.peer.message": "{0} mensagem",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "IKO Pessoal",
  "ctx.modes.storage": "Unidade",
  "ctx.liturgy.0": "O servidor é cego.",
  "ctx.liturgy.1": "Aqui só tu lês.",
  "ctx.liturgy.2": "Ninguém sabe que estás aqui.",
  "ctx.liturgy.3": "Um IKO é um segredo que só tu conheces.",
  "ctx.liturgy.4": "A tua privacidade é a arquitetura.",
  "ccb.universe.changeOrExit": "Mudar de IKO ou sair",
  "ccb.universe.activate": "Ativar IKO",
  "ccb.leave.title": "Sair do IKO (voltar ao IKOGNIT)",
  "ccb.leave.aria": "Sair do IKO",
  "ccb.tag.cipher.title": "Cifra simétrica ativa",
  "ccb.tag.srv.title": "O servidor não consegue ler o conteúdo",
  "ccb.tag.unread.title": "Mensagens não lidas",
  "ccb.settings.title": "Definições · perfil, temas, sessão",
  "ccb.settings.aria": "Definições",
  "ccb.identity.title": "Sessão: @{0}",
  "ccb.clock.title": "Hora local",
  "ccb.modes.personalPrefix": "PESSOAL · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "IKO PESSOAL",
  "holo.modes.general": "O TEU NICK + CONTACTOS",
  "holo.claim.inIko": "Este IKO permanece invisível para quem não o conhece.",
  "holo.claim.general": "O teu espaço pessoal no IKOGNIT. Aqui falas com os teus contactos.",
  "holo.card.conversations": "Conversas",
  "holo.card.contacts": "Contactos",
  "holo.card.cipher": "Cifragem",
  "holo.card.server": "Servidor",
  "holo.foot": "Escolhe uma conversa, ativa um IKO, ou cria um novo espaço.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "IKO Pessoal",
  "uib.context.coordTitle": "O IKO",
  "uib.context.general": "IKO geral",
  "uib.e2e.title": "O servidor não consegue ler o teu conteúdo — cifragem E2E com a tua chave",
  "uib.e2e.label": "Servidor cego",
  "uib.pseudoTitle": "O teu pseudónimo neste IKO",
  "uib.nickTitle": "O teu nick",
  "uib.exitTitle": "Voltar ao IKO geral",
  "uib.exitLabel": "Sair",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Navegação principal",
  "chat.tab.chats": "Chats",
  "chat.tab.calls": "Chamadas",
  "chat.tab.contacts": "Contactos",
  "chat.backToIkognit.title": "Voltar ao IKOGNIT geral",
  "chat.delete.title": "Eliminar",
  "chat.delete.aria": "Eliminar",
  "chat.call.title": "Ligar",
  "chat.videoCall.title": "Videochamada",
  "chat.videoCall.aria": "Videochamada com {0}",
  "chat.search.clear": "Limpar pesquisa",
  "chat.filters.aria": "Filtros de chats",
  "chat.filter.all": "Todos",
  "chat.filter.unread": "Não lidos",
  "chat.filter.groups": "Grupos",
  "chat.attachPending": "Anexo pendente",
  "chat.remove.title": "Remover",
  "chat.cancel.title": "Cancelar",
  "chat.blocked.text": "Bloqueaste {0}. Não podes enviar-lhe mensagens nem ligar.",
  "chat.unblock": "Desbloquear",
  "contacts.alias.placeholder": "Um alias para o identificar",
  "contacts.notes.placeholder": "Só tu a vês (cifrada no servidor).",
  "contacts.search.placeholder": "Procurar por alias ou IKOGNIT ID",
  "contacts.edit.title": "Editar alias e nota",
  "contacts.edit.aria": "Editar",
  "contacts.blockBtn": "Bloquear contacto",
  "contacts.unblockBtn": "Desbloquear contacto",
  "contacts.confirmBlock.title": "Bloquear contacto",
  "contacts.confirmUnblock.title": "Desbloquear contacto",
  "contacts.confirmBlock.body": "Bloquear {0}? Deixarás de receber as suas mensagens e chamadas.",
  "contacts.confirmUnblock.body": "Desbloquear {0}? Voltarás a receber as suas mensagens.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Categorias do IKO Pessoal",
  "piko.rail.head": "PESSOAL",
  "piko.cat.all": "Tudo",
  "piko.cat.photos": "Fotos",
  "piko.cat.videos": "Vídeos",
  "piko.cat.audios": "Áudios",
  "piko.cat.files": "Ficheiros",
  "piko.cat.notes": "Notas",
  "piko.cat.passwords": "Palavras-passe",
  "piko.cat.cards": "Cartões",
  "piko.cat.identities": "Identidades",
  "piko.cat.sshkeys": "Chaves SSH",
  "piko.cat.custom": "Pasta",
  "piko.cat.agendas": "Agendas IKO",
  "piko.cat.storage": "Unidades e Discos",

  "auth.field.nickPlaceholder": "ex.: user123",
  "auth.field.emailPlaceholder": "teu@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Lido {0}",
  "bubble.tick.delivered": "Entregue {0}",
  "bubble.tick.sent": "Enviado",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Bloqueaste este utilizador.",
  "chat.preview.image": "Imagem",
  "chat.preview.video": "Vídeo",
  "chat.preview.voice": "Mensagem de voz",
  "chat.preview.audio": "Áudio",
  "error.push.denied": "Recusaste a permissão de notificações.",
  "error.push.noSw": "Este navegador não suporta service workers.",
  "error.push.noPush": "Este navegador não suporta notificações push.",
  "error.push.noVapid": "O servidor não forneceu a chave VAPID.",
  "error.push.activateFailed": "Não foi possível ativar ({0}).",
  "chat.group.membersWord": "membros",
  "chat.newCall.title": "Nova chamada",
  "chat.newChat.title": "Novo chat",
  "chat.newCall.empty": "Ainda não tens contactos. Adiciona um a partir do + em Chats.",
  "chat.unread.aria": "mensagens não lidas",
  "chat.calls.title": "Chamadas",
  "chat.calls.empty": "Ainda não há chamadas. Inicia uma a partir do chat com um contacto.",
  "chat.calls.callContact": "Ligar a um contacto",
  "chat.calls.historySoon": "O histórico de chamadas estará disponível em breve.",
  "chat.deleteConv.titleOne": "Eliminar conversa",
  "chat.deleteConv.titleMany": "Eliminar {0} conversas",
  "chat.deleteConv.hint": "\"Para mim\" apaga a tua cópia (todos os teus dispositivos). \"Para todos\" também pede ao contacto que apague no seu lado.",
  "chat.deleteConv.forMe": "Eliminar para mim",
  "chat.deleteConv.forAll": "Eliminar para todos",
  "chat.myContacts": "Os meus contactos",
  "chat.contacts.noResults": "Sem resultados.",
  "chat.contacts.empty": "Ainda não tens contactos.",
  "chat.contact.badgeBlocked": "bloqueado",
  "chat.contact.badgePending": "não confirmado",
  "chat.toast.saved": "Guardado",
  "chat.toast.videoSaved": "Vídeo guardado em Fotos",
  "chat.toast.imageSaved": "Imagem guardada em Fotos",
  "chat.toast.updateTestflight": "Atualiza o TestFlight para 1.0(10)+ para Guardar.",
  "chat.toast.saveFailed": "Não foi possível guardar: {0}",
  "chat.toast.saveError": "Erro ao guardar",
  "iko.banner.exitAria": "Sair do IKO e voltar ao plano geral",
  "iko.liturgy.entering": "A entrar em IKO",
  "iko.liturgy.returning": "A regressar",
  "iko.liturgy.toIkognit": "para IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "IKO Pessoal",
  "manifest.blindServer": "O servidor é cego.",
  "manifest.onlyYouRead": "Aqui só tu lês.",
  "manifest.noPublicProfiles": "Sem perfis públicos.",
  "manifest.noAdsNoClouds": "Sem publicidade. Sem nuvens alheias.",
  "manifest.keyWithYou": "A chave vive contigo.",
  "manifest.yourIkoYourSpaces": "Os teus IKO. Os teus espaços.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Ficheiros",
  "orb.mod.notes": "Notas",
  "orb.mod.photos": "Fotos",
  "orb.mod.vault": "Pasta",
  "orb.mod.audios": "Áudios",
  "orb.copy.line1": "Os teus IKO.",
  "orb.copy.line2": "Os teus espaços.",
  "explorer.filesNotProcessed": "Ficheiro(s) não processados",
  "demo.edit": "Editar",
  "common.exit": "Sair",
  "common.more": "Mais",
  "chat.tab.settings": "Definições",
  "chat.search.placeholder": "Procurar conversa",
  "chat.presence.online": "em linha",
  "chat.action.call": "Ligar",
  "chat.action.videoCall": "Videochamada",
  "chat.attach.label": "Anexar",
  "chat.attach.camera": "Câmara",
  "chat.attach.voice": "Voz",
  "chat.attach.file": "Anexar ficheiro",
  "chat.composer.placeholder": "Escreve uma mensagem...",
  "settings.addYourName": "Adiciona o teu nome",
  "settings.editProfile": "Editar perfil",
  "chat.welcome.intro": "Seleciona uma conversa para começar a falar com encriptação ponta a ponta.",

  // Batch2: footer atajos web
  "web.footer.palette": "paleta",
  "web.footer.send": "enviar",
  "web.footer.line": "linha",
  "mobile.tb.ikoActivate": "Ativar IKO",
  "mobile.tb.ikoExit": "Voltar a IKOGNIT geral",

  "chat.header.blocked": "Bloqueado",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Nota privada",
  "settings.account.newNickPlaceholder": "novo_nick",
  "settings.account.newEmailPlaceholder": "novo@email.com",


  "common.delete": "Eliminar",








};

const fr: Catalog = {
  "auth.verify.notSent": "Nous n’avons pas pu t’envoyer le code. Ton compte existe : appuie sur « Renvoyer le code » dans un instant.",
  "lg.rotulo": "Messagerie avec espaces privés",
  "lg.btn.entrar": "Se connecter",
  "lg.eyebrow": "Messagerie privée · Itrion Software",
  "lg.h1a": "Tes conversations de toujours.",
  "lg.h1b": "Et un endroit qui n'existe que lorsque tu l'invoques.",
  "lg.lead1": "Tu parles avec ta famille, tes amis et ton équipe, comme dans n'importe quelle app. La différence commence quand tu ouvres un IKO : un espace à toi où l'on entre en écrivant un secret que seuls connaissent ceux qui sont dedans.",
  "lg.lead2": "Tant que tu ne l'invoques pas, cet espace n'est pas sur ton appareil — ni sur le téléphone, ni sur la tablette, ni sur l'ordinateur. Ce n'est pas qu'il soit chiffré.",
  "lg.lead2b": "C'est qu'il n'est pas là.",
  "lg.pruebalo": "Essaie · écris un secret et regarde ce qui se passe",
  "lg.panel.plano": "Plan général",
  "lg.demo.hilos": "Famille=Maman : on dîne dimanche à la maison ?=19:04|Marta=je t'envoie les photos de samedi=17:52|Équipe=Luis : demain à neuf heures, alors=Hier|Javi=haha j'y crois pas=Hier",
  "lg.demo.mundos": "Rien que nous deux~tu l'as mis là où on avait dit ?|oui. l'acte et le passeport>~Acte de l'appartement.pdf=2,4 Mo|Photos privées=214|Carte · banque=Données~~Les affaires de la maison~je te laisse ici le bail>|et la clé du routeur, tu la perds toujours~Bail.pdf=1,1 Mo|Copie de la carte d'identité=2 fichiers|Clés de la maison=Données~~Mes notes~je ne l'ai dit à personne>|et ce n'est pas la peine>~Journal=48 notes|Photos=1 207|Comptes de l'année=Données~~Projet Lisbonne~l'offre tombe à 180|la voilà, aucune copie dehors>~Offre_v4.pdf=860 Ko|Contacts=12|Carte de l'entreprise=Données~~Le déjeuner de samedi~ne dis encore rien à Marta|tranquille, ici personne ne l'apprend>~Réservation.pdf=120 Ko|Photos de l'an dernier=63|Liste des invités=Données",
  "lg.invocaLabel": "Invoque ton IKO",
  "lg.invocaPlaceholder": "écris un secret, n'importe lequel",
  "lg.invocaBtn": "Invoquer",
  "lg.invocaHint": "Chaque mot mène à un espace différent. Essaies-en un autre.",
  "lg.estela.vacio": "Écris n'importe quoi : ici c'est une démonstration.",
  "lg.estela.primero": "Invoqué. Il n'existe que pendant que tu y es.",
  "lg.estela.otro": "Un autre secret, un autre espace. Aucun ne sait pour les autres.",
  "lg.estela.salida": "Il est parti. Aucune trace sur l'appareil. Essaie un autre mot.",
  "lg.ikoActivo": "IKO actif",
  "lg.nadaEnDispositivo": "Rien de tout cela n'est sur l'appareil",
  "lg.salirIko": "Quitter l'IKO",
  "lg.planos.h2a": "Un plan à la vue de tous.",
  "lg.planos.h2b": "En dessous, ceux que tu invoques.",
  "lg.planos.lead": "Il n'y a pas « l'IKO ». Il y a ceux que tu ouvres : un pour la maison, un pour le travail, un que vous n'êtes que deux à connaître, un dont tu n'as jamais parlé à personne. Chaque secret mène au sien, et aucun ne sait pour les autres.",
  "lg.planos.unoRotulo": "Le plan général · un",
  "lg.planos.unoH3": "Là où tu parles à tout le monde",
  "lg.planos.unoP": "Conversations, groupes, appels, photos et fichiers, chiffrés de bout en bout. Ce que tu attends d'une messagerie, bien fait. Tes discussions de toujours vivent ici et se comportent comme toujours.",
  "lg.planos.nRotulo": "Les IKO · autant que tu veux",
  "lg.planos.nH3": "Là où personne d'autre n'arrive",
  "lg.planos.nP": "Tu écris un secret et l'espace correspondant apparaît. Des conversations et tes affaires y tiennent. Quand tu sors, il quitte l'appareil sans laisser de trace. Il n'y a pas de liste, pas de nombre, et personne ne peut deviner combien tu en as, ni qu'il en existe un seul.",
  "lg.planos.chips": "Les affaires de la maison|Le travail|Ce que vous n'êtes que deux à savoir|Le tien et celui de personne d'autre|Celui que tu as ouvert une fois et jamais rouvert|Ceux que tu décideras demain",
  "lg.forense.h2a": "Ce n'est pas chiffré sur ton appareil.",
  "lg.forense.h2b": "Ce n'est pas sur ton appareil.",
  "lg.forense.lead": "Les autres apps gardent tes messages sur la machine et les chiffrent. Si quelqu'un l'emporte, ta vie privée dépend de la résistance de ce chiffrement. Ici il n'y a rien qui doive résister : ce qui vit dans un IKO ne s'écrit sur aucun appareil. On l'invoque, on s'en sert, il s'en va.",
  "lg.forense.multi": "C'est pareil partout : téléphone, tablette, ordinateur de la maison, portable du bureau, Windows, Mac ou le navigateur d'un endroit qui n'est pas le tien. Tu entres où tu veux et, en sortant, cet endroit ne sait plus rien de toi.",
  "lg.forense.caption": "Ce que trouve celui qui examine n'importe lequel de tes appareils",
  "lg.forense.filas": "Messages de tes IKO=0|Fichiers et photos de tes IKO=0|Secrets d’IKO enregistrés=0|Base de données contenant tes IKO=inexistante|Trace qu’un IKO a été ouvert=aucune|Combien d’IKO tu as=indéterminable",
  "lg.escenas.h2": "Ce qui t'inquiète vraiment.",
  "lg.escenas.filas": "« J'ai perdu mon téléphone. »=Ta vie privée n'est pas partie avec lui. Ce qui était dans un IKO n'a jamais été sur cette machine : rien à récupérer, rien à craindre. Tu l'invoques depuis n'importe quel autre appareil et tout est resté où c'était.~« On m'a pris mon portable. »=On verra tes conversations ordinaires, les mêmes que dans n'importe quelle app. Du reste, on ne verra ni le contenu, ni le nom, ni le moindre indice que ça existe.~« On a examiné mon ordinateur. »=Une analyse forensique récupère ce qui est écrit sur le disque, même chiffré et effacé. Ici il n'y a rien d'écrit à récupérer. La réponse n'est pas « on ne peut pas déchiffrer » : c'est qu'il n'y a rien. Et pareil sur la tablette, sur le téléphone et sur le navigateur utilisé un après-midi.",
  "lg.ciego.h2": "Ni nous. Ni celui qui héberge les serveurs.",
  "lg.ciego.p1": "Le serveur garde des choses qu'il ne peut pas lire. Il n'a pas ton secret, il ne l'a jamais eu et aucune copie n'existe nulle part. Ce n'est pas que nous refusions de livrer ce qu'il y a dans tes IKO : c'est que nous ne l'avons pas, et qu'il n'y a aucun moyen de l'avoir. Ni l'entreprise qui héberge les machines, ni quiconque mettrait la main dessus.",
  "lg.ciego.p2": "Cela a un prix et il est juste de le dire : si tu perds ton secret, personne ne peut te le rendre. La raison même pour laquelle personne d'autre ne peut entrer est la raison pour laquelle nous ne pouvons pas non plus t'aider à entrer.",
  "lg.guardas": "Photos de famille|Les notes que tu ne montres pas|Cartes et coordonnées bancaires|Mots de passe|Documents|Conversations qui ne regardent que vous",
  "lg.nombre.esta": "c'est là",
  "lg.nombre.noEsta": "ce n'est pas là",
  "lg.nombre.h2": "D'où le nom.",
  "lg.nombre.p": "En swahili, iko veut dire « c'est là » et haiko, « ce n'est pas là ». Un IKO est là tant que tu l'invoques. Le reste du temps — c'est-à-dire presque tout le temps — il n'est pas là : ni sur tes appareils, ni sous les yeux de personne, ni même comme soupçon.",
  "lg.cierre.h2": "Commence à parler.",
  "lg.cierre.p": "Ça s'utilise comme n'importe quelle messagerie, sur le téléphone, la tablette et l'ordinateur. Les IKO sont là le jour où tu en as besoin.",
  "lg.cierre.btnCrear": "Créer un compte",
  "lg.cierre.btnEntrar": "J'ai déjà un compte",
  "lg.cierre.pago": "IKOGNIT est un produit payant. Pas de publicité, pas de profils publicitaires et aucune copie de quoi que ce soit chez nous : nous vivons de ce que l'app en vaille la peine, pas de ce que tu pourrais y raconter.",
  "lg.pie.ciego": "Serveur aveugle",
  "auth.hola": "Bonjour à nouveau.",
  "auth.queEs": "C'est quoi IKOGNIT ?",
  "common.cancel": "Annuler",
  "common.error.generic": "Ça n'a pas abouti. Réessaie.",
  "common.save": "Enregistrer",
  "common.confirm": "Confirmer",
  "common.close": "Fermer",
  "common.add": "Ajouter",
  "common.back": "Retour",
  "common.tagline": "Souveraineté numérique.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "En swahili, iko veut dire « c’est là ». Et haiko, « ce n’est pas là ».",
  "auth.legal.age": "Je confirme avoir l'âge minimum requis par la loi de mon pays pour utiliser IKOGNIT.",
  "auth.legal.accept": "J'ai lu et j'accepte les <a href='https://ikognit.org/legal/fr/conditions.html' target='_blank' rel='noopener'>Conditions</a>, la <a href='https://ikognit.org/legal/fr/confidentialite.html' target='_blank' rel='noopener'>Politique de Confidentialité</a> et les <a href='https://ikognit.org/legal/fr/regles-communaute.html' target='_blank' rel='noopener'>Règles de la Communauté</a>.",
  "recovery.title": "Ta clé de récupération",
  "recovery.intro": "Ces **24 mots** sont le seul moyen de récupérer ton compte et l'historique si tu oublies ton mot de passe ou perds ton appareil. **Écris-les sur papier et garde-les en lieu sûr.** Personne chez IKOGNIT ne peut les récupérer pour toi.",
  "recovery.warn": "**Note-les HORS LIGNE.** Ne fais pas de capture d'écran. Ne les envoie pas par email ni par messagerie. Qui détient ces mots contrôle l'intégralité de ton compte.",
  "recovery.btn.show": "Afficher les mots",
  "recovery.btn.copy": "Copier",
  "recovery.btn.copied": "Copié · s'efface dans {0}s",
  "recovery.btn.cleared": "Presse-papiers effacé",
  "recovery.btn.copyAria": "Copier la phrase de récupération dans le presse-papiers (sera effacée automatiquement)",
  "recovery.btn.download": "Télécharger",
  "recovery.btn.downloadAria": "Télécharger la phrase comme fichier texte",
  "recovery.btn.back": "Revoir les mots",
  "recovery.btn.continue": "Continuer",
  "recovery.btn.done": "J'ai terminé",
  "recovery.btn.need3": "Écris les 3 mots corrects",
  "recovery.verify.intro": "Pour confirmer que tu as sauvegardé ta clé, écris ces mots. Tu ne peux pas continuer sans les saisir correctement.",
  "recovery.verify.wordN": "Mot #{0}",
  "recovery.verify.correct": "Correct",
  "recovery.verify.wrong": "Incorrect",
  "auth.error.legalRequired": "Tu dois accepter les conditions légales et confirmer ton âge pour créer un IKOGNIT ID.",
  "settings.legal.title": "Informations légales",
  "settings.legal.hub": "Centre Légal",
  "settings.legal.terms": "Conditions Générales",
  "settings.legal.privacy": "Politique de Confidentialité",
  "settings.legal.rules": "Règles de la Communauté",
  "settings.legal.report": "Signalements et Modération",
  "settings.legal.cookies": "Politique de Cookies",
  "settings.legal.minors": "Politique des Mineurs",
  "settings.legal.notice": "Mentions Légales",
  "settings.tab.legal": "Légal",
  "auth.loading": "Chargement…",
  "auth.savedSession": "Cet appareil reconnaît déjà son propriétaire.",
  "auth.locked": "Ça s'est évanoui faute d'activité. Entre à nouveau.",
  "auth.sessionExpired": "La session s'est évanouie. Entre à nouveau.",
  "auth.tab.login": "Se connecter",
  "auth.tab.register": "Nouvel IKOGNIT ID",
  "auth.subLogin": "Tu entres dans le plan général : tes conversations de toujours. Tes IKO ne s'invoquent pas ici — ils s'invoquent dedans, quand tu en as besoin.",
  "auth.subRegister": "Le compte est à ton nom. Le pseudo est ce que les autres voient ; l'e-mail sert seulement à récupérer l'accès et à t'avertir.",
  "auth.field.devicePin": "Clé maîtresse",
  "auth.field.password": "Clé maîtresse",
  "auth.btn.unlock": "Entrer",
  "auth.btn.unlocking": "Connexion…",
  "auth.btn.processing": "Traitement…",
  "auth.btn.createIdentity": "Créer IKOGNIT ID",
  "auth.btn.useOther": "Utiliser un autre IKOGNIT ID",
  "auth.btn.forget": "Oublier cet appareil",
  "auth.btn.backToUnlock": "Retour",
  "auth.confirmForget": "Cet appareil cessera de te reconnaître : le compte enregistré et tout ce qui est en cache s'évanouissent. Pour revenir, il te faudra ton mot de passe.",
  "auth.confirmForget.warning": "Sans la phrase de récupération de 24 mots notée, il n'y a pas de retour : personne ne peut te la rendre.",
  "invite.welcomeSub": "Messagerie et espace à toi : ce que tu gardes ici est à ton nom. Crée ton compte et vous serez connectés.",
  "auth.reset.warnNewIdentity": "Ton compte reste le tien, mais récupérer par e-mail te donne une nouvelle identité : les messages antérieurs ne pourront plus être lus. Si tu as encore ta phrase de récupération de 24 mots, passe plutôt par là.",
  "recover.intro": "Saisis ton pseudo ou ton e-mail et les 24 mots de récupération remis à la création du compte. Tu choisiras ensuite un nouveau mot de passe.",
  "auth.error.badCreds": "IKOGNIT ID ou clé incorrects.",
  "auth.error.userNotFound": "IKOGNIT ID introuvable.",
  "auth.error.cantConnect": "Impossible de se connecter au serveur.",
  "auth.error.badPin": "Clé incorrecte.",
  "auth.footnote": "Le propriétaire en répond.\nSi tu perds ton mot de passe,\nil n'y a personne à qui réclamer.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "IKO actuel : {0}",
  "sidebar.freqPublic": "IKO : {0}",
  "sidebar.freqPrivate": "IKO Personnel : {0}",
  "sidebar.freqPsh": "IKO de Domaine : {0}",
  "sidebar.tune": "Activer IKO",
  "sidebar.exitFreq": "Retour à IKOGNIT",
  "sidebar.notifications": "Notifications",
  "sidebar.remember": "Mémoriser l'appareil",
  "sidebar.forget": "Oublier l'appareil",
  "sidebar.addContact": "Ajouter un contact par nick",
  "sidebar.newGroup": "Nouveau groupe",
  "sidebar.settings": "Réglages",
  "sidebar.logout": "Quitter",
  "sidebar.tooltip.logout": "Se déconnecter et effacer tout le local",
  "sidebar.savedFreq.tooltip": "Activer {0}",
  "chat.empty": "Sélectionne ou ajoute un contact",
  "welcome.title": "Bienvenue dans IKOGNIT",
  "welcome.concept": "Dans IKOGNIT tu parles avec d'autres utilisateurs identifié par ton nick. Quand tu veux un espace à part, tu actives un IKO et tu entres dans un IKO. S'il est Public, tu rencontres ceux qui l'activent aussi. S'il est Privé, tu entres dans un IKO où il n'y a que toi.",
  "welcome.step1": "Active un IKO Public et entre dans un IKO avec ceux qui le connaissent aussi.",
  "welcome.step2": "Ici dans IKOGNIT, ajoute un nick comme contact et commence à discuter.",
  "welcome.step3": "Active un IKO Privé et ouvre un IKO rien que pour toi, où tu gardes fichiers, photos, audios, vidéos, mots de passe, notes et lettres.",
  "welcome.multidevice": "Les IKO ne sont jamais stockés nulle part. Si tu oublies un IKO, son IKO cesse d'exister pour toi.",
  "welcome.btnFreq": "Activer IKO",
  "welcome.btnContacts": "Ajouter un contact",
  "push.btnOn": "Notifications ON",
  "push.btnOff": "Notifications OFF",
  "push.btnEnable": "Notifications désactivées. Clique pour activer.",
  "push.btnDisable": "Notifications activées. Clique pour désactiver.",
  "push.introTitle": "Avant d'activer les notifications",
  "push.introBody": "Pour la confidentialité, les notifications IKOGNIT sont différentes de celles des autres apps de messagerie :",
  "push.introBullet1": "Le contenu du message n'est pas inclus.",
  "push.introBullet2": "Le nom et l'IKOGNIT ID de l'expéditeur ne sont pas affichés.",
  "push.introBullet3": "Tu recevras seulement une alerte \"nouveau message\" ; ouvre l'app pour le lire chiffré sur ton appareil.",
  "push.introConfirm": "Activer les notifications",
  "chat.placeholder": "Écris un message…",
  "chat.newMessages": "nouveaux",
  "chat.newMessagesBadge": "Aller à {0} nouveaux messages",
  "chat.mediaRetry": "Réessayer",
  "chat.mediaFailed": "Impossible de charger",
  "chat.media.download": "Télécharger",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Modifie ton message…",
  "chat.replyingTo": "Réponse à {0}",
  "chat.editing": "Modification du message",
  "chat.confirmContact": "Ajouter aux contacts",
  "chat.unconfirmedBanner": "Cet utilisateur t'a écrit mais n'est pas dans tes contacts. Tant que tu ne l'ajoutes pas, ta photo et ton info ne lui seront pas visibles selon tes réglages de confidentialité.",
  "chat.online": "en ligne",
  "chat.lastSeen": "vu pour la dernière fois {0}",
  "chat.tooltip.attach": "Joindre un fichier",
  "chat.tooltip.shareContact": "Partager un contact",
  "chat.tooltip.paste": "Coller une image du presse-papiers",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Appel vocal",
  "chat.tooltip.callVideo": "Appel vidéo",
  "chat.btn.send": "Envoyer",
  "chat.uploading": "…",
  "preview.image": "📷 Image",
  "preview.video": "🎬 Vidéo",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Répondre",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Modifier",
  "bubble.edited": "modifié",
  "bubble.contact.label": "Contact IKOGNIT",
  "bubble.media.decrypting": "Déchiffrement…",
  "bubble.media.failed": "Impossible de déchiffrer le fichier.",
  "call.calling": "Appel…",
  "call.incoming.audio": "Appel entrant",
  "call.incoming.video": "Appel vidéo entrant",
  "call.connecting": "Connexion…",
  "call.ending": "Fin…",
  "call.accept": "Accepter",
  "call.reject": "Refuser",
  "call.hangup": "Raccrocher",
  "call.mic": "Microphone",
  "call.camera": "Caméra",
  "call.audioOut": "Sortie audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Pour appeler tu dois être à l'intérieur d'un IKO.",
  "error.notFound": "Ressource introuvable.",
  "error.notInFreq": "{0} n'est pas encore dans ce IKO. Demande-lui par un autre canal de l'activer.",
  "error.push.iosTooOld": "Ton iOS est antérieur à 16.4. Mets-le à jour pour recevoir des notifications.",
  "error.push.iosNotStandalone": "Pour recevoir des notifications sur iPhone, installe IKOGNIT sur l'écran d'accueil : appuie sur Partager → Ajouter à l'écran d'accueil.",
  "error.expired": "Session expirée. Reconnecte-toi.",
  "error.gone": "Le fichier a expiré.",
  "error.invalid": "Données invalides.",
  "error.server": "Erreur du serveur. Réessaie.",
  "error.network": "Pas de connexion au serveur.",
  "error.cantStartCall": "Impossible de démarrer l'appel : {0}",
  "error.cantAcceptCall": "Impossible d'accepter l'appel : {0}",
  "error.cantPaste": "Impossible d'accéder au presse-papiers. Essaie le bouton de pièce jointe.",
  "error.noImageInClipboard": "Aucune image dans le presse-papiers.",
  "error.clipboardUnsupported": "Ton navigateur n'autorise pas la lecture du presse-papiers. Colle avec Ctrl+V ou utilise le bouton de pièce jointe.",
  "error.selfContact": "Tu ne peux pas t'ajouter toi-même.",
  "error.blocked": "Tu as bloqué cet utilisateur. Débloque-le dans Réglages pour reparler.",
  "settings.title": "Réglages",
  "settings.close": "Fermer",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Confidentialité",
  "settings.tab.messages": "✉ Messages",
  "settings.tab.blocked": "🚫 Bloqués",
  "settings.tab.notifications": "🔔 Notifications",
  "settings.tab.session": "⏱ Session",
  "settings.tab.account": "🆔 Compte",
  "settings.tab.language": "🌐 Langue",
  "settings.tab.about": "ℹ À propos",
  "settings.scope.global": "Global (IKOGNIT)",
  "settings.scope.freq": "Seulement dans {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Ces valeurs sont utilisées par défaut et héritées dans tous les IKO.",
  "settings.profile.hintFreq": "Elles écrasent le profil global quand tu es dans {0}. Si tu ne définis rien ici, ça hérite du global.",
  "settings.profile.displayName": "Nom affiché",
  "settings.profile.displayNamePh.global": "(sans nom — ton nick sera affiché)",
  "settings.profile.displayNamePh.freq": "(hérite du global)",
  "settings.profile.photo": "Photo de profil",
  "settings.profile.changePhoto": "Changer la photo",
  "settings.profile.removePhoto": "Retirer la photo",
  "settings.profile.adjustPhoto": "Ajuste ta photo",
  "settings.profile.info": "Info / Statut",
  "settings.profile.infoPh": "Salut, j'utilise IKOGNIT",
  "settings.profile.removeOverride": "Supprimer l'override de {0}",
  "settings.profile.warn": "Les modifications seront envoyées automatiquement à tes autres contacts lorsque tu interagiras avec eux dans ce IKO.",
  "settings.privacy.title": "Confidentialité",
  "settings.privacy.hintGlobal": "Configure qui peut voir chacune de tes informations par défaut.",
  "settings.privacy.hintFreq": "Écrase ces règles seulement quand tu es dans {0}.",
  "settings.privacy.showPhoto": "Qui voit ma photo",
  "settings.privacy.showInfo": "Qui voit mon info / statut",
  "settings.privacy.showLastSeen": "Qui voit ma dernière connexion",
  "settings.privacy.showOnline": "Qui voit si je suis en ligne",
  "settings.privacy.whoAdds": "Qui peut m'ajouter aux groupes",
  "settings.privacy.readReceipts": "Confirmations de lecture",
  "settings.privacy.readReceiptsHint": "Si désactivé, aucun ticket bleu n'est envoyé quand tu lis les messages. Tu ne verras pas ceux des autres non plus.",
  "settings.vis.all": "Tout le monde",
  "settings.vis.contacts": "Mes contacts",
  "settings.vis.none": "Personne",
  "settings.messages.title": "Messages",
  "settings.messages.ttl": "Expiration par défaut",
  "settings.messages.ttlHint": "Les messages que tu envoies seront supprimés du serveur après ce délai. Tu peux choisir une valeur différente en joignant un fichier.",
  "settings.blocked.title": "Bloqués",
  "settings.blocked.hint": "Les utilisateurs bloqués ne peuvent pas t'envoyer de messages. Tu ne peux pas leur en envoyer non plus.",
  "settings.blocked.placeholder": "IKOGNIT ID à bloquer",
  "settings.blocked.btn": "Bloquer",
  "settings.blocked.unblock": "Débloquer",
  "settings.blocked.empty": "Tu n'as personne de bloqué.",
  "settings.notif.title": "Notifications",
  "settings.notif.sound": "Son",
  "settings.notif.preview": "Afficher l'aperçu du message",
  "settings.notif.vibration": "Vibration (mobile)",
  "settings.notif.hint": "Les notifications push du navigateur ne sont émises que pour les messages dans IKOGNIT général, sans contenu ni nom de l'expéditeur (par conception).",
  "settings.session.title": "Session",
  "settings.session.timeout": "Fermer le IKO après inactivité",
  "settings.session.timeoutHint": "Si tu passes ce temps sans toucher l'app, le IKO actif est désactivé automatiquement et tu reviens à IKOGNIT. \"Jamais\" garde le IKO jusqu'à ce que tu fermes l'app.",
  "settings.session.remember": "Mémoriser les IKO activés",
  "settings.session.rememberHint": "Si activé, les IKO que tu actives apparaissent comme raccourcis dans la barre latérale. Quiconque voit ton écran pourrait savoir dans quels IKO tu es entré, donc c'est désactivé par défaut. En le désactivant, ceux déjà mémorisés sont effacés.",
  "settings.account.title": "Compte",
  "settings.account.email": "Email optionnel (utilisé uniquement pour la récupération, jamais publié)",
  "settings.account.emailPh": "email@exemple.com",
  "settings.account.changePassword": "Changer le mot de passe",
  "settings.account.currentPw": "Mot de passe actuel",
  "settings.account.newPw": "Nouveau mot de passe (min. 8)",
  "settings.account.confirmPw": "Répète le nouveau",
  "settings.account.saving": "Enregistrement…",
  "settings.account.success": "Mot de passe mis à jour.",
  "settings.account.errPwBad": "Le mot de passe actuel n'est pas correct.",
  "settings.account.errPwShort": "Le nouveau mot de passe doit comporter au moins 8 caractères.",
  "settings.account.errPwMismatch": "Les mots de passe ne correspondent pas.",
  "settings.language.title": "Langue",
  "settings.language.hint": "Choisis la langue de l'interface. Ta préférence est enregistrée sur cet appareil.",
  "settings.about.title": "À propos de IKOGNIT",
  "settings.about.version": "Version",
  "settings.about.tech": "Chiffrement E2E avec NaCl box (X25519). IKO : dérivation Argon2id + HMAC déterministe. Persistance locale chiffrée avec Argon2id sur PIN.",
  "modal.freq.title": "Activer les IKO",
  "modal.freq.hint": "Un IKO, ce sont les IKO exactes de l'un de tes IKO. Public : tu rencontres qui écrit les mêmes. Privé : tu atteins un IKO où tu es invisible, même si quelqu'un d'autre écrit les mêmes IKO.",
  "modal.freq.placeholder": "Écris tes IKO",
  "modal.freq.activate": "Activer",
  "modal.freq.deriving": "Calcul des IKO…",
  "modal.freq.warn": "Les IKO ne sont stockées nulle part. Si tu les oublies, cet IKO cesse d'exister pour toi.",
  "modal.freq.errShort": "Le IKO doit avoir au moins 8 caractères.",
  "modal.freq.errCommon": "Ce IKO est trop commun. Choisis quelque chose d'unique.",
  "modal.freq.errRepeat": "N'utilise pas un seul caractère répété.",
  "modal.freq.errSeqNum": "Évite les séquences numériques évidentes.",
  "modal.freq.errSeqAlpha": "Évite les séquences alphabétiques.",
  "billing.title": "Facturation",
  "billing.manage": "Gérer",
  "billing.seats": "Places",
  "billing.renews": "Renouvellement",
  "billing.needsUpgrade": "Vous avez atteint la limite de votre palier. Passez au suivant pour ajouter plus de places.",
  "billing.upgradeTo": "Passer au palier ({price}/place)",
  "billing.portal": "Gérer le paiement",
  "join.loginToAccept": "Se connecter / Créer un compte",
  "private.badge": "PRIVÉ",
  "private.welcome.title": "Ton IKO Privé",
  "private.welcome.intro": "Tu es à des IKO où personne ne peut te voir. Même si une autre personne écrivait le même IKO, elle arriverait à un IKO différent. Ici tu gardes tes affaires en sécurité.",
  "private.welcome.hint": "Choisis une section pour commencer.",
  "private.mod.notes": "Notes",
  "private.mod.notes.desc": "Notes, lettres, journal.",
  "private.mod.files": "Fichiers",
  "private.mod.files.desc": "Documents, feuilles, PDFs.",
  "private.mod.photos": "Photos",
  "private.mod.photos.desc": "Ta galerie privée.",
  "private.mod.videos": "Vidéos",
  "private.mod.videos.desc": "Tes vidéos personnelles.",
  "private.mod.audios": "Audios",
  "private.mod.audios.desc": "Enregistrements et notes vocales.",
  "private.mod.vault": "Mots de passe",
  "private.mod.vault.desc": "Mots de passe, cartes, identités, clés SSH et ce dont tu as besoin.",
  "private.mod.iko": "Mes IKO",
  "private.mod.iko.desc": "Tes IKO enregistrés, prêts à activer.",
  "savediko.intro": "Garde ici les IKO que tu ne veux pas retenir. Tu en retiens un seul et les autres vivent dedans.",
  "savediko.empty": "Tu n'as encore enregistré aucun IKO.",
  "savediko.add": "Enregistrer un IKO",
  "savediko.activate": "Activer le IKO",
  "savediko.formNew": "Enregistrer un IKO",
  "savediko.formEdit": "Modifier le IKO enregistré",
  "savediko.descLabel": "Description",
  "savediko.descPh": "Une description pour le reconnaître plus tard",
  "savediko.ikoLabel": "L'IKO",
  "savediko.ikoPh": "Écris l'IKO",
  "savediko.errDesc": "Saisis une description.",
  "savediko.errIko": "Écris l'IKO.",
  "savediko.confirmDel": "Supprimer ?",
  "vault.new": "Nouvel élément",
  "vault.edit": "Modifier",
  "vault.delete": "Supprimer",
  "vault.save": "Enregistrer",
  "vault.show": "Afficher",
  "vault.hide": "Masquer",
  "vault.copy": "Copier",
  "vault.copied": "Copié ✓",
  "vault.search": "Rechercher…",
  "vault.empty": "Ton dossier est vide. Crée ton premier élément.",
  "vault.noMatches": "Aucun élément ne correspond à la recherche.",
  "vault.untitled": "Sans nom",
  "vault.startHint": "Sélectionne un élément à gauche ou crée-en un nouveau.",
  "vault.confirmDelete": "Supprimer cet élément ? Il ne peut pas être récupéré.",
  "vault.notes": "Notes",
  "vault.sensitive": "Sensible",
  "vault.sensitiveHint": "Les champs sensibles sont masqués par défaut et peuvent être copiés dans le presse-papiers.",
  "vault.removeField": "Supprimer ce champ",
  "vault.addField": "Ajouter un champ",
  "vault.fieldSingular": "champ",
  "vault.fieldPlural": "champs",
  "vault.type.login": "Identifiant",
  "vault.type.card": "Carte",
  "vault.type.identity": "Identité",
  "vault.type.sshkey": "Clé SSH",
  "vault.type.custom": "Personnalisé",
  "vault.field.name": "Nom",
  "vault.field.name.ph": "Comment l'appelles-tu ?",
  "vault.field.labelPh": "Étiquette du champ",
  "vault.field.newField": "Champ",
  "vault.field.username": "Utilisateur",
  "vault.field.password": "Mot de passe",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Titulaire",
  "vault.field.cardBrand": "Marque",
  "vault.field.cardNumber": "Numéro",
  "vault.field.cardExpiry": "Expiration (MM/AA)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Prénom",
  "vault.field.lastname": "Nom",
  "vault.field.dni": "Pièce d'identité",
  "vault.field.address": "Adresse",
  "vault.field.city": "Ville",
  "vault.field.zip": "Code postal",
  "vault.field.country": "Pays",
  "vault.field.phone": "Téléphone",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Date de naissance",
  "vault.field.sshPrivate": "Clé privée",
  "vault.field.sshPublic": "Clé publique",
  "vault.field.sshFingerprint": "Empreinte",
  "vault.field.sshHost": "Hôte",
  "vault.ft.text": "Texte",
  "vault.ft.password": "Mot de passe",
  "vault.ft.textarea": "Texte long",
  "vault.ft.date": "Date",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Nombre",
  "vault.tpl.title": "Modèles",
  "vault.tpl.manage": "Gérer les modèles",
  "vault.tpl.yours": "Tes modèles",
  "vault.tpl.new": "Nouveau modèle",
  "vault.tpl.edit": "Modifier le modèle",
  "vault.tpl.empty": "Tu n'as pas encore de modèles. Crée-en un pour définir ton propre type d'élément.",
  "vault.tpl.name": "Nom du modèle",
  "vault.tpl.name.ph": "Ex. : Portefeuille crypto, Réservation d'hôtel…",
  "vault.tpl.confirmDelete": "Supprimer ce modèle ? Les éléments créés à partir de lui restent.",
  "totp.copyCode": "Copier le code",
  "totp.copySecret": "Copier le secret",
  "totp.showSecret": "Afficher le secret",
  "totp.hideSecret": "Masquer le secret",
  "totp.invalid": "secret invalide",
  "private.module.coming": "Bientôt disponible.",
  "private.module.comingHint": "Ce module sera disponible très bientôt. La crypto de l'IKO Privé fonctionne déjà — bientôt tu pourras y enregistrer ce dont tu as besoin.",
  "notes.new": "Nouvelle note",
  "notes.empty": "Tu n'as pas encore de notes dans cet IKO.",
  "notes.emptyPreview": "(vide)",
  "notes.untitled": "Sans titre",
  "notes.delete": "Supprimer la note",
  "notes.confirmDelete": "Supprimer cette note ? Elle ne peut pas être récupérée.",
  "notes.titlePlaceholder": "Titre",
  "notes.contentPlaceholder": "Écris ce dont tu as besoin de te souvenir…",
  "notes.startHint": "Pas de notes dans cet IKO. Crée la première.",
  "notes.autosaveHint": "Enregistré automatiquement, chiffré, ici seulement.",
  "notes.yesterday": "Hier",
  "passwords.new": "Nouvelle entrée",
  "passwords.empty": "Tu n'as encore rien enregistré dans cet IKO.",
  "passwords.untitled": "Sans nom",
  "passwords.startHint": "Pas de mots de passe dans cet IKO. Crée le premier.",
  "passwords.confirmDelete": "Supprimer cette entrée ? Elle ne peut pas être récupérée.",
  "passwords.save": "Enregistrer",
  "passwords.edit": "Modifier",
  "passwords.delete": "Supprimer",
  "passwords.copy": "Copier",
  "passwords.copied": "Copié ✓",
  "passwords.show": "Afficher",
  "passwords.hide": "Masquer",
  "passwords.field.label": "Nom",
  "passwords.field.label.ph": "Banque, compte, service…",
  "passwords.field.username": "Utilisateur",
  "passwords.field.username.ph": "Email, alias, numéro…",
  "passwords.field.password": "Mot de passe",
  "passwords.field.password.ph": "Le mot de passe que tu veux enregistrer",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notes",
  "passwords.field.notes.ph": "Tout détail utile",
  "media.uploading": "Envoi…",
  "media.uploadFailed": "Impossible d'envoyer le fichier.",
  "media.upload.file": "Envoyer un fichier",
  "media.upload.photo": "Envoyer une photo",
  "media.upload.video": "Envoyer une vidéo",
  "media.upload.audio": "Envoyer un audio",
  "media.empty.file": "Pas encore de fichiers dans cet IKO.",
  "media.empty.photo": "Pas encore de photos dans cet IKO.",
  "media.empty.video": "Pas encore de vidéos dans cet IKO.",
  "media.empty.audio": "Pas encore d'audios dans cet IKO.",
  "media.play": "Lire",
  "media.download": "Télécharger",
  "media.delete": "Supprimer",
  "media.confirmDelete": "Supprimer cet élément ? Il ne peut pas être récupéré.",
  "media.noPreview": "Pas d'aperçu pour ce type de fichier.",
  "modal.share.title": "Partager un contact",
  "modal.share.hint": "Choisis un contact dans la liste ou saisis un IKOGNIT ID manuellement.",
  "modal.share.filter": "Filtrer les contacts…",
  "modal.share.empty": "Pas de contacts dans ce IKO",
  "modal.share.manual": "Ou un IKOGNIT ID manuel",
  "modal.share.btn": "Partager",
  "modal.group.title": "Nouveau groupe",
  "modal.group.hint": "Choisis un nom et sélectionne des membres parmi tes contacts dans ce IKO.",
  "modal.group.namePh": "Nom du groupe",
  "modal.group.selected": "{0} sélectionnés",
  "modal.group.create": "Créer le groupe",
  "modal.remember.title": "Mémoriser cet appareil",
  "modal.remember.hint": "Ta session, contacts, groupes et messages seront enregistrés sur cet appareil, chiffrés avec un PIN que toi seul connais. À la réouverture de l'app, tu saisiras le PIN pour déverrouiller.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Répète le PIN",
  "modal.remember.warn": "Si tu oublies le PIN, les données enregistrées ne pourront pas être récupérées. Tu devras te reconnecter avec ton nom d'utilisateur et ton mot de passe.",
  "modal.remember.errShort": "Le PIN doit avoir au moins 4 caractères.",
  "modal.remember.errMismatch": "Les PIN ne correspondent pas.",
  "stickers.faces": "Visages",
  "stickers.gestures": "Gestes",
  "stickers.hearts": "Cœurs",
  "stickers.symbols": "Symboles",
  "stickers.animals": "Animaux",
  "stickers.food": "Nourriture",
  "ttl.1h": "1 heure",
  "ttl.1d": "1 jour",
  "ttl.1w": "1 semaine",
  "ttl.1m": "1 mois",
  "ttl.6m": "6 mois",
  "ttl.12m": "12 mois",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Jamais",
  "toast.newMessage": "Nouveau message",
  "toast.group": "{0} (groupe)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informations et navigation de l'IKO",
  "ctx.section.universe": "IKO ACTUEL",
  "ctx.universe.personal": "Ton espace personnel",
  "ctx.status.serverBlind": "Serveur aveugle actif",
  "ctx.status.e2e": "Chiffrement de bout en bout",
  "ctx.section.nav": "NAVIGATION",
  "ctx.nav.changeIko": "Changer de IKO",
  "ctx.nav.activateIko": "Activer un IKO",
  "ctx.nav.backToIkognit": "Retour à IKOGNIT",
  "ctx.section.actions": "ACTIONS",
  "ctx.action.newChat": "Nouvelle conversation",
  "ctx.action.newGroup": "Nouveau groupe",
  "ctx.action.contacts": "Mes contacts",
  "ctx.section.conversation": "CONVERSATION",
  "ctx.peer.online": "en ligne",
  "ctx.peer.offline": "hors ligne",
  "ctx.peer.messages": "{0} messages",
  "ctx.peer.message": "{0} message",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "IKO Personnel",
  "ctx.modes.storage": "Lecteur",
  "ctx.liturgy.0": "Le serveur est aveugle.",
  "ctx.liturgy.1": "Toi seul·e lis ici.",
  "ctx.liturgy.2": "Personne ne sait que tu es ici.",
  "ctx.liturgy.3": "Un IKO est un secret que toi seul·e connais.",
  "ctx.liturgy.4": "Ta vie privée est l'architecture.",
  "ccb.universe.changeOrExit": "Changer de IKO ou sortir",
  "ccb.universe.activate": "Activer un IKO",
  "ccb.leave.title": "Quitter le IKO (retour à IKOGNIT)",
  "ccb.leave.aria": "Quitter le IKO",
  "ccb.tag.cipher.title": "Chiffrement symétrique actif",
  "ccb.tag.srv.title": "Le serveur ne peut pas lire le contenu",
  "ccb.tag.unread.title": "Messages non lus",
  "ccb.settings.title": "Paramètres · profil, thèmes, session",
  "ccb.settings.aria": "Paramètres",
  "ccb.identity.title": "Session : @{0}",
  "ccb.clock.title": "Heure locale",
  "ccb.modes.personalPrefix": "PERSONNEL · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "IKO PERSONNEL",
  "holo.modes.general": "TON PSEUDO + CONTACTS",
  "holo.claim.inIko": "Ce IKO reste invisible pour qui ne le connaît pas.",
  "holo.claim.general": "Ton espace personnel sur IKOGNIT. Tu y discutes avec tes contacts.",
  "holo.card.conversations": "Conversations",
  "holo.card.contacts": "Contacts",
  "holo.card.cipher": "Chiffrement",
  "holo.card.server": "Serveur",
  "holo.foot": "Choisis une conversation, active un IKO, ou crée un nouvel espace.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "IKO Personnel",
  "uib.context.coordTitle": "L'IKO",
  "uib.context.general": "IKO général",
  "uib.e2e.title": "Le serveur ne peut pas lire ton contenu — chiffrement E2E avec ta clé",
  "uib.e2e.label": "Serveur aveugle",
  "uib.pseudoTitle": "Ton pseudonyme dans ce IKO",
  "uib.nickTitle": "Ton pseudo",
  "uib.exitTitle": "Revenir à l'IKO général",
  "uib.exitLabel": "Sortir",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Navigation principale",
  "chat.tab.chats": "Discussions",
  "chat.tab.calls": "Appels",
  "chat.tab.contacts": "Contacts",
  "chat.backToIkognit.title": "Retour à IKOGNIT général",
  "chat.delete.title": "Supprimer",
  "chat.delete.aria": "Supprimer",
  "chat.call.title": "Appeler",
  "chat.videoCall.title": "Appel vidéo",
  "chat.videoCall.aria": "Appel vidéo avec {0}",
  "chat.search.clear": "Effacer la recherche",
  "chat.filters.aria": "Filtres de discussions",
  "chat.filter.all": "Toutes",
  "chat.filter.unread": "Non lues",
  "chat.filter.groups": "Groupes",
  "chat.attachPending": "Pièce jointe en attente",
  "chat.remove.title": "Retirer",
  "chat.cancel.title": "Annuler",
  "chat.blocked.text": "Tu as bloqué {0}. Tu ne peux ni lui écrire ni l'appeler.",
  "chat.unblock": "Débloquer",
  "contacts.alias.placeholder": "Un alias pour l'identifier",
  "contacts.notes.placeholder": "Toi seul·e la vois (chiffrée côté serveur).",
  "contacts.search.placeholder": "Rechercher par alias ou IKOGNIT ID",
  "contacts.edit.title": "Modifier l'alias et la note",
  "contacts.edit.aria": "Modifier",
  "contacts.blockBtn": "Bloquer le contact",
  "contacts.unblockBtn": "Débloquer le contact",
  "contacts.confirmBlock.title": "Bloquer le contact",
  "contacts.confirmUnblock.title": "Débloquer le contact",
  "contacts.confirmBlock.body": "Bloquer {0} ? Tu ne recevras plus ses messages ni appels.",
  "contacts.confirmUnblock.body": "Débloquer {0} ? Tu recevras de nouveau ses messages.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Catégories du IKO Personnel",
  "piko.rail.head": "PERSONNEL",
  "piko.cat.all": "Tout",
  "piko.cat.photos": "Photos",
  "piko.cat.videos": "Vidéos",
  "piko.cat.audios": "Audios",
  "piko.cat.files": "Fichiers",
  "piko.cat.notes": "Notes",
  "piko.cat.passwords": "Mots de passe",
  "piko.cat.cards": "Cartes",
  "piko.cat.identities": "Identités",
  "piko.cat.sshkeys": "Clés SSH",
  "piko.cat.custom": "Dossier",
  "piko.cat.agendas": "Répertoires IKO",
  "piko.cat.storage": "Lecteurs et Disques",

  "auth.field.nickPlaceholder": "ex. user123",
  "auth.field.emailPlaceholder": "toi@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Lu {0}",
  "bubble.tick.delivered": "Remis {0}",
  "bubble.tick.sent": "Envoyé",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Vous avez bloqué cet utilisateur.",
  "chat.preview.image": "Image",
  "chat.preview.video": "Vidéo",
  "chat.preview.voice": "Message vocal",
  "chat.preview.audio": "Audio",
  "error.push.denied": "Tu as refusé l'autorisation de notifications.",
  "error.push.noSw": "Ce navigateur ne prend pas en charge les service workers.",
  "error.push.noPush": "Ce navigateur ne prend pas en charge les notifications push.",
  "error.push.noVapid": "Le serveur n'a pas fourni la clé VAPID.",
  "error.push.activateFailed": "Impossible d'activer ({0}).",
  "chat.group.membersWord": "membres",
  "chat.newCall.title": "Nouvel appel",
  "chat.newChat.title": "Nouveau chat",
  "chat.newCall.empty": "Pas encore de contacts. Ajoutes-en un depuis le + dans Chats.",
  "chat.unread.aria": "messages non lus",
  "chat.calls.title": "Appels",
  "chat.calls.empty": "Pas encore d'appels. Lance-en un depuis le chat avec un contact.",
  "chat.calls.callContact": "Appeler un contact",
  "chat.calls.historySoon": "L'historique des appels sera bientôt disponible.",
  "chat.deleteConv.titleOne": "Supprimer la conversation",
  "chat.deleteConv.titleMany": "Supprimer {0} conversations",
  "chat.deleteConv.hint": "« Pour moi » supprime ta copie (tous tes appareils). « Pour tout le monde » demande aussi au contact de la supprimer.",
  "chat.deleteConv.forMe": "Supprimer pour moi",
  "chat.deleteConv.forAll": "Supprimer pour tous",
  "chat.myContacts": "Mes contacts",
  "chat.contacts.noResults": "Aucun résultat.",
  "chat.contacts.empty": "Pas encore de contacts.",
  "chat.contact.badgeBlocked": "bloqué",
  "chat.contact.badgePending": "non confirmé",
  "chat.toast.saved": "Enregistré",
  "chat.toast.videoSaved": "Vidéo enregistrée dans Photos",
  "chat.toast.imageSaved": "Image enregistrée dans Photos",
  "chat.toast.updateTestflight": "Mets à jour TestFlight vers 1.0(10)+ pour Enregistrer.",
  "chat.toast.saveFailed": "Impossible d'enregistrer : {0}",
  "chat.toast.saveError": "Erreur d'enregistrement",
  "iko.banner.exitAria": "Quitter l’IKO et revenir au plan général",
  "iko.liturgy.entering": "Entrée dans IKO",
  "iko.liturgy.returning": "Retour",
  "iko.liturgy.toIkognit": "vers IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "IKO Personnel",
  "manifest.blindServer": "Le serveur est aveugle.",
  "manifest.onlyYouRead": "Ici, toi seul lis.",
  "manifest.noPublicProfiles": "Sans profils publics.",
  "manifest.noAdsNoClouds": "Sans publicité. Sans clouds tiers.",
  "manifest.keyWithYou": "La clé vit avec toi.",
  "manifest.yourIkoYourSpaces": "Tes IKO. Tes espaces.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Fichiers",
  "orb.mod.notes": "Notes",
  "orb.mod.photos": "Photos",
  "orb.mod.vault": "Dossier",
  "orb.mod.audios": "Audios",
  "orb.copy.line1": "Tes IKO.",
  "orb.copy.line2": "Tes espaces.",
  "explorer.filesNotProcessed": "Fichier(s) non traités",
  "demo.edit": "Modifier",
  "common.exit": "Quitter",
  "common.more": "Plus",
  "chat.tab.settings": "Réglages",
  "chat.search.placeholder": "Rechercher un chat",
  "chat.presence.online": "en ligne",
  "chat.action.call": "Appeler",
  "chat.action.videoCall": "Appel vidéo",
  "chat.attach.label": "Joindre",
  "chat.attach.camera": "Caméra",
  "chat.attach.voice": "Voix",
  "chat.attach.file": "Joindre un fichier",
  "chat.composer.placeholder": "Écris un message…",
  "settings.addYourName": "Ajoute ton nom",
  "settings.editProfile": "Modifier le profil",
  "chat.welcome.intro": "Sélectionne un chat pour commencer à parler avec un chiffrement de bout en bout.",

  // Batch2: footer atajos web
  "web.footer.palette": "palette",
  "web.footer.send": "envoyer",
  "web.footer.line": "ligne",
  "mobile.tb.ikoActivate": "Activer IKO",
  "mobile.tb.ikoExit": "Retour à IKOGNIT général",

  "chat.header.blocked": "Bloqué",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Note privée",
  "settings.account.newNickPlaceholder": "nouveau_pseudo",
  "settings.account.newEmailPlaceholder": "nouveau@email.com",


  "common.delete": "Supprimer",








};

const it: Catalog = {
  "auth.verify.notSent": "Non siamo riusciti a inviarti il codice. Il tuo account esiste: premi «Invia di nuovo il codice» tra poco.",
  "lg.rotulo": "Messaggistica con spazi privati",
  "lg.btn.entrar": "Entra",
  "lg.eyebrow": "Messaggistica privata · Itrion Software",
  "lg.h1a": "Le conversazioni di sempre.",
  "lg.h1b": "E un posto che esiste solo quando lo invochi.",
  "lg.lead1": "Parli con la tua famiglia, con i tuoi amici e con il tuo team, come in qualsiasi app. La differenza comincia quando apri un IKO: uno spazio tuo in cui si entra scrivendo un segreto che conoscete solo voi che state dentro.",
  "lg.lead2": "Finché non lo invochi, quello spazio non è sul tuo dispositivo — né sul telefono, né sul tablet, né sul computer. Non è che sia cifrato.",
  "lg.lead2b": "È che non c'è.",
  "lg.pruebalo": "Provalo · scrivi un segreto e guarda cosa succede",
  "lg.panel.plano": "Piano generale",
  "lg.demo.hilos": "Famiglia=Mamma: domenica si cena da noi?=19:04|Marta=ti mando le foto di sabato=17:52|Team=Luis: domani alle nove, allora=Ieri|Javi=ahah non ci credo=Ieri",
  "lg.demo.mundos": "Solo noi due~l'hai messo dove avevamo detto?|sì. l'atto e il passaporto>~Atto della casa.pdf=2,4 MB|Foto private=214|Carta · banca=Dati~~Cose di casa~ti lascio qui il contratto d'affitto>|e la chiave del router, che la perdi sempre~Contratto d'affitto.pdf=1,1 MB|Copia della carta d'identità=2 file|Chiavi di casa=Dati~~I miei appunti~questo non l'ho detto a nessuno>|e non serve dirlo>~Diario=48 note|Foto=1.207|Conti dell'anno=Dati~~Progetto Lisbona~l'offerta viene 180|eccola, senza copie fuori>~Offerta_v4.pdf=860 KB|Contatti=12|Carta aziendale=Dati~~Il pranzo di sabato~non dire ancora niente a Marta|tranquillo, qui non lo sa nessuno>~Prenotazione.pdf=120 KB|Foto dell'anno scorso=63|Lista degli invitati=Dati",
  "lg.invocaLabel": "Invoca il tuo IKO",
  "lg.invocaPlaceholder": "scrivi un segreto qualsiasi",
  "lg.invocaBtn": "Invoca",
  "lg.invocaHint": "Ogni parola porta a uno spazio diverso. Provane un'altra.",
  "lg.estela.vacio": "Scrivi qualunque cosa: qui è una dimostrazione.",
  "lg.estela.primero": "Invocato. Esiste solo finché ci sei dentro.",
  "lg.estela.otro": "Un altro segreto, un altro spazio. Nessuno sa degli altri.",
  "lg.estela.salida": "Se n'è andato. Nessuna traccia sul dispositivo. Prova con un'altra parola.",
  "lg.ikoActivo": "IKO attivo",
  "lg.nadaEnDispositivo": "Niente di tutto questo sta sul dispositivo",
  "lg.salirIko": "Esci dall'IKO",
  "lg.planos.h2a": "Un piano in bella vista.",
  "lg.planos.h2b": "Sotto, quelli che invochi tu.",
  "lg.planos.lead": "Non esiste «l'IKO». Esistono quelli che apri: uno per le cose di casa, uno per il lavoro, uno che conoscete solo in due, uno di cui non hai mai parlato a nessuno. Ogni segreto porta al suo, e nessuno sa degli altri.",
  "lg.planos.unoRotulo": "Il piano generale · uno",
  "lg.planos.unoH3": "Dove parli con tutti",
  "lg.planos.unoP": "Conversazioni, gruppi, chiamate, foto e file, cifrati end-to-end. Quello che ti aspetti da un'app di messaggistica, fatto bene. Le chat di sempre vivono qui e si comportano come sempre.",
  "lg.planos.nRotulo": "Gli IKO · quanti vuoi",
  "lg.planos.nH3": "Dove non arriva nessun altro",
  "lg.planos.nP": "Scrivi un segreto e appare lo spazio che gli corrisponde. Dentro ci stanno conversazioni e le tue cose. Quando esci, se ne va dal dispositivo senza lasciare traccia. Non c'è elenco, non c'è numero e nessuno può scoprire quanti ne hai, né che ne esista uno.",
  "lg.planos.chips": "Le cose di casa|Il lavoro|Quello che sapete solo in due|Il tuo e di nessun altro|Quello aperto una volta e mai più|Quelli che deciderai domani",
  "lg.forense.h2a": "Non è cifrato sul tuo dispositivo.",
  "lg.forense.h2b": "Non è sul tuo dispositivo.",
  "lg.forense.lead": "Le altre app tengono i tuoi messaggi sull'apparecchio e li cifrano. Se qualcuno se lo porta via, la tua privacy dipende da quanto regge quella cifratura. Qui non c'è niente che debba reggere: quello che vive dentro un IKO non si scrive su nessun dispositivo. Si invoca, si usa e se ne va.",
  "lg.forense.multi": "Vale uguale per tutti: telefono, tablet, computer di casa, portatile del lavoro, Windows, Mac o il browser di un posto che non è tuo. Entri dove vuoi e, quando esci, quel posto torna a non sapere niente di te.",
  "lg.forense.caption": "Quello che trova chi esamina uno qualsiasi dei tuoi dispositivi",
  "lg.forense.filas": "Messaggi dei tuoi IKO=0|File e foto dei tuoi IKO=0|Segreti di IKO salvati=0|Database con i tuoi IKO=non esiste|Traccia che un IKO sia stato aperto=nessuna|Quanti IKO hai=indeterminabile",
  "lg.escenas.h2": "Quello che davvero ti preoccupa.",
  "lg.escenas.filas": "«Ho perso il telefono.»=La tua privacy non se n'è andata con lui. Quello che stava dentro un IKO non è mai stato su quell'apparecchio, quindi non c'è niente da recuperare né niente da temere. Lo invochi da qualsiasi altro dispositivo ed è tutto dov'era.~«Mi hanno preso il portatile.»=Vedranno le tue conversazioni normali, le stesse che vedrebbero in qualsiasi app. Del resto non vedranno il contenuto, né il nome, né l'indizio che esista.~«Mi hanno esaminato il computer.»=Un'analisi forense recupera quello che è scritto sul disco, anche cifrato e cancellato. Qui non c'è niente di scritto da recuperare. La risposta non è «non si può decifrare»: è che non c'è niente. E lo stesso vale per il tablet, per il telefono e per il browser che hai usato un pomeriggio.",
  "lg.ciego.h2": "Né noi. Né chi ospita i server.",
  "lg.ciego.p1": "Il server conserva cose che non può leggere. Non ha il tuo segreto, non l'ha mai avuto e non esiste nessuna copia da nessuna parte. Non è che ci rifiutiamo di consegnare quello che sta dentro i tuoi IKO: è che non ce l'abbiamo, e non c'è modo di averlo. Nemmeno l'azienda che ospita le macchine, né chiunque ci mettesse sopra le mani.",
  "lg.ciego.p2": "Questo ha un prezzo ed è giusto dirlo: se perdi il tuo segreto, non c'è nessuno che possa restituirtelo. La stessa ragione per cui nessun altro può entrare è la ragione per cui nemmeno noi possiamo aiutarti a entrare.",
  "lg.guardas": "Foto di famiglia|Gli appunti che non fai vedere|Carte e dati bancari|Password|Documenti|Conversazioni che riguardano solo voi",
  "lg.nombre.esta": "c'è",
  "lg.nombre.noEsta": "non c'è",
  "lg.nombre.h2": "Da lì il nome.",
  "lg.nombre.p": "In swahili, iko vuol dire «c'è» e haiko, «non c'è». Un IKO c'è finché lo invochi. Il resto del tempo — cioè quasi sempre — non c'è: né sui tuoi dispositivi, né sotto gli occhi di nessuno, né come sospetto.",
  "lg.cierre.h2": "Comincia a parlare.",
  "lg.cierre.p": "Si usa come qualsiasi app di messaggistica, sul telefono, sul tablet e sul computer. Gli IKO sono lì il giorno in cui ti servono.",
  "lg.cierre.btnCrear": "Crea un account",
  "lg.cierre.btnEntrar": "Ho già un account",
  "lg.cierre.pago": "IKOGNIT è un prodotto a pagamento. Niente pubblicità, niente profili pubblicitari e nessuna copia nostra di niente: viviamo del fatto che l'app ti valga la pena, non di quello che ci puoi dire dentro.",
  "lg.pie.ciego": "Server cieco",
  "auth.hola": "Ciao di nuovo.",
  "auth.queEs": "Che cos'è IKOGNIT?",
  "common.cancel": "Annulla",
  "common.error.generic": "Non è andata. Riprova.",
  "common.save": "Salva",
  "common.confirm": "Conferma",
  "common.close": "Chiudi",
  "common.add": "Aggiungi",
  "common.back": "Indietro",
  "common.tagline": "Sovranità digitale.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "In swahili, iko vuol dire «c’è». E haiko, «non c’è».",
  "auth.legal.age": "Confermo di avere l'età minima richiesta dalla legge del mio paese per usare IKOGNIT.",
  "auth.legal.accept": "Ho letto e accetto i <a href='https://ikognit.org/legal/it/termini.html' target='_blank' rel='noopener'>Termini</a>, l'<a href='https://ikognit.org/legal/it/privacy.html' target='_blank' rel='noopener'>Informativa sulla Privacy</a> e le <a href='https://ikognit.org/legal/it/regole-comunita.html' target='_blank' rel='noopener'>Regole della Comunità</a>.",
  "recovery.title": "La tua chiave di recupero",
  "recovery.intro": "Queste **24 parole** sono l'unico modo per recuperare il tuo account e la cronologia se dimentichi la password o perdi il dispositivo. **Annotale su carta e conservale in un posto sicuro.** Nessuno in IKOGNIT può recuperarle al posto tuo.",
  "recovery.warn": "**Annotale OFFLINE.** Non farne uno screenshot. Non inviarle via email o messaggi. Chi possiede queste parole controlla l'intero account.",
  "recovery.btn.show": "Mostra parole",
  "recovery.btn.copy": "Copia",
  "recovery.btn.copied": "Copiato · si cancella in {0}s",
  "recovery.btn.cleared": "Appunti puliti",
  "recovery.btn.copyAria": "Copia la frase di recupero negli appunti (verrà cancellata automaticamente)",
  "recovery.btn.download": "Scarica",
  "recovery.btn.downloadAria": "Scarica la frase come file di testo",
  "recovery.btn.back": "Torna a vedere le parole",
  "recovery.btn.continue": "Continua",
  "recovery.btn.done": "Ho finito",
  "recovery.btn.need3": "Scrivi le 3 parole corrette",
  "recovery.verify.intro": "Per confermare di aver salvato la chiave, scrivi queste parole. Non puoi continuare senza indovinarle.",
  "recovery.verify.wordN": "Parola #{0}",
  "recovery.verify.correct": "Corretto",
  "recovery.verify.wrong": "Sbagliato",
  "auth.error.legalRequired": "Devi accettare i termini legali e confermare la tua età per creare un IKOGNIT ID.",
  "settings.legal.title": "Informazioni legali",
  "settings.legal.hub": "Centro Legale",
  "settings.legal.terms": "Termini e Condizioni",
  "settings.legal.privacy": "Informativa sulla Privacy",
  "settings.legal.rules": "Regole della Comunità",
  "settings.legal.report": "Segnalazioni e Moderazione",
  "settings.legal.cookies": "Informativa sui Cookie",
  "settings.legal.minors": "Informativa sui Minori",
  "settings.legal.notice": "Note Legali",
  "settings.tab.legal": "Legale",
  "auth.loading": "Caricamento…",
  "auth.savedSession": "Questo dispositivo riconosce già il suo proprietario.",
  "auth.locked": "È svanito per inattività. Entra di nuovo.",
  "auth.sessionExpired": "La sessione è svanita. Entra di nuovo.",
  "auth.tab.login": "Accedi",
  "auth.tab.register": "Nuovo IKOGNIT ID",
  "auth.subLogin": "Entri nel piano generale: le conversazioni di sempre. I tuoi IKO non si invocano qui — si invocano dentro, quando ti servono.",
  "auth.subRegister": "L'account resta a tuo nome. Il nick è come ti vedono; l'email serve solo per recuperare l'accesso e per gli avvisi.",
  "auth.field.devicePin": "Chiave maestra",
  "auth.field.password": "Chiave maestra",
  "auth.btn.unlock": "Accedi",
  "auth.btn.unlocking": "Accesso…",
  "auth.btn.processing": "Elaborazione…",
  "auth.btn.createIdentity": "Crea IKOGNIT ID",
  "auth.btn.useOther": "Usa un altro IKOGNIT ID",
  "auth.btn.forget": "Dimentica questo dispositivo",
  "auth.btn.backToUnlock": "Indietro",
  "auth.confirmForget": "Questo dispositivo smetterà di riconoscerti: svaniscono l'account salvato e tutto ciò che è in cache. Per rientrare ti servirà la tua password.",
  "auth.confirmForget.warning": "Senza la frase di recupero di 24 parole annotata, non si torna indietro: nessuno può restituirtela.",
  "invite.welcomeSub": "Messaggi e uno spazio tuo: quello che conservi qui resta a tuo nome. Crea il tuo account e sarete collegati.",
  "auth.reset.warnNewIdentity": "Il tuo account resta tuo, ma recuperare via email ti dà una nuova identità: i messaggi precedenti non si potranno più leggere. Se conservi la frase di recupero di 24 parole, usa quella via.",
  "recover.intro": "Scrivi il tuo nick o email e le 24 parole di recupero ricevute quando hai creato l'account. Poi sceglierai una nuova password.",
  "auth.error.badCreds": "IKOGNIT ID o chiave errati.",
  "auth.error.userNotFound": "IKOGNIT ID non trovato.",
  "auth.error.cantConnect": "Impossibile connettersi al server.",
  "auth.error.badPin": "Chiave errata.",
  "auth.footnote": "Chi è proprietario, ne risponde.\nSe perdi la password,\nnon c'è nessuno a cui reclamare.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "IKO attivo: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "IKO Personale: {0}",
  "sidebar.freqPsh": "IKO di Dominio: {0}",
  "sidebar.tune": "Attiva IKO",
  "sidebar.exitFreq": "Torna a IKOGNIT",
  "sidebar.notifications": "Notifiche",
  "sidebar.remember": "Ricorda dispositivo",
  "sidebar.forget": "Dimentica dispositivo",
  "sidebar.addContact": "Aggiungi contatto tramite nick",
  "sidebar.newGroup": "Nuovo gruppo",
  "sidebar.settings": "Impostazioni",
  "sidebar.logout": "Esci",
  "sidebar.tooltip.logout": "Disconnettiti e cancella tutto in locale",
  "sidebar.savedFreq.tooltip": "Attiva {0}",
  "chat.empty": "Seleziona o aggiungi un contatto",
  "welcome.title": "Benvenuto in IKOGNIT",
  "welcome.concept": "In IKOGNIT parli con altri utenti identificato dal tuo nick. Quando vuoi uno spazio a parte, attivi un IKO ed entri in un IKO. Se è Pubblico, incontri chi lo attiva anche. Se è Privato, entri in un IKO in cui sei solo tu.",
  "welcome.step1": "Attiva un IKO Pubblico ed entra in un IKO con chi lo conosce.",
  "welcome.step2": "Qui in IKOGNIT, aggiungi un nick come contatto e inizia a parlare.",
  "welcome.step3": "Attiva un IKO Privato e apri un IKO solo per te, dove conservi file, foto, audio, video, password, note e lettere.",
  "welcome.multidevice": "I IKO non vengono mai memorizzati da nessuna parte. Se dimentichi un IKO, il suo IKO cessa di esistere per te.",
  "welcome.btnFreq": "Attiva IKO",
  "welcome.btnContacts": "Aggiungi contatto",
  "push.btnOn": "Notifiche ON",
  "push.btnOff": "Notifiche OFF",
  "push.btnEnable": "Notifiche disattivate. Clicca per attivare.",
  "push.btnDisable": "Notifiche attive. Clicca per disattivare.",
  "push.introTitle": "Prima di attivare le notifiche",
  "push.introBody": "Per privacy, le notifiche di IKOGNIT sono diverse da quelle di altre app di messaggistica:",
  "push.introBullet1": "Il contenuto del messaggio non è incluso.",
  "push.introBullet2": "Il nome e l'IKOGNIT ID del mittente non vengono mostrati.",
  "push.introBullet3": "Riceverai solo un avviso di \"nuovo messaggio\"; apri l'app per leggerlo cifrato sul tuo dispositivo.",
  "push.introConfirm": "Attiva notifiche",
  "chat.placeholder": "Scrivi un messaggio…",
  "chat.newMessages": "nuovi",
  "chat.newMessagesBadge": "Vai a {0} nuovi messaggi",
  "chat.mediaRetry": "Riprova",
  "chat.mediaFailed": "Caricamento fallito",
  "chat.media.download": "Scarica",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Modifica il tuo messaggio…",
  "chat.replyingTo": "Risposta a {0}",
  "chat.editing": "Modifica messaggio",
  "chat.confirmContact": "Aggiungi ai contatti",
  "chat.unconfirmedBanner": "Questo utente ti ha scritto ma non è nei tuoi contatti. Finché non lo aggiungi, la tua foto e info non gli saranno visibili secondo le tue impostazioni di privacy.",
  "chat.online": "online",
  "chat.lastSeen": "ultimo accesso {0}",
  "chat.tooltip.attach": "Allega file",
  "chat.tooltip.shareContact": "Condividi contatto",
  "chat.tooltip.paste": "Incolla immagine dagli appunti",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Chiamata vocale",
  "chat.tooltip.callVideo": "Videochiamata",
  "chat.btn.send": "Invia",
  "chat.uploading": "…",
  "preview.image": "📷 Immagine",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Rispondi",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Modifica",
  "bubble.edited": "modificato",
  "bubble.contact.label": "Contatto IKOGNIT",
  "bubble.media.decrypting": "Decifratura…",
  "bubble.media.failed": "Impossibile decifrare il file.",
  "call.calling": "Chiamata in corso…",
  "call.incoming.audio": "Chiamata in arrivo",
  "call.incoming.video": "Videochiamata in arrivo",
  "call.connecting": "Connessione…",
  "call.ending": "Termine…",
  "call.accept": "Accetta",
  "call.reject": "Rifiuta",
  "call.hangup": "Riaggancia",
  "call.mic": "Microfono",
  "call.camera": "Fotocamera",
  "call.audioOut": "Uscita audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Per chiamare devi essere dentro un IKO.",
  "error.notFound": "Risorsa non trovata.",
  "error.notInFreq": "{0} non è ancora in questo IKO. Chiedigli per un altro canale di attivarlo.",
  "error.push.iosTooOld": "Il tuo iOS è precedente a 16.4. Aggiornalo per ricevere notifiche.",
  "error.push.iosNotStandalone": "Per ricevere notifiche su iPhone, installa IKOGNIT nella schermata Home: tocca Condividi → Aggiungi a Home.",
  "error.expired": "Sessione scaduta. Accedi di nuovo.",
  "error.gone": "Il file è scaduto.",
  "error.invalid": "Dati non validi.",
  "error.server": "Errore del server. Riprova.",
  "error.network": "Nessuna connessione al server.",
  "error.cantStartCall": "Impossibile avviare la chiamata: {0}",
  "error.cantAcceptCall": "Impossibile accettare la chiamata: {0}",
  "error.cantPaste": "Impossibile accedere agli appunti. Prova il pulsante di allegato.",
  "error.noImageInClipboard": "Non c'è nessuna immagine negli appunti.",
  "error.clipboardUnsupported": "Il tuo browser non consente di leggere gli appunti. Incolla con Ctrl+V o usa il pulsante di allegato.",
  "error.selfContact": "Non puoi aggiungere te stesso.",
  "error.blocked": "Hai bloccato questo utente. Sbloccalo in Impostazioni per riprendere la conversazione.",
  "settings.title": "Impostazioni",
  "settings.close": "Chiudi",
  "settings.tab.profile": "👤 Profilo",
  "settings.tab.privacy": "🔒 Privacy",
  "settings.tab.messages": "✉ Messaggi",
  "settings.tab.blocked": "🚫 Bloccati",
  "settings.tab.notifications": "🔔 Notifiche",
  "settings.tab.session": "⏱ Sessione",
  "settings.tab.account": "🆔 Account",
  "settings.tab.language": "🌐 Lingua",
  "settings.tab.about": "ℹ Informazioni",
  "settings.scope.global": "Globale (IKOGNIT)",
  "settings.scope.freq": "Solo in {0}",
  "settings.profile.title": "Profilo",
  "settings.profile.hintGlobal": "Questi valori sono usati di default ed ereditati in tutti i IKO.",
  "settings.profile.hintFreq": "Sovrascrivono il profilo globale quando sei in {0}. Se non definisci nulla qui, viene ereditato dal globale.",
  "settings.profile.displayName": "Nome mostrato",
  "settings.profile.displayNamePh.global": "(senza nome — verrà mostrato il tuo nick)",
  "settings.profile.displayNamePh.freq": "(eredita dal globale)",
  "settings.profile.photo": "Foto profilo",
  "settings.profile.changePhoto": "Cambia foto",
  "settings.profile.removePhoto": "Rimuovi foto",
  "settings.profile.adjustPhoto": "Regola la tua foto",
  "settings.profile.info": "Info / Stato",
  "settings.profile.infoPh": "Ciao, uso IKOGNIT",
  "settings.profile.removeOverride": "Rimuovi override di {0}",
  "settings.profile.warn": "Le modifiche verranno inviate automaticamente al resto dei tuoi contatti quando interagirai con loro in questo IKO.",
  "settings.privacy.title": "Privacy",
  "settings.privacy.hintGlobal": "Configura chi può vedere ciascuna tua informazione di default.",
  "settings.privacy.hintFreq": "Sovrascrivi queste regole solo quando sei in {0}.",
  "settings.privacy.showPhoto": "Chi vede la mia foto",
  "settings.privacy.showInfo": "Chi vede la mia info / stato",
  "settings.privacy.showLastSeen": "Chi vede il mio ultimo accesso",
  "settings.privacy.showOnline": "Chi vede se sono online",
  "settings.privacy.whoAdds": "Chi può aggiungermi ai gruppi",
  "settings.privacy.readReceipts": "Conferme di lettura",
  "settings.privacy.readReceiptsHint": "Se disattivato, non vengono inviati tick blu quando leggi i messaggi. Non vedrai nemmeno quelli degli altri.",
  "settings.vis.all": "Tutti",
  "settings.vis.contacts": "I miei contatti",
  "settings.vis.none": "Nessuno",
  "settings.messages.title": "Messaggi",
  "settings.messages.ttl": "Scadenza di default",
  "settings.messages.ttlHint": "I messaggi che invii verranno eliminati dal server dopo questo tempo. Puoi scegliere un valore diverso quando alleghi un file.",
  "settings.blocked.title": "Bloccati",
  "settings.blocked.hint": "Gli utenti bloccati non possono inviarti messaggi. Nemmeno tu puoi inviarne.",
  "settings.blocked.placeholder": "IKOGNIT ID da bloccare",
  "settings.blocked.btn": "Blocca",
  "settings.blocked.unblock": "Sblocca",
  "settings.blocked.empty": "Non hai nessuno bloccato.",
  "settings.notif.title": "Notifiche",
  "settings.notif.sound": "Suono",
  "settings.notif.preview": "Mostra anteprima del messaggio",
  "settings.notif.vibration": "Vibrazione (mobile)",
  "settings.notif.hint": "Le notifiche push del browser vengono emesse solo per i messaggi in IKOGNIT generale, senza contenuto né nome del mittente (per design).",
  "settings.session.title": "Sessione",
  "settings.session.timeout": "Chiudi il IKO dopo inattività",
  "settings.session.timeoutHint": "Se passi questo tempo senza toccare l'app, il IKO attivo viene disattivato automaticamente e torni a IKOGNIT. \"Mai\" mantiene il IKO fino alla chiusura dell'app.",
  "settings.session.remember": "Ricorda IKO attivati",
  "settings.session.rememberHint": "Se attivato, i IKO che attivi appaiono come scorciatoie nella barra laterale. Chi vede il tuo schermo potrebbe sapere in quali IKO sei entrato, quindi è disattivato di default. Disattivandolo si cancellano quelli già salvati.",
  "settings.account.title": "Account",
  "settings.account.email": "Email opzionale (solo per recupero, mai pubblicata)",
  "settings.account.emailPh": "email@esempio.com",
  "settings.account.changePassword": "Cambia password",
  "settings.account.currentPw": "Password attuale",
  "settings.account.newPw": "Nuova password (min. 8)",
  "settings.account.confirmPw": "Ripeti la nuova",
  "settings.account.saving": "Salvataggio…",
  "settings.account.success": "Password aggiornata.",
  "settings.account.errPwBad": "La password attuale non è corretta.",
  "settings.account.errPwShort": "La nuova password deve avere almeno 8 caratteri.",
  "settings.account.errPwMismatch": "Le password non corrispondono.",
  "settings.language.title": "Lingua",
  "settings.language.hint": "Scegli la lingua dell'interfaccia. La tua preferenza viene salvata su questo dispositivo.",
  "settings.about.title": "Informazioni su IKOGNIT",
  "settings.about.version": "Versione",
  "settings.about.tech": "Cifratura E2E con NaCl box (X25519). IKO: derivazione Argon2id + HMAC deterministico. Persistenza locale cifrata con Argon2id sul PIN.",
  "modal.freq.title": "Attiva IKO",
  "modal.freq.hint": "Un IKO sono le IKO esatte di uno dei tuoi IKO. Pubblico: incontri chi scrive le stesse. Privato: raggiungi un IKO dove sei invisibile, anche se un altro scrive le stesse IKO.",
  "modal.freq.placeholder": "Scrivi le tue IKO",
  "modal.freq.activate": "Attiva",
  "modal.freq.deriving": "Calcolo IKO…",
  "modal.freq.warn": "Le IKO non vengono memorizzate da nessuna parte. Se le dimentichi, quell'IKO cessa di esistere per te.",
  "modal.freq.errShort": "Il IKO deve avere almeno 8 caratteri.",
  "modal.freq.errCommon": "Questo IKO è troppo comune. Scegli qualcosa di unico.",
  "modal.freq.errRepeat": "Non usare un singolo carattere ripetuto.",
  "modal.freq.errSeqNum": "Evita sequenze numeriche ovvie.",
  "modal.freq.errSeqAlpha": "Evita sequenze alfabetiche.",
  "billing.title": "Fatturazione",
  "billing.manage": "Gestisci",
  "billing.seats": "Posti",
  "billing.renews": "Rinnovo",
  "billing.needsUpgrade": "Hai raggiunto il limite della tua fascia. Passa a una superiore per aggiungere altri posti.",
  "billing.upgradeTo": "Passa alla fascia ({price}/posto)",
  "billing.portal": "Gestisci pagamento",
  "join.loginToAccept": "Accedi / Crea account",
  "private.badge": "PRIVATO",
  "private.welcome.title": "Il tuo IKO Privato",
  "private.welcome.intro": "Sei a delle IKO dove nessuno può vederti. Anche se un'altra persona scrivesse lo stesso IKO, arriverebbe a un IKO diverso. Qui custodisci ciò che è tuo al sicuro.",
  "private.welcome.hint": "Scegli una sezione per iniziare.",
  "private.mod.notes": "Note",
  "private.mod.notes.desc": "Note, lettere, diario.",
  "private.mod.files": "File",
  "private.mod.files.desc": "Documenti, fogli, PDF.",
  "private.mod.photos": "Foto",
  "private.mod.photos.desc": "La tua galleria privata.",
  "private.mod.videos": "Video",
  "private.mod.videos.desc": "I tuoi video personali.",
  "private.mod.audios": "Audio",
  "private.mod.audios.desc": "Registrazioni e note vocali.",
  "private.mod.vault": "Password",
  "private.mod.vault.desc": "Password, carte, identità, chiavi SSH e quello che ti serve.",
  "private.mod.iko": "I miei IKO",
  "private.mod.iko.desc": "I tuoi IKO salvati, pronti da attivare.",
  "savediko.intro": "Conserva qui gli IKO che non vuoi memorizzare. Ne ricordi uno solo e gli altri vivono dentro.",
  "savediko.empty": "Non hai ancora salvato nessun IKO.",
  "savediko.add": "Salva un IKO",
  "savediko.activate": "Attiva IKO",
  "savediko.formNew": "Salva un IKO",
  "savediko.formEdit": "Modifica IKO salvato",
  "savediko.descLabel": "Descrizione",
  "savediko.descPh": "Una descrizione per riconoscerlo in seguito",
  "savediko.ikoLabel": "L'IKO",
  "savediko.ikoPh": "Scrivi l'IKO",
  "savediko.errDesc": "Scrivi una descrizione.",
  "savediko.errIko": "Scrivi l'IKO.",
  "savediko.confirmDel": "Eliminare?",
  "vault.new": "Nuovo elemento",
  "vault.edit": "Modifica",
  "vault.delete": "Elimina",
  "vault.save": "Salva",
  "vault.show": "Mostra",
  "vault.hide": "Nascondi",
  "vault.copy": "Copia",
  "vault.copied": "Copiato ✓",
  "vault.search": "Cerca…",
  "vault.empty": "La tua cartella è vuota. Crea il tuo primo elemento.",
  "vault.noMatches": "Nessun elemento corrisponde alla ricerca.",
  "vault.untitled": "Senza nome",
  "vault.startHint": "Seleziona un elemento a sinistra o creane uno nuovo.",
  "vault.confirmDelete": "Eliminare questo elemento? Non è recuperabile.",
  "vault.notes": "Note",
  "vault.sensitive": "Sensibile",
  "vault.sensitiveHint": "I campi sensibili sono nascosti di default e possono essere copiati negli appunti.",
  "vault.removeField": "Rimuovi questo campo",
  "vault.addField": "Aggiungi campo",
  "vault.fieldSingular": "campo",
  "vault.fieldPlural": "campi",
  "vault.type.login": "Login",
  "vault.type.card": "Carta",
  "vault.type.identity": "Identità",
  "vault.type.sshkey": "Chiave SSH",
  "vault.type.custom": "Personalizzato",
  "vault.field.name": "Nome",
  "vault.field.name.ph": "Come lo chiami?",
  "vault.field.labelPh": "Etichetta del campo",
  "vault.field.newField": "Campo",
  "vault.field.username": "Utente",
  "vault.field.password": "Password",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Intestatario",
  "vault.field.cardBrand": "Marca",
  "vault.field.cardNumber": "Numero",
  "vault.field.cardExpiry": "Scadenza (MM/AA)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Nome",
  "vault.field.lastname": "Cognome",
  "vault.field.dni": "Documento",
  "vault.field.address": "Indirizzo",
  "vault.field.city": "Città",
  "vault.field.zip": "CAP",
  "vault.field.country": "Paese",
  "vault.field.phone": "Telefono",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Data di nascita",
  "vault.field.sshPrivate": "Chiave privata",
  "vault.field.sshPublic": "Chiave pubblica",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Testo",
  "vault.ft.password": "Password",
  "vault.ft.textarea": "Testo lungo",
  "vault.ft.date": "Data",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Numero",
  "vault.tpl.title": "Modelli",
  "vault.tpl.manage": "Gestisci modelli",
  "vault.tpl.yours": "I tuoi modelli",
  "vault.tpl.new": "Nuovo modello",
  "vault.tpl.edit": "Modifica modello",
  "vault.tpl.empty": "Non hai ancora modelli. Creane uno per definire il tuo tipo di elemento.",
  "vault.tpl.name": "Nome del modello",
  "vault.tpl.name.ph": "Es.: Wallet crypto, Prenotazione hotel…",
  "vault.tpl.confirmDelete": "Eliminare questo modello? Gli elementi creati da esso rimangono.",
  "totp.copyCode": "Copia codice",
  "totp.copySecret": "Copia secret",
  "totp.showSecret": "Mostra secret",
  "totp.hideSecret": "Nascondi secret",
  "totp.invalid": "secret non valido",
  "private.module.coming": "Prossimamente.",
  "private.module.comingHint": "Questo modulo sarà disponibile molto presto. La crittografia dell'IKO Privato funziona già — presto potrai conservare qui ciò che ti serve.",
  "notes.new": "Nuova nota",
  "notes.empty": "Non hai ancora note in questo IKO.",
  "notes.emptyPreview": "(vuota)",
  "notes.untitled": "Senza titolo",
  "notes.delete": "Elimina nota",
  "notes.confirmDelete": "Eliminare questa nota? Non è recuperabile.",
  "notes.titlePlaceholder": "Titolo",
  "notes.contentPlaceholder": "Scrivi ciò che ti serve ricordare…",
  "notes.startHint": "Nessuna nota in questo IKO. Crea la prima.",
  "notes.autosaveHint": "Salvata automaticamente, cifrata, solo qui.",
  "notes.yesterday": "Ieri",
  "passwords.new": "Nuova voce",
  "passwords.empty": "Non hai ancora salvato nessuna voce in questo IKO.",
  "passwords.untitled": "Senza nome",
  "passwords.startHint": "Nessuna password in questo IKO. Crea la prima.",
  "passwords.confirmDelete": "Eliminare questa voce? Non è recuperabile.",
  "passwords.save": "Salva",
  "passwords.edit": "Modifica",
  "passwords.delete": "Elimina",
  "passwords.copy": "Copia",
  "passwords.copied": "Copiato ✓",
  "passwords.show": "Mostra",
  "passwords.hide": "Nascondi",
  "passwords.field.label": "Nome",
  "passwords.field.label.ph": "Banca, account, servizio…",
  "passwords.field.username": "Utente",
  "passwords.field.username.ph": "Email, alias, numero…",
  "passwords.field.password": "Password",
  "passwords.field.password.ph": "La password che vuoi salvare",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Note",
  "passwords.field.notes.ph": "Qualsiasi dettaglio utile",
  "media.uploading": "Caricamento…",
  "media.uploadFailed": "Impossibile caricare il file.",
  "media.upload.file": "Carica file",
  "media.upload.photo": "Carica foto",
  "media.upload.video": "Carica video",
  "media.upload.audio": "Carica audio",
  "media.empty.file": "Nessun file in questo IKO.",
  "media.empty.photo": "Nessuna foto in questo IKO.",
  "media.empty.video": "Nessun video in questo IKO.",
  "media.empty.audio": "Nessun audio in questo IKO.",
  "media.play": "Riproduci",
  "media.download": "Scarica",
  "media.delete": "Elimina",
  "media.confirmDelete": "Eliminare questo elemento? Non è recuperabile.",
  "media.noPreview": "Nessuna anteprima per questo tipo di file.",
  "modal.share.title": "Condividi contatto",
  "modal.share.hint": "Scegli un contatto dalla lista o inserisci un IKOGNIT ID manualmente.",
  "modal.share.filter": "Filtra contatti…",
  "modal.share.empty": "Nessun contatto in questo IKO",
  "modal.share.manual": "O un IKOGNIT ID manuale",
  "modal.share.btn": "Condividi",
  "modal.group.title": "Nuovo gruppo",
  "modal.group.hint": "Scegli un nome e seleziona membri tra i tuoi contatti in questo IKO.",
  "modal.group.namePh": "Nome del gruppo",
  "modal.group.selected": "{0} selezionati",
  "modal.group.create": "Crea gruppo",
  "modal.remember.title": "Ricorda questo dispositivo",
  "modal.remember.hint": "La tua sessione, contatti, gruppi e messaggi verranno salvati su questo dispositivo, cifrati con un PIN che solo tu conosci. Riaprendo l'app inserirai il PIN per sbloccare.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Ripeti PIN",
  "modal.remember.warn": "Se dimentichi il PIN, i dati salvati non saranno recuperabili. Dovrai accedere di nuovo con utente e password.",
  "modal.remember.errShort": "Il PIN deve avere almeno 4 caratteri.",
  "modal.remember.errMismatch": "I PIN non corrispondono.",
  "stickers.faces": "Volti",
  "stickers.gestures": "Gesti",
  "stickers.hearts": "Cuori",
  "stickers.symbols": "Simboli",
  "stickers.animals": "Animali",
  "stickers.food": "Cibo",
  "ttl.1h": "1 ora",
  "ttl.1d": "1 giorno",
  "ttl.1w": "1 settimana",
  "ttl.1m": "1 mese",
  "ttl.6m": "6 mesi",
  "ttl.12m": "12 mesi",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Mai",
  "toast.newMessage": "Nuovo messaggio",
  "toast.group": "{0} (gruppo)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informazioni e navigazione dell'IKO",
  "ctx.section.universe": "IKO ATTUALE",
  "ctx.universe.personal": "Il tuo spazio personale",
  "ctx.status.serverBlind": "Server cieco attivo",
  "ctx.status.e2e": "Cifratura end-to-end",
  "ctx.section.nav": "NAVIGAZIONE",
  "ctx.nav.changeIko": "Cambia IKO",
  "ctx.nav.activateIko": "Attiva un IKO",
  "ctx.nav.backToIkognit": "Torna a IKOGNIT",
  "ctx.section.actions": "AZIONI",
  "ctx.action.newChat": "Nuova chat",
  "ctx.action.newGroup": "Nuovo gruppo",
  "ctx.action.contacts": "I miei contatti",
  "ctx.section.conversation": "CONVERSAZIONE",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} messaggi",
  "ctx.peer.message": "{0} messaggio",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "IKO Personale",
  "ctx.modes.storage": "Unità",
  "ctx.liturgy.0": "Il server è cieco.",
  "ctx.liturgy.1": "Qui leggi solo tu.",
  "ctx.liturgy.2": "Nessuno sa che sei qui.",
  "ctx.liturgy.3": "Un IKO è un segreto che solo tu conosci.",
  "ctx.liturgy.4": "La tua privacy è l'architettura.",
  "ccb.universe.changeOrExit": "Cambia IKO o esci",
  "ccb.universe.activate": "Attiva IKO",
  "ccb.leave.title": "Esci dal IKO (torna a IKOGNIT)",
  "ccb.leave.aria": "Esci dal IKO",
  "ccb.tag.cipher.title": "Cifratura simmetrica attiva",
  "ccb.tag.srv.title": "Il server non può leggere il contenuto",
  "ccb.tag.unread.title": "Messaggi non letti",
  "ccb.settings.title": "Impostazioni · profilo, temi, sessione",
  "ccb.settings.aria": "Impostazioni",
  "ccb.identity.title": "Sessione: @{0}",
  "ccb.clock.title": "Ora locale",
  "ccb.modes.personalPrefix": "PERSONALE · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "IKO PERSONALE",
  "holo.modes.general": "IL TUO NICK + CONTATTI",
  "holo.claim.inIko": "Questo IKO resta invisibile a chi non lo conosce.",
  "holo.claim.general": "Il tuo spazio personale in IKOGNIT. Qui parli con i tuoi contatti.",
  "holo.card.conversations": "Conversazioni",
  "holo.card.contacts": "Contatti",
  "holo.card.cipher": "Cifratura",
  "holo.card.server": "Server",
  "holo.foot": "Scegli una conversazione, attiva un IKO, o crea un nuovo spazio.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "IKO Personale",
  "uib.context.coordTitle": "L'IKO",
  "uib.context.general": "IKO generale",
  "uib.e2e.title": "Il server non può leggere il tuo contenuto — cifratura E2E con la tua chiave",
  "uib.e2e.label": "Server cieco",
  "uib.pseudoTitle": "Il tuo pseudonimo in questo IKO",
  "uib.nickTitle": "Il tuo nick",
  "uib.exitTitle": "Torna all'IKO generale",
  "uib.exitLabel": "Esci",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Navigazione principale",
  "chat.tab.chats": "Chat",
  "chat.tab.calls": "Chiamate",
  "chat.tab.contacts": "Contatti",
  "chat.backToIkognit.title": "Torna a IKOGNIT generale",
  "chat.delete.title": "Elimina",
  "chat.delete.aria": "Elimina",
  "chat.call.title": "Chiama",
  "chat.videoCall.title": "Videochiamata",
  "chat.videoCall.aria": "Videochiamata con {0}",
  "chat.search.clear": "Cancella ricerca",
  "chat.filters.aria": "Filtri delle chat",
  "chat.filter.all": "Tutte",
  "chat.filter.unread": "Non lette",
  "chat.filter.groups": "Gruppi",
  "chat.attachPending": "Allegato in attesa",
  "chat.remove.title": "Rimuovi",
  "chat.cancel.title": "Annulla",
  "chat.blocked.text": "Hai bloccato {0}. Non puoi inviargli messaggi né chiamarlo.",
  "chat.unblock": "Sblocca",
  "contacts.alias.placeholder": "Un alias per riconoscerlo",
  "contacts.notes.placeholder": "La vedi solo tu (cifrata sul server).",
  "contacts.search.placeholder": "Cerca per alias o IKOGNIT ID",
  "contacts.edit.title": "Modifica alias e nota",
  "contacts.edit.aria": "Modifica",
  "contacts.blockBtn": "Blocca contatto",
  "contacts.unblockBtn": "Sblocca contatto",
  "contacts.confirmBlock.title": "Blocca contatto",
  "contacts.confirmUnblock.title": "Sblocca contatto",
  "contacts.confirmBlock.body": "Bloccare {0}? Non riceverai più i suoi messaggi né chiamate.",
  "contacts.confirmUnblock.body": "Sbloccare {0}? Riceverai di nuovo i suoi messaggi.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Categorie del IKO Personale",
  "piko.rail.head": "PERSONALE",
  "piko.cat.all": "Tutto",
  "piko.cat.photos": "Foto",
  "piko.cat.videos": "Video",
  "piko.cat.audios": "Audio",
  "piko.cat.files": "File",
  "piko.cat.notes": "Note",
  "piko.cat.passwords": "Password",
  "piko.cat.cards": "Carte",
  "piko.cat.identities": "Identità",
  "piko.cat.sshkeys": "Chiavi SSH",
  "piko.cat.custom": "Cassaforti",
  "piko.cat.agendas": "Rubriche IKO",
  "piko.cat.storage": "Unità e Dischi",

  "auth.field.nickPlaceholder": "es. user123",
  "auth.field.emailPlaceholder": "tu@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Letto {0}",
  "bubble.tick.delivered": "Consegnato {0}",
  "bubble.tick.sent": "Inviato",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Hai bloccato questo utente.",
  "chat.preview.image": "Immagine",
  "chat.preview.video": "Video",
  "chat.preview.voice": "Messaggio vocale",
  "chat.preview.audio": "Audio",
  "error.push.denied": "Hai negato il permesso per le notifiche.",
  "error.push.noSw": "Questo browser non supporta i service worker.",
  "error.push.noPush": "Questo browser non supporta le notifiche push.",
  "error.push.noVapid": "Il server non ha fornito la chiave VAPID.",
  "error.push.activateFailed": "Impossibile attivare ({0}).",
  "chat.group.membersWord": "membri",
  "chat.newCall.title": "Nuova chiamata",
  "chat.newChat.title": "Nuova chat",
  "chat.newCall.empty": "Nessun contatto ancora. Aggiungine uno dal + in Chat.",
  "chat.unread.aria": "messaggi non letti",
  "chat.calls.title": "Chiamate",
  "chat.calls.empty": "Nessuna chiamata ancora. Iniziane una dalla chat con un contatto.",
  "chat.calls.callContact": "Chiamare un contatto",
  "chat.calls.historySoon": "La cronologia delle chiamate sarà presto disponibile.",
  "chat.deleteConv.titleOne": "Elimina conversazione",
  "chat.deleteConv.titleMany": "Elimina {0} conversazioni",
  "chat.deleteConv.hint": "\"Per me\" cancella la tua copia (su tutti i tuoi dispositivi). \"Per tutti\" chiede anche al contatto di cancellarla.",
  "chat.deleteConv.forMe": "Elimina per me",
  "chat.deleteConv.forAll": "Elimina per tutti",
  "chat.myContacts": "I miei contatti",
  "chat.contacts.noResults": "Nessun risultato.",
  "chat.contacts.empty": "Nessun contatto ancora.",
  "chat.contact.badgeBlocked": "bloccato",
  "chat.contact.badgePending": "non confermato",
  "chat.toast.saved": "Salvato",
  "chat.toast.videoSaved": "Video salvato in Foto",
  "chat.toast.imageSaved": "Immagine salvata in Foto",
  "chat.toast.updateTestflight": "Aggiorna TestFlight a 1.0(10)+ per Salvare.",
  "chat.toast.saveFailed": "Impossibile salvare: {0}",
  "chat.toast.saveError": "Errore di salvataggio",
  "iko.banner.exitAria": "Uscire dall’IKO e tornare al piano generale",
  "iko.liturgy.entering": "Ingresso in IKO",
  "iko.liturgy.returning": "Ritorno",
  "iko.liturgy.toIkognit": "a IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "IKO Personale",
  "manifest.blindServer": "Il server è cieco.",
  "manifest.onlyYouRead": "Qui solo tu leggi.",
  "manifest.noPublicProfiles": "Nessun profilo pubblico.",
  "manifest.noAdsNoClouds": "Senza pubblicità. Senza cloud altrui.",
  "manifest.keyWithYou": "La chiave vive con te.",
  "manifest.yourIkoYourSpaces": "I tuoi IKO. I tuoi spazi.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "File",
  "orb.mod.notes": "Note",
  "orb.mod.photos": "Foto",
  "orb.mod.vault": "Cartella",
  "orb.mod.audios": "Audio",
  "orb.copy.line1": "I tuoi IKO.",
  "orb.copy.line2": "I tuoi spazi.",
  "explorer.filesNotProcessed": "File non elaborati",
  "demo.edit": "Modifica",
  "common.exit": "Esci",
  "common.more": "Altro",
  "chat.tab.settings": "Impostazioni",
  "chat.search.placeholder": "Cerca chat",
  "chat.presence.online": "in linea",
  "chat.action.call": "Chiama",
  "chat.action.videoCall": "Videochiamata",
  "chat.attach.label": "Allega",
  "chat.attach.camera": "Fotocamera",
  "chat.attach.voice": "Voce",
  "chat.attach.file": "Allega file",
  "chat.composer.placeholder": "Scrivi un messaggio...",
  "settings.addYourName": "Aggiungi il tuo nome",
  "settings.editProfile": "Modifica profilo",
  "chat.welcome.intro": "Seleziona una chat per iniziare a parlare con crittografia end-to-end.",

  // Batch2: footer atajos web
  "web.footer.palette": "tavolozza",
  "web.footer.send": "invia",
  "web.footer.line": "riga",
  "mobile.tb.ikoActivate": "Attiva IKO",
  "mobile.tb.ikoExit": "Torna a IKOGNIT generale",

  "chat.header.blocked": "Bloccato",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Nota privata",
  "settings.account.newNickPlaceholder": "nuovo_nick",
  "settings.account.newEmailPlaceholder": "nuovo@email.com",


  "common.delete": "Elimina",








};

const de: Catalog = {
  "auth.verify.notSent": "Wir konnten dir den Code nicht senden. Dein Konto existiert: drücke gleich auf „Code erneut senden“.",
  "lg.rotulo": "Messenger mit privaten Räumen",
  "lg.btn.entrar": "Anmelden",
  "lg.eyebrow": "Privater Messenger · Itrion Software",
  "lg.h1a": "Deine Gespräche wie immer.",
  "lg.h1b": "Und ein Ort, den es nur gibt, wenn du ihn rufst.",
  "lg.lead1": "Du sprichst mit deiner Familie, deinen Freunden und deinem Team, wie in jeder App. Der Unterschied beginnt, wenn du ein IKO öffnest: ein eigener Raum, den man betritt, indem man ein Geheimnis schreibt, das nur die Anwesenden kennen.",
  "lg.lead2": "Solange du es nicht rufst, ist dieser Raum nicht auf deinem Gerät — nicht auf dem Handy, nicht auf dem Tablet, nicht auf dem Rechner. Es ist nicht so, dass er verschlüsselt wäre.",
  "lg.lead2b": "Er ist einfach nicht da.",
  "lg.pruebalo": "Probier es aus · schreib ein Geheimnis und sieh, was passiert",
  "lg.panel.plano": "Allgemeine Ebene",
  "lg.demo.hilos": "Familie=Mama: Essen wir Sonntag bei uns?=19:04|Marta=schicke dir die Fotos von Samstag=17:52|Team=Luis: morgen um neun also=Gestern|Javi=haha das glaub ich nicht=Gestern",
  "lg.demo.mundos": "Nur wir beide~hast du es dort abgelegt, wo wir gesagt haben?|ja. die Urkunde und den Pass>~Wohnungsurkunde.pdf=2,4 MB|Private Fotos=214|Karte · Bank=Daten~~Sachen von zu Hause~ich lege dir hier den Mietvertrag hin>|und den Router-Schlüssel, den du immer verlierst~Mietvertrag.pdf=1,1 MB|Ausweiskopie=2 Dateien|Hausschlüssel=Daten~~Meine Notizen~das habe ich niemandem erzählt>|und es muss auch niemand wissen>~Tagebuch=48 Notizen|Fotos=1.207|Jahresabrechnung=Daten~~Projekt Lissabon~das Angebot liegt bei 180|hier ist es, keine Kopien draußen>~Angebot_v4.pdf=860 KB|Kontakte=12|Firmenkarte=Daten~~Das Essen am Samstag~sag Marta noch nichts|keine Sorge, hier erfährt es niemand>~Reservierung.pdf=120 KB|Fotos vom letzten Jahr=63|Gästeliste=Daten",
  "lg.invocaLabel": "Ruf dein IKO",
  "lg.invocaPlaceholder": "schreib irgendein Geheimnis",
  "lg.invocaBtn": "Rufen",
  "lg.invocaHint": "Jedes Wort führt zu einem anderen Raum. Probier ein anderes.",
  "lg.estela.vacio": "Schreib irgendetwas: das hier ist eine Demonstration.",
  "lg.estela.primero": "Da. Es existiert nur, solange du drin bist.",
  "lg.estela.otro": "Anderes Geheimnis, anderer Raum. Keiner weiß von den anderen.",
  "lg.estela.salida": "Weg. Keine Spur auf dem Gerät. Probier ein anderes Wort.",
  "lg.ikoActivo": "IKO aktiv",
  "lg.nadaEnDispositivo": "Nichts davon liegt auf dem Gerät",
  "lg.salirIko": "IKO verlassen",
  "lg.planos.h2a": "Eine Ebene, die man sieht.",
  "lg.planos.h2b": "Darunter die, die du rufst.",
  "lg.planos.lead": "Es gibt nicht «das IKO». Es gibt die, die du öffnest: eines für zu Hause, eines für die Arbeit, eines, das nur zwei kennen, eines, von dem du nie jemandem erzählt hast. Jedes Geheimnis führt zu seinem, und keines weiß von den anderen.",
  "lg.planos.unoRotulo": "Die allgemeine Ebene · eine",
  "lg.planos.unoH3": "Wo du mit allen sprichst",
  "lg.planos.unoP": "Gespräche, Gruppen, Anrufe, Fotos und Dateien, Ende-zu-Ende verschlüsselt. Was du von einem Messenger erwartest, ordentlich gemacht. Deine gewohnten Chats leben hier und verhalten sich wie immer.",
  "lg.planos.nRotulo": "Die IKO · so viele du willst",
  "lg.planos.nH3": "Wo sonst niemand hinkommt",
  "lg.planos.nP": "Du schreibst ein Geheimnis und der dazugehörige Raum erscheint. Darin haben Gespräche und deine Sachen Platz. Wenn du gehst, verschwindet er spurlos vom Gerät. Es gibt keine Liste, keine Zahl, und niemand kann herausfinden, wie viele du hast — oder dass überhaupt eines existiert.",
  "lg.planos.chips": "Das von zu Hause|Die Arbeit|Was nur zwei wissen|Deins und sonst niemandes|Das eine, das du einmal geöffnet hast|Die, die du morgen entscheidest",
  "lg.forense.h2a": "Es ist nicht auf deinem Gerät verschlüsselt.",
  "lg.forense.h2b": "Es ist nicht auf deinem Gerät.",
  "lg.forense.lead": "Andere Apps legen deine Nachrichten auf dem Gerät ab und verschlüsseln sie. Nimmt jemand das Gerät mit, hängt deine Privatsphäre daran, dass diese Verschlüsselung lange genug hält. Hier gibt es nichts, was halten müsste: was in einem IKO lebt, wird auf kein Gerät geschrieben. Man ruft es, benutzt es, und es geht wieder.",
  "lg.forense.multi": "Überall gleich: Handy, Tablet, Rechner zu Hause, Laptop von der Arbeit, Windows, Mac oder der Browser an einem fremden Ort. Du gehst hinein, wo du willst, und beim Verlassen weiß dieser Ort wieder nichts von dir.",
  "lg.forense.caption": "Was jemand findet, der eines deiner Geräte untersucht",
  "lg.forense.filas": "Nachrichten aus deinen IKO=0|Dateien und Fotos aus deinen IKO=0|Gespeicherte IKO-Geheimnisse=0|Datenbank mit deinen IKO=existiert nicht|Spur, dass ein IKO offen war=keine|Wie viele IKO du hast=nicht bestimmbar",
  "lg.escenas.h2": "Was dir wirklich Sorgen macht.",
  "lg.escenas.filas": "«Ich habe mein Handy verloren.»=Deine Privatsphäre ist nicht mitgegangen. Was in einem IKO war, war nie auf diesem Gerät — es gibt nichts zu retten und nichts zu befürchten. Du rufst es von einem beliebigen anderen Gerät und alles ist noch da, wo es war.~«Jemand hat meinen Laptop mitgenommen.»=Er sieht deine gewöhnlichen Gespräche, dieselben wie in jeder App. Vom Rest sieht er weder den Inhalt noch den Namen noch einen Hinweis darauf, dass es existiert.~«Man hat meinen Rechner untersucht.»=Eine forensische Analyse holt zurück, was auf der Platte steht, auch verschlüsselt und gelöscht. Hier steht nichts geschrieben, was man zurückholen könnte. Die Antwort lautet nicht «es lässt sich nicht entschlüsseln», sondern: es ist nichts da. Genauso auf dem Tablet, dem Handy und dem Browser, den du einen Nachmittag benutzt hast.",
  "lg.ciego.h2": "Wir nicht. Und wer die Server betreibt, auch nicht.",
  "lg.ciego.p1": "Der Server bewahrt Dinge auf, die er nicht lesen kann. Er hat dein Geheimnis nicht, hat es nie gehabt, und nirgends existiert eine Kopie. Es ist nicht so, dass wir uns weigern würden, den Inhalt deiner IKO herauszugeben: wir haben ihn nicht, und wir können ihn gar nicht haben. Auch nicht das Unternehmen, das die Maschinen betreibt, und auch nicht, wer sie in die Hände bekäme.",
  "lg.ciego.p2": "Das hat seinen Preis, und den muss man nennen: verlierst du dein Geheimnis, kann es dir niemand zurückgeben. Genau der Grund, aus dem niemand sonst hineinkommt, ist der Grund, aus dem auch wir dir nicht hineinhelfen können.",
  "lg.guardas": "Familienfotos|Die Notizen, die du nicht zeigst|Karten und Bankdaten|Passwörter|Dokumente|Gespräche, die nur euch angehen",
  "lg.nombre.esta": "es ist da",
  "lg.nombre.noEsta": "es ist nicht da",
  "lg.nombre.h2": "Daher der Name.",
  "lg.nombre.p": "Auf Suaheli heißt iko «es ist da» und haiko «es ist nicht da». Ein IKO ist da, solange du es rufst. Die restliche Zeit — also fast immer — ist es nicht da: nicht auf deinen Geräten, nicht in jemandes Blickfeld, nicht einmal als Verdacht.",
  "lg.cierre.h2": "Fang an zu reden.",
  "lg.cierre.p": "Man benutzt es wie jeden Messenger, auf dem Handy, dem Tablet und dem Rechner. Die IKO sind da, an dem Tag, an dem du sie brauchst.",
  "lg.cierre.btnCrear": "Konto erstellen",
  "lg.cierre.btnEntrar": "Ich habe schon ein Konto",
  "lg.cierre.pago": "IKOGNIT ist ein bezahltes Produkt. Keine Werbung, keine Werbeprofile und bei uns keine Kopie von irgendetwas: wir leben davon, dass sich die App für dich lohnt, nicht davon, was du darin erzählst.",
  "lg.pie.ciego": "Blinder Server",
  "auth.hola": "Hallo, schön wieder da.",
  "auth.queEs": "Was ist IKOGNIT?",
  "common.cancel": "Abbrechen",
  "common.error.generic": "Es hat nicht geklappt. Versuch es noch einmal.",
  "common.save": "Speichern",
  "common.confirm": "Bestätigen",
  "common.close": "Schließen",
  "common.add": "Hinzufügen",
  "common.back": "Zurück",
  "common.tagline": "Digitale Souveränität.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "Auf Suaheli heißt iko „es ist da“. Und haiko: „es ist nicht da“.",
  "auth.legal.age": "Ich bestätige, dass ich das nach dem Recht meines Landes erforderliche Mindestalter zur Nutzung von IKOGNIT erreicht habe.",
  "auth.legal.accept": "Ich habe die <a href='https://ikognit.org/legal/de/bedingungen.html' target='_blank' rel='noopener'>Bedingungen</a>, die <a href='https://ikognit.org/legal/de/datenschutz.html' target='_blank' rel='noopener'>Datenschutzerklärung</a> und die <a href='https://ikognit.org/legal/de/community-regeln.html' target='_blank' rel='noopener'>Community-Regeln</a> gelesen und akzeptiere sie.",
  "recovery.title": "Dein Wiederherstellungsschlüssel",
  "recovery.intro": "Diese **24 Wörter** sind der einzige Weg, dein Konto und den Verlauf wiederherzustellen, wenn du dein Passwort vergisst oder dein Gerät verlierst. **Schreibe sie auf Papier und bewahre sie sicher auf.** Niemand bei IKOGNIT kann sie für dich wiederherstellen.",
  "recovery.warn": "**Notiere sie OFFLINE.** Mach keinen Screenshot. Sende sie nicht per E-Mail oder Messenger. Wer diese Wörter hat, kontrolliert dein ganzes Konto.",
  "recovery.btn.show": "Wörter anzeigen",
  "recovery.btn.copy": "Kopieren",
  "recovery.btn.copied": "Kopiert · wird in {0}s gelöscht",
  "recovery.btn.cleared": "Zwischenablage geleert",
  "recovery.btn.copyAria": "Wiederherstellungsphrase in die Zwischenablage kopieren (wird automatisch gelöscht)",
  "recovery.btn.download": "Herunterladen",
  "recovery.btn.downloadAria": "Phrase als Textdatei herunterladen",
  "recovery.btn.back": "Wörter erneut anzeigen",
  "recovery.btn.continue": "Weiter",
  "recovery.btn.done": "Fertig",
  "recovery.btn.need3": "Schreibe die 3 korrekten Wörter",
  "recovery.verify.intro": "Um zu bestätigen, dass du deinen Schlüssel gespeichert hast, gib diese Wörter ein. Ohne korrekte Eingabe kannst du nicht fortfahren.",
  "recovery.verify.wordN": "Wort #{0}",
  "recovery.verify.correct": "Korrekt",
  "recovery.verify.wrong": "Falsch",
  "auth.error.legalRequired": "Du musst die rechtlichen Bedingungen akzeptieren und dein Alter bestätigen, um eine IKOGNIT ID zu erstellen.",
  "settings.legal.title": "Rechtliche Informationen",
  "settings.legal.hub": "Rechtszentrum",
  "settings.legal.terms": "Allgemeine Geschäftsbedingungen",
  "settings.legal.privacy": "Datenschutzerklärung",
  "settings.legal.rules": "Community-Regeln",
  "settings.legal.report": "Meldungen und Moderation",
  "settings.legal.cookies": "Cookie-Richtlinie",
  "settings.legal.minors": "Minderjährigen-Richtlinie",
  "settings.legal.notice": "Impressum",
  "settings.tab.legal": "Rechtliches",
  "auth.loading": "Wird geladen…",
  "auth.savedSession": "Dieses Gerät kennt seinen Besitzer bereits.",
  "auth.locked": "Nach Untätigkeit verschwunden. Geh wieder hinein.",
  "auth.sessionExpired": "Die Sitzung ist verschwunden. Geh wieder hinein.",
  "auth.tab.login": "Anmelden",
  "auth.tab.register": "Neue IKOGNIT ID",
  "auth.subLogin": "Du betrittst die allgemeine Ebene: deine gewohnten Gespräche. Deine IKO werden nicht hier gerufen — sondern drinnen, wenn du sie brauchst.",
  "auth.subRegister": "Das Konto läuft auf deinen Namen. Der Nick ist, wie andere dich sehen; die E-Mail dient nur dazu, den Zugang wiederzuerlangen, und für Hinweise.",
  "auth.field.devicePin": "Hauptschlüssel",
  "auth.field.password": "Hauptschlüssel",
  "auth.btn.unlock": "Anmelden",
  "auth.btn.unlocking": "Anmeldung läuft…",
  "auth.btn.processing": "Verarbeitung…",
  "auth.btn.createIdentity": "IKOGNIT ID erstellen",
  "auth.btn.useOther": "Andere IKOGNIT ID verwenden",
  "auth.btn.forget": "Dieses Gerät vergessen",
  "auth.btn.backToUnlock": "Zurück",
  "auth.confirmForget": "Dieses Gerät wird dich nicht mehr erkennen: Das gespeicherte Konto und alles im Zwischenspeicher verschwinden. Zum Wiedereintritt brauchst du dein Passwort.",
  "auth.confirmForget.warning": "Ohne notierte 24-Wort-Wiederherstellungsphrase gibt es keinen Weg zurück: niemand kann sie dir zurückgeben.",
  "invite.welcomeSub": "Nachrichten und ein eigener Raum: Was du hier aufbewahrst, läuft auf deinen Namen. Erstelle dein Konto, und ihr seid verbunden.",
  "auth.reset.warnNewIdentity": "Dein Konto bleibt deins, aber die Wiederherstellung per E-Mail gibt dir eine neue Identität: frühere Nachrichten lassen sich nicht mehr lesen. Wenn du deine 24-Wort-Phrase noch hast, nimm lieber diesen Weg.",
  "recover.intro": "Gib deinen Nick oder deine E-Mail ein sowie die 24 Wiederherstellungswörter, die dir bei der Kontoerstellung gegeben wurden. Danach wählst du ein neues Passwort.",
  "auth.error.badCreds": "IKOGNIT ID oder Schlüssel falsch.",
  "auth.error.userNotFound": "IKOGNIT ID nicht gefunden.",
  "auth.error.cantConnect": "Verbindung zum Server fehlgeschlagen.",
  "auth.error.badPin": "Falscher Schlüssel.",
  "auth.footnote": "Wer Eigentümer ist, haftet.\nWer das Passwort verliert, hat\nniemanden, den er belangen kann.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Aktuelles IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Persönliches IKO: {0}",
  "sidebar.freqPsh": "Domain-IKO: {0}",
  "sidebar.tune": "IKO aktivieren",
  "sidebar.exitFreq": "Zurück zu IKOGNIT",
  "sidebar.notifications": "Benachrichtigungen",
  "sidebar.remember": "Gerät merken",
  "sidebar.forget": "Gerät vergessen",
  "sidebar.addContact": "Kontakt per nick hinzufügen",
  "sidebar.newGroup": "Neue Gruppe",
  "sidebar.settings": "Einstellungen",
  "sidebar.logout": "Abmelden",
  "sidebar.tooltip.logout": "Abmelden und alle lokalen Daten löschen",
  "sidebar.savedFreq.tooltip": "{0} aktivieren",
  "chat.empty": "Wähle oder füge einen Kontakt hinzu",
  "welcome.title": "Willkommen bei IKOGNIT",
  "welcome.concept": "In IKOGNIT sprichst du mit anderen Nutzern, identifiziert durch deinen Nick. Wenn du einen separaten Raum willst, aktivierst du ein IKO und betrittst ein IKO. Ist es Öffentlich, triffst du jene, die es auch aktivieren. Ist es Privat, betrittst du ein IKO, in dem nur du bist.",
  "welcome.step1": "Aktiviere ein Öffentliches IKO und betritt ein IKO mit jenen, die es ebenfalls kennen.",
  "welcome.step2": "Hier in IKOGNIT, füge einen Nick als Kontakt hinzu und beginne zu sprechen.",
  "welcome.step3": "Aktiviere ein Privates IKO und öffne ein IKO nur für dich, in dem du Dateien, Fotos, Audios, Videos, Passwörter, Notizen und Briefe aufbewahrst.",
  "welcome.multidevice": "IKO werden nirgendwo gespeichert. Vergisst du ein IKO, hört sein IKO für dich auf zu existieren.",
  "welcome.btnFreq": "IKO aktivieren",
  "welcome.btnContacts": "Kontakt hinzufügen",
  "push.btnOn": "Benachrichtigungen AN",
  "push.btnOff": "Benachrichtigungen AUS",
  "push.btnEnable": "Benachrichtigungen aus. Klicken zum Aktivieren.",
  "push.btnDisable": "Benachrichtigungen an. Klicken zum Deaktivieren.",
  "push.introTitle": "Vor dem Aktivieren der Benachrichtigungen",
  "push.introBody": "Aus Datenschutzgründen sind die Benachrichtigungen von IKOGNIT anders als bei anderen Messaging-Apps:",
  "push.introBullet1": "Der Inhalt der Nachricht ist nicht enthalten.",
  "push.introBullet2": "Name und IKOGNIT ID des Absenders werden nicht angezeigt.",
  "push.introBullet3": "Du erhältst nur einen \"Neue Nachricht\"-Hinweis; öffne die App, um sie verschlüsselt auf deinem Gerät zu lesen.",
  "push.introConfirm": "Benachrichtigungen aktivieren",
  "chat.placeholder": "Nachricht schreiben…",
  "chat.newMessages": "neu",
  "chat.newMessagesBadge": "Zu {0} neuen Nachrichten springen",
  "chat.mediaRetry": "Erneut versuchen",
  "chat.mediaFailed": "Konnte nicht geladen werden",
  "chat.media.download": "Herunterladen",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Nachricht bearbeiten…",
  "chat.replyingTo": "Antwort an {0}",
  "chat.editing": "Nachricht bearbeiten",
  "chat.confirmContact": "Zu Kontakten hinzufügen",
  "chat.unconfirmedBanner": "Dieser Nutzer hat dir geschrieben, ist aber nicht in deinen Kontakten. Bis du ihn hinzufügst, sind dein Foto und Info ihm gemäß deinen Datenschutzeinstellungen nicht sichtbar.",
  "chat.online": "online",
  "chat.lastSeen": "zuletzt gesehen {0}",
  "chat.tooltip.attach": "Datei anhängen",
  "chat.tooltip.shareContact": "Kontakt teilen",
  "chat.tooltip.paste": "Bild aus Zwischenablage einfügen",
  "chat.tooltip.stickers": "Sticker",
  "chat.tooltip.callAudio": "Sprachanruf",
  "chat.tooltip.callVideo": "Videoanruf",
  "chat.btn.send": "Senden",
  "chat.uploading": "…",
  "preview.image": "📷 Bild",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Antworten",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Bearbeiten",
  "bubble.edited": "bearbeitet",
  "bubble.contact.label": "IKOGNIT-Kontakt",
  "bubble.media.decrypting": "Wird entschlüsselt…",
  "bubble.media.failed": "Datei konnte nicht entschlüsselt werden.",
  "call.calling": "Anruf…",
  "call.incoming.audio": "Eingehender Anruf",
  "call.incoming.video": "Eingehender Videoanruf",
  "call.connecting": "Verbinde…",
  "call.ending": "Beende…",
  "call.accept": "Annehmen",
  "call.reject": "Ablehnen",
  "call.hangup": "Auflegen",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Audioausgabe",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Zum Anrufen musst du innerhalb eines IKO sein.",
  "error.notFound": "Ressource nicht gefunden.",
  "error.notInFreq": "{0} ist noch nicht in diesem IKO. Bitte ihn über einen anderen Kanal, es zu aktivieren.",
  "error.push.iosTooOld": "Dein iOS ist älter als 16.4. Aktualisiere, um Benachrichtigungen zu erhalten.",
  "error.push.iosNotStandalone": "Um auf dem iPhone Benachrichtigungen zu erhalten, installiere IKOGNIT auf dem Startbildschirm: Teilen → Zum Home-Bildschirm.",
  "error.expired": "Sitzung abgelaufen. Erneut anmelden.",
  "error.gone": "Die Datei ist abgelaufen.",
  "error.invalid": "Ungültige Daten.",
  "error.server": "Serverfehler. Bitte erneut versuchen.",
  "error.network": "Keine Serververbindung.",
  "error.cantStartCall": "Anruf konnte nicht gestartet werden: {0}",
  "error.cantAcceptCall": "Anruf konnte nicht angenommen werden: {0}",
  "error.cantPaste": "Zugriff auf die Zwischenablage nicht möglich. Versuche den Anhang-Button.",
  "error.noImageInClipboard": "Kein Bild in der Zwischenablage.",
  "error.clipboardUnsupported": "Dein Browser erlaubt das Lesen der Zwischenablage nicht. Füge mit Strg+V ein oder verwende den Anhang-Button.",
  "error.selfContact": "Du kannst dich nicht selbst hinzufügen.",
  "error.blocked": "Du hast diesen Nutzer blockiert. Hebe die Blockade in den Einstellungen auf, um wieder zu sprechen.",
  "settings.title": "Einstellungen",
  "settings.close": "Schließen",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Datenschutz",
  "settings.tab.messages": "✉ Nachrichten",
  "settings.tab.blocked": "🚫 Blockierte",
  "settings.tab.notifications": "🔔 Benachrichtigungen",
  "settings.tab.session": "⏱ Sitzung",
  "settings.tab.account": "🆔 Konto",
  "settings.tab.language": "🌐 Sprache",
  "settings.tab.about": "ℹ Über",
  "settings.scope.global": "Global (IKOGNIT)",
  "settings.scope.freq": "Nur in {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Diese Werte werden standardmäßig verwendet und in allen IKO vererbt.",
  "settings.profile.hintFreq": "Überschreiben das globale Profil, wenn du in {0} bist. Wenn du hier nichts definierst, wird vom Globalen geerbt.",
  "settings.profile.displayName": "Anzeigename",
  "settings.profile.displayNamePh.global": "(kein Name — deine nick wird angezeigt)",
  "settings.profile.displayNamePh.freq": "(erbt vom Globalen)",
  "settings.profile.photo": "Profilbild",
  "settings.profile.changePhoto": "Bild ändern",
  "settings.profile.removePhoto": "Bild entfernen",
  "settings.profile.adjustPhoto": "Bild anpassen",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Hallo, ich nutze IKOGNIT",
  "settings.profile.removeOverride": "Override für {0} entfernen",
  "settings.profile.warn": "Änderungen werden automatisch an deine übrigen Kontakte gesendet, wenn du in diesem IKO mit ihnen interagierst.",
  "settings.privacy.title": "Datenschutz",
  "settings.privacy.hintGlobal": "Lege standardmäßig fest, wer welche deiner Informationen sehen kann.",
  "settings.privacy.hintFreq": "Überschreibe diese Regeln nur, wenn du in {0} bist.",
  "settings.privacy.showPhoto": "Wer sieht mein Bild",
  "settings.privacy.showInfo": "Wer sieht meine Info / Status",
  "settings.privacy.showLastSeen": "Wer sieht meinen letzten Login",
  "settings.privacy.showOnline": "Wer sieht, ob ich online bin",
  "settings.privacy.whoAdds": "Wer kann mich Gruppen hinzufügen",
  "settings.privacy.readReceipts": "Lesebestätigungen",
  "settings.privacy.readReceiptsHint": "Wenn deaktiviert, werden beim Lesen keine blauen Häkchen gesendet. Du siehst auch nicht die der anderen.",
  "settings.vis.all": "Alle",
  "settings.vis.contacts": "Meine Kontakte",
  "settings.vis.none": "Niemand",
  "settings.messages.title": "Nachrichten",
  "settings.messages.ttl": "Standardablauf",
  "settings.messages.ttlHint": "Gesendete Nachrichten werden nach dieser Zeit vom Server gelöscht. Beim Anhängen einer Datei kannst du einen anderen Wert wählen.",
  "settings.blocked.title": "Blockierte",
  "settings.blocked.hint": "Blockierte Nutzer können dir keine Nachrichten senden. Auch du kannst ihnen keine senden.",
  "settings.blocked.placeholder": "Zu blockierende IKOGNIT ID",
  "settings.blocked.btn": "Blockieren",
  "settings.blocked.unblock": "Entsperren",
  "settings.blocked.empty": "Du hast niemanden blockiert.",
  "settings.notif.title": "Benachrichtigungen",
  "settings.notif.sound": "Ton",
  "settings.notif.preview": "Nachrichtenvorschau anzeigen",
  "settings.notif.vibration": "Vibration (mobil)",
  "settings.notif.hint": "Browser-Push-Benachrichtigungen werden nur für Nachrichten im allgemeinen IKOGNIT ausgegeben, ohne Inhalt oder Absendername (per Design).",
  "settings.session.title": "Sitzung",
  "settings.session.timeout": "IKO nach Inaktivität schließen",
  "settings.session.timeoutHint": "Wenn du diese Zeit ohne App-Aktion verbringst, wird das aktive IKO automatisch deaktiviert und du kehrst zu IKOGNIT zurück. \"Nie\" behält das IKO bis zum Schließen der App.",
  "settings.session.remember": "Aktivierte IKO merken",
  "settings.session.rememberHint": "Wenn aktiviert, erscheinen aktivierte IKO als Verknüpfungen in der Seitenleiste. Wer deinen Bildschirm sieht, könnte erfahren, in welchen IKO du warst, daher standardmäßig deaktiviert. Beim Ausschalten werden bereits gespeicherte gelöscht.",
  "settings.account.title": "Konto",
  "settings.account.email": "Optionale E-Mail (nur für Wiederherstellung, nie veröffentlicht)",
  "settings.account.emailPh": "email@beispiel.com",
  "settings.account.changePassword": "Passwort ändern",
  "settings.account.currentPw": "Aktuelles Passwort",
  "settings.account.newPw": "Neues Passwort (mind. 8)",
  "settings.account.confirmPw": "Wiederhole das neue",
  "settings.account.saving": "Speichern…",
  "settings.account.success": "Passwort aktualisiert.",
  "settings.account.errPwBad": "Das aktuelle Passwort ist falsch.",
  "settings.account.errPwShort": "Das neue Passwort muss mindestens 8 Zeichen haben.",
  "settings.account.errPwMismatch": "Passwörter stimmen nicht überein.",
  "settings.language.title": "Sprache",
  "settings.language.hint": "Wähle die Sprache der Oberfläche. Deine Präferenz wird auf diesem Gerät gespeichert.",
  "settings.about.title": "Über IKOGNIT",
  "settings.about.version": "Version",
  "settings.about.tech": "E2E-Verschlüsselung mit NaCl box (X25519). IKO: Argon2id-Ableitung + deterministischer HMAC. Lokale verschlüsselte Persistenz mit Argon2id über PIN.",
  "modal.freq.title": "IKO aktivieren",
  "modal.freq.hint": "Ein IKO sind die genauen IKO eines deiner IKO. Öffentlich: du triffst, wer dasselbe schreibt. Privat: du erreichst ein IKO, in dem du unsichtbar bist, auch wenn ein anderer dieselben IKO schreibt.",
  "modal.freq.placeholder": "Schreibe deine IKO",
  "modal.freq.activate": "Aktivieren",
  "modal.freq.deriving": "Berechne IKO…",
  "modal.freq.warn": "IKO werden nirgendwo gespeichert. Vergisst du sie, hört dieses IKO für dich auf zu existieren.",
  "modal.freq.errShort": "Das IKO muss mindestens 8 Zeichen haben.",
  "modal.freq.errCommon": "Dieses IKO ist zu häufig. Wähle etwas Einzigartiges.",
  "modal.freq.errRepeat": "Kein einzelnes wiederholtes Zeichen verwenden.",
  "modal.freq.errSeqNum": "Offensichtliche Zahlensequenzen vermeiden.",
  "modal.freq.errSeqAlpha": "Alphabetische Sequenzen vermeiden.",
  "billing.title": "Abrechnung",
  "billing.manage": "Verwalten",
  "billing.seats": "Plätze",
  "billing.renews": "Verlängerung",
  "billing.needsUpgrade": "Du hast das Platzlimit deiner Stufe erreicht. Upgrade, um mehr hinzuzufügen.",
  "billing.upgradeTo": "Stufe erhöhen ({price}/Platz)",
  "billing.portal": "Zahlung verwalten",
  "join.loginToAccept": "Anmelden / Konto erstellen",
  "private.badge": "PRIVAT",
  "private.welcome.title": "Dein Privates IKO",
  "private.welcome.intro": "Du bist an IKO, an denen dich niemand sehen kann. Auch wenn jemand das gleiche IKO schreiben würde, käme er in ein anderes IKO. Hier bewahrst du deine Sachen sicher auf.",
  "private.welcome.hint": "Wähle einen Bereich, um zu beginnen.",
  "private.mod.notes": "Notizen",
  "private.mod.notes.desc": "Notizen, Briefe, Tagebuch.",
  "private.mod.files": "Dateien",
  "private.mod.files.desc": "Dokumente, Tabellen, PDFs.",
  "private.mod.photos": "Fotos",
  "private.mod.photos.desc": "Deine private Galerie.",
  "private.mod.videos": "Videos",
  "private.mod.videos.desc": "Deine persönlichen Videos.",
  "private.mod.audios": "Audios",
  "private.mod.audios.desc": "Aufnahmen und Sprachnotizen.",
  "private.mod.vault": "Passwörter",
  "private.mod.vault.desc": "Passwörter, Karten, Identitäten, SSH-Schlüssel und was du brauchst.",
  "private.mod.iko": "Meine IKO",
  "private.mod.iko.desc": "Deine gespeicherten IKO, bereit zum Aktivieren.",
  "savediko.intro": "Bewahre hier die IKO auf, die du dir nicht merken willst. Du merkst dir eines, der Rest lebt darin.",
  "savediko.empty": "Du hast noch kein IKO gespeichert.",
  "savediko.add": "Ein IKO speichern",
  "savediko.activate": "IKO aktivieren",
  "savediko.formNew": "Ein IKO speichern",
  "savediko.formEdit": "Gespeichertes IKO bearbeiten",
  "savediko.descLabel": "Beschreibung",
  "savediko.descPh": "Eine Beschreibung, um es später wiederzuerkennen",
  "savediko.ikoLabel": "Das IKO",
  "savediko.ikoPh": "Schreibe das IKO",
  "savediko.errDesc": "Gib eine Beschreibung ein.",
  "savediko.errIko": "Schreibe das IKO.",
  "savediko.confirmDel": "Löschen?",
  "vault.new": "Neues Element",
  "vault.edit": "Bearbeiten",
  "vault.delete": "Löschen",
  "vault.save": "Speichern",
  "vault.show": "Anzeigen",
  "vault.hide": "Verbergen",
  "vault.copy": "Kopieren",
  "vault.copied": "Kopiert ✓",
  "vault.search": "Suchen…",
  "vault.empty": "Dein Ordner ist leer. Erstelle dein erstes Element.",
  "vault.noMatches": "Kein Element entspricht der Suche.",
  "vault.untitled": "Ohne Namen",
  "vault.startHint": "Wähle links ein Element oder erstelle ein neues.",
  "vault.confirmDelete": "Dieses Element löschen? Es kann nicht wiederhergestellt werden.",
  "vault.notes": "Notizen",
  "vault.sensitive": "Sensibel",
  "vault.sensitiveHint": "Sensible Felder sind standardmäßig verborgen und können in die Zwischenablage kopiert werden.",
  "vault.removeField": "Dieses Feld entfernen",
  "vault.addField": "Feld hinzufügen",
  "vault.fieldSingular": "Feld",
  "vault.fieldPlural": "Felder",
  "vault.type.login": "Login",
  "vault.type.card": "Karte",
  "vault.type.identity": "Identität",
  "vault.type.sshkey": "SSH-Schlüssel",
  "vault.type.custom": "Benutzerdefiniert",
  "vault.field.name": "Name",
  "vault.field.name.ph": "Wie nennst du es?",
  "vault.field.labelPh": "Feldbeschriftung",
  "vault.field.newField": "Feld",
  "vault.field.username": "Benutzer",
  "vault.field.password": "Passwort",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Karteninhaber",
  "vault.field.cardBrand": "Marke",
  "vault.field.cardNumber": "Nummer",
  "vault.field.cardExpiry": "Ablauf (MM/JJ)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Vorname",
  "vault.field.lastname": "Nachname",
  "vault.field.dni": "Ausweis",
  "vault.field.address": "Adresse",
  "vault.field.city": "Stadt",
  "vault.field.zip": "PLZ",
  "vault.field.country": "Land",
  "vault.field.phone": "Telefon",
  "vault.field.email": "E-Mail",
  "vault.field.birthdate": "Geburtsdatum",
  "vault.field.sshPrivate": "Privater Schlüssel",
  "vault.field.sshPublic": "Öffentlicher Schlüssel",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Text",
  "vault.ft.password": "Passwort",
  "vault.ft.textarea": "Langer Text",
  "vault.ft.date": "Datum",
  "vault.ft.url": "URL",
  "vault.ft.email": "E-Mail",
  "vault.ft.number": "Zahl",
  "vault.tpl.title": "Vorlagen",
  "vault.tpl.manage": "Vorlagen verwalten",
  "vault.tpl.yours": "Deine Vorlagen",
  "vault.tpl.new": "Neue Vorlage",
  "vault.tpl.edit": "Vorlage bearbeiten",
  "vault.tpl.empty": "Du hast noch keine Vorlagen. Erstelle eine, um deinen eigenen Elementtyp zu definieren.",
  "vault.tpl.name": "Vorlagenname",
  "vault.tpl.name.ph": "Z. B.: Crypto-Wallet, Hotelbuchung…",
  "vault.tpl.confirmDelete": "Diese Vorlage löschen? Daraus erstellte Elemente bleiben erhalten.",
  "totp.copyCode": "Code kopieren",
  "totp.copySecret": "Secret kopieren",
  "totp.showSecret": "Secret anzeigen",
  "totp.hideSecret": "Secret verbergen",
  "totp.invalid": "ungültiges Secret",
  "private.module.coming": "Demnächst.",
  "private.module.comingHint": "Dieses Modul ist bald verfügbar. Die Kryptografie des Privaten IKO funktioniert bereits — bald kannst du hier speichern, was du brauchst.",
  "notes.new": "Neue Notiz",
  "notes.empty": "Du hast in diesem IKO noch keine Notizen.",
  "notes.emptyPreview": "(leer)",
  "notes.untitled": "Ohne Titel",
  "notes.delete": "Notiz löschen",
  "notes.confirmDelete": "Diese Notiz löschen? Sie kann nicht wiederhergestellt werden.",
  "notes.titlePlaceholder": "Titel",
  "notes.contentPlaceholder": "Schreibe, was du dir merken musst…",
  "notes.startHint": "Keine Notizen in diesem IKO. Erstelle die erste.",
  "notes.autosaveHint": "Automatisch gespeichert, verschlüsselt, nur hier.",
  "notes.yesterday": "Gestern",
  "passwords.new": "Neuer Eintrag",
  "passwords.empty": "Du hast in diesem IKO noch nichts gespeichert.",
  "passwords.untitled": "Ohne Namen",
  "passwords.startHint": "Keine Passwörter in diesem IKO. Erstelle das erste.",
  "passwords.confirmDelete": "Diesen Eintrag löschen? Er kann nicht wiederhergestellt werden.",
  "passwords.save": "Speichern",
  "passwords.edit": "Bearbeiten",
  "passwords.delete": "Löschen",
  "passwords.copy": "Kopieren",
  "passwords.copied": "Kopiert ✓",
  "passwords.show": "Anzeigen",
  "passwords.hide": "Verbergen",
  "passwords.field.label": "Name",
  "passwords.field.label.ph": "Bank, Konto, Dienst…",
  "passwords.field.username": "Benutzer",
  "passwords.field.username.ph": "E-Mail, Alias, Nummer…",
  "passwords.field.password": "Passwort",
  "passwords.field.password.ph": "Das Passwort, das du speichern willst",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notizen",
  "passwords.field.notes.ph": "Jedes nützliche Detail",
  "media.uploading": "Hochladen…",
  "media.uploadFailed": "Datei konnte nicht hochgeladen werden.",
  "media.upload.file": "Datei hochladen",
  "media.upload.photo": "Foto hochladen",
  "media.upload.video": "Video hochladen",
  "media.upload.audio": "Audio hochladen",
  "media.empty.file": "Noch keine Dateien in diesem IKO.",
  "media.empty.photo": "Noch keine Fotos in diesem IKO.",
  "media.empty.video": "Noch keine Videos in diesem IKO.",
  "media.empty.audio": "Noch keine Audios in diesem IKO.",
  "media.play": "Abspielen",
  "media.download": "Herunterladen",
  "media.delete": "Löschen",
  "media.confirmDelete": "Dieses Element löschen? Es kann nicht wiederhergestellt werden.",
  "media.noPreview": "Keine Vorschau für diesen Dateityp.",
  "modal.share.title": "Kontakt teilen",
  "modal.share.hint": "Wähle einen Kontakt aus der Liste oder gib eine IKOGNIT ID manuell ein.",
  "modal.share.filter": "Kontakte filtern…",
  "modal.share.empty": "Keine Kontakte in diesem IKO",
  "modal.share.manual": "Oder eine manuelle IKOGNIT ID",
  "modal.share.btn": "Teilen",
  "modal.group.title": "Neue Gruppe",
  "modal.group.hint": "Wähle einen Namen und Mitglieder aus deinen Kontakten in diesem IKO.",
  "modal.group.namePh": "Gruppenname",
  "modal.group.selected": "{0} ausgewählt",
  "modal.group.create": "Gruppe erstellen",
  "modal.remember.title": "Dieses Gerät merken",
  "modal.remember.hint": "Deine Sitzung, Kontakte, Gruppen und Nachrichten werden auf diesem Gerät gespeichert, mit einem PIN verschlüsselt, den nur du kennst. Beim erneuten Öffnen der App gibst du den PIN zum Entsperren ein.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "PIN wiederholen",
  "modal.remember.warn": "Wenn du den PIN vergisst, sind die gespeicherten Daten nicht wiederherstellbar. Du musst dich erneut mit Benutzer und Passwort anmelden.",
  "modal.remember.errShort": "Der PIN muss mindestens 4 Zeichen haben.",
  "modal.remember.errMismatch": "PINs stimmen nicht überein.",
  "stickers.faces": "Gesichter",
  "stickers.gestures": "Gesten",
  "stickers.hearts": "Herzen",
  "stickers.symbols": "Symbole",
  "stickers.animals": "Tiere",
  "stickers.food": "Essen",
  "ttl.1h": "1 Stunde",
  "ttl.1d": "1 Tag",
  "ttl.1w": "1 Woche",
  "ttl.1m": "1 Monat",
  "ttl.6m": "6 Monate",
  "ttl.12m": "12 Monate",
  "timeout.5min": "5 Min",
  "timeout.15min": "15 Min",
  "timeout.30min": "30 Min",
  "timeout.never": "Nie",
  "toast.newMessage": "Neue Nachricht",
  "toast.group": "{0} (Gruppe)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informationen und Navigation des IKO",
  "ctx.section.universe": "AKTUELLES IKO",
  "ctx.universe.personal": "Dein persönlicher Raum",
  "ctx.status.serverBlind": "Blinder Server aktiv",
  "ctx.status.e2e": "Ende-zu-Ende-Verschlüsselung",
  "ctx.section.nav": "NAVIGATION",
  "ctx.nav.changeIko": "IKO wechseln",
  "ctx.nav.activateIko": "IKO aktivieren",
  "ctx.nav.backToIkognit": "Zurück zu IKOGNIT",
  "ctx.section.actions": "AKTIONEN",
  "ctx.action.newChat": "Neuer Chat",
  "ctx.action.newGroup": "Neue Gruppe",
  "ctx.action.contacts": "Meine Kontakte",
  "ctx.section.conversation": "UNTERHALTUNG",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} Nachrichten",
  "ctx.peer.message": "{0} Nachricht",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Persönliches IKO",
  "ctx.modes.storage": "Laufwerk",
  "ctx.liturgy.0": "Der Server ist blind.",
  "ctx.liturgy.1": "Nur du liest hier.",
  "ctx.liturgy.2": "Niemand weiß, dass du hier bist.",
  "ctx.liturgy.3": "Ein IKO ist ein Geheimnis, das nur du kennst.",
  "ctx.liturgy.4": "Deine Privatsphäre ist die Architektur.",
  "ccb.universe.changeOrExit": "IKO wechseln oder verlassen",
  "ccb.universe.activate": "IKO aktivieren",
  "ccb.leave.title": "IKO verlassen (zurück zu IKOGNIT)",
  "ccb.leave.aria": "IKO verlassen",
  "ccb.tag.cipher.title": "Symmetrische Verschlüsselung aktiv",
  "ccb.tag.srv.title": "Der Server kann den Inhalt nicht lesen",
  "ccb.tag.unread.title": "Ungelesene Nachrichten",
  "ccb.settings.title": "Einstellungen · Profil, Themes, Sitzung",
  "ccb.settings.aria": "Einstellungen",
  "ccb.identity.title": "Sitzung: @{0}",
  "ccb.clock.title": "Ortszeit",
  "ccb.modes.personalPrefix": "PERSÖNLICH · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "PERSÖNLICHES IKO",
  "holo.modes.general": "DEIN NICK + KONTAKTE",
  "holo.claim.inIko": "Dieses IKO bleibt unsichtbar für alle, die es nicht kennen.",
  "holo.claim.general": "Dein persönlicher Raum in IKOGNIT. Hier sprichst du mit deinen Kontakten.",
  "holo.card.conversations": "Unterhaltungen",
  "holo.card.contacts": "Kontakte",
  "holo.card.cipher": "Verschlüsselung",
  "holo.card.server": "Server",
  "holo.foot": "Wähle eine Unterhaltung, aktiviere ein IKO oder erstelle einen neuen Raum.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Persönliches IKO",
  "uib.context.coordTitle": "Das IKO",
  "uib.context.general": "Allgemeines IKO",
  "uib.e2e.title": "Der Server kann deinen Inhalt nicht lesen — E2E-Verschlüsselung mit deinem Schlüssel",
  "uib.e2e.label": "Blinder Server",
  "uib.pseudoTitle": "Dein Pseudonym in diesem IKO",
  "uib.nickTitle": "Dein Nick",
  "uib.exitTitle": "Zurück zum Allgemeinen IKO",
  "uib.exitLabel": "Verlassen",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Hauptnavigation",
  "chat.tab.chats": "Chats",
  "chat.tab.calls": "Anrufe",
  "chat.tab.contacts": "Kontakte",
  "chat.backToIkognit.title": "Zurück zu IKOGNIT allgemein",
  "chat.delete.title": "Löschen",
  "chat.delete.aria": "Löschen",
  "chat.call.title": "Anrufen",
  "chat.videoCall.title": "Videoanruf",
  "chat.videoCall.aria": "Videoanruf mit {0}",
  "chat.search.clear": "Suche löschen",
  "chat.filters.aria": "Chat-Filter",
  "chat.filter.all": "Alle",
  "chat.filter.unread": "Ungelesen",
  "chat.filter.groups": "Gruppen",
  "chat.attachPending": "Anhang ausstehend",
  "chat.remove.title": "Entfernen",
  "chat.cancel.title": "Abbrechen",
  "chat.blocked.text": "Du hast {0} blockiert. Du kannst keine Nachrichten senden oder anrufen.",
  "chat.unblock": "Entsperren",
  "contacts.alias.placeholder": "Ein Alias zum Wiedererkennen",
  "contacts.notes.placeholder": "Nur du siehst sie (verschlüsselt auf dem Server).",
  "contacts.search.placeholder": "Nach Alias oder IKOGNIT-ID suchen",
  "contacts.edit.title": "Alias und Notiz bearbeiten",
  "contacts.edit.aria": "Bearbeiten",
  "contacts.blockBtn": "Kontakt blockieren",
  "contacts.unblockBtn": "Kontakt entsperren",
  "contacts.confirmBlock.title": "Kontakt blockieren",
  "contacts.confirmUnblock.title": "Kontakt entsperren",
  "contacts.confirmBlock.body": "{0} blockieren? Du erhältst keine Nachrichten und Anrufe mehr.",
  "contacts.confirmUnblock.body": "{0} entsperren? Du erhältst wieder Nachrichten.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Kategorien des persönlichen IKO",
  "piko.rail.head": "PERSÖNLICH",
  "piko.cat.all": "Alles",
  "piko.cat.photos": "Fotos",
  "piko.cat.videos": "Videos",
  "piko.cat.audios": "Audios",
  "piko.cat.files": "Dateien",
  "piko.cat.notes": "Notizen",
  "piko.cat.passwords": "Passwörter",
  "piko.cat.cards": "Karten",
  "piko.cat.identities": "Identitäten",
  "piko.cat.sshkeys": "SSH-Schlüssel",
  "piko.cat.custom": "Ordnere",
  "piko.cat.agendas": "IKO-Verzeichnisse",
  "piko.cat.storage": "Laufwerks & Datenträger",

  "auth.field.nickPlaceholder": "z. B. user123",
  "auth.field.emailPlaceholder": "du@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Gelesen {0}",
  "bubble.tick.delivered": "Zugestellt {0}",
  "bubble.tick.sent": "Gesendet",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Du hast diesen Nutzer blockiert.",
  "chat.preview.image": "Bild",
  "chat.preview.video": "Video",
  "chat.preview.voice": "Sprachnachricht",
  "chat.preview.audio": "Audio",
  "error.push.denied": "Du hast die Benachrichtigungsberechtigung verweigert.",
  "error.push.noSw": "Dieser Browser unterstützt keine Service Worker.",
  "error.push.noPush": "Dieser Browser unterstützt keine Push-Benachrichtigungen.",
  "error.push.noVapid": "Der Server lieferte keinen VAPID-Schlüssel.",
  "error.push.activateFailed": "Aktivierung fehlgeschlagen ({0}).",
  "chat.group.membersWord": "Mitglieder",
  "chat.newCall.title": "Neuer Anruf",
  "chat.newChat.title": "Neuer Chat",
  "chat.newCall.empty": "Noch keine Kontakte. Füge einen über das + in Chats hinzu.",
  "chat.unread.aria": "ungelesene Nachrichten",
  "chat.calls.title": "Anrufe",
  "chat.calls.empty": "Noch keine Anrufe. Starte einen aus dem Chat mit einem Kontakt.",
  "chat.calls.callContact": "Kontakt anrufen",
  "chat.calls.historySoon": "Anrufverlauf wird in Kürze verfügbar sein.",
  "chat.deleteConv.titleOne": "Unterhaltung löschen",
  "chat.deleteConv.titleMany": "{0} Unterhaltungen löschen",
  "chat.deleteConv.hint": "\"Für mich\" löscht deine Kopie (alle deine Geräte). \"Für alle\" bittet auch den Kontakt, sie zu löschen.",
  "chat.deleteConv.forMe": "Für mich löschen",
  "chat.deleteConv.forAll": "Für alle löschen",
  "chat.myContacts": "Meine Kontakte",
  "chat.contacts.noResults": "Keine Ergebnisse.",
  "chat.contacts.empty": "Noch keine Kontakte.",
  "chat.contact.badgeBlocked": "blockiert",
  "chat.contact.badgePending": "unbestätigt",
  "chat.toast.saved": "Gespeichert",
  "chat.toast.videoSaved": "Video in Fotos gespeichert",
  "chat.toast.imageSaved": "Bild in Fotos gespeichert",
  "chat.toast.updateTestflight": "Aktualisiere TestFlight auf 1.0(10)+, um zu speichern.",
  "chat.toast.saveFailed": "Speichern fehlgeschlagen: {0}",
  "chat.toast.saveError": "Speicherfehler",
  "iko.banner.exitAria": "Das IKO verlassen und zur allgemeinen Ebene zurück",
  "iko.liturgy.entering": "IKO wird betreten",
  "iko.liturgy.returning": "Rückkehr",
  "iko.liturgy.toIkognit": "zu IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Persönliches IKO",
  "manifest.blindServer": "Der Server ist blind.",
  "manifest.onlyYouRead": "Hier liest nur du.",
  "manifest.noPublicProfiles": "Keine öffentlichen Profile.",
  "manifest.noAdsNoClouds": "Keine Werbung. Keine fremden Clouds.",
  "manifest.keyWithYou": "Der Schlüssel lebt bei dir.",
  "manifest.yourIkoYourSpaces": "Deine IKO. Deine Räume.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Dateien",
  "orb.mod.notes": "Notizen",
  "orb.mod.photos": "Fotos",
  "orb.mod.vault": "Ordner",
  "orb.mod.audios": "Audios",
  "orb.copy.line1": "Deine IKO.",
  "orb.copy.line2": "Deine Räume.",
  "explorer.filesNotProcessed": "Nicht verarbeitete Datei(en)",
  "demo.edit": "Bearbeiten",
  "common.exit": "Verlassen",
  "common.more": "Mehr",
  "chat.tab.settings": "Einstellungen",
  "chat.search.placeholder": "Chat suchen",
  "chat.presence.online": "online",
  "chat.action.call": "Anrufen",
  "chat.action.videoCall": "Videoanruf",
  "chat.attach.label": "Anhängen",
  "chat.attach.camera": "Kamera",
  "chat.attach.voice": "Stimme",
  "chat.attach.file": "Datei anhängen",
  "chat.composer.placeholder": "Schreibe eine Nachricht…",
  "settings.addYourName": "Füge deinen Namen hinzu",
  "settings.editProfile": "Profil bearbeiten",
  "chat.welcome.intro": "Wähle einen Chat, um Ende-zu-Ende-verschlüsselt zu sprechen.",

  // Batch2: footer atajos web
  "web.footer.palette": "Palette",
  "web.footer.send": "senden",
  "web.footer.line": "Zeile",
  "mobile.tb.ikoActivate": "IKO aktivieren",
  "mobile.tb.ikoExit": "Zurück zu IKOGNIT allgemein",

  "chat.header.blocked": "Blockiert",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Private Notiz",
  "settings.account.newNickPlaceholder": "neuer_nick",
  "settings.account.newEmailPlaceholder": "neu@email.com",


  "common.delete": "Löschen",








};

const nl: Catalog = {
  "auth.verify.notSent": "We konden je de code niet sturen. Je account bestaat: druk zo op ‘Code opnieuw sturen’.",
  "lg.rotulo": "Berichten met privéruimtes",
  "lg.btn.entrar": "Inloggen",
  "lg.eyebrow": "Privéberichten · Itrion Software",
  "lg.h1a": "Je gesprekken van altijd.",
  "lg.h1b": "En een plek die alleen bestaat als je hem oproept.",
  "lg.lead1": "Je praat met je familie, je vrienden en je team, zoals in elke app. Het verschil begint wanneer je een IKO opent: een eigen ruimte waar je binnenkomt door een geheim te schrijven dat alleen de aanwezigen kennen.",
  "lg.lead2": "Zolang je hem niet oproept, staat die ruimte niet op je apparaat — niet op de telefoon, niet op de tablet, niet op de computer. Het is niet zo dat hij versleuteld is.",
  "lg.lead2b": "Hij is er gewoon niet.",
  "lg.pruebalo": "Probeer het · schrijf een geheim en kijk wat er gebeurt",
  "lg.panel.plano": "Algemeen vlak",
  "lg.demo.hilos": "Familie=Mam: eten we zondag bij ons?=19:04|Marta=ik stuur je de foto's van zaterdag=17:52|Team=Luis: morgen om negen uur dan=Gisteren|Javi=haha dat meen je niet=Gisteren",
  "lg.demo.mundos": "Alleen wij tweeën~heb je het gezet waar we zeiden?|ja. de akte en het paspoort>~Akte van het huis.pdf=2,4 MB|Privéfoto's=214|Kaart · bank=Gegevens~~Dingen van thuis~ik zet het huurcontract hier neer>|en de routersleutel, die je altijd kwijtraakt~Huurcontract.pdf=1,1 MB|Kopie identiteitsbewijs=2 bestanden|Huissleutels=Gegevens~~Mijn aantekeningen~dit heb ik aan niemand verteld>|en dat hoeft ook niet>~Dagboek=48 notities|Foto's=1.207|Jaarrekening=Gegevens~~Project Lissabon~het bod komt op 180|hier is het, geen kopieën buiten>~Bod_v4.pdf=860 KB|Contacten=12|Bedrijfskaart=Gegevens~~De lunch van zaterdag~zeg nog niks tegen Marta|rustig, hier komt niemand het te weten>~Reservering.pdf=120 KB|Foto's van vorig jaar=63|Gastenlijst=Gegevens",
  "lg.invocaLabel": "Roep je IKO op",
  "lg.invocaPlaceholder": "schrijf een willekeurig geheim",
  "lg.invocaBtn": "Oproepen",
  "lg.invocaHint": "Elk woord leidt naar een andere ruimte. Probeer er een andere.",
  "lg.estela.vacio": "Schrijf wat je wilt: dit is een demonstratie.",
  "lg.estela.primero": "Daar. Hij bestaat alleen zolang je erin bent.",
  "lg.estela.otro": "Ander geheim, andere ruimte. Geen van beide weet van de ander.",
  "lg.estela.salida": "Weg. Geen spoor op het apparaat. Probeer een ander woord.",
  "lg.ikoActivo": "IKO actief",
  "lg.nadaEnDispositivo": "Niets hiervan staat op het apparaat",
  "lg.salirIko": "IKO verlaten",
  "lg.planos.h2a": "Eén vlak dat iedereen ziet.",
  "lg.planos.h2b": "Daaronder, die jij oproept.",
  "lg.planos.lead": "Er is niet «de IKO». Er zijn de IKO die je opent: één voor thuis, één voor werk, één die jullie met z'n tweeën kennen, één waarover je nooit iemand hebt verteld. Elk geheim leidt naar de zijne, en geen enkele weet van de andere.",
  "lg.planos.unoRotulo": "Het algemene vlak · één",
  "lg.planos.unoH3": "Waar je met iedereen praat",
  "lg.planos.unoP": "Gesprekken, groepen, gesprekken, foto's en bestanden, end-to-end versleuteld. Wat je van een berichtenapp verwacht, goed gedaan. Je gewone chats wonen hier en gedragen zich als altijd.",
  "lg.planos.nRotulo": "De IKO · zoveel je wilt",
  "lg.planos.nH3": "Waar niemand anders komt",
  "lg.planos.nP": "Je schrijft een geheim en de bijbehorende ruimte verschijnt. Daarin passen gesprekken en je spullen. Als je weggaat, verdwijnt hij spoorloos van het apparaat. Er is geen lijst, geen aantal, en niemand kan achterhalen hoeveel je er hebt, of dat er ook maar één bestaat.",
  "lg.planos.chips": "De dingen van thuis|Het werk|Wat jullie met z'n tweeën weten|Van jou en van niemand anders|Die je één keer opende en nooit meer|Die je morgen bedenkt",
  "lg.forense.h2a": "Het is niet versleuteld op je apparaat.",
  "lg.forense.h2b": "Het staat niet op je apparaat.",
  "lg.forense.lead": "Andere apps bewaren je berichten op het toestel en versleutelen ze. Als iemand het meeneemt, hangt je privacy ervan af of die versleuteling lang genoeg standhoudt. Hier hoeft niets stand te houden: wat in een IKO leeft, wordt op geen enkel apparaat weggeschreven. Je roept het op, je gebruikt het, en het gaat weer weg.",
  "lg.forense.multi": "Overal hetzelfde: telefoon, tablet, computer thuis, laptop van het werk, Windows, Mac of de browser op een plek die niet van jou is. Je gaat naar binnen waar je wilt en als je weggaat, weet die plek weer niets van je.",
  "lg.forense.caption": "Wat iemand vindt die een van je apparaten onderzoekt",
  "lg.forense.filas": "Berichten uit je IKO=0|Bestanden en foto’s uit je IKO=0|Opgeslagen IKO-geheimen=0|Database met je IKO=bestaat niet|Spoor dat een IKO open is geweest=geen|Hoeveel IKO je hebt=niet vast te stellen",
  "lg.escenas.h2": "Waar je je echt zorgen om maakt.",
  "lg.escenas.filas": "«Ik ben mijn telefoon kwijt.»=Je privacy is niet meegegaan. Wat in een IKO zat, heeft nooit op dat toestel gestaan, dus er valt niets te redden en niets te vrezen. Je roept hem op vanaf elk ander apparaat en alles staat nog waar het stond.~«Iemand heeft mijn laptop meegenomen.»=Hij ziet je gewone gesprekken, dezelfde die hij in elke app zou zien. Van de rest ziet hij de inhoud niet, de naam niet, en geen enkele aanwijzing dat het bestaat.~«Ze hebben mijn computer onderzocht.»=Een forensische analyse haalt terug wat op de schijf staat, ook versleuteld en gewist. Hier staat niets geschreven om terug te halen. Het antwoord is niet «het valt niet te ontsleutelen»: er is niets. Hetzelfde geldt voor de tablet, de telefoon en de browser die je een middag gebruikte.",
  "lg.ciego.h2": "Wij niet. En wie de servers host ook niet.",
  "lg.ciego.p1": "De server bewaart dingen die hij niet kan lezen. Hij heeft je geheim niet, heeft het nooit gehad, en nergens bestaat een kopie. Het is niet zo dat we weigeren te geven wat er in je IKO zit: we hebben het niet, en er is geen manier om het te hebben. Ook het bedrijf dat de machines host niet, en niemand die ze in handen zou krijgen.",
  "lg.ciego.p2": "Dat heeft een prijs en die hoort erbij: raak je je geheim kwijt, dan kan niemand het teruggeven. Precies de reden waarom niemand anders binnenkomt, is de reden waarom ook wij je niet binnen kunnen helpen.",
  "lg.guardas": "Familiefoto's|De aantekeningen die je niet laat zien|Kaarten en bankgegevens|Wachtwoorden|Documenten|Gesprekken die alleen jullie aangaan",
  "lg.nombre.esta": "het is er",
  "lg.nombre.noEsta": "het is er niet",
  "lg.nombre.h2": "Vandaar de naam.",
  "lg.nombre.p": "In het Swahili betekent iko «het is er» en haiko «het is er niet». Een IKO is er zolang je hem oproept. De rest van de tijd — dat is bijna altijd — is hij er niet: niet op je apparaten, niet in iemands zicht, zelfs niet als vermoeden.",
  "lg.cierre.h2": "Begin met praten.",
  "lg.cierre.p": "Het werkt als elke berichtenapp, op de telefoon, de tablet en de computer. De IKO staan er op de dag dat je ze nodig hebt.",
  "lg.cierre.btnCrear": "Account aanmaken",
  "lg.cierre.btnEntrar": "Ik heb al een account",
  "lg.cierre.pago": "IKOGNIT is een betaald product. Geen advertenties, geen advertentieprofielen en bij ons geen kopie van wat dan ook: we leven ervan dat de app het waard is, niet van wat je erin vertelt.",
  "lg.pie.ciego": "Blinde server",
  "auth.hola": "Hallo, weer terug.",
  "auth.queEs": "Wat is IKOGNIT?",
  "common.cancel": "Annuleren",
  "common.error.generic": "Het is niet gelukt. Probeer opnieuw.",
  "common.save": "Opslaan",
  "common.confirm": "Bevestigen",
  "common.close": "Sluiten",
  "common.add": "Toevoegen",
  "common.back": "Terug",
  "common.tagline": "Digitale soevereiniteit.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "In het Swahili betekent iko ‘het is er’. En haiko: ‘het is er niet’.",
  "auth.legal.age": "Ik bevestig dat ik de minimumleeftijd heb die de wet van mijn land vereist om IKOGNIT te gebruiken.",
  "auth.legal.accept": "Ik heb de <a href='https://ikognit.org/legal/nl/voorwaarden.html' target='_blank' rel='noopener'>Voorwaarden</a>, het <a href='https://ikognit.org/legal/nl/privacy.html' target='_blank' rel='noopener'>Privacybeleid</a> en de <a href='https://ikognit.org/legal/nl/gemeenschapsregels.html' target='_blank' rel='noopener'>Gemeenschapsregels</a> gelezen en accepteer ze.",
  "recovery.title": "Jouw herstelsleutel",
  "recovery.intro": "Deze **24 woorden** zijn de enige manier om je account en geschiedenis te herstellen als je je wachtwoord vergeet of je apparaat verliest. **Schrijf ze op papier en bewaar ze op een veilige plek.** Niemand bij IKOGNIT kan ze voor je herstellen.",
  "recovery.warn": "**Schrijf ze OFFLINE op.** Maak geen screenshot. Verstuur ze niet via e-mail of berichten. Wie deze woorden heeft, beheert je hele account.",
  "recovery.btn.show": "Woorden tonen",
  "recovery.btn.copy": "Kopiëren",
  "recovery.btn.copied": "Gekopieerd · wordt over {0}s gewist",
  "recovery.btn.cleared": "Klembord gewist",
  "recovery.btn.copyAria": "Herstelfrase naar klembord kopiëren (wordt automatisch gewist)",
  "recovery.btn.download": "Downloaden",
  "recovery.btn.downloadAria": "Frase downloaden als tekstbestand",
  "recovery.btn.back": "Woorden opnieuw bekijken",
  "recovery.btn.continue": "Verder",
  "recovery.btn.done": "Klaar",
  "recovery.btn.need3": "Schrijf de 3 juiste woorden",
  "recovery.verify.intro": "Om te bevestigen dat je je sleutel hebt opgeslagen, typ deze woorden. Je kunt niet verder zonder ze juist te raden.",
  "recovery.verify.wordN": "Woord #{0}",
  "recovery.verify.correct": "Correct",
  "recovery.verify.wrong": "Onjuist",
  "auth.error.legalRequired": "Je moet de juridische voorwaarden accepteren en je leeftijd bevestigen om een IKOGNIT ID aan te maken.",
  "settings.legal.title": "Juridische informatie",
  "settings.legal.hub": "Juridisch centrum",
  "settings.legal.terms": "Algemene voorwaarden",
  "settings.legal.privacy": "Privacybeleid",
  "settings.legal.rules": "Gemeenschapsregels",
  "settings.legal.report": "Meldingen en moderatie",
  "settings.legal.cookies": "Cookiebeleid",
  "settings.legal.minors": "Minderjarigenbeleid",
  "settings.legal.notice": "Juridische kennisgeving",
  "settings.tab.legal": "Juridisch",
  "auth.loading": "Laden…",
  "auth.savedSession": "Dit apparaat kent zijn eigenaar al.",
  "auth.locked": "Verdwenen na inactiviteit. Ga opnieuw naar binnen.",
  "auth.sessionExpired": "De sessie is verdwenen. Ga opnieuw naar binnen.",
  "auth.tab.login": "Aanmelden",
  "auth.tab.register": "Nieuwe IKOGNIT ID",
  "auth.subLogin": "Je komt op het algemene vlak: je gewone gesprekken. Je IKO roep je hier niet op — dat doe je binnen, wanneer je ze nodig hebt.",
  "auth.subRegister": "De account staat op jouw naam. De nick is hoe anderen je zien; e-mail dient alleen om toegang te herstellen en voor meldingen.",
  "auth.field.devicePin": "Hoofdsleutel",
  "auth.field.password": "Hoofdsleutel",
  "auth.btn.unlock": "Aanmelden",
  "auth.btn.unlocking": "Aanmelden…",
  "auth.btn.processing": "Verwerken…",
  "auth.btn.createIdentity": "IKOGNIT ID aanmaken",
  "auth.btn.useOther": "Andere IKOGNIT ID gebruiken",
  "auth.btn.forget": "Dit apparaat vergeten",
  "auth.btn.backToUnlock": "Terug",
  "auth.confirmForget": "Dit apparaat herkent je niet langer: het opgeslagen account en alles in de cache verdwijnen. Om terug te komen heb je je wachtwoord nodig.",
  "auth.confirmForget.warning": "Zonder de herstelzin van 24 woorden op papier is er geen weg terug: niemand kan die voor je terughalen.",
  "invite.welcomeSub": "Berichten en een eigen ruimte: wat je hier bewaart, staat op jouw naam. Maak je account aan en jullie zijn verbonden.",
  "auth.reset.warnNewIdentity": "Je account blijft van jou, maar herstel via e-mail geeft je een nieuwe identiteit: eerdere berichten zijn niet meer te lezen. Heb je je herstelzin van 24 woorden nog, gebruik dan die weg.",
  "recover.intro": "Vul je nick of e-mail in en de 24 herstelwoorden die je bij het aanmaken van het account kreeg. Daarna kies je een nieuw wachtwoord.",
  "auth.error.badCreds": "IKOGNIT ID of sleutel onjuist.",
  "auth.error.userNotFound": "IKOGNIT ID niet gevonden.",
  "auth.error.cantConnect": "Kan geen verbinding maken met de server.",
  "auth.error.badPin": "Onjuiste sleutel.",
  "auth.footnote": "Wie eigenaar is, staat ervoor in.\nRaak je je wachtwoord kwijt,\ndan is er niemand om aan te kloppen.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Huidige IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Persoonlijk IKO: {0}",
  "sidebar.freqPsh": "Domein-IKO: {0}",
  "sidebar.tune": "IKO activeren",
  "sidebar.exitFreq": "Terug naar IKOGNIT",
  "sidebar.notifications": "Meldingen",
  "sidebar.remember": "Apparaat onthouden",
  "sidebar.forget": "Apparaat vergeten",
  "sidebar.addContact": "Contact toevoegen via nick",
  "sidebar.newGroup": "Nieuwe groep",
  "sidebar.settings": "Instellingen",
  "sidebar.logout": "Afmelden",
  "sidebar.tooltip.logout": "Afmelden en alles lokaal wissen",
  "sidebar.savedFreq.tooltip": "{0} activeren",
  "chat.empty": "Selecteer of voeg een contact toe",
  "welcome.title": "Welkom bij IKOGNIT",
  "welcome.concept": "In IKOGNIT praat je met andere gebruikers, geïdentificeerd door je nick. Wanneer je een aparte ruimte wilt, activeer je een IKO en betreed je een IKO. Is het Openbaar, dan ontmoet je degenen die het ook activeren. Is het Privé, dan betreed je een IKO waarin alleen jij bestaat.",
  "welcome.step1": "Activeer een Openbare IKO en betreed een IKO met degenen die het ook kennen.",
  "welcome.step2": "Hier in IKOGNIT, voeg een nick toe als contact en begin te praten.",
  "welcome.step3": "Activeer een Privé IKO en open een IKO alleen voor jou, waar je bestanden, foto's, audio, video's, wachtwoorden, notities en brieven bewaart.",
  "welcome.multidevice": "IKO worden nergens opgeslagen. Als je een IKO vergeet, houdt het IKO op te bestaan voor jou.",
  "welcome.btnFreq": "IKO activeren",
  "welcome.btnContacts": "Contact toevoegen",
  "push.btnOn": "Meldingen AAN",
  "push.btnOff": "Meldingen UIT",
  "push.btnEnable": "Meldingen uitgeschakeld. Klik om in te schakelen.",
  "push.btnDisable": "Meldingen ingeschakeld. Klik om uit te schakelen.",
  "push.introTitle": "Voor je meldingen inschakelt",
  "push.introBody": "Voor privacy zijn IKOGNIT-meldingen anders dan die van andere berichtenapps:",
  "push.introBullet1": "De berichtinhoud wordt niet opgenomen.",
  "push.introBullet2": "Naam en IKOGNIT ID van de afzender worden niet getoond.",
  "push.introBullet3": "Je krijgt alleen een \"nieuw bericht\"-melding; open de app om het versleuteld op je apparaat te lezen.",
  "push.introConfirm": "Meldingen inschakelen",
  "chat.placeholder": "Schrijf een bericht…",
  "chat.newMessages": "nieuw",
  "chat.newMessagesBadge": "Spring naar {0} nieuwe berichten",
  "chat.mediaRetry": "Opnieuw proberen",
  "chat.mediaFailed": "Kon niet laden",
  "chat.media.download": "Downloaden",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Bewerk je bericht…",
  "chat.replyingTo": "Antwoorden aan {0}",
  "chat.editing": "Bericht bewerken",
  "chat.confirmContact": "Aan contacten toevoegen",
  "chat.unconfirmedBanner": "Deze gebruiker heeft je geschreven maar staat niet in je contacten. Tot je hem toevoegt, zijn je foto en info voor hem niet zichtbaar volgens je privacy-instellingen.",
  "chat.online": "online",
  "chat.lastSeen": "laatst gezien {0}",
  "chat.tooltip.attach": "Bestand bijvoegen",
  "chat.tooltip.shareContact": "Contact delen",
  "chat.tooltip.paste": "Afbeelding uit klembord plakken",
  "chat.tooltip.stickers": "Stickers",
  "chat.tooltip.callAudio": "Spraakoproep",
  "chat.tooltip.callVideo": "Videogesprek",
  "chat.btn.send": "Verzenden",
  "chat.uploading": "…",
  "preview.image": "📷 Afbeelding",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Antwoorden",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Bewerken",
  "bubble.edited": "bewerkt",
  "bubble.contact.label": "IKOGNIT-contact",
  "bubble.media.decrypting": "Ontsleutelen…",
  "bubble.media.failed": "Kon het bestand niet ontsleutelen.",
  "call.calling": "Bellen…",
  "call.incoming.audio": "Inkomend gesprek",
  "call.incoming.video": "Inkomend videogesprek",
  "call.connecting": "Verbinden…",
  "call.ending": "Beëindigen…",
  "call.accept": "Accepteren",
  "call.reject": "Weigeren",
  "call.hangup": "Ophangen",
  "call.mic": "Microfoon",
  "call.camera": "Camera",
  "call.audioOut": "Audio-uitgang",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Om te bellen moet je in een IKO zijn.",
  "error.notFound": "Bron niet gevonden.",
  "error.notInFreq": "{0} is nog niet in deze IKO. Vraag via een ander kanaal hem te activeren.",
  "error.push.iosTooOld": "Je iOS is ouder dan 16.4. Werk bij om meldingen te ontvangen.",
  "error.push.iosNotStandalone": "Om meldingen op iPhone te ontvangen, installeer IKOGNIT op het startscherm: tik op Delen → Toevoegen aan beginscherm.",
  "error.expired": "Sessie verlopen. Meld je opnieuw aan.",
  "error.gone": "Het bestand is verlopen.",
  "error.invalid": "Ongeldige gegevens.",
  "error.server": "Serverfout. Probeer opnieuw.",
  "error.network": "Geen verbinding met de server.",
  "error.cantStartCall": "Kon het gesprek niet starten: {0}",
  "error.cantAcceptCall": "Kon het gesprek niet aannemen: {0}",
  "error.cantPaste": "Kon klembord niet openen. Probeer de bijlageknop.",
  "error.noImageInClipboard": "Geen afbeelding in het klembord.",
  "error.clipboardUnsupported": "Je browser staat klembordlezen niet toe. Plak met Ctrl+V of gebruik de bijlageknop.",
  "error.selfContact": "Je kunt jezelf niet toevoegen.",
  "error.blocked": "Je hebt deze gebruiker geblokkeerd. Deblokkeer in Instellingen om weer te praten.",
  "settings.title": "Instellingen",
  "settings.close": "Sluiten",
  "settings.tab.profile": "👤 Profiel",
  "settings.tab.privacy": "🔒 Privacy",
  "settings.tab.messages": "✉ Berichten",
  "settings.tab.blocked": "🚫 Geblokkeerd",
  "settings.tab.notifications": "🔔 Meldingen",
  "settings.tab.session": "⏱ Sessie",
  "settings.tab.account": "🆔 Account",
  "settings.tab.language": "🌐 Taal",
  "settings.tab.about": "ℹ Over",
  "settings.scope.global": "Globaal (IKOGNIT)",
  "settings.scope.freq": "Alleen in {0}",
  "settings.profile.title": "Profiel",
  "settings.profile.hintGlobal": "Deze waarden worden standaard gebruikt en geërfd in alle IKO.",
  "settings.profile.hintFreq": "Overschrijven het globale profiel wanneer je in {0} bent. Als je hier niets definieert, wordt het van globaal geërfd.",
  "settings.profile.displayName": "Weergavenaam",
  "settings.profile.displayNamePh.global": "(geen naam — je nick wordt getoond)",
  "settings.profile.displayNamePh.freq": "(erft van globaal)",
  "settings.profile.photo": "Profielfoto",
  "settings.profile.changePhoto": "Foto wijzigen",
  "settings.profile.removePhoto": "Foto verwijderen",
  "settings.profile.adjustPhoto": "Pas je foto aan",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Hallo, ik gebruik IKOGNIT",
  "settings.profile.removeOverride": "Override van {0} verwijderen",
  "settings.profile.warn": "Wijzigingen worden automatisch verzonden naar je overige contacten wanneer je in deze IKO met hen interacteert.",
  "settings.privacy.title": "Privacy",
  "settings.privacy.hintGlobal": "Configureer standaard wie elk van je gegevens kan zien.",
  "settings.privacy.hintFreq": "Overschrijf deze regels alleen wanneer je in {0} bent.",
  "settings.privacy.showPhoto": "Wie ziet mijn foto",
  "settings.privacy.showInfo": "Wie ziet mijn info / status",
  "settings.privacy.showLastSeen": "Wie ziet mijn laatste verbinding",
  "settings.privacy.showOnline": "Wie ziet of ik online ben",
  "settings.privacy.whoAdds": "Wie kan me aan groepen toevoegen",
  "settings.privacy.readReceipts": "Leesbevestigingen",
  "settings.privacy.readReceiptsHint": "Indien uitgeschakeld, worden geen blauwe vinkjes gestuurd wanneer je berichten leest. Je ziet die van anderen ook niet.",
  "settings.vis.all": "Iedereen",
  "settings.vis.contacts": "Mijn contacten",
  "settings.vis.none": "Niemand",
  "settings.messages.title": "Berichten",
  "settings.messages.ttl": "Standaard vervaldatum",
  "settings.messages.ttlHint": "Berichten die je verzendt worden na deze tijd van de server verwijderd. Je kunt een andere waarde kiezen bij het bijvoegen van een bestand.",
  "settings.blocked.title": "Geblokkeerd",
  "settings.blocked.hint": "Geblokkeerde gebruikers kunnen je geen berichten sturen. Jij ook niet aan hen.",
  "settings.blocked.placeholder": "Te blokkeren IKOGNIT ID",
  "settings.blocked.btn": "Blokkeren",
  "settings.blocked.unblock": "Deblokkeren",
  "settings.blocked.empty": "Je hebt niemand geblokkeerd.",
  "settings.notif.title": "Meldingen",
  "settings.notif.sound": "Geluid",
  "settings.notif.preview": "Berichtvoorbeeld tonen",
  "settings.notif.vibration": "Trillen (mobiel)",
  "settings.notif.hint": "Browser push-meldingen worden alleen verzonden voor berichten in algemeen IKOGNIT, zonder inhoud of afzendernaam (per ontwerp).",
  "settings.session.title": "Sessie",
  "settings.session.timeout": "IKO sluiten na inactiviteit",
  "settings.session.timeoutHint": "Als je deze tijd zonder de app aan te raken doorbrengt, wordt de actieve IKO automatisch gedeactiveerd en keer je terug naar IKOGNIT. \"Nooit\" houdt de IKO tot je de app sluit.",
  "settings.session.remember": "Geactiveerde IKO onthouden",
  "settings.session.rememberHint": "Indien ingeschakeld, verschijnen de IKO die je activeert als snelkoppelingen in de zijbalk. Wie je scherm ziet, kan weten in welke IKO je bent geweest, dus standaard uit. Uitschakelen wist de reeds opgeslagen.",
  "settings.account.title": "Account",
  "settings.account.email": "Optioneel e-mail (alleen voor herstel, nooit gepubliceerd)",
  "settings.account.emailPh": "email@voorbeeld.com",
  "settings.account.changePassword": "Wachtwoord wijzigen",
  "settings.account.currentPw": "Huidig wachtwoord",
  "settings.account.newPw": "Nieuw wachtwoord (min. 8)",
  "settings.account.confirmPw": "Herhaal het nieuwe",
  "settings.account.saving": "Opslaan…",
  "settings.account.success": "Wachtwoord bijgewerkt.",
  "settings.account.errPwBad": "Het huidige wachtwoord is onjuist.",
  "settings.account.errPwShort": "Het nieuwe wachtwoord moet ten minste 8 tekens hebben.",
  "settings.account.errPwMismatch": "Wachtwoorden komen niet overeen.",
  "settings.language.title": "Taal",
  "settings.language.hint": "Kies de taal van de interface. Je voorkeur wordt op dit apparaat opgeslagen.",
  "settings.about.title": "Over IKOGNIT",
  "settings.about.version": "Versie",
  "settings.about.tech": "E2E-versleuteling met NaCl box (X25519). IKO: Argon2id-afleiding + deterministische HMAC. Lokale versleutelde persistentie met Argon2id over PIN.",
  "modal.freq.title": "IKO activeren",
  "modal.freq.hint": "Een IKO zijn de exacte IKO van één van je IKO. Openbaar: je ontmoet wie dezelfde schrijft. Privé: je bereikt een IKO waar je onzichtbaar bent, zelfs als een ander dezelfde IKO schrijft.",
  "modal.freq.placeholder": "Schrijf je IKO",
  "modal.freq.activate": "Activeren",
  "modal.freq.deriving": "IKO berekenen…",
  "modal.freq.warn": "IKO worden nergens opgeslagen. Als je ze vergeet, houdt dat IKO op te bestaan voor jou.",
  "modal.freq.errShort": "De IKO moet ten minste 8 tekens hebben.",
  "modal.freq.errCommon": "Deze IKO is te gewoon. Kies iets unieks.",
  "modal.freq.errRepeat": "Gebruik geen enkel herhaald teken.",
  "modal.freq.errSeqNum": "Vermijd voor de hand liggende numerieke reeksen.",
  "modal.freq.errSeqAlpha": "Vermijd alfabetische reeksen.",
  "billing.title": "Facturatie",
  "billing.manage": "Beheren",
  "billing.seats": "Plaatsen",
  "billing.renews": "Verlenging",
  "billing.needsUpgrade": "Je hebt de plaatslimiet van je schaal bereikt. Upgrade om meer toe te voegen.",
  "billing.upgradeTo": "Schaal upgraden ({price}/plaats)",
  "billing.portal": "Betaling beheren",
  "join.loginToAccept": "Inloggen / Account aanmaken",
  "private.badge": "PRIVÉ",
  "private.welcome.title": "Jouw Privé-IKO",
  "private.welcome.intro": "Je bent op IKO waar niemand je kan zien. Zelfs als een andere persoon dezelfde IKO schrijft, komt hij in een ander IKO uit. Hier bewaar je jouw spullen veilig.",
  "private.welcome.hint": "Kies een sectie om te beginnen.",
  "private.mod.notes": "Notities",
  "private.mod.notes.desc": "Notities, brieven, dagboek.",
  "private.mod.files": "Bestanden",
  "private.mod.files.desc": "Documenten, sheets, PDF's.",
  "private.mod.photos": "Foto's",
  "private.mod.photos.desc": "Je privégalerij.",
  "private.mod.videos": "Video's",
  "private.mod.videos.desc": "Je persoonlijke video's.",
  "private.mod.audios": "Audio",
  "private.mod.audios.desc": "Opnames en spraaknotities.",
  "private.mod.vault": "Wachtwoorden",
  "private.mod.vault.desc": "Wachtwoorden, kaarten, identiteiten, SSH-sleutels en wat je nodig hebt.",
  "private.mod.iko": "Mijn IKO",
  "private.mod.iko.desc": "Je opgeslagen IKO, klaar om te activeren.",
  "savediko.intro": "Bewaar hier de IKO die je niet wilt onthouden. Je onthoudt er één en de rest woont daarin.",
  "savediko.empty": "Je hebt nog geen IKO opgeslagen.",
  "savediko.add": "Een IKO opslaan",
  "savediko.activate": "IKO activeren",
  "savediko.formNew": "Een IKO opslaan",
  "savediko.formEdit": "Opgeslagen IKO bewerken",
  "savediko.descLabel": "Omschrijving",
  "savediko.descPh": "Een omschrijving om het later te herkennen",
  "savediko.ikoLabel": "De IKO",
  "savediko.ikoPh": "Schrijf de IKO",
  "savediko.errDesc": "Voer een omschrijving in.",
  "savediko.errIko": "Schrijf de IKO.",
  "savediko.confirmDel": "Verwijderen?",
  "vault.new": "Nieuw element",
  "vault.edit": "Bewerken",
  "vault.delete": "Verwijderen",
  "vault.save": "Opslaan",
  "vault.show": "Tonen",
  "vault.hide": "Verbergen",
  "vault.copy": "Kopiëren",
  "vault.copied": "Gekopieerd ✓",
  "vault.search": "Zoeken…",
  "vault.empty": "Je map is leeg. Maak je eerste element.",
  "vault.noMatches": "Geen element komt overeen met de zoekopdracht.",
  "vault.untitled": "Zonder naam",
  "vault.startHint": "Selecteer een element links of maak een nieuw aan.",
  "vault.confirmDelete": "Dit element verwijderen? Het kan niet worden hersteld.",
  "vault.notes": "Notities",
  "vault.sensitive": "Gevoelig",
  "vault.sensitiveHint": "Gevoelige velden zijn standaard verborgen en kunnen naar het klembord worden gekopieerd.",
  "vault.removeField": "Dit veld verwijderen",
  "vault.addField": "Veld toevoegen",
  "vault.fieldSingular": "veld",
  "vault.fieldPlural": "velden",
  "vault.type.login": "Login",
  "vault.type.card": "Kaart",
  "vault.type.identity": "Identiteit",
  "vault.type.sshkey": "SSH-sleutel",
  "vault.type.custom": "Aangepast",
  "vault.field.name": "Naam",
  "vault.field.name.ph": "Hoe noem je het?",
  "vault.field.labelPh": "Veldlabel",
  "vault.field.newField": "Veld",
  "vault.field.username": "Gebruiker",
  "vault.field.password": "Wachtwoord",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Houder",
  "vault.field.cardBrand": "Merk",
  "vault.field.cardNumber": "Nummer",
  "vault.field.cardExpiry": "Verloopt (MM/JJ)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Voornaam",
  "vault.field.lastname": "Achternaam",
  "vault.field.dni": "ID-nummer",
  "vault.field.address": "Adres",
  "vault.field.city": "Stad",
  "vault.field.zip": "Postcode",
  "vault.field.country": "Land",
  "vault.field.phone": "Telefoon",
  "vault.field.email": "E-mail",
  "vault.field.birthdate": "Geboortedatum",
  "vault.field.sshPrivate": "Privésleutel",
  "vault.field.sshPublic": "Publieke sleutel",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Tekst",
  "vault.ft.password": "Wachtwoord",
  "vault.ft.textarea": "Lange tekst",
  "vault.ft.date": "Datum",
  "vault.ft.url": "URL",
  "vault.ft.email": "E-mail",
  "vault.ft.number": "Getal",
  "vault.tpl.title": "Sjablonen",
  "vault.tpl.manage": "Sjablonen beheren",
  "vault.tpl.yours": "Jouw sjablonen",
  "vault.tpl.new": "Nieuw sjabloon",
  "vault.tpl.edit": "Sjabloon bewerken",
  "vault.tpl.empty": "Je hebt nog geen sjablonen. Maak er een om je eigen elementtype te definiëren.",
  "vault.tpl.name": "Sjabloonnaam",
  "vault.tpl.name.ph": "Bijv.: Crypto-wallet, Hotelreservering…",
  "vault.tpl.confirmDelete": "Dit sjabloon verwijderen? Elementen die ervan zijn gemaakt blijven.",
  "totp.copyCode": "Code kopiëren",
  "totp.copySecret": "Secret kopiëren",
  "totp.showSecret": "Secret tonen",
  "totp.hideSecret": "Secret verbergen",
  "totp.invalid": "ongeldig secret",
  "private.module.coming": "Binnenkort.",
  "private.module.comingHint": "Deze module komt zeer binnenkort beschikbaar. De crypto van het Privé-IKO werkt al — binnenkort kun je hier opslaan wat je nodig hebt.",
  "notes.new": "Nieuwe notitie",
  "notes.empty": "Je hebt nog geen notities in dit IKO.",
  "notes.emptyPreview": "(leeg)",
  "notes.untitled": "Zonder titel",
  "notes.delete": "Notitie verwijderen",
  "notes.confirmDelete": "Deze notitie verwijderen? Ze kan niet worden hersteld.",
  "notes.titlePlaceholder": "Titel",
  "notes.contentPlaceholder": "Schrijf wat je moet onthouden…",
  "notes.startHint": "Geen notities in dit IKO. Maak de eerste.",
  "notes.autosaveHint": "Automatisch opgeslagen, versleuteld, alleen hier.",
  "notes.yesterday": "Gisteren",
  "passwords.new": "Nieuwe vermelding",
  "passwords.empty": "Je hebt nog niets opgeslagen in dit IKO.",
  "passwords.untitled": "Zonder naam",
  "passwords.startHint": "Geen wachtwoorden in dit IKO. Maak de eerste.",
  "passwords.confirmDelete": "Deze vermelding verwijderen? Ze kan niet worden hersteld.",
  "passwords.save": "Opslaan",
  "passwords.edit": "Bewerken",
  "passwords.delete": "Verwijderen",
  "passwords.copy": "Kopiëren",
  "passwords.copied": "Gekopieerd ✓",
  "passwords.show": "Tonen",
  "passwords.hide": "Verbergen",
  "passwords.field.label": "Naam",
  "passwords.field.label.ph": "Bank, account, dienst…",
  "passwords.field.username": "Gebruiker",
  "passwords.field.username.ph": "E-mail, alias, nummer…",
  "passwords.field.password": "Wachtwoord",
  "passwords.field.password.ph": "Het wachtwoord dat je wilt opslaan",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notities",
  "passwords.field.notes.ph": "Elk nuttig detail",
  "media.uploading": "Uploaden…",
  "media.uploadFailed": "Kon het bestand niet uploaden.",
  "media.upload.file": "Bestand uploaden",
  "media.upload.photo": "Foto uploaden",
  "media.upload.video": "Video uploaden",
  "media.upload.audio": "Audio uploaden",
  "media.empty.file": "Nog geen bestanden in dit IKO.",
  "media.empty.photo": "Nog geen foto's in dit IKO.",
  "media.empty.video": "Nog geen video's in dit IKO.",
  "media.empty.audio": "Nog geen audio in dit IKO.",
  "media.play": "Afspelen",
  "media.download": "Downloaden",
  "media.delete": "Verwijderen",
  "media.confirmDelete": "Dit element verwijderen? Het kan niet worden hersteld.",
  "media.noPreview": "Geen voorbeeld voor dit bestandstype.",
  "modal.share.title": "Contact delen",
  "modal.share.hint": "Kies een contact uit de lijst of voer handmatig een IKOGNIT ID in.",
  "modal.share.filter": "Contacten filteren…",
  "modal.share.empty": "Geen contacten in deze IKO",
  "modal.share.manual": "Of een handmatige IKOGNIT ID",
  "modal.share.btn": "Delen",
  "modal.group.title": "Nieuwe groep",
  "modal.group.hint": "Kies een naam en selecteer leden uit je contacten in deze IKO.",
  "modal.group.namePh": "Groepsnaam",
  "modal.group.selected": "{0} geselecteerd",
  "modal.group.create": "Groep aanmaken",
  "modal.remember.title": "Dit apparaat onthouden",
  "modal.remember.hint": "Je sessie, contacten, groepen en berichten worden op dit apparaat opgeslagen, versleuteld met een PIN die alleen jij kent. Bij heropening van de app voer je de PIN in om te ontgrendelen.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "PIN herhalen",
  "modal.remember.warn": "Als je de PIN vergeet, kunnen de opgeslagen gegevens niet worden hersteld. Je zult opnieuw moeten aanmelden met je gebruiker en wachtwoord.",
  "modal.remember.errShort": "De PIN moet ten minste 4 tekens hebben.",
  "modal.remember.errMismatch": "PIN's komen niet overeen.",
  "stickers.faces": "Gezichten",
  "stickers.gestures": "Gebaren",
  "stickers.hearts": "Harten",
  "stickers.symbols": "Symbolen",
  "stickers.animals": "Dieren",
  "stickers.food": "Eten",
  "ttl.1h": "1 uur",
  "ttl.1d": "1 dag",
  "ttl.1w": "1 week",
  "ttl.1m": "1 maand",
  "ttl.6m": "6 maanden",
  "ttl.12m": "12 maanden",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nooit",
  "toast.newMessage": "Nieuw bericht",
  "toast.group": "{0} (groep)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informatie en navigatie van het IKO",
  "ctx.section.universe": "HUIDIG IKO",
  "ctx.universe.personal": "Jouw persoonlijke ruimte",
  "ctx.status.serverBlind": "Blinde server actief",
  "ctx.status.e2e": "End-to-end versleuteling",
  "ctx.section.nav": "NAVIGATIE",
  "ctx.nav.changeIko": "Wissel van IKO",
  "ctx.nav.activateIko": "Activeer een IKO",
  "ctx.nav.backToIkognit": "Terug naar IKOGNIT",
  "ctx.section.actions": "ACTIES",
  "ctx.action.newChat": "Nieuwe chat",
  "ctx.action.newGroup": "Nieuwe groep",
  "ctx.action.contacts": "Mijn contacten",
  "ctx.section.conversation": "GESPREK",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} berichten",
  "ctx.peer.message": "{0} bericht",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Persoonlijke IKO",
  "ctx.modes.storage": "Station",
  "ctx.liturgy.0": "De server is blind.",
  "ctx.liturgy.1": "Alleen jij leest hier.",
  "ctx.liturgy.2": "Niemand weet dat je hier bent.",
  "ctx.liturgy.3": "Een IKO is een geheim dat alleen jij kent.",
  "ctx.liturgy.4": "Jouw privacy is de architectuur.",
  "ccb.universe.changeOrExit": "IKO wisselen of verlaten",
  "ccb.universe.activate": "IKO activeren",
  "ccb.leave.title": "IKO verlaten (terug naar IKOGNIT)",
  "ccb.leave.aria": "IKO verlaten",
  "ccb.tag.cipher.title": "Symmetrische versleuteling actief",
  "ccb.tag.srv.title": "De server kan de inhoud niet lezen",
  "ccb.tag.unread.title": "Ongelezen berichten",
  "ccb.settings.title": "Instellingen · profiel, thema's, sessie",
  "ccb.settings.aria": "Instellingen",
  "ccb.identity.title": "Sessie: @{0}",
  "ccb.clock.title": "Lokale tijd",
  "ccb.modes.personalPrefix": "PERSOONLIJK · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "PERSOONLIJKE IKO",
  "holo.modes.general": "JOUW NICK + CONTACTEN",
  "holo.claim.inIko": "Deze IKO blijft onzichtbaar voor wie hem niet kent.",
  "holo.claim.general": "Jouw persoonlijke ruimte in IKOGNIT. Hier praat je met je contacten.",
  "holo.card.conversations": "Gesprekken",
  "holo.card.contacts": "Contacten",
  "holo.card.cipher": "Versleuteling",
  "holo.card.server": "Server",
  "holo.foot": "Kies een gesprek, activeer een IKO of maak een nieuwe ruimte.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Persoonlijke IKO",
  "uib.context.coordTitle": "De IKO",
  "uib.context.general": "Algemeen IKO",
  "uib.e2e.title": "De server kan jouw inhoud niet lezen — E2E-versleuteling met jouw sleutel",
  "uib.e2e.label": "Blinde server",
  "uib.pseudoTitle": "Jouw pseudoniem in deze IKO",
  "uib.nickTitle": "Jouw nick",
  "uib.exitTitle": "Terug naar het Algemene IKO",
  "uib.exitLabel": "Verlaten",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Hoofdnavigatie",
  "chat.tab.chats": "Chats",
  "chat.tab.calls": "Oproepen",
  "chat.tab.contacts": "Contacten",
  "chat.backToIkognit.title": "Terug naar algemeen IKOGNIT",
  "chat.delete.title": "Verwijderen",
  "chat.delete.aria": "Verwijderen",
  "chat.call.title": "Bellen",
  "chat.videoCall.title": "Video-oproep",
  "chat.videoCall.aria": "Video-oproep met {0}",
  "chat.search.clear": "Zoekopdracht wissen",
  "chat.filters.aria": "Chatfilters",
  "chat.filter.all": "Alle",
  "chat.filter.unread": "Ongelezen",
  "chat.filter.groups": "Groepen",
  "chat.attachPending": "Bijlage in afwachting",
  "chat.remove.title": "Verwijderen",
  "chat.cancel.title": "Annuleren",
  "chat.blocked.text": "Je hebt {0} geblokkeerd. Je kunt geen berichten sturen of bellen.",
  "chat.unblock": "Deblokkeren",
  "contacts.alias.placeholder": "Een alias om hem te herkennen",
  "contacts.notes.placeholder": "Alleen jij ziet hem (versleuteld op de server).",
  "contacts.search.placeholder": "Zoek op alias of IKOGNIT ID",
  "contacts.edit.title": "Alias en notitie bewerken",
  "contacts.edit.aria": "Bewerken",
  "contacts.blockBtn": "Contact blokkeren",
  "contacts.unblockBtn": "Contact deblokkeren",
  "contacts.confirmBlock.title": "Contact blokkeren",
  "contacts.confirmUnblock.title": "Contact deblokkeren",
  "contacts.confirmBlock.body": "{0} blokkeren? Je ontvangt geen berichten of oproepen meer.",
  "contacts.confirmUnblock.body": "{0} deblokkeren? Je ontvangt weer berichten.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Categorieën van de Persoonlijke IKO",
  "piko.rail.head": "PERSOONLIJK",
  "piko.cat.all": "Alles",
  "piko.cat.photos": "Foto's",
  "piko.cat.videos": "Video's",
  "piko.cat.audios": "Audio's",
  "piko.cat.files": "Bestanden",
  "piko.cat.notes": "Notities",
  "piko.cat.passwords": "Wachtwoorden",
  "piko.cat.cards": "Kaarten",
  "piko.cat.identities": "Identiteiten",
  "piko.cat.sshkeys": "SSH-sleutels",
  "piko.cat.custom": "Kluizen",
  "piko.cat.agendas": "IKO-adresboeken",
  "piko.cat.storage": "Stations & Schijven",

  "auth.field.nickPlaceholder": "bijv. user123",
  "auth.field.emailPlaceholder": "jij@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Gelezen {0}",
  "bubble.tick.delivered": "Bezorgd {0}",
  "bubble.tick.sent": "Verzonden",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Je hebt deze gebruiker geblokkeerd.",
  "chat.preview.image": "Afbeelding",
  "chat.preview.video": "Video",
  "chat.preview.voice": "Spraakbericht",
  "chat.preview.audio": "Audio",
  "error.push.denied": "Je hebt de notificatietoestemming geweigerd.",
  "error.push.noSw": "Deze browser ondersteunt geen service workers.",
  "error.push.noPush": "Deze browser ondersteunt geen pushnotificaties.",
  "error.push.noVapid": "De server leverde de VAPID-sleutel niet.",
  "error.push.activateFailed": "Activeren mislukt ({0}).",
  "chat.group.membersWord": "leden",
  "chat.newCall.title": "Nieuw gesprek",
  "chat.newChat.title": "Nieuwe chat",
  "chat.newCall.empty": "Nog geen contacten. Voeg er een toe via de + in Chats.",
  "chat.unread.aria": "ongelezen berichten",
  "chat.calls.title": "Gesprekken",
  "chat.calls.empty": "Nog geen gesprekken. Begin er een vanuit een chat met een contact.",
  "chat.calls.callContact": "Bel een contact",
  "chat.calls.historySoon": "Gespreksgeschiedenis komt binnenkort beschikbaar.",
  "chat.deleteConv.titleOne": "Gesprek verwijderen",
  "chat.deleteConv.titleMany": "{0} gesprekken verwijderen",
  "chat.deleteConv.hint": "\"Voor mij\" verwijdert jouw kopie (al je apparaten). \"Voor iedereen\" vraagt ook het contact om te verwijderen.",
  "chat.deleteConv.forMe": "Verwijderen voor mij",
  "chat.deleteConv.forAll": "Verwijderen voor iedereen",
  "chat.myContacts": "Mijn contacten",
  "chat.contacts.noResults": "Geen resultaten.",
  "chat.contacts.empty": "Nog geen contacten.",
  "chat.contact.badgeBlocked": "geblokkeerd",
  "chat.contact.badgePending": "onbevestigd",
  "chat.toast.saved": "Opgeslagen",
  "chat.toast.videoSaved": "Video opgeslagen in Foto's",
  "chat.toast.imageSaved": "Afbeelding opgeslagen in Foto's",
  "chat.toast.updateTestflight": "Werk TestFlight bij naar 1.0(10)+ om op te slaan.",
  "chat.toast.saveFailed": "Opslaan mislukt: {0}",
  "chat.toast.saveError": "Fout bij opslaan",
  "iko.banner.exitAria": "De IKO verlaten en terug naar het algemene vlak",
  "iko.liturgy.entering": "IKO binnengaan",
  "iko.liturgy.returning": "Terugkeren",
  "iko.liturgy.toIkognit": "naar IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Persoonlijke IKO",
  "manifest.blindServer": "De server is blind.",
  "manifest.onlyYouRead": "Alleen jij leest hier.",
  "manifest.noPublicProfiles": "Geen openbare profielen.",
  "manifest.noAdsNoClouds": "Geen advertenties. Geen externe clouds.",
  "manifest.keyWithYou": "De sleutel woont bij jou.",
  "manifest.yourIkoYourSpaces": "Jouw IKO. Jouw ruimtes.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Bestanden",
  "orb.mod.notes": "Notities",
  "orb.mod.photos": "Foto's",
  "orb.mod.vault": "Map",
  "orb.mod.audios": "Audio's",
  "orb.copy.line1": "Jouw IKO.",
  "orb.copy.line2": "Jouw ruimtes.",
  "explorer.filesNotProcessed": "Niet-verwerkte bestand(en)",
  "demo.edit": "Bewerken",
  "common.exit": "Afsluiten",
  "common.more": "Meer",
  "chat.tab.settings": "Instellingen",
  "chat.search.placeholder": "Chat zoeken",
  "chat.presence.online": "online",
  "chat.action.call": "Bellen",
  "chat.action.videoCall": "Videogesprek",
  "chat.attach.label": "Bijvoegen",
  "chat.attach.camera": "Camera",
  "chat.attach.voice": "Stem",
  "chat.attach.file": "Bestand bijvoegen",
  "chat.composer.placeholder": "Typ een bericht...",
  "settings.addYourName": "Voeg je naam toe",
  "settings.editProfile": "Profiel bewerken",
  "chat.welcome.intro": "Selecteer een chat om end-to-end versleuteld te beginnen.",

  // Batch2: footer atajos web
  "web.footer.palette": "palet",
  "web.footer.send": "verzenden",
  "web.footer.line": "regel",
  "mobile.tb.ikoActivate": "IKO activeren",
  "mobile.tb.ikoExit": "Terug naar algemene IKOGNIT",

  "chat.header.blocked": "Geblokkeerd",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Privénotitie",
  "settings.account.newNickPlaceholder": "nieuwe_nick",
  "settings.account.newEmailPlaceholder": "nieuw@email.com",


  "common.delete": "Verwijderen",








};

const pl: Catalog = {
  "auth.verify.notSent": "Nie udało się wysłać kodu. Twoje konto istnieje: za chwilę naciśnij «Wyślij kod ponownie».",
  "lg.rotulo": "Komunikator z prywatnymi przestrzeniami",
  "lg.btn.entrar": "Zaloguj się",
  "lg.eyebrow": "Prywatny komunikator · Itrion Software",
  "lg.h1a": "Twoje zwykłe rozmowy.",
  "lg.h1b": "I miejsce, które istnieje tylko wtedy, gdy je przywołasz.",
  "lg.lead1": "Rozmawiasz z rodziną, przyjaciółmi i zespołem, jak w każdej aplikacji. Różnica zaczyna się, gdy otwierasz IKO: własną przestrzeń, do której wchodzi się, wpisując sekret znany tylko tym, którzy są w środku.",
  "lg.lead2": "Dopóki go nie przywołasz, tej przestrzeni nie ma na twoim urządzeniu — ani w telefonie, ani na tablecie, ani na komputerze. Nie chodzi o to, że jest zaszyfrowana.",
  "lg.lead2b": "Po prostu jej nie ma.",
  "lg.pruebalo": "Spróbuj · wpisz sekret i zobacz, co się stanie",
  "lg.panel.plano": "Plan ogólny",
  "lg.demo.hilos": "Rodzina=Mama: zjemy w niedzielę u nas?=19:04|Marta=wysyłam ci zdjęcia z soboty=17:52|Zespół=Luis: jutro o dziewiątej, czyli=Wczoraj|Javi=haha nie wierzę=Wczoraj",
  "lg.demo.mundos": "Tylko my dwoje~schowałeś tam, gdzie mówiliśmy?|tak. akt i paszport>~Akt notarialny.pdf=2,4 MB|Prywatne zdjęcia=214|Karta · bank=Dane~~Sprawy domowe~zostawiam ci tu umowę najmu>|i klucz do routera, bo ciągle go gubisz~Umowa najmu.pdf=1,1 MB|Kopia dowodu=2 pliki|Klucze do domu=Dane~~Moje notatki~nikomu o tym nie mówiłem>|i nie trzeba>~Dziennik=48 notatek|Zdjęcia=1207|Rozliczenia roczne=Dane~~Projekt Lizbona~oferta wychodzi na 180|jest, bez kopii na zewnątrz>~Oferta_v4.pdf=860 KB|Kontakty=12|Karta firmowa=Dane~~Sobotni obiad~nie mów jeszcze nic Marcie|spokojnie, tu nikt się nie dowie>~Rezerwacja.pdf=120 KB|Zdjęcia z zeszłego roku=63|Lista gości=Dane",
  "lg.invocaLabel": "Przywołaj swoje IKO",
  "lg.invocaPlaceholder": "wpisz jakikolwiek sekret",
  "lg.invocaBtn": "Przywołaj",
  "lg.invocaHint": "Każde słowo prowadzi do innej przestrzeni. Spróbuj innego.",
  "lg.estela.vacio": "Wpisz cokolwiek: to jest pokaz.",
  "lg.estela.primero": "Jest. Istnieje tylko, dopóki jesteś w środku.",
  "lg.estela.otro": "Inny sekret, inna przestrzeń. Żadna nie wie o pozostałych.",
  "lg.estela.salida": "Zniknęła. Żadnego śladu na urządzeniu. Spróbuj innego słowa.",
  "lg.ikoActivo": "IKO aktywne",
  "lg.nadaEnDispositivo": "Nic z tego nie ma na urządzeniu",
  "lg.salirIko": "Wyjdź z IKO",
  "lg.planos.h2a": "Jeden plan na widoku.",
  "lg.planos.h2b": "Pod spodem te, które przywołasz.",
  "lg.planos.lead": "Nie ma czegoś takiego jak «to IKO». Są te, które otworzysz: jedno na sprawy domowe, drugie do pracy, trzecie znane tylko wam dwojgu, czwarte, o którym nikomu nie powiedziałeś. Każdy sekret prowadzi do swojego, i żadne nie wie o pozostałych.",
  "lg.planos.unoRotulo": "Plan ogólny · jeden",
  "lg.planos.unoH3": "Gdzie rozmawiasz ze wszystkimi",
  "lg.planos.unoP": "Rozmowy, grupy, połączenia, zdjęcia i pliki, szyfrowane end-to-end. To, czego oczekujesz od komunikatora, zrobione porządnie. Twoje zwykłe czaty mieszkają tutaj i zachowują się jak zawsze.",
  "lg.planos.nRotulo": "IKO · tyle, ile chcesz",
  "lg.planos.nH3": "Gdzie nie dociera nikt inny",
  "lg.planos.nP": "Wpisujesz sekret i pojawia się odpowiadająca mu przestrzeń. Mieszczą się w niej rozmowy i twoje rzeczy. Gdy wychodzisz, znika z urządzenia bez śladu. Nie ma listy, nie ma liczby i nikt nie ustali, ile ich masz ani czy w ogóle istnieje choć jedno.",
  "lg.planos.chips": "Sprawy domowe|Praca|To, co wiecie tylko we dwoje|Twoje i niczyje więcej|To otwarte raz i nigdy więcej|Te, o których zdecydujesz jutro",
  "lg.forense.h2a": "To nie jest zaszyfrowane na twoim urządzeniu.",
  "lg.forense.h2b": "Tego nie ma na twoim urządzeniu.",
  "lg.forense.lead": "Inne aplikacje trzymają twoje wiadomości na urządzeniu i je szyfrują. Jeśli ktoś je zabierze, twoja prywatność zależy od tego, czy szyfrowanie wytrzyma wystarczająco długo. Tu nie ma nic, co musiałoby wytrzymać: to, co żyje w IKO, nie zapisuje się na żadnym urządzeniu. Przywołujesz, używasz, znika.",
  "lg.forense.multi": "Wszędzie tak samo: telefon, tablet, komputer w domu, laptop z pracy, Windows, Mac albo przeglądarka w cudzym miejscu. Wchodzisz, gdzie chcesz, a gdy wychodzisz, to miejsce znów nic o tobie nie wie.",
  "lg.forense.caption": "Co znajdzie ktoś, kto zbada którekolwiek z twoich urządzeń",
  "lg.forense.filas": "Wiadomości z twoich IKO=0|Pliki i zdjęcia z twoich IKO=0|Zapisane sekrety IKO=0|Baza z twoimi IKO=nie istnieje|Ślad, że IKO było otwarte=żaden|Ile masz IKO=nie do ustalenia",
  "lg.escenas.h2": "To, co naprawdę cię martwi.",
  "lg.escenas.filas": "«Zgubiłem telefon.»=Twoja prywatność nie zniknęła razem z nim. To, co było w IKO, nigdy nie było na tym urządzeniu, więc nie ma czego ratować ani czego się bać. Przywołujesz je z dowolnego innego urządzenia i wszystko jest tam, gdzie było.~«Ktoś zabrał mi laptopa.»=Zobaczy twoje zwykłe rozmowy, te same co w każdej aplikacji. Z reszty nie zobaczy ani treści, ani nazwy, ani śladu, że istnieje.~«Zbadali mój komputer.»=Analiza śledcza odzyskuje to, co zapisane na dysku, nawet zaszyfrowane i skasowane. Tu nie ma nic zapisanego do odzyskania. Odpowiedź nie brzmi «nie da się odszyfrować»: po prostu nic nie ma. Tak samo na tablecie, w telefonie i w przeglądarce, z której korzystałeś jedno popołudnie.",
  "lg.ciego.h2": "Ani my. Ani ten, kto hostuje serwery.",
  "lg.ciego.p1": "Serwer przechowuje rzeczy, których nie potrafi odczytać. Nie ma twojego sekretu, nigdy go nie miał i nigdzie nie istnieje żadna kopia. Nie chodzi o to, że odmawiamy wydania tego, co jest w twoich IKO: my tego nie mamy i nie ma sposobu, żebyśmy mieli. Ani firma, która hostuje maszyny, ani nikt, kto by je przejął.",
  "lg.ciego.p2": "To ma swoją cenę i wypada ją powiedzieć: jeśli stracisz sekret, nikt ci go nie odda. Dokładnie ten sam powód, dla którego nikt inny nie wejdzie, sprawia, że my też nie pomożemy ci wejść.",
  "lg.guardas": "Zdjęcia rodzinne|Notatki, których nie pokazujesz|Karty i dane bankowe|Hasła|Dokumenty|Rozmowy, które dotyczą tylko was",
  "lg.nombre.esta": "jest",
  "lg.nombre.noEsta": "nie ma",
  "lg.nombre.h2": "Stąd nazwa.",
  "lg.nombre.p": "W suahili iko znaczy «jest», a haiko — «nie ma». IKO jest, dopóki je przywołujesz. Przez resztę czasu — czyli prawie zawsze — go nie ma: ani na twoich urządzeniach, ani na czyichś oczach, ani nawet jako podejrzenie.",
  "lg.cierre.h2": "Zacznij rozmawiać.",
  "lg.cierre.p": "Używa się tego jak każdego komunikatora, na telefonie, tablecie i komputerze. IKO są na miejscu tego dnia, w którym ich potrzebujesz.",
  "lg.cierre.btnCrear": "Załóż konto",
  "lg.cierre.btnEntrar": "Mam już konto",
  "lg.cierre.pago": "IKOGNIT to produkt płatny. Bez reklam, bez profili reklamowych i bez żadnej naszej kopii czegokolwiek: żyjemy z tego, że aplikacja jest dla ciebie warta swojej ceny, a nie z tego, co w niej powiesz.",
  "lg.pie.ciego": "Ślepy serwer",
  "auth.hola": "Znowu cześć.",
  "auth.queEs": "Czym jest IKOGNIT?",
  "common.cancel": "Anuluj",
  "common.error.generic": "Nie udało się. Spróbuj ponownie.",
  "common.save": "Zapisz",
  "common.confirm": "Potwierdź",
  "common.close": "Zamknij",
  "common.add": "Dodaj",
  "common.back": "Wstecz",
  "common.tagline": "Suwerenność cyfrowa.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "W suahili iko znaczy „jest”. A haiko — „nie ma”.",
  "auth.legal.age": "Potwierdzam, że osiągnąłem(-am) minimalny wiek wymagany przez prawo mojego kraju do korzystania z IKOGNIT.",
  "auth.legal.accept": "Przeczytałem(-am) i akceptuję <a href='https://ikognit.org/legal/pl/regulamin.html' target='_blank' rel='noopener'>Regulamin</a>, <a href='https://ikognit.org/legal/pl/prywatnosc.html' target='_blank' rel='noopener'>Politykę Prywatności</a> oraz <a href='https://ikognit.org/legal/pl/zasady-spolecznosci.html' target='_blank' rel='noopener'>Zasady Społeczności</a>.",
  "recovery.title": "Twój klucz odzyskiwania",
  "recovery.intro": "Te **24 słowa** to jedyny sposób odzyskania konta i historii, jeśli zapomnisz hasła lub stracisz urządzenie. **Zapisz je na papierze i przechowuj w bezpiecznym miejscu.** Nikt w IKOGNIT nie może ich odzyskać za Ciebie.",
  "recovery.warn": "**Zapisz je OFFLINE.** Nie rób zrzutu ekranu. Nie wysyłaj ich e-mailem ani komunikatorem. Kto ma te słowa, kontroluje całe Twoje konto.",
  "recovery.btn.show": "Pokaż słowa",
  "recovery.btn.copy": "Kopiuj",
  "recovery.btn.copied": "Skopiowano · wyczyści się za {0}s",
  "recovery.btn.cleared": "Schowek wyczyszczony",
  "recovery.btn.copyAria": "Skopiuj frazę odzyskiwania do schowka (zostanie automatycznie wyczyszczona)",
  "recovery.btn.download": "Pobierz",
  "recovery.btn.downloadAria": "Pobierz frazę jako plik tekstowy",
  "recovery.btn.back": "Powrót do wyświetlenia słów",
  "recovery.btn.continue": "Dalej",
  "recovery.btn.done": "Skończyłem(-am)",
  "recovery.btn.need3": "Wpisz 3 poprawne słowa",
  "recovery.verify.intro": "Aby potwierdzić, że zapisałeś(-aś) klucz, wpisz te słowa. Nie możesz kontynuować bez ich poprawnego wpisania.",
  "recovery.verify.wordN": "Słowo #{0}",
  "recovery.verify.correct": "Poprawnie",
  "recovery.verify.wrong": "Błędnie",
  "auth.error.legalRequired": "Musisz zaakceptować warunki prawne i potwierdzić swój wiek, aby utworzyć IKOGNIT ID.",
  "settings.legal.title": "Informacje prawne",
  "settings.legal.hub": "Centrum Prawne",
  "settings.legal.terms": "Regulamin",
  "settings.legal.privacy": "Polityka Prywatności",
  "settings.legal.rules": "Zasady Społeczności",
  "settings.legal.report": "Zgłoszenia i Moderacja",
  "settings.legal.cookies": "Polityka Cookies",
  "settings.legal.minors": "Polityka dot. Małoletnich",
  "settings.legal.notice": "Nota Prawna",
  "settings.tab.legal": "Prawne",
  "auth.loading": "Ładowanie…",
  "auth.savedSession": "To urządzenie zna już swojego właściciela.",
  "auth.locked": "Rozwiało się po bezczynności. Wejdź ponownie.",
  "auth.sessionExpired": "Sesja się rozwiała. Wejdź ponownie.",
  "auth.tab.login": "Zaloguj się",
  "auth.tab.register": "Nowy IKOGNIT ID",
  "auth.subLogin": "Wchodzisz na plan ogólny: twoje zwykłe rozmowy. IKO nie przywołuje się tutaj — przywołujesz je w środku, kiedy ich potrzebujesz.",
  "auth.subRegister": "Konto jest zapisane na ciebie. Nick to sposób, w jaki cię widzą; e-mail służy tylko do odzyskania dostępu i do powiadomień.",
  "auth.field.devicePin": "Klucz główny",
  "auth.field.password": "Klucz główny",
  "auth.btn.unlock": "Zaloguj",
  "auth.btn.unlocking": "Logowanie…",
  "auth.btn.processing": "Przetwarzanie…",
  "auth.btn.createIdentity": "Utwórz IKOGNIT ID",
  "auth.btn.useOther": "Użyj innego IKOGNIT ID",
  "auth.btn.forget": "Zapomnij to urządzenie",
  "auth.btn.backToUnlock": "Wstecz",
  "auth.confirmForget": "To urządzenie przestanie cię rozpoznawać: znika zapisane konto i wszystko z pamięci podręcznej. Aby wrócić, będziesz potrzebować hasła.",
  "auth.confirmForget.warning": "Bez zapisanej 24-wyrazowej frazy odzyskiwania nie ma powrotu: nikt ci jej nie zwróci.",
  "invite.welcomeSub": "Wiadomości i własna przestrzeń: to, co tu przechowujesz, jest zapisane na ciebie. Załóż konto, a będziecie połączeni.",
  "auth.reset.warnNewIdentity": "Konto pozostaje twoje, ale odzyskiwanie przez e-mail daje ci nową tożsamość: wcześniejszych wiadomości nie da się już odczytać. Jeśli masz 24-wyrazową frazę odzyskiwania, wybierz tamtą drogę.",
  "recover.intro": "Wpisz swój nick lub e-mail oraz 24 słowa odzyskiwania otrzymane przy zakładaniu konta. Następnie wybierzesz nowe hasło.",
  "auth.error.badCreds": "Nieprawidłowy IKOGNIT ID lub klucz.",
  "auth.error.userNotFound": "Nie znaleziono IKOGNIT ID.",
  "auth.error.cantConnect": "Nie można połączyć się z serwerem.",
  "auth.error.badPin": "Nieprawidłowy klucz.",
  "auth.footnote": "Kto jest właścicielem, odpowiada.\nJeśli stracisz hasło,\nnie ma do kogo się zwrócić.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Aktualny IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "IKO Osobisty: {0}",
  "sidebar.freqPsh": "IKO Domeny: {0}",
  "sidebar.tune": "Aktywuj IKO",
  "sidebar.exitFreq": "Wróć do IKOGNIT",
  "sidebar.notifications": "Powiadomienia",
  "sidebar.remember": "Zapamiętaj urządzenie",
  "sidebar.forget": "Zapomnij urządzenie",
  "sidebar.addContact": "Dodaj kontakt po nick",
  "sidebar.newGroup": "Nowa grupa",
  "sidebar.settings": "Ustawienia",
  "sidebar.logout": "Wyloguj",
  "sidebar.tooltip.logout": "Wyloguj i usuń wszystkie lokalne dane",
  "sidebar.savedFreq.tooltip": "Aktywuj {0}",
  "chat.empty": "Wybierz lub dodaj kontakt",
  "welcome.title": "Witaj w IKOGNIT",
  "welcome.concept": "W IKOGNIT rozmawiasz z innymi użytkownikami, identyfikowany przez swój nick. Gdy chcesz odrębną przestrzeń, aktywujesz IKO i wchodzisz do IKO. Jeśli jest Publiczny, spotkasz tych, którzy też go aktywują. Jeśli jest Prywatny, wchodzisz do IKO, w którym istniejesz tylko ty.",
  "welcome.step1": "Aktywuj Publiczny IKO i wejdź do IKO z tymi, którzy też go znają.",
  "welcome.step2": "Tutaj w IKOGNIT, dodaj nick jako kontakt i zacznij rozmawiać.",
  "welcome.step3": "Aktywuj Prywatny IKO i otwórz IKO tylko dla siebie, w którym przechowujesz pliki, zdjęcia, audio, wideo, hasła, notatki i listy.",
  "welcome.multidevice": "IKO nigdy nie są nigdzie przechowywane. Jeśli zapomnisz IKO, jego IKO przestaje istnieć dla ciebie.",
  "welcome.btnFreq": "Aktywuj IKO",
  "welcome.btnContacts": "Dodaj kontakt",
  "push.btnOn": "Powiadomienia WŁ.",
  "push.btnOff": "Powiadomienia WYŁ.",
  "push.btnEnable": "Powiadomienia wyłączone. Kliknij, aby włączyć.",
  "push.btnDisable": "Powiadomienia włączone. Kliknij, aby wyłączyć.",
  "push.introTitle": "Przed włączeniem powiadomień",
  "push.introBody": "Ze względu na prywatność powiadomienia IKOGNIT różnią się od innych aplikacji do wiadomości:",
  "push.introBullet1": "Treść wiadomości nie jest dołączana.",
  "push.introBullet2": "Imię ani IKOGNIT ID nadawcy nie są wyświetlane.",
  "push.introBullet3": "Otrzymasz tylko alert \"nowa wiadomość\"; otwórz aplikację, aby ją odczytać zaszyfrowaną na swoim urządzeniu.",
  "push.introConfirm": "Włącz powiadomienia",
  "chat.placeholder": "Napisz wiadomość…",
  "chat.newMessages": "nowych",
  "chat.newMessagesBadge": "Przejdź do {0} nowych wiadomości",
  "chat.mediaRetry": "Spróbuj ponownie",
  "chat.mediaFailed": "Nie udało się załadować",
  "chat.media.download": "Pobierz",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Edytuj wiadomość…",
  "chat.replyingTo": "Odpowiadasz {0}",
  "chat.editing": "Edycja wiadomości",
  "chat.confirmContact": "Dodaj do kontaktów",
  "chat.unconfirmedBanner": "Ten użytkownik napisał do ciebie, ale nie jest w twoich kontaktach. Dopóki go nie dodasz, twoje zdjęcie i info nie będą dla niego widoczne zgodnie z twoimi ustawieniami prywatności.",
  "chat.online": "online",
  "chat.lastSeen": "ostatnio widziany {0}",
  "chat.tooltip.attach": "Załącz plik",
  "chat.tooltip.shareContact": "Udostępnij kontakt",
  "chat.tooltip.paste": "Wklej obraz ze schowka",
  "chat.tooltip.stickers": "Stickery",
  "chat.tooltip.callAudio": "Połączenie głosowe",
  "chat.tooltip.callVideo": "Wideopołączenie",
  "chat.btn.send": "Wyślij",
  "chat.uploading": "…",
  "preview.image": "📷 Obraz",
  "preview.video": "🎬 Wideo",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Odpowiedz",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Edytuj",
  "bubble.edited": "edytowane",
  "bubble.contact.label": "Kontakt IKOGNIT",
  "bubble.media.decrypting": "Odszyfrowywanie…",
  "bubble.media.failed": "Nie udało się odszyfrować pliku.",
  "call.calling": "Dzwonię…",
  "call.incoming.audio": "Połączenie przychodzące",
  "call.incoming.video": "Wideopołączenie przychodzące",
  "call.connecting": "Łączenie…",
  "call.ending": "Kończenie…",
  "call.accept": "Akceptuj",
  "call.reject": "Odrzuć",
  "call.hangup": "Rozłącz",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Wyjście audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Aby zadzwonić, musisz być wewnątrz IKO.",
  "error.notFound": "Nie znaleziono zasobu.",
  "error.notInFreq": "{0} nie jest jeszcze w tym IKO. Poproś przez inny kanał, aby go aktywował.",
  "error.push.iosTooOld": "Twój iOS jest starszy niż 16.4. Zaktualizuj, aby otrzymywać powiadomienia.",
  "error.push.iosNotStandalone": "Aby otrzymywać powiadomienia na iPhonie, zainstaluj IKOGNIT na ekranie głównym: dotknij Udostępnij → Dodaj do ekranu głównego.",
  "error.expired": "Sesja wygasła. Zaloguj się ponownie.",
  "error.gone": "Plik wygasł.",
  "error.invalid": "Nieprawidłowe dane.",
  "error.server": "Błąd serwera. Spróbuj ponownie.",
  "error.network": "Brak połączenia z serwerem.",
  "error.cantStartCall": "Nie można rozpocząć połączenia: {0}",
  "error.cantAcceptCall": "Nie można przyjąć połączenia: {0}",
  "error.cantPaste": "Nie można uzyskać dostępu do schowka. Spróbuj przycisku załącz.",
  "error.noImageInClipboard": "Brak obrazu w schowku.",
  "error.clipboardUnsupported": "Twoja przeglądarka nie pozwala na odczyt schowka. Wklej Ctrl+V lub użyj przycisku załącz.",
  "error.selfContact": "Nie możesz dodać samego siebie.",
  "error.blocked": "Zablokowałeś tego użytkownika. Odblokuj w Ustawieniach, aby znów rozmawiać.",
  "settings.title": "Ustawienia",
  "settings.close": "Zamknij",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Prywatność",
  "settings.tab.messages": "✉ Wiadomości",
  "settings.tab.blocked": "🚫 Zablokowani",
  "settings.tab.notifications": "🔔 Powiadomienia",
  "settings.tab.session": "⏱ Sesja",
  "settings.tab.account": "🆔 Konto",
  "settings.tab.language": "🌐 Język",
  "settings.tab.about": "ℹ O aplikacji",
  "settings.scope.global": "Globalne (IKOGNIT)",
  "settings.scope.freq": "Tylko w {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Te wartości są używane domyślnie i dziedziczone we wszystkich IKO.",
  "settings.profile.hintFreq": "Nadpisują profil globalny, gdy jesteś w {0}. Jeśli nie zdefiniujesz czegoś tutaj, dziedziczone z globalnego.",
  "settings.profile.displayName": "Nazwa wyświetlana",
  "settings.profile.displayNamePh.global": "(brak nazwy — zostanie wyświetlony twój nick)",
  "settings.profile.displayNamePh.freq": "(dziedziczy z globalnego)",
  "settings.profile.photo": "Zdjęcie profilowe",
  "settings.profile.changePhoto": "Zmień zdjęcie",
  "settings.profile.removePhoto": "Usuń zdjęcie",
  "settings.profile.adjustPhoto": "Dostosuj zdjęcie",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Cześć, używam IKOGNIT",
  "settings.profile.removeOverride": "Usuń nadpisanie z {0}",
  "settings.profile.warn": "Zmiany zostaną wysłane do pozostałych kontaktów automatycznie, gdy będziesz z nimi wchodzić w interakcję w tym IKO.",
  "settings.privacy.title": "Prywatność",
  "settings.privacy.hintGlobal": "Skonfiguruj, kto domyślnie może widzieć każdą z twoich informacji.",
  "settings.privacy.hintFreq": "Nadpisz te reguły tylko, gdy jesteś w {0}.",
  "settings.privacy.showPhoto": "Kto widzi moje zdjęcie",
  "settings.privacy.showInfo": "Kto widzi moje info / status",
  "settings.privacy.showLastSeen": "Kto widzi moje ostatnie połączenie",
  "settings.privacy.showOnline": "Kto widzi, czy jestem online",
  "settings.privacy.whoAdds": "Kto może dodać mnie do grup",
  "settings.privacy.readReceipts": "Potwierdzenia odczytu",
  "settings.privacy.readReceiptsHint": "Jeśli wyłączone, niebieskie ptaszki nie są wysyłane, gdy czytasz wiadomości. Nie zobaczysz też tych od innych.",
  "settings.vis.all": "Wszyscy",
  "settings.vis.contacts": "Moje kontakty",
  "settings.vis.none": "Nikt",
  "settings.messages.title": "Wiadomości",
  "settings.messages.ttl": "Domyślna wygaśnięcie",
  "settings.messages.ttlHint": "Wiadomości, które wyślesz, zostaną usunięte z serwera po tym czasie. Możesz wybrać inną wartość przy załączaniu pliku.",
  "settings.blocked.title": "Zablokowani",
  "settings.blocked.hint": "Zablokowani użytkownicy nie mogą wysyłać ci wiadomości. Ty też nie możesz im.",
  "settings.blocked.placeholder": "IKOGNIT ID do zablokowania",
  "settings.blocked.btn": "Zablokuj",
  "settings.blocked.unblock": "Odblokuj",
  "settings.blocked.empty": "Nie masz nikogo zablokowanego.",
  "settings.notif.title": "Powiadomienia",
  "settings.notif.sound": "Dźwięk",
  "settings.notif.preview": "Pokaż podgląd wiadomości",
  "settings.notif.vibration": "Wibracje (mobilne)",
  "settings.notif.hint": "Powiadomienia push przeglądarki są emitowane tylko dla wiadomości w ogólnym IKOGNIT, bez treści ani nazwy nadawcy (z założenia).",
  "settings.session.title": "Sesja",
  "settings.session.timeout": "Zamknij IKO po bezczynności",
  "settings.session.timeoutHint": "Jeśli spędzisz ten czas bez dotykania aplikacji, aktywny IKO zostanie automatycznie dezaktywowany i wrócisz do IKOGNIT. \"Nigdy\" utrzymuje IKO, dopóki nie zamkniesz aplikacji.",
  "settings.session.remember": "Pamiętaj aktywowane IKO",
  "settings.session.rememberHint": "Jeśli włączone, aktywowane IKO pojawiają się jako skróty w pasku bocznym. Każdy, kto widzi twój ekran, może wiedzieć, w jakich IKO byłeś, więc domyślnie wyłączone. Wyłączenie kasuje już zapisane.",
  "settings.account.title": "Konto",
  "settings.account.email": "Opcjonalny e-mail (tylko do odzyskiwania, nigdy nie publikowany)",
  "settings.account.emailPh": "email@przyklad.com",
  "settings.account.changePassword": "Zmień hasło",
  "settings.account.currentPw": "Aktualne hasło",
  "settings.account.newPw": "Nowe hasło (min. 8)",
  "settings.account.confirmPw": "Powtórz nowe",
  "settings.account.saving": "Zapisywanie…",
  "settings.account.success": "Hasło zaktualizowane.",
  "settings.account.errPwBad": "Aktualne hasło jest nieprawidłowe.",
  "settings.account.errPwShort": "Nowe hasło musi mieć co najmniej 8 znaków.",
  "settings.account.errPwMismatch": "Hasła nie pasują.",
  "settings.language.title": "Język",
  "settings.language.hint": "Wybierz język interfejsu. Twoja preferencja jest zapisana na tym urządzeniu.",
  "settings.about.title": "O IKOGNIT",
  "settings.about.version": "Wersja",
  "settings.about.tech": "Szyfrowanie E2E z NaCl box (X25519). IKO: pochodna Argon2id + deterministyczny HMAC. Lokalna szyfrowana persystencja z Argon2id na PIN.",
  "modal.freq.title": "Aktywuj IKO",
  "modal.freq.hint": "IKO to dokładne IKO jednego z twoich IKO. Publiczny: spotykasz tych, którzy piszą te same. Prywatny: docierasz do IKO, w którym jesteś niewidzialny, nawet jeśli ktoś inny zapisze te same IKO.",
  "modal.freq.placeholder": "Wpisz swoje IKO",
  "modal.freq.activate": "Aktywuj",
  "modal.freq.deriving": "Obliczanie IKO…",
  "modal.freq.warn": "IKO nie są nigdzie zapisywane. Jeśli je zapomnisz, ten IKO przestaje istnieć dla ciebie.",
  "modal.freq.errShort": "IKO musi mieć co najmniej 8 znaków.",
  "modal.freq.errCommon": "Ten IKO jest zbyt powszechny. Wybierz coś unikalnego.",
  "modal.freq.errRepeat": "Nie używaj pojedynczego powtórzonego znaku.",
  "modal.freq.errSeqNum": "Unikaj oczywistych sekwencji numerycznych.",
  "modal.freq.errSeqAlpha": "Unikaj sekwencji alfabetycznych.",
  "billing.title": "Rozliczenia",
  "billing.manage": "Zarządzaj",
  "billing.seats": "Miejsca",
  "billing.renews": "Odnowienie",
  "billing.needsUpgrade": "Osiągnięto limit miejsc w twoim progu. Zwiększ próg, aby dodać więcej.",
  "billing.upgradeTo": "Zwiększ próg ({price}/miejsce)",
  "billing.portal": "Zarządzaj płatnością",
  "join.loginToAccept": "Zaloguj / Utwórz konto",
  "private.badge": "PRYWATNE",
  "private.welcome.title": "Twój Prywatny IKO",
  "private.welcome.intro": "Jesteś na IKO, gdzie nikt cię nie widzi. Nawet gdyby inna osoba zapisała ten sam IKO, dotarłaby do innego IKO. Tutaj bezpiecznie przechowujesz swoje rzeczy.",
  "private.welcome.hint": "Wybierz sekcję, aby rozpocząć.",
  "private.mod.notes": "Notatki",
  "private.mod.notes.desc": "Notatki, listy, dziennik.",
  "private.mod.files": "Pliki",
  "private.mod.files.desc": "Dokumenty, arkusze, PDF.",
  "private.mod.photos": "Zdjęcia",
  "private.mod.photos.desc": "Twoja prywatna galeria.",
  "private.mod.videos": "Filmy",
  "private.mod.videos.desc": "Twoje osobiste filmy.",
  "private.mod.audios": "Audio",
  "private.mod.audios.desc": "Nagrania i notatki głosowe.",
  "private.mod.vault": "Hasła",
  "private.mod.vault.desc": "Hasła, karty, tożsamości, klucze SSH i to, czego potrzebujesz.",
  "private.mod.iko": "Moje IKO",
  "private.mod.iko.desc": "Twoje zapisane IKO, gotowe do aktywacji.",
  "savediko.intro": "Trzymaj tu te IKO, których nie chcesz pamiętać. Pamiętasz jeden, a reszta mieszka w środku.",
  "savediko.empty": "Nie zapisałeś jeszcze żadnego IKO.",
  "savediko.add": "Zapisz IKO",
  "savediko.activate": "Aktywuj IKO",
  "savediko.formNew": "Zapisz IKO",
  "savediko.formEdit": "Edytuj zapisany IKO",
  "savediko.descLabel": "Opis",
  "savediko.descPh": "Opis, aby rozpoznać go później",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "Wpisz IKO",
  "savediko.errDesc": "Wpisz opis.",
  "savediko.errIko": "Wpisz IKO.",
  "savediko.confirmDel": "Usunąć?",
  "vault.new": "Nowy element",
  "vault.edit": "Edytuj",
  "vault.delete": "Usuń",
  "vault.save": "Zapisz",
  "vault.show": "Pokaż",
  "vault.hide": "Ukryj",
  "vault.copy": "Kopiuj",
  "vault.copied": "Skopiowane ✓",
  "vault.search": "Szukaj…",
  "vault.empty": "Twój folder jest pusty. Utwórz pierwszy element.",
  "vault.noMatches": "Żaden element nie pasuje do wyszukiwania.",
  "vault.untitled": "Bez nazwy",
  "vault.startHint": "Wybierz element po lewej lub utwórz nowy.",
  "vault.confirmDelete": "Usunąć ten element? Nie można go odzyskać.",
  "vault.notes": "Notatki",
  "vault.sensitive": "Wrażliwe",
  "vault.sensitiveHint": "Pola wrażliwe są domyślnie ukryte i mogą być kopiowane do schowka.",
  "vault.removeField": "Usuń to pole",
  "vault.addField": "Dodaj pole",
  "vault.fieldSingular": "pole",
  "vault.fieldPlural": "pola",
  "vault.type.login": "Login",
  "vault.type.card": "Karta",
  "vault.type.identity": "Tożsamość",
  "vault.type.sshkey": "Klucz SSH",
  "vault.type.custom": "Niestandardowy",
  "vault.field.name": "Nazwa",
  "vault.field.name.ph": "Jak to nazywasz?",
  "vault.field.labelPh": "Etykieta pola",
  "vault.field.newField": "Pole",
  "vault.field.username": "Użytkownik",
  "vault.field.password": "Hasło",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Posiadacz",
  "vault.field.cardBrand": "Marka",
  "vault.field.cardNumber": "Numer",
  "vault.field.cardExpiry": "Ważność (MM/RR)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Imię",
  "vault.field.lastname": "Nazwisko",
  "vault.field.dni": "Dowód osobisty",
  "vault.field.address": "Adres",
  "vault.field.city": "Miasto",
  "vault.field.zip": "Kod pocztowy",
  "vault.field.country": "Kraj",
  "vault.field.phone": "Telefon",
  "vault.field.email": "E-mail",
  "vault.field.birthdate": "Data urodzenia",
  "vault.field.sshPrivate": "Klucz prywatny",
  "vault.field.sshPublic": "Klucz publiczny",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Tekst",
  "vault.ft.password": "Hasło",
  "vault.ft.textarea": "Długi tekst",
  "vault.ft.date": "Data",
  "vault.ft.url": "URL",
  "vault.ft.email": "E-mail",
  "vault.ft.number": "Liczba",
  "vault.tpl.title": "Szablony",
  "vault.tpl.manage": "Zarządzaj szablonami",
  "vault.tpl.yours": "Twoje szablony",
  "vault.tpl.new": "Nowy szablon",
  "vault.tpl.edit": "Edytuj szablon",
  "vault.tpl.empty": "Nie masz jeszcze szablonów. Utwórz jeden, aby zdefiniować własny typ elementu.",
  "vault.tpl.name": "Nazwa szablonu",
  "vault.tpl.name.ph": "Np.: Portfel krypto, Rezerwacja hotelu…",
  "vault.tpl.confirmDelete": "Usunąć ten szablon? Elementy utworzone z niego pozostają.",
  "totp.copyCode": "Kopiuj kod",
  "totp.copySecret": "Kopiuj secret",
  "totp.showSecret": "Pokaż secret",
  "totp.hideSecret": "Ukryj secret",
  "totp.invalid": "nieprawidłowy secret",
  "private.module.coming": "Wkrótce.",
  "private.module.comingHint": "Ten moduł będzie dostępny wkrótce. Kryptografia Prywatnego IKO już działa — wkrótce będziesz mógł przechowywać tu to, czego potrzebujesz.",
  "notes.new": "Nowa notatka",
  "notes.empty": "Nie masz jeszcze notatek w tym Wszechświecie.",
  "notes.emptyPreview": "(pusta)",
  "notes.untitled": "Bez tytułu",
  "notes.delete": "Usuń notatkę",
  "notes.confirmDelete": "Usunąć tę notatkę? Nie można jej odzyskać.",
  "notes.titlePlaceholder": "Tytuł",
  "notes.contentPlaceholder": "Zapisz, co musisz pamiętać…",
  "notes.startHint": "Brak notatek w tym Wszechświecie. Utwórz pierwszą.",
  "notes.autosaveHint": "Zapisywane automatycznie, zaszyfrowane, tylko tutaj.",
  "notes.yesterday": "Wczoraj",
  "passwords.new": "Nowy wpis",
  "passwords.empty": "Nie zapisałeś jeszcze niczego w tym Wszechświecie.",
  "passwords.untitled": "Bez nazwy",
  "passwords.startHint": "Brak haseł w tym Wszechświecie. Utwórz pierwsze.",
  "passwords.confirmDelete": "Usunąć ten wpis? Nie można go odzyskać.",
  "passwords.save": "Zapisz",
  "passwords.edit": "Edytuj",
  "passwords.delete": "Usuń",
  "passwords.copy": "Kopiuj",
  "passwords.copied": "Skopiowane ✓",
  "passwords.show": "Pokaż",
  "passwords.hide": "Ukryj",
  "passwords.field.label": "Nazwa",
  "passwords.field.label.ph": "Bank, konto, usługa…",
  "passwords.field.username": "Użytkownik",
  "passwords.field.username.ph": "E-mail, alias, numer…",
  "passwords.field.password": "Hasło",
  "passwords.field.password.ph": "Hasło, które chcesz zapisać",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Notatki",
  "passwords.field.notes.ph": "Każdy przydatny szczegół",
  "media.uploading": "Przesyłanie…",
  "media.uploadFailed": "Nie udało się przesłać pliku.",
  "media.upload.file": "Prześlij plik",
  "media.upload.photo": "Prześlij zdjęcie",
  "media.upload.video": "Prześlij wideo",
  "media.upload.audio": "Prześlij audio",
  "media.empty.file": "Brak plików w tym Wszechświecie.",
  "media.empty.photo": "Brak zdjęć w tym Wszechświecie.",
  "media.empty.video": "Brak filmów w tym Wszechświecie.",
  "media.empty.audio": "Brak audio w tym Wszechświecie.",
  "media.play": "Odtwórz",
  "media.download": "Pobierz",
  "media.delete": "Usuń",
  "media.confirmDelete": "Usunąć ten element? Nie można go odzyskać.",
  "media.noPreview": "Brak podglądu dla tego typu pliku.",
  "modal.share.title": "Udostępnij kontakt",
  "modal.share.hint": "Wybierz kontakt z listy lub wprowadź IKOGNIT ID ręcznie.",
  "modal.share.filter": "Filtruj kontakty…",
  "modal.share.empty": "Brak kontaktów w tym IKO",
  "modal.share.manual": "Lub ręczny IKOGNIT ID",
  "modal.share.btn": "Udostępnij",
  "modal.group.title": "Nowa grupa",
  "modal.group.hint": "Wybierz nazwę i wybierz członków z kontaktów w tym IKO.",
  "modal.group.namePh": "Nazwa grupy",
  "modal.group.selected": "Wybrano: {0}",
  "modal.group.create": "Utwórz grupę",
  "modal.remember.title": "Zapamiętaj to urządzenie",
  "modal.remember.hint": "Twoja sesja, kontakty, grupy i wiadomości zostaną zapisane na tym urządzeniu, zaszyfrowane PIN-em, który znasz tylko ty. Po ponownym otwarciu aplikacji wprowadzisz PIN, aby odblokować.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Powtórz PIN",
  "modal.remember.warn": "Jeśli zapomnisz PIN-u, zapisane dane nie będą mogły być odzyskane. Będziesz musiał zalogować się ponownie z użytkownikiem i hasłem.",
  "modal.remember.errShort": "PIN musi mieć co najmniej 4 znaki.",
  "modal.remember.errMismatch": "PIN-y nie pasują.",
  "stickers.faces": "Twarze",
  "stickers.gestures": "Gesty",
  "stickers.hearts": "Serca",
  "stickers.symbols": "Symbole",
  "stickers.animals": "Zwierzęta",
  "stickers.food": "Jedzenie",
  "ttl.1h": "1 godzina",
  "ttl.1d": "1 dzień",
  "ttl.1w": "1 tydzień",
  "ttl.1m": "1 miesiąc",
  "ttl.6m": "6 miesięcy",
  "ttl.12m": "12 miesięcy",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nigdy",
  "toast.newMessage": "Nowa wiadomość",
  "toast.group": "{0} (grupa)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informacje i nawigacja po uniwersum",
  "ctx.section.universe": "BIEŻĄCE UNIWERSUM",
  "ctx.universe.personal": "Twoja osobista przestrzeń",
  "ctx.status.serverBlind": "Ślepy serwer aktywny",
  "ctx.status.e2e": "Szyfrowanie end-to-end",
  "ctx.section.nav": "NAWIGACJA",
  "ctx.nav.changeIko": "Zmień IKO",
  "ctx.nav.activateIko": "Aktywuj IKO",
  "ctx.nav.backToIkognit": "Powrót do IKOGNIT",
  "ctx.section.actions": "AKCJE",
  "ctx.action.newChat": "Nowy czat",
  "ctx.action.newGroup": "Nowa grupa",
  "ctx.action.contacts": "Moje kontakty",
  "ctx.section.conversation": "ROZMOWA",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} wiadomości",
  "ctx.peer.message": "{0} wiadomość",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "IKO Osobisty",
  "ctx.modes.storage": "Napęd",
  "ctx.liturgy.0": "Serwer jest ślepy.",
  "ctx.liturgy.1": "Tu czytasz tylko ty.",
  "ctx.liturgy.2": "Nikt nie wie, że tu jesteś.",
  "ctx.liturgy.3": "IKO to sekret, który znasz tylko ty.",
  "ctx.liturgy.4": "Twoja prywatność to architektura.",
  "ccb.universe.changeOrExit": "Zmień IKO lub wyjdź",
  "ccb.universe.activate": "Aktywuj IKO",
  "ccb.leave.title": "Wyjdź z IKO (powrót do IKOGNIT)",
  "ccb.leave.aria": "Wyjdź z IKO",
  "ccb.tag.cipher.title": "Aktywne szyfrowanie symetryczne",
  "ccb.tag.srv.title": "Serwer nie może czytać treści",
  "ccb.tag.unread.title": "Nieprzeczytane wiadomości",
  "ccb.settings.title": "Ustawienia · profil, motywy, sesja",
  "ccb.settings.aria": "Ustawienia",
  "ccb.identity.title": "Sesja: @{0}",
  "ccb.clock.title": "Czas lokalny",
  "ccb.modes.personalPrefix": "OSOBISTY · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "IKO OSOBISTY",
  "holo.modes.general": "TWÓJ NICK + KONTAKTY",
  "holo.claim.inIko": "Ten IKO pozostaje niewidoczny dla nieznających go.",
  "holo.claim.general": "Twoja osobista przestrzeń w IKOGNIT. Tu rozmawiasz ze swoimi kontaktami.",
  "holo.card.conversations": "Rozmowy",
  "holo.card.contacts": "Kontakty",
  "holo.card.cipher": "Szyfrowanie",
  "holo.card.server": "Serwer",
  "holo.foot": "Wybierz rozmowę, aktywuj IKO lub utwórz nową przestrzeń.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "IKO Osobisty",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "Uniwersum ogólne",
  "uib.e2e.title": "Serwer nie może czytać twojej treści — szyfrowanie E2E twoim kluczem",
  "uib.e2e.label": "Ślepy serwer",
  "uib.pseudoTitle": "Twój pseudonim w tym IKO",
  "uib.nickTitle": "Twój nick",
  "uib.exitTitle": "Powrót do Uniwersum ogólnego",
  "uib.exitLabel": "Wyjdź",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Nawigacja główna",
  "chat.tab.chats": "Czaty",
  "chat.tab.calls": "Połączenia",
  "chat.tab.contacts": "Kontakty",
  "chat.backToIkognit.title": "Powrót do ogólnego IKOGNIT",
  "chat.delete.title": "Usuń",
  "chat.delete.aria": "Usuń",
  "chat.call.title": "Zadzwoń",
  "chat.videoCall.title": "Rozmowa wideo",
  "chat.videoCall.aria": "Rozmowa wideo z {0}",
  "chat.search.clear": "Wyczyść wyszukiwanie",
  "chat.filters.aria": "Filtry czatów",
  "chat.filter.all": "Wszystkie",
  "chat.filter.unread": "Nieprzeczytane",
  "chat.filter.groups": "Grupy",
  "chat.attachPending": "Załącznik oczekujący",
  "chat.remove.title": "Usuń",
  "chat.cancel.title": "Anuluj",
  "chat.blocked.text": "Zablokowałeś {0}. Nie możesz wysyłać wiadomości ani dzwonić.",
  "chat.unblock": "Odblokuj",
  "contacts.alias.placeholder": "Alias do rozpoznania",
  "contacts.notes.placeholder": "Tylko ty ją widzisz (zaszyfrowana na serwerze).",
  "contacts.search.placeholder": "Szukaj po aliasie lub IKOGNIT ID",
  "contacts.edit.title": "Edytuj alias i notatkę",
  "contacts.edit.aria": "Edytuj",
  "contacts.blockBtn": "Zablokuj kontakt",
  "contacts.unblockBtn": "Odblokuj kontakt",
  "contacts.confirmBlock.title": "Zablokuj kontakt",
  "contacts.confirmUnblock.title": "Odblokuj kontakt",
  "contacts.confirmBlock.body": "Zablokować {0}? Nie będziesz otrzymywać wiadomości ani połączeń.",
  "contacts.confirmUnblock.body": "Odblokować {0}? Znów będziesz otrzymywać wiadomości.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Kategorie IKO Osobistego",
  "piko.rail.head": "OSOBISTY",
  "piko.cat.all": "Wszystko",
  "piko.cat.photos": "Zdjęcia",
  "piko.cat.videos": "Filmy",
  "piko.cat.audios": "Audio",
  "piko.cat.files": "Pliki",
  "piko.cat.notes": "Notatki",
  "piko.cat.passwords": "Hasła",
  "piko.cat.cards": "Karty",
  "piko.cat.identities": "Tożsamości",
  "piko.cat.sshkeys": "Klucze SSH",
  "piko.cat.custom": "Sejfy",
  "piko.cat.agendas": "Katalogi IKO",
  "piko.cat.storage": "Dysky i Dyski",

  "auth.field.nickPlaceholder": "np. user123",
  "auth.field.emailPlaceholder": "ty@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Przeczytano {0}",
  "bubble.tick.delivered": "Dostarczono {0}",
  "bubble.tick.sent": "Wysłano",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Zablokowałeś tego użytkownika.",
  "chat.preview.image": "Zdjęcie",
  "chat.preview.video": "Wideo",
  "chat.preview.voice": "Wiadomość głosowa",
  "chat.preview.audio": "Dźwięk",
  "error.push.denied": "Odmówiłeś zgody na powiadomienia.",
  "error.push.noSw": "Ta przeglądarka nie obsługuje service workers.",
  "error.push.noPush": "Ta przeglądarka nie obsługuje powiadomień push.",
  "error.push.noVapid": "Serwer nie dostarczył klucza VAPID.",
  "error.push.activateFailed": "Nie udało się aktywować ({0}).",
  "chat.group.membersWord": "członków",
  "chat.newCall.title": "Nowe połączenie",
  "chat.newChat.title": "Nowy czat",
  "chat.newCall.empty": "Brak kontaktów. Dodaj jeden z + w Czatach.",
  "chat.unread.aria": "nieprzeczytane wiadomości",
  "chat.calls.title": "Połączenia",
  "chat.calls.empty": "Brak połączeń. Rozpocznij jedno z czatu z kontaktem.",
  "chat.calls.callContact": "Zadzwoń do kontaktu",
  "chat.calls.historySoon": "Historia połączeń wkrótce będzie dostępna.",
  "chat.deleteConv.titleOne": "Usuń konwersację",
  "chat.deleteConv.titleMany": "Usuń {0} konwersacji",
  "chat.deleteConv.hint": "\"Dla mnie\" usuwa twoją kopię (wszystkie urządzenia). \"Dla wszystkich\" prosi też kontakt o usunięcie.",
  "chat.deleteConv.forMe": "Usuń dla mnie",
  "chat.deleteConv.forAll": "Usuń dla wszystkich",
  "chat.myContacts": "Moje kontakty",
  "chat.contacts.noResults": "Brak wyników.",
  "chat.contacts.empty": "Brak kontaktów.",
  "chat.contact.badgeBlocked": "zablokowany",
  "chat.contact.badgePending": "niepotwierdzony",
  "chat.toast.saved": "Zapisano",
  "chat.toast.videoSaved": "Wideo zapisane w Zdjęciach",
  "chat.toast.imageSaved": "Zdjęcie zapisane w Zdjęciach",
  "chat.toast.updateTestflight": "Zaktualizuj TestFlight do 1.0(10)+, aby zapisać.",
  "chat.toast.saveFailed": "Nie udało się zapisać: {0}",
  "chat.toast.saveError": "Błąd zapisu",
  "iko.banner.exitAria": "Wyjdź z IKO i wróć do planu ogólnego",
  "iko.liturgy.entering": "Wchodzenie do IKO",
  "iko.liturgy.returning": "Powrót",
  "iko.liturgy.toIkognit": "do IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Osobisty IKO",
  "manifest.blindServer": "Serwer jest ślepy.",
  "manifest.onlyYouRead": "Tu czytasz tylko ty.",
  "manifest.noPublicProfiles": "Bez publicznych profili.",
  "manifest.noAdsNoClouds": "Bez reklam. Bez obcych chmur.",
  "manifest.keyWithYou": "Klucz mieszka z tobą.",
  "manifest.yourIkoYourSpaces": "Twoje IKO. Twoje przestrzenie.",
  "orb.mod.chat": "Czat",
  "orb.mod.files": "Pliki",
  "orb.mod.notes": "Notatki",
  "orb.mod.photos": "Zdjęcia",
  "orb.mod.vault": "Sejf",
  "orb.mod.audios": "Dźwięki",
  "orb.copy.line1": "Twoje IKO.",
  "orb.copy.line2": "Twoje przestrzenie.",
  "explorer.filesNotProcessed": "Nieprzetworzone pliki",
  "demo.edit": "Edytuj",
  "common.exit": "Wyjdź",
  "common.more": "Więcej",
  "chat.tab.settings": "Ustawienia",
  "chat.search.placeholder": "Szukaj czatu",
  "chat.presence.online": "online",
  "chat.action.call": "Zadzwoń",
  "chat.action.videoCall": "Wideorozmowa",
  "chat.attach.label": "Załącz",
  "chat.attach.camera": "Aparat",
  "chat.attach.voice": "Głos",
  "chat.attach.file": "Załącz plik",
  "chat.composer.placeholder": "Napisz wiadomość...",
  "settings.addYourName": "Dodaj swoje imię",
  "settings.editProfile": "Edytuj profil",
  "chat.welcome.intro": "Wybierz czat, aby rozpocząć szyfrowaną rozmowę end-to-end.",

  // Batch2: footer atajos web
  "web.footer.palette": "paleta",
  "web.footer.send": "wyślij",
  "web.footer.line": "wiersz",
  "mobile.tb.ikoActivate": "Aktywuj IKO",
  "mobile.tb.ikoExit": "Wróć do ogólnego IKOGNIT",

  "chat.header.blocked": "Zablokowany",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Prywatna notatka",
  "settings.account.newNickPlaceholder": "nowy_nick",
  "settings.account.newEmailPlaceholder": "nowy@email.com",


  "common.delete": "Usuń",








};

const cs: Catalog = {
  "auth.verify.notSent": "Kód se nepodařilo odeslat. Tvůj účet existuje: za chvíli stiskni «Poslat kód znovu».",
  "lg.rotulo": "Zprávy se soukromými prostory",
  "lg.btn.entrar": "Přihlásit se",
  "lg.eyebrow": "Soukromé zprávy · Itrion Software",
  "lg.h1a": "Tvoje obvyklé konverzace.",
  "lg.h1b": "A místo, které existuje, jen když ho přivoláš.",
  "lg.lead1": "Mluvíš s rodinou, s přáteli a se svým týmem jako v každé aplikaci. Rozdíl začíná ve chvíli, kdy otevřeš IKO: vlastní prostor, do kterého se vstupuje napsáním tajemství, jež znají jen ti, kdo jsou uvnitř.",
  "lg.lead2": "Dokud ho nepřivoláš, ten prostor ve tvém zařízení není — ani v telefonu, ani v tabletu, ani v počítači. Není to tak, že by byl zašifrovaný.",
  "lg.lead2b": "Prostě tam není.",
  "lg.pruebalo": "Vyzkoušej si to · napiš tajemství a podívej se, co se stane",
  "lg.panel.plano": "Obecná rovina",
  "lg.demo.hilos": "Rodina=Mamka: dáme si v neděli večeři u nás?=19:04|Marta=posílám ti fotky ze soboty=17:52|Tým=Luis: zítra v devět, tak=Včera|Javi=haha tomu nevěřím=Včera",
  "lg.demo.mundos": "Jen my dva~dal jsi to tam, kde jsme říkali?|ano. listinu a pas>~Listina k bytu.pdf=2,4 MB|Soukromé fotky=214|Karta · banka=Údaje~~Věci z domu~nechávám ti tu nájemní smlouvu>|a klíč k routeru, pořád ho ztrácíš~Nájemní smlouva.pdf=1,1 MB|Kopie občanky=2 soubory|Klíče od domu=Údaje~~Moje poznámky~tohle jsem nikomu neřekl>|a ani není potřeba>~Deník=48 poznámek|Fotky=1207|Roční účty=Údaje~~Projekt Lisabon~nabídka vychází na 180|tady je, žádné kopie venku>~Nabídka_v4.pdf=860 KB|Kontakty=12|Firemní karta=Údaje~~Sobotní oběd~Martě zatím nic neříkej|klid, tady se to nikdo nedozví>~Rezervace.pdf=120 KB|Fotky z loňska=63|Seznam hostů=Údaje",
  "lg.invocaLabel": "Přivolej své IKO",
  "lg.invocaPlaceholder": "napiš jakékoli tajemství",
  "lg.invocaBtn": "Přivolat",
  "lg.invocaHint": "Každé slovo vede do jiného prostoru. Zkus jiné.",
  "lg.estela.vacio": "Napiš cokoli: tohle je ukázka.",
  "lg.estela.primero": "Je tu. Existuje, jen dokud jsi uvnitř.",
  "lg.estela.otro": "Jiné tajemství, jiný prostor. Žádný neví o ostatních.",
  "lg.estela.salida": "Je pryč. Na zařízení nezůstala stopa. Zkus jiné slovo.",
  "lg.ikoActivo": "IKO aktivní",
  "lg.nadaEnDispositivo": "Nic z toho není v zařízení",
  "lg.salirIko": "Opustit IKO",
  "lg.planos.h2a": "Jedna rovina na očích.",
  "lg.planos.h2b": "Pod ní ty, které přivoláš.",
  "lg.planos.lead": "Neexistuje «to IKO». Existují ta, která otevřeš: jedno na domácí věci, druhé do práce, třetí, které znáte jen dva, čtvrté, o kterém jsi nikomu neřekl. Každé tajemství vede ke svému a žádné neví o ostatních.",
  "lg.planos.unoRotulo": "Obecná rovina · jedna",
  "lg.planos.unoH3": "Kde mluvíš se všemi",
  "lg.planos.unoP": "Konverzace, skupiny, hovory, fotky a soubory, šifrované end-to-end. To, co od komunikátoru čekáš, udělané pořádně. Tvoje obvyklé chaty bydlí tady a chovají se jako vždycky.",
  "lg.planos.nRotulo": "IKO · kolik chceš",
  "lg.planos.nH3": "Kam se nikdo jiný nedostane",
  "lg.planos.nP": "Napíšeš tajemství a objeví se odpovídající prostor. Vejdou se do něj konverzace i tvoje věci. Když odejdeš, zmizí ze zařízení beze stopy. Není seznam, není počet a nikdo nezjistí, kolik jich máš, ani že vůbec nějaké existuje.",
  "lg.planos.chips": "Domácí věci|Práce|To, co víte jen dva|Tvoje a ničí jiné|To, co jsi otevřel jednou a už nikdy|Ta, o kterých rozhodneš zítra",
  "lg.forense.h2a": "Není to zašifrované ve tvém zařízení.",
  "lg.forense.h2b": "Není to ve tvém zařízení.",
  "lg.forense.lead": "Ostatní aplikace drží tvoje zprávy v přístroji a šifrují je. Když ho někdo odnese, tvoje soukromí závisí na tom, jestli to šifrování vydrží dost dlouho. Tady není nic, co by muselo vydržet: to, co žije uvnitř IKO, se nezapisuje do žádného zařízení. Přivolá se, použije a zmizí.",
  "lg.forense.multi": "Všude stejně: telefon, tablet, počítač doma, notebook z práce, Windows, Mac nebo prohlížeč na cizím místě. Vejdeš, kam chceš, a když odejdeš, to místo o tobě zase nic neví.",
  "lg.forense.caption": "Co najde ten, kdo prohledá kterékoli z tvých zařízení",
  "lg.forense.filas": "Zprávy z tvých IKO=0|Soubory a fotky z tvých IKO=0|Uložená tajemství IKO=0|Databáze s tvými IKO=neexistuje|Stopa, že bylo IKO otevřené=žádná|Kolik máš IKO=nezjistitelné",
  "lg.escenas.h2": "To, co tě opravdu trápí.",
  "lg.escenas.filas": "«Ztratil jsem telefon.»=Tvoje soukromí s ním neodešlo. To, co bylo uvnitř IKO, na tom přístroji nikdy nebylo, takže není co zachraňovat ani čeho se bát. Přivoláš ho z kteréhokoli jiného zařízení a všechno je tam, kde bylo.~«Někdo mi vzal notebook.»=Uvidí tvoje běžné konverzace, ty samé jako v jakékoli aplikaci. Ze zbytku neuvidí obsah, ani název, ani náznak, že něco existuje.~«Prohledali mi počítač.»=Forenzní analýza obnoví to, co je zapsané na disku, i zašifrované a smazané. Tady není nic zapsaného, co by šlo obnovit. Odpověď nezní «nedá se to rozšifrovat»: prostě tam nic není. A stejně tak v tabletu, v telefonu i v prohlížeči, který jsi jedno odpoledne použil.",
  "lg.ciego.h2": "Ani my. Ani ten, kdo hostuje servery.",
  "lg.ciego.p1": "Server uchovává věci, které neumí přečíst. Nemá tvoje tajemství, nikdy ho neměl a nikde neexistuje žádná kopie. Není to tak, že bychom odmítali vydat, co je uvnitř tvých IKO: my to nemáme a nemáme jak to mít. Ani firma, která ty stroje hostuje, ani nikdo, kdo by na ně sáhl.",
  "lg.ciego.p2": "Má to svou cenu a je správné ji říct: když ztratíš svoje tajemství, nikdo ti ho nevrátí. Přesně ten důvod, proč se dovnitř nedostane nikdo jiný, je důvod, proč ti dovnitř nepomůžeme ani my.",
  "lg.guardas": "Rodinné fotky|Poznámky, které neukazuješ|Karty a bankovní údaje|Hesla|Dokumenty|Konverzace, které se týkají jen vás",
  "lg.nombre.esta": "je tu",
  "lg.nombre.noEsta": "není tu",
  "lg.nombre.h2": "Odtud to jméno.",
  "lg.nombre.p": "Ve svahilštině iko znamená «je tu» a haiko «není tu». IKO tu je, dokud ho přivoláváš. Po zbytek času — a to je skoro pořád — tu není: ani v tvých zařízeních, ani nikomu na očích, ani jako podezření.",
  "lg.cierre.h2": "Začni mluvit.",
  "lg.cierre.p": "Používá se jako každý komunikátor, na telefonu, na tabletu i na počítači. IKO tu jsou v den, kdy je budeš potřebovat.",
  "lg.cierre.btnCrear": "Vytvořit účet",
  "lg.cierre.btnEntrar": "Účet už mám",
  "lg.cierre.pago": "IKOGNIT je placený produkt. Žádné reklamy, žádné reklamní profily a u nás žádná kopie ničeho: živíme se tím, že se ti aplikace vyplatí, ne tím, co v ní řekneš.",
  "lg.pie.ciego": "Slepý server",
  "auth.hola": "Zase ahoj.",
  "auth.queEs": "Co je IKOGNIT?",
  "common.cancel": "Zrušit",
  "common.error.generic": "Nepovedlo se. Zkus to znovu.",
  "common.save": "Uložit",
  "common.confirm": "Potvrdit",
  "common.close": "Zavřít",
  "common.add": "Přidat",
  "common.back": "Zpět",
  "common.tagline": "Digitální suverenita.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "Ve svahilštině iko znamená „je tu“. A haiko — „není tu“.",
  "auth.legal.age": "Potvrzuji, že splňuji minimální věk vyžadovaný zákony mé země pro používání IKOGNIT.",
  "auth.legal.accept": "Přečetl(a) jsem si a souhlasím s <a href='https://ikognit.org/legal/cs/podminky.html' target='_blank' rel='noopener'>Podmínkami</a>, <a href='https://ikognit.org/legal/cs/soukromi.html' target='_blank' rel='noopener'>Zásadami ochrany soukromí</a> a <a href='https://ikognit.org/legal/cs/pravidla-komunity.html' target='_blank' rel='noopener'>Pravidly komunity</a>.",
  "recovery.title": "Tvůj klíč pro obnovení",
  "recovery.intro": "Těchto **24 slov** je jediný způsob, jak obnovit účet a historii, pokud zapomeneš heslo nebo ztratíš zařízení. **Zapiš si je na papír a ulož na bezpečné místo.** Nikdo v IKOGNIT je za tebe nemůže obnovit.",
  "recovery.warn": "**Zapiš si je OFFLINE.** Nedělej snímek obrazovky. Neposílej je e-mailem ani zprávami. Kdo má tato slova, ovládá celý tvůj účet.",
  "recovery.btn.show": "Zobrazit slova",
  "recovery.btn.copy": "Kopírovat",
  "recovery.btn.copied": "Zkopírováno · smaže se za {0}s",
  "recovery.btn.cleared": "Schránka vymazána",
  "recovery.btn.copyAria": "Zkopírovat frázi pro obnovení do schránky (bude automaticky smazána)",
  "recovery.btn.download": "Stáhnout",
  "recovery.btn.downloadAria": "Stáhnout frázi jako textový soubor",
  "recovery.btn.back": "Zpět k zobrazení slov",
  "recovery.btn.continue": "Pokračovat",
  "recovery.btn.done": "Hotovo",
  "recovery.btn.need3": "Napiš 3 správná slova",
  "recovery.verify.intro": "Pro potvrzení, že jsi klíč uložil(a), napiš tato slova. Bez správného zadání nemůžeš pokračovat.",
  "recovery.verify.wordN": "Slovo #{0}",
  "recovery.verify.correct": "Správně",
  "recovery.verify.wrong": "Špatně",
  "auth.error.legalRequired": "Pro vytvoření IKOGNIT ID musíte přijmout právní podmínky a potvrdit svůj věk.",
  "settings.legal.title": "Právní informace",
  "settings.legal.hub": "Právní centrum",
  "settings.legal.terms": "Podmínky použití",
  "settings.legal.privacy": "Zásady ochrany soukromí",
  "settings.legal.rules": "Pravidla komunity",
  "settings.legal.report": "Hlášení a moderace",
  "settings.legal.cookies": "Zásady cookies",
  "settings.legal.minors": "Zásady pro nezletilé",
  "settings.legal.notice": "Právní upozornění",
  "settings.tab.legal": "Právní",
  "auth.loading": "Načítání…",
  "auth.savedSession": "Toto zařízení už zná svého majitele.",
  "auth.locked": "Po nečinnosti se to rozplynulo. Vejdi znovu.",
  "auth.sessionExpired": "Relace se rozplynula. Vejdi znovu.",
  "auth.tab.login": "Přihlásit se",
  "auth.tab.register": "Nové IKOGNIT ID",
  "auth.subLogin": "Vstupuješ do obecné roviny: tvoje obvyklé konverzace. Tvoje IKO se nepřivolávají tady — přivolávají se uvnitř, až je budeš potřebovat.",
  "auth.subRegister": "Účet je vedený na tebe. Nick je to, jak tě vidí ostatní; e-mail slouží jen k obnovení přístupu a k oznámením.",
  "auth.field.devicePin": "Hlavní klíč",
  "auth.field.password": "Hlavní klíč",
  "auth.btn.unlock": "Přihlásit",
  "auth.btn.unlocking": "Přihlašování…",
  "auth.btn.processing": "Zpracování…",
  "auth.btn.createIdentity": "Vytvořit IKOGNIT ID",
  "auth.btn.useOther": "Použít jiné IKOGNIT ID",
  "auth.btn.forget": "Zapomenout toto zařízení",
  "auth.btn.backToUnlock": "Zpět",
  "auth.confirmForget": "Toto zařízení tě přestane poznávat: uložený účet i vše v mezipaměti se rozplyne. Pro návrat budeš potřebovat své heslo.",
  "auth.confirmForget.warning": "Bez zapsané 24slovné obnovovací fráze není cesty zpět: nikdo ti ji nevrátí.",
  "invite.welcomeSub": "Zprávy a vlastní prostor: co si tu uložíš, je vedené na tebe. Založ si účet a budete propojeni.",
  "auth.reset.warnNewIdentity": "Účet zůstává tvůj, ale obnova přes e-mail ti dá novou identitu: dřívější zprávy už nepůjde přečíst. Pokud máš 24slovnou obnovovací frázi, použij raději ji.",
  "recover.intro": "Zadej svůj nick nebo e-mail a 24 obnovovacích slov, která jsi dostal při založení účtu. Poté zvolíš nové heslo.",
  "auth.error.badCreds": "Nesprávné IKOGNIT ID nebo klíč.",
  "auth.error.userNotFound": "IKOGNIT ID nenalezeno.",
  "auth.error.cantConnect": "Nelze se připojit k serveru.",
  "auth.error.badPin": "Nesprávný klíč.",
  "auth.footnote": "Kdo je majitel, ten odpovídá.\nKdyž ztratíš heslo,\nnení se koho dovolávat.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Aktuální IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Osobní IKO: {0}",
  "sidebar.freqPsh": "Doménový IKO: {0}",
  "sidebar.tune": "Aktivovat IKO",
  "sidebar.exitFreq": "Zpět do IKOGNIT",
  "sidebar.notifications": "Oznámení",
  "sidebar.remember": "Zapamatovat zařízení",
  "sidebar.forget": "Zapomenout zařízení",
  "sidebar.addContact": "Přidat kontakt podle nick",
  "sidebar.newGroup": "Nová skupina",
  "sidebar.settings": "Nastavení",
  "sidebar.logout": "Odhlásit",
  "sidebar.tooltip.logout": "Odhlásit a vymazat vše lokální",
  "sidebar.savedFreq.tooltip": "Aktivovat {0}",
  "chat.empty": "Vyberte nebo přidejte kontakt",
  "welcome.title": "Vítejte v IKOGNIT",
  "welcome.concept": "V IKOGNIT hovoříte s ostatními uživateli, identifikováni svým nickem. Když chcete oddělený prostor, aktivujete IKO a vstoupíte do IKO. Pokud je Veřejný, setkáte se s těmi, kteří jej také aktivují. Pokud je Soukromý, vstoupíte do IKO, kde existujete pouze vy.",
  "welcome.step1": "Aktivujte Veřejný IKO a vstupte do IKO s těmi, kteří jej také znají.",
  "welcome.step2": "Zde v IKOGNIT přidejte nick jako kontakt a začněte mluvit.",
  "welcome.step3": "Aktivujte Soukromý IKO a otevřete IKO jen pro sebe, kde uchováváte soubory, fotky, audio, videa, hesla, poznámky a dopisy.",
  "welcome.multidevice": "IKO se nikde neukládají. Pokud IKO zapomenete, jeho IKO pro vás přestane existovat.",
  "welcome.btnFreq": "Aktivovat IKO",
  "welcome.btnContacts": "Přidat kontakt",
  "push.btnOn": "Oznámení ZAP",
  "push.btnOff": "Oznámení VYP",
  "push.btnEnable": "Oznámení vypnuta. Kliknutím zapnete.",
  "push.btnDisable": "Oznámení zapnuta. Kliknutím vypnete.",
  "push.introTitle": "Před zapnutím oznámení",
  "push.introBody": "Z důvodu soukromí jsou oznámení IKOGNIT odlišná od jiných aplikací pro zprávy:",
  "push.introBullet1": "Obsah zprávy není zahrnut.",
  "push.introBullet2": "Jméno ani IKOGNIT ID odesílatele se nezobrazují.",
  "push.introBullet3": "Obdržíte pouze upozornění \"nová zpráva\"; otevřete aplikaci a přečtěte si ji šifrovanou na svém zařízení.",
  "push.introConfirm": "Zapnout oznámení",
  "chat.placeholder": "Napište zprávu…",
  "chat.newMessages": "nových",
  "chat.newMessagesBadge": "Přejít na {0} nových zpráv",
  "chat.mediaRetry": "Zkusit znovu",
  "chat.mediaFailed": "Nepodařilo se načíst",
  "chat.media.download": "Stáhnout",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Upravit zprávu…",
  "chat.replyingTo": "Odpověď pro {0}",
  "chat.editing": "Úprava zprávy",
  "chat.confirmContact": "Přidat do kontaktů",
  "chat.unconfirmedBanner": "Tento uživatel vám napsal, ale není ve vašich kontaktech. Dokud jej nepřidáte, vaše foto a info pro něj nebudou viditelné podle vašich nastavení soukromí.",
  "chat.online": "online",
  "chat.lastSeen": "naposledy viděn {0}",
  "chat.tooltip.attach": "Připojit soubor",
  "chat.tooltip.shareContact": "Sdílet kontakt",
  "chat.tooltip.paste": "Vložit obrázek ze schránky",
  "chat.tooltip.stickers": "Samolepky",
  "chat.tooltip.callAudio": "Hlasový hovor",
  "chat.tooltip.callVideo": "Videohovor",
  "chat.btn.send": "Odeslat",
  "chat.uploading": "…",
  "preview.image": "📷 Obrázek",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Odpovědět",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Upravit",
  "bubble.edited": "upraveno",
  "bubble.contact.label": "Kontakt IKOGNIT",
  "bubble.media.decrypting": "Dešifrování…",
  "bubble.media.failed": "Soubor nelze dešifrovat.",
  "call.calling": "Volání…",
  "call.incoming.audio": "Příchozí hovor",
  "call.incoming.video": "Příchozí videohovor",
  "call.connecting": "Připojování…",
  "call.ending": "Ukončení…",
  "call.accept": "Přijmout",
  "call.reject": "Odmítnout",
  "call.hangup": "Zavěsit",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Výstup zvuku",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Pro volání musíte být uvnitř IKO.",
  "error.notFound": "Prostředek nenalezen.",
  "error.notInFreq": "{0} ještě není v tomto IKO. Požádejte ho jiným kanálem, aby jej aktivoval.",
  "error.push.iosTooOld": "Váš iOS je starší než 16.4. Aktualizujte pro příjem oznámení.",
  "error.push.iosNotStandalone": "Pro příjem oznámení na iPhone nainstalujte IKOGNIT na domovskou obrazovku: klepněte na Sdílet → Přidat na domovskou obrazovku.",
  "error.expired": "Relace vypršela. Přihlaste se znovu.",
  "error.gone": "Soubor vypršel.",
  "error.invalid": "Neplatná data.",
  "error.server": "Chyba serveru. Zkuste to znovu.",
  "error.network": "Žádné připojení k serveru.",
  "error.cantStartCall": "Nelze zahájit hovor: {0}",
  "error.cantAcceptCall": "Nelze přijmout hovor: {0}",
  "error.cantPaste": "Nelze přistupovat ke schránce. Zkuste tlačítko příloha.",
  "error.noImageInClipboard": "Ve schránce není žádný obrázek.",
  "error.clipboardUnsupported": "Váš prohlížeč neumožňuje čtení schránky. Vložte Ctrl+V nebo použijte tlačítko příloha.",
  "error.selfContact": "Nemůžete přidat sami sebe.",
  "error.blocked": "Tohoto uživatele jste zablokovali. Odblokujte v Nastavení, abyste mohli znovu mluvit.",
  "settings.title": "Nastavení",
  "settings.close": "Zavřít",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Soukromí",
  "settings.tab.messages": "✉ Zprávy",
  "settings.tab.blocked": "🚫 Blokovaní",
  "settings.tab.notifications": "🔔 Oznámení",
  "settings.tab.session": "⏱ Relace",
  "settings.tab.account": "🆔 Účet",
  "settings.tab.language": "🌐 Jazyk",
  "settings.tab.about": "ℹ O aplikaci",
  "settings.scope.global": "Globální (IKOGNIT)",
  "settings.scope.freq": "Pouze v {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Tyto hodnoty se používají výchozí a dědí se ve všech IKO.",
  "settings.profile.hintFreq": "Přepisují globální profil, když jste v {0}. Pokud zde něco nedefinujete, dědí se z globálního.",
  "settings.profile.displayName": "Zobrazované jméno",
  "settings.profile.displayNamePh.global": "(bez jména — zobrazí se vaše nick)",
  "settings.profile.displayNamePh.freq": "(dědí z globálního)",
  "settings.profile.photo": "Profilový obrázek",
  "settings.profile.changePhoto": "Změnit obrázek",
  "settings.profile.removePhoto": "Odstranit obrázek",
  "settings.profile.adjustPhoto": "Upravte obrázek",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Ahoj, používám IKOGNIT",
  "settings.profile.removeOverride": "Odstranit přepis z {0}",
  "settings.profile.warn": "Změny budou automaticky odeslány ostatním kontaktům, když s nimi budete v tomto IKO interagovat.",
  "settings.privacy.title": "Soukromí",
  "settings.privacy.hintGlobal": "Nakonfigurujte, kdo může výchozí vidět každou z vašich informací.",
  "settings.privacy.hintFreq": "Přepište tato pravidla pouze, když jste v {0}.",
  "settings.privacy.showPhoto": "Kdo vidí mou fotku",
  "settings.privacy.showInfo": "Kdo vidí mé info / status",
  "settings.privacy.showLastSeen": "Kdo vidí mé poslední připojení",
  "settings.privacy.showOnline": "Kdo vidí, jestli jsem online",
  "settings.privacy.whoAdds": "Kdo mě může přidat do skupin",
  "settings.privacy.readReceipts": "Potvrzení o přečtení",
  "settings.privacy.readReceiptsHint": "Pokud vypnuto, modré fajfky se neodesílají při čtení zpráv. Neuvidíte ani fajfky ostatních.",
  "settings.vis.all": "Všichni",
  "settings.vis.contacts": "Mé kontakty",
  "settings.vis.none": "Nikdo",
  "settings.messages.title": "Zprávy",
  "settings.messages.ttl": "Výchozí expirace",
  "settings.messages.ttlHint": "Zprávy, které odešlete, budou ze serveru smazány po této době. Můžete zvolit jinou hodnotu při připojení souboru.",
  "settings.blocked.title": "Blokovaní",
  "settings.blocked.hint": "Blokovaní uživatelé vám nemohou posílat zprávy. Ani vy jim.",
  "settings.blocked.placeholder": "IKOGNIT ID k blokování",
  "settings.blocked.btn": "Blokovat",
  "settings.blocked.unblock": "Odblokovat",
  "settings.blocked.empty": "Nemáte nikoho blokovaného.",
  "settings.notif.title": "Oznámení",
  "settings.notif.sound": "Zvuk",
  "settings.notif.preview": "Zobrazit náhled zprávy",
  "settings.notif.vibration": "Vibrace (mobil)",
  "settings.notif.hint": "Push oznámení prohlížeče jsou emitována pouze pro zprávy v obecném IKOGNIT, bez obsahu nebo jména odesílatele (záměrně).",
  "settings.session.title": "Relace",
  "settings.session.timeout": "Zavřít IKO po nečinnosti",
  "settings.session.timeoutHint": "Pokud strávíte tento čas bez dotyku aplikace, aktivní IKO bude automaticky deaktivován a vrátíte se do IKOGNIT. \"Nikdy\" udržuje IKO, dokud nezavřete aplikaci.",
  "settings.session.remember": "Zapamatovat aktivované IKO",
  "settings.session.rememberHint": "Pokud zapnuto, IKO, které aktivujete, se objeví jako zkratky v postranním panelu. Kdokoli vidí vaši obrazovku, mohl by vědět, do jakého IKO jste vstoupili, proto je výchozí vypnuto. Vypnutím se vymažou již uložené.",
  "settings.account.title": "Účet",
  "settings.account.email": "Volitelný e-mail (pouze pro obnovu, nikdy nezveřejněn)",
  "settings.account.emailPh": "email@priklad.com",
  "settings.account.changePassword": "Změnit heslo",
  "settings.account.currentPw": "Aktuální heslo",
  "settings.account.newPw": "Nové heslo (min. 8)",
  "settings.account.confirmPw": "Zopakujte nové",
  "settings.account.saving": "Ukládání…",
  "settings.account.success": "Heslo aktualizováno.",
  "settings.account.errPwBad": "Aktuální heslo není správné.",
  "settings.account.errPwShort": "Nové heslo musí mít alespoň 8 znaků.",
  "settings.account.errPwMismatch": "Hesla se neshodují.",
  "settings.language.title": "Jazyk",
  "settings.language.hint": "Zvolte jazyk rozhraní. Vaše preference je uložena v tomto zařízení.",
  "settings.about.title": "O IKOGNIT",
  "settings.about.version": "Verze",
  "settings.about.tech": "E2E šifrování s NaCl box (X25519). IKO: Argon2id derivace + deterministický HMAC. Lokální šifrovaná persistence s Argon2id přes PIN.",
  "modal.freq.title": "Aktivovat IKO",
  "modal.freq.hint": "IKO jsou přesné IKO jednoho z vašich IKO. Veřejný: potkáte ty, kdo napíší totéž. Soukromý: dosáhnete IKO, kde jste neviditelní, i když někdo jiný napíše stejné IKO.",
  "modal.freq.placeholder": "Napište své IKO",
  "modal.freq.activate": "Aktivovat",
  "modal.freq.deriving": "Výpočet IKO…",
  "modal.freq.warn": "IKO se nikde neukládají. Pokud je zapomenete, tento IKO pro vás přestane existovat.",
  "modal.freq.errShort": "IKO musí mít alespoň 8 znaků.",
  "modal.freq.errCommon": "Tento IKO je příliš běžný. Zvolte něco unikátního.",
  "modal.freq.errRepeat": "Nepoužívejte jediný opakovaný znak.",
  "modal.freq.errSeqNum": "Vyhněte se zřejmým číselným sekvencím.",
  "modal.freq.errSeqAlpha": "Vyhněte se abecedním sekvencím.",
  "billing.title": "Fakturace",
  "billing.manage": "Spravovat",
  "billing.seats": "Místa",
  "billing.renews": "Obnovení",
  "billing.needsUpgrade": "Dosáhli jste limitu vašeho pásma. Zvyšte pásmo, abyste přidali další místa.",
  "billing.upgradeTo": "Zvýšit pásmo ({price}/místo)",
  "billing.portal": "Spravovat platbu",
  "join.loginToAccept": "Přihlásit / Vytvořit účet",
  "private.badge": "SOUKROMÉ",
  "private.welcome.title": "Váš Soukromý IKO",
  "private.welcome.intro": "Jste na IKO, kde vás nikdo nevidí. I kdyby jiná osoba napsala stejný IKO, dorazila by do jiného IKO. Zde bezpečně uchováváte své věci.",
  "private.welcome.hint": "Zvolte sekci pro začátek.",
  "private.mod.notes": "Poznámky",
  "private.mod.notes.desc": "Poznámky, dopisy, deník.",
  "private.mod.files": "Soubory",
  "private.mod.files.desc": "Dokumenty, tabulky, PDF.",
  "private.mod.photos": "Fotky",
  "private.mod.photos.desc": "Vaše soukromá galerie.",
  "private.mod.videos": "Videa",
  "private.mod.videos.desc": "Vaše osobní videa.",
  "private.mod.audios": "Audia",
  "private.mod.audios.desc": "Nahrávky a hlasové poznámky.",
  "private.mod.vault": "Hesla",
  "private.mod.vault.desc": "Hesla, karty, identity, SSH klíče a co potřebujete.",
  "private.mod.iko": "Moje IKO",
  "private.mod.iko.desc": "Tvoje uložené IKO, připravené k aktivaci.",
  "savediko.intro": "Uchovávej tu IKO, která si nechceš pamatovat. Pamatuješ si jedno a zbytek žije uvnitř.",
  "savediko.empty": "Zatím sis neuložil žádný IKO.",
  "savediko.add": "Uložit IKO",
  "savediko.activate": "Aktivovat IKO",
  "savediko.formNew": "Uložit IKO",
  "savediko.formEdit": "Upravit uložený IKO",
  "savediko.descLabel": "Popis",
  "savediko.descPh": "Popis, abys to později poznal(a)",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "Napište IKO",
  "savediko.errDesc": "Zadej popis.",
  "savediko.errIko": "Napište IKO.",
  "savediko.confirmDel": "Smazat?",
  "vault.new": "Nový prvek",
  "vault.edit": "Upravit",
  "vault.delete": "Smazat",
  "vault.save": "Uložit",
  "vault.show": "Zobrazit",
  "vault.hide": "Skrýt",
  "vault.copy": "Kopírovat",
  "vault.copied": "Zkopírováno ✓",
  "vault.search": "Hledat…",
  "vault.empty": "Váš složka je prázdný. Vytvořte první prvek.",
  "vault.noMatches": "Žádný prvek neodpovídá vyhledávání.",
  "vault.untitled": "Bez názvu",
  "vault.startHint": "Vyberte prvek vlevo nebo vytvořte nový.",
  "vault.confirmDelete": "Smazat tento prvek? Nelze obnovit.",
  "vault.notes": "Poznámky",
  "vault.sensitive": "Citlivé",
  "vault.sensitiveHint": "Citlivá pole jsou výchozí skryta a lze je zkopírovat do schránky.",
  "vault.removeField": "Odstranit toto pole",
  "vault.addField": "Přidat pole",
  "vault.fieldSingular": "pole",
  "vault.fieldPlural": "polí",
  "vault.type.login": "Přihlášení",
  "vault.type.card": "Karta",
  "vault.type.identity": "Identita",
  "vault.type.sshkey": "SSH klíč",
  "vault.type.custom": "Vlastní",
  "vault.field.name": "Název",
  "vault.field.name.ph": "Jak tomu říkáte?",
  "vault.field.labelPh": "Štítek pole",
  "vault.field.newField": "Pole",
  "vault.field.username": "Uživatel",
  "vault.field.password": "Heslo",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Držitel",
  "vault.field.cardBrand": "Značka",
  "vault.field.cardNumber": "Číslo",
  "vault.field.cardExpiry": "Platnost (MM/RR)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Jméno",
  "vault.field.lastname": "Příjmení",
  "vault.field.dni": "Doklad",
  "vault.field.address": "Adresa",
  "vault.field.city": "Město",
  "vault.field.zip": "PSČ",
  "vault.field.country": "Země",
  "vault.field.phone": "Telefon",
  "vault.field.email": "E-mail",
  "vault.field.birthdate": "Datum narození",
  "vault.field.sshPrivate": "Soukromý klíč",
  "vault.field.sshPublic": "Veřejný klíč",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Text",
  "vault.ft.password": "Heslo",
  "vault.ft.textarea": "Dlouhý text",
  "vault.ft.date": "Datum",
  "vault.ft.url": "URL",
  "vault.ft.email": "E-mail",
  "vault.ft.number": "Číslo",
  "vault.tpl.title": "Šablony",
  "vault.tpl.manage": "Spravovat šablony",
  "vault.tpl.yours": "Vaše šablony",
  "vault.tpl.new": "Nová šablona",
  "vault.tpl.edit": "Upravit šablonu",
  "vault.tpl.empty": "Ještě nemáte šablony. Vytvořte jednu, abyste definovali vlastní typ prvku.",
  "vault.tpl.name": "Název šablony",
  "vault.tpl.name.ph": "Např.: Krypto peněženka, Rezervace hotelu…",
  "vault.tpl.confirmDelete": "Smazat tuto šablonu? Prvky z ní vytvořené zůstávají.",
  "totp.copyCode": "Kopírovat kód",
  "totp.copySecret": "Kopírovat secret",
  "totp.showSecret": "Zobrazit secret",
  "totp.hideSecret": "Skrýt secret",
  "totp.invalid": "neplatný secret",
  "private.module.coming": "Brzy.",
  "private.module.comingHint": "Tento modul bude brzy k dispozici. Kryptografie Soukromého IKO již funguje — brzy zde budete moci uložit, co potřebujete.",
  "notes.new": "Nová poznámka",
  "notes.empty": "V tomto IKO ještě nemáte poznámky.",
  "notes.emptyPreview": "(prázdná)",
  "notes.untitled": "Bez názvu",
  "notes.delete": "Smazat poznámku",
  "notes.confirmDelete": "Smazat tuto poznámku? Nelze obnovit.",
  "notes.titlePlaceholder": "Název",
  "notes.contentPlaceholder": "Napište, co si potřebujete zapamatovat…",
  "notes.startHint": "Žádné poznámky v tomto IKO. Vytvořte první.",
  "notes.autosaveHint": "Automaticky uloženo, šifrováno, pouze zde.",
  "notes.yesterday": "Včera",
  "passwords.new": "Nová položka",
  "passwords.empty": "V tomto IKO jste ještě nic neuložili.",
  "passwords.untitled": "Bez názvu",
  "passwords.startHint": "Žádná hesla v tomto IKO. Vytvořte první.",
  "passwords.confirmDelete": "Smazat tuto položku? Nelze obnovit.",
  "passwords.save": "Uložit",
  "passwords.edit": "Upravit",
  "passwords.delete": "Smazat",
  "passwords.copy": "Kopírovat",
  "passwords.copied": "Zkopírováno ✓",
  "passwords.show": "Zobrazit",
  "passwords.hide": "Skrýt",
  "passwords.field.label": "Název",
  "passwords.field.label.ph": "Banka, účet, služba…",
  "passwords.field.username": "Uživatel",
  "passwords.field.username.ph": "E-mail, alias, číslo…",
  "passwords.field.password": "Heslo",
  "passwords.field.password.ph": "Heslo, které chcete uložit",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Poznámky",
  "passwords.field.notes.ph": "Jakýkoli užitečný detail",
  "media.uploading": "Nahrávání…",
  "media.uploadFailed": "Soubor nelze nahrát.",
  "media.upload.file": "Nahrát soubor",
  "media.upload.photo": "Nahrát fotku",
  "media.upload.video": "Nahrát video",
  "media.upload.audio": "Nahrát audio",
  "media.empty.file": "V tomto IKO zatím nejsou soubory.",
  "media.empty.photo": "V tomto IKO zatím nejsou fotky.",
  "media.empty.video": "V tomto IKO zatím nejsou videa.",
  "media.empty.audio": "V tomto IKO zatím nejsou audia.",
  "media.play": "Přehrát",
  "media.download": "Stáhnout",
  "media.delete": "Smazat",
  "media.confirmDelete": "Smazat tento prvek? Nelze obnovit.",
  "media.noPreview": "Žádný náhled pro tento typ souboru.",
  "modal.share.title": "Sdílet kontakt",
  "modal.share.hint": "Vyberte kontakt ze seznamu nebo zadejte IKOGNIT ID ručně.",
  "modal.share.filter": "Filtrovat kontakty…",
  "modal.share.empty": "Žádné kontakty v tomto IKO",
  "modal.share.manual": "Nebo ruční IKOGNIT ID",
  "modal.share.btn": "Sdílet",
  "modal.group.title": "Nová skupina",
  "modal.group.hint": "Vyberte název a vyberte členy z kontaktů v tomto IKO.",
  "modal.group.namePh": "Název skupiny",
  "modal.group.selected": "{0} vybráno",
  "modal.group.create": "Vytvořit skupinu",
  "modal.remember.title": "Zapamatovat toto zařízení",
  "modal.remember.hint": "Vaše relace, kontakty, skupiny a zprávy budou uloženy na tomto zařízení, šifrované PINem, který znáte pouze vy. Při opětovném otevření aplikace zadáte PIN k odemčení.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Zopakujte PIN",
  "modal.remember.warn": "Pokud PIN zapomenete, uložená data nelze obnovit. Budete se muset přihlásit znovu uživatelem a heslem.",
  "modal.remember.errShort": "PIN musí mít alespoň 4 znaky.",
  "modal.remember.errMismatch": "PINy se neshodují.",
  "stickers.faces": "Tváře",
  "stickers.gestures": "Gesta",
  "stickers.hearts": "Srdce",
  "stickers.symbols": "Symboly",
  "stickers.animals": "Zvířata",
  "stickers.food": "Jídlo",
  "ttl.1h": "1 hodina",
  "ttl.1d": "1 den",
  "ttl.1w": "1 týden",
  "ttl.1m": "1 měsíc",
  "ttl.6m": "6 měsíců",
  "ttl.12m": "12 měsíců",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Nikdy",
  "toast.newMessage": "Nová zpráva",
  "toast.group": "{0} (skupina)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informace a navigace ve IKO",
  "ctx.section.universe": "AKTUÁLNÍ IKO",
  "ctx.universe.personal": "Tvůj osobní prostor",
  "ctx.status.serverBlind": "Slepý server aktivní",
  "ctx.status.e2e": "Šifrování end-to-end",
  "ctx.section.nav": "NAVIGACE",
  "ctx.nav.changeIko": "Změnit IKO",
  "ctx.nav.activateIko": "Aktivovat IKO",
  "ctx.nav.backToIkognit": "Zpět do IKOGNIT",
  "ctx.section.actions": "AKCE",
  "ctx.action.newChat": "Nový chat",
  "ctx.action.newGroup": "Nová skupina",
  "ctx.action.contacts": "Moje kontakty",
  "ctx.section.conversation": "KONVERZACE",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} zpráv",
  "ctx.peer.message": "{0} zpráva",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Osobní IKO",
  "ctx.modes.storage": "Jednotka",
  "ctx.liturgy.0": "Server je slepý.",
  "ctx.liturgy.1": "Tady čteš jen ty.",
  "ctx.liturgy.2": "Nikdo neví, že jsi tady.",
  "ctx.liturgy.3": "IKO je tajemství, které znáš jen ty.",
  "ctx.liturgy.4": "Tvé soukromí je architektura.",
  "ccb.universe.changeOrExit": "Změnit IKO nebo odejít",
  "ccb.universe.activate": "Aktivovat IKO",
  "ccb.leave.title": "Opustit IKO (zpět do IKOGNIT)",
  "ccb.leave.aria": "Opustit IKO",
  "ccb.tag.cipher.title": "Symetrické šifrování aktivní",
  "ccb.tag.srv.title": "Server nemůže číst obsah",
  "ccb.tag.unread.title": "Nepřečtené zprávy",
  "ccb.settings.title": "Nastavení · profil, motivy, relace",
  "ccb.settings.aria": "Nastavení",
  "ccb.identity.title": "Relace: @{0}",
  "ccb.clock.title": "Místní čas",
  "ccb.modes.personalPrefix": "OSOBNÍ · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "OSOBNÍ IKO",
  "holo.modes.general": "TVŮJ NICK + KONTAKTY",
  "holo.claim.inIko": "Tento IKO zůstává neviditelný pro toho, kdo ho nezná.",
  "holo.claim.general": "Tvůj osobní prostor v IKOGNIT. Tady mluvíš se svými kontakty.",
  "holo.card.conversations": "Konverzace",
  "holo.card.contacts": "Kontakty",
  "holo.card.cipher": "Šifrování",
  "holo.card.server": "Server",
  "holo.foot": "Vyber konverzaci, aktivuj IKO nebo vytvoř nový prostor.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Osobní IKO",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "Obecný IKO",
  "uib.e2e.title": "Server nemůže číst tvůj obsah — šifrování E2E s tvým klíčem",
  "uib.e2e.label": "Slepý server",
  "uib.pseudoTitle": "Tvůj pseudonym v tomto IKO",
  "uib.nickTitle": "Tvůj nick",
  "uib.exitTitle": "Zpět do Obecného IKO",
  "uib.exitLabel": "Odejít",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Hlavní navigace",
  "chat.tab.chats": "Chaty",
  "chat.tab.calls": "Hovory",
  "chat.tab.contacts": "Kontakty",
  "chat.backToIkognit.title": "Zpět do obecného IKOGNIT",
  "chat.delete.title": "Smazat",
  "chat.delete.aria": "Smazat",
  "chat.call.title": "Volat",
  "chat.videoCall.title": "Videohovor",
  "chat.videoCall.aria": "Videohovor s {0}",
  "chat.search.clear": "Vymazat hledání",
  "chat.filters.aria": "Filtry chatů",
  "chat.filter.all": "Vše",
  "chat.filter.unread": "Nepřečtené",
  "chat.filter.groups": "Skupiny",
  "chat.attachPending": "Příloha čeká",
  "chat.remove.title": "Odebrat",
  "chat.cancel.title": "Zrušit",
  "chat.blocked.text": "Zablokoval(a) jsi {0}. Nemůžeš mu posílat zprávy ani volat.",
  "chat.unblock": "Odblokovat",
  "contacts.alias.placeholder": "Přezdívka pro snadné rozpoznání",
  "contacts.notes.placeholder": "Vidíš ji jen ty (šifrovaná na serveru).",
  "contacts.search.placeholder": "Hledat podle přezdívky nebo IKOGNIT ID",
  "contacts.edit.title": "Upravit přezdívku a poznámku",
  "contacts.edit.aria": "Upravit",
  "contacts.blockBtn": "Zablokovat kontakt",
  "contacts.unblockBtn": "Odblokovat kontakt",
  "contacts.confirmBlock.title": "Zablokovat kontakt",
  "contacts.confirmUnblock.title": "Odblokovat kontakt",
  "contacts.confirmBlock.body": "Zablokovat {0}? Přestaneš dostávat jeho zprávy a hovory.",
  "contacts.confirmUnblock.body": "Odblokovat {0}? Znovu budeš dostávat jeho zprávy.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Kategorie Osobního IKO",
  "piko.rail.head": "OSOBNÍ",
  "piko.cat.all": "Vše",
  "piko.cat.photos": "Fotky",
  "piko.cat.videos": "Videa",
  "piko.cat.audios": "Audio",
  "piko.cat.files": "Soubory",
  "piko.cat.notes": "Poznámky",
  "piko.cat.passwords": "Hesla",
  "piko.cat.cards": "Karty",
  "piko.cat.identities": "Identity",
  "piko.cat.sshkeys": "SSH klíče",
  "piko.cat.custom": "Složka",
  "piko.cat.agendas": "Adresáře IKO",
  "piko.cat.storage": "Disky a Disky",

  "auth.field.nickPlaceholder": "např. user123",
  "auth.field.emailPlaceholder": "ty@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Přečteno {0}",
  "bubble.tick.delivered": "Doručeno {0}",
  "bubble.tick.sent": "Odesláno",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Tohoto uživatele jste zablokovali.",
  "chat.preview.image": "Obrázek",
  "chat.preview.video": "Video",
  "chat.preview.voice": "Hlasová zpráva",
  "chat.preview.audio": "Zvuk",
  "error.push.denied": "Odepřeli jste oprávnění pro oznámení.",
  "error.push.noSw": "Tento prohlížeč nepodporuje service workers.",
  "error.push.noPush": "Tento prohlížeč nepodporuje push notifikace.",
  "error.push.noVapid": "Server nepředal klíč VAPID.",
  "error.push.activateFailed": "Nelze aktivovat ({0}).",
  "chat.group.membersWord": "členů",
  "chat.newCall.title": "Nový hovor",
  "chat.newChat.title": "Nový chat",
  "chat.newCall.empty": "Zatím žádné kontakty. Přidejte jeden přes + v Chatech.",
  "chat.unread.aria": "nepřečtených zpráv",
  "chat.calls.title": "Hovory",
  "chat.calls.empty": "Zatím žádné hovory. Začněte z chatu s kontaktem.",
  "chat.calls.callContact": "Zavolat kontaktu",
  "chat.calls.historySoon": "Historie hovorů bude brzy k dispozici.",
  "chat.deleteConv.titleOne": "Smazat konverzaci",
  "chat.deleteConv.titleMany": "Smazat {0} konverzací",
  "chat.deleteConv.hint": "\"Pro mě\" smaže vaši kopii (všechna vaše zařízení). \"Pro všechny\" požádá také kontakt o smazání.",
  "chat.deleteConv.forMe": "Smazat pro mě",
  "chat.deleteConv.forAll": "Smazat pro všechny",
  "chat.myContacts": "Moje kontakty",
  "chat.contacts.noResults": "Žádné výsledky.",
  "chat.contacts.empty": "Zatím žádné kontakty.",
  "chat.contact.badgeBlocked": "blokován",
  "chat.contact.badgePending": "nepotvrzeno",
  "chat.toast.saved": "Uloženo",
  "chat.toast.videoSaved": "Video uloženo do Fotek",
  "chat.toast.imageSaved": "Obrázek uložen do Fotek",
  "chat.toast.updateTestflight": "Aktualizujte TestFlight na 1.0(10)+ pro uložení.",
  "chat.toast.saveFailed": "Nelze uložit: {0}",
  "chat.toast.saveError": "Chyba ukládání",
  "iko.banner.exitAria": "Opustit IKO a vrátit se do obecné roviny",
  "iko.liturgy.entering": "Vstup do IKO",
  "iko.liturgy.returning": "Návrat",
  "iko.liturgy.toIkognit": "do IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Osobní IKO",
  "manifest.blindServer": "Server je slepý.",
  "manifest.onlyYouRead": "Tady čteš jen ty.",
  "manifest.noPublicProfiles": "Žádné veřejné profily.",
  "manifest.noAdsNoClouds": "Bez reklam. Bez cizích cloudů.",
  "manifest.keyWithYou": "Klíč žije s tebou.",
  "manifest.yourIkoYourSpaces": "Tvé IKO. Tvé prostory.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Soubory",
  "orb.mod.notes": "Poznámky",
  "orb.mod.photos": "Fotky",
  "orb.mod.vault": "Složka",
  "orb.mod.audios": "Zvuky",
  "orb.copy.line1": "Tvé IKO.",
  "orb.copy.line2": "Tvé prostory.",
  "explorer.filesNotProcessed": "Nezpracované soubory",
  "demo.edit": "Upravit",
  "common.exit": "Opustit",
  "common.more": "Více",
  "chat.tab.settings": "Nastavení",
  "chat.search.placeholder": "Hledat chat",
  "chat.presence.online": "online",
  "chat.action.call": "Zavolat",
  "chat.action.videoCall": "Videohovor",
  "chat.attach.label": "Připojit",
  "chat.attach.camera": "Kamera",
  "chat.attach.voice": "Hlas",
  "chat.attach.file": "Připojit soubor",
  "chat.composer.placeholder": "Napište zprávu...",
  "settings.addYourName": "Přidejte své jméno",
  "settings.editProfile": "Upravit profil",
  "chat.welcome.intro": "Vyberte chat a začněte hovořit s šifrováním end-to-end.",

  // Batch2: footer atajos web
  "web.footer.palette": "paleta",
  "web.footer.send": "odeslat",
  "web.footer.line": "řádek",
  "mobile.tb.ikoActivate": "Aktivovat IKO",
  "mobile.tb.ikoExit": "Zpět na obecné IKOGNIT",

  "chat.header.blocked": "Zablokováno",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Soukromá poznámka",
  "settings.account.newNickPlaceholder": "nový_nick",
  "settings.account.newEmailPlaceholder": "nový@email.com",


  "common.delete": "Smazat",








};

const hu: Catalog = {
  "auth.verify.notSent": "Nem tudtuk elküldeni a kódot. A fiókod létrejött: nyomd meg mindjárt a «Kód újraküldése» gombot.",
  "lg.rotulo": "Üzenetküldés privát terekkel",
  "lg.btn.entrar": "Belépés",
  "lg.eyebrow": "Privát üzenetküldés · Itrion Software",
  "lg.h1a": "A megszokott beszélgetéseid.",
  "lg.h1b": "És egy hely, ami csak akkor létezik, ha megidézed.",
  "lg.lead1": "Beszélgetsz a családoddal, a barátaiddal és a csapatoddal, mint bármelyik appban. A különbség ott kezdődik, amikor megnyitsz egy IKO-t: egy saját teret, ahová úgy lépsz be, hogy leírsz egy titkot, amit csak a bent lévők ismernek.",
  "lg.lead2": "Amíg meg nem idézed, az a tér nincs az eszközödön — sem a telefonon, sem a tableten, sem a számítógépen. Nem arról van szó, hogy titkosítva van.",
  "lg.lead2b": "Egyszerűen nincs ott.",
  "lg.pruebalo": "Próbáld ki · írj be egy titkot, és nézd meg, mi történik",
  "lg.panel.plano": "Általános sík",
  "lg.demo.hilos": "Család=Anya: vasárnap nálunk vacsorázunk?=19:04|Marta=küldöm a szombati fotókat=17:52|Csapat=Luis: akkor holnap kilenckor=Tegnap|Javi=haha ezt nem hiszem el=Tegnap",
  "lg.demo.mundos": "Csak mi ketten~oda tetted, ahová mondtuk?|igen. az okiratot és az útlevelet>~Lakás okirata.pdf=2,4 MB|Privát fotók=214|Kártya · bank=Adatok~~Otthoni dolgok~itt hagyom neked a bérleti szerződést>|és a router kulcsát, mert mindig elveszíted~Bérleti szerződés.pdf=1,1 MB|Személyi másolata=2 fájl|Házkulcsok=Adatok~~A jegyzeteim~ezt senkinek nem mondtam el>|és nem is kell>~Napló=48 jegyzet|Fotók=1207|Éves elszámolás=Adatok~~Lisszabon projekt~az ajánlat 180-ra jön ki|itt van, kint semmilyen másolat>~Ajánlat_v4.pdf=860 KB|Kapcsolatok=12|Céges kártya=Adatok~~A szombati ebéd~Martának még ne szólj|nyugi, itt nem tudja meg senki>~Foglalás.pdf=120 KB|Tavalyi fotók=63|Vendéglista=Adatok",
  "lg.invocaLabel": "Idézd meg az IKO-dat",
  "lg.invocaPlaceholder": "írj be egy tetszőleges titkot",
  "lg.invocaBtn": "Megidézés",
  "lg.invocaHint": "Minden szó más térbe visz. Próbálj ki egy másikat.",
  "lg.estela.vacio": "Írj be bármit: ez itt egy bemutató.",
  "lg.estela.primero": "Megvan. Csak addig létezik, amíg bent vagy.",
  "lg.estela.otro": "Másik titok, másik tér. Egyik sem tud a többiről.",
  "lg.estela.salida": "Eltűnt. Nem maradt nyoma az eszközön. Próbálj egy másik szót.",
  "lg.ikoActivo": "IKO aktív",
  "lg.nadaEnDispositivo": "Ebből semmi nincs az eszközön",
  "lg.salirIko": "Kilépés az IKO-ból",
  "lg.planos.h2a": "Egy sík, ami látszik.",
  "lg.planos.h2b": "Alatta azok, amiket te idézel meg.",
  "lg.planos.lead": "Nincs olyan, hogy «az IKO». Azok vannak, amiket megnyitsz: egy az otthoni dolgokra, egy a munkára, egy, amit csak ketten ismertek, egy, amiről soha senkinek nem beszéltél. Minden titok a sajátjához vezet, és egyik sem tud a többiről.",
  "lg.planos.unoRotulo": "Az általános sík · egy",
  "lg.planos.unoH3": "Ahol mindenkivel beszélsz",
  "lg.planos.unoP": "Beszélgetések, csoportok, hívások, fotók és fájlok, végponttól végpontig titkosítva. Amit egy üzenetküldőtől elvársz, rendesen megcsinálva. A megszokott csevegéseid itt élnek és úgy viselkednek, mint mindig.",
  "lg.planos.nRotulo": "Az IKO-k · amennyit akarsz",
  "lg.planos.nH3": "Ahová senki más nem jut el",
  "lg.planos.nP": "Leírsz egy titkot, és megjelenik a hozzá tartozó tér. Beleférnek a beszélgetések és a dolgaid. Amikor kilépsz, nyomtalanul eltűnik az eszközről. Nincs lista, nincs szám, és senki nem tudja kideríteni, hányat használsz, sem azt, hogy egyáltalán létezik-e egy is.",
  "lg.planos.chips": "Az otthoni dolgok|A munka|Amit csak ketten tudtok|A tiéd és senki másé|Amit egyszer megnyitottál és soha többé|Amiket holnap találsz ki",
  "lg.forense.h2a": "Nincs titkosítva az eszközödön.",
  "lg.forense.h2b": "Nincs az eszközödön.",
  "lg.forense.lead": "A többi app a készüléken tartja az üzeneteidet és titkosítja őket. Ha valaki elviszi, a magánéleted azon múlik, hogy az a titkosítás elég sokáig kitart-e. Itt nincs semmi, aminek ki kellene tartania: ami egy IKO-ban él, az egyetlen eszközre sem íródik ki. Megidézed, használod, és elmegy.",
  "lg.forense.multi": "Mindenhol ugyanígy: telefon, tablet, otthoni gép, munkahelyi laptop, Windows, Mac vagy egy idegen hely böngészője. Bemész, ahol akarsz, és amikor kilépsz, az a hely megint semmit sem tud rólad.",
  "lg.forense.caption": "Amit az talál, aki bármelyik eszközödet átvizsgálja",
  "lg.forense.filas": "Az IKO-id üzenetei=0|Az IKO-id fájljai és fotói=0|Elmentett IKO-titkok=0|Az IKO-idat tartalmazó adatbázis=nem létezik|Nyom arról, hogy egy IKO nyitva volt=semmi|Hány IKO-d van=megállapíthatatlan",
  "lg.escenas.h2": "Ami valóban aggaszt.",
  "lg.escenas.filas": "«Elvesztettem a telefonom.»=A magánéleted nem veszett el vele. Ami egy IKO-ban volt, soha nem volt azon a készüléken, tehát nincs mit menteni és nincs mitől félni. Bármelyik másik eszközről megidézed, és minden ott van, ahol volt.~«Elvitték a laptopomat.»=Látni fogja a szokásos beszélgetéseidet, ugyanazokat, amiket bármelyik appban látna. A többiből nem látja sem a tartalmat, sem a nevét, sem annak nyomát, hogy létezik.~«Átvizsgálták a számítógépemet.»=Egy törvényszéki elemzés visszahozza azt, ami a lemezre van írva, még titkosítva és törölve is. Itt nincs leírva semmi, amit vissza lehetne hozni. A válasz nem az, hogy «nem lehet visszafejteni»: egyszerűen nincs semmi. És ugyanez a tableten, a telefonon és a böngészőben, amit egy délután használtál.",
  "lg.ciego.h2": "Mi sem. És az sem, aki a szervereket üzemelteti.",
  "lg.ciego.p1": "A szerver olyan dolgokat őriz, amiket nem tud elolvasni. Nincs meg neki a titkod, soha nem is volt, és sehol nem létezik másolat. Nem arról van szó, hogy megtagadnánk az IKO-id tartalmának kiadását: nincs nálunk, és nincs is rá mód, hogy nálunk legyen. Sem a gépeket üzemeltető cégnél, sem annál, aki rájuk tenné a kezét.",
  "lg.ciego.p2": "Ennek ára van, és illik kimondani: ha elveszíted a titkodat, senki nem tudja visszaadni. Pontosan az az ok, ami miatt más nem juthat be, az az ok, ami miatt mi sem tudunk bejuttatni.",
  "lg.guardas": "Családi fotók|A jegyzetek, amiket nem mutatsz meg|Kártyák és banki adatok|Jelszavak|Dokumentumok|Beszélgetések, amik csak rátok tartoznak",
  "lg.nombre.esta": "ott van",
  "lg.nombre.noEsta": "nincs ott",
  "lg.nombre.h2": "Innen a név.",
  "lg.nombre.p": "Szuahéliül az iko azt jelenti: «ott van», a haiko pedig: «nincs ott». Egy IKO addig van, amíg megidézed. A többi időben — vagyis szinte mindig — nincs ott: sem az eszközeiden, sem bárki szeme előtt, még gyanúként sem.",
  "lg.cierre.h2": "Kezdj el beszélgetni.",
  "lg.cierre.p": "Úgy használod, mint bármelyik üzenetküldőt, telefonon, tableten és számítógépen. Az IKO-k ott lesznek azon a napon, amikor szükséged lesz rájuk.",
  "lg.cierre.btnCrear": "Fiók létrehozása",
  "lg.cierre.btnEntrar": "Már van fiókom",
  "lg.cierre.pago": "Az IKOGNIT fizetős termék. Nincs hirdetés, nincs hirdetési profil, és nálunk nincs másolat semmiről: abból élünk, hogy megéri neked az app, nem abból, amit benne elmondasz.",
  "lg.pie.ciego": "Vak szerver",
  "auth.hola": "Szia, újra itt.",
  "auth.queEs": "Mi az az IKOGNIT?",
  "common.cancel": "Mégse",
  "common.error.generic": "Nem sikerült. Próbáld újra.",
  "common.save": "Mentés",
  "common.confirm": "Megerősítés",
  "common.close": "Bezárás",
  "common.add": "Hozzáadás",
  "common.back": "Vissza",
  "common.tagline": "Digitális szuverenitás.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "Szuahéliül az iko azt jelenti: „ott van”. A haiko pedig: „nincs ott”.",
  "auth.legal.age": "Megerősítem, hogy elértem az országom törvénye által IKOGNIT használatához előírt minimális életkort.",
  "auth.legal.accept": "Elolvastam és elfogadom a <a href='https://ikognit.org/legal/hu/feltetelek.html' target='_blank' rel='noopener'>Feltételeket</a>, az <a href='https://ikognit.org/legal/hu/adatvedelem.html' target='_blank' rel='noopener'>Adatvédelmi szabályzatot</a> és a <a href='https://ikognit.org/legal/hu/kozossegi-szabalyok.html' target='_blank' rel='noopener'>Közösségi szabályokat</a>.",
  "recovery.title": "A helyreállító kulcsod",
  "recovery.intro": "Ez a **24 szó** az egyetlen módja, hogy visszaszerezd a fiókodat és az előzményeket, ha elfelejted a jelszót vagy elveszíted az eszközt. **Írd le papírra és tartsd biztonságos helyen.** Senki sem tudja helyetted visszaszerezni az IKOGNIT-ban.",
  "recovery.warn": "**Írd le OFFLINE.** Ne készíts képernyőképet. Ne küldd el e-mailben vagy üzenetben. Aki birtokolja ezeket a szavakat, az teljes fiókodat irányítja.",
  "recovery.btn.show": "Szavak megjelenítése",
  "recovery.btn.copy": "Másolás",
  "recovery.btn.copied": "Másolva · {0}s múlva törlődik",
  "recovery.btn.cleared": "Vágólap törölve",
  "recovery.btn.copyAria": "Helyreállító mondat másolása a vágólapra (automatikusan törlődik)",
  "recovery.btn.download": "Letöltés",
  "recovery.btn.downloadAria": "Mondat letöltése szövegfájlként",
  "recovery.btn.back": "Vissza a szavak megnézéséhez",
  "recovery.btn.continue": "Tovább",
  "recovery.btn.done": "Készen vagyok",
  "recovery.btn.need3": "Írd be a 3 helyes szót",
  "recovery.verify.intro": "Hogy megerősítsd, elmentetted a kulcsot, írd be ezeket a szavakat. Nem folytathatod, amíg nem találod el őket.",
  "recovery.verify.wordN": "Szó #{0}",
  "recovery.verify.correct": "Helyes",
  "recovery.verify.wrong": "Helytelen",
  "auth.error.legalRequired": "El kell fogadnod a jogi feltételeket és meg kell erősítened a korodat IKOGNIT ID létrehozásához.",
  "settings.legal.title": "Jogi információk",
  "settings.legal.hub": "Jogi központ",
  "settings.legal.terms": "Felhasználási feltételek",
  "settings.legal.privacy": "Adatvédelmi szabályzat",
  "settings.legal.rules": "Közösségi szabályok",
  "settings.legal.report": "Bejelentések és moderálás",
  "settings.legal.cookies": "Süti szabályzat",
  "settings.legal.minors": "Kiskorúak szabályzata",
  "settings.legal.notice": "Jogi nyilatkozat",
  "settings.tab.legal": "Jogi",
  "auth.loading": "Betöltés…",
  "auth.savedSession": "Ez az eszköz már ismeri a gazdáját.",
  "auth.locked": "Tétlenség után elhalványult. Lépj be újra.",
  "auth.sessionExpired": "A munkamenet elhalványult. Lépj be újra.",
  "auth.tab.login": "Belépés",
  "auth.tab.register": "Új IKOGNIT ID",
  "auth.subLogin": "Az általános síkra lépsz be: a megszokott beszélgetéseidhez. Az IKO-kat nem itt idézed meg — hanem bent, amikor szükséged van rájuk.",
  "auth.subRegister": "A fiók a te nevedre szól. A nick az, ahogy mások látnak; az e-mail csak a hozzáférés visszaszerzésére és értesítésekre szolgál.",
  "auth.field.devicePin": "Főkulcs",
  "auth.field.password": "Főkulcs",
  "auth.btn.unlock": "Belépés",
  "auth.btn.unlocking": "Belépés…",
  "auth.btn.processing": "Feldolgozás…",
  "auth.btn.createIdentity": "IKOGNIT ID létrehozása",
  "auth.btn.useOther": "Másik IKOGNIT ID használata",
  "auth.btn.forget": "Felejtsd el ezt az eszközt",
  "auth.btn.backToUnlock": "Vissza",
  "auth.confirmForget": "Ez az eszköz többé nem ismer fel: eltűnik a mentett fiók és minden, ami a gyorsítótárban van. A visszatéréshez a jelszavadra lesz szükség.",
  "auth.confirmForget.warning": "A 24 szavas helyreállítási mondat feljegyzése nélkül nincs visszaút: senki nem tudja visszaadni.",
  "invite.welcomeSub": "Üzenetek és saját tér: amit itt tartasz, a te nevedre szól. Hozd létre a fiókod, és kapcsolatban lesztek.",
  "auth.reset.warnNewIdentity": "A fiók a tiéd marad, de az e-mailes helyreállítás új azonosságot ad: a korábbi üzenetek már nem olvashatók. Ha megvan a 24 szavas helyreállítási mondatod, inkább azt használd.",
  "recover.intro": "Írd be a nicked vagy az e-mail-címed és a 24 helyreállítási szót, amelyet a fiók létrehozásakor kaptál. Utána új jelszót választasz.",
  "auth.error.badCreds": "Helytelen IKOGNIT ID vagy kulcs.",
  "auth.error.userNotFound": "IKOGNIT ID nem található.",
  "auth.error.cantConnect": "Nem sikerült csatlakozni a szerverhez.",
  "auth.error.badPin": "Helytelen kulcs.",
  "auth.footnote": "Aki tulajdonos, felel is érte.\nHa elveszted a jelszavad,\nnincs kinél reklamálni.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Aktuális IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Személyes IKO: {0}",
  "sidebar.freqPsh": "Tartomány IKO: {0}",
  "sidebar.tune": "IKO aktiválása",
  "sidebar.exitFreq": "Vissza a IKOGNIT-ba",
  "sidebar.notifications": "Értesítések",
  "sidebar.remember": "Eszköz megjegyzése",
  "sidebar.forget": "Eszköz elfelejtése",
  "sidebar.addContact": "Kapcsolat hozzáadása nick alapján",
  "sidebar.newGroup": "Új csoport",
  "sidebar.settings": "Beállítások",
  "sidebar.logout": "Kilépés",
  "sidebar.tooltip.logout": "Kilépés és minden helyi adat törlése",
  "sidebar.savedFreq.tooltip": "{0} aktiválása",
  "chat.empty": "Válassz vagy adj hozzá egy kapcsolatot",
  "welcome.title": "Üdvözlünk a IKOGNIT-ban",
  "welcome.concept": "A IKOGNIT-ban más felhasználókkal beszélgetsz, a nicked alapján azonosítva. Amikor külön teret szeretnél, aktiválsz egy IKO-ot és belépsz egy IKO. Ha Nyilvános, találkozol azokkal, akik szintén aktiválják. Ha Privát, olyan IKO lépsz, ahol csak te vagy.",
  "welcome.step1": "Aktiválj egy Nyilvános IKO-ot és lépj be egy IKO azokkal, akik szintén ismerik.",
  "welcome.step2": "Itt a IKOGNIT-ban adj hozzá egy nick-t kapcsolatként és kezdj beszélgetni.",
  "welcome.step3": "Aktiválj egy Privát IKO-ot és nyiss egy IKO csak magadnak, ahol fájlokat, fotókat, hangokat, videókat, jelszavakat, jegyzeteket és leveleket tárolsz.",
  "welcome.multidevice": "A IKO-okat sehol sem tárolják. Ha elfelejtesz egy IKO-ot, az IKO számodra megszűnik létezni.",
  "welcome.btnFreq": "IKO aktiválása",
  "welcome.btnContacts": "Kapcsolat hozzáadása",
  "push.btnOn": "Értesítések BE",
  "push.btnOff": "Értesítések KI",
  "push.btnEnable": "Értesítések kikapcsolva. Kattints a bekapcsoláshoz.",
  "push.btnDisable": "Értesítések bekapcsolva. Kattints a kikapcsoláshoz.",
  "push.introTitle": "Az értesítések bekapcsolása előtt",
  "push.introBody": "Adatvédelmi okokból a IKOGNIT értesítések különböznek más üzenetküldő alkalmazásoktól:",
  "push.introBullet1": "Az üzenet tartalma nincs benne.",
  "push.introBullet2": "A küldő neve és IKOGNIT ID-je nem jelenik meg.",
  "push.introBullet3": "Csak \"új üzenet\" figyelmeztetést kapsz; nyisd meg az alkalmazást, hogy titkosítva olvasd el az eszközödön.",
  "push.introConfirm": "Értesítések bekapcsolása",
  "chat.placeholder": "Írj üzenetet…",
  "chat.newMessages": "új",
  "chat.newMessagesBadge": "Ugrás {0} új üzenethez",
  "chat.mediaRetry": "Újra",
  "chat.mediaFailed": "Nem sikerült betölteni",
  "chat.media.download": "Letöltés",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Szerkeszd üzenetedet…",
  "chat.replyingTo": "Válasz {0} részére",
  "chat.editing": "Üzenet szerkesztése",
  "chat.confirmContact": "Hozzáadás a kapcsolatokhoz",
  "chat.unconfirmedBanner": "Ez a felhasználó írt neked, de nincs a kapcsolataid közt. Amíg nem adod hozzá, a fotód és infód az adatvédelmi beállításaid szerint nem lesz számára látható.",
  "chat.online": "elérhető",
  "chat.lastSeen": "utoljára látva {0}",
  "chat.tooltip.attach": "Fájl csatolása",
  "chat.tooltip.shareContact": "Kapcsolat megosztása",
  "chat.tooltip.paste": "Kép beillesztése vágólapról",
  "chat.tooltip.stickers": "Matricák",
  "chat.tooltip.callAudio": "Hanghívás",
  "chat.tooltip.callVideo": "Videóhívás",
  "chat.btn.send": "Küldés",
  "chat.uploading": "…",
  "preview.image": "📷 Kép",
  "preview.video": "🎬 Videó",
  "preview.audio": "🎙 Hang",
  "bubble.reply": "Válasz",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Szerkesztés",
  "bubble.edited": "szerkesztett",
  "bubble.contact.label": "IKOGNIT kapcsolat",
  "bubble.media.decrypting": "Visszafejtés…",
  "bubble.media.failed": "A fájlt nem sikerült visszafejteni.",
  "call.calling": "Hívás…",
  "call.incoming.audio": "Bejövő hívás",
  "call.incoming.video": "Bejövő videóhívás",
  "call.connecting": "Csatlakozás…",
  "call.ending": "Befejezés…",
  "call.accept": "Elfogadás",
  "call.reject": "Elutasítás",
  "call.hangup": "Befejezés",
  "call.mic": "Mikrofon",
  "call.camera": "Kamera",
  "call.audioOut": "Hangkimenet",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "A híváshoz IKO-ban kell lenned.",
  "error.notFound": "Az erőforrás nem található.",
  "error.notInFreq": "{0} még nincs ebben a IKO-ban. Kérd meg más csatornán, hogy aktiválja.",
  "error.push.iosTooOld": "Az iOS-ed korábbi mint 16.4. Frissítsd, hogy értesítéseket kaphass.",
  "error.push.iosNotStandalone": "Az iPhone értesítésekhez telepítsd a IKOGNIT-ot a kezdőképernyőre: érintsd Megosztás → Hozzáadás a kezdőképernyőhöz.",
  "error.expired": "A munkamenet lejárt. Lépj be újra.",
  "error.gone": "A fájl lejárt.",
  "error.invalid": "Érvénytelen adatok.",
  "error.server": "Szerverhiba. Próbáld újra.",
  "error.network": "Nincs kapcsolat a szerverrel.",
  "error.cantStartCall": "Nem sikerült elindítani a hívást: {0}",
  "error.cantAcceptCall": "Nem sikerült fogadni a hívást: {0}",
  "error.cantPaste": "Nem sikerült hozzáférni a vágólaphoz. Próbáld a csatolás gombot.",
  "error.noImageInClipboard": "Nincs kép a vágólapon.",
  "error.clipboardUnsupported": "A böngésződ nem engedi a vágólap olvasását. Illeszd be Ctrl+V-vel vagy használd a csatolás gombot.",
  "error.selfContact": "Nem adhatod hozzá magadat.",
  "error.blocked": "Letiltottad ezt a felhasználót. Oldd fel a Beállításokban, hogy újra beszélj vele.",
  "settings.title": "Beállítások",
  "settings.close": "Bezárás",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Adatvédelem",
  "settings.tab.messages": "✉ Üzenetek",
  "settings.tab.blocked": "🚫 Letiltottak",
  "settings.tab.notifications": "🔔 Értesítések",
  "settings.tab.session": "⏱ Munkamenet",
  "settings.tab.account": "🆔 Fiók",
  "settings.tab.language": "🌐 Nyelv",
  "settings.tab.about": "ℹ Névjegy",
  "settings.scope.global": "Globális (IKOGNIT)",
  "settings.scope.freq": "Csak {0}-ban",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Ezek az alapértelmezett értékek, minden IKO-ban öröklődnek.",
  "settings.profile.hintFreq": "Felülírják a globális profilt {0}-ban. Ha itt nem adsz meg semmit, a globálisból öröklődik.",
  "settings.profile.displayName": "Megjelenített név",
  "settings.profile.displayNamePh.global": "(nincs név — a nick-d jelenik meg)",
  "settings.profile.displayNamePh.freq": "(a globálisból öröklődik)",
  "settings.profile.photo": "Profilkép",
  "settings.profile.changePhoto": "Kép módosítása",
  "settings.profile.removePhoto": "Kép eltávolítása",
  "settings.profile.adjustPhoto": "Állítsd be a képet",
  "settings.profile.info": "Infó / Státusz",
  "settings.profile.infoPh": "Szia, IKOGNIT-ot használok",
  "settings.profile.removeOverride": "{0} felülírásának eltávolítása",
  "settings.profile.warn": "A változások automatikusan elküldődnek a többi kapcsolatodhoz, amikor velük ebben a IKO-ban interakcióba lépsz.",
  "settings.privacy.title": "Adatvédelem",
  "settings.privacy.hintGlobal": "Állítsd be, ki láthatja alapértelmezetten az egyes adataidat.",
  "settings.privacy.hintFreq": "Csak {0}-ban írd felül ezeket a szabályokat.",
  "settings.privacy.showPhoto": "Ki látja a fotómat",
  "settings.privacy.showInfo": "Ki látja az infómat / státuszomat",
  "settings.privacy.showLastSeen": "Ki látja az utolsó belépésemet",
  "settings.privacy.showOnline": "Ki látja, ha elérhető vagyok",
  "settings.privacy.whoAdds": "Ki adhat hozzá csoportokhoz",
  "settings.privacy.readReceipts": "Olvasási visszaigazolások",
  "settings.privacy.readReceiptsHint": "Ha kikapcsolod, nincs kék pipa, amikor üzeneteket olvasol. Mások sem fognak látszani.",
  "settings.vis.all": "Mindenki",
  "settings.vis.contacts": "A kapcsolataim",
  "settings.vis.none": "Senki",
  "settings.messages.title": "Üzenetek",
  "settings.messages.ttl": "Alapértelmezett lejárat",
  "settings.messages.ttlHint": "Az általad küldött üzenetek a szerverről ennyi idő után törlődnek. Fájl csatolásánál más értéket választhatsz.",
  "settings.blocked.title": "Letiltottak",
  "settings.blocked.hint": "A letiltott felhasználók nem küldhetnek üzenetet. Te sem küldhetsz nekik.",
  "settings.blocked.placeholder": "Letiltandó IKOGNIT ID",
  "settings.blocked.btn": "Letiltás",
  "settings.blocked.unblock": "Feloldás",
  "settings.blocked.empty": "Senki sincs letiltva.",
  "settings.notif.title": "Értesítések",
  "settings.notif.sound": "Hang",
  "settings.notif.preview": "Üzenet előnézet megjelenítése",
  "settings.notif.vibration": "Rezgés (mobil)",
  "settings.notif.hint": "A böngésző push értesítései csak az általános IKOGNIT-ban érkező üzenetekhez generálódnak, tartalom és küldő neve nélkül (szándékosan).",
  "settings.session.title": "Munkamenet",
  "settings.session.timeout": "IKO bezárása inaktivitás után",
  "settings.session.timeoutHint": "Ha ezt az időt anélkül töltöd, hogy hozzáérnél az alkalmazáshoz, az aktív IKO automatikusan deaktiválódik és visszakerülsz a IKOGNIT-ba. \"Soha\" megtartja a IKO-ot, amíg be nem zárod az alkalmazást.",
  "settings.session.remember": "Aktivált IKO-ok megjegyzése",
  "settings.session.rememberHint": "Ha bekapcsolod, az aktivált IKO-ok parancsikonként jelennek meg az oldalsávon. Aki látja a képernyődet, tudhatja, mely IKO-okba léptél be, ezért alapértelmezetten ki van kapcsolva. Kikapcsolva törlődnek a már mentettek.",
  "settings.account.title": "Fiók",
  "settings.account.email": "Opcionális e-mail (csak helyreállításhoz, soha nem publikus)",
  "settings.account.emailPh": "email@példa.com",
  "settings.account.changePassword": "Jelszó módosítása",
  "settings.account.currentPw": "Jelenlegi jelszó",
  "settings.account.newPw": "Új jelszó (min. 8)",
  "settings.account.confirmPw": "Ismételd meg az újat",
  "settings.account.saving": "Mentés…",
  "settings.account.success": "Jelszó frissítve.",
  "settings.account.errPwBad": "A jelenlegi jelszó nem helyes.",
  "settings.account.errPwShort": "Az új jelszónak legalább 8 karakteresnek kell lennie.",
  "settings.account.errPwMismatch": "A jelszavak nem egyeznek.",
  "settings.language.title": "Nyelv",
  "settings.language.hint": "Válaszd ki a felület nyelvét. A beállításod ezen az eszközön tárolódik.",
  "settings.about.title": "IKOGNIT névjegy",
  "settings.about.version": "Verzió",
  "settings.about.tech": "E2E titkosítás NaCl box-szal (X25519). IKO: Argon2id származtatás + determinisztikus HMAC. Helyi titkosított persistálás Argon2id-vel PIN-en.",
  "modal.freq.title": "IKO aktiválása",
  "modal.freq.hint": "A IKO az egyik IKO pontos IKO. Nyilvános: találkozol azokkal, akik ugyanazt írják. Privát: olyan IKO érsz, ahol láthatatlan vagy, még ha más is ugyanazokat a IKO írja.",
  "modal.freq.placeholder": "Írd be a IKO",
  "modal.freq.activate": "Aktiválás",
  "modal.freq.deriving": "IKO számítása…",
  "modal.freq.warn": "A IKO sehol sem kerülnek mentésre. Ha elfelejted őket, az az IKO számodra megszűnik létezni.",
  "modal.freq.errShort": "A IKO-nak legalább 8 karakteresnek kell lennie.",
  "modal.freq.errCommon": "Ez a IKO túl gyakori. Válassz valami egyedit.",
  "modal.freq.errRepeat": "Ne használj egyetlen ismétlődő karaktert.",
  "modal.freq.errSeqNum": "Kerüld a nyilvánvaló számsorozatokat.",
  "modal.freq.errSeqAlpha": "Kerüld az ábécé sorozatokat.",
  "billing.title": "Számlázás",
  "billing.manage": "Kezelés",
  "billing.seats": "Helyek",
  "billing.renews": "Megújul",
  "billing.needsUpgrade": "Elérted a sávod helykorlátját. Lépj feljebb, hogy többet adhass hozzá.",
  "billing.upgradeTo": "Feljebb lépés ({price}/hely)",
  "billing.portal": "Fizetés kezelése",
  "join.loginToAccept": "Bejelentkezés / Fiók létrehozása",
  "private.badge": "PRIVÁT",
  "private.welcome.title": "A te Privát IKO",
  "private.welcome.intro": "Olyan IKO vagy, ahol senki sem láthat. Még ha más személy ugyanazt a IKO-ot írná, másik IKO érne. Itt biztonságosan tárolod a tieidet.",
  "private.welcome.hint": "Válassz egy szekciót a kezdéshez.",
  "private.mod.notes": "Jegyzetek",
  "private.mod.notes.desc": "Jegyzetek, levelek, napló.",
  "private.mod.files": "Fájlok",
  "private.mod.files.desc": "Dokumentumok, lapok, PDF-ek.",
  "private.mod.photos": "Fotók",
  "private.mod.photos.desc": "A privát galériád.",
  "private.mod.videos": "Videók",
  "private.mod.videos.desc": "A személyes videóid.",
  "private.mod.audios": "Hangok",
  "private.mod.audios.desc": "Felvételek és hangjegyzetek.",
  "private.mod.vault": "Jelszavak",
  "private.mod.vault.desc": "Jelszavak, kártyák, identitások, SSH kulcsok és amire szükséged van.",
  "private.mod.iko": "IKO-jaim",
  "private.mod.iko.desc": "Elmentett IKO-jaid, aktiválásra készen.",
  "savediko.intro": "Itt őrizd azokat az IKO-kat, amelyeket nem akarsz megjegyezni. Egyre emlékszel, a többi abban él.",
  "savediko.empty": "Még egyetlen IKO-ot sem mentettél el.",
  "savediko.add": "IKO mentése",
  "savediko.activate": "IKO aktiválása",
  "savediko.formNew": "IKO mentése",
  "savediko.formEdit": "Mentett IKO szerkesztése",
  "savediko.descLabel": "Leírás",
  "savediko.descPh": "Egy leírás, hogy később felismerd",
  "savediko.ikoLabel": "Az IKO",
  "savediko.ikoPh": "Írd be az IKO-t",
  "savediko.errDesc": "Adj meg egy leírást.",
  "savediko.errIko": "Írd be az IKO-t.",
  "savediko.confirmDel": "Törlöd?",
  "vault.new": "Új elem",
  "vault.edit": "Szerkesztés",
  "vault.delete": "Törlés",
  "vault.save": "Mentés",
  "vault.show": "Megjelenítés",
  "vault.hide": "Elrejtés",
  "vault.copy": "Másolás",
  "vault.copied": "Másolva ✓",
  "vault.search": "Keresés…",
  "vault.empty": "A mappa üres. Hozd létre az első elemet.",
  "vault.noMatches": "Egyetlen elem sem felel meg a keresésnek.",
  "vault.untitled": "Név nélküli",
  "vault.startHint": "Válassz egy elemet balra vagy hozz létre egy újat.",
  "vault.confirmDelete": "Törlöd ezt az elemet? Nem állítható vissza.",
  "vault.notes": "Jegyzetek",
  "vault.sensitive": "Érzékeny",
  "vault.sensitiveHint": "Az érzékeny mezők alapértelmezetten rejtettek és vágólapra másolhatók.",
  "vault.removeField": "Mező eltávolítása",
  "vault.addField": "Mező hozzáadása",
  "vault.fieldSingular": "mező",
  "vault.fieldPlural": "mező",
  "vault.type.login": "Bejelentkezés",
  "vault.type.card": "Kártya",
  "vault.type.identity": "Identitás",
  "vault.type.sshkey": "SSH kulcs",
  "vault.type.custom": "Egyéni",
  "vault.field.name": "Név",
  "vault.field.name.ph": "Hogy hívod?",
  "vault.field.labelPh": "Mező címke",
  "vault.field.newField": "Mező",
  "vault.field.username": "Felhasználó",
  "vault.field.password": "Jelszó",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Tulajdonos",
  "vault.field.cardBrand": "Márka",
  "vault.field.cardNumber": "Szám",
  "vault.field.cardExpiry": "Lejárat (HH/ÉÉ)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Keresztnév",
  "vault.field.lastname": "Vezetéknév",
  "vault.field.dni": "Igazolvány",
  "vault.field.address": "Cím",
  "vault.field.city": "Város",
  "vault.field.zip": "Irányítószám",
  "vault.field.country": "Ország",
  "vault.field.phone": "Telefon",
  "vault.field.email": "E-mail",
  "vault.field.birthdate": "Születési dátum",
  "vault.field.sshPrivate": "Privát kulcs",
  "vault.field.sshPublic": "Nyilvános kulcs",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Szöveg",
  "vault.ft.password": "Jelszó",
  "vault.ft.textarea": "Hosszú szöveg",
  "vault.ft.date": "Dátum",
  "vault.ft.url": "URL",
  "vault.ft.email": "E-mail",
  "vault.ft.number": "Szám",
  "vault.tpl.title": "Sablonok",
  "vault.tpl.manage": "Sablonok kezelése",
  "vault.tpl.yours": "A sablonjaid",
  "vault.tpl.new": "Új sablon",
  "vault.tpl.edit": "Sablon szerkesztése",
  "vault.tpl.empty": "Még nincsenek sablonjaid. Hozz létre egyet, hogy saját elemtípust definiálj.",
  "vault.tpl.name": "Sablon neve",
  "vault.tpl.name.ph": "Pl.: Kripto pénztárca, Szállodafoglalás…",
  "vault.tpl.confirmDelete": "Törlöd ezt a sablont? A belőle létrehozott elemek megmaradnak.",
  "totp.copyCode": "Kód másolása",
  "totp.copySecret": "Secret másolása",
  "totp.showSecret": "Secret megjelenítése",
  "totp.hideSecret": "Secret elrejtése",
  "totp.invalid": "érvénytelen secret",
  "private.module.coming": "Hamarosan.",
  "private.module.comingHint": "Ez a modul hamarosan elérhető lesz. A Privát IKO kriptográfiája már működik — hamarosan ide menthetsz, amire szükséged van.",
  "notes.new": "Új jegyzet",
  "notes.empty": "Még nincsenek jegyzeteid ebben az IKO.",
  "notes.emptyPreview": "(üres)",
  "notes.untitled": "Cím nélkül",
  "notes.delete": "Jegyzet törlése",
  "notes.confirmDelete": "Törlöd ezt a jegyzetet? Nem állítható vissza.",
  "notes.titlePlaceholder": "Cím",
  "notes.contentPlaceholder": "Írd le, amire emlékezned kell…",
  "notes.startHint": "Nincsenek jegyzetek ebben az IKO. Hozd létre az elsőt.",
  "notes.autosaveHint": "Automatikusan mentve, titkosítva, csak itt.",
  "notes.yesterday": "Tegnap",
  "passwords.new": "Új bejegyzés",
  "passwords.empty": "Még nem mentettél semmit ebben az IKO.",
  "passwords.untitled": "Név nélküli",
  "passwords.startHint": "Nincsenek jelszavak ebben az IKO. Hozd létre az elsőt.",
  "passwords.confirmDelete": "Törlöd ezt a bejegyzést? Nem állítható vissza.",
  "passwords.save": "Mentés",
  "passwords.edit": "Szerkesztés",
  "passwords.delete": "Törlés",
  "passwords.copy": "Másolás",
  "passwords.copied": "Másolva ✓",
  "passwords.show": "Megjelenítés",
  "passwords.hide": "Elrejtés",
  "passwords.field.label": "Név",
  "passwords.field.label.ph": "Bank, fiók, szolgáltatás…",
  "passwords.field.username": "Felhasználó",
  "passwords.field.username.ph": "E-mail, alias, szám…",
  "passwords.field.password": "Jelszó",
  "passwords.field.password.ph": "A jelszó, amit menteni szeretnél",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Jegyzetek",
  "passwords.field.notes.ph": "Bármilyen hasznos részlet",
  "media.uploading": "Feltöltés…",
  "media.uploadFailed": "A fájl feltöltése sikertelen.",
  "media.upload.file": "Fájl feltöltése",
  "media.upload.photo": "Fotó feltöltése",
  "media.upload.video": "Videó feltöltése",
  "media.upload.audio": "Hang feltöltése",
  "media.empty.file": "Még nincsenek fájlok ebben az IKO.",
  "media.empty.photo": "Még nincsenek fotók ebben az IKO.",
  "media.empty.video": "Még nincsenek videók ebben az IKO.",
  "media.empty.audio": "Még nincsenek hangok ebben az IKO.",
  "media.play": "Lejátszás",
  "media.download": "Letöltés",
  "media.delete": "Törlés",
  "media.confirmDelete": "Törlöd ezt az elemet? Nem állítható vissza.",
  "media.noPreview": "Nincs előnézet ehhez a fájltípushoz.",
  "modal.share.title": "Kapcsolat megosztása",
  "modal.share.hint": "Válassz egy kapcsolatot a listából vagy add meg manuálisan a IKOGNIT ID-t.",
  "modal.share.filter": "Kapcsolatok szűrése…",
  "modal.share.empty": "Nincsenek kapcsolatok ebben a IKO-ban",
  "modal.share.manual": "Vagy manuális IKOGNIT ID",
  "modal.share.btn": "Megosztás",
  "modal.group.title": "Új csoport",
  "modal.group.hint": "Válassz nevet és válassz tagokat a kapcsolataid közül ebben a IKO-ban.",
  "modal.group.namePh": "Csoport neve",
  "modal.group.selected": "{0} kiválasztva",
  "modal.group.create": "Csoport létrehozása",
  "modal.remember.title": "Eszköz megjegyzése",
  "modal.remember.hint": "A munkameneted, kapcsolataid, csoportjaid és üzeneteid mentésre kerülnek ezen az eszközön, csak általad ismert PIN-nel titkosítva. Az alkalmazás újranyitásakor megadod a PIN-t a feloldáshoz.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Ismételd a PIN-t",
  "modal.remember.warn": "Ha elfelejted a PIN-t, a mentett adatok nem visszaállíthatók. Újra be kell jelentkezned felhasználóval és jelszóval.",
  "modal.remember.errShort": "A PIN-nek legalább 4 karakteresnek kell lennie.",
  "modal.remember.errMismatch": "A PIN-ek nem egyeznek.",
  "stickers.faces": "Arcok",
  "stickers.gestures": "Gesztusok",
  "stickers.hearts": "Szívek",
  "stickers.symbols": "Szimbólumok",
  "stickers.animals": "Állatok",
  "stickers.food": "Étel",
  "ttl.1h": "1 óra",
  "ttl.1d": "1 nap",
  "ttl.1w": "1 hét",
  "ttl.1m": "1 hónap",
  "ttl.6m": "6 hónap",
  "ttl.12m": "12 hónap",
  "timeout.5min": "5 perc",
  "timeout.15min": "15 perc",
  "timeout.30min": "30 perc",
  "timeout.never": "Soha",
  "toast.newMessage": "Új üzenet",
  "toast.group": "{0} (csoport)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "IKO-információ és navigáció",
  "ctx.section.universe": "JELENLEGI IKO",
  "ctx.universe.personal": "A te személyes tered",
  "ctx.status.serverBlind": "Vak szerver aktív",
  "ctx.status.e2e": "Végpontok közötti titkosítás",
  "ctx.section.nav": "NAVIGÁCIÓ",
  "ctx.nav.changeIko": "IKO-váltás",
  "ctx.nav.activateIko": "IKO aktiválása",
  "ctx.nav.backToIkognit": "Vissza az IKOGNIT-hoz",
  "ctx.section.actions": "MŰVELETEK",
  "ctx.action.newChat": "Új csevegés",
  "ctx.action.newGroup": "Új csoport",
  "ctx.action.contacts": "Saját kontaktok",
  "ctx.section.conversation": "BESZÉLGETÉS",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} üzenet",
  "ctx.peer.message": "{0} üzenet",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Személyes IKO",
  "ctx.modes.storage": "Meghajtó",
  "ctx.liturgy.0": "A szerver vak.",
  "ctx.liturgy.1": "Itt csak te olvasol.",
  "ctx.liturgy.2": "Senki nem tudja, hogy itt vagy.",
  "ctx.liturgy.3": "A IKO olyan titok, amit csak te ismersz.",
  "ctx.liturgy.4": "A magánéleted az architektúra.",
  "ccb.universe.changeOrExit": "IKO-váltás vagy kilépés",
  "ccb.universe.activate": "IKO aktiválása",
  "ccb.leave.title": "Kilépés a IKO-ból (vissza az IKOGNIT-ba)",
  "ccb.leave.aria": "Kilépés a IKO-ból",
  "ccb.tag.cipher.title": "Szimmetrikus titkosítás aktív",
  "ccb.tag.srv.title": "A szerver nem tudja elolvasni a tartalmat",
  "ccb.tag.unread.title": "Olvasatlan üzenetek",
  "ccb.settings.title": "Beállítások · profil, témák, munkamenet",
  "ccb.settings.aria": "Beállítások",
  "ccb.identity.title": "Munkamenet: @{0}",
  "ccb.clock.title": "Helyi idő",
  "ccb.modes.personalPrefix": "SZEMÉLYES · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "SZEMÉLYES IKO",
  "holo.modes.general": "A NICKED + KONTAKTOK",
  "holo.claim.inIko": "Ez a IKO láthatatlan marad annak, aki nem ismeri.",
  "holo.claim.general": "A te személyes tered az IKOGNIT-ban. Itt beszélsz a kontaktjaiddal.",
  "holo.card.conversations": "Beszélgetések",
  "holo.card.contacts": "Kontaktok",
  "holo.card.cipher": "Titkosítás",
  "holo.card.server": "Szerver",
  "holo.foot": "Válassz beszélgetést, aktiválj egy IKO-ot vagy hozz létre új teret.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Személyes IKO",
  "uib.context.coordTitle": "Az IKO",
  "uib.context.general": "Általános IKO",
  "uib.e2e.title": "A szerver nem olvashatja a tartalmadat — E2E titkosítás a te kulcsoddal",
  "uib.e2e.label": "Vak szerver",
  "uib.pseudoTitle": "Az álneved ebben a IKO-ban",
  "uib.nickTitle": "A nicked",
  "uib.exitTitle": "Vissza az Általános IKO",
  "uib.exitLabel": "Kilépés",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Fő navigáció",
  "chat.tab.chats": "Csevegések",
  "chat.tab.calls": "Hívások",
  "chat.tab.contacts": "Kontaktok",
  "chat.backToIkognit.title": "Vissza az általános IKOGNIT-ba",
  "chat.delete.title": "Törlés",
  "chat.delete.aria": "Törlés",
  "chat.call.title": "Hívás",
  "chat.videoCall.title": "Videohívás",
  "chat.videoCall.aria": "Videohívás {0}-vel",
  "chat.search.clear": "Keresés törlése",
  "chat.filters.aria": "Csevegés szűrők",
  "chat.filter.all": "Mind",
  "chat.filter.unread": "Olvasatlanok",
  "chat.filter.groups": "Csoportok",
  "chat.attachPending": "Csatolmány függőben",
  "chat.remove.title": "Eltávolítás",
  "chat.cancel.title": "Mégse",
  "chat.blocked.text": "Letiltottad {0}-t. Nem küldhetsz neki üzenetet és nem hívhatod.",
  "chat.unblock": "Feloldás",
  "contacts.alias.placeholder": "Egy álnév a felismeréshez",
  "contacts.notes.placeholder": "Csak te látod (titkosítva a szerveren).",
  "contacts.search.placeholder": "Keresés álnév vagy IKOGNIT ID alapján",
  "contacts.edit.title": "Álnév és jegyzet szerkesztése",
  "contacts.edit.aria": "Szerkesztés",
  "contacts.blockBtn": "Kontakt letiltása",
  "contacts.unblockBtn": "Kontakt feloldása",
  "contacts.confirmBlock.title": "Kontakt letiltása",
  "contacts.confirmUnblock.title": "Kontakt feloldása",
  "contacts.confirmBlock.body": "Letiltod {0}-t? Nem kapsz tőle üzenetet és hívást.",
  "contacts.confirmUnblock.body": "Feloldod {0}-t? Újra kapsz tőle üzeneteket.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "A Személyes IKO kategóriái",
  "piko.rail.head": "SZEMÉLYES",
  "piko.cat.all": "Minden",
  "piko.cat.photos": "Fotók",
  "piko.cat.videos": "Videók",
  "piko.cat.audios": "Hangok",
  "piko.cat.files": "Fájlok",
  "piko.cat.notes": "Jegyzetek",
  "piko.cat.passwords": "Jelszavak",
  "piko.cat.cards": "Kártyák",
  "piko.cat.identities": "Identitások",
  "piko.cat.sshkeys": "SSH-kulcsok",
  "piko.cat.custom": "Mappák",
  "piko.cat.agendas": "IKO-címtárak",
  "piko.cat.storage": "Lemezok és Lemezek",

  "auth.field.nickPlaceholder": "pl. user123",
  "auth.field.emailPlaceholder": "te@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Olvasva {0}",
  "bubble.tick.delivered": "Kézbesítve {0}",
  "bubble.tick.sent": "Elküldve",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Letiltottad ezt a felhasználót.",
  "chat.preview.image": "Kép",
  "chat.preview.video": "Videó",
  "chat.preview.voice": "Hangüzenet",
  "chat.preview.audio": "Hang",
  "error.push.denied": "Megtagadtad az értesítési engedélyt.",
  "error.push.noSw": "Ez a böngésző nem támogatja a service workereket.",
  "error.push.noPush": "Ez a böngésző nem támogatja a push értesítéseket.",
  "error.push.noVapid": "A szerver nem adta át a VAPID kulcsot.",
  "error.push.activateFailed": "Nem sikerült aktiválni ({0}).",
  "chat.group.membersWord": "tag",
  "chat.newCall.title": "Új hívás",
  "chat.newChat.title": "Új csevegés",
  "chat.newCall.empty": "Még nincsenek kapcsolatok. Adj hozzá egyet a Csevegések + gombjával.",
  "chat.unread.aria": "olvasatlan üzenet",
  "chat.calls.title": "Hívások",
  "chat.calls.empty": "Még nincsenek hívások. Indíts egyet egy kapcsolat csevegéséből.",
  "chat.calls.callContact": "Hívás indítása",
  "chat.calls.historySoon": "A híváselőzmények hamarosan elérhetők lesznek.",
  "chat.deleteConv.titleOne": "Beszélgetés törlése",
  "chat.deleteConv.titleMany": "{0} beszélgetés törlése",
  "chat.deleteConv.hint": "„Nálam” törli a saját másolatodat (minden eszközöd). „Mindenkinél” kéri a kapcsolatot is, hogy törölje.",
  "chat.deleteConv.forMe": "Törlés nálam",
  "chat.deleteConv.forAll": "Törlés mindenkinél",
  "chat.myContacts": "Saját kapcsolatok",
  "chat.contacts.noResults": "Nincs találat.",
  "chat.contacts.empty": "Még nincsenek kapcsolatok.",
  "chat.contact.badgeBlocked": "letiltva",
  "chat.contact.badgePending": "megerősítetlen",
  "chat.toast.saved": "Mentve",
  "chat.toast.videoSaved": "Videó mentve a Fotók közé",
  "chat.toast.imageSaved": "Kép mentve a Fotók közé",
  "chat.toast.updateTestflight": "Frissítsd a TestFlight-ot 1.0(10)+ verzióra a mentéshez.",
  "chat.toast.saveFailed": "Mentés sikertelen: {0}",
  "chat.toast.saveError": "Mentési hiba",
  "iko.banner.exitAria": "Kilépés az IKO-ból az általános síkra",
  "iko.liturgy.entering": "Belépés a IKO-ba",
  "iko.liturgy.returning": "Visszatérés",
  "iko.liturgy.toIkognit": "IKOGNIT-ba",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Személyes IKO",
  "manifest.blindServer": "A szerver vak.",
  "manifest.onlyYouRead": "Itt csak te olvasol.",
  "manifest.noPublicProfiles": "Nincsenek nyilvános profilok.",
  "manifest.noAdsNoClouds": "Nincsenek hirdetések. Nincsenek külső felhők.",
  "manifest.keyWithYou": "A kulcs nálad él.",
  "manifest.yourIkoYourSpaces": "A te IKO-aid. A te tereid.",
  "orb.mod.chat": "Csevegés",
  "orb.mod.files": "Fájlok",
  "orb.mod.notes": "Jegyzetek",
  "orb.mod.photos": "Fotók",
  "orb.mod.vault": "Mappa",
  "orb.mod.audios": "Hangok",
  "orb.copy.line1": "A te IKO-aid.",
  "orb.copy.line2": "A te tereid.",
  "explorer.filesNotProcessed": "Feldolgozatlan fájl(ok)",
  "demo.edit": "Szerkesztés",
  "common.exit": "Kilépés",
  "common.more": "Több",
  "chat.tab.settings": "Beállítások",
  "chat.search.placeholder": "Csevegés keresése",
  "chat.presence.online": "online",
  "chat.action.call": "Hívás",
  "chat.action.videoCall": "Videohívás",
  "chat.attach.label": "Csatolás",
  "chat.attach.camera": "Kamera",
  "chat.attach.voice": "Hang",
  "chat.attach.file": "Fájl csatolása",
  "chat.composer.placeholder": "Írj egy üzenetet...",
  "settings.addYourName": "Add meg a neved",
  "settings.editProfile": "Profil szerkesztése",
  "chat.welcome.intro": "Válassz egy csevegést, hogy elkezdj végpontok közötti titkosítással beszélni.",

  // Batch2: footer atajos web
  "web.footer.palette": "paletta",
  "web.footer.send": "küldés",
  "web.footer.line": "sor",
  "mobile.tb.ikoActivate": "IKO aktiválása",
  "mobile.tb.ikoExit": "Vissza az általános IKOGNIT-hoz",

  "chat.header.blocked": "Letiltva",
  "contacts.alias.label": "Álnév",
  "contacts.note.label": "Privát jegyzet",
  "settings.account.newNickPlaceholder": "új_becenév",
  "settings.account.newEmailPlaceholder": "uj@email.com",


  "common.delete": "Törlés",








};

const ro: Catalog = {
  "auth.verify.notSent": "Nu am putut să-ți trimitem codul. Contul tău există: apasă «Retrimite codul» într-o clipă.",
  "lg.rotulo": "Mesagerie cu spații private",
  "lg.btn.entrar": "Intră",
  "lg.eyebrow": "Mesagerie privată · Itrion Software",
  "lg.h1a": "Conversațiile tale dintotdeauna.",
  "lg.h1b": "Și un loc care există doar când îl invoci.",
  "lg.lead1": "Vorbești cu familia, cu prietenii și cu echipa ta, ca în orice aplicație. Diferența începe când deschizi un IKO: un spațiu al tău în care intri scriind un secret pe care îl știu doar cei dinăuntru.",
  "lg.lead2": "Cât timp nu îl invoci, acel spațiu nu se află pe dispozitivul tău — nici pe telefon, nici pe tabletă, nici pe calculator. Nu e vorba că ar fi criptat.",
  "lg.lead2b": "Pur și simplu nu e acolo.",
  "lg.pruebalo": "Încearcă · scrie un secret și vezi ce se întâmplă",
  "lg.panel.plano": "Planul general",
  "lg.demo.hilos": "Familia=Mama: mâncăm duminică la noi?=19:04|Marta=îți trimit pozele de sâmbătă=17:52|Echipa=Luis: mâine la nouă, deci=Ieri|Javi=haha nu-mi vine să cred=Ieri",
  "lg.demo.mundos": "Doar noi doi~l-ai pus unde am zis?|da. actele și pașaportul>~Actele apartamentului.pdf=2,4 MB|Poze private=214|Card · bancă=Date~~Lucruri de acasă~îți las aici contractul de închiriere>|și cheia de la router, că mereu o pierzi~Contract de închiriere.pdf=1,1 MB|Copie buletin=2 fișiere|Cheile casei=Date~~Notițele mele~asta nu am spus nimănui>|și nici nu e nevoie>~Jurnal=48 de notițe|Poze=1.207|Conturile anului=Date~~Proiectul Lisabona~oferta iese 180|uite-o, fără copii pe afară>~Oferta_v4.pdf=860 KB|Contacte=12|Card de firmă=Date~~Prânzul de sâmbătă~nu-i spune încă nimic Martei|liniștit, aici nu află nimeni>~Rezervare.pdf=120 KB|Poze de anul trecut=63|Lista invitaților=Date",
  "lg.invocaLabel": "Invocă-ți IKO",
  "lg.invocaPlaceholder": "scrie un secret oarecare",
  "lg.invocaBtn": "Invocă",
  "lg.invocaHint": "Fiecare cuvânt duce la alt spațiu. Încearcă altul.",
  "lg.estela.vacio": "Scrie orice: aici e o demonstrație.",
  "lg.estela.primero": "Gata. Există doar cât timp ești înăuntru.",
  "lg.estela.otro": "Alt secret, alt spațiu. Niciunul nu știe de celelalte.",
  "lg.estela.salida": "S-a dus. Nicio urmă pe dispozitiv. Încearcă alt cuvânt.",
  "lg.ikoActivo": "IKO activ",
  "lg.nadaEnDispositivo": "Nimic din toate astea nu e pe dispozitiv",
  "lg.salirIko": "Ieși din IKO",
  "lg.planos.h2a": "Un plan la vedere.",
  "lg.planos.h2b": "Dedesubt, cele pe care le invoci tu.",
  "lg.planos.lead": "Nu există «IKO-ul». Există cele pe care le deschizi: unul pentru lucrurile de acasă, altul pentru muncă, altul pe care îl știți doar voi doi, altul despre care n-ai vorbit nimănui. Fiecare secret duce la al lui, și niciunul nu știe de celelalte.",
  "lg.planos.unoRotulo": "Planul general · unul",
  "lg.planos.unoH3": "Unde vorbești cu toată lumea",
  "lg.planos.unoP": "Conversații, grupuri, apeluri, poze și fișiere, criptate cap la cap. Ce aștepți de la o aplicație de mesagerie, făcut ca lumea. Conversațiile tale obișnuite locuiesc aici și se comportă ca întotdeauna.",
  "lg.planos.nRotulo": "IKO-urile · câte vrei",
  "lg.planos.nH3": "Unde nu ajunge nimeni altcineva",
  "lg.planos.nP": "Scrii un secret și apare spațiul care îi corespunde. Înăuntru încap conversații și lucrurile tale. Când ieși, dispare de pe dispozitiv fără urmă. Nu există listă, nu există număr și nimeni nu poate afla câte ai, nici că există măcar unul.",
  "lg.planos.chips": "Lucrurile de acasă|Munca|Ce știți doar voi doi|Al tău și al nimănui altcuiva|Cel deschis o dată și niciodată de atunci|Cele pe care le decizi mâine",
  "lg.forense.h2a": "Nu e criptat pe dispozitivul tău.",
  "lg.forense.h2b": "Nu e pe dispozitivul tău.",
  "lg.forense.lead": "Celelalte aplicații îți țin mesajele pe aparat și le criptează. Dacă cineva îl ia, intimitatea ta depinde de cât rezistă acea criptare. Aici nu e nimic care să trebuiască să reziste: ce trăiește într-un IKO nu se scrie pe niciun dispozitiv. Se invocă, se folosește și pleacă.",
  "lg.forense.multi": "La fel peste tot: telefon, tabletă, calculatorul de acasă, laptopul de la muncă, Windows, Mac sau browserul dintr-un loc care nu e al tău. Intri unde vrei și, la ieșire, locul acela nu mai știe nimic despre tine.",
  "lg.forense.caption": "Ce găsește cel care îți examinează oricare dintre dispozitive",
  "lg.forense.filas": "Mesaje din IKO-urile tale=0|Fișiere și fotografii din IKO-urile tale=0|Secrete de IKO salvate=0|Bază de date cu IKO-urile tale=nu există|Urmă că un IKO a fost deschis=niciuna|Câte IKO ai=imposibil de stabilit",
  "lg.escenas.h2": "Ce te îngrijorează cu adevărat.",
  "lg.escenas.filas": "«Mi-am pierdut telefonul.»=Intimitatea ta nu s-a pierdut cu el. Ce era într-un IKO n-a fost niciodată pe aparatul acela, deci nu e nimic de salvat și nimic de temut. Îl invoci de pe orice alt dispozitiv și totul e unde era.~«Mi-au luat laptopul.»=Va vedea conversațiile tale obișnuite, aceleași pe care le-ar vedea în orice aplicație. Din rest nu va vedea nici conținutul, nici numele, nici indiciul că există.~«Mi-au examinat calculatorul.»=O analiză criminalistică recuperează ce e scris pe disc, chiar criptat și șters. Aici nu e nimic scris de recuperat. Răspunsul nu e «nu se poate decripta»: nu e nimic acolo. Și la fel pe tabletă, pe telefon și în browserul folosit o după-amiază.",
  "lg.ciego.h2": "Nici noi. Nici cine găzduiește serverele.",
  "lg.ciego.p1": "Serverul păstrează lucruri pe care nu le poate citi. Nu are secretul tău, nu l-a avut niciodată și nu există nicio copie nicăieri. Nu e vorba că refuzăm să predăm ce e în IKO-urile tale: nu îl avem și nu avem cum să îl avem. Nici firma care găzduiește mașinile, nici cineva care ar pune mâna pe ele.",
  "lg.ciego.p2": "Asta are un preț și e corect să îl spunem: dacă îți pierzi secretul, nu are cine să ți-l dea înapoi. Exact motivul pentru care nimeni altcineva nu poate intra este motivul pentru care nici noi nu te putem ajuta să intri.",
  "lg.guardas": "Poze de familie|Notițele pe care nu le arăți|Carduri și date bancare|Parole|Documente|Conversații care vă privesc doar pe voi",
  "lg.nombre.esta": "există",
  "lg.nombre.noEsta": "nu există",
  "lg.nombre.h2": "De aici numele.",
  "lg.nombre.p": "În swahili, iko înseamnă «există» și haiko, «nu există». Un IKO există cât timp îl invoci. În restul timpului — adică aproape tot timpul — nu există: nici pe dispozitivele tale, nici la vederea cuiva, nici măcar ca bănuială.",
  "lg.cierre.h2": "Începe să vorbești.",
  "lg.cierre.p": "Se folosește ca orice aplicație de mesagerie, pe telefon, pe tabletă și pe calculator. IKO-urile sunt acolo în ziua în care ai nevoie de ele.",
  "lg.cierre.btnCrear": "Creează cont",
  "lg.cierre.btnEntrar": "Am deja cont",
  "lg.cierre.pago": "IKOGNIT este un produs cu plată. Fără reclame, fără profiluri publicitare și fără nicio copie a nimic la noi: trăim din faptul că aplicația merită pentru tine, nu din ce spui în ea.",
  "lg.pie.ciego": "Server orb",
  "auth.hola": "Salut din nou.",
  "auth.queEs": "Ce este IKOGNIT?",
  "common.cancel": "Anulează",
  "common.error.generic": "Nu s-a putut. Încearcă din nou.",
  "common.save": "Salvează",
  "common.confirm": "Confirmă",
  "common.close": "Închide",
  "common.add": "Adaugă",
  "common.back": "Înapoi",
  "common.tagline": "Suveranitate digitală.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "În swahili, iko înseamnă „există”. Iar haiko, „nu există”.",
  "auth.legal.age": "Confirm că am vârsta minimă cerută de legea țării mele pentru a folosi IKOGNIT.",
  "auth.legal.accept": "Am citit și accept <a href='https://ikognit.org/legal/ro/termeni.html' target='_blank' rel='noopener'>Termenii</a>, <a href='https://ikognit.org/legal/ro/confidentialitate.html' target='_blank' rel='noopener'>Politica de Confidențialitate</a> și <a href='https://ikognit.org/legal/ro/reguli-comunitate.html' target='_blank' rel='noopener'>Regulile Comunității</a>.",
  "recovery.title": "Cheia ta de recuperare",
  "recovery.intro": "Aceste **24 de cuvinte** sunt singura cale de a-ți recupera contul și istoricul dacă uiți parola sau pierzi dispozitivul. **Scrie-le pe hârtie și păstrează-le într-un loc sigur.** Nimeni la IKOGNIT nu le poate recupera pentru tine.",
  "recovery.warn": "**Scrie-le OFFLINE.** Nu face captură de ecran. Nu le trimite prin email sau mesagerie. Cine deține aceste cuvinte controlează întregul tău cont.",
  "recovery.btn.show": "Arată cuvintele",
  "recovery.btn.copy": "Copiază",
  "recovery.btn.copied": "Copiat · se șterge în {0}s",
  "recovery.btn.cleared": "Clipboard șters",
  "recovery.btn.copyAria": "Copiază fraza de recuperare în clipboard (se șterge automat)",
  "recovery.btn.download": "Descarcă",
  "recovery.btn.downloadAria": "Descarcă fraza ca fișier text",
  "recovery.btn.back": "Înapoi la cuvinte",
  "recovery.btn.continue": "Continuă",
  "recovery.btn.done": "Am terminat",
  "recovery.btn.need3": "Scrie cele 3 cuvinte corecte",
  "recovery.verify.intro": "Pentru a confirma că ți-ai salvat cheia, scrie aceste cuvinte. Nu poți continua fără să le nimerești.",
  "recovery.verify.wordN": "Cuvânt #{0}",
  "recovery.verify.correct": "Corect",
  "recovery.verify.wrong": "Greșit",
  "auth.error.legalRequired": "Trebuie să accepți termenii legali și să confirmi vârsta pentru a crea un IKOGNIT ID.",
  "settings.legal.title": "Informații legale",
  "settings.legal.hub": "Centrul Legal",
  "settings.legal.terms": "Termeni și Condiții",
  "settings.legal.privacy": "Politica de Confidențialitate",
  "settings.legal.rules": "Regulile Comunității",
  "settings.legal.report": "Raportări și Moderare",
  "settings.legal.cookies": "Politica Cookies",
  "settings.legal.minors": "Politica Minorilor",
  "settings.legal.notice": "Notă Legală",
  "settings.tab.legal": "Legal",
  "auth.loading": "Se încarcă…",
  "auth.savedSession": "Acest dispozitiv își cunoaște deja proprietarul.",
  "auth.locked": "S-a risipit din lipsă de activitate. Intră din nou.",
  "auth.sessionExpired": "Sesiunea s-a risipit. Intră din nou.",
  "auth.tab.login": "Conectare",
  "auth.tab.register": "IKOGNIT ID nou",
  "auth.subLogin": "Intri în planul general: conversațiile tale dintotdeauna. IKO-urile nu se invocă aici — se invocă înăuntru, când ai nevoie de ele.",
  "auth.subRegister": "Contul rămâne pe numele tău. Nick-ul e felul în care te văd ceilalți; emailul servește doar la recuperarea accesului și la anunțuri.",
  "auth.field.devicePin": "Cheie principală",
  "auth.field.password": "Cheie principală",
  "auth.btn.unlock": "Conectare",
  "auth.btn.unlocking": "Conectare…",
  "auth.btn.processing": "Procesare…",
  "auth.btn.createIdentity": "Crează IKOGNIT ID",
  "auth.btn.useOther": "Folosește alt IKOGNIT ID",
  "auth.btn.forget": "Uită acest dispozitiv",
  "auth.btn.backToUnlock": "Înapoi",
  "auth.confirmForget": "Acest dispozitiv nu te va mai recunoaște: dispar contul salvat și tot ce e în cache. Ca să intri din nou vei avea nevoie de parolă.",
  "auth.confirmForget.warning": "Fără fraza de recuperare de 24 de cuvinte notată, nu mai e cale de întoarcere: nimeni nu ți-o poate da înapoi.",
  "invite.welcomeSub": "Mesaje și un spațiu al tău: ce păstrezi aici rămâne pe numele tău. Creează-ți contul și veți fi conectați.",
  "auth.reset.warnNewIdentity": "Contul rămâne al tău, dar recuperarea prin email îți dă o identitate nouă: mesajele anterioare nu vor mai putea fi citite. Dacă mai ai fraza de recuperare de 24 de cuvinte, folosește calea aceea.",
  "recover.intro": "Scrie-ți nick-ul sau emailul și cele 24 de cuvinte de recuperare primite la crearea contului. Apoi vei alege o parolă nouă.",
  "auth.error.badCreds": "IKOGNIT ID sau cheie incorecte.",
  "auth.error.userNotFound": "IKOGNIT ID negăsit.",
  "auth.error.cantConnect": "Nu s-a putut conecta la server.",
  "auth.error.badPin": "Cheie incorectă.",
  "auth.footnote": "Cine e proprietar, răspunde.\nDacă îți pierzi parola,\nnu ai la cine să reclami.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "IKO actual: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "IKO Personal: {0}",
  "sidebar.freqPsh": "IKO de Domeniu: {0}",
  "sidebar.tune": "Activează IKO",
  "sidebar.exitFreq": "Înapoi la IKOGNIT",
  "sidebar.notifications": "Notificări",
  "sidebar.remember": "Memorează dispozitivul",
  "sidebar.forget": "Uită dispozitivul",
  "sidebar.addContact": "Adaugă contact prin nick",
  "sidebar.newGroup": "Grup nou",
  "sidebar.settings": "Setări",
  "sidebar.logout": "Ieșire",
  "sidebar.tooltip.logout": "Deconectează și șterge tot localul",
  "sidebar.savedFreq.tooltip": "Activează {0}",
  "chat.empty": "Selectează sau adaugă un contact",
  "welcome.title": "Bine ai venit la IKOGNIT",
  "welcome.concept": "În IKOGNIT discuți cu alți utilizatori, identificat prin nick. Când vrei un spațiu separat, activezi un IKO și intri într-un IKO. Dacă e Public, te întâlnești cu cei care îl activează și ei. Dacă e Privat, intri într-un IKO unde ești doar tu.",
  "welcome.step1": "Activează un IKO Public și intră într-un IKO cu cei care îl cunosc și ei.",
  "welcome.step2": "Aici în IKOGNIT, adaugă un nick ca contact și începe să vorbești.",
  "welcome.step3": "Activează un IKO Privat și deschide un IKO doar pentru tine, unde păstrezi fișiere, fotografii, audio, video, parole, note și scrisori.",
  "welcome.multidevice": "IKO-urile nu se stochează niciodată nicăieri. Dacă uiți un IKO, IKO său încetează să existe pentru tine.",
  "welcome.btnFreq": "Activează IKO",
  "welcome.btnContacts": "Adaugă contact",
  "push.btnOn": "Notificări ON",
  "push.btnOff": "Notificări OFF",
  "push.btnEnable": "Notificări dezactivate. Click pentru a activa.",
  "push.btnDisable": "Notificări activate. Click pentru a dezactiva.",
  "push.introTitle": "Înainte de a activa notificările",
  "push.introBody": "Pentru confidențialitate, notificările IKOGNIT sunt diferite de cele ale altor aplicații de mesagerie:",
  "push.introBullet1": "Conținutul mesajului nu este inclus.",
  "push.introBullet2": "Numele și IKOGNIT ID-ul expeditorului nu sunt afișate.",
  "push.introBullet3": "Vei primi doar o alertă „mesaj nou”; deschide aplicația pentru a-l citi criptat pe dispozitivul tău.",
  "push.introConfirm": "Activează notificări",
  "chat.placeholder": "Scrie un mesaj…",
  "chat.newMessages": "noi",
  "chat.newMessagesBadge": "Mergi la {0} mesaje noi",
  "chat.mediaRetry": "Reîncearcă",
  "chat.mediaFailed": "Nu s-a putut încărca",
  "chat.media.download": "Descarcă",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Editează mesajul…",
  "chat.replyingTo": "Răspundeți lui {0}",
  "chat.editing": "Editare mesaj",
  "chat.confirmContact": "Adaugă la contacte",
  "chat.unconfirmedBanner": "Acest utilizator ți-a scris, dar nu este în contactele tale. Până nu îl adaugi, poza și info-ul tău nu îi vor fi vizibile conform setărilor tale de confidențialitate.",
  "chat.online": "online",
  "chat.lastSeen": "ultima dată văzut {0}",
  "chat.tooltip.attach": "Atașează fișier",
  "chat.tooltip.shareContact": "Partajează contact",
  "chat.tooltip.paste": "Lipește imagine din clipboard",
  "chat.tooltip.stickers": "Stickere",
  "chat.tooltip.callAudio": "Apel vocal",
  "chat.tooltip.callVideo": "Apel video",
  "chat.btn.send": "Trimite",
  "chat.uploading": "…",
  "preview.image": "📷 Imagine",
  "preview.video": "🎬 Video",
  "preview.audio": "🎙 Audio",
  "bubble.reply": "Răspunde",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Editează",
  "bubble.edited": "editat",
  "bubble.contact.label": "Contact IKOGNIT",
  "bubble.media.decrypting": "Decriptare…",
  "bubble.media.failed": "Nu s-a putut decripta fișierul.",
  "call.calling": "Apelare…",
  "call.incoming.audio": "Apel primit",
  "call.incoming.video": "Apel video primit",
  "call.connecting": "Conectare…",
  "call.ending": "Încheiere…",
  "call.accept": "Acceptă",
  "call.reject": "Respinge",
  "call.hangup": "Închide",
  "call.mic": "Microfon",
  "call.camera": "Cameră",
  "call.audioOut": "Ieșire audio",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Pentru a apela trebuie să fii într-un IKO.",
  "error.notFound": "Resursa nu a fost găsită.",
  "error.notInFreq": "{0} nu este încă în acest IKO. Cere-i prin alt canal să îl activeze.",
  "error.push.iosTooOld": "iOS-ul tău este anterior 16.4. Actualizează pentru a primi notificări.",
  "error.push.iosNotStandalone": "Pentru a primi notificări pe iPhone, instalează IKOGNIT pe ecranul de pornire: apasă Partajare → Adaugă la ecranul principal.",
  "error.expired": "Sesiune expirată. Conectează-te din nou.",
  "error.gone": "Fișierul a expirat.",
  "error.invalid": "Date invalide.",
  "error.server": "Eroare server. Încearcă din nou.",
  "error.network": "Fără conexiune la server.",
  "error.cantStartCall": "Nu s-a putut iniția apelul: {0}",
  "error.cantAcceptCall": "Nu s-a putut accepta apelul: {0}",
  "error.cantPaste": "Nu s-a putut accesa clipboardul. Încearcă butonul atașare.",
  "error.noImageInClipboard": "Nicio imagine în clipboard.",
  "error.clipboardUnsupported": "Browserul tău nu permite citirea clipboardului. Lipește cu Ctrl+V sau folosește butonul atașare.",
  "error.selfContact": "Nu te poți adăuga pe tine însuți.",
  "error.blocked": "Ai blocat acest utilizator. Deblochează-l în Setări pentru a vorbi din nou.",
  "settings.title": "Setări",
  "settings.close": "Închide",
  "settings.tab.profile": "👤 Profil",
  "settings.tab.privacy": "🔒 Confidențialitate",
  "settings.tab.messages": "✉ Mesaje",
  "settings.tab.blocked": "🚫 Blocați",
  "settings.tab.notifications": "🔔 Notificări",
  "settings.tab.session": "⏱ Sesiune",
  "settings.tab.account": "🆔 Cont",
  "settings.tab.language": "🌐 Limbă",
  "settings.tab.about": "ℹ Despre",
  "settings.scope.global": "Global (IKOGNIT)",
  "settings.scope.freq": "Doar în {0}",
  "settings.profile.title": "Profil",
  "settings.profile.hintGlobal": "Aceste valori sunt folosite implicit și moștenite în toate IKO-urile.",
  "settings.profile.hintFreq": "Suprascriu profilul global când ești în {0}. Dacă nu definești ceva aici, se moștenește din global.",
  "settings.profile.displayName": "Nume afișat",
  "settings.profile.displayNamePh.global": "(fără nume — se va afișa nick-ul tău)",
  "settings.profile.displayNamePh.freq": "(moștenește din global)",
  "settings.profile.photo": "Poză de profil",
  "settings.profile.changePhoto": "Schimbă poza",
  "settings.profile.removePhoto": "Elimină poza",
  "settings.profile.adjustPhoto": "Ajustează poza",
  "settings.profile.info": "Info / Status",
  "settings.profile.infoPh": "Salut, folosesc IKOGNIT",
  "settings.profile.removeOverride": "Elimină suprascrierea pentru {0}",
  "settings.profile.warn": "Modificările vor fi trimise automat celorlalte contacte când interacționezi cu ele în acest IKO.",
  "settings.privacy.title": "Confidențialitate",
  "settings.privacy.hintGlobal": "Configurează cine poate vedea fiecare informație implicită.",
  "settings.privacy.hintFreq": "Suprascrie aceste reguli doar când ești în {0}.",
  "settings.privacy.showPhoto": "Cine vede poza mea",
  "settings.privacy.showInfo": "Cine vede info-ul / statusul",
  "settings.privacy.showLastSeen": "Cine vede ultima conectare",
  "settings.privacy.showOnline": "Cine vede dacă sunt online",
  "settings.privacy.whoAdds": "Cine mă poate adăuga în grupuri",
  "settings.privacy.readReceipts": "Confirmări de citire",
  "settings.privacy.readReceiptsHint": "Dacă dezactivezi, nu se trimit bifele albastre când citești mesaje. Nici nu vei vedea ale celorlalți.",
  "settings.vis.all": "Toți",
  "settings.vis.contacts": "Contactele mele",
  "settings.vis.none": "Nimeni",
  "settings.messages.title": "Mesaje",
  "settings.messages.ttl": "Expirare implicită",
  "settings.messages.ttlHint": "Mesajele pe care le trimiți vor fi șterse de pe server după acest timp. Poți alege altă valoare la atașarea unui fișier.",
  "settings.blocked.title": "Blocați",
  "settings.blocked.hint": "Utilizatorii blocați nu îți pot trimite mesaje. Nici tu lor.",
  "settings.blocked.placeholder": "IKOGNIT ID de blocat",
  "settings.blocked.btn": "Blochează",
  "settings.blocked.unblock": "Deblochează",
  "settings.blocked.empty": "Nu ai pe nimeni blocat.",
  "settings.notif.title": "Notificări",
  "settings.notif.sound": "Sunet",
  "settings.notif.preview": "Afișează previzualizarea mesajului",
  "settings.notif.vibration": "Vibrație (mobil)",
  "settings.notif.hint": "Notificările push ale browserului sunt emise doar pentru mesajele din IKOGNIT general, fără conținut sau nume al expeditorului (prin design).",
  "settings.session.title": "Sesiune",
  "settings.session.timeout": "Închide IKO după inactivitate",
  "settings.session.timeoutHint": "Dacă petreci acest timp fără a atinge aplicația, IKO-ul activ este dezactivat automat și revii la IKOGNIT. „Niciodată” păstrează IKO-ul până închizi aplicația.",
  "settings.session.remember": "Memorează IKO-urile activate",
  "settings.session.rememberHint": "Dacă este activat, IKO-urile pe care le activezi apar ca scurtături în bara laterală. Oricine îți vede ecranul ar putea ști în ce IKO-uri ai intrat, așa că este dezactivat implicit. Dezactivarea șterge cele deja salvate.",
  "settings.account.title": "Cont",
  "settings.account.email": "Email opțional (doar pentru recuperare, niciodată publicat)",
  "settings.account.emailPh": "email@exemplu.com",
  "settings.account.changePassword": "Schimbă parola",
  "settings.account.currentPw": "Parola curentă",
  "settings.account.newPw": "Parolă nouă (min. 8)",
  "settings.account.confirmPw": "Repetă noua",
  "settings.account.saving": "Salvare…",
  "settings.account.success": "Parolă actualizată.",
  "settings.account.errPwBad": "Parola curentă nu este corectă.",
  "settings.account.errPwShort": "Noua parolă trebuie să aibă cel puțin 8 caractere.",
  "settings.account.errPwMismatch": "Parolele nu se potrivesc.",
  "settings.language.title": "Limbă",
  "settings.language.hint": "Alege limba interfeței. Preferința ta este salvată pe acest dispozitiv.",
  "settings.about.title": "Despre IKOGNIT",
  "settings.about.version": "Versiune",
  "settings.about.tech": "Criptare E2E cu NaCl box (X25519). IKO: derivare Argon2id + HMAC determinist. Persistență locală criptată cu Argon2id peste PIN.",
  "modal.freq.title": "Activează IKO",
  "modal.freq.hint": "Un IKO este IKO exacte ale unuia dintre IKO tale. Public: te întâlnești cu cine scrie aceleași. Privat: ajungi într-un IKO unde ești invizibil, chiar dacă altcineva scrie aceleași IKO.",
  "modal.freq.placeholder": "Scrie IKO tale",
  "modal.freq.activate": "Activează",
  "modal.freq.deriving": "Calcul IKO…",
  "modal.freq.warn": "IKO nu sunt salvate nicăieri. Dacă le uiți, acel IKO încetează să existe pentru tine.",
  "modal.freq.errShort": "IKO-ul trebuie să aibă cel puțin 8 caractere.",
  "modal.freq.errCommon": "Acest IKO este prea comun. Alege ceva unic.",
  "modal.freq.errRepeat": "Nu folosi un singur caracter repetat.",
  "modal.freq.errSeqNum": "Evită secvențe numerice evidente.",
  "modal.freq.errSeqAlpha": "Evită secvențe alfabetice.",
  "billing.title": "Facturare",
  "billing.manage": "Gestionează",
  "billing.seats": "Locuri",
  "billing.renews": "Reînnoire",
  "billing.needsUpgrade": "Ai atins limita de locuri a treptei tale. Treci la următoarea pentru a adăuga mai multe.",
  "billing.upgradeTo": "Treci la treapta ({price}/loc)",
  "billing.portal": "Gestionează plata",
  "join.loginToAccept": "Autentificare / Cont nou",
  "private.badge": "PRIVAT",
  "private.welcome.title": "IKO tău Privat",
  "private.welcome.intro": "Ești la IKO unde nimeni nu te poate vedea. Chiar dacă altă persoană ar scrie același IKO, ar ajunge într-un IKO diferit. Aici păstrezi ale tale în siguranță.",
  "private.welcome.hint": "Alege o secțiune pentru a începe.",
  "private.mod.notes": "Note",
  "private.mod.notes.desc": "Note, scrisori, jurnal.",
  "private.mod.files": "Fișiere",
  "private.mod.files.desc": "Documente, foi, PDF-uri.",
  "private.mod.photos": "Fotografii",
  "private.mod.photos.desc": "Galeria ta privată.",
  "private.mod.videos": "Videoclipuri",
  "private.mod.videos.desc": "Videoclipurile tale personale.",
  "private.mod.audios": "Audio",
  "private.mod.audios.desc": "Înregistrări și note vocale.",
  "private.mod.vault": "Parole",
  "private.mod.vault.desc": "Parole, carduri, identități, chei SSH și ce ai nevoie.",
  "private.mod.iko": "IKO-urile mele",
  "private.mod.iko.desc": "IKO-urile tale salvate, gata de activat.",
  "savediko.intro": "Păstrează aici IKO pe care nu vrei să le memorezi. Ții minte unul singur, iar restul trăiesc înăuntru.",
  "savediko.empty": "Încă nu ai salvat niciun IKO.",
  "savediko.add": "Salvează un IKO",
  "savediko.activate": "Activează IKO",
  "savediko.formNew": "Salvează un IKO",
  "savediko.formEdit": "Editează IKO-ul salvat",
  "savediko.descLabel": "Descriere",
  "savediko.descPh": "O descriere pentru a-l recunoaște mai târziu",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "Scrie IKO",
  "savediko.errDesc": "Scrie o descriere.",
  "savediko.errIko": "Scrie IKO.",
  "savediko.confirmDel": "Ștergi?",
  "vault.new": "Element nou",
  "vault.edit": "Editează",
  "vault.delete": "Șterge",
  "vault.save": "Salvează",
  "vault.show": "Afișează",
  "vault.hide": "Ascunde",
  "vault.copy": "Copiază",
  "vault.copied": "Copiat ✓",
  "vault.search": "Caută…",
  "vault.empty": "Dosar tău este gol. Creează primul element.",
  "vault.noMatches": "Niciun element nu corespunde căutării.",
  "vault.untitled": "Fără nume",
  "vault.startHint": "Selectează un element din stânga sau creează unul nou.",
  "vault.confirmDelete": "Ștergi acest element? Nu poate fi recuperat.",
  "vault.notes": "Note",
  "vault.sensitive": "Sensibil",
  "vault.sensitiveHint": "Câmpurile sensibile sunt ascunse implicit și pot fi copiate în clipboard.",
  "vault.removeField": "Elimină acest câmp",
  "vault.addField": "Adaugă câmp",
  "vault.fieldSingular": "câmp",
  "vault.fieldPlural": "câmpuri",
  "vault.type.login": "Autentificare",
  "vault.type.card": "Card",
  "vault.type.identity": "Identitate",
  "vault.type.sshkey": "Cheie SSH",
  "vault.type.custom": "Personalizat",
  "vault.field.name": "Nume",
  "vault.field.name.ph": "Cum îl numești?",
  "vault.field.labelPh": "Etichetă câmp",
  "vault.field.newField": "Câmp",
  "vault.field.username": "Utilizator",
  "vault.field.password": "Parolă",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Titular",
  "vault.field.cardBrand": "Marcă",
  "vault.field.cardNumber": "Număr",
  "vault.field.cardExpiry": "Expirare (LL/AA)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Prenume",
  "vault.field.lastname": "Nume",
  "vault.field.dni": "Act identitate",
  "vault.field.address": "Adresă",
  "vault.field.city": "Oraș",
  "vault.field.zip": "Cod poștal",
  "vault.field.country": "Țară",
  "vault.field.phone": "Telefon",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Data nașterii",
  "vault.field.sshPrivate": "Cheie privată",
  "vault.field.sshPublic": "Cheie publică",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Text",
  "vault.ft.password": "Parolă",
  "vault.ft.textarea": "Text lung",
  "vault.ft.date": "Dată",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Număr",
  "vault.tpl.title": "Șabloane",
  "vault.tpl.manage": "Gestionează șabloanele",
  "vault.tpl.yours": "Șabloanele tale",
  "vault.tpl.new": "Șablon nou",
  "vault.tpl.edit": "Editează șablon",
  "vault.tpl.empty": "Nu ai încă șabloane. Creează unul pentru a defini propriul tip de element.",
  "vault.tpl.name": "Nume șablon",
  "vault.tpl.name.ph": "Ex.: Portofel crypto, Rezervare hotel…",
  "vault.tpl.confirmDelete": "Ștergi acest șablon? Elementele create din el rămân.",
  "totp.copyCode": "Copiază codul",
  "totp.copySecret": "Copiază secret",
  "totp.showSecret": "Afișează secret",
  "totp.hideSecret": "Ascunde secret",
  "totp.invalid": "secret invalid",
  "private.module.coming": "În curând.",
  "private.module.comingHint": "Acest modul va fi disponibil foarte curând. Criptografia IKO Privat funcționează deja — în curând vei putea salva aici ce ai nevoie.",
  "notes.new": "Notă nouă",
  "notes.empty": "Nu ai încă note în acest IKO.",
  "notes.emptyPreview": "(goală)",
  "notes.untitled": "Fără titlu",
  "notes.delete": "Șterge nota",
  "notes.confirmDelete": "Ștergi această notă? Nu poate fi recuperată.",
  "notes.titlePlaceholder": "Titlu",
  "notes.contentPlaceholder": "Scrie ce trebuie să îți amintești…",
  "notes.startHint": "Fără note în acest IKO. Creează prima.",
  "notes.autosaveHint": "Salvat automat, criptat, doar aici.",
  "notes.yesterday": "Ieri",
  "passwords.new": "Intrare nouă",
  "passwords.empty": "Nu ai salvat încă nimic în acest IKO.",
  "passwords.untitled": "Fără nume",
  "passwords.startHint": "Fără parole în acest IKO. Creează prima.",
  "passwords.confirmDelete": "Ștergi această intrare? Nu poate fi recuperată.",
  "passwords.save": "Salvează",
  "passwords.edit": "Editează",
  "passwords.delete": "Șterge",
  "passwords.copy": "Copiază",
  "passwords.copied": "Copiat ✓",
  "passwords.show": "Afișează",
  "passwords.hide": "Ascunde",
  "passwords.field.label": "Nume",
  "passwords.field.label.ph": "Bancă, cont, serviciu…",
  "passwords.field.username": "Utilizator",
  "passwords.field.username.ph": "Email, alias, număr…",
  "passwords.field.password": "Parolă",
  "passwords.field.password.ph": "Parola pe care vrei să o salvezi",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Note",
  "passwords.field.notes.ph": "Orice detaliu util",
  "media.uploading": "Se încarcă…",
  "media.uploadFailed": "Nu s-a putut încărca fișierul.",
  "media.upload.file": "Încarcă fișier",
  "media.upload.photo": "Încarcă foto",
  "media.upload.video": "Încarcă video",
  "media.upload.audio": "Încarcă audio",
  "media.empty.file": "Încă nu există fișiere în acest IKO.",
  "media.empty.photo": "Încă nu există fotografii în acest IKO.",
  "media.empty.video": "Încă nu există videoclipuri în acest IKO.",
  "media.empty.audio": "Încă nu există audio în acest IKO.",
  "media.play": "Redă",
  "media.download": "Descarcă",
  "media.delete": "Șterge",
  "media.confirmDelete": "Ștergi acest element? Nu poate fi recuperat.",
  "media.noPreview": "Fără previzualizare pentru acest tip de fișier.",
  "modal.share.title": "Partajează contact",
  "modal.share.hint": "Alege un contact din listă sau introdu un IKOGNIT ID manual.",
  "modal.share.filter": "Filtrează contactele…",
  "modal.share.empty": "Fără contacte în acest IKO",
  "modal.share.manual": "Sau un IKOGNIT ID manual",
  "modal.share.btn": "Partajează",
  "modal.group.title": "Grup nou",
  "modal.group.hint": "Alege un nume și selectează membri dintre contactele din acest IKO.",
  "modal.group.namePh": "Nume grup",
  "modal.group.selected": "{0} selectați",
  "modal.group.create": "Creează grup",
  "modal.remember.title": "Memorează acest dispozitiv",
  "modal.remember.hint": "Sesiunea, contactele, grupurile și mesajele tale vor fi salvate pe acest dispozitiv, criptate cu un PIN pe care doar tu îl cunoști. La redeschiderea aplicației vei introduce PIN-ul pentru a debloca.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Repetă PIN-ul",
  "modal.remember.warn": "Dacă uiți PIN-ul, datele salvate nu vor putea fi recuperate. Va trebui să te conectezi din nou cu utilizatorul și parola.",
  "modal.remember.errShort": "PIN-ul trebuie să aibă cel puțin 4 caractere.",
  "modal.remember.errMismatch": "PIN-urile nu se potrivesc.",
  "stickers.faces": "Fețe",
  "stickers.gestures": "Gesturi",
  "stickers.hearts": "Inimi",
  "stickers.symbols": "Simboluri",
  "stickers.animals": "Animale",
  "stickers.food": "Mâncare",
  "ttl.1h": "1 oră",
  "ttl.1d": "1 zi",
  "ttl.1w": "1 săptămână",
  "ttl.1m": "1 lună",
  "ttl.6m": "6 luni",
  "ttl.12m": "12 luni",
  "timeout.5min": "5 min",
  "timeout.15min": "15 min",
  "timeout.30min": "30 min",
  "timeout.never": "Niciodată",
  "toast.newMessage": "Mesaj nou",
  "toast.group": "{0} (grup)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Informații și navigare în IKO",
  "ctx.section.universe": "IKO CURENT",
  "ctx.universe.personal": "Spațiul tău personal",
  "ctx.status.serverBlind": "Server orb activ",
  "ctx.status.e2e": "Criptare end-to-end",
  "ctx.section.nav": "NAVIGARE",
  "ctx.nav.changeIko": "Schimbă IKO",
  "ctx.nav.activateIko": "Activează un IKO",
  "ctx.nav.backToIkognit": "Înapoi la IKOGNIT",
  "ctx.section.actions": "ACȚIUNI",
  "ctx.action.newChat": "Chat nou",
  "ctx.action.newGroup": "Grup nou",
  "ctx.action.contacts": "Contactele mele",
  "ctx.section.conversation": "CONVERSAȚIE",
  "ctx.peer.online": "online",
  "ctx.peer.offline": "offline",
  "ctx.peer.messages": "{0} mesaje",
  "ctx.peer.message": "{0} mesaj",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "IKO Personal",
  "ctx.modes.storage": "Unitate",
  "ctx.liturgy.0": "Serverul este orb.",
  "ctx.liturgy.1": "Aici doar tu citești.",
  "ctx.liturgy.2": "Nimeni nu știe că ești aici.",
  "ctx.liturgy.3": "Un IKO este un secret pe care doar tu îl cunoști.",
  "ctx.liturgy.4": "Confidențialitatea ta este arhitectura.",
  "ccb.universe.changeOrExit": "Schimbă IKO sau ieși",
  "ccb.universe.activate": "Activează IKO",
  "ccb.leave.title": "Ieși din IKO (înapoi la IKOGNIT)",
  "ccb.leave.aria": "Ieși din IKO",
  "ccb.tag.cipher.title": "Cifrare simetrică activă",
  "ccb.tag.srv.title": "Serverul nu poate citi conținutul",
  "ccb.tag.unread.title": "Mesaje necitite",
  "ccb.settings.title": "Setări · profil, teme, sesiune",
  "ccb.settings.aria": "Setări",
  "ccb.identity.title": "Sesiune: @{0}",
  "ccb.clock.title": "Ora locală",
  "ccb.modes.personalPrefix": "PERSONAL · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "IKO PERSONAL",
  "holo.modes.general": "NICK-UL TĂU + CONTACTE",
  "holo.claim.inIko": "Acest IKO rămâne invizibil pentru cine nu îl cunoaște.",
  "holo.claim.general": "Spațiul tău personal în IKOGNIT. Aici vorbești cu contactele tale.",
  "holo.card.conversations": "Conversații",
  "holo.card.contacts": "Contacte",
  "holo.card.cipher": "Criptare",
  "holo.card.server": "Server",
  "holo.foot": "Alege o conversație, activează un IKO sau creează un spațiu nou.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "IKO Personal",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "IKO general",
  "uib.e2e.title": "Serverul nu poate citi conținutul tău — criptare E2E cu cheia ta",
  "uib.e2e.label": "Server orb",
  "uib.pseudoTitle": "Pseudonimul tău în acest IKO",
  "uib.nickTitle": "Nick-ul tău",
  "uib.exitTitle": "Înapoi la IKO general",
  "uib.exitLabel": "Ieșire",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Navigare principală",
  "chat.tab.chats": "Conversații",
  "chat.tab.calls": "Apeluri",
  "chat.tab.contacts": "Contacte",
  "chat.backToIkognit.title": "Înapoi la IKOGNIT general",
  "chat.delete.title": "Șterge",
  "chat.delete.aria": "Șterge",
  "chat.call.title": "Apelează",
  "chat.videoCall.title": "Apel video",
  "chat.videoCall.aria": "Apel video cu {0}",
  "chat.search.clear": "Curăță căutarea",
  "chat.filters.aria": "Filtre conversații",
  "chat.filter.all": "Toate",
  "chat.filter.unread": "Necitite",
  "chat.filter.groups": "Grupuri",
  "chat.attachPending": "Atașament în așteptare",
  "chat.remove.title": "Elimină",
  "chat.cancel.title": "Anulează",
  "chat.blocked.text": "L-ai blocat pe {0}. Nu îi poți trimite mesaje sau apela.",
  "chat.unblock": "Deblochează",
  "contacts.alias.placeholder": "Un alias pentru a-l recunoaște",
  "contacts.notes.placeholder": "Doar tu o vezi (criptată pe server).",
  "contacts.search.placeholder": "Caută după alias sau IKOGNIT ID",
  "contacts.edit.title": "Editează aliasul și nota",
  "contacts.edit.aria": "Editează",
  "contacts.blockBtn": "Blochează contactul",
  "contacts.unblockBtn": "Deblochează contactul",
  "contacts.confirmBlock.title": "Blochează contactul",
  "contacts.confirmUnblock.title": "Deblochează contactul",
  "contacts.confirmBlock.body": "Blochezi {0}? Nu vei mai primi mesajele și apelurile lui.",
  "contacts.confirmUnblock.body": "Deblochezi {0}? Vei primi din nou mesajele lui.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Categorii ale IKO Personal",
  "piko.rail.head": "PERSONAL",
  "piko.cat.all": "Tot",
  "piko.cat.photos": "Fotografii",
  "piko.cat.videos": "Videoclipuri",
  "piko.cat.audios": "Audio",
  "piko.cat.files": "Fișiere",
  "piko.cat.notes": "Notițe",
  "piko.cat.passwords": "Parole",
  "piko.cat.cards": "Carduri",
  "piko.cat.identities": "Identități",
  "piko.cat.sshkeys": "Chei SSH",
  "piko.cat.custom": "Dosar",
  "piko.cat.agendas": "Agende IKO",
  "piko.cat.storage": "Discs și Discuri",

  "auth.field.nickPlaceholder": "ex.: user123",
  "auth.field.emailPlaceholder": "tu@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Citit {0}",
  "bubble.tick.delivered": "Livrat {0}",
  "bubble.tick.sent": "Trimis",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Ai blocat acest utilizator.",
  "chat.preview.image": "Imagine",
  "chat.preview.video": "Video",
  "chat.preview.voice": "Mesaj vocal",
  "chat.preview.audio": "Audio",
  "error.push.denied": "Ai refuzat permisiunea pentru notificări.",
  "error.push.noSw": "Acest browser nu suportă service workers.",
  "error.push.noPush": "Acest browser nu suportă notificări push.",
  "error.push.noVapid": "Serverul nu a furnizat cheia VAPID.",
  "error.push.activateFailed": "Activarea a eșuat ({0}).",
  "chat.group.membersWord": "membri",
  "chat.newCall.title": "Apel nou",
  "chat.newChat.title": "Chat nou",
  "chat.newCall.empty": "Niciun contact încă. Adaugă unul din + în Chats.",
  "chat.unread.aria": "mesaje necitite",
  "chat.calls.title": "Apeluri",
  "chat.calls.empty": "Niciun apel încă. Începe unul dintr-un chat cu un contact.",
  "chat.calls.callContact": "Sună un contact",
  "chat.calls.historySoon": "Istoricul apelurilor va fi disponibil în curând.",
  "chat.deleteConv.titleOne": "Șterge conversația",
  "chat.deleteConv.titleMany": "Șterge {0} conversații",
  "chat.deleteConv.hint": "\"Pentru mine\" șterge copia ta (toate dispozitivele). \"Pentru toți\" cere și contactului să o șteargă.",
  "chat.deleteConv.forMe": "Șterge pentru mine",
  "chat.deleteConv.forAll": "Șterge pentru toți",
  "chat.myContacts": "Contactele mele",
  "chat.contacts.noResults": "Niciun rezultat.",
  "chat.contacts.empty": "Niciun contact încă.",
  "chat.contact.badgeBlocked": "blocat",
  "chat.contact.badgePending": "neconfirmat",
  "chat.toast.saved": "Salvat",
  "chat.toast.videoSaved": "Video salvat în Fotografii",
  "chat.toast.imageSaved": "Imagine salvată în Fotografii",
  "chat.toast.updateTestflight": "Actualizează TestFlight la 1.0(10)+ pentru a Salva.",
  "chat.toast.saveFailed": "Salvarea a eșuat: {0}",
  "chat.toast.saveError": "Eroare la salvare",
  "iko.banner.exitAria": "Ieși din IKO și revino la planul general",
  "iko.liturgy.entering": "Intrare în IKO",
  "iko.liturgy.returning": "Revenire",
  "iko.liturgy.toIkognit": "la IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "IKO Personal",
  "manifest.blindServer": "Serverul este orb.",
  "manifest.onlyYouRead": "Aici doar tu citești.",
  "manifest.noPublicProfiles": "Fără profiluri publice.",
  "manifest.noAdsNoClouds": "Fără reclame. Fără cloud-uri străine.",
  "manifest.keyWithYou": "Cheia trăiește cu tine.",
  "manifest.yourIkoYourSpaces": "IKO-urile tale. Spațiile tale.",
  "orb.mod.chat": "Chat",
  "orb.mod.files": "Fișiere",
  "orb.mod.notes": "Note",
  "orb.mod.photos": "Fotografii",
  "orb.mod.vault": "Dosar",
  "orb.mod.audios": "Audiouri",
  "orb.copy.line1": "IKO-urile tale.",
  "orb.copy.line2": "Spațiile tale.",
  "explorer.filesNotProcessed": "Fișier(e) neprocesate",
  "demo.edit": "Editează",
  "common.exit": "Ieși",
  "common.more": "Mai mult",
  "chat.tab.settings": "Setări",
  "chat.search.placeholder": "Caută chat",
  "chat.presence.online": "online",
  "chat.action.call": "Sună",
  "chat.action.videoCall": "Apel video",
  "chat.attach.label": "Atașează",
  "chat.attach.camera": "Cameră",
  "chat.attach.voice": "Voce",
  "chat.attach.file": "Atașează fișier",
  "chat.composer.placeholder": "Scrie un mesaj...",
  "settings.addYourName": "Adaugă numele tău",
  "settings.editProfile": "Editează profilul",
  "chat.welcome.intro": "Selectează un chat pentru a începe să vorbești cu criptare end-to-end.",

  // Batch2: footer atajos web
  "web.footer.palette": "paletă",
  "web.footer.send": "trimite",
  "web.footer.line": "linie",
  "mobile.tb.ikoActivate": "Activează IKO",
  "mobile.tb.ikoExit": "Înapoi la IKOGNIT general",

  "chat.header.blocked": "Blocat",
  "contacts.alias.label": "Alias",
  "contacts.note.label": "Notă privată",
  "settings.account.newNickPlaceholder": "nick_nou",
  "settings.account.newEmailPlaceholder": "nou@email.com",


  "common.delete": "Șterge",








};

const el: Catalog = {
  "auth.verify.notSent": "Δεν μπορέσαμε να σου στείλουμε τον κωδικό. Ο λογαριασμός σου υπάρχει: πάτησε «Επαναποστολή κωδικού» σε λίγο.",
  "lg.rotulo": "Μηνύματα με ιδιωτικούς χώρους",
  "lg.btn.entrar": "Είσοδος",
  "lg.eyebrow": "Ιδιωτικά μηνύματα · Itrion Software",
  "lg.h1a": "Οι συνομιλίες σου όπως πάντα.",
  "lg.h1b": "Και ένα μέρος που υπάρχει μόνο όταν το καλείς.",
  "lg.lead1": "Μιλάς με την οικογένειά σου, τους φίλους σου και την ομάδα σου, όπως σε κάθε εφαρμογή. Η διαφορά αρχίζει όταν ανοίγεις ένα IKO: έναν δικό σου χώρο όπου μπαίνεις γράφοντας ένα μυστικό που ξέρουν μόνο όσοι βρίσκονται μέσα.",
  "lg.lead2": "Όσο δεν το καλείς, αυτός ο χώρος δεν βρίσκεται στη συσκευή σου — ούτε στο κινητό, ούτε στο τάμπλετ, ούτε στον υπολογιστή. Δεν είναι ότι είναι κρυπτογραφημένος.",
  "lg.lead2b": "Απλώς δεν είναι εκεί.",
  "lg.pruebalo": "Δοκίμασέ το · γράψε ένα μυστικό και δες τι γίνεται",
  "lg.panel.plano": "Γενικό επίπεδο",
  "lg.demo.hilos": "Οικογένεια=Μαμά: τρώμε Κυριακή στο σπίτι;=19:04|Marta=σου στέλνω τις φωτογραφίες του Σαββάτου=17:52|Ομάδα=Luis: αύριο στις εννιά, λοιπόν=Χθες|Javi=χαχα δεν το πιστεύω=Χθες",
  "lg.demo.mundos": "Μόνο εμείς οι δύο~το έβαλες εκεί που είπαμε;|ναι. τα συμβόλαια και το διαβατήριο>~Συμβόλαια σπιτιού.pdf=2,4 MB|Ιδιωτικές φωτογραφίες=214|Κάρτα · τράπεζα=Δεδομένα~~Πράγματα του σπιτιού~σου αφήνω εδώ το μισθωτήριο>|και το κλειδί του ρούτερ, που το χάνεις πάντα~Μισθωτήριο.pdf=1,1 MB|Αντίγραφο ταυτότητας=2 αρχεία|Κλειδιά σπιτιού=Δεδομένα~~Οι σημειώσεις μου~αυτό δεν το είπα σε κανέναν>|ούτε χρειάζεται>~Ημερολόγιο=48 σημειώσεις|Φωτογραφίες=1.207|Λογαριασμοί της χρονιάς=Δεδομένα~~Έργο Λισαβόνα~η προσφορά βγαίνει 180|ορίστε, χωρίς αντίγραφα έξω>~Προσφορά_v4.pdf=860 KB|Επαφές=12|Εταιρική κάρτα=Δεδομένα~~Το γεύμα του Σαββάτου~μην πεις τίποτα ακόμα στη Marta|ήσυχα, εδώ δεν το μαθαίνει κανείς>~Κράτηση.pdf=120 KB|Φωτογραφίες πέρσι=63|Λίστα καλεσμένων=Δεδομένα",
  "lg.invocaLabel": "Κάλεσε το IKO σου",
  "lg.invocaPlaceholder": "γράψε ένα οποιοδήποτε μυστικό",
  "lg.invocaBtn": "Κάλεσε",
  "lg.invocaHint": "Κάθε λέξη οδηγεί σε διαφορετικό χώρο. Δοκίμασε άλλη.",
  "lg.estela.vacio": "Γράψε ό,τι θες: εδώ είναι μια επίδειξη.",
  "lg.estela.primero": "Να το. Υπάρχει μόνο όσο είσαι μέσα.",
  "lg.estela.otro": "Άλλο μυστικό, άλλος χώρος. Κανένας δεν ξέρει για τους άλλους.",
  "lg.estela.salida": "Έφυγε. Κανένα ίχνος στη συσκευή. Δοκίμασε άλλη λέξη.",
  "lg.ikoActivo": "IKO ενεργό",
  "lg.nadaEnDispositivo": "Τίποτα από αυτά δεν βρίσκεται στη συσκευή",
  "lg.salirIko": "Έξοδος από το IKO",
  "lg.planos.h2a": "Ένα επίπεδο στη θέα όλων.",
  "lg.planos.h2b": "Από κάτω, όσα καλείς εσύ.",
  "lg.planos.lead": "Δεν υπάρχει «το IKO». Υπάρχουν όσα ανοίγεις: ένα για τα του σπιτιού, ένα για τη δουλειά, ένα που το ξέρετε μόνο οι δυο σας, ένα για το οποίο δεν μίλησες ποτέ σε κανέναν. Κάθε μυστικό οδηγεί στο δικό του, και κανένα δεν ξέρει για τα υπόλοιπα.",
  "lg.planos.unoRotulo": "Το γενικό επίπεδο · ένα",
  "lg.planos.unoH3": "Εκεί που μιλάς με όλους",
  "lg.planos.unoP": "Συνομιλίες, ομάδες, κλήσεις, φωτογραφίες και αρχεία, κρυπτογραφημένα από άκρο σε άκρο. Ό,τι περιμένεις από μια εφαρμογή μηνυμάτων, φτιαγμένο σωστά. Οι συνηθισμένες σου συνομιλίες ζουν εδώ και συμπεριφέρονται όπως πάντα.",
  "lg.planos.nRotulo": "Τα IKO · όσα θέλεις",
  "lg.planos.nH3": "Εκεί που δεν φτάνει κανείς άλλος",
  "lg.planos.nP": "Γράφεις ένα μυστικό και εμφανίζεται ο χώρος που του αντιστοιχεί. Μέσα χωρούν συνομιλίες και τα πράγματά σου. Όταν βγαίνεις, φεύγει από τη συσκευή χωρίς ίχνος. Δεν υπάρχει λίστα, δεν υπάρχει αριθμός και κανείς δεν μπορεί να βρει πόσα έχεις, ούτε ότι υπάρχει έστω ένα.",
  "lg.planos.chips": "Τα του σπιτιού|Η δουλειά|Αυτό που ξέρετε μόνο οι δυο σας|Δικό σου και κανενός άλλου|Αυτό που άνοιξες μια φορά και ποτέ ξανά|Όσα αποφασίσεις αύριο",
  "lg.forense.h2a": "Δεν είναι κρυπτογραφημένο στη συσκευή σου.",
  "lg.forense.h2b": "Δεν είναι στη συσκευή σου.",
  "lg.forense.lead": "Οι άλλες εφαρμογές κρατούν τα μηνύματά σου στη συσκευή και τα κρυπτογραφούν. Αν κάποιος την πάρει, η ιδιωτικότητά σου εξαρτάται από το αν αντέξει αρκετά αυτή η κρυπτογράφηση. Εδώ δεν υπάρχει τίποτα που να πρέπει να αντέξει: ό,τι ζει μέσα σε ένα IKO δεν γράφεται σε καμία συσκευή. Το καλείς, το χρησιμοποιείς και φεύγει.",
  "lg.forense.multi": "Παντού το ίδιο: κινητό, τάμπλετ, υπολογιστής στο σπίτι, φορητός της δουλειάς, Windows, Mac ή ο περιηγητής σε ξένο μέρος. Μπαίνεις όπου θέλεις και, όταν βγαίνεις, εκείνο το μέρος δεν ξέρει ξανά τίποτα για σένα.",
  "lg.forense.caption": "Τι βρίσκει όποιος εξετάσει οποιαδήποτε από τις συσκευές σου",
  "lg.forense.filas": "Μηνύματα από τα IKO σου=0|Αρχεία και φωτογραφίες από τα IKO σου=0|Αποθηκευμένα μυστικά IKO=0|Βάση δεδομένων με τα IKO σου=δεν υπάρχει|Ίχνος ότι κάποιο IKO ήταν ανοιχτό=κανένα|Πόσα IKO έχεις=απροσδιόριστο",
  "lg.escenas.h2": "Αυτό που πραγματικά σε ανησυχεί.",
  "lg.escenas.filas": "«Έχασα το κινητό μου.»=Η ιδιωτικότητά σου δεν χάθηκε μαζί του. Ό,τι ήταν μέσα σε ένα IKO δεν βρέθηκε ποτέ σε εκείνη τη συσκευή, οπότε δεν υπάρχει τίποτα να σωθεί ούτε τίποτα να φοβηθείς. Το καλείς από οποιαδήποτε άλλη συσκευή και όλα είναι εκεί που ήταν.~«Μου πήραν τον φορητό.»=Θα δει τις συνηθισμένες σου συνομιλίες, τις ίδιες που θα έβλεπε σε οποιαδήποτε εφαρμογή. Από τα υπόλοιπα δεν θα δει ούτε το περιεχόμενο, ούτε το όνομα, ούτε ένδειξη ότι υπάρχουν.~«Εξέτασαν τον υπολογιστή μου.»=Μια εγκληματολογική ανάλυση ανακτά ό,τι είναι γραμμένο στον δίσκο, ακόμη κρυπτογραφημένο και διαγραμμένο. Εδώ δεν υπάρχει τίποτα γραμμένο για ανάκτηση. Η απάντηση δεν είναι «δεν αποκρυπτογραφείται»: είναι ότι δεν υπάρχει τίποτα. Το ίδιο και στο τάμπλετ, στο κινητό και στον περιηγητή που χρησιμοποίησες ένα απόγευμα.",
  "lg.ciego.h2": "Ούτε εμείς. Ούτε όποιος φιλοξενεί τους διακομιστές.",
  "lg.ciego.p1": "Ο διακομιστής φυλάει πράγματα που δεν μπορεί να διαβάσει. Δεν έχει το μυστικό σου, δεν το είχε ποτέ και δεν υπάρχει κανένα αντίγραφο πουθενά. Δεν είναι ότι αρνούμαστε να παραδώσουμε ό,τι υπάρχει μέσα στα IKO σου: δεν το έχουμε, και δεν υπάρχει τρόπος να το έχουμε. Ούτε η εταιρεία που φιλοξενεί τα μηχανήματα, ούτε όποιος τα έπιανε στα χέρια του.",
  "lg.ciego.p2": "Αυτό έχει το τίμημά του και είναι δίκαιο να ειπωθεί: αν χάσεις το μυστικό σου, δεν υπάρχει κανείς να σου το επιστρέψει. Ακριβώς ο λόγος για τον οποίο δεν μπορεί να μπει κανένας άλλος είναι ο λόγος για τον οποίο ούτε εμείς μπορούμε να σε βοηθήσουμε να μπεις.",
  "lg.guardas": "Οικογενειακές φωτογραφίες|Οι σημειώσεις που δεν δείχνεις|Κάρτες και τραπεζικά στοιχεία|Κωδικοί|Έγγραφα|Συνομιλίες που αφορούν μόνο εσάς",
  "lg.nombre.esta": "υπάρχει",
  "lg.nombre.noEsta": "δεν υπάρχει",
  "lg.nombre.h2": "Από εκεί το όνομα.",
  "lg.nombre.p": "Στα σουαχίλι, iko σημαίνει «υπάρχει» και haiko, «δεν υπάρχει». Ένα IKO υπάρχει όσο το καλείς. Τον υπόλοιπο χρόνο — δηλαδή σχεδόν πάντα — δεν υπάρχει: ούτε στις συσκευές σου, ούτε μπροστά στα μάτια κανενός, ούτε καν ως υποψία.",
  "lg.cierre.h2": "Ξεκίνα να μιλάς.",
  "lg.cierre.p": "Χρησιμοποιείται όπως κάθε εφαρμογή μηνυμάτων, στο κινητό, στο τάμπλετ και στον υπολογιστή. Τα IKO είναι εκεί την ημέρα που θα τα χρειαστείς.",
  "lg.cierre.btnCrear": "Δημιουργία λογαριασμού",
  "lg.cierre.btnEntrar": "Έχω ήδη λογαριασμό",
  "lg.cierre.pago": "Το IKOGNIT είναι προϊόν επί πληρωμή. Χωρίς διαφημίσεις, χωρίς διαφημιστικά προφίλ και χωρίς κανένα δικό μας αντίγραφο: ζούμε από το ότι η εφαρμογή αξίζει σε σένα, όχι από όσα λες μέσα σε αυτήν.",
  "lg.pie.ciego": "Τυφλός διακομιστής",
  "auth.hola": "Γεια σου ξανά.",
  "auth.queEs": "Τι είναι το IKOGNIT;",
  "common.cancel": "Άκυρο",
  "common.error.generic": "Δεν έγινε. Δοκίμασε ξανά.",
  "common.save": "Αποθήκευση",
  "common.confirm": "Επιβεβαίωση",
  "common.close": "Κλείσιμο",
  "common.add": "Προσθήκη",
  "common.back": "Πίσω",
  "common.tagline": "Ψηφιακή κυριαρχία.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "Στα σουαχίλι, iko σημαίνει «υπάρχει». Και haiko, «δεν υπάρχει».",
  "auth.legal.age": "Επιβεβαιώνω ότι έχω την ελάχιστη ηλικία που απαιτεί ο νόμος της χώρας μου για να χρησιμοποιήσω IKOGNIT.",
  "auth.legal.accept": "Διάβασα και αποδέχομαι τους <a href='https://ikognit.org/legal/el/oroi.html' target='_blank' rel='noopener'>Όρους</a>, την <a href='https://ikognit.org/legal/el/idiotikotita.html' target='_blank' rel='noopener'>Πολιτική Απορρήτου</a> και τους <a href='https://ikognit.org/legal/el/kanones-koinotitas.html' target='_blank' rel='noopener'>Κανόνες Κοινότητας</a>.",
  "recovery.title": "Το κλειδί ανάκτησης",
  "recovery.intro": "Αυτές οι **24 λέξεις** είναι ο μόνος τρόπος να ανακτήσεις τον λογαριασμό σου και το ιστορικό αν ξεχάσεις τον κωδικό ή χάσεις τη συσκευή. **Γράψε τες σε χαρτί και κράτησέ τες σε ασφαλές μέρος.** Κανείς στο IKOGNIT δεν μπορεί να τις ανακτήσει για εσένα.",
  "recovery.warn": "**Γράψε τες OFFLINE.** Μην κάνεις στιγμιότυπο οθόνης. Μην τις στέλνεις με email ή μηνύματα. Όποιος έχει αυτές τις λέξεις ελέγχει όλο τον λογαριασμό σου.",
  "recovery.btn.show": "Εμφάνιση λέξεων",
  "recovery.btn.copy": "Αντιγραφή",
  "recovery.btn.copied": "Αντιγράφηκε · διαγράφεται σε {0}s",
  "recovery.btn.cleared": "Πρόχειρο διαγράφηκε",
  "recovery.btn.copyAria": "Αντιγραφή φράσης ανάκτησης στο πρόχειρο (διαγράφεται αυτόματα)",
  "recovery.btn.download": "Λήψη",
  "recovery.btn.downloadAria": "Λήψη φράσης ως αρχείο κειμένου",
  "recovery.btn.back": "Επιστροφή στις λέξεις",
  "recovery.btn.continue": "Συνέχεια",
  "recovery.btn.done": "Τελείωσα",
  "recovery.btn.need3": "Γράψε τις 3 σωστές λέξεις",
  "recovery.verify.intro": "Για επιβεβαίωση ότι αποθήκευσες το κλειδί, γράψε αυτές τις λέξεις. Δεν μπορείς να συνεχίσεις χωρίς να τις γράψεις σωστά.",
  "recovery.verify.wordN": "Λέξη #{0}",
  "recovery.verify.correct": "Σωστό",
  "recovery.verify.wrong": "Λάθος",
  "auth.error.legalRequired": "Πρέπει να αποδεχτείτε τους νομικούς όρους και να επιβεβαιώσετε την ηλικία σας για να δημιουργήσετε IKOGNIT ID.",
  "settings.legal.title": "Νομικές πληροφορίες",
  "settings.legal.hub": "Νομικό Κέντρο",
  "settings.legal.terms": "Όροι και Προϋποθέσεις",
  "settings.legal.privacy": "Πολιτική Απορρήτου",
  "settings.legal.rules": "Κανόνες Κοινότητας",
  "settings.legal.report": "Αναφορές και Συντονισμός",
  "settings.legal.cookies": "Πολιτική Cookies",
  "settings.legal.minors": "Πολιτική Ανηλίκων",
  "settings.legal.notice": "Νομική Σημείωση",
  "settings.tab.legal": "Νομικά",
  "auth.loading": "Φόρτωση…",
  "auth.savedSession": "Αυτή η συσκευή γνωρίζει ήδη τον κάτοχό της.",
  "auth.locked": "Χάθηκε από αδράνεια. Μπες ξανά.",
  "auth.sessionExpired": "Η συνεδρία χάθηκε. Μπες ξανά.",
  "auth.tab.login": "Είσοδος",
  "auth.tab.register": "Νέο IKOGNIT ID",
  "auth.subLogin": "Μπαίνεις στο γενικό επίπεδο: τις συνηθισμένες σου συνομιλίες. Τα IKO σου δεν καλούνται εδώ — καλούνται μέσα, όταν τα χρειαστείς.",
  "auth.subRegister": "Ο λογαριασμός είναι στο όνομά σου. Το nick είναι το πώς σε βλέπουν· το email χρησιμεύει μόνο για να ανακτήσεις την πρόσβαση και για ειδοποιήσεις.",
  "auth.field.devicePin": "Κύριο κλειδί",
  "auth.field.password": "Κύριο κλειδί",
  "auth.btn.unlock": "Είσοδος",
  "auth.btn.unlocking": "Είσοδος…",
  "auth.btn.processing": "Επεξεργασία…",
  "auth.btn.createIdentity": "Δημιουργία IKOGNIT ID",
  "auth.btn.useOther": "Χρήση άλλου IKOGNIT ID",
  "auth.btn.forget": "Ξεχάστε αυτή τη συσκευή",
  "auth.btn.backToUnlock": "Πίσω",
  "auth.confirmForget": "Αυτή η συσκευή θα πάψει να σε αναγνωρίζει: ο αποθηκευμένος λογαριασμός και ό,τι υπάρχει στην προσωρινή μνήμη χάνονται. Για να ξαναμπείς θα χρειαστείς τον κωδικό σου.",
  "auth.confirmForget.warning": "Χωρίς σημειωμένη τη φράση ανάκτησης των 24 λέξεων, δεν υπάρχει επιστροφή: κανείς δεν μπορεί να σου τη δώσει πίσω.",
  "invite.welcomeSub": "Μηνύματα και δικός σου χώρος: ό,τι κρατάς εδώ είναι στο όνομά σου. Φτιάξε λογαριασμό και θα συνδεθείτε.",
  "auth.reset.warnNewIdentity": "Ο λογαριασμός παραμένει δικός σου, αλλά η ανάκτηση μέσω email σού δίνει νέα ταυτότητα: τα προηγούμενα μηνύματα δεν θα μπορούν πια να διαβαστούν. Αν κρατάς τη φράση ανάκτησης των 24 λέξεων, προτίμησε εκείνον τον δρόμο.",
  "recover.intro": "Γράψε το nick ή το email σου και τις 24 λέξεις ανάκτησης που σου δόθηκαν όταν δημιουργήθηκε ο λογαριασμός. Έπειτα θα διαλέξεις νέο κωδικό.",
  "auth.error.badCreds": "Λάθος IKOGNIT ID ή κλειδί.",
  "auth.error.userNotFound": "IKOGNIT ID δεν βρέθηκε.",
  "auth.error.cantConnect": "Δεν ήταν δυνατή η σύνδεση στον διακομιστή.",
  "auth.error.badPin": "Λάθος κλειδί.",
  "auth.footnote": "Ο κάτοχος ευθύνεται.\nΑν χάσεις τον κωδικό σου,\nδεν υπάρχει σε ποιον να πας.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Τρέχον IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Προσωπικό IKO: {0}",
  "sidebar.freqPsh": "IKO Τομέα: {0}",
  "sidebar.tune": "Ενεργοποίηση IKO",
  "sidebar.exitFreq": "Επιστροφή στο IKOGNIT",
  "sidebar.notifications": "Ειδοποιήσεις",
  "sidebar.remember": "Απομνημόνευση συσκευής",
  "sidebar.forget": "Ξεχάστε συσκευή",
  "sidebar.addContact": "Προσθήκη επαφής με nick",
  "sidebar.newGroup": "Νέα ομάδα",
  "sidebar.settings": "Ρυθμίσεις",
  "sidebar.logout": "Έξοδος",
  "sidebar.tooltip.logout": "Αποσύνδεση και διαγραφή όλων των τοπικών",
  "sidebar.savedFreq.tooltip": "Ενεργοποίηση {0}",
  "chat.empty": "Επιλέξτε ή προσθέστε επαφή",
  "welcome.title": "Καλώς ήρθατε στο IKOGNIT",
  "welcome.concept": "Στο IKOGNIT συνομιλείτε με άλλους χρήστες αναγνωριζόμενος από το nick σας. Όταν θέλετε ξεχωριστό χώρο, ενεργοποιείτε ένα IKO και εισέρχεστε σε IKO. Αν είναι Δημόσιο, συναντάτε όσους το ενεργοποιούν επίσης. Αν είναι Ιδιωτικό, εισέρχεστε σε IKO όπου είστε μόνο εσείς.",
  "welcome.step1": "Ενεργοποιήστε ένα Δημόσιο IKO και εισέλθετε σε IKO με όσους το γνωρίζουν επίσης.",
  "welcome.step2": "Εδώ στο IKOGNIT, προσθέστε ένα nick ως επαφή και αρχίστε να μιλάτε.",
  "welcome.step3": "Ενεργοποιήστε ένα Ιδιωτικό IKO και ανοίξτε ένα IKO μόνο για εσάς, όπου φυλάτε αρχεία, φωτογραφίες, ήχους, βίντεο, κωδικούς, σημειώσεις και επιστολές.",
  "welcome.multidevice": "Τα IKO δεν αποθηκεύονται ποτέ πουθενά. Αν ξεχάσετε ένα IKO, το IKO του παύει να υπάρχει για εσάς.",
  "welcome.btnFreq": "Ενεργοποίηση IKO",
  "welcome.btnContacts": "Προσθήκη επαφής",
  "push.btnOn": "Ειδοποιήσεις ON",
  "push.btnOff": "Ειδοποιήσεις OFF",
  "push.btnEnable": "Ειδοποιήσεις απενεργοποιημένες. Κάντε κλικ για ενεργοποίηση.",
  "push.btnDisable": "Ειδοποιήσεις ενεργοποιημένες. Κάντε κλικ για απενεργοποίηση.",
  "push.introTitle": "Πριν ενεργοποιήσετε τις ειδοποιήσεις",
  "push.introBody": "Για λόγους απορρήτου, οι ειδοποιήσεις IKOGNIT διαφέρουν από άλλες εφαρμογές μηνυμάτων:",
  "push.introBullet1": "Το περιεχόμενο του μηνύματος δεν περιλαμβάνεται.",
  "push.introBullet2": "Το όνομα και το IKOGNIT ID του αποστολέα δεν εμφανίζονται.",
  "push.introBullet3": "Θα λάβετε μόνο ειδοποίηση «νέο μήνυμα»· ανοίξτε την εφαρμογή για να το διαβάσετε κρυπτογραφημένο στη συσκευή σας.",
  "push.introConfirm": "Ενεργοποίηση ειδοποιήσεων",
  "chat.placeholder": "Γράψτε ένα μήνυμα…",
  "chat.newMessages": "νέα",
  "chat.newMessagesBadge": "Μετάβαση σε {0} νέα μηνύματα",
  "chat.mediaRetry": "Επανάληψη",
  "chat.mediaFailed": "Αδυναμία φόρτωσης",
  "chat.media.download": "Λήψη",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Επεξεργαστείτε το μήνυμά σας…",
  "chat.replyingTo": "Απάντηση στον/στην {0}",
  "chat.editing": "Επεξεργασία μηνύματος",
  "chat.confirmContact": "Προσθήκη στις επαφές",
  "chat.unconfirmedBanner": "Αυτός ο χρήστης σας έγραψε αλλά δεν βρίσκεται στις επαφές σας. Μέχρι να τον προσθέσετε, η φωτογραφία και οι πληροφορίες σας δεν θα είναι ορατές σε αυτόν σύμφωνα με τις ρυθμίσεις απορρήτου.",
  "chat.online": "συνδεδεμένος",
  "chat.lastSeen": "τελευταία είδε {0}",
  "chat.tooltip.attach": "Επισύναψη αρχείου",
  "chat.tooltip.shareContact": "Κοινοποίηση επαφής",
  "chat.tooltip.paste": "Επικόλληση εικόνας από το πρόχειρο",
  "chat.tooltip.stickers": "Αυτοκόλλητα",
  "chat.tooltip.callAudio": "Φωνητική κλήση",
  "chat.tooltip.callVideo": "Βιντεοκλήση",
  "chat.btn.send": "Αποστολή",
  "chat.uploading": "…",
  "preview.image": "📷 Εικόνα",
  "preview.video": "🎬 Βίντεο",
  "preview.audio": "🎙 Ήχος",
  "bubble.reply": "Απάντηση",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Επεξεργασία",
  "bubble.edited": "επεξεργασμένο",
  "bubble.contact.label": "Επαφή IKOGNIT",
  "bubble.media.decrypting": "Αποκρυπτογράφηση…",
  "bubble.media.failed": "Δεν ήταν δυνατή η αποκρυπτογράφηση του αρχείου.",
  "call.calling": "Κλήση…",
  "call.incoming.audio": "Εισερχόμενη κλήση",
  "call.incoming.video": "Εισερχόμενη βιντεοκλήση",
  "call.connecting": "Σύνδεση…",
  "call.ending": "Τερματισμός…",
  "call.accept": "Αποδοχή",
  "call.reject": "Απόρριψη",
  "call.hangup": "Κλείσιμο",
  "call.mic": "Μικρόφωνο",
  "call.camera": "Κάμερα",
  "call.audioOut": "Έξοδος ήχου",
  "call.audioOut.auto": "Auto",
  "call.error.notInFreq": "Για να καλέσετε πρέπει να είστε μέσα σε ένα IKO.",
  "error.notFound": "Δεν βρέθηκε ο πόρος.",
  "error.notInFreq": "Ο/η {0} δεν είναι ακόμα σε αυτό το IKO. Ζητήστε του από άλλο κανάλι να το ενεργοποιήσει.",
  "error.push.iosTooOld": "Το iOS σας είναι παλαιότερο από 16.4. Ενημερώστε για να λάβετε ειδοποιήσεις.",
  "error.push.iosNotStandalone": "Για να λάβετε ειδοποιήσεις σε iPhone εγκαταστήστε το IKOGNIT στην αρχική οθόνη: πατήστε Κοινοποίηση → Προσθήκη στην αρχική οθόνη.",
  "error.expired": "Η συνεδρία έληξε. Συνδεθείτε ξανά.",
  "error.gone": "Το αρχείο έληξε.",
  "error.invalid": "Μη έγκυρα δεδομένα.",
  "error.server": "Σφάλμα διακομιστή. Δοκιμάστε ξανά.",
  "error.network": "Καμία σύνδεση με τον διακομιστή.",
  "error.cantStartCall": "Δεν ήταν δυνατή η εκκίνηση της κλήσης: {0}",
  "error.cantAcceptCall": "Δεν ήταν δυνατή η αποδοχή της κλήσης: {0}",
  "error.cantPaste": "Δεν ήταν δυνατή η πρόσβαση στο πρόχειρο. Δοκιμάστε το κουμπί επισύναψης.",
  "error.noImageInClipboard": "Δεν υπάρχει εικόνα στο πρόχειρο.",
  "error.clipboardUnsupported": "Το πρόγραμμα περιήγησής σας δεν επιτρέπει την ανάγνωση του προχείρου. Επικολλήστε με Ctrl+V ή χρησιμοποιήστε το κουμπί επισύναψης.",
  "error.selfContact": "Δεν μπορείτε να προσθέσετε τον εαυτό σας.",
  "error.blocked": "Έχετε αποκλείσει αυτόν τον χρήστη. Ξεμπλοκάρετε στις Ρυθμίσεις για να μιλήσετε ξανά.",
  "settings.title": "Ρυθμίσεις",
  "settings.close": "Κλείσιμο",
  "settings.tab.profile": "👤 Προφίλ",
  "settings.tab.privacy": "🔒 Απόρρητο",
  "settings.tab.messages": "✉ Μηνύματα",
  "settings.tab.blocked": "🚫 Αποκλεισμένοι",
  "settings.tab.notifications": "🔔 Ειδοποιήσεις",
  "settings.tab.session": "⏱ Συνεδρία",
  "settings.tab.account": "🆔 Λογαριασμός",
  "settings.tab.language": "🌐 Γλώσσα",
  "settings.tab.about": "ℹ Σχετικά",
  "settings.scope.global": "Καθολικό (IKOGNIT)",
  "settings.scope.freq": "Μόνο στο {0}",
  "settings.profile.title": "Προφίλ",
  "settings.profile.hintGlobal": "Αυτές οι τιμές χρησιμοποιούνται ως προεπιλογή και κληρονομούνται σε όλα τα IKO.",
  "settings.profile.hintFreq": "Υπερβαίνουν το καθολικό προφίλ όταν είστε στο {0}. Αν δεν ορίσετε κάτι εδώ, κληρονομείται από το καθολικό.",
  "settings.profile.displayName": "Εμφανιζόμενο όνομα",
  "settings.profile.displayNamePh.global": "(χωρίς όνομα — θα εμφανιστεί το nick σας)",
  "settings.profile.displayNamePh.freq": "(κληρονομεί από το καθολικό)",
  "settings.profile.photo": "Φωτογραφία προφίλ",
  "settings.profile.changePhoto": "Αλλαγή φωτογραφίας",
  "settings.profile.removePhoto": "Αφαίρεση φωτογραφίας",
  "settings.profile.adjustPhoto": "Προσαρμόστε τη φωτογραφία σας",
  "settings.profile.info": "Πληροφορίες / Κατάσταση",
  "settings.profile.infoPh": "Γεια, χρησιμοποιώ IKOGNIT",
  "settings.profile.removeOverride": "Αφαίρεση παράκαμψης για {0}",
  "settings.profile.warn": "Οι αλλαγές θα αποσταλούν αυτόματα στις υπόλοιπες επαφές σας όταν αλληλεπιδράσετε μαζί τους σε αυτό το IKO.",
  "settings.privacy.title": "Απόρρητο",
  "settings.privacy.hintGlobal": "Ρυθμίστε ποιος μπορεί να βλέπει κάθε πληροφορία σας από προεπιλογή.",
  "settings.privacy.hintFreq": "Υπερβείτε αυτούς τους κανόνες μόνο όταν είστε στο {0}.",
  "settings.privacy.showPhoto": "Ποιος βλέπει τη φωτογραφία μου",
  "settings.privacy.showInfo": "Ποιος βλέπει τις πληροφορίες / κατάστασή μου",
  "settings.privacy.showLastSeen": "Ποιος βλέπει την τελευταία μου σύνδεση",
  "settings.privacy.showOnline": "Ποιος βλέπει αν είμαι συνδεδεμένος",
  "settings.privacy.whoAdds": "Ποιος μπορεί να με προσθέσει σε ομάδες",
  "settings.privacy.readReceipts": "Επιβεβαιώσεις ανάγνωσης",
  "settings.privacy.readReceiptsHint": "Αν απενεργοποιήσετε, δεν αποστέλλονται μπλε σημάδια όταν διαβάζετε μηνύματα. Δεν θα βλέπετε και των άλλων.",
  "settings.vis.all": "Όλοι",
  "settings.vis.contacts": "Οι επαφές μου",
  "settings.vis.none": "Κανείς",
  "settings.messages.title": "Μηνύματα",
  "settings.messages.ttl": "Προεπιλεγμένη λήξη",
  "settings.messages.ttlHint": "Τα μηνύματα που στέλνετε θα διαγραφούν από τον διακομιστή μετά από αυτόν τον χρόνο. Μπορείτε να επιλέξετε άλλη τιμή κατά την επισύναψη αρχείου.",
  "settings.blocked.title": "Αποκλεισμένοι",
  "settings.blocked.hint": "Οι αποκλεισμένοι χρήστες δεν μπορούν να σας στείλουν μηνύματα. Ούτε εσείς σε αυτούς.",
  "settings.blocked.placeholder": "IKOGNIT ID προς αποκλεισμό",
  "settings.blocked.btn": "Αποκλεισμός",
  "settings.blocked.unblock": "Άρση αποκλεισμού",
  "settings.blocked.empty": "Δεν έχετε αποκλείσει κανέναν.",
  "settings.notif.title": "Ειδοποιήσεις",
  "settings.notif.sound": "Ήχος",
  "settings.notif.preview": "Εμφάνιση προεπισκόπησης μηνύματος",
  "settings.notif.vibration": "Δόνηση (κινητό)",
  "settings.notif.hint": "Οι push ειδοποιήσεις του προγράμματος περιήγησης εκδίδονται μόνο για μηνύματα στο γενικό IKOGNIT, χωρίς περιεχόμενο ή όνομα αποστολέα (εκ σχεδιασμού).",
  "settings.session.title": "Συνεδρία",
  "settings.session.timeout": "Κλείσιμο IKO μετά από αδράνεια",
  "settings.session.timeoutHint": "Αν περάσετε αυτόν τον χρόνο χωρίς να αγγίξετε την εφαρμογή, το ενεργό IKO απενεργοποιείται αυτόματα και επιστρέφετε στο IKOGNIT. «Ποτέ» διατηρεί το IKO μέχρι να κλείσετε την εφαρμογή.",
  "settings.session.remember": "Απομνημόνευση ενεργοποιημένων IKO",
  "settings.session.rememberHint": "Αν ενεργοποιηθεί, τα IKO που ενεργοποιείτε εμφανίζονται ως συντομεύσεις στην πλαϊνή μπάρα. Όποιος βλέπει την οθόνη σας μπορεί να ξέρει σε ποια IKO μπήκατε, οπότε είναι απενεργοποιημένο από προεπιλογή. Η απενεργοποίηση διαγράφει τα ήδη αποθηκευμένα.",
  "settings.account.title": "Λογαριασμός",
  "settings.account.email": "Προαιρετικό email (μόνο για ανάκτηση, ποτέ δημοσιευμένο)",
  "settings.account.emailPh": "email@παράδειγμα.com",
  "settings.account.changePassword": "Αλλαγή κωδικού",
  "settings.account.currentPw": "Τρέχων κωδικός",
  "settings.account.newPw": "Νέος κωδικός (ελάχ. 8)",
  "settings.account.confirmPw": "Επανάληψη νέου",
  "settings.account.saving": "Αποθήκευση…",
  "settings.account.success": "Κωδικός ενημερώθηκε.",
  "settings.account.errPwBad": "Ο τρέχων κωδικός δεν είναι σωστός.",
  "settings.account.errPwShort": "Ο νέος κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες.",
  "settings.account.errPwMismatch": "Οι κωδικοί δεν ταιριάζουν.",
  "settings.language.title": "Γλώσσα",
  "settings.language.hint": "Επιλέξτε τη γλώσσα της διεπαφής. Η προτίμησή σας αποθηκεύεται σε αυτή τη συσκευή.",
  "settings.about.title": "Σχετικά με το IKOGNIT",
  "settings.about.version": "Έκδοση",
  "settings.about.tech": "E2E κρυπτογράφηση με NaCl box (X25519). IKO: παραγωγή Argon2id + ντετερμινιστικό HMAC. Τοπική κρυπτογραφημένη επιμονή με Argon2id πάνω σε PIN.",
  "modal.freq.title": "Ενεργοποίηση IKO",
  "modal.freq.hint": "Ένα IKO είναι οι ακριβείς IKO ενός από τα IKO σας. Δημόσιο: συναντάτε όσους γράφουν τις ίδιες. Ιδιωτικό: φτάνετε σε IKO όπου είστε αόρατοι, ακόμα και αν άλλος γράψει τις ίδιες IKO.",
  "modal.freq.placeholder": "Γράψτε τις IKO σας",
  "modal.freq.activate": "Ενεργοποίηση",
  "modal.freq.deriving": "Υπολογισμός IKO…",
  "modal.freq.warn": "Οι IKO δεν αποθηκεύονται πουθενά. Αν τις ξεχάσετε, αυτό το IKO παύει να υπάρχει για εσάς.",
  "modal.freq.errShort": "Το IKO πρέπει να έχει τουλάχιστον 8 χαρακτήρες.",
  "modal.freq.errCommon": "Αυτό το IKO είναι πολύ κοινό. Επιλέξτε κάτι μοναδικό.",
  "modal.freq.errRepeat": "Μη χρησιμοποιείτε έναν μόνο επαναλαμβανόμενο χαρακτήρα.",
  "modal.freq.errSeqNum": "Αποφύγετε προφανείς αριθμητικές ακολουθίες.",
  "modal.freq.errSeqAlpha": "Αποφύγετε αλφαβητικές ακολουθίες.",
  "billing.title": "Χρέωση",
  "billing.manage": "Διαχείριση",
  "billing.seats": "Θέσεις",
  "billing.renews": "Ανανέωση",
  "billing.needsUpgrade": "Έφτασες στο όριο θέσεων της κλίμακάς σου. Πέρασε σε μεγαλύτερη για να προσθέσεις κι άλλες.",
  "billing.upgradeTo": "Αναβάθμιση σε ({price}/θέση)",
  "billing.portal": "Διαχείριση πληρωμής",
  "join.loginToAccept": "Σύνδεση / Δημιουργία λογαριασμού",
  "private.badge": "ΙΔΙΩΤΙΚΟ",
  "private.welcome.title": "Το Ιδιωτικό σας IKO",
  "private.welcome.intro": "Είστε σε IKO όπου κανείς δεν μπορεί να σας δει. Ακόμα και αν άλλο άτομο έγραφε το ίδιο IKO, θα έφτανε σε διαφορετικό IKO. Εδώ κρατάτε τα δικά σας με ασφάλεια.",
  "private.welcome.hint": "Επιλέξτε ενότητα για να ξεκινήσετε.",
  "private.mod.notes": "Σημειώσεις",
  "private.mod.notes.desc": "Σημειώσεις, γράμματα, ημερολόγιο.",
  "private.mod.files": "Αρχεία",
  "private.mod.files.desc": "Έγγραφα, φύλλα, PDF.",
  "private.mod.photos": "Φωτογραφίες",
  "private.mod.photos.desc": "Η ιδιωτική σας συλλογή.",
  "private.mod.videos": "Βίντεο",
  "private.mod.videos.desc": "Τα προσωπικά σας βίντεο.",
  "private.mod.audios": "Ήχοι",
  "private.mod.audios.desc": "Ηχογραφήσεις και φωνητικές σημειώσεις.",
  "private.mod.vault": "Κωδικοί",
  "private.mod.vault.desc": "Κωδικοί, κάρτες, ταυτότητες, SSH κλειδιά και ό,τι χρειάζεστε.",
  "private.mod.iko": "Τα IKO μου",
  "private.mod.iko.desc": "Τα αποθηκευμένα σου IKO, έτοιμα προς ενεργοποίηση.",
  "savediko.intro": "Φύλαξε εδώ τα IKO που δεν θέλεις να θυμάσαι. Θυμάσαι ένα μόνο και τα υπόλοιπα ζουν μέσα του.",
  "savediko.empty": "Δεν έχεις αποθηκεύσει ακόμη κανένα IKO.",
  "savediko.add": "Αποθήκευση IKO",
  "savediko.activate": "Ενεργοποίηση IKO",
  "savediko.formNew": "Αποθήκευση IKO",
  "savediko.formEdit": "Επεξεργασία αποθηκευμένου IKO",
  "savediko.descLabel": "Περιγραφή",
  "savediko.descPh": "Μια περιγραφή για να το αναγνωρίσεις αργότερα",
  "savediko.ikoLabel": "Το IKO",
  "savediko.ikoPh": "Γράψε το IKO",
  "savediko.errDesc": "Γράψε μια περιγραφή.",
  "savediko.errIko": "Γράψε το IKO.",
  "savediko.confirmDel": "Διαγραφή;",
  "vault.new": "Νέο στοιχείο",
  "vault.edit": "Επεξεργασία",
  "vault.delete": "Διαγραφή",
  "vault.save": "Αποθήκευση",
  "vault.show": "Εμφάνιση",
  "vault.hide": "Απόκρυψη",
  "vault.copy": "Αντιγραφή",
  "vault.copied": "Αντιγράφηκε ✓",
  "vault.search": "Αναζήτηση…",
  "vault.empty": "Το φάκελος σας είναι άδειο. Δημιουργήστε το πρώτο στοιχείο.",
  "vault.noMatches": "Κανένα στοιχείο δεν αντιστοιχεί στην αναζήτηση.",
  "vault.untitled": "Χωρίς όνομα",
  "vault.startHint": "Επιλέξτε στοιχείο αριστερά ή δημιουργήστε νέο.",
  "vault.confirmDelete": "Διαγραφή αυτού του στοιχείου; Δεν μπορεί να ανακτηθεί.",
  "vault.notes": "Σημειώσεις",
  "vault.sensitive": "Ευαίσθητο",
  "vault.sensitiveHint": "Τα ευαίσθητα πεδία είναι κρυμμένα από προεπιλογή και μπορούν να αντιγραφούν στο πρόχειρο.",
  "vault.removeField": "Αφαίρεση αυτού του πεδίου",
  "vault.addField": "Προσθήκη πεδίου",
  "vault.fieldSingular": "πεδίο",
  "vault.fieldPlural": "πεδία",
  "vault.type.login": "Σύνδεση",
  "vault.type.card": "Κάρτα",
  "vault.type.identity": "Ταυτότητα",
  "vault.type.sshkey": "SSH κλειδί",
  "vault.type.custom": "Προσαρμοσμένο",
  "vault.field.name": "Όνομα",
  "vault.field.name.ph": "Πώς το ονομάζετε;",
  "vault.field.labelPh": "Ετικέτα πεδίου",
  "vault.field.newField": "Πεδίο",
  "vault.field.username": "Χρήστης",
  "vault.field.password": "Κωδικός",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Κάτοχος",
  "vault.field.cardBrand": "Μάρκα",
  "vault.field.cardNumber": "Αριθμός",
  "vault.field.cardExpiry": "Λήξη (ΜΜ/ΕΕ)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Όνομα",
  "vault.field.lastname": "Επώνυμο",
  "vault.field.dni": "Ταυτότητα",
  "vault.field.address": "Διεύθυνση",
  "vault.field.city": "Πόλη",
  "vault.field.zip": "Τ.Κ.",
  "vault.field.country": "Χώρα",
  "vault.field.phone": "Τηλέφωνο",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Ημ/νία γέννησης",
  "vault.field.sshPrivate": "Ιδιωτικό κλειδί",
  "vault.field.sshPublic": "Δημόσιο κλειδί",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Κείμενο",
  "vault.ft.password": "Κωδικός",
  "vault.ft.textarea": "Μεγάλο κείμενο",
  "vault.ft.date": "Ημερομηνία",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Αριθμός",
  "vault.tpl.title": "Πρότυπα",
  "vault.tpl.manage": "Διαχείριση προτύπων",
  "vault.tpl.yours": "Τα πρότυπά σας",
  "vault.tpl.new": "Νέο πρότυπο",
  "vault.tpl.edit": "Επεξεργασία προτύπου",
  "vault.tpl.empty": "Δεν έχετε ακόμα πρότυπα. Δημιουργήστε ένα για να ορίσετε δικό σας τύπο στοιχείου.",
  "vault.tpl.name": "Όνομα προτύπου",
  "vault.tpl.name.ph": "Π.χ.: Crypto wallet, Κράτηση ξενοδοχείου…",
  "vault.tpl.confirmDelete": "Διαγραφή αυτού του προτύπου; Τα στοιχεία που δημιουργήθηκαν από αυτό παραμένουν.",
  "totp.copyCode": "Αντιγραφή κωδικού",
  "totp.copySecret": "Αντιγραφή secret",
  "totp.showSecret": "Εμφάνιση secret",
  "totp.hideSecret": "Απόκρυψη secret",
  "totp.invalid": "μη έγκυρο secret",
  "private.module.coming": "Σύντομα.",
  "private.module.comingHint": "Αυτή η ενότητα θα είναι διαθέσιμη πολύ σύντομα. Η κρυπτογραφία του Ιδιωτικού IKO ήδη λειτουργεί — σύντομα θα μπορείτε να αποθηκεύετε εδώ ό,τι χρειάζεστε.",
  "notes.new": "Νέα σημείωση",
  "notes.empty": "Δεν έχετε ακόμα σημειώσεις σε αυτό το IKO.",
  "notes.emptyPreview": "(κενή)",
  "notes.untitled": "Χωρίς τίτλο",
  "notes.delete": "Διαγραφή σημείωσης",
  "notes.confirmDelete": "Διαγραφή αυτής της σημείωσης; Δεν μπορεί να ανακτηθεί.",
  "notes.titlePlaceholder": "Τίτλος",
  "notes.contentPlaceholder": "Γράψτε ό,τι χρειάζεται να θυμάστε…",
  "notes.startHint": "Καμία σημείωση σε αυτό το IKO. Δημιουργήστε την πρώτη.",
  "notes.autosaveHint": "Αποθηκεύεται αυτόματα, κρυπτογραφημένη, μόνο εδώ.",
  "notes.yesterday": "Χθες",
  "passwords.new": "Νέα καταχώρηση",
  "passwords.empty": "Δεν έχετε αποθηκεύσει ακόμα τίποτα σε αυτό το IKO.",
  "passwords.untitled": "Χωρίς όνομα",
  "passwords.startHint": "Κανένας κωδικός σε αυτό το IKO. Δημιουργήστε τον πρώτο.",
  "passwords.confirmDelete": "Διαγραφή αυτής της καταχώρησης; Δεν μπορεί να ανακτηθεί.",
  "passwords.save": "Αποθήκευση",
  "passwords.edit": "Επεξεργασία",
  "passwords.delete": "Διαγραφή",
  "passwords.copy": "Αντιγραφή",
  "passwords.copied": "Αντιγράφηκε ✓",
  "passwords.show": "Εμφάνιση",
  "passwords.hide": "Απόκρυψη",
  "passwords.field.label": "Όνομα",
  "passwords.field.label.ph": "Τράπεζα, λογαριασμός, υπηρεσία…",
  "passwords.field.username": "Χρήστης",
  "passwords.field.username.ph": "Email, ψευδώνυμο, αριθμός…",
  "passwords.field.password": "Κωδικός",
  "passwords.field.password.ph": "Ο κωδικός που θέλετε να αποθηκεύσετε",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Σημειώσεις",
  "passwords.field.notes.ph": "Οποιαδήποτε χρήσιμη λεπτομέρεια",
  "media.uploading": "Μεταφόρτωση…",
  "media.uploadFailed": "Δεν ήταν δυνατή η μεταφόρτωση του αρχείου.",
  "media.upload.file": "Μεταφόρτωση αρχείου",
  "media.upload.photo": "Μεταφόρτωση φωτογραφίας",
  "media.upload.video": "Μεταφόρτωση βίντεο",
  "media.upload.audio": "Μεταφόρτωση ήχου",
  "media.empty.file": "Δεν υπάρχουν ακόμα αρχεία σε αυτό το IKO.",
  "media.empty.photo": "Δεν υπάρχουν ακόμα φωτογραφίες σε αυτό το IKO.",
  "media.empty.video": "Δεν υπάρχουν ακόμα βίντεο σε αυτό το IKO.",
  "media.empty.audio": "Δεν υπάρχουν ακόμα ήχοι σε αυτό το IKO.",
  "media.play": "Αναπαραγωγή",
  "media.download": "Λήψη",
  "media.delete": "Διαγραφή",
  "media.confirmDelete": "Διαγραφή αυτού του στοιχείου; Δεν μπορεί να ανακτηθεί.",
  "media.noPreview": "Καμία προεπισκόπηση για αυτόν τον τύπο αρχείου.",
  "modal.share.title": "Κοινοποίηση επαφής",
  "modal.share.hint": "Επιλέξτε επαφή από τη λίστα ή εισάγετε χειροκίνητα IKOGNIT ID.",
  "modal.share.filter": "Φίλτρο επαφών…",
  "modal.share.empty": "Καμία επαφή σε αυτό το IKO",
  "modal.share.manual": "Ή χειροκίνητο IKOGNIT ID",
  "modal.share.btn": "Κοινοποίηση",
  "modal.group.title": "Νέα ομάδα",
  "modal.group.hint": "Επιλέξτε όνομα και μέλη από τις επαφές σας σε αυτό το IKO.",
  "modal.group.namePh": "Όνομα ομάδας",
  "modal.group.selected": "{0} επιλεγμένοι",
  "modal.group.create": "Δημιουργία ομάδας",
  "modal.remember.title": "Απομνημόνευση αυτής της συσκευής",
  "modal.remember.hint": "Η συνεδρία, οι επαφές, οι ομάδες και τα μηνύματά σας θα αποθηκευτούν σε αυτή τη συσκευή, κρυπτογραφημένα με PIN που μόνο εσείς γνωρίζετε. Όταν ανοίξετε ξανά την εφαρμογή θα εισάγετε το PIN για ξεκλείδωμα.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Επανάληψη PIN",
  "modal.remember.warn": "Αν ξεχάσετε το PIN, τα αποθηκευμένα δεδομένα δεν μπορούν να ανακτηθούν. Θα πρέπει να συνδεθείτε ξανά με χρήστη και κωδικό.",
  "modal.remember.errShort": "Το PIN πρέπει να έχει τουλάχιστον 4 χαρακτήρες.",
  "modal.remember.errMismatch": "Τα PIN δεν ταιριάζουν.",
  "stickers.faces": "Πρόσωπα",
  "stickers.gestures": "Χειρονομίες",
  "stickers.hearts": "Καρδιές",
  "stickers.symbols": "Σύμβολα",
  "stickers.animals": "Ζώα",
  "stickers.food": "Φαγητό",
  "ttl.1h": "1 ώρα",
  "ttl.1d": "1 ημέρα",
  "ttl.1w": "1 εβδομάδα",
  "ttl.1m": "1 μήνας",
  "ttl.6m": "6 μήνες",
  "ttl.12m": "12 μήνες",
  "timeout.5min": "5 λεπτά",
  "timeout.15min": "15 λεπτά",
  "timeout.30min": "30 λεπτά",
  "timeout.never": "Ποτέ",
  "toast.newMessage": "Νέο μήνυμα",
  "toast.group": "{0} (ομάδα)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Πληροφορίες και πλοήγηση του IKO",
  "ctx.section.universe": "ΤΡΕΧΟΝ IKO",
  "ctx.universe.personal": "Ο προσωπικός σου χώρος",
  "ctx.status.serverBlind": "Τυφλός διακομιστής ενεργός",
  "ctx.status.e2e": "Κρυπτογράφηση από άκρο σε άκρο",
  "ctx.section.nav": "ΠΛΟΗΓΗΣΗ",
  "ctx.nav.changeIko": "Αλλαγή IKO",
  "ctx.nav.activateIko": "Ενεργοποίηση IKO",
  "ctx.nav.backToIkognit": "Πίσω στο IKOGNIT",
  "ctx.section.actions": "ΕΝΕΡΓΕΙΕΣ",
  "ctx.action.newChat": "Νέα συνομιλία",
  "ctx.action.newGroup": "Νέα ομάδα",
  "ctx.action.contacts": "Οι επαφές μου",
  "ctx.section.conversation": "ΣΥΝΟΜΙΛΙΑ",
  "ctx.peer.online": "συνδεδεμένος",
  "ctx.peer.offline": "αποσυνδεδεμένος",
  "ctx.peer.messages": "{0} μηνύματα",
  "ctx.peer.message": "{0} μήνυμα",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Προσωπικό IKO",
  "ctx.modes.storage": "Μονάδα",
  "ctx.liturgy.0": "Ο διακομιστής είναι τυφλός.",
  "ctx.liturgy.1": "Εδώ διαβάζεις μόνο εσύ.",
  "ctx.liturgy.2": "Κανείς δεν ξέρει ότι είσαι εδώ.",
  "ctx.liturgy.3": "Ένα IKO είναι ένα μυστικό που γνωρίζεις μόνο εσύ.",
  "ctx.liturgy.4": "Η ιδιωτικότητά σου είναι η αρχιτεκτονική.",
  "ccb.universe.changeOrExit": "Αλλαγή IKO ή έξοδος",
  "ccb.universe.activate": "Ενεργοποίηση IKO",
  "ccb.leave.title": "Έξοδος από το IKO (πίσω στο IKOGNIT)",
  "ccb.leave.aria": "Έξοδος από το IKO",
  "ccb.tag.cipher.title": "Συμμετρική κρυπτογράφηση ενεργή",
  "ccb.tag.srv.title": "Ο διακομιστής δεν μπορεί να διαβάσει το περιεχόμενο",
  "ccb.tag.unread.title": "Μη αναγνωσμένα μηνύματα",
  "ccb.settings.title": "Ρυθμίσεις · προφίλ, θέματα, συνεδρία",
  "ccb.settings.aria": "Ρυθμίσεις",
  "ccb.identity.title": "Συνεδρία: @{0}",
  "ccb.clock.title": "Τοπική ώρα",
  "ccb.modes.personalPrefix": "ΠΡΟΣΩΠΙΚΟ · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "ΠΡΟΣΩΠΙΚΟ IKO",
  "holo.modes.general": "ΤΟ NICK ΣΟΥ + ΕΠΑΦΕΣ",
  "holo.claim.inIko": "Αυτό το IKO παραμένει αόρατο σε όποιον δεν το γνωρίζει.",
  "holo.claim.general": "Ο προσωπικός σου χώρος στο IKOGNIT. Εδώ μιλάς με τις επαφές σου.",
  "holo.card.conversations": "Συνομιλίες",
  "holo.card.contacts": "Επαφές",
  "holo.card.cipher": "Κρυπτογράφηση",
  "holo.card.server": "Διακομιστής",
  "holo.foot": "Διάλεξε μια συνομιλία, ενεργοποίησε ένα IKO ή δημιούργησε νέο χώρο.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Προσωπικό IKO",
  "uib.context.coordTitle": "Το IKO",
  "uib.context.general": "Γενικό IKO",
  "uib.e2e.title": "Ο διακομιστής δεν μπορεί να διαβάσει το περιεχόμενό σου — κρυπτογράφηση E2E με το κλειδί σου",
  "uib.e2e.label": "Τυφλός διακομιστής",
  "uib.pseudoTitle": "Το ψευδώνυμό σου σε αυτό το IKO",
  "uib.nickTitle": "Το nick σου",
  "uib.exitTitle": "Επιστροφή στο Γενικό IKO",
  "uib.exitLabel": "Έξοδος",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Κύρια πλοήγηση",
  "chat.tab.chats": "Συνομιλίες",
  "chat.tab.calls": "Κλήσεις",
  "chat.tab.contacts": "Επαφές",
  "chat.backToIkognit.title": "Πίσω στο γενικό IKOGNIT",
  "chat.delete.title": "Διαγραφή",
  "chat.delete.aria": "Διαγραφή",
  "chat.call.title": "Κλήση",
  "chat.videoCall.title": "Βιντεοκλήση",
  "chat.videoCall.aria": "Βιντεοκλήση με {0}",
  "chat.search.clear": "Καθαρισμός αναζήτησης",
  "chat.filters.aria": "Φίλτρα συνομιλιών",
  "chat.filter.all": "Όλες",
  "chat.filter.unread": "Μη αναγνωσμένα",
  "chat.filter.groups": "Ομάδες",
  "chat.attachPending": "Εκκρεμές συνημμένο",
  "chat.remove.title": "Αφαίρεση",
  "chat.cancel.title": "Άκυρο",
  "chat.blocked.text": "Έχεις αποκλείσει τον/την {0}. Δεν μπορείς να στείλεις μήνυμα ή να καλέσεις.",
  "chat.unblock": "Άρση αποκλεισμού",
  "contacts.alias.placeholder": "Ένα ψευδώνυμο για να τον αναγνωρίσεις",
  "contacts.notes.placeholder": "Μόνο εσύ τη βλέπεις (κρυπτογραφημένη στον διακομιστή).",
  "contacts.search.placeholder": "Αναζήτηση με ψευδώνυμο ή IKOGNIT ID",
  "contacts.edit.title": "Επεξεργασία ψευδωνύμου και σημείωσης",
  "contacts.edit.aria": "Επεξεργασία",
  "contacts.blockBtn": "Αποκλεισμός επαφής",
  "contacts.unblockBtn": "Άρση αποκλεισμού επαφής",
  "contacts.confirmBlock.title": "Αποκλεισμός επαφής",
  "contacts.confirmUnblock.title": "Άρση αποκλεισμού επαφής",
  "contacts.confirmBlock.body": "Αποκλεισμός του/της {0}; Δεν θα λαμβάνεις μηνύματα και κλήσεις.",
  "contacts.confirmUnblock.body": "Άρση αποκλεισμού του/της {0}; Θα λαμβάνεις ξανά μηνύματα.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Κατηγορίες του Προσωπικού IKO",
  "piko.rail.head": "ΠΡΟΣΩΠΙΚΟ",
  "piko.cat.all": "Όλα",
  "piko.cat.photos": "Φωτογραφίες",
  "piko.cat.videos": "Βίντεο",
  "piko.cat.audios": "Ήχοι",
  "piko.cat.files": "Αρχεία",
  "piko.cat.notes": "Σημειώσεις",
  "piko.cat.passwords": "Κωδικοί",
  "piko.cat.cards": "Κάρτες",
  "piko.cat.identities": "Ταυτότητες",
  "piko.cat.sshkeys": "Κλειδιά SSH",
  "piko.cat.custom": "Χρηματοκιβώτια",
  "piko.cat.agendas": "Κατάλογοι IKO",
  "piko.cat.storage": "Δίσκος & Δίσκοι",

  "auth.field.nickPlaceholder": "π.χ. user123",
  "auth.field.emailPlaceholder": "esy@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Διαβάστηκε {0}",
  "bubble.tick.delivered": "Παραδόθηκε {0}",
  "bubble.tick.sent": "Στάλθηκε",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Έχεις αποκλείσει αυτόν τον χρήστη.",
  "chat.preview.image": "Εικόνα",
  "chat.preview.video": "Βίντεο",
  "chat.preview.voice": "Φωνητικό μήνυμα",
  "chat.preview.audio": "Ήχος",
  "error.push.denied": "Αρνήθηκες την άδεια ειδοποιήσεων.",
  "error.push.noSw": "Αυτό το πρόγραμμα περιήγησης δεν υποστηρίζει service workers.",
  "error.push.noPush": "Αυτό το πρόγραμμα περιήγησης δεν υποστηρίζει push ειδοποιήσεις.",
  "error.push.noVapid": "Ο διακομιστής δεν παρέδωσε το κλειδί VAPID.",
  "error.push.activateFailed": "Αδυναμία ενεργοποίησης ({0}).",
  "chat.group.membersWord": "μέλη",
  "chat.newCall.title": "Νέα κλήση",
  "chat.newChat.title": "Νέα συνομιλία",
  "chat.newCall.empty": "Δεν υπάρχουν επαφές ακόμη. Πρόσθεσε μία από το + στις Συνομιλίες.",
  "chat.unread.aria": "μη αναγνωσμένα μηνύματα",
  "chat.calls.title": "Κλήσεις",
  "chat.calls.empty": "Δεν υπάρχουν κλήσεις ακόμη. Ξεκίνα μία από συνομιλία με επαφή.",
  "chat.calls.callContact": "Κλήση επαφής",
  "chat.calls.historySoon": "Το ιστορικό κλήσεων θα είναι σύντομα διαθέσιμο.",
  "chat.deleteConv.titleOne": "Διαγραφή συνομιλίας",
  "chat.deleteConv.titleMany": "Διαγραφή {0} συνομιλιών",
  "chat.deleteConv.hint": "«Για μένα» διαγράφει το αντίγραφό σου (όλες οι συσκευές). «Για όλους» ζητά και από την επαφή να τη διαγράψει.",
  "chat.deleteConv.forMe": "Διαγραφή για εμένα",
  "chat.deleteConv.forAll": "Διαγραφή για όλους",
  "chat.myContacts": "Οι επαφές μου",
  "chat.contacts.noResults": "Κανένα αποτέλεσμα.",
  "chat.contacts.empty": "Δεν υπάρχουν επαφές ακόμη.",
  "chat.contact.badgeBlocked": "αποκλεισμένος",
  "chat.contact.badgePending": "μη επιβεβαιωμένος",
  "chat.toast.saved": "Αποθηκεύτηκε",
  "chat.toast.videoSaved": "Το βίντεο αποθηκεύτηκε στις Φωτογραφίες",
  "chat.toast.imageSaved": "Η εικόνα αποθηκεύτηκε στις Φωτογραφίες",
  "chat.toast.updateTestflight": "Ενημέρωσε το TestFlight σε 1.0(10)+ για Αποθήκευση.",
  "chat.toast.saveFailed": "Αδυναμία αποθήκευσης: {0}",
  "chat.toast.saveError": "Σφάλμα αποθήκευσης",
  "iko.banner.exitAria": "Έξοδος από το IKO και επιστροφή στο γενικό επίπεδο",
  "iko.liturgy.entering": "Είσοδος στο IKO",
  "iko.liturgy.returning": "Επιστροφή",
  "iko.liturgy.toIkognit": "στο IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Προσωπικό IKO",
  "manifest.blindServer": "Ο διακομιστής είναι τυφλός.",
  "manifest.onlyYouRead": "Εδώ διαβάζεις μόνο εσύ.",
  "manifest.noPublicProfiles": "Χωρίς δημόσια προφίλ.",
  "manifest.noAdsNoClouds": "Χωρίς διαφημίσεις. Χωρίς ξένα cloud.",
  "manifest.keyWithYou": "Το κλειδί ζει μαζί σου.",
  "manifest.yourIkoYourSpaces": "Τα δικά σου IKO. Οι δικοί σου χώροι.",
  "orb.mod.chat": "Συνομιλία",
  "orb.mod.files": "Αρχεία",
  "orb.mod.notes": "Σημειώσεις",
  "orb.mod.photos": "Φωτογραφίες",
  "orb.mod.vault": "Φάκελος",
  "orb.mod.audios": "Ήχοι",
  "orb.copy.line1": "Τα δικά σου IKO.",
  "orb.copy.line2": "Οι δικοί σου χώροι.",
  "explorer.filesNotProcessed": "Μη επεξεργασμένα αρχεία",
  "demo.edit": "Επεξεργασία",
  "common.exit": "Έξοδος",
  "common.more": "Περισσότερα",
  "chat.tab.settings": "Ρυθμίσεις",
  "chat.search.placeholder": "Αναζήτηση συνομιλίας",
  "chat.presence.online": "σε σύνδεση",
  "chat.action.call": "Κλήση",
  "chat.action.videoCall": "Βιντεοκλήση",
  "chat.attach.label": "Επισύναψη",
  "chat.attach.camera": "Κάμερα",
  "chat.attach.voice": "Φωνή",
  "chat.attach.file": "Επισύναψη αρχείου",
  "chat.composer.placeholder": "Γράψε ένα μήνυμα...",
  "settings.addYourName": "Πρόσθεσε το όνομά σου",
  "settings.editProfile": "Επεξεργασία προφίλ",
  "chat.welcome.intro": "Επίλεξε μια συνομιλία για να ξεκινήσεις με κρυπτογράφηση άκρο-σε-άκρο.",

  // Batch2: footer atajos web
  "web.footer.palette": "παλέτα",
  "web.footer.send": "αποστολή",
  "web.footer.line": "γραμμή",
  "mobile.tb.ikoActivate": "Ενεργοποίηση IKO",
  "mobile.tb.ikoExit": "Επιστροφή στο γενικό IKOGNIT",

  "chat.header.blocked": "Μπλοκαρισμένος",
  "contacts.alias.label": "Ψευδώνυμο",
  "contacts.note.label": "Ιδιωτική σημείωση",
  "settings.account.newNickPlaceholder": "neo_psevdonimo",
  "settings.account.newEmailPlaceholder": "neo@email.com",


  "common.delete": "Διαγραφή",








};

const ru: Catalog = {
  "auth.verify.notSent": "Не удалось отправить код. Ваш аккаунт создан: нажмите «Отправить код ещё раз» через минуту.",
  "lg.rotulo": "Мессенджер с приватными пространствами",
  "lg.btn.entrar": "Войти",
  "lg.eyebrow": "Приватный мессенджер · Itrion Software",
  "lg.h1a": "Твои обычные разговоры.",
  "lg.h1b": "И место, которое существует, только когда ты его вызываешь.",
  "lg.lead1": "Ты общаешься с семьёй, друзьями и коллегами, как в любом приложении. Разница начинается, когда ты открываешь IKO: собственное пространство, куда входят, написав секрет, который знают только те, кто внутри.",
  "lg.lead2": "Пока ты его не вызвал, этого пространства нет на твоём устройстве — ни в телефоне, ни в планшете, ни в компьютере. Дело не в том, что оно зашифровано.",
  "lg.lead2b": "Его просто нет.",
  "lg.pruebalo": "Попробуй сам · напиши секрет и посмотри, что будет",
  "lg.panel.plano": "Общий план",
  "lg.demo.hilos": "Семья=Мама: поужинаем в воскресенье у нас?=19:04|Марта=отправляю фото с субботы=17:52|Команда=Луис: значит, завтра в девять=Вчера|Хави=хаха не верю=Вчера",
  "lg.demo.mundos": "Только мы вдвоём~ты положил туда, где договорились?|да. документы и паспорт>~Документы на квартиру.pdf=2,4 МБ|Личные фото=214|Карта · банк=Данные~~Домашние дела~оставляю тебе здесь договор аренды>|и ключ от роутера, ты его вечно теряешь~Договор аренды.pdf=1,1 МБ|Копия паспорта=2 файла|Ключи от дома=Данные~~Мои записи~я об этом никому не говорил>|и не нужно>~Дневник=48 заметок|Фото=1207|Счета за год=Данные~~Проект «Лиссабон»~предложение выходит на 180|вот оно, никаких копий снаружи>~Предложение_v4.pdf=860 КБ|Контакты=12|Карта компании=Данные~~Субботний обед~пока ничего не говори Марте|спокойно, здесь никто не узнает>~Бронь.pdf=120 КБ|Фото прошлого года=63|Список гостей=Данные",
  "lg.invocaLabel": "Вызови свой IKO",
  "lg.invocaPlaceholder": "напиши любой секрет",
  "lg.invocaBtn": "Вызвать",
  "lg.invocaHint": "Каждое слово ведёт в другое пространство. Попробуй другое.",
  "lg.estela.vacio": "Напиши что угодно: здесь это демонстрация.",
  "lg.estela.primero": "Есть. Существует, только пока ты внутри.",
  "lg.estela.otro": "Другой секрет — другое пространство. Ни одно не знает об остальных.",
  "lg.estela.salida": "Исчезло. На устройстве не осталось следа. Попробуй другое слово.",
  "lg.ikoActivo": "IKO активен",
  "lg.nadaEnDispositivo": "Ничего из этого нет на устройстве",
  "lg.salirIko": "Выйти из IKO",
  "lg.planos.h2a": "Один план на виду.",
  "lg.planos.h2b": "Под ним — те, что вызываешь ты.",
  "lg.planos.lead": "Нет никакого «того самого IKO». Есть те, что ты открываешь: один для домашних дел, другой для работы, третий знаете только вы вдвоём, четвёртый — о котором ты никому не говорил. Каждый секрет ведёт к своему, и ни один не знает об остальных.",
  "lg.planos.unoRotulo": "Общий план · один",
  "lg.planos.unoH3": "Где ты говоришь со всеми",
  "lg.planos.unoP": "Переписки, группы, звонки, фото и файлы со сквозным шифрованием. То, чего ждёшь от мессенджера, сделанное как следует. Твои обычные чаты живут здесь и ведут себя как всегда.",
  "lg.planos.nRotulo": "IKO · сколько захочешь",
  "lg.planos.nH3": "Куда не добирается никто другой",
  "lg.planos.nP": "Ты пишешь секрет — и появляется соответствующее ему пространство. Внутри помещаются разговоры и твои вещи. Когда выходишь, оно уходит с устройства без следа. Нет списка, нет числа, и никто не выяснит, сколько их у тебя и существует ли хоть одно.",
  "lg.planos.chips": "Домашние дела|Работа|То, что знаете только вы двое|Твоё и ничьё больше|Тот, что открыл однажды и больше не трогал|Те, что решишь завтра",
  "lg.forense.h2a": "Оно не зашифровано на твоём устройстве.",
  "lg.forense.h2b": "Его нет на твоём устройстве.",
  "lg.forense.lead": "Другие приложения хранят твои сообщения на устройстве и шифруют их. Если кто-то его заберёт, твоя приватность зависит от того, выдержит ли это шифрование достаточно долго. Здесь нечему выдерживать: то, что живёт внутри IKO, не записывается ни на одно устройство. Его вызывают, им пользуются, и оно уходит.",
  "lg.forense.multi": "Везде одинаково: телефон, планшет, домашний компьютер, рабочий ноутбук, Windows, Mac или браузер в чужом месте. Заходишь где хочешь, а когда выходишь, это место снова ничего о тебе не знает.",
  "lg.forense.caption": "Что найдёт тот, кто изучит любое из твоих устройств",
  "lg.forense.filas": "Сообщения из ваших IKO=0|Файлы и фото из ваших IKO=0|Сохранённые секреты IKO=0|База данных с вашими IKO=не существует|След того, что IKO был открыт=никакого|Сколько у вас IKO=не установить",
  "lg.escenas.h2": "То, что тебя действительно беспокоит.",
  "lg.escenas.filas": "«Я потерял телефон.»=Твоя приватность не ушла вместе с ним. То, что было внутри IKO, никогда не находилось на этом устройстве, так что спасать нечего и бояться нечего. Вызываешь его с любого другого устройства — и всё там же, где было.~«У меня забрали ноутбук.»=Увидят твои обычные разговоры, те же, что увидели бы в любом приложении. Из остального не увидят ни содержимого, ни названия, ни намёка на то, что оно существует.~«Мой компьютер изучили.»=Криминалистический анализ восстанавливает то, что записано на диске, даже зашифрованное и удалённое. Здесь нечего восстанавливать. Ответ не «это невозможно расшифровать», а «там ничего нет». То же самое на планшете, на телефоне и в браузере, которым ты пользовался один вечер.",
  "lg.ciego.h2": "Ни мы. Ни тот, кто размещает серверы.",
  "lg.ciego.p1": "Сервер хранит то, что не может прочитать. У него нет твоего секрета, никогда не было, и нигде не существует копии. Дело не в том, что мы отказываемся выдать содержимое твоих IKO: у нас его нет, и получить его невозможно. Ни у компании, где стоят машины, ни у того, кто до них доберётся.",
  "lg.ciego.p2": "У этого есть цена, и о ней честно сказать: если потеряешь свой секрет, вернуть его некому. Ровно та причина, по которой не войдёт никто другой, — причина, по которой и мы не сможем помочь тебе войти.",
  "lg.guardas": "Семейные фото|Записи, которые ты не показываешь|Карты и банковские данные|Пароли|Документы|Разговоры, которые касаются только вас",
  "lg.nombre.esta": "есть",
  "lg.nombre.noEsta": "нет",
  "lg.nombre.h2": "Отсюда и название.",
  "lg.nombre.p": "На суахили iko значит «есть», а haiko — «нет». IKO есть, пока ты его вызываешь. Всё остальное время — то есть почти всегда — его нет: ни на твоих устройствах, ни у кого-то на виду, ни даже как подозрение.",
  "lg.cierre.h2": "Начни говорить.",
  "lg.cierre.p": "Пользуешься как любым мессенджером: на телефоне, на планшете и на компьютере. IKO будут на месте в тот день, когда понадобятся.",
  "lg.cierre.btnCrear": "Создать аккаунт",
  "lg.cierre.btnEntrar": "У меня уже есть аккаунт",
  "lg.cierre.pago": "IKOGNIT — платный продукт. Ни рекламы, ни рекламных профилей, ни нашей копии чего бы то ни было: мы живём с того, что приложение того стоит, а не с того, что ты в нём говоришь.",
  "lg.pie.ciego": "Слепой сервер",
  "auth.hola": "И снова привет.",
  "auth.queEs": "Что такое IKOGNIT?",
  "common.cancel": "Отмена",
  "common.error.generic": "Не вышло. Попробуй ещё раз.",
  "common.save": "Сохранить",
  "common.confirm": "Подтвердить",
  "common.close": "Закрыть",
  "common.add": "Добавить",
  "common.back": "Назад",
  "common.tagline": "Цифровой суверенитет.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "На суахили iko значит «есть». А haiko — «нет».",
  "auth.legal.age": "Подтверждаю, что я достиг(ла) минимального возраста, требуемого законом моей страны для использования IKOGNIT.",
  "auth.legal.accept": "Я прочитал(а) и принимаю <a href='https://ikognit.org/legal/ru/usloviya.html' target='_blank' rel='noopener'>Условия</a>, <a href='https://ikognit.org/legal/ru/konfidentsialnost.html' target='_blank' rel='noopener'>Политику конфиденциальности</a> и <a href='https://ikognit.org/legal/ru/pravila-soobshchestva.html' target='_blank' rel='noopener'>Правила сообщества</a>.",
  "recovery.title": "Твой ключ восстановления",
  "recovery.intro": "Эти **24 слова** — единственный способ восстановить аккаунт и историю, если забудешь пароль или потеряешь устройство. **Запиши их на бумагу и храни в безопасном месте.** Никто в IKOGNIT не сможет восстановить их за тебя.",
  "recovery.warn": "**Записывай их OFFLINE.** Не делай скриншот. Не отправляй по email или мессенджерам. Кто владеет этими словами — владеет всем твоим аккаунтом.",
  "recovery.btn.show": "Показать слова",
  "recovery.btn.copy": "Копировать",
  "recovery.btn.copied": "Скопировано · удалится через {0}с",
  "recovery.btn.cleared": "Буфер обмена очищен",
  "recovery.btn.copyAria": "Скопировать фразу восстановления в буфер обмена (удалится автоматически)",
  "recovery.btn.download": "Скачать",
  "recovery.btn.downloadAria": "Скачать фразу как текстовый файл",
  "recovery.btn.back": "Вернуться к словам",
  "recovery.btn.continue": "Продолжить",
  "recovery.btn.done": "Готово",
  "recovery.btn.need3": "Введи 3 правильных слова",
  "recovery.verify.intro": "Чтобы подтвердить, что ты сохранил(а) ключ, введи эти слова. Без правильного ответа продолжить нельзя.",
  "recovery.verify.wordN": "Слово #{0}",
  "recovery.verify.correct": "Верно",
  "recovery.verify.wrong": "Неверно",
  "auth.error.legalRequired": "Чтобы создать IKOGNIT ID, необходимо принять юридические условия и подтвердить возраст.",
  "settings.legal.title": "Юридическая информация",
  "settings.legal.hub": "Юридический центр",
  "settings.legal.terms": "Условия использования",
  "settings.legal.privacy": "Политика конфиденциальности",
  "settings.legal.rules": "Правила сообщества",
  "settings.legal.report": "Жалобы и модерация",
  "settings.legal.cookies": "Политика cookies",
  "settings.legal.minors": "Политика для несовершеннолетних",
  "settings.legal.notice": "Юридическое уведомление",
  "settings.tab.legal": "Юридическое",
  "auth.loading": "Загрузка…",
  "auth.savedSession": "Это устройство уже знает своего владельца.",
  "auth.locked": "Растворилось из-за бездействия. Войди снова.",
  "auth.sessionExpired": "Сеанс растворился. Войди снова.",
  "auth.tab.login": "Войти",
  "auth.tab.register": "Новый IKOGNIT ID",
  "auth.subLogin": "Ты входишь на общий план: твои обычные разговоры. IKO вызываются не здесь — их вызывают внутри, когда они нужны.",
  "auth.subRegister": "Учётная запись оформлена на тебя. Ник — это то, каким тебя видят; почта нужна только для восстановления доступа и уведомлений.",
  "auth.field.devicePin": "Главный ключ",
  "auth.field.password": "Главный ключ",
  "auth.btn.unlock": "Войти",
  "auth.btn.unlocking": "Вход…",
  "auth.btn.processing": "Обработка…",
  "auth.btn.createIdentity": "Создать IKOGNIT ID",
  "auth.btn.useOther": "Использовать другой IKOGNIT ID",
  "auth.btn.forget": "Забыть это устройство",
  "auth.btn.backToUnlock": "Назад",
  "auth.confirmForget": "Это устройство перестанет тебя узнавать: сохранённая учётная запись и всё из кэша исчезают. Чтобы войти снова, понадобится пароль.",
  "auth.confirmForget.warning": "Без записанной фразы восстановления из 24 слов пути назад нет: никто её не вернёт.",
  "invite.welcomeSub": "Сообщения и собственное пространство: то, что ты здесь хранишь, оформлено на тебя. Создай учётную запись — и вы на связи.",
  "auth.reset.warnNewIdentity": "Учётная запись остаётся твоей, но восстановление по почте даёт новую личность: прежние сообщения прочитать уже не получится. Если сохранилась фраза восстановления из 24 слов, иди этим путём.",
  "recover.intro": "Введи ник или почту и 24 слова восстановления, выданные при создании учётной записи. Затем выберешь новый пароль.",
  "auth.error.badCreds": "Неверный IKOGNIT ID или ключ.",
  "auth.error.userNotFound": "IKOGNIT ID не найден.",
  "auth.error.cantConnect": "Не удалось подключиться к серверу.",
  "auth.error.badPin": "Неверный ключ.",
  "auth.footnote": "Кто владеет, тот и отвечает.\nПотеряешь пароль —\nспросить будет не с кого.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Текущий IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Личный IKO: {0}",
  "sidebar.freqPsh": "Доменный IKO: {0}",
  "sidebar.tune": "Активировать IKO",
  "sidebar.exitFreq": "Вернуться в IKOGNIT",
  "sidebar.notifications": "Уведомления",
  "sidebar.remember": "Запомнить устройство",
  "sidebar.forget": "Забыть устройство",
  "sidebar.addContact": "Добавить контакт по nick",
  "sidebar.newGroup": "Новая группа",
  "sidebar.settings": "Настройки",
  "sidebar.logout": "Выйти",
  "sidebar.tooltip.logout": "Выйти и удалить всё локальное",
  "sidebar.savedFreq.tooltip": "Активировать {0}",
  "chat.empty": "Выберите или добавьте контакт",
  "welcome.title": "Добро пожаловать в IKOGNIT",
  "welcome.concept": "В IKOGNIT вы общаетесь с другими пользователями, идентифицируясь по своему nick. Когда хотите отдельное пространство, активируете IKO и входите во IKO. Если Публичная — встречаетесь с теми, кто её тоже активирует. Если Приватная — входите во IKO, где есть только вы.",
  "welcome.step1": "Активируйте Публичный IKO и войдите во IKO с теми, кто его тоже знает.",
  "welcome.step2": "Здесь в IKOGNIT добавьте nick как контакт и начинайте общаться.",
  "welcome.step3": "Активируйте Приватный IKO и откройте IKO только для себя, где храните файлы, фотографии, аудио, видео, пароли, заметки и письма.",
  "welcome.multidevice": "IKO никогда нигде не хранятся. Если забудете IKO, его IKO перестанет существовать для вас.",
  "welcome.btnFreq": "Активировать IKO",
  "welcome.btnContacts": "Добавить контакт",
  "push.btnOn": "Уведомления ВКЛ",
  "push.btnOff": "Уведомления ВЫКЛ",
  "push.btnEnable": "Уведомления выключены. Нажмите для включения.",
  "push.btnDisable": "Уведомления включены. Нажмите для отключения.",
  "push.introTitle": "Перед включением уведомлений",
  "push.introBody": "В целях конфиденциальности уведомления IKOGNIT отличаются от других мессенджеров:",
  "push.introBullet1": "Содержание сообщения не включается.",
  "push.introBullet2": "Имя и IKOGNIT ID отправителя не показываются.",
  "push.introBullet3": "Вы получите только оповещение «новое сообщение»; откройте приложение, чтобы прочитать его зашифрованным на устройстве.",
  "push.introConfirm": "Включить уведомления",
  "chat.placeholder": "Напишите сообщение…",
  "chat.newMessages": "новых",
  "chat.newMessagesBadge": "Перейти к {0} новым сообщениям",
  "chat.mediaRetry": "Повторить",
  "chat.mediaFailed": "Не удалось загрузить",
  "chat.media.download": "Скачать",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Редактировать сообщение…",
  "chat.replyingTo": "Ответ на {0}",
  "chat.editing": "Редактирование сообщения",
  "chat.confirmContact": "Добавить в контакты",
  "chat.unconfirmedBanner": "Этот пользователь написал вам, но он не в ваших контактах. Пока вы не добавите его, ваше фото и инфо не будут видны ему согласно настройкам конфиденциальности.",
  "chat.online": "в сети",
  "chat.lastSeen": "последний раз был(а) {0}",
  "chat.tooltip.attach": "Прикрепить файл",
  "chat.tooltip.shareContact": "Поделиться контактом",
  "chat.tooltip.paste": "Вставить изображение из буфера",
  "chat.tooltip.stickers": "Стикеры",
  "chat.tooltip.callAudio": "Голосовой вызов",
  "chat.tooltip.callVideo": "Видеовызов",
  "chat.btn.send": "Отправить",
  "chat.uploading": "…",
  "preview.image": "📷 Изображение",
  "preview.video": "🎬 Видео",
  "preview.audio": "🎙 Аудио",
  "bubble.reply": "Ответить",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Редактировать",
  "bubble.edited": "отредактировано",
  "bubble.contact.label": "Контакт IKOGNIT",
  "bubble.media.decrypting": "Расшифровка…",
  "bubble.media.failed": "Не удалось расшифровать файл.",
  "call.calling": "Вызов…",
  "call.incoming.audio": "Входящий вызов",
  "call.incoming.video": "Входящий видеовызов",
  "call.connecting": "Соединение…",
  "call.ending": "Завершение…",
  "call.accept": "Принять",
  "call.reject": "Отклонить",
  "call.hangup": "Завершить",
  "call.mic": "Микрофон",
  "call.camera": "Камера",
  "call.audioOut": "Аудиовыход",
  "call.audioOut.auto": "Авто",
  "call.error.notInFreq": "Для вызова нужно находиться внутри IKO.",
  "error.notFound": "Ресурс не найден.",
  "error.notInFreq": "{0} ещё не в этом IKO. Попросите через другой канал активировать его.",
  "error.push.iosTooOld": "Ваш iOS старше 16.4. Обновите для получения уведомлений.",
  "error.push.iosNotStandalone": "Для получения уведомлений на iPhone установите IKOGNIT на главный экран: Поделиться → На экран «Домой».",
  "error.expired": "Сессия истекла. Войдите снова.",
  "error.gone": "Файл устарел.",
  "error.invalid": "Неверные данные.",
  "error.server": "Ошибка сервера. Попробуйте снова.",
  "error.network": "Нет соединения с сервером.",
  "error.cantStartCall": "Не удалось начать вызов: {0}",
  "error.cantAcceptCall": "Не удалось принять вызов: {0}",
  "error.cantPaste": "Не удалось получить доступ к буферу обмена. Попробуйте кнопку вложения.",
  "error.noImageInClipboard": "В буфере нет изображения.",
  "error.clipboardUnsupported": "Браузер не позволяет читать буфер. Вставьте Ctrl+V или используйте кнопку вложения.",
  "error.selfContact": "Нельзя добавить самого себя.",
  "error.blocked": "Вы заблокировали этого пользователя. Разблокируйте в Настройках, чтобы снова общаться.",
  "settings.title": "Настройки",
  "settings.close": "Закрыть",
  "settings.tab.profile": "👤 Профиль",
  "settings.tab.privacy": "🔒 Конфиденциальность",
  "settings.tab.messages": "✉ Сообщения",
  "settings.tab.blocked": "🚫 Заблокированные",
  "settings.tab.notifications": "🔔 Уведомления",
  "settings.tab.session": "⏱ Сессия",
  "settings.tab.account": "🆔 Аккаунт",
  "settings.tab.language": "🌐 Язык",
  "settings.tab.about": "ℹ О приложении",
  "settings.scope.global": "Глобально (IKOGNIT)",
  "settings.scope.freq": "Только в {0}",
  "settings.profile.title": "Профиль",
  "settings.profile.hintGlobal": "Эти значения используются по умолчанию и наследуются во всех IKO.",
  "settings.profile.hintFreq": "Перекрывают глобальный профиль, когда вы в {0}. Если что-то не задано здесь, наследуется из глобального.",
  "settings.profile.displayName": "Отображаемое имя",
  "settings.profile.displayNamePh.global": "(без имени — будет показан ваш nick)",
  "settings.profile.displayNamePh.freq": "(наследуется из глобального)",
  "settings.profile.photo": "Фото профиля",
  "settings.profile.changePhoto": "Изменить фото",
  "settings.profile.removePhoto": "Удалить фото",
  "settings.profile.adjustPhoto": "Настройте фото",
  "settings.profile.info": "Инфо / Статус",
  "settings.profile.infoPh": "Привет, я использую IKOGNIT",
  "settings.profile.removeOverride": "Удалить переопределение для {0}",
  "settings.profile.warn": "Изменения будут отправлены другим контактам автоматически при взаимодействии в этом IKO.",
  "settings.privacy.title": "Конфиденциальность",
  "settings.privacy.hintGlobal": "Настройте, кто может видеть каждую вашу информацию по умолчанию.",
  "settings.privacy.hintFreq": "Переопределяйте эти правила только когда вы в {0}.",
  "settings.privacy.showPhoto": "Кто видит мое фото",
  "settings.privacy.showInfo": "Кто видит мое инфо / статус",
  "settings.privacy.showLastSeen": "Кто видит последний вход",
  "settings.privacy.showOnline": "Кто видит, что я в сети",
  "settings.privacy.whoAdds": "Кто может добавить меня в группы",
  "settings.privacy.readReceipts": "Подтверждения прочтения",
  "settings.privacy.readReceiptsHint": "Если отключено, синие галочки не отправляются при чтении сообщений. Вы также не будете видеть их у других.",
  "settings.vis.all": "Все",
  "settings.vis.contacts": "Мои контакты",
  "settings.vis.none": "Никто",
  "settings.messages.title": "Сообщения",
  "settings.messages.ttl": "Срок по умолчанию",
  "settings.messages.ttlHint": "Отправленные вами сообщения будут удалены с сервера по истечении этого времени. При вложении файла можно выбрать другое значение.",
  "settings.blocked.title": "Заблокированные",
  "settings.blocked.hint": "Заблокированные пользователи не могут отправлять вам сообщения. Вы им также.",
  "settings.blocked.placeholder": "IKOGNIT ID для блокировки",
  "settings.blocked.btn": "Заблокировать",
  "settings.blocked.unblock": "Разблокировать",
  "settings.blocked.empty": "Никого не заблокировано.",
  "settings.notif.title": "Уведомления",
  "settings.notif.sound": "Звук",
  "settings.notif.preview": "Показывать превью сообщения",
  "settings.notif.vibration": "Вибрация (мобильное)",
  "settings.notif.hint": "Push-уведомления браузера отправляются только для сообщений в общем IKOGNIT, без содержания и имени отправителя (по дизайну).",
  "settings.session.title": "Сессия",
  "settings.session.timeout": "Закрыть IKO после бездействия",
  "settings.session.timeoutHint": "Если это время прошло без касания приложения, активный IKO автоматически деактивируется и вы возвращаетесь в IKOGNIT. «Никогда» удерживает IKO до закрытия приложения.",
  "settings.session.remember": "Запоминать активированные IKO",
  "settings.session.rememberHint": "Если включено, активированные IKO появляются как ярлыки в боковой панели. Любой, видящий ваш экран, сможет узнать, в какие IKO вы входили, поэтому по умолчанию отключено. Отключение стирает уже сохранённые.",
  "settings.account.title": "Аккаунт",
  "settings.account.email": "Опциональный email (только для восстановления, никогда не публикуется)",
  "settings.account.emailPh": "email@пример.com",
  "settings.account.changePassword": "Сменить пароль",
  "settings.account.currentPw": "Текущий пароль",
  "settings.account.newPw": "Новый пароль (мин. 8)",
  "settings.account.confirmPw": "Повторите новый",
  "settings.account.saving": "Сохранение…",
  "settings.account.success": "Пароль обновлён.",
  "settings.account.errPwBad": "Текущий пароль неверен.",
  "settings.account.errPwShort": "Новый пароль должен содержать минимум 8 символов.",
  "settings.account.errPwMismatch": "Пароли не совпадают.",
  "settings.language.title": "Язык",
  "settings.language.hint": "Выберите язык интерфейса. Ваш выбор сохраняется на этом устройстве.",
  "settings.about.title": "О IKOGNIT",
  "settings.about.version": "Версия",
  "settings.about.tech": "E2E шифрование с NaCl box (X25519). IKO: вывод Argon2id + детерминированный HMAC. Локальная зашифрованная persistence Argon2id над PIN.",
  "modal.freq.title": "Активировать IKO",
  "modal.freq.hint": "IKO — это точные IKO одной из ваших IKO. Публичный: встречаетесь с теми, кто пишет те же. Приватный: попадаете во IKO, где вы невидимы, даже если другой напишет те же IKO.",
  "modal.freq.placeholder": "Напишите ваши IKO",
  "modal.freq.activate": "Активировать",
  "modal.freq.deriving": "Вычисление IKO…",
  "modal.freq.warn": "IKO нигде не сохраняются. Если забудете, эта IKO перестанет существовать для вас.",
  "modal.freq.errShort": "IKO должен содержать минимум 8 символов.",
  "modal.freq.errCommon": "Этот IKO слишком распространён. Выберите уникальное.",
  "modal.freq.errRepeat": "Не используйте один повторяющийся символ.",
  "modal.freq.errSeqNum": "Избегайте очевидных числовых последовательностей.",
  "modal.freq.errSeqAlpha": "Избегайте алфавитных последовательностей.",
  "billing.title": "Биллинг",
  "billing.manage": "Управление",
  "billing.seats": "Места",
  "billing.renews": "Продление",
  "billing.needsUpgrade": "Достигнут лимит мест уровня. Перейди на следующий, чтобы добавить ещё.",
  "billing.upgradeTo": "Перейти на ({price}/место)",
  "billing.portal": "Управление оплатой",
  "join.loginToAccept": "Войти / Создать аккаунт",
  "private.badge": "ПРИВАТНОЕ",
  "private.welcome.title": "Ваша Приватная IKO",
  "private.welcome.intro": "Вы на IKO, где никто не может вас увидеть. Даже если бы другой человек написал тот же IKO, он попал бы в иную IKO. Здесь вы храните своё в безопасности.",
  "private.welcome.hint": "Выберите раздел, чтобы начать.",
  "private.mod.notes": "Заметки",
  "private.mod.notes.desc": "Заметки, письма, дневник.",
  "private.mod.files": "Файлы",
  "private.mod.files.desc": "Документы, таблицы, PDF.",
  "private.mod.photos": "Фото",
  "private.mod.photos.desc": "Ваша приватная галерея.",
  "private.mod.videos": "Видео",
  "private.mod.videos.desc": "Ваши личные видео.",
  "private.mod.audios": "Аудио",
  "private.mod.audios.desc": "Записи и голосовые заметки.",
  "private.mod.vault": "Пароли",
  "private.mod.vault.desc": "Пароли, карты, удостоверения, ключи SSH и всё, что нужно.",
  "private.mod.iko": "Мои IKO",
  "private.mod.iko.desc": "Сохранённые IKO, готовые к активации.",
  "savediko.intro": "Храни здесь те IKO, которые не хочешь запоминать. Помнишь один — остальные живут внутри.",
  "savediko.empty": "Ты ещё не сохранил ни одного IKO.",
  "savediko.add": "Сохранить IKO",
  "savediko.activate": "Активировать IKO",
  "savediko.formNew": "Сохранить IKO",
  "savediko.formEdit": "Изменить сохранённый IKO",
  "savediko.descLabel": "Описание",
  "savediko.descPh": "Описание, чтобы узнать его позже",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "Напишите IKO",
  "savediko.errDesc": "Введи описание.",
  "savediko.errIko": "Напишите IKO.",
  "savediko.confirmDel": "Удалить?",
  "vault.new": "Новый элемент",
  "vault.edit": "Редактировать",
  "vault.delete": "Удалить",
  "vault.save": "Сохранить",
  "vault.show": "Показать",
  "vault.hide": "Скрыть",
  "vault.copy": "Копировать",
  "vault.copied": "Скопировано ✓",
  "vault.search": "Поиск…",
  "vault.empty": "Ваш папка пуст. Создайте первый элемент.",
  "vault.noMatches": "Ни один элемент не соответствует поиску.",
  "vault.untitled": "Без названия",
  "vault.startHint": "Выберите элемент слева или создайте новый.",
  "vault.confirmDelete": "Удалить этот элемент? Восстановить нельзя.",
  "vault.notes": "Заметки",
  "vault.sensitive": "Конфиденциальное",
  "vault.sensitiveHint": "Конфиденциальные поля скрыты по умолчанию и могут быть скопированы в буфер.",
  "vault.removeField": "Удалить это поле",
  "vault.addField": "Добавить поле",
  "vault.fieldSingular": "поле",
  "vault.fieldPlural": "поля",
  "vault.type.login": "Логин",
  "vault.type.card": "Карта",
  "vault.type.identity": "Удостоверение",
  "vault.type.sshkey": "SSH-ключ",
  "vault.type.custom": "Пользовательский",
  "vault.field.name": "Название",
  "vault.field.name.ph": "Как вы это называете?",
  "vault.field.labelPh": "Метка поля",
  "vault.field.newField": "Поле",
  "vault.field.username": "Пользователь",
  "vault.field.password": "Пароль",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Владелец",
  "vault.field.cardBrand": "Марка",
  "vault.field.cardNumber": "Номер",
  "vault.field.cardExpiry": "Срок (ММ/ГГ)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Имя",
  "vault.field.lastname": "Фамилия",
  "vault.field.dni": "Документ",
  "vault.field.address": "Адрес",
  "vault.field.city": "Город",
  "vault.field.zip": "Индекс",
  "vault.field.country": "Страна",
  "vault.field.phone": "Телефон",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Дата рождения",
  "vault.field.sshPrivate": "Приватный ключ",
  "vault.field.sshPublic": "Публичный ключ",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Текст",
  "vault.ft.password": "Пароль",
  "vault.ft.textarea": "Длинный текст",
  "vault.ft.date": "Дата",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Число",
  "vault.tpl.title": "Шаблоны",
  "vault.tpl.manage": "Управление шаблонами",
  "vault.tpl.yours": "Ваши шаблоны",
  "vault.tpl.new": "Новый шаблон",
  "vault.tpl.edit": "Редактировать шаблон",
  "vault.tpl.empty": "У вас пока нет шаблонов. Создайте один, чтобы определить свой тип элемента.",
  "vault.tpl.name": "Название шаблона",
  "vault.tpl.name.ph": "Например: Крипто-кошелёк, Бронирование отеля…",
  "vault.tpl.confirmDelete": "Удалить этот шаблон? Элементы, созданные из него, останутся.",
  "totp.copyCode": "Скопировать код",
  "totp.copySecret": "Скопировать secret",
  "totp.showSecret": "Показать secret",
  "totp.hideSecret": "Скрыть secret",
  "totp.invalid": "неверный secret",
  "private.module.coming": "Скоро.",
  "private.module.comingHint": "Этот модуль скоро будет доступен. Криптография Приватной IKO уже работает — скоро вы сможете хранить здесь всё необходимое.",
  "notes.new": "Новая заметка",
  "notes.empty": "В этой IKO ещё нет заметок.",
  "notes.emptyPreview": "(пусто)",
  "notes.untitled": "Без заголовка",
  "notes.delete": "Удалить заметку",
  "notes.confirmDelete": "Удалить эту заметку? Восстановить нельзя.",
  "notes.titlePlaceholder": "Заголовок",
  "notes.contentPlaceholder": "Запишите то, что нужно помнить…",
  "notes.startHint": "В этой IKO нет заметок. Создайте первую.",
  "notes.autosaveHint": "Сохраняется автоматически, зашифровано, только здесь.",
  "notes.yesterday": "Вчера",
  "passwords.new": "Новая запись",
  "passwords.empty": "В этой IKO вы ещё ничего не сохранили.",
  "passwords.untitled": "Без названия",
  "passwords.startHint": "В этой IKO нет паролей. Создайте первый.",
  "passwords.confirmDelete": "Удалить эту запись? Восстановить нельзя.",
  "passwords.save": "Сохранить",
  "passwords.edit": "Редактировать",
  "passwords.delete": "Удалить",
  "passwords.copy": "Копировать",
  "passwords.copied": "Скопировано ✓",
  "passwords.show": "Показать",
  "passwords.hide": "Скрыть",
  "passwords.field.label": "Название",
  "passwords.field.label.ph": "Банк, аккаунт, сервис…",
  "passwords.field.username": "Пользователь",
  "passwords.field.username.ph": "Email, алиас, номер…",
  "passwords.field.password": "Пароль",
  "passwords.field.password.ph": "Пароль, который хотите сохранить",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Заметки",
  "passwords.field.notes.ph": "Любая полезная деталь",
  "media.uploading": "Загрузка…",
  "media.uploadFailed": "Не удалось загрузить файл.",
  "media.upload.file": "Загрузить файл",
  "media.upload.photo": "Загрузить фото",
  "media.upload.video": "Загрузить видео",
  "media.upload.audio": "Загрузить аудио",
  "media.empty.file": "В этой IKO ещё нет файлов.",
  "media.empty.photo": "В этой IKO ещё нет фото.",
  "media.empty.video": "В этой IKO ещё нет видео.",
  "media.empty.audio": "В этой IKO ещё нет аудио.",
  "media.play": "Воспроизвести",
  "media.download": "Скачать",
  "media.delete": "Удалить",
  "media.confirmDelete": "Удалить этот элемент? Восстановить нельзя.",
  "media.noPreview": "Нет предпросмотра для этого типа файла.",
  "modal.share.title": "Поделиться контактом",
  "modal.share.hint": "Выберите контакт из списка или введите IKOGNIT ID вручную.",
  "modal.share.filter": "Фильтр контактов…",
  "modal.share.empty": "Нет контактов в этом IKO",
  "modal.share.manual": "Или IKOGNIT ID вручную",
  "modal.share.btn": "Поделиться",
  "modal.group.title": "Новая группа",
  "modal.group.hint": "Выберите имя и членов из ваших контактов в этом IKO.",
  "modal.group.namePh": "Название группы",
  "modal.group.selected": "Выбрано: {0}",
  "modal.group.create": "Создать группу",
  "modal.remember.title": "Запомнить это устройство",
  "modal.remember.hint": "Ваша сессия, контакты, группы и сообщения будут сохранены на этом устройстве, зашифрованы PIN-кодом, известным только вам. При повторном открытии приложения введёте PIN для разблокировки.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Повторите PIN",
  "modal.remember.warn": "Если забудете PIN, сохранённые данные восстановить нельзя. Придётся войти снова с пользователем и паролем.",
  "modal.remember.errShort": "PIN должен содержать минимум 4 символа.",
  "modal.remember.errMismatch": "PIN-коды не совпадают.",
  "stickers.faces": "Лица",
  "stickers.gestures": "Жесты",
  "stickers.hearts": "Сердца",
  "stickers.symbols": "Символы",
  "stickers.animals": "Животные",
  "stickers.food": "Еда",
  "ttl.1h": "1 час",
  "ttl.1d": "1 день",
  "ttl.1w": "1 неделя",
  "ttl.1m": "1 месяц",
  "ttl.6m": "6 месяцев",
  "ttl.12m": "12 месяцев",
  "timeout.5min": "5 мин",
  "timeout.15min": "15 мин",
  "timeout.30min": "30 мин",
  "timeout.never": "Никогда",
  "toast.newMessage": "Новое сообщение",
  "toast.group": "{0} (группа)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Информация и навигация по IKO",
  "ctx.section.universe": "ТЕКУЩАЯ IKO",
  "ctx.universe.personal": "Твоё личное пространство",
  "ctx.status.serverBlind": "Слепой сервер активен",
  "ctx.status.e2e": "Сквозное шифрование",
  "ctx.section.nav": "НАВИГАЦИЯ",
  "ctx.nav.changeIko": "Сменить IKO",
  "ctx.nav.activateIko": "Активировать IKO",
  "ctx.nav.backToIkognit": "Назад в IKOGNIT",
  "ctx.section.actions": "ДЕЙСТВИЯ",
  "ctx.action.newChat": "Новый чат",
  "ctx.action.newGroup": "Новая группа",
  "ctx.action.contacts": "Мои контакты",
  "ctx.section.conversation": "БЕСЕДА",
  "ctx.peer.online": "в сети",
  "ctx.peer.offline": "не в сети",
  "ctx.peer.messages": "{0} сообщений",
  "ctx.peer.message": "{0} сообщение",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Личный IKO",
  "ctx.modes.storage": "Накопитель",
  "ctx.liturgy.0": "Сервер слеп.",
  "ctx.liturgy.1": "Здесь читаешь только ты.",
  "ctx.liturgy.2": "Никто не знает, что ты здесь.",
  "ctx.liturgy.3": "IKO — это секрет, который знаешь только ты.",
  "ctx.liturgy.4": "Твоя приватность — это архитектура.",
  "ccb.universe.changeOrExit": "Сменить IKO или выйти",
  "ccb.universe.activate": "Активировать IKO",
  "ccb.leave.title": "Выйти из IKO (назад в IKOGNIT)",
  "ccb.leave.aria": "Выйти из IKO",
  "ccb.tag.cipher.title": "Симметричное шифрование активно",
  "ccb.tag.srv.title": "Сервер не может прочитать содержимое",
  "ccb.tag.unread.title": "Непрочитанные сообщения",
  "ccb.settings.title": "Настройки · профиль, темы, сессия",
  "ccb.settings.aria": "Настройки",
  "ccb.identity.title": "Сессия: @{0}",
  "ccb.clock.title": "Местное время",
  "ccb.modes.personalPrefix": "ЛИЧНЫЙ · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "ЛИЧНЫЙ IKO",
  "holo.modes.general": "ТВОЙ НИК + КОНТАКТЫ",
  "holo.claim.inIko": "Этот IKO остаётся невидимым для тех, кто его не знает.",
  "holo.claim.general": "Твоё личное пространство в IKOGNIT. Здесь ты общаешься со своими контактами.",
  "holo.card.conversations": "Беседы",
  "holo.card.contacts": "Контакты",
  "holo.card.cipher": "Шифрование",
  "holo.card.server": "Сервер",
  "holo.foot": "Выбери беседу, активируй IKO или создай новое пространство.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Личный IKO",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "Общая IKO",
  "uib.e2e.title": "Сервер не может прочитать твоё содержимое — E2E-шифрование твоим ключом",
  "uib.e2e.label": "Слепой сервер",
  "uib.pseudoTitle": "Твой псевдоним в этом IKO",
  "uib.nickTitle": "Твой ник",
  "uib.exitTitle": "Вернуться в Общую IKO",
  "uib.exitLabel": "Выйти",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Главная навигация",
  "chat.tab.chats": "Чаты",
  "chat.tab.calls": "Звонки",
  "chat.tab.contacts": "Контакты",
  "chat.backToIkognit.title": "Назад в общий IKOGNIT",
  "chat.delete.title": "Удалить",
  "chat.delete.aria": "Удалить",
  "chat.call.title": "Позвонить",
  "chat.videoCall.title": "Видеозвонок",
  "chat.videoCall.aria": "Видеозвонок с {0}",
  "chat.search.clear": "Очистить поиск",
  "chat.filters.aria": "Фильтры чатов",
  "chat.filter.all": "Все",
  "chat.filter.unread": "Непрочитанные",
  "chat.filter.groups": "Группы",
  "chat.attachPending": "Вложение в ожидании",
  "chat.remove.title": "Убрать",
  "chat.cancel.title": "Отмена",
  "chat.blocked.text": "Ты заблокировал(а) {0}. Сообщения и звонки невозможны.",
  "chat.unblock": "Разблокировать",
  "contacts.alias.placeholder": "Псевдоним для распознавания",
  "contacts.notes.placeholder": "Видишь только ты (шифруется на сервере).",
  "contacts.search.placeholder": "Поиск по псевдониму или IKOGNIT ID",
  "contacts.edit.title": "Изменить псевдоним и заметку",
  "contacts.edit.aria": "Изменить",
  "contacts.blockBtn": "Заблокировать контакт",
  "contacts.unblockBtn": "Разблокировать контакт",
  "contacts.confirmBlock.title": "Заблокировать контакт",
  "contacts.confirmUnblock.title": "Разблокировать контакт",
  "contacts.confirmBlock.body": "Заблокировать {0}? Ты не будешь получать его сообщения и звонки.",
  "contacts.confirmUnblock.body": "Разблокировать {0}? Ты снова будешь получать его сообщения.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Категории Личного IKO",
  "piko.rail.head": "ЛИЧНЫЙ",
  "piko.cat.all": "Всё",
  "piko.cat.photos": "Фото",
  "piko.cat.videos": "Видео",
  "piko.cat.audios": "Аудио",
  "piko.cat.files": "Файлы",
  "piko.cat.notes": "Заметки",
  "piko.cat.passwords": "Пароли",
  "piko.cat.cards": "Карты",
  "piko.cat.identities": "Личности",
  "piko.cat.sshkeys": "SSH-ключи",
  "piko.cat.custom": "Хранилища",
  "piko.cat.agendas": "Каталоги IKO",
  "piko.cat.storage": "Диск и Диски",

  "auth.field.nickPlaceholder": "напр. user123",
  "auth.field.emailPlaceholder": "ty@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Прочитано {0}",
  "bubble.tick.delivered": "Доставлено {0}",
  "bubble.tick.sent": "Отправлено",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Вы заблокировали этого пользователя.",
  "chat.preview.image": "Изображение",
  "chat.preview.video": "Видео",
  "chat.preview.voice": "Голосовое сообщение",
  "chat.preview.audio": "Аудио",
  "error.push.denied": "Вы запретили разрешение на уведомления.",
  "error.push.noSw": "Этот браузер не поддерживает service workers.",
  "error.push.noPush": "Этот браузер не поддерживает push-уведомления.",
  "error.push.noVapid": "Сервер не предоставил ключ VAPID.",
  "error.push.activateFailed": "Не удалось активировать ({0}).",
  "chat.group.membersWord": "участников",
  "chat.newCall.title": "Новый звонок",
  "chat.newChat.title": "Новый чат",
  "chat.newCall.empty": "Пока нет контактов. Добавьте через + в Чатах.",
  "chat.unread.aria": "непрочитанных сообщений",
  "chat.calls.title": "Звонки",
  "chat.calls.empty": "Пока нет звонков. Начните из чата с контактом.",
  "chat.calls.callContact": "Позвонить контакту",
  "chat.calls.historySoon": "История звонков скоро будет доступна.",
  "chat.deleteConv.titleOne": "Удалить разговор",
  "chat.deleteConv.titleMany": "Удалить {0} разговоров",
  "chat.deleteConv.hint": "«Для меня» удаляет вашу копию (все ваши устройства). «Для всех» также просит контакт удалить у себя.",
  "chat.deleteConv.forMe": "Удалить у меня",
  "chat.deleteConv.forAll": "Удалить у всех",
  "chat.myContacts": "Мои контакты",
  "chat.contacts.noResults": "Нет результатов.",
  "chat.contacts.empty": "Пока нет контактов.",
  "chat.contact.badgeBlocked": "заблокирован",
  "chat.contact.badgePending": "не подтверждён",
  "chat.toast.saved": "Сохранено",
  "chat.toast.videoSaved": "Видео сохранено в Фото",
  "chat.toast.imageSaved": "Изображение сохранено в Фото",
  "chat.toast.updateTestflight": "Обновите TestFlight до 1.0(10)+ для сохранения.",
  "chat.toast.saveFailed": "Не удалось сохранить: {0}",
  "chat.toast.saveError": "Ошибка сохранения",
  "iko.banner.exitAria": "Выйти из IKO и вернуться на общий план",
  "iko.liturgy.entering": "Вход в IKO",
  "iko.liturgy.returning": "Возврат",
  "iko.liturgy.toIkognit": "в IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Личный IKO",
  "manifest.blindServer": "Сервер слеп.",
  "manifest.onlyYouRead": "Здесь читаете только вы.",
  "manifest.noPublicProfiles": "Без публичных профилей.",
  "manifest.noAdsNoClouds": "Без рекламы. Без чужих облаков.",
  "manifest.keyWithYou": "Ключ живёт с вами.",
  "manifest.yourIkoYourSpaces": "Ваши IKO. Ваши пространства.",
  "orb.mod.chat": "Чат",
  "orb.mod.files": "Файлы",
  "orb.mod.notes": "Заметки",
  "orb.mod.photos": "Фото",
  "orb.mod.vault": "Хранилище",
  "orb.mod.audios": "Аудио",
  "orb.copy.line1": "Ваши IKO.",
  "orb.copy.line2": "Ваши пространства.",
  "explorer.filesNotProcessed": "Необработанные файлы",
  "demo.edit": "Изменить",
  "common.exit": "Выход",
  "common.more": "Ещё",
  "chat.tab.settings": "Настройки",
  "chat.search.placeholder": "Поиск чата",
  "chat.presence.online": "в сети",
  "chat.action.call": "Позвонить",
  "chat.action.videoCall": "Видеозвонок",
  "chat.attach.label": "Прикрепить",
  "chat.attach.camera": "Камера",
  "chat.attach.voice": "Голос",
  "chat.attach.file": "Прикрепить файл",
  "chat.composer.placeholder": "Введите сообщение...",
  "settings.addYourName": "Добавьте имя",
  "settings.editProfile": "Изменить профиль",
  "chat.welcome.intro": "Выберите чат, чтобы начать общение со сквозным шифрованием.",

  // Batch2: footer atajos web
  "web.footer.palette": "палитра",
  "web.footer.send": "отправить",
  "web.footer.line": "строка",
  "mobile.tb.ikoActivate": "Активировать IKO",
  "mobile.tb.ikoExit": "Назад к общему IKOGNIT",

  "chat.header.blocked": "Заблокирован",
  "contacts.alias.label": "Псевдоним",
  "contacts.note.label": "Личная заметка",
  "settings.account.newNickPlaceholder": "новый_ник",
  "settings.account.newEmailPlaceholder": "новый@email.com",


  "common.delete": "Удалить",








};

const uk: Catalog = {
  "auth.verify.notSent": "Не вдалося надіслати код. Ваш акаунт створено: за хвилину натисніть «Надіслати код ще раз».",
  "lg.rotulo": "Месенджер із приватними просторами",
  "lg.btn.entrar": "Увійти",
  "lg.eyebrow": "Приватний месенджер · Itrion Software",
  "lg.h1a": "Твої звичні розмови.",
  "lg.h1b": "І місце, яке існує лише тоді, коли ти його викликаєш.",
  "lg.lead1": "Ти спілкуєшся з родиною, друзями та командою, як у будь-якому застосунку. Різниця починається, коли ти відкриваєш IKO: власний простір, куди заходять, написавши секрет, який знають лише ті, хто всередині.",
  "lg.lead2": "Доки ти його не викликав, цього простору немає на твоєму пристрої — ні в телефоні, ні в планшеті, ні в компʼютері. Річ не в тім, що він зашифрований.",
  "lg.lead2b": "Його просто немає.",
  "lg.pruebalo": "Спробуй сам · напиши секрет і подивись, що буде",
  "lg.panel.plano": "Загальний план",
  "lg.demo.hilos": "Родина=Мама: повечеряємо в неділю в нас?=19:04|Марта=надсилаю фото із суботи=17:52|Команда=Луїс: отже, завтра о девʼятій=Учора|Хаві=хаха не вірю=Учора",
  "lg.demo.mundos": "Тільки ми вдвох~ти поклав туди, де домовились?|так. документи й паспорт>~Документи на квартиру.pdf=2,4 МБ|Особисті фото=214|Картка · банк=Дані~~Домашні справи~лишаю тобі тут договір оренди>|і ключ від роутера, ти його вічно губиш~Договір оренди.pdf=1,1 МБ|Копія паспорта=2 файли|Ключі від дому=Дані~~Мої нотатки~я про це нікому не казав>|і не треба>~Щоденник=48 нотаток|Фото=1207|Рахунки за рік=Дані~~Проєкт «Лісабон»~пропозиція виходить на 180|ось вона, жодних копій назовні>~Пропозиція_v4.pdf=860 КБ|Контакти=12|Картка компанії=Дані~~Суботній обід~поки нічого не кажи Марті|спокійно, тут ніхто не дізнається>~Бронювання.pdf=120 КБ|Фото торішні=63|Список гостей=Дані",
  "lg.invocaLabel": "Виклич свій IKO",
  "lg.invocaPlaceholder": "напиши будь-який секрет",
  "lg.invocaBtn": "Викликати",
  "lg.invocaHint": "Кожне слово веде до іншого простору. Спробуй інше.",
  "lg.estela.vacio": "Напиши будь-що: тут це демонстрація.",
  "lg.estela.primero": "Є. Існує, лише поки ти всередині.",
  "lg.estela.otro": "Інший секрет — інший простір. Жоден не знає про решту.",
  "lg.estela.salida": "Зникло. На пристрої не лишилося сліду. Спробуй інше слово.",
  "lg.ikoActivo": "IKO активний",
  "lg.nadaEnDispositivo": "Нічого з цього немає на пристрої",
  "lg.salirIko": "Вийти з IKO",
  "lg.planos.h2a": "Один план на видноті.",
  "lg.planos.h2b": "Під ним — ті, що викликаєш ти.",
  "lg.planos.lead": "Немає жодного «того самого IKO». Є ті, що ти відкриваєш: один для домашніх справ, інший для роботи, ще один знаєте лише ви двоє, ще один — про який ти нікому не казав. Кожен секрет веде до свого, і жоден не знає про решту.",
  "lg.planos.unoRotulo": "Загальний план · один",
  "lg.planos.unoH3": "Де ти говориш з усіма",
  "lg.planos.unoP": "Розмови, групи, дзвінки, фото й файли з наскрізним шифруванням. Те, чого чекаєш від месенджера, зроблене як слід. Твої звичні чати живуть тут і поводяться як завжди.",
  "lg.planos.nRotulo": "IKO · скільки захочеш",
  "lg.planos.nH3": "Куди не дістанеться ніхто інший",
  "lg.planos.nP": "Ти пишеш секрет — і зʼявляється відповідний простір. Усередині вміщаються розмови й твої речі. Коли виходиш, він іде з пристрою без сліду. Немає списку, немає числа, і ніхто не зʼясує, скільки їх у тебе і чи існує бодай один.",
  "lg.planos.chips": "Домашні справи|Робота|Те, що знаєте лише ви двоє|Твоє і нічиє більше|Той, що відкрив одного разу й більше не чіпав|Ті, про які вирішиш завтра",
  "lg.forense.h2a": "Воно не зашифроване на твоєму пристрої.",
  "lg.forense.h2b": "Його немає на твоєму пристрої.",
  "lg.forense.lead": "Інші застосунки тримають твої повідомлення на пристрої й шифрують їх. Якщо хтось його забере, твоя приватність залежить від того, чи витримає те шифрування достатньо довго. Тут немає чому витримувати: те, що живе всередині IKO, не записується на жоден пристрій. Його викликають, ним користуються, і воно йде.",
  "lg.forense.multi": "Скрізь однаково: телефон, планшет, домашній компʼютер, робочий ноутбук, Windows, Mac або браузер у чужому місці. Заходиш де хочеш, а коли виходиш, те місце знову нічого про тебе не знає.",
  "lg.forense.caption": "Що знайде той, хто огляне будь-який із твоїх пристроїв",
  "lg.forense.filas": "Повідомлення з ваших IKO=0|Файли та фото з ваших IKO=0|Збережені секрети IKO=0|База даних із вашими IKO=не існує|Слід того, що IKO був відкритий=жодного|Скільки у вас IKO=не встановити",
  "lg.escenas.h2": "Те, що справді тебе турбує.",
  "lg.escenas.filas": "«Я загубив телефон.»=Твоя приватність не пішла разом із ним. Те, що було всередині IKO, ніколи не було на тому пристрої, тож рятувати нічого і боятися нічого. Викликаєш його з будь-якого іншого пристрою — і все там, де було.~«У мене забрали ноутбук.»=Побачать твої звичайні розмови, ті самі, що побачили б у будь-якому застосунку. З решти не побачать ні вмісту, ні назви, ні натяку на те, що воно існує.~«Мій компʼютер оглянули.»=Криміналістичний аналіз відновлює те, що записано на диску, навіть зашифроване й видалене. Тут немає чого відновлювати. Відповідь не «це неможливо розшифрувати», а «там нічого немає». Так само на планшеті, на телефоні й у браузері, яким ти скористався один вечір.",
  "lg.ciego.h2": "Ні ми. Ні той, хто розміщує сервери.",
  "lg.ciego.p1": "Сервер зберігає те, чого не може прочитати. У нього немає твого секрету, ніколи не було, і ніде не існує копії. Річ не в тім, що ми відмовляємось видати вміст твоїх IKO: у нас його немає, і отримати його неможливо. Ані в компанії, де стоять машини, ані в того, хто до них дістанеться.",
  "lg.ciego.p2": "У цього є ціна, і про неї чесно сказати: якщо втратиш свій секрет, повернути його нікому. Саме та причина, через яку не зайде ніхто інший, — причина, через яку і ми не зможемо допомогти тобі зайти.",
  "lg.guardas": "Сімейні фото|Нотатки, які ти не показуєш|Картки та банківські дані|Паролі|Документи|Розмови, що стосуються лише вас",
  "lg.nombre.esta": "є",
  "lg.nombre.noEsta": "немає",
  "lg.nombre.h2": "Звідси й назва.",
  "lg.nombre.p": "Мовою суахілі iko означає «є», а haiko — «немає». IKO є, поки ти його викликаєш. Решту часу — тобто майже завжди — його немає: ані на твоїх пристроях, ані в когось на видноті, ані навіть як підозра.",
  "lg.cierre.h2": "Почни говорити.",
  "lg.cierre.p": "Користуєшся як будь-яким месенджером: на телефоні, на планшеті й на компʼютері. IKO будуть на місці того дня, коли знадобляться.",
  "lg.cierre.btnCrear": "Створити акаунт",
  "lg.cierre.btnEntrar": "У мене вже є акаунт",
  "lg.cierre.pago": "IKOGNIT — платний продукт. Ані реклами, ані рекламних профілів, ані нашої копії будь-чого: ми живемо з того, що застосунок вартий своїх грошей, а не з того, що ти в ньому кажеш.",
  "lg.pie.ciego": "Сліпий сервер",
  "auth.hola": "І знову вітаємо.",
  "auth.queEs": "Що таке IKOGNIT?",
  "common.cancel": "Скасувати",
  "common.error.generic": "Не вийшло. Спробуй ще раз.",
  "common.save": "Зберегти",
  "common.confirm": "Підтвердити",
  "common.close": "Закрити",
  "common.add": "Додати",
  "common.back": "Назад",
  "common.tagline": "Цифровий суверенітет.",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "Мовою суахілі iko означає «є». А haiko — «немає».",
  "auth.legal.age": "Підтверджую, що досяг(ла) мінімального віку, передбаченого законом моєї країни для використання IKOGNIT.",
  "auth.legal.accept": "Я прочитав(ла) та приймаю <a href='https://ikognit.org/legal/uk/umovy.html' target='_blank' rel='noopener'>Умови</a>, <a href='https://ikognit.org/legal/uk/konfidentsiynist.html' target='_blank' rel='noopener'>Політику конфіденційності</a> та <a href='https://ikognit.org/legal/uk/pravyla-spilnoty.html' target='_blank' rel='noopener'>Правила спільноти</a>.",
  "recovery.title": "Твій ключ відновлення",
  "recovery.intro": "Ці **24 слова** — єдиний спосіб відновити обліковий запис та історію, якщо забудеш пароль або втратиш пристрій. **Запиши їх на папір і збережи у безпечному місці.** Ніхто в IKOGNIT не зможе їх відновити за тебе.",
  "recovery.warn": "**Записуй їх OFFLINE.** Не роби скріншот. Не надсилай електронною поштою чи месенджерами. Хто має ці слова — контролює весь твій акаунт.",
  "recovery.btn.show": "Показати слова",
  "recovery.btn.copy": "Копіювати",
  "recovery.btn.copied": "Скопійовано · видалиться через {0}с",
  "recovery.btn.cleared": "Буфер обміну очищено",
  "recovery.btn.copyAria": "Скопіювати фразу відновлення до буфера обміну (видалиться автоматично)",
  "recovery.btn.download": "Завантажити",
  "recovery.btn.downloadAria": "Завантажити фразу як текстовий файл",
  "recovery.btn.back": "Повернутися до слів",
  "recovery.btn.continue": "Продовжити",
  "recovery.btn.done": "Готово",
  "recovery.btn.need3": "Введи 3 правильних слова",
  "recovery.verify.intro": "Щоб підтвердити, що ти зберіг(ла) ключ, введи ці слова. Без правильної відповіді продовжити неможливо.",
  "recovery.verify.wordN": "Слово #{0}",
  "recovery.verify.correct": "Правильно",
  "recovery.verify.wrong": "Неправильно",
  "auth.error.legalRequired": "Щоб створити IKOGNIT ID, потрібно прийняти юридичні умови та підтвердити вік.",
  "settings.legal.title": "Юридична інформація",
  "settings.legal.hub": "Юридичний центр",
  "settings.legal.terms": "Умови використання",
  "settings.legal.privacy": "Політика конфіденційності",
  "settings.legal.rules": "Правила спільноти",
  "settings.legal.report": "Скарги та модерація",
  "settings.legal.cookies": "Політика cookies",
  "settings.legal.minors": "Політика для неповнолітніх",
  "settings.legal.notice": "Юридичне повідомлення",
  "settings.tab.legal": "Юридичне",
  "auth.loading": "Завантаження…",
  "auth.savedSession": "Цей пристрій уже знає свого власника.",
  "auth.locked": "Розтануло через бездіяльність. Зайди знову.",
  "auth.sessionExpired": "Сеанс розтанув. Зайди знову.",
  "auth.tab.login": "Увійти",
  "auth.tab.register": "Новий IKOGNIT ID",
  "auth.subLogin": "Ти входиш на загальний план: твої звичні розмови. IKO викликаються не тут — їх викликають усередині, коли вони потрібні.",
  "auth.subRegister": "Обліковий запис оформлено на тебе. Нік — це те, яким тебе бачать; пошта потрібна лише для відновлення доступу та сповіщень.",
  "auth.field.devicePin": "Головний ключ",
  "auth.field.password": "Головний ключ",
  "auth.btn.unlock": "Увійти",
  "auth.btn.unlocking": "Вхід…",
  "auth.btn.processing": "Обробка…",
  "auth.btn.createIdentity": "Створити IKOGNIT ID",
  "auth.btn.useOther": "Використати інший IKOGNIT ID",
  "auth.btn.forget": "Забути цей пристрій",
  "auth.btn.backToUnlock": "Назад",
  "auth.confirmForget": "Цей пристрій перестане тебе впізнавати: збережений обліковий запис і все з кешу зникають. Щоб зайти знову, знадобиться пароль.",
  "auth.confirmForget.warning": "Без записаної фрази відновлення з 24 слів шляху назад немає: ніхто її не поверне.",
  "invite.welcomeSub": "Повідомлення і власний простір: те, що ти тут зберігаєш, оформлено на тебе. Створи обліковий запис — і ви на зв'язку.",
  "auth.reset.warnNewIdentity": "Обліковий запис залишається твоїм, але відновлення поштою дає нову особу: попередні повідомлення прочитати вже не вийде. Якщо збереглася фраза відновлення з 24 слів, скористайся нею.",
  "recover.intro": "Введи нік або пошту і 24 слова відновлення, видані при створенні облікового запису. Потім обереш новий пароль.",
  "auth.error.badCreds": "Невірний IKOGNIT ID або ключ.",
  "auth.error.userNotFound": "IKOGNIT ID не знайдено.",
  "auth.error.cantConnect": "Не вдалося підключитися до сервера.",
  "auth.error.badPin": "Невірний ключ.",
  "auth.footnote": "Хто володіє, той і відповідає.\nВтратиш пароль —\nпитати буде ні з кого.",
  "sidebar.general": "IKOGNIT",
  "sidebar.freq": "Поточний IKO: {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.freqPrivate": "Особистий IKO: {0}",
  "sidebar.freqPsh": "Доменний IKO: {0}",
  "sidebar.tune": "Активувати IKO",
  "sidebar.exitFreq": "Повернутися до IKOGNIT",
  "sidebar.notifications": "Сповіщення",
  "sidebar.remember": "Запам'ятати пристрій",
  "sidebar.forget": "Забути пристрій",
  "sidebar.addContact": "Додати контакт за nick",
  "sidebar.newGroup": "Нова група",
  "sidebar.settings": "Налаштування",
  "sidebar.logout": "Вийти",
  "sidebar.tooltip.logout": "Вийти і видалити все локальне",
  "sidebar.savedFreq.tooltip": "Активувати {0}",
  "chat.empty": "Виберіть або додайте контакт",
  "welcome.title": "Ласкаво просимо до IKOGNIT",
  "welcome.concept": "У IKOGNIT ви спілкуєтеся з іншими користувачами, ідентифіковані за вашим nick. Коли хочете окремий простір, активуєте IKO і входите у IKO. Якщо Публічний — зустрічаєтеся з тими, хто його також активує. Якщо Приватний — входите у IKO, де є лише ви.",
  "welcome.step1": "Активуйте Публічний IKO і увійдіть у IKO з тими, хто його також знає.",
  "welcome.step2": "Тут у IKOGNIT додайте nick як контакт і починайте спілкуватися.",
  "welcome.step3": "Активуйте Приватний IKO і відкрийте IKO лише для себе, де зберігаєте файли, фото, аудіо, відео, паролі, нотатки та листи.",
  "welcome.multidevice": "IKO ніколи ніде не зберігаються. Якщо забудете IKO, його IKO перестане існувати для вас.",
  "welcome.btnFreq": "Активувати IKO",
  "welcome.btnContacts": "Додати контакт",
  "push.btnOn": "Сповіщення УВІМК",
  "push.btnOff": "Сповіщення ВИМК",
  "push.btnEnable": "Сповіщення вимкнено. Натисніть, щоб увімкнути.",
  "push.btnDisable": "Сповіщення увімкнено. Натисніть, щоб вимкнути.",
  "push.introTitle": "Перед увімкненням сповіщень",
  "push.introBody": "З міркувань приватності сповіщення IKOGNIT відрізняються від інших месенджерів:",
  "push.introBullet1": "Вміст повідомлення не включається.",
  "push.introBullet2": "Ім'я та IKOGNIT ID відправника не показуються.",
  "push.introBullet3": "Ви отримаєте лише сповіщення «нове повідомлення»; відкрийте додаток, щоб прочитати його зашифрованим на пристрої.",
  "push.introConfirm": "Увімкнути сповіщення",
  "chat.placeholder": "Напишіть повідомлення…",
  "chat.newMessages": "нових",
  "chat.newMessagesBadge": "Перейти до {0} нових повідомлень",
  "chat.mediaRetry": "Повторити",
  "chat.mediaFailed": "Не вдалося завантажити",
  "chat.media.download": "Завантажити",
  "chat.media.share": "Compartir",
  "chat.media.forward": "Reenviar",
  "chat.media.delete": "Eliminar",
  "chat.media.deleteConfirmTitle": "¿Eliminar foto?",
  "chat.media.deleteConfirmBody": "Esta acción no se puede deshacer.",
  "chat.media.deleteForMe": "Eliminar para mí",
  "chat.media.deleteForAll": "Eliminar para todos",
  "chat.media.forwardTo": "Reenviar a",
  "chat.editPlaceholder": "Редагувати повідомлення…",
  "chat.replyingTo": "Відповідь на {0}",
  "chat.editing": "Редагування повідомлення",
  "chat.confirmContact": "Додати до контактів",
  "chat.unconfirmedBanner": "Цей користувач написав вам, але його немає у ваших контактах. Поки ви його не додасте, ваше фото та інфо не будуть видимими для нього згідно з налаштуваннями приватності.",
  "chat.online": "у мережі",
  "chat.lastSeen": "востаннє був(ла) {0}",
  "chat.tooltip.attach": "Прикріпити файл",
  "chat.tooltip.shareContact": "Поділитися контактом",
  "chat.tooltip.paste": "Вставити зображення з буфера",
  "chat.tooltip.stickers": "Стікери",
  "chat.tooltip.callAudio": "Голосовий виклик",
  "chat.tooltip.callVideo": "Відеовиклик",
  "chat.btn.send": "Надіслати",
  "chat.uploading": "…",
  "preview.image": "📷 Зображення",
  "preview.video": "🎬 Відео",
  "preview.audio": "🎙 Аудіо",
  "bubble.reply": "Відповісти",
  "bubble.forward": "Reenviar",
  "bubble.edit": "Редагувати",
  "bubble.edited": "відредаговано",
  "bubble.contact.label": "Контакт IKOGNIT",
  "bubble.media.decrypting": "Розшифрування…",
  "bubble.media.failed": "Не вдалося розшифрувати файл.",
  "call.calling": "Виклик…",
  "call.incoming.audio": "Вхідний виклик",
  "call.incoming.video": "Вхідний відеовиклик",
  "call.connecting": "З'єднання…",
  "call.ending": "Завершення…",
  "call.accept": "Прийняти",
  "call.reject": "Відхилити",
  "call.hangup": "Завершити",
  "call.mic": "Мікрофон",
  "call.camera": "Камера",
  "call.audioOut": "Аудіовихід",
  "call.audioOut.auto": "Авто",
  "call.error.notInFreq": "Щоб зателефонувати, потрібно бути всередині IKO.",
  "error.notFound": "Ресурс не знайдено.",
  "error.notInFreq": "{0} ще не в цьому IKO. Попросіть через інший канал активувати його.",
  "error.push.iosTooOld": "Ваш iOS старший за 16.4. Оновіть для отримання сповіщень.",
  "error.push.iosNotStandalone": "Щоб отримувати сповіщення на iPhone, встановіть IKOGNIT на головний екран: Поділитися → На екран «Дім».",
  "error.expired": "Сесія закінчилася. Увійдіть знову.",
  "error.gone": "Файл застарів.",
  "error.invalid": "Невірні дані.",
  "error.server": "Помилка сервера. Спробуйте знову.",
  "error.network": "Немає з'єднання з сервером.",
  "error.cantStartCall": "Не вдалося розпочати виклик: {0}",
  "error.cantAcceptCall": "Не вдалося прийняти виклик: {0}",
  "error.cantPaste": "Не вдалося отримати доступ до буфера обміну. Спробуйте кнопку вкладення.",
  "error.noImageInClipboard": "У буфері немає зображення.",
  "error.clipboardUnsupported": "Браузер не дозволяє читати буфер. Вставте Ctrl+V або використайте кнопку вкладення.",
  "error.selfContact": "Не можна додати самого себе.",
  "error.blocked": "Ви заблокували цього користувача. Розблокуйте в Налаштуваннях, щоб знову спілкуватися.",
  "settings.title": "Налаштування",
  "settings.close": "Закрити",
  "settings.tab.profile": "👤 Профіль",
  "settings.tab.privacy": "🔒 Приватність",
  "settings.tab.messages": "✉ Повідомлення",
  "settings.tab.blocked": "🚫 Заблоковані",
  "settings.tab.notifications": "🔔 Сповіщення",
  "settings.tab.session": "⏱ Сесія",
  "settings.tab.account": "🆔 Акаунт",
  "settings.tab.language": "🌐 Мова",
  "settings.tab.about": "ℹ Про додаток",
  "settings.scope.global": "Глобально (IKOGNIT)",
  "settings.scope.freq": "Тільки в {0}",
  "settings.profile.title": "Профіль",
  "settings.profile.hintGlobal": "Ці значення використовуються за замовчуванням і успадковуються в усіх IKO.",
  "settings.profile.hintFreq": "Перекривають глобальний профіль, коли ви в {0}. Якщо тут нічого не задано, успадковується з глобального.",
  "settings.profile.displayName": "Відображуване ім'я",
  "settings.profile.displayNamePh.global": "(без імені — буде показано ваш nick)",
  "settings.profile.displayNamePh.freq": "(успадковується з глобального)",
  "settings.profile.photo": "Фото профілю",
  "settings.profile.changePhoto": "Змінити фото",
  "settings.profile.removePhoto": "Видалити фото",
  "settings.profile.adjustPhoto": "Налаштуйте фото",
  "settings.profile.info": "Інфо / Статус",
  "settings.profile.infoPh": "Привіт, я використовую IKOGNIT",
  "settings.profile.removeOverride": "Видалити перевизначення для {0}",
  "settings.profile.warn": "Зміни буде надіслано іншим контактам автоматично при взаємодії в цьому IKO.",
  "settings.privacy.title": "Приватність",
  "settings.privacy.hintGlobal": "Налаштуйте, хто може бачити кожну вашу інформацію за замовчуванням.",
  "settings.privacy.hintFreq": "Перевизначайте ці правила лише коли ви в {0}.",
  "settings.privacy.showPhoto": "Хто бачить моє фото",
  "settings.privacy.showInfo": "Хто бачить моє інфо / статус",
  "settings.privacy.showLastSeen": "Хто бачить останній вхід",
  "settings.privacy.showOnline": "Хто бачить, чи я в мережі",
  "settings.privacy.whoAdds": "Хто може додати мене до груп",
  "settings.privacy.readReceipts": "Підтвердження прочитання",
  "settings.privacy.readReceiptsHint": "Якщо вимкнено, сині галочки не надсилаються при прочитанні повідомлень. Ви також не побачите їх в інших.",
  "settings.vis.all": "Усі",
  "settings.vis.contacts": "Мої контакти",
  "settings.vis.none": "Ніхто",
  "settings.messages.title": "Повідомлення",
  "settings.messages.ttl": "Термін за замовчуванням",
  "settings.messages.ttlHint": "Надіслані вами повідомлення буде видалено з сервера після цього часу. При прикріпленні файлу можна вибрати інше значення.",
  "settings.blocked.title": "Заблоковані",
  "settings.blocked.hint": "Заблоковані користувачі не можуть надсилати вам повідомлення. Ви їм також.",
  "settings.blocked.placeholder": "IKOGNIT ID для блокування",
  "settings.blocked.btn": "Заблокувати",
  "settings.blocked.unblock": "Розблокувати",
  "settings.blocked.empty": "Нікого не заблоковано.",
  "settings.notif.title": "Сповіщення",
  "settings.notif.sound": "Звук",
  "settings.notif.preview": "Показувати прев'ю повідомлення",
  "settings.notif.vibration": "Вібрація (мобільне)",
  "settings.notif.hint": "Push-сповіщення браузера надсилаються лише для повідомлень у загальному IKOGNIT, без вмісту та імені відправника (за дизайном).",
  "settings.session.title": "Сесія",
  "settings.session.timeout": "Закрити IKO після бездіяльності",
  "settings.session.timeoutHint": "Якщо цей час пройшов без дотику до додатку, активний IKO автоматично деактивується і ви повернетеся до IKOGNIT. «Ніколи» утримує IKO до закриття додатку.",
  "settings.session.remember": "Запам'ятовувати активовані IKO",
  "settings.session.rememberHint": "Якщо увімкнено, активовані IKO з'являються як ярлики у бічній панелі. Будь-хто, бачачи ваш екран, зможе знати, до яких IKO ви входили, тому за замовчуванням вимкнено. Вимкнення стирає вже збережені.",
  "settings.account.title": "Акаунт",
  "settings.account.email": "Опціональний email (лише для відновлення, ніколи не публікується)",
  "settings.account.emailPh": "email@приклад.com",
  "settings.account.changePassword": "Змінити пароль",
  "settings.account.currentPw": "Поточний пароль",
  "settings.account.newPw": "Новий пароль (мін. 8)",
  "settings.account.confirmPw": "Повторіть новий",
  "settings.account.saving": "Збереження…",
  "settings.account.success": "Пароль оновлено.",
  "settings.account.errPwBad": "Поточний пароль невірний.",
  "settings.account.errPwShort": "Новий пароль має містити мінімум 8 символів.",
  "settings.account.errPwMismatch": "Паролі не співпадають.",
  "settings.language.title": "Мова",
  "settings.language.hint": "Виберіть мову інтерфейсу. Ваш вибір зберігається на цьому пристрої.",
  "settings.about.title": "Про IKOGNIT",
  "settings.about.version": "Версія",
  "settings.about.tech": "E2E шифрування з NaCl box (X25519). IKO: похідна Argon2id + детермінований HMAC. Локальна зашифрована persistence Argon2id над PIN.",
  "modal.freq.title": "Активувати IKO",
  "modal.freq.hint": "IKO — це точні IKO одного з ваших IKO. Публічний: зустрічаєтеся з тими, хто пише ті ж. Приватний: потрапляєте у IKO, де ви невидимі, навіть якщо інший напише ті ж IKO.",
  "modal.freq.placeholder": "Напишіть свої IKO",
  "modal.freq.activate": "Активувати",
  "modal.freq.deriving": "Обчислення IKO…",
  "modal.freq.warn": "IKO ніде не зберігаються. Якщо забудете, цей IKO перестане існувати для вас.",
  "modal.freq.errShort": "IKO має містити мінімум 8 символів.",
  "modal.freq.errCommon": "Цей IKO надто поширений. Виберіть унікальне.",
  "modal.freq.errRepeat": "Не використовуйте один повторюваний символ.",
  "modal.freq.errSeqNum": "Уникайте очевидних числових послідовностей.",
  "modal.freq.errSeqAlpha": "Уникайте алфавітних послідовностей.",
  "billing.title": "Білінг",
  "billing.manage": "Керування",
  "billing.seats": "Місця",
  "billing.renews": "Поновлення",
  "billing.needsUpgrade": "Досягнуто ліміту місць рівня. Перейди на наступний, щоб додати ще.",
  "billing.upgradeTo": "Перейти на ({price}/місце)",
  "billing.portal": "Керування оплатою",
  "join.loginToAccept": "Увійти / Створити акаунт",
  "private.badge": "ПРИВАТНЕ",
  "private.welcome.title": "Ваш Приватний IKO",
  "private.welcome.intro": "Ви на IKO, де ніхто не може вас побачити. Навіть якби інша людина написала той самий IKO, вона потрапила б в інший IKO. Тут ви зберігаєте своє в безпеці.",
  "private.welcome.hint": "Виберіть розділ, щоб почати.",
  "private.mod.notes": "Нотатки",
  "private.mod.notes.desc": "Нотатки, листи, щоденник.",
  "private.mod.files": "Файли",
  "private.mod.files.desc": "Документи, таблиці, PDF.",
  "private.mod.photos": "Фото",
  "private.mod.photos.desc": "Ваша приватна галерея.",
  "private.mod.videos": "Відео",
  "private.mod.videos.desc": "Ваші особисті відео.",
  "private.mod.audios": "Аудіо",
  "private.mod.audios.desc": "Записи та голосові нотатки.",
  "private.mod.vault": "Паролі",
  "private.mod.vault.desc": "Паролі, картки, посвідчення, ключі SSH і все, що потрібно.",
  "private.mod.iko": "Мої IKO",
  "private.mod.iko.desc": "Збережені IKO, готові до активації.",
  "savediko.intro": "Зберігай тут ті IKO, які не хочеш запамʼятовувати. Памʼятаєш один — решта живуть усередині.",
  "savediko.empty": "Ти ще не зберіг жодного IKO.",
  "savediko.add": "Зберегти IKO",
  "savediko.activate": "Активувати IKO",
  "savediko.formNew": "Зберегти IKO",
  "savediko.formEdit": "Редагувати збережений IKO",
  "savediko.descLabel": "Опис",
  "savediko.descPh": "Опис, щоб упізнати його пізніше",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "Напишіть IKO",
  "savediko.errDesc": "Введи опис.",
  "savediko.errIko": "Напишіть IKO.",
  "savediko.confirmDel": "Видалити?",
  "vault.new": "Новий елемент",
  "vault.edit": "Редагувати",
  "vault.delete": "Видалити",
  "vault.save": "Зберегти",
  "vault.show": "Показати",
  "vault.hide": "Приховати",
  "vault.copy": "Копіювати",
  "vault.copied": "Скопійовано ✓",
  "vault.search": "Пошук…",
  "vault.empty": "Ваш тека порожній. Створіть перший елемент.",
  "vault.noMatches": "Жоден елемент не відповідає пошуку.",
  "vault.untitled": "Без назви",
  "vault.startHint": "Виберіть елемент зліва або створіть новий.",
  "vault.confirmDelete": "Видалити цей елемент? Відновити неможливо.",
  "vault.notes": "Нотатки",
  "vault.sensitive": "Конфіденційне",
  "vault.sensitiveHint": "Конфіденційні поля приховано за замовчуванням і їх можна копіювати в буфер.",
  "vault.removeField": "Видалити це поле",
  "vault.addField": "Додати поле",
  "vault.fieldSingular": "поле",
  "vault.fieldPlural": "поля",
  "vault.type.login": "Логін",
  "vault.type.card": "Картка",
  "vault.type.identity": "Посвідчення",
  "vault.type.sshkey": "SSH-ключ",
  "vault.type.custom": "Користувацький",
  "vault.field.name": "Назва",
  "vault.field.name.ph": "Як ви це називаєте?",
  "vault.field.labelPh": "Мітка поля",
  "vault.field.newField": "Поле",
  "vault.field.username": "Користувач",
  "vault.field.password": "Пароль",
  "vault.field.url": "URL",
  "vault.field.totp": "TOTP",
  "vault.field.cardHolder": "Власник",
  "vault.field.cardBrand": "Марка",
  "vault.field.cardNumber": "Номер",
  "vault.field.cardExpiry": "Термін (ММ/РР)",
  "vault.field.cardCvv": "CVV",
  "vault.field.firstname": "Ім'я",
  "vault.field.lastname": "Прізвище",
  "vault.field.dni": "Документ",
  "vault.field.address": "Адреса",
  "vault.field.city": "Місто",
  "vault.field.zip": "Поштовий індекс",
  "vault.field.country": "Країна",
  "vault.field.phone": "Телефон",
  "vault.field.email": "Email",
  "vault.field.birthdate": "Дата народження",
  "vault.field.sshPrivate": "Приватний ключ",
  "vault.field.sshPublic": "Публічний ключ",
  "vault.field.sshFingerprint": "Fingerprint",
  "vault.field.sshHost": "Host",
  "vault.ft.text": "Текст",
  "vault.ft.password": "Пароль",
  "vault.ft.textarea": "Довгий текст",
  "vault.ft.date": "Дата",
  "vault.ft.url": "URL",
  "vault.ft.email": "Email",
  "vault.ft.number": "Число",
  "vault.tpl.title": "Шаблони",
  "vault.tpl.manage": "Керування шаблонами",
  "vault.tpl.yours": "Ваші шаблони",
  "vault.tpl.new": "Новий шаблон",
  "vault.tpl.edit": "Редагувати шаблон",
  "vault.tpl.empty": "У вас ще немає шаблонів. Створіть один, щоб визначити власний тип елемента.",
  "vault.tpl.name": "Назва шаблону",
  "vault.tpl.name.ph": "Напр.: Крипто-гаманець, Бронювання готелю…",
  "vault.tpl.confirmDelete": "Видалити цей шаблон? Елементи, створені з нього, залишаться.",
  "totp.copyCode": "Копіювати код",
  "totp.copySecret": "Копіювати secret",
  "totp.showSecret": "Показати secret",
  "totp.hideSecret": "Приховати secret",
  "totp.invalid": "недійсний secret",
  "private.module.coming": "Незабаром.",
  "private.module.comingHint": "Цей модуль буде доступний дуже скоро. Криптографія Приватного IKO вже працює — незабаром ви зможете зберігати тут все необхідне.",
  "notes.new": "Нова нотатка",
  "notes.empty": "У цьому IKO ще немає нотаток.",
  "notes.emptyPreview": "(порожньо)",
  "notes.untitled": "Без заголовка",
  "notes.delete": "Видалити нотатку",
  "notes.confirmDelete": "Видалити цю нотатку? Відновити неможливо.",
  "notes.titlePlaceholder": "Заголовок",
  "notes.contentPlaceholder": "Запишіть, що потрібно пам'ятати…",
  "notes.startHint": "У цьому IKO немає нотаток. Створіть першу.",
  "notes.autosaveHint": "Зберігається автоматично, зашифровано, лише тут.",
  "notes.yesterday": "Вчора",
  "passwords.new": "Новий запис",
  "passwords.empty": "У цьому IKO ви ще нічого не зберегли.",
  "passwords.untitled": "Без назви",
  "passwords.startHint": "У цьому IKO немає паролів. Створіть перший.",
  "passwords.confirmDelete": "Видалити цей запис? Відновити неможливо.",
  "passwords.save": "Зберегти",
  "passwords.edit": "Редагувати",
  "passwords.delete": "Видалити",
  "passwords.copy": "Копіювати",
  "passwords.copied": "Скопійовано ✓",
  "passwords.show": "Показати",
  "passwords.hide": "Приховати",
  "passwords.field.label": "Назва",
  "passwords.field.label.ph": "Банк, акаунт, сервіс…",
  "passwords.field.username": "Користувач",
  "passwords.field.username.ph": "Email, alias, номер…",
  "passwords.field.password": "Пароль",
  "passwords.field.password.ph": "Пароль, який хочете зберегти",
  "passwords.field.url": "URL",
  "passwords.field.notes": "Нотатки",
  "passwords.field.notes.ph": "Будь-яка корисна деталь",
  "media.uploading": "Завантаження…",
  "media.uploadFailed": "Не вдалося завантажити файл.",
  "media.upload.file": "Завантажити файл",
  "media.upload.photo": "Завантажити фото",
  "media.upload.video": "Завантажити відео",
  "media.upload.audio": "Завантажити аудіо",
  "media.empty.file": "У цьому IKO ще немає файлів.",
  "media.empty.photo": "У цьому IKO ще немає фото.",
  "media.empty.video": "У цьому IKO ще немає відео.",
  "media.empty.audio": "У цьому IKO ще немає аудіо.",
  "media.play": "Відтворити",
  "media.download": "Завантажити",
  "media.delete": "Видалити",
  "media.confirmDelete": "Видалити цей елемент? Відновити неможливо.",
  "media.noPreview": "Немає попереднього перегляду для цього типу файлу.",
  "modal.share.title": "Поділитися контактом",
  "modal.share.hint": "Виберіть контакт зі списку або введіть IKOGNIT ID вручну.",
  "modal.share.filter": "Фільтр контактів…",
  "modal.share.empty": "Немає контактів у цьому IKO",
  "modal.share.manual": "Або IKOGNIT ID вручну",
  "modal.share.btn": "Поділитися",
  "modal.group.title": "Нова група",
  "modal.group.hint": "Виберіть назву та учасників з ваших контактів у цьому IKO.",
  "modal.group.namePh": "Назва групи",
  "modal.group.selected": "Вибрано: {0}",
  "modal.group.create": "Створити групу",
  "modal.remember.title": "Запам'ятати цей пристрій",
  "modal.remember.hint": "Ваша сесія, контакти, групи та повідомлення будуть збережені на цьому пристрої, зашифровані PIN-кодом, відомим лише вам. При повторному відкритті додатку введете PIN для розблокування.",
  "modal.remember.pin": "PIN",
  "modal.remember.confirm": "Повторіть PIN",
  "modal.remember.warn": "Якщо забудете PIN, збережені дані не вдасться відновити. Доведеться знову увійти з користувачем та паролем.",
  "modal.remember.errShort": "PIN має містити мінімум 4 символи.",
  "modal.remember.errMismatch": "PIN-коди не співпадають.",
  "stickers.faces": "Обличчя",
  "stickers.gestures": "Жести",
  "stickers.hearts": "Серця",
  "stickers.symbols": "Символи",
  "stickers.animals": "Тварини",
  "stickers.food": "Їжа",
  "ttl.1h": "1 година",
  "ttl.1d": "1 день",
  "ttl.1w": "1 тиждень",
  "ttl.1m": "1 місяць",
  "ttl.6m": "6 місяців",
  "ttl.12m": "12 місяців",
  "timeout.5min": "5 хв",
  "timeout.15min": "15 хв",
  "timeout.30min": "30 хв",
  "timeout.never": "Ніколи",
  "toast.newMessage": "Нове повідомлення",
  "toast.group": "{0} (група)",
  // Web 2035 — ContextPanel / ControlCenterBar / HolographicEmpty / IdentityBar
  "ctx.aria": "Інформація та навігація у IKO",
  "ctx.section.universe": "ПОТОЧНИЙ IKO",
  "ctx.universe.personal": "Твій особистий простір",
  "ctx.status.serverBlind": "Сліпий сервер активний",
  "ctx.status.e2e": "Наскрізне шифрування",
  "ctx.section.nav": "НАВІГАЦІЯ",
  "ctx.nav.changeIko": "Змінити IKO",
  "ctx.nav.activateIko": "Активувати IKO",
  "ctx.nav.backToIkognit": "Назад до IKOGNIT",
  "ctx.section.actions": "ДІЇ",
  "ctx.action.newChat": "Новий чат",
  "ctx.action.newGroup": "Нова група",
  "ctx.action.contacts": "Мої контакти",
  "ctx.section.conversation": "РОЗМОВА",
  "ctx.peer.online": "у мережі",
  "ctx.peer.offline": "не в мережі",
  "ctx.peer.messages": "{0} повідомлень",
  "ctx.peer.message": "{0} повідомлення",
  "ctx.modes.shared": "IKO",
  "ctx.modes.private": "Особистий IKO",
  "ctx.modes.storage": "Накопичувач",
  "ctx.liturgy.0": "Сервер сліпий.",
  "ctx.liturgy.1": "Тут читаєш лише ти.",
  "ctx.liturgy.2": "Ніхто не знає, що ти тут.",
  "ctx.liturgy.3": "IKO — це таємниця, яку знаєш лише ти.",
  "ctx.liturgy.4": "Твоя приватність — це архітектура.",
  "ccb.universe.changeOrExit": "Змінити IKO або вийти",
  "ccb.universe.activate": "Активувати IKO",
  "ccb.leave.title": "Вийти з IKO (назад до IKOGNIT)",
  "ccb.leave.aria": "Вийти з IKO",
  "ccb.tag.cipher.title": "Симетричне шифрування активне",
  "ccb.tag.srv.title": "Сервер не може читати вміст",
  "ccb.tag.unread.title": "Непрочитані повідомлення",
  "ccb.settings.title": "Налаштування · профіль, теми, сесія",
  "ccb.settings.aria": "Налаштування",
  "ccb.identity.title": "Сесія: @{0}",
  "ccb.clock.title": "Місцевий час",
  "ccb.modes.personalPrefix": "ОСОБИСТИЙ · ",
  "holo.modes.shared": "IKO",
  "holo.modes.private": "ОСОБИСТИЙ IKO",
  "holo.modes.general": "ТВІЙ НІК + КОНТАКТИ",
  "holo.claim.inIko": "Цей IKO залишається невидимим для тих, хто його не знає.",
  "holo.claim.general": "Твій особистий простір в IKOGNIT. Тут ти спілкуєшся зі своїми контактами.",
  "holo.card.conversations": "Розмови",
  "holo.card.contacts": "Контакти",
  "holo.card.cipher": "Шифрування",
  "holo.card.server": "Сервер",
  "holo.foot": "Вибери розмову, активуй IKO або створи новий простір.",
  "uib.modes.shared": "IKO",
  "uib.modes.private": "Особистий IKO",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "Загальний IKO",
  "uib.e2e.title": "Сервер не може читати твій вміст — E2E-шифрування твоїм ключем",
  "uib.e2e.label": "Сліпий сервер",
  "uib.pseudoTitle": "Твій псевдонім у цьому IKO",
  "uib.nickTitle": "Твій нік",
  "uib.exitTitle": "Повернутися до Загального IKO",
  "uib.exitLabel": "Вийти",

  // Web 2035 — Chat.shared restantes
  "chat.nav.aria": "Головна навігація",
  "chat.tab.chats": "Чати",
  "chat.tab.calls": "Дзвінки",
  "chat.tab.contacts": "Контакти",
  "chat.backToIkognit.title": "Назад до загального IKOGNIT",
  "chat.delete.title": "Видалити",
  "chat.delete.aria": "Видалити",
  "chat.call.title": "Зателефонувати",
  "chat.videoCall.title": "Відеодзвінок",
  "chat.videoCall.aria": "Відеодзвінок з {0}",
  "chat.search.clear": "Очистити пошук",
  "chat.filters.aria": "Фільтри чатів",
  "chat.filter.all": "Усі",
  "chat.filter.unread": "Непрочитані",
  "chat.filter.groups": "Групи",
  "chat.attachPending": "Вкладення в очікуванні",
  "chat.remove.title": "Прибрати",
  "chat.cancel.title": "Скасувати",
  "chat.blocked.text": "Ти заблокував(ла) {0}. Не можеш надсилати повідомлення і дзвонити.",
  "chat.unblock": "Розблокувати",
  "contacts.alias.placeholder": "Псевдонім для розпізнавання",
  "contacts.notes.placeholder": "Бачиш лише ти (зашифрована на сервері).",
  "contacts.search.placeholder": "Пошук за псевдонімом або IKOGNIT ID",
  "contacts.edit.title": "Редагувати псевдонім і нотатку",
  "contacts.edit.aria": "Редагувати",
  "contacts.blockBtn": "Заблокувати контакт",
  "contacts.unblockBtn": "Розблокувати контакт",
  "contacts.confirmBlock.title": "Заблокувати контакт",
  "contacts.confirmUnblock.title": "Розблокувати контакт",
  "contacts.confirmBlock.body": "Заблокувати {0}? Ти не отримуватимеш повідомлення і дзвінки.",
  "contacts.confirmUnblock.body": "Розблокувати {0}? Ти знову отримуватимеш повідомлення.",

  // Web 2035 — PrivateIkoRail
  "piko.rail.aria": "Категорії Особистого IKO",
  "piko.rail.head": "ОСОБИСТИЙ",
  "piko.cat.all": "Усе",
  "piko.cat.photos": "Фото",
  "piko.cat.videos": "Відео",
  "piko.cat.audios": "Аудіо",
  "piko.cat.files": "Файли",
  "piko.cat.notes": "Нотатки",
  "piko.cat.passwords": "Паролі",
  "piko.cat.cards": "Картки",
  "piko.cat.identities": "Особистості",
  "piko.cat.sshkeys": "SSH-ключі",
  "piko.cat.custom": "Тека",
  "piko.cat.agendas": "Каталоги IKO",
  "piko.cat.storage": "Диск і Диски",

  "auth.field.nickPlaceholder": "напр. user123",
  "auth.field.emailPlaceholder": "ty@email.com",


  // Tick de mensajes
  "bubble.tick.read": "Прочитано {0}",
  "bubble.tick.delivered": "Доставлено {0}",
  "bubble.tick.sent": "Надіслано",

  // Batch1: chat/manifest/orb/liturgy/explorer/join/demo
  "chat.error.userBlocked": "Ви заблокували цього користувача.",
  "chat.preview.image": "Зображення",
  "chat.preview.video": "Відео",
  "chat.preview.voice": "Голосове повідомлення",
  "chat.preview.audio": "Аудіо",
  "error.push.denied": "Ви відмовили в дозволі на сповіщення.",
  "error.push.noSw": "Цей браузер не підтримує service workers.",
  "error.push.noPush": "Цей браузер не підтримує push-сповіщення.",
  "error.push.noVapid": "Сервер не надав ключ VAPID.",
  "error.push.activateFailed": "Не вдалося активувати ({0}).",
  "chat.group.membersWord": "учасників",
  "chat.newCall.title": "Новий дзвінок",
  "chat.newChat.title": "Новий чат",
  "chat.newCall.empty": "Контактів ще немає. Додайте через + у Чатах.",
  "chat.unread.aria": "непрочитаних повідомлень",
  "chat.calls.title": "Дзвінки",
  "chat.calls.empty": "Дзвінків ще немає. Почніть із чату з контактом.",
  "chat.calls.callContact": "Зателефонувати контакту",
  "chat.calls.historySoon": "Історія дзвінків незабаром буде доступна.",
  "chat.deleteConv.titleOne": "Видалити розмову",
  "chat.deleteConv.titleMany": "Видалити {0} розмов",
  "chat.deleteConv.hint": "«Для мене» видаляє вашу копію (усі ваші пристрої). «Для всіх» також просить контакт видалити в нього.",
  "chat.deleteConv.forMe": "Видалити в мене",
  "chat.deleteConv.forAll": "Видалити в усіх",
  "chat.myContacts": "Мої контакти",
  "chat.contacts.noResults": "Немає результатів.",
  "chat.contacts.empty": "Контактів ще немає.",
  "chat.contact.badgeBlocked": "заблоковано",
  "chat.contact.badgePending": "не підтверджено",
  "chat.toast.saved": "Збережено",
  "chat.toast.videoSaved": "Відео збережено у Фото",
  "chat.toast.imageSaved": "Зображення збережено у Фото",
  "chat.toast.updateTestflight": "Оновіть TestFlight до 1.0(10)+ для збереження.",
  "chat.toast.saveFailed": "Не вдалося зберегти: {0}",
  "chat.toast.saveError": "Помилка збереження",
  "iko.banner.exitAria": "Вийти з IKO і повернутися на загальний план",
  "iko.liturgy.entering": "Вхід у IKO",
  "iko.liturgy.returning": "Повернення",
  "iko.liturgy.toIkognit": "до IKOGNIT",
  "iko.mode.shared": "IKO",
  "iko.mode.private": "Особистий IKO",
  "manifest.blindServer": "Сервер сліпий.",
  "manifest.onlyYouRead": "Тут читаєте лише ви.",
  "manifest.noPublicProfiles": "Без публічних профілів.",
  "manifest.noAdsNoClouds": "Без реклами. Без чужих хмар.",
  "manifest.keyWithYou": "Ключ живе з вами.",
  "manifest.yourIkoYourSpaces": "Ваші IKO. Ваші простори.",
  "orb.mod.chat": "Чат",
  "orb.mod.files": "Файли",
  "orb.mod.notes": "Нотатки",
  "orb.mod.photos": "Фото",
  "orb.mod.vault": "Тека",
  "orb.mod.audios": "Аудіо",
  "orb.copy.line1": "Ваші IKO.",
  "orb.copy.line2": "Ваші простори.",
  "explorer.filesNotProcessed": "Необроблені файли",
  "demo.edit": "Редагувати",
  "common.exit": "Вихід",
  "common.more": "Більше",
  "chat.tab.settings": "Налаштування",
  "chat.search.placeholder": "Пошук чату",
  "chat.presence.online": "у мережі",
  "chat.action.call": "Дзвонити",
  "chat.action.videoCall": "Відеодзвінок",
  "chat.attach.label": "Прикріпити",
  "chat.attach.camera": "Камера",
  "chat.attach.voice": "Голос",
  "chat.attach.file": "Прикріпити файл",
  "chat.composer.placeholder": "Напишіть повідомлення...",
  "settings.addYourName": "Додайте ім'я",
  "settings.editProfile": "Редагувати профіль",
  "chat.welcome.intro": "Виберіть чат, щоб почати спілкування з наскрізним шифруванням.",

  // Batch2: footer atajos web
  "web.footer.palette": "палітра",
  "web.footer.send": "надіслати",
  "web.footer.line": "рядок",
  "mobile.tb.ikoActivate": "Активувати IKO",
  "mobile.tb.ikoExit": "Назад до загального IKOGNIT",

  "chat.header.blocked": "Заблоковано",
  "contacts.alias.label": "Псевдонім",
  "contacts.note.label": "Особиста нотатка",
  "settings.account.newNickPlaceholder": "новий_нік",
  "settings.account.newEmailPlaceholder": "новий@email.com",


  "common.delete": "Видалити",








};

const zh: Catalog = {
  "auth.verify.notSent": "我们没能把验证码发给你。你的账户已经创建：稍后点「重新发送验证码」。",
  "lg.rotulo": "带私密空间的即时通讯",
  "lg.btn.entrar": "登录",
  "lg.eyebrow": "私密通讯 · Itrion Software",
  "lg.h1a": "你一如既往的对话。",
  "lg.h1b": "以及一个只有你召唤时才存在的地方。",
  "lg.lead1": "你和家人、朋友、同事聊天，和任何应用一样。不同之处从你打开一个 IKO 开始：那是你自己的空间，写出只有里面的人才知道的秘密才能进去。",
  "lg.lead2": "只要你不召唤它，那个空间就不在你的设备上——不在手机里，不在平板里，也不在电脑里。并不是它被加密了。",
  "lg.lead2b": "而是它根本不存在。",
  "lg.pruebalo": "自己试试 · 写一个秘密，看看会发生什么",
  "lg.panel.plano": "一般层面",
  "lg.demo.hilos": "家人=妈妈：周日在家吃饭吗？=19:04|Marta=周六的照片发给你=17:52|团队=Luis：那就明天九点=昨天|Javi=哈哈我不信=昨天",
  "lg.demo.mundos": "只有我们俩~你放在我们说好的地方了吗？|放了。房产证和护照>~房产证.pdf=2.4 MB|私人照片=214|银行卡=数据~~家里的事~租房合同放这儿了>|还有路由器密钥，你总是弄丢~租房合同.pdf=1.1 MB|身份证复印件=2 个文件|家门钥匙=数据~~我的笔记~这件事我没跟任何人说过>|也不需要说>~日记=48 条|照片=1,207|年度账目=数据~~里斯本项目~报价是 180|在这里，外面没有副本>~报价_v4.pdf=860 KB|联系人=12|公司卡=数据~~周六的午饭~先别跟 Marta 说|放心，这里没人会知道>~预订.pdf=120 KB|去年的照片=63|宾客名单=数据",
  "lg.invocaLabel": "召唤你的 IKO",
  "lg.invocaPlaceholder": "随便写一个秘密",
  "lg.invocaBtn": "召唤",
  "lg.invocaHint": "每个词通往不同的空间。换一个试试。",
  "lg.estela.vacio": "随便写点什么：这里只是演示。",
  "lg.estela.primero": "出现了。只在你身处其中时存在。",
  "lg.estela.otro": "换个秘密，就是另一个空间。彼此互不知情。",
  "lg.estela.salida": "已消失。设备上没有留下痕迹。换个词试试。",
  "lg.ikoActivo": "IKO 已启用",
  "lg.nadaEnDispositivo": "这些都不在设备上",
  "lg.salirIko": "离开 IKO",
  "lg.planos.h2a": "一个看得见的层面。",
  "lg.planos.h2b": "下面，是你召唤出来的那些。",
  "lg.planos.lead": "并不存在「那个 IKO」。存在的是你打开的那些：一个放家里的事，一个放工作，一个只有你们两人知道，还有一个你从没跟任何人提过。每个秘密通往它自己的那一个，彼此互不知情。",
  "lg.planos.unoRotulo": "一般层面 · 一个",
  "lg.planos.unoH3": "你和所有人聊天的地方",
  "lg.planos.unoP": "对话、群组、通话、照片和文件，端到端加密。你对一款通讯应用的期待，认真做好。你平常的聊天都住在这里，表现一如既往。",
  "lg.planos.nRotulo": "IKO · 你想要多少都行",
  "lg.planos.nH3": "别人到不了的地方",
  "lg.planos.nP": "你写下一个秘密，对应的空间就出现。里面装得下对话和你的东西。你离开时，它从设备上消失，不留痕迹。没有列表，没有数量，没有人能查出你有几个，甚至查不出是否存在过一个。",
  "lg.planos.chips": "家里的事|工作|只有你们俩知道的事|你的，别人无份|开过一次再没碰过的那个|明天你才决定的那些",
  "lg.forense.h2a": "它不是在你的设备上被加密。",
  "lg.forense.h2b": "它根本不在你的设备上。",
  "lg.forense.lead": "别的应用把你的消息留在机器里再加密。要是有人把机器拿走，你的隐私就取决于那层加密能撑多久。这里没有什么需要撑住：IKO 里的东西不会写进任何设备。召唤、使用，然后离开。",
  "lg.forense.multi": "在哪儿都一样：手机、平板、家里的电脑、公司的笔记本、Windows、Mac，或者别人地方的浏览器。你想在哪儿进就在哪儿进，离开之后，那个地方对你一无所知。",
  "lg.forense.caption": "有人检查你任何一台设备时会找到什么",
  "lg.forense.filas": "你的 IKO 里的消息=0|你的 IKO 里的文件和照片=0|保存的 IKO 秘密=0|存放你 IKO 的数据库=不存在|IKO 曾被打开的痕迹=没有|你有多少个 IKO=无法确定",
  "lg.escenas.h2": "你真正担心的事。",
  "lg.escenas.filas": "「我手机丢了。」=你的隐私没有跟着丢。IKO 里的东西从来没有在那台机器上，所以没什么可抢救的，也没什么可怕的。换任何一台设备召唤，一切都还在原处。~「有人拿走了我的笔记本。」=他会看到你平常的对话，和在任何应用里看到的一样。其余的，他看不到内容，看不到名字，也看不到它存在的任何迹象。~「我的电脑被检查了。」=取证分析能恢复写在磁盘上的东西，哪怕加密过、删除过。这里没有写下任何可恢复的东西。答案不是「解不开」，而是「什么都没有」。平板、手机，以及你某个下午用过的浏览器，同样如此。",
  "lg.ciego.h2": "我们不行。托管服务器的人也不行。",
  "lg.ciego.p1": "服务器保存着它读不懂的东西。它没有你的秘密，从来没有过，任何地方都不存在副本。不是我们拒绝交出你 IKO 里的内容：而是我们没有，也无从拥有。托管机器的公司没有，把机器弄到手的人也没有。",
  "lg.ciego.p2": "这有代价，也应当说清楚：如果你弄丢了秘密，没有人能还给你。别人进不来的那个原因，正是我们也帮不了你进去的原因。",
  "lg.guardas": "家庭照片|不给别人看的笔记|银行卡和账户资料|密码|文件|只关乎你们的对话",
  "lg.nombre.esta": "在",
  "lg.nombre.noEsta": "不在",
  "lg.nombre.h2": "名字由此而来。",
  "lg.nombre.p": "在斯瓦希里语里，iko 是「在」，haiko 是「不在」。IKO 在你召唤它的时候在。其余时间——也就是几乎所有时间——它不在：不在你的设备上，不在任何人眼里，甚至不作为一种怀疑存在。",
  "lg.cierre.h2": "开始聊天吧。",
  "lg.cierre.p": "用起来和任何通讯应用一样，手机、平板和电脑都可以。你需要 IKO 的那一天，它们就在那里。",
  "lg.cierre.btnCrear": "创建账户",
  "lg.cierre.btnEntrar": "我已有账户",
  "lg.cierre.pago": "IKOGNIT 是付费产品。没有广告，没有广告画像，我们这边也没有任何副本：我们靠这款应用值不值得你付费而活，不靠你在里面说了什么。",
  "lg.pie.ciego": "盲服务器",
  "auth.hola": "又见面了。",
  "auth.queEs": "IKOGNIT 是什么？",
  "auth.btn.backToUnlock": "后退",
  "auth.btn.createIdentity": "创建账户",
  "auth.btn.forget": "忘记这个设备",
  "auth.btn.processing": "加工…",
  "auth.btn.unlock": "登入",
  "auth.btn.unlocking": "正在登录...",
  "auth.btn.useOther": "使用另一个帐户",
  "auth.confirmForget": "这台设备将不再认得你：已保存的账户和缓存中的内容都会消失。要再次进入，你需要密码。",
  "auth.confirmForget.warning": "如果没有抄下 24 个词的恢复短语，就没有退路：没有人能把它还给你。",
  "invite.welcomeSub": "消息，加上一处自己的空间：你存在这里的东西登记在你名下。创建账户，你们就连上了。",
  "auth.reset.warnNewIdentity": "账户仍是你的，但通过邮箱恢复会给你一个新身份：以前的消息将无法再读取。如果还留着 24 个词的恢复短语，请走那条路。",
  "recover.intro": "输入你的昵称或邮箱，以及创建账户时给你的 24 个恢复词。随后你将设置新密码。",
  "auth.error.badCreds": "昵称/电子邮件或密码错误。",
  "auth.error.badPin": "钥匙错误。",
  "auth.error.cantConnect": "无法连接到服务器。",
  "auth.error.legalRequired": "您必须接受法律条款并确认您的年龄才能创建帐户。",
  "auth.error.userNotFound": "未找到帐户。",
  "auth.field.devicePin": "设备PIN",
  "auth.field.emailPlaceholder": "你@email.com",
  "auth.field.nickPlaceholder": "例如user123",
  "auth.field.password": "密码",
  "auth.footnote": "谁是主人，谁就担责。\n密码丢了，\n就没有人可以找。",
  "auth.legal.accept": "我已阅读并接受 <a href='https://ikognit.org/legal/en/terms.html' target='_blank' rel='noopener'> 条款 </a>、<a href='https://ikognit.org/legal/en/privacy.html' target='_blank' rel='noopener'> 隐私政策 </a> 和 <a href='https://ikognit.org/legal/en/community-rules.html' target='_blank' rel='noopener'> 社区规则 </a>。",
  "auth.legal.age": "我确认我符合所在国家/地区法律规定的使用 IKOGNIT 的最低年龄。",
  "auth.loading": "加载中…",
  "auth.savedSession": "这台设备已经认得它的主人。",
  "auth.locked": "闲置太久，已经消散。重新进入。",
  "auth.sessionExpired": "会话已经消散。重新进入。",
  "auth.subLogin": "你进入的是一般层面：你平常的对话。IKO 不在这里召唤——要在里面召唤，等你需要的时候。",
  "auth.subRegister": "账户登记在你名下。昵称是别人看到的你；邮箱只用于找回访问权限和接收通知。",
  "auth.tab.login": "登入",
  "auth.tab.register": "新账户",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "斯瓦希里语里，iko 是「在」，haiko 是「不在」。",
  "billing.manage": "管理",
  "billing.needsUpgrade": "您已达到级别的座位限制。升级以添加更多座位。",
  "billing.portal": "管理付款",
  "billing.renews": "续订",
  "billing.seats": "座位数",
  "billing.title": "计费",
  "billing.upgradeTo": "升级等级（{price}/座位）",
  "bubble.contact.label": "IKOGNIT 联系人",
  "bubble.edit": "编辑",
  "bubble.edited": "已编辑",
  "bubble.forward": "向前",
  "bubble.media.decrypting": "正在解密...",
  "bubble.media.failed": "无法解密该文件。",
  "bubble.reply": "回复",
  "bubble.tick.delivered": "已交付 {0}",
  "bubble.tick.read": "读取{0}",
  "bubble.tick.sent": "发送",
  "call.accept": "接受",
  "call.audioOut": "音频输出",
  "call.audioOut.auto": "汽车",
  "call.calling": "呼叫…",
  "call.camera": "相机",
  "call.connecting": "正在连接…",
  "call.ending": "结束…",
  "call.error.notInFreq": "要调用您必须位于 IKO 内。",
  "call.hangup": "挂断",
  "call.incoming.audio": "来电",
  "call.incoming.video": "来电视频通话",
  "call.mic": "麦克风",
  "call.reject": "拒绝",
  "ccb.clock.title": "当地时间",
  "ccb.identity.title": "会话：@{0}",
  "ccb.leave.aria": "退出IKO",
  "ccb.leave.title": "退出IKO（返回IKOGNIT）",
  "ccb.modes.personalPrefix": "个人的 ·",
  "ccb.settings.aria": "设置",
  "ccb.settings.title": "设置 · 个人资料、主题、会话",
  "ccb.tag.cipher.title": "对称密码激活",
  "ccb.tag.srv.title": "服务器无法读取您的内容",
  "ccb.tag.unread.title": "未读消息",
  "ccb.universe.activate": "激活IKO",
  "ccb.universe.changeOrExit": "切换IKO或退出",
  "chat.action.call": "称呼",
  "chat.action.videoCall": "视频电话",
  "chat.attach.camera": "相机",
  "chat.attach.file": "附加文件",
  "chat.attach.label": "附",
  "chat.attach.voice": "嗓音",
  "chat.attachPending": "待附件",
  "chat.backToIkognit.title": "返回一般IKOGNIT",
  "chat.blocked.text": "您屏蔽了 {0} 。您无法发送消息或致电他们。",
  "chat.btn.send": "发送",
  "chat.call.title": "称呼",
  "chat.calls.callContact": "致电联系人",
  "chat.calls.empty": "还没有来电。从与联系人的聊天开始。",
  "chat.calls.historySoon": "通话记录很快就会可用。",
  "chat.calls.title": "通话",
  "chat.cancel.title": "取消",
  "chat.composer.placeholder": "输入消息...",
  "chat.confirmContact": "添加至联系人",
  "chat.contact.badgeBlocked": "被阻止",
  "chat.contact.badgePending": "未证实",
  "chat.contacts.empty": "还没有联系方式。",
  "chat.contacts.noResults": "没有结果。",
  "chat.delete.aria": "删除",
  "chat.delete.title": "删除",
  "chat.deleteConv.forAll": "为大家删除",
  "chat.deleteConv.forMe": "为我删除",
  "chat.deleteConv.hint": "“为我”会删除您的副本（您的所有设备）。 “对于所有人”还要求联系人将其删除。",
  "chat.deleteConv.titleMany": "删除 {0} 对话",
  "chat.deleteConv.titleOne": "删除对话",
  "chat.editPlaceholder": "编辑您的消息...",
  "chat.editing": "编辑消息",
  "chat.empty": "选择或添加联系人",
  "chat.error.userBlocked": "您已阻止该用户。",
  "chat.filter.all": "全部",
  "chat.filter.groups": "团体",
  "chat.filter.unread": "未读",
  "chat.filters.aria": "聊天过滤器",
  "chat.group.membersWord": "会员",
  "chat.header.blocked": "被阻止",
  "chat.lastSeen": "上次出现 {0}",
  "chat.media.delete": "删除",
  "chat.media.deleteConfirmBody": "此操作无法撤消。",
  "chat.media.deleteConfirmTitle": "删除照片？",
  "chat.media.deleteForAll": "为大家删除",
  "chat.media.deleteForMe": "为我删除",
  "chat.media.download": "下载",
  "chat.media.forward": "向前",
  "chat.media.forwardTo": "转发至",
  "chat.media.share": "分享",
  "chat.mediaFailed": "无法加载",
  "chat.mediaRetry": "重试",
  "chat.myContacts": "我的联系人",
  "chat.nav.aria": "主导航",
  "chat.newCall.empty": "还没有联系方式。从“聊天”中的“+”添加一。",
  "chat.newCall.title": "新来电",
  "chat.newChat.title": "新聊天",
  "chat.newMessages": "新的",
  "chat.newMessagesBadge": "跳转至 {0} 新消息",
  "chat.online": "在线的",
  "chat.placeholder": "写留言...",
  "chat.presence.online": "在线的",
  "chat.preview.audio": "声音的",
  "chat.preview.image": "图像",
  "chat.preview.video": "视频",
  "chat.preview.voice": "语音留言",
  "chat.remove.title": "消除",
  "chat.replyingTo": "回复{0}",
  "chat.search.clear": "清除搜索",
  "chat.search.placeholder": "搜索聊天",
  "chat.tab.calls": "通话",
  "chat.tab.chats": "聊天记录",
  "chat.tab.contacts": "联系方式",
  "chat.tab.settings": "设置",
  "chat.toast.imageSaved": "图像保存到照片",
  "chat.toast.saveError": "保存错误",
  "chat.toast.saveFailed": "无法保存：{0}",
  "chat.toast.saved": "已保存",
  "chat.toast.updateTestflight": "将 TestFlight 更新为 1.0(10)+ 以保存。",
  "chat.toast.videoSaved": "视频保存到照片",
  "chat.tooltip.attach": "附加文件",
  "chat.tooltip.callAudio": "语音通话",
  "chat.tooltip.callVideo": "视频电话",
  "chat.tooltip.paste": "从剪贴板粘贴图像",
  "chat.tooltip.shareContact": "分享联系方式",
  "chat.tooltip.stickers": "贴纸",
  "chat.unblock": "解锁",
  "chat.unconfirmedBanner": "该用户已写信给您，但不在您的通讯录中。在您添加它们之前，根据您的隐私设置，他们将看不到您的照片和信息。",
  "chat.unread.aria": "未读消息",
  "chat.uploading": "……",
  "chat.videoCall.aria": "与 {0} 进行视频通话",
  "chat.videoCall.title": "视频电话",
  "chat.welcome.intro": "选择一个聊天即可开始使用端到端加密进行交谈。",
  "common.add": "添加",
  "common.back": "后退",
  "common.cancel": "取消",
  "common.close": "关闭",
  "common.confirm": "确认",
  "common.delete": "删除",
  "common.error.generic": "没有成功。再试一次。",
  "common.exit": "出口",
  "common.more": "更多的",
  "common.save": "节省",
  "common.tagline": "数字主权。",
  "contacts.alias.label": "别名",
  "contacts.alias.placeholder": "识别它们的别名",
  "contacts.blockBtn": "块接触",
  "contacts.confirmBlock.body": "块 {0} ？您将停止接收他们的消息和电话。",
  "contacts.confirmBlock.title": "块接触",
  "contacts.confirmUnblock.body": "解锁 {0} ？您将再次收到他们的消息。",
  "contacts.confirmUnblock.title": "取消阻止联系人",
  "contacts.edit.aria": "编辑",
  "contacts.edit.title": "编辑别名和注释",
  "contacts.note.label": "私人笔记",
  "contacts.notes.placeholder": "只有您可以看到它（在服务器上加密）。",
  "contacts.search.placeholder": "按别名或 IKOGNIT ID 搜索",
  "contacts.unblockBtn": "取消阻止联系人",
  "ctx.action.contacts": "我的联系人",
  "ctx.action.newChat": "新聊天",
  "ctx.action.newGroup": "新组",
  "ctx.aria": "IKO信息和导航",
  "ctx.liturgy.0": "服务员是瞎子。",
  "ctx.liturgy.1": "只有你在这里阅读。",
  "ctx.liturgy.2": "没有人知道你在这里。",
  "ctx.liturgy.3": "IKO 是只有您知道的秘密。",
  "ctx.liturgy.4": "您的隐私就是架构。",
  "ctx.modes.private": "个人IKO",
  "ctx.modes.storage": "驱动器",
  "ctx.modes.shared": "IKO",
  "ctx.nav.activateIko": "激活 IKO",
  "ctx.nav.backToIkognit": "返回IKOGNIT",
  "ctx.nav.changeIko": "开关IKO",
  "ctx.peer.message": "{0} 消息",
  "ctx.peer.messages": "{0} 消息",
  "ctx.peer.offline": "离线",
  "ctx.peer.online": "在线的",
  "ctx.section.actions": "行动",
  "ctx.section.conversation": "对话",
  "ctx.section.nav": "导航",
  "ctx.section.universe": "当前的IKO",
  "ctx.status.e2e": "端到端加密",
  "ctx.status.serverBlind": "盲服务器主动",
  "ctx.universe.personal": "您的个人空间",
  "demo.edit": "编辑",
  "error.blocked": "您已阻止该用户。在“设置”中取消阻止即可再次通话。",
  "error.cantAcceptCall": "无法接听电话：{0}",
  "error.cantPaste": "无法访问剪贴板。尝试使用附加按钮。",
  "error.cantStartCall": "无法开始通话：{0}",
  "error.clipboardUnsupported": "您的浏览器不允许读取剪贴板。使用 Ctrl+V 粘贴或使​​用附加按钮。",
  "error.expired": "会话已过期。再次登录。",
  "error.gone": "文件已过期。",
  "error.invalid": "无效数据。",
  "error.network": "没有连接到服务器。",
  "error.noImageInClipboard": "剪贴板中没有图像。",
  "error.notFound": "未找到资源。",
  "error.notInFreq": "{0} 尚未在此 IKO 中。通过另一个渠道要求他们激活它。",
  "error.push.activateFailed": "无法激活（{0}）。",
  "error.push.denied": "您拒绝了通知权限。",
  "error.push.iosNotStandalone": "要在 iPhone 上接收通知，请将 IKOGNIT 安装到主屏幕：点击共享 → 添加到主屏幕。",
  "error.push.iosTooOld": "您的 iOS 版本早于 16.4。更新它以接收通知。",
  "error.push.noPush": "此浏览器不支持推送通知。",
  "error.push.noSw": "此浏览器不支持 Service Worker。",
  "error.push.noVapid": "服务器未提供 VAPID 密钥。",
  "error.selfContact": "您无法添加自己。",
  "error.server": "服务器错误。请再试一次。",
  "explorer.filesNotProcessed": "未处理的文件",
  "holo.card.cipher": "密码",
  "holo.card.contacts": "联系方式",
  "holo.card.conversations": "对话",
  "holo.card.server": "服务器",
  "holo.claim.general": "您在 IKOGNIT 中的个人空间。您可以在这里与您的联系人交谈。",
  "holo.claim.inIko": "对于任何不知道它的人来说，这个IKO仍然是不可见的。",
  "holo.foot": "选择一个对话，激活 IKO 或创建一个新空间。",
  "holo.modes.general": "您的昵称 + 联系方式",
  "holo.modes.private": "个人IKO",
  "holo.modes.shared": "IKO",
  "join.loginToAccept": "登录/创建帐户",
  "iko.banner.exitAria": "离开 IKO，回到一般层面",
  "iko.liturgy.entering": "输入IKO",
  "iko.liturgy.returning": "返回",
  "iko.liturgy.toIkognit": "至 IKOGNIT",
  "iko.mode.private": "个人IKO",
  "iko.mode.shared": "IKO",
  "manifest.blindServer": "服务员是瞎子。",
  "manifest.keyWithYou": "钥匙与你同在。",
  "manifest.noAdsNoClouds": "没有广告。外面无云。",
  "manifest.noPublicProfiles": "没有公开的个人资料。",
  "manifest.onlyYouRead": "只有你在这里阅读。",
  "manifest.yourIkoYourSpaces": "你的 IKO 。你的空间。",
  "media.confirmDelete": "删除此项目？它无法恢复。",
  "media.delete": "删除",
  "media.download": "下载",
  "media.empty.audio": "这个IKO中还没有音频。",
  "media.empty.file": "此IKO中还没有文件。",
  "media.empty.photo": "这个IKO中还没有照片。",
  "media.empty.video": "该IKO中还没有视频。",
  "media.noPreview": "此文件类型没有预览。",
  "media.play": "玩",
  "media.upload.audio": "上传音频",
  "media.upload.file": "上传文件",
  "media.upload.photo": "上传照片",
  "media.upload.video": "上传视频",
  "media.uploadFailed": "无法上传文件。",
  "media.uploading": "正在上传...",
  "mobile.tb.ikoActivate": "激活IKO",
  "mobile.tb.ikoExit": "回到一般IKOGNIT",
  "modal.freq.activate": "激活",
  "modal.freq.deriving": "计算IKO...",
  "modal.freq.errCommon": "IKO 太常见了。选择一些独特的东西。",
  "modal.freq.errRepeat": "不要使用单个重复字符。",
  "modal.freq.errSeqAlpha": "避免字母顺序。",
  "modal.freq.errSeqNum": "避免明显的数字序列。",
  "modal.freq.errShort": "IKO 必须至少有 8 个字符。",
  "modal.freq.hint": "IKO 是您的某个IKO的精确IKO。  IKO：你会遇到写相同IKO的人。个人：你到达了一个你看不见的IKO，即使另一个人写了同样的东西。域名：它属于所有者，只有在他们注册您后您才能进入。",
  "modal.freq.placeholder": "写下你的IKO",
  "modal.freq.title": "激活IKO",
  "modal.freq.warn": "IKO不存储在任何地方。如果你忘记了它们，那个IKO对你来说就不复存在了。",
  "modal.group.create": "创建群组",
  "modal.group.hint": "选择一个姓名并从此 IKO 中的联系人中选择成员。",
  "modal.group.namePh": "团体名称",
  "modal.group.selected": "已选择 {0}",
  "modal.group.title": "新组",
  "modal.remember.confirm": "重复PIN",
  "modal.remember.errMismatch": "PIN 码不匹配。",
  "modal.remember.errShort": "PIN 必须至少有 4 个字符。",
  "modal.remember.hint": "您的会话、联系人、群组和消息将保存在此设备上，并使用只有您知道的 PIN 进行加密。当您重新打开应用程序时，您将输入 PIN 进行解锁。",
  "modal.remember.pin": "PIN",
  "modal.remember.title": "记住这个设备",
  "modal.remember.warn": "如果忘记 PIN ，保存的数据将无法恢复。您必须使用您的用户名和密码再次登录。",
  "modal.share.btn": "分享",
  "modal.share.empty": "此 IKO 中没有联系人",
  "modal.share.filter": "过滤联系人...",
  "modal.share.hint": "从列表中选择联系人或手动输入昵称。",
  "modal.share.manual": "或者手动刻痕",
  "modal.share.title": "分享联系方式",
  "notes.autosaveHint": "自动保存、加密，仅在此处。",
  "notes.confirmDelete": "删除此注释？它无法恢复。",
  "notes.contentPlaceholder": "写下您需要记住的任何内容...",
  "notes.delete": "删除注释",
  "notes.empty": "您在此IKO中还没有笔记。",
  "notes.emptyPreview": "（空的）",
  "notes.new": "新笔记",
  "notes.startHint": "这个IKO中没有笔记。创建第一个。",
  "notes.titlePlaceholder": "标题",
  "notes.untitled": "无题",
  "notes.yesterday": "昨天",
  "orb.copy.line1": "你的 IKO 。",
  "orb.copy.line2": "你的空间。",
  "orb.mod.audios": "音频",
  "orb.mod.chat": "聊天",
  "orb.mod.files": "文件",
  "orb.mod.notes": "笔记",
  "orb.mod.photos": "照片",
  "orb.mod.vault": "文件夹",
  "passwords.confirmDelete": "删除此条目？它无法恢复。",
  "passwords.copied": "已复制 ✓",
  "passwords.copy": "复制",
  "passwords.delete": "删除",
  "passwords.edit": "编辑",
  "passwords.empty": "您尚未在此IKO中保存任何条目。",
  "passwords.field.label": "姓名",
  "passwords.field.label.ph": "银行、账户、服务……",
  "passwords.field.notes": "笔记",
  "passwords.field.notes.ph": "任何有用的细节",
  "passwords.field.password": "密码",
  "passwords.field.password.ph": "您要保存的密码",
  "passwords.field.url": "URL",
  "passwords.field.username": "用户名",
  "passwords.field.username.ph": "电子邮件、别名、电话号码……",
  "passwords.hide": "隐藏",
  "passwords.new": "新条目",
  "passwords.save": "节省",
  "passwords.show": "展示",
  "passwords.startHint": "这个IKO中没有密码。创建第一个。",
  "passwords.untitled": "无题",
  "piko.cat.all": "全部",
  "piko.cat.audios": "音频",
  "piko.cat.cards": "牌",
  "piko.cat.custom": "金库",
  "piko.cat.agendas": "IKO 目录",
  "piko.cat.storage": "驱动器 与磁盘",
  "piko.cat.files": "文件",
  "piko.cat.identities": "身份",
  "piko.cat.notes": "笔记",
  "piko.cat.passwords": "密码",
  "piko.cat.photos": "照片",
  "piko.cat.sshkeys": "SSH 密钥",
  "piko.cat.videos": "视频",
  "piko.rail.aria": "个人 IKO 类别",
  "piko.rail.head": "个人的",
  "preview.audio": "🎙 音频",
  "preview.image": "📷 图片",
  "preview.video": "🎬 视频",
  "private.badge": "个人的",
  "private.mod.audios": "音频",
  "private.mod.audios.desc": "录音和语音笔记。",
  "private.mod.files": "文件",
  "private.mod.files.desc": "文档、表格、PDF。",
  "private.mod.iko": "我的IKO",
  "private.mod.iko.desc": "您保存的 IKO 已准备好激活。",
  "private.mod.notes": "笔记",
  "private.mod.notes.desc": "笔记、信件、日记。",
  "private.mod.photos": "照片",
  "private.mod.photos.desc": "您的私人画廊。",
  "private.mod.vault": "密码",
  "private.mod.vault.desc": "密码、卡、身份、SSH 密钥以及您需要的任何内容。",
  "private.mod.videos": "视频",
  "private.mod.videos.desc": "您的个人视频。",
  "private.module.coming": "即将推出。",
  "private.module.comingHint": "该模块很快就会推出。 IKO 加密货币已经可以使用了——很快你就可以在这里保存你需要的任何东西。",
  "private.welcome.hint": "选择一个部分开始。",
  "private.welcome.intro": "您位于无人能看到您的IKO处。即使另一个人写了相同的 IKO ，他们也会到达不同的IKO。在这里您可以保证您的物品安全。",
  "private.welcome.title": "您的个人 IKO",
  "push.btnDisable": "通知开启。单击以禁用。",
  "push.btnEnable": "通知关闭。单击以启用。",
  "push.btnOff": "通知关闭",
  "push.btnOn": "通知开启",
  "push.introBody": "出于隐私考虑，IKOGNIT 通知与其他消息应用程序的通知不同：",
  "push.introBullet1": "不包括消息内容。",
  "push.introBullet2": "不显示发件人的姓名或昵称。",
  "push.introBullet3": "您只会收到“新消息”提醒；打开应用程序以在您的设备上以加密方式读取它。",
  "push.introConfirm": "启用通知",
  "push.introTitle": "启用通知之前",
  "recovery.btn.back": "回去看看字",
  "recovery.btn.cleared": "剪贴板已清除",
  "recovery.btn.continue": "继续",
  "recovery.btn.copied": "已复制 · 在 {0} 秒内清除",
  "recovery.btn.copy": "复制",
  "recovery.btn.copyAria": "将恢复短语复制到剪贴板（将自动清除）",
  "recovery.btn.done": "我受够了",
  "recovery.btn.download": "下载",
  "recovery.btn.downloadAria": "将短语下载为文本文件",
  "recovery.btn.need3": "输入3个正确的单词",
  "recovery.btn.show": "显示单词",
  "recovery.intro": "如果您忘记密码或丢失设备，这些**24 个字**是恢复您的帐户和历史记录的唯一方法。 **将它们写在纸上并将它们保存在安全的地方。** IKOGNIT 没有人可以为您恢复它们。",
  "recovery.title": "您的恢复密钥",
  "recovery.verify.correct": "正确的",
  "recovery.verify.intro": "要确认您已保存密钥，请输入这些文字。如果不把它们做好，你就无法继续。",
  "recovery.verify.wordN": "字# {0}",
  "recovery.verify.wrong": "不正确",
  "recovery.warn": "**离线写下它们。**不要截屏。不要通过电子邮件或短信发送它们。谁拥有这些词，谁就控制了您的整个帐户。",
  "savediko.activate": "激活IKO",
  "savediko.add": "保存 IKO",
  "savediko.confirmDel": "删除？",
  "savediko.descLabel": "描述",
  "savediko.descPh": "稍后识别的描述",
  "savediko.empty": "您尚未保存任何 IKO。",
  "savediko.errDesc": "输入描述。",
  "savediko.errIko": "写下 IKO.",
  "savediko.formEdit": "编辑已保存的 IKO",
  "savediko.formNew": "保存 IKO",
  "savediko.intro": "把你不想记住的 IKO 放在这里。你只记住一个，其余的都住在里面。",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "写下 IKO",
  "settings.about.tech": "E2E 使用 NaCl 盒加密 (X25519)。  IKO：Argon2id 推导 + 确定性 HMAC。通过 PIN 使用 Argon2id 进行本地加密持久性。",
  "settings.about.title": "关于IKOGNIT",
  "settings.about.version": "版本",
  "settings.account.changePassword": "更改密码",
  "settings.account.confirmPw": "重复新的",
  "settings.account.currentPw": "当前密码",
  "settings.account.email": "电子邮件",
  "settings.account.emailPh": "电子邮件@example.com",
  "settings.account.errPwBad": "当前密码不正确。",
  "settings.account.errPwMismatch": "密码不匹配。",
  "settings.account.errPwShort": "新密码必须至少有 8 个字符。",
  "settings.account.newEmailPlaceholder": "新@email.com",
  "settings.account.newNickPlaceholder": "新尼克",
  "settings.account.newPw": "新密码（最少 8 个）",
  "settings.account.saving": "保存…",
  "settings.account.success": "密码已更新。",
  "settings.account.title": "帐户",
  "settings.addYourName": "添加您的名字",
  "settings.blocked.btn": "堵塞",
  "settings.blocked.empty": "没有人阻止你。",
  "settings.blocked.hint": "被阻止的用户无法向您发送消息。您也无法向他们发送消息。",
  "settings.blocked.placeholder": "尼克要阻止",
  "settings.blocked.title": "被阻止",
  "settings.blocked.unblock": "解锁",
  "settings.close": "关闭",
  "settings.editProfile": "编辑个人资料",
  "settings.language.hint": "选择界面语言。您的选择会保存在此设备上。",
  "settings.language.title": "语言",
  "settings.legal.cookies": "Cookie 政策",
  "settings.legal.hub": "法律中心",
  "settings.legal.minors": "未成年人政策",
  "settings.legal.notice": "法律声明",
  "settings.legal.privacy": "隐私政策",
  "settings.legal.report": "报告和审核",
  "settings.legal.rules": "社区规则",
  "settings.legal.terms": "条款和条件",
  "settings.legal.title": "法律信息",
  "settings.messages.title": "留言",
  "settings.messages.ttl": "默认过期时间",
  "settings.messages.ttlHint": "在此时间之后，您发送的消息将从服务器中删除。附加文件时您可以选择不同的值。",
  "settings.notif.hint": "浏览器推送通知仅针对 IKOGNIT 中的消息发出，一般不包含内容或发件人名称（按设计）。",
  "settings.notif.preview": "显示消息预览",
  "settings.notif.sound": "声音",
  "settings.notif.title": "通知",
  "settings.notif.vibration": "振动（移动）",
  "settings.privacy.hintFreq": "仅当您处于 {0} 时才覆盖这些规则。",
  "settings.privacy.hintGlobal": "配置默认情况下谁可以查看您的每项详细信息。",
  "settings.privacy.readReceipts": "阅读收据",
  "settings.privacy.readReceiptsHint": "如果禁用，则在您阅读消息时不会发送蓝色勾号。你也不会看到别人的。",
  "settings.privacy.showInfo": "谁看到我的信息/状态",
  "settings.privacy.showLastSeen": "谁看到我最后的连接",
  "settings.privacy.showOnline": "谁能看到我是否在线",
  "settings.privacy.showPhoto": "谁看到我的照片",
  "settings.privacy.title": "隐私",
  "settings.privacy.whoAdds": "谁可以将我添加到群组",
  "settings.profile.adjustPhoto": "调整你的图片",
  "settings.profile.changePhoto": "更改图片",
  "settings.profile.displayName": "显示名称",
  "settings.profile.displayNamePh.freq": "（继承自全局）",
  "settings.profile.displayNamePh.global": "（没有名字 - 将显示您的昵称）",
  "settings.profile.hintFreq": "当您处于 {0} 时，这些会覆盖全局配置文件。如果您没有在这里定义某些内容，它将继承自 global。",
  "settings.profile.hintGlobal": "这些值默认使用并在所有 IKO 中继承。",
  "settings.profile.info": "信息/状态",
  "settings.profile.infoPh": "你好，我用 IKOGNIT",
  "settings.profile.photo": "个人资料图片",
  "settings.profile.removeOverride": "删除 {0} 的覆盖",
  "settings.profile.removePhoto": "删除图片",
  "settings.profile.title": "轮廓",
  "settings.profile.warn": "当您在此 IKO 中与其他联系人互动时，更改将自动发送给他们。",
  "settings.scope.freq": "仅在{0}",
  "settings.scope.global": "全局（IKOGNIT）",
  "settings.session.remember": "记住激活的IKO",
  "settings.session.rememberHint": "如果启用，您激活的 IKO 将在侧栏中显示为快捷方式。任何看到您屏幕的人都可以知道您输入了哪个IKO，因此默认情况下它是禁用的。关闭它会删除已经保存的内容。",
  "settings.session.timeout": "不活动后关闭 IKO",
  "settings.session.timeoutHint": "如果您在这段时间内没有触摸应用程序，则活动的 IKO 将自动停用，并且您将返回到 IKOGNIT 。 “从不”会保留 IKO，直到您关闭应用程序。",
  "settings.session.title": "会议",
  "settings.tab.about": "ℹ 关于",
  "settings.tab.account": "🆔 账户",
  "settings.tab.blocked": "🚫 被阻止",
  "settings.tab.language": "🌐 语言",
  "settings.tab.legal": "合法的",
  "settings.tab.messages": "✉ 留言",
  "settings.tab.notifications": "🔔 通知",
  "settings.tab.privacy": "🔒 隐私",
  "settings.tab.profile": "👤 简介",
  "settings.tab.session": "⏱ 会议",
  "settings.title": "设置",
  "settings.vis.all": "每个人",
  "settings.vis.contacts": "我的联系人",
  "settings.vis.none": "没有人",
  "sidebar.addContact": "通过昵称添加联系人",
  "sidebar.exitFreq": "返回IKOGNIT",
  "sidebar.forget": "忘记设备",
  "sidebar.freq": "当前 IKO : {0}",
  "sidebar.freqPrivate": "个人 IKO : {0}",
  "sidebar.freqPsh": "域 IKO : {0}",
  "sidebar.freqPublic": "IKO : {0}",
  "sidebar.general": "IKOGNIT",
  "sidebar.logout": "登出",
  "sidebar.newGroup": "新组",
  "sidebar.notifications": "通知",
  "sidebar.remember": "记住设备",
  "sidebar.savedFreq.tooltip": "激活{0}",
  "sidebar.settings": "设置",
  "sidebar.tooltip.logout": "注销并擦除本地所有内容",
  "sidebar.tune": "激活IKO",
  "stickers.animals": "动物",
  "stickers.faces": "面孔",
  "stickers.food": "食物",
  "stickers.gestures": "手势",
  "stickers.hearts": "红心",
  "stickers.symbols": "符号",
  "timeout.15min": "15分钟",
  "timeout.30min": "30分钟",
  "timeout.5min": "5分钟",
  "timeout.never": "绝不",
  "toast.group": "{0} (群展)",
  "toast.newMessage": "新消息",
  "totp.copyCode": "复制代码",
  "totp.copySecret": "复制秘密",
  "totp.hideSecret": "隐藏秘密",
  "totp.invalid": "无效秘密",
  "totp.showSecret": "显示秘密",
  "ttl.12m": "12个月",
  "ttl.1d": "1天",
  "ttl.1h": "1小时",
  "ttl.1m": "1个月",
  "ttl.1w": "1周",
  "ttl.6m": "6个月",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "一般IKO",
  "uib.e2e.label": "盲服务器",
  "uib.e2e.title": "服务器无法读取您的内容 - 使用您的密钥进行 E2E 加密",
  "uib.exitLabel": "出口",
  "uib.exitTitle": "返回一般IKO",
  "uib.modes.private": "个人IKO",
  "uib.modes.shared": "IKO",
  "uib.nickTitle": "你的昵称",
  "uib.pseudoTitle": "您在此 IKO 中的笔名",
  "vault.addField": "添加字段",
  "vault.confirmDelete": "删除此项目？它无法恢复。",
  "vault.copied": "已复制 ✓",
  "vault.copy": "复制",
  "vault.delete": "删除",
  "vault.edit": "编辑",
  "vault.empty": "你的金库是空的。创建您的第一个项目。",
  "vault.field.address": "地址",
  "vault.field.birthdate": "出生日期",
  "vault.field.cardBrand": "品牌",
  "vault.field.cardCvv": "CVV",
  "vault.field.cardExpiry": "到期日（月/年）",
  "vault.field.cardHolder": "持卡人",
  "vault.field.cardNumber": "数字",
  "vault.field.city": "城市",
  "vault.field.country": "国家",
  "vault.field.dni": "身份证/社会安全号码",
  "vault.field.email": "电子邮件",
  "vault.field.firstname": "名",
  "vault.field.labelPh": "字段标签",
  "vault.field.lastname": "姓",
  "vault.field.name": "姓名",
  "vault.field.name.ph": "你怎么称呼它？",
  "vault.field.newField": "场地",
  "vault.field.password": "密码",
  "vault.field.phone": "电话",
  "vault.field.sshFingerprint": "指纹",
  "vault.field.sshHost": "主持人",
  "vault.field.sshPrivate": "私钥",
  "vault.field.sshPublic": "公钥",
  "vault.field.totp": "托普",
  "vault.field.url": "URL",
  "vault.field.username": "用户名",
  "vault.field.zip": "邮政编码",
  "vault.fieldPlural": "领域",
  "vault.fieldSingular": "场地",
  "vault.ft.date": "日期",
  "vault.ft.email": "电子邮件",
  "vault.ft.number": "数字",
  "vault.ft.password": "密码",
  "vault.ft.text": "文本",
  "vault.ft.textarea": "长文本",
  "vault.ft.url": "URL",
  "vault.hide": "隐藏",
  "vault.new": "新商品",
  "vault.noMatches": "没有项目与搜索匹配。",
  "vault.notes": "笔记",
  "vault.removeField": "删除该字段",
  "vault.save": "节省",
  "vault.search": "搜索…",
  "vault.sensitive": "敏感的",
  "vault.sensitiveHint": "敏感字段默认隐藏，可以复制到剪贴板。",
  "vault.show": "展示",
  "vault.startHint": "从左侧选择一个项目或创建一个新项目。",
  "vault.tpl.confirmDelete": "删除这个模板吗？由它创建的项目仍然存在。",
  "vault.tpl.edit": "编辑模板",
  "vault.tpl.empty": "您还没有模板。创建一个来定义您自己的项目类型。",
  "vault.tpl.manage": "管理模板",
  "vault.tpl.name": "模板名称",
  "vault.tpl.name.ph": "例如：加密钱包、酒店预订……",
  "vault.tpl.new": "新模板",
  "vault.tpl.title": "模板",
  "vault.tpl.yours": "您的模板",
  "vault.type.card": "卡片",
  "vault.type.custom": "风俗",
  "vault.type.identity": "身份",
  "vault.type.login": "登录",
  "vault.type.sshkey": "SSH 密钥",
  "vault.untitled": "无题",
  "web.footer.line": "线",
  "web.footer.palette": "调色板",
  "web.footer.send": "发送",
  "welcome.btnContacts": "添加联系人",
  "welcome.btnFreq": "激活IKO",
  "welcome.concept": "在 IKOGNIT 中，您可以与通过您的昵称识别的其他用户交谈。当你想要一个单独的空间时，你激活一个IKO并进入一个IKO。如果它是公开的，您会遇到那些也激活它的人。如果它是私人的，您将进入一个只有您存在的IKO。",
  "welcome.multidevice": "IKO 永远不会存储在任何地方。如果你忘记了 IKO ，它的IKO对你来说就不复存在了。",
  "welcome.step1": "激活IKO并与那些也知道它的人一起进入一个IKO。",
  "welcome.step2": "在 IKOGNIT 中，添加昵称作为联系人并开始交谈。",
  "welcome.step3": "激活个人 IKO 并打开一个专属于您的IKO，您可以在其中保存文件、照片、音频、视频、密码、笔记和信件。",
  "welcome.title": "欢迎来到IKOGNIT",

};

const ja: Catalog = {
  "auth.verify.notSent": "コードを送信できませんでした。アカウントは作成済みです。少ししてから「コードを再送」を押してください。",
  "lg.rotulo": "プライベートな空間をもつメッセンジャー",
  "lg.btn.entrar": "ログイン",
  "lg.eyebrow": "プライベートメッセンジャー · Itrion Software",
  "lg.h1a": "いつもどおりの会話。",
  "lg.h1b": "そして、呼び出したときだけ存在する場所。",
  "lg.lead1": "家族と、友人と、チームと話す。ほかのアプリと同じだ。違いは IKO を開いたときに始まる。中にいる者だけが知る秘密を書いて入る、自分だけの空間。",
  "lg.lead2": "呼び出さないかぎり、その空間はあなたの端末にない。スマホにも、タブレットにも、パソコンにもない。暗号化されているのではない。",
  "lg.lead2b": "そもそも存在しない。",
  "lg.pruebalo": "試してみる · 秘密を書いて、何が起きるか見る",
  "lg.panel.plano": "一般の面",
  "lg.demo.hilos": "家族=母：日曜はうちで夕食にする？=19:04|Marta=土曜の写真を送るね=17:52|チーム=Luis：じゃあ明日の九時に=昨日|Javi=はは信じられない=昨日",
  "lg.demo.mundos": "ふたりだけ~決めた場所に置いた？|うん。権利証とパスポート>~住まいの権利証.pdf=2.4 MB|プライベート写真=214|カード · 銀行=データ~~家のこと~賃貸契約書をここに置いておく>|あとルーターの鍵、いつも失くすでしょ~賃貸契約書.pdf=1.1 MB|身分証のコピー=2 件|家の鍵=データ~~自分のメモ~これは誰にも言っていない>|言う必要もない>~日記=48 件|写真=1,207|今年の帳簿=データ~~リスボンの案件~見積もりは 180 になる|ここにある。外には一部も出さない>~見積_v4.pdf=860 KB|連絡先=12|会社のカード=データ~~土曜の昼食~Marta にはまだ言わないで|大丈夫、ここでは誰にも知られない>~予約.pdf=120 KB|去年の写真=63|招待客リスト=データ",
  "lg.invocaLabel": "IKO を呼び出す",
  "lg.invocaPlaceholder": "どんな秘密でもいい、書いてみて",
  "lg.invocaBtn": "呼び出す",
  "lg.invocaHint": "言葉ごとに別の空間へ行く。別の言葉も試してみて。",
  "lg.estela.vacio": "何でもいいので書いて。これはデモです。",
  "lg.estela.primero": "現れた。中にいるあいだだけ存在する。",
  "lg.estela.otro": "別の秘密、別の空間。互いのことは知らない。",
  "lg.estela.salida": "消えた。端末に痕跡は残らない。別の言葉も試してみて。",
  "lg.ikoActivo": "IKO 起動中",
  "lg.nadaEnDispositivo": "これらは端末上にない",
  "lg.salirIko": "IKO を出る",
  "lg.planos.h2a": "見えている面がひとつ。",
  "lg.planos.h2b": "その下に、あなたが呼び出す面。",
  "lg.planos.lead": "「その IKO」というものはない。あるのは、あなたが開いたぶんだけ。家のこと用、仕事用、ふたりだけが知るもの、誰にも話していないもの。秘密ごとに自分の IKO へ行き、どれも他を知らない。",
  "lg.planos.unoRotulo": "一般の面 · ひとつ",
  "lg.planos.unoH3": "みんなと話す場所",
  "lg.planos.unoP": "会話、グループ、通話、写真、ファイル。すべてエンドツーエンドで暗号化。メッセンジャーに期待することを、きちんと。いつものトークはここに住み、いつもどおりに動く。",
  "lg.planos.nRotulo": "IKO · いくつでも",
  "lg.planos.nH3": "ほかの誰も届かない場所",
  "lg.planos.nP": "秘密を書くと、それに対応する空間が現れる。中には会話とあなたのものが入る。出ると、痕跡を残さず端末から消える。一覧もなければ数もなく、いくつ持っているかも、ひとつでも存在するかも、誰にもわからない。",
  "lg.planos.chips": "家のこと|仕事|ふたりだけが知っていること|あなただけのもの|一度開いてそれきりのもの|明日決めるもの",
  "lg.forense.h2a": "端末の上で暗号化されているのではない。",
  "lg.forense.h2b": "端末の上に存在しない。",
  "lg.forense.lead": "ほかのアプリはメッセージを端末に置いて暗号化する。誰かが端末を持ち去れば、プライバシーはその暗号が十分に持ちこたえるかどうかにかかる。ここには持ちこたえるべきものがない。IKO の中にあるものは、どの端末にも書き込まれない。呼び出し、使い、去る。",
  "lg.forense.multi": "どこでも同じだ。スマホ、タブレット、家のパソコン、仕事のノート、Windows、Mac、あるいは自分のものではない場所のブラウザ。好きなところから入り、出れば、その場所はまたあなたを何も知らない。",
  "lg.forense.caption": "あなたの端末のどれかを調べた者が見つけるもの",
  "lg.forense.filas": "IKO のメッセージ=0|IKO のファイルと写真=0|保存された IKO の秘密=0|IKO を収めたデータベース=存在しない|IKO が開かれた痕跡=なし|IKO をいくつ持っているか=判定不能",
  "lg.escenas.h2": "本当に心配なこと。",
  "lg.escenas.filas": "「スマホをなくした。」=プライバシーは一緒に消えていない。IKO の中にあったものは、その端末に一度も置かれていない。取り戻すものも、恐れるものもない。ほかのどの端末からでも呼び出せば、すべて元のままだ。~「ノートパソコンを持っていかれた。」=いつもの会話は見えるだろう。ほかのアプリでも見えるのと同じものだ。それ以外は、中身も、名前も、存在する気配すら見えない。~「パソコンを調べられた。」=フォレンジック解析はディスクに書かれたものを、暗号化され削除されていても取り出す。ここには取り出すべきものが書かれていない。答えは「復号できない」ではなく「何もない」だ。タブレットでも、スマホでも、ある午後に使ったブラウザでも同じ。",
  "lg.ciego.h2": "私たちにも。サーバーを預かる側にも。",
  "lg.ciego.p1": "サーバーは、読めないものを保管している。あなたの秘密は持っていないし、持ったこともなく、どこにも複製は存在しない。IKO の中身の引き渡しを拒んでいるのではない。持っていないし、持ちようがないのだ。機械を置いている会社も、それを手に入れた者も同じだ。",
  "lg.ciego.p2": "それには代償があり、はっきり言っておく。秘密をなくせば、返せる者は誰もいない。ほかの誰も入れない理由が、そのまま、私たちにもあなたを入れてあげられない理由だ。",
  "lg.guardas": "家族の写真|人に見せないメモ|カードと口座の情報|パスワード|書類|あなたたちだけの会話",
  "lg.nombre.esta": "ある",
  "lg.nombre.noEsta": "ない",
  "lg.nombre.h2": "名前の由来。",
  "lg.nombre.p": "スワヒリ語で iko は「ある」、haiko は「ない」。IKO は呼び出しているあいだだけある。それ以外の時間は——つまりほとんどの時間は——ない。端末の上にも、誰かの目の前にも、疑いとしてすら。",
  "lg.cierre.h2": "話しはじめよう。",
  "lg.cierre.p": "ほかのメッセンジャーと同じように使える。スマホでも、タブレットでも、パソコンでも。IKO は、必要になった日にそこにある。",
  "lg.cierre.btnCrear": "アカウントを作る",
  "lg.cierre.btnEntrar": "アカウントを持っている",
  "lg.cierre.pago": "IKOGNIT は有料の製品です。広告も、広告用のプロフィールもなく、こちらに何の複製もありません。アプリがあなたにとって価値があることで成り立っていて、あなたが中で話す内容で成り立っているのではありません。",
  "lg.pie.ciego": "見えないサーバー",
  "auth.hola": "おかえりなさい。",
  "auth.queEs": "IKOGNIT とは？",
  "auth.btn.backToUnlock": "戻る",
  "auth.btn.createIdentity": "アカウントを作成する",
  "auth.btn.forget": "このデバイスを忘れてください",
  "auth.btn.processing": "処理…",
  "auth.btn.unlock": "サインイン",
  "auth.btn.unlocking": "サインイン中…",
  "auth.btn.useOther": "別のアカウントを使用する",
  "auth.confirmForget": "この端末はあなたを認識しなくなる。保存されたアカウントとキャッシュは消える。再び入るにはパスワードが必要になる。",
  "auth.confirmForget.warning": "24語の復元フレーズを控えていなければ、後戻りはできない。誰も返してはくれない。",
  "invite.welcomeSub": "メッセージと、自分の場所。ここに置いたものはあなたの名義になる。アカウントを作れば、つながる。",
  "auth.reset.warnNewIdentity": "アカウントはあなたのままだが、メールでの復旧は新しい身元を与える。以前のメッセージはもう読めなくなる。24語の復元フレーズが手元にあるなら、そちらを使うほうがいい。",
  "recover.intro": "ニックネームかメールと、アカウント作成時に渡された24語の復元ワードを入力する。そのあと新しいパスワードを決める。",
  "auth.error.badCreds": "ニックネーム/メールアドレスまたはパスワードが間違っています。",
  "auth.error.badPin": "キーが間違っています。",
  "auth.error.cantConnect": "サーバーに接続できませんでした。",
  "auth.error.legalRequired": "アカウントを作成するには、法的条件に同意し、年齢を確認する必要があります。",
  "auth.error.userNotFound": "アカウントが見つかりません。",
  "auth.field.devicePin": "デバイスPIN",
  "auth.field.emailPlaceholder": "you@email.com",
  "auth.field.nickPlaceholder": "例えばファス1",
  "auth.field.password": "パスワード",
  "auth.footnote": "持ち主が、その責めを負う。\nパスワードを失えば、\n掛け合う相手はいない。",
  "auth.legal.accept": "<a href='https://ikognit.org/legal/en/terms.html' target='_blank' rel='noopener'> 規約 </a> 、 <a href='https://ikognit.org/legal/en/privacy.html' target='_blank' rel='noopener'> プライバシー ポリシー </a> 、および <a href='https://ikognit.org/legal/en/community-rules.html' target='_blank' rel='noopener'> コミュニティ ルール </a> を読み、同意します。",
  "auth.legal.age": "IKOGNIT を使用するために国の法律で求められる最低年齢を満たしていることを確認します。",
  "auth.loading": "読み込み中…",
  "auth.savedSession": "この端末はすでに持ち主を知っている。",
  "auth.locked": "放置したので消えた。もう一度入る。",
  "auth.sessionExpired": "セッションは消えた。もう一度入る。",
  "auth.subLogin": "入るのは一般の面、いつもの会話です。IKO はここでは呼び出しません。必要になったとき、中で呼び出します。",
  "auth.subRegister": "アカウントはあなたの名義になる。ニックネームは他人から見えるあなた。メールはアクセスの回復と通知にだけ使う。",
  "auth.tab.login": "サインイン",
  "auth.tab.register": "新しいアカウント",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "スワヒリ語で iko は「ある」。haiko は「ない」。",
  "billing.manage": "管理",
  "billing.needsUpgrade": "ティアのシート制限に達しました。アップグレードして座席を追加してください。",
  "billing.portal": "支払いの管理",
  "billing.renews": "更新します",
  "billing.seats": "席",
  "billing.title": "請求する",
  "billing.upgradeTo": "アップグレード層 ( {price} /seat)",
  "bubble.contact.label": "IKOGNIT 連絡先",
  "bubble.edit": "編集",
  "bubble.edited": "編集済み",
  "bubble.forward": "フォワード",
  "bubble.media.decrypting": "復号中…",
  "bubble.media.failed": "ファイルを復号化できませんでした。",
  "bubble.reply": "返事",
  "bubble.tick.delivered": "{0} を納品しました",
  "bubble.tick.read": "{0} を読み取ります",
  "bubble.tick.sent": "送信済み",
  "call.accept": "受け入れる",
  "call.audioOut": "音声出力",
  "call.audioOut.auto": "自動",
  "call.calling": "通話中…",
  "call.camera": "カメラ",
  "call.connecting": "接続中…",
  "call.ending": "エンディング…",
  "call.error.notInFreq": "電話をかけるには、 IKO 内にいる必要があります。",
  "call.hangup": "電話を切る",
  "call.incoming.audio": "着信",
  "call.incoming.video": "ビデオ通話の着信",
  "call.mic": "マイクロフォン",
  "call.reject": "拒否する",
  "ccb.clock.title": "現地時間",
  "ccb.identity.title": "セッション: @ {0}",
  "ccb.leave.aria": "IKO を終了します",
  "ccb.leave.title": "IKO を終了します (IKOGNIT に戻ります)",
  "ccb.modes.personalPrefix": "個人的 ・",
  "ccb.settings.aria": "設定",
  "ccb.settings.title": "設定・プロフィール、テーマ、セッション",
  "ccb.tag.cipher.title": "対称暗号が有効です",
  "ccb.tag.srv.title": "サーバーがコンテンツを読み取れません",
  "ccb.tag.unread.title": "未読メッセージ",
  "ccb.universe.activate": "IKOをアクティブにする",
  "ccb.universe.changeOrExit": "IKO を切り替えるか終了します",
  "chat.action.call": "電話",
  "chat.action.videoCall": "ビデオ通話",
  "chat.attach.camera": "カメラ",
  "chat.attach.file": "ファイルを添付する",
  "chat.attach.label": "添付する",
  "chat.attach.voice": "声",
  "chat.attachPending": "保留中の添付ファイル",
  "chat.backToIkognit.title": "一般 IKOGNIT に戻る",
  "chat.blocked.text": "{0} をブロックしました。メッセージの送信や通話はできません。",
  "chat.btn.send": "送信",
  "chat.call.title": "電話",
  "chat.calls.callContact": "連絡先に電話をかける",
  "chat.calls.empty": "まだ電話はありません。連絡先とのチャットから開始します。",
  "chat.calls.historySoon": "通話履歴はすぐに利用できるようになります。",
  "chat.calls.title": "電話",
  "chat.cancel.title": "キャンセル",
  "chat.composer.placeholder": "メッセージを入力してください...",
  "chat.confirmContact": "連絡先に追加",
  "chat.contact.badgeBlocked": "ブロックされました",
  "chat.contact.badgePending": "未確認",
  "chat.contacts.empty": "まだ連絡先がありません。",
  "chat.contacts.noResults": "結果はありません。",
  "chat.delete.aria": "消去",
  "chat.delete.title": "消去",
  "chat.deleteConv.forAll": "全員に削除",
  "chat.deleteConv.forMe": "私のために削除してください",
  "chat.deleteConv.hint": "「自分用」では、コピー (すべてのデバイス) が削除されます。 「全員向け」では、連絡先に自分側で削除するよう依頼することもできます。",
  "chat.deleteConv.titleMany": "{0} の会話を削除します",
  "chat.deleteConv.titleOne": "会話を削除する",
  "chat.editPlaceholder": "メッセージを編集してください…",
  "chat.editing": "メッセージの編集",
  "chat.empty": "連絡先を選択または追加します",
  "chat.error.userBlocked": "このユーザーをブロックしました。",
  "chat.filter.all": "全て",
  "chat.filter.groups": "グループ",
  "chat.filter.unread": "未読",
  "chat.filters.aria": "チャットフィルター",
  "chat.group.membersWord": "メンバー",
  "chat.header.blocked": "ブロックされました",
  "chat.lastSeen": "最後に見た {0}",
  "chat.media.delete": "消去",
  "chat.media.deleteConfirmBody": "この操作は元に戻すことができません。",
  "chat.media.deleteConfirmTitle": "写真を削除しますか?",
  "chat.media.deleteForAll": "全員に削除",
  "chat.media.deleteForMe": "私のために削除してください",
  "chat.media.download": "ダウンロード",
  "chat.media.forward": "フォワード",
  "chat.media.forwardTo": "に転送",
  "chat.media.share": "共有",
  "chat.mediaFailed": "ロードできませんでした",
  "chat.mediaRetry": "リトライ",
  "chat.myContacts": "私の連絡先",
  "chat.nav.aria": "メインナビゲーション",
  "chat.newCall.empty": "まだ連絡先がありません。チャットの+から追加してください。",
  "chat.newCall.title": "新しい通話",
  "chat.newChat.title": "新しいチャット",
  "chat.newMessages": "新しい",
  "chat.newMessagesBadge": "{0} の新着メッセージにジャンプします",
  "chat.online": "オンライン",
  "chat.placeholder": "メッセージを書いて…",
  "chat.presence.online": "オンライン",
  "chat.preview.audio": "オーディオ",
  "chat.preview.image": "画像",
  "chat.preview.video": "ビデオ",
  "chat.preview.voice": "音声メッセージ",
  "chat.remove.title": "取り除く",
  "chat.replyingTo": "{0}に返信します",
  "chat.search.clear": "検索をクリア",
  "chat.search.placeholder": "チャットを検索",
  "chat.tab.calls": "電話",
  "chat.tab.chats": "チャット",
  "chat.tab.contacts": "連絡先",
  "chat.tab.settings": "設定",
  "chat.toast.imageSaved": "画像を写真に保存",
  "chat.toast.saveError": "保存エラー",
  "chat.toast.saveFailed": "保存できませんでした: {0}",
  "chat.toast.saved": "保存されました",
  "chat.toast.updateTestflight": "TestFlight を 1.0(10)+ に更新して保存します。",
  "chat.toast.videoSaved": "ビデオを写真に保存",
  "chat.tooltip.attach": "ファイルを添付する",
  "chat.tooltip.callAudio": "音声通話",
  "chat.tooltip.callVideo": "ビデオ通話",
  "chat.tooltip.paste": "クリップボードから画像を貼り付ける",
  "chat.tooltip.shareContact": "連絡先を共有する",
  "chat.tooltip.stickers": "ステッカー",
  "chat.unblock": "ブロックを解除する",
  "chat.unconfirmedBanner": "このユーザーはあなたに手紙を書いていますが、あなたの連絡先には登録されていません。追加するまで、プライバシー設定に従って、あなたの写真と情報はそれらのユーザーに表示されません。",
  "chat.unread.aria": "未読メッセージ",
  "chat.uploading": "…",
  "chat.videoCall.aria": "{0} とのビデオ通話",
  "chat.videoCall.title": "ビデオ通話",
  "chat.welcome.intro": "チャットを選択して、エンドツーエンド暗号化を使用した会話を開始します。",
  "common.add": "追加",
  "common.back": "戻る",
  "common.cancel": "キャンセル",
  "common.close": "近い",
  "common.confirm": "確認する",
  "common.delete": "消去",
  "common.error.generic": "うまくいかなかった。もう一度試す。",
  "common.exit": "出口",
  "common.more": "もっと",
  "common.save": "保存",
  "common.tagline": "デジタル主権。",
  "contacts.alias.label": "エイリアス",
  "contacts.alias.placeholder": "それらを認識するためのエイリアス",
  "contacts.blockBtn": "連絡先をブロックする",
  "contacts.confirmBlock.body": "ブロック {0} ?彼らのメッセージや電話の受信が停止されます。",
  "contacts.confirmBlock.title": "連絡先をブロックする",
  "contacts.confirmUnblock.body": "{0} のブロックを解除しますか?彼らからのメッセージを再度受け取ることになります。",
  "contacts.confirmUnblock.title": "連絡先のブロックを解除する",
  "contacts.edit.aria": "編集",
  "contacts.edit.title": "エイリアスとメモを編集する",
  "contacts.note.label": "私的なメモ",
  "contacts.notes.placeholder": "あなただけがそれを見ることができます（サーバー上で暗号化されています）。",
  "contacts.search.placeholder": "エイリアスまたはIKOGNIT IDで検索",
  "contacts.unblockBtn": "連絡先のブロックを解除する",
  "ctx.action.contacts": "私の連絡先",
  "ctx.action.newChat": "新しいチャット",
  "ctx.action.newGroup": "新しいグループ",
  "ctx.aria": "IKOの情報とナビゲーション",
  "ctx.liturgy.0": "サーバーは盲目です。",
  "ctx.liturgy.1": "ここを読んでいるのはあなただけです。",
  "ctx.liturgy.2": "あなたがここにいることを誰も知りません。",
  "ctx.liturgy.3": "IKO はあなただけが知っている秘密です。",
  "ctx.liturgy.4": "あなたのプライバシーはアーキテクチャです。",
  "ctx.modes.private": "個人 IKO",
  "ctx.modes.storage": "ドライブ",
  "ctx.modes.shared": "IKO",
  "ctx.nav.activateIko": "IKOをアクティブにする",
  "ctx.nav.backToIkognit": "IKOGNIT に戻る",
  "ctx.nav.changeIko": "スイッチIKO",
  "ctx.peer.message": "{0} メッセージ",
  "ctx.peer.messages": "{0} メッセージ",
  "ctx.peer.offline": "オフライン",
  "ctx.peer.online": "オンライン",
  "ctx.section.actions": "アクション",
  "ctx.section.conversation": "会話",
  "ctx.section.nav": "ナビゲーション",
  "ctx.section.universe": "現在のIKO",
  "ctx.status.e2e": "エンドツーエンドの暗号化",
  "ctx.status.serverBlind": "ブラインドサーバーがアクティブです",
  "ctx.universe.personal": "あなたのパーソナルスペース",
  "demo.edit": "編集",
  "error.blocked": "このユーザーをブロックしました。再度通話するには、設定でブロックを解除してください。",
  "error.cantAcceptCall": "通話に応答できませんでした: {0}",
  "error.cantPaste": "クリップボードにアクセスできませんでした。添付ボタンを使用してみてください。",
  "error.cantStartCall": "通話を開始できませんでした: {0}",
  "error.clipboardUnsupported": "お使いのブラウザではクリップボードの読み取りが許可されていません。 Ctrl+V で貼り付けるか、添付ボタンを使用します。",
  "error.expired": "セッションの有効期限が切れました。再度サインインします。",
  "error.gone": "ファイルの有効期限が切れています。",
  "error.invalid": "無効なデータです。",
  "error.network": "サーバーに接続されていません。",
  "error.noImageInClipboard": "クリップボードに画像がありません。",
  "error.notFound": "リソースが見つかりません。",
  "error.notInFreq": "{0} はまだこの IKO にありません。別のチャネルを通じてアクティブ化するよう依頼してください。",
  "error.push.activateFailed": "アクティブ化できませんでした ( {0} )。",
  "error.push.denied": "通知の許可を拒否しました。",
  "error.push.iosNotStandalone": "iPhone で通知を受け取るには、IKOGNIT をホーム画面にインストールします。[共有] → [ホーム画面に追加] をタップします。",
  "error.push.iosTooOld": "お使いの iOS は 16.4 より古いです。通知を受信できるように更新してください。",
  "error.push.noPush": "このブラウザはプッシュ通知をサポートしていません。",
  "error.push.noSw": "このブラウザは Service Worker をサポートしていません。",
  "error.push.noVapid": "サーバーは VAPID キーを提供しませんでした。",
  "error.selfContact": "自分自身を追加することはできません。",
  "error.server": "サーバーエラー。もう一度試してください。",
  "explorer.filesNotProcessed": "未処理のファイル",
  "holo.card.cipher": "暗号",
  "holo.card.contacts": "連絡先",
  "holo.card.conversations": "会話",
  "holo.card.server": "サーバ",
  "holo.claim.general": "IKOGNIT のあなたの個人的なスペース。ここで連絡先と会話します。",
  "holo.claim.inIko": "この IKO は知らない人には見えないままです。",
  "holo.foot": "会話を選択するか、 IKO をアクティブにするか、新しいスペースを作成します。",
  "holo.modes.general": "あなたのニック + 連絡先",
  "holo.modes.private": "個人 IKO",
  "holo.modes.shared": "IKO",
  "join.loginToAccept": "サインイン/アカウントの作成",
  "iko.banner.exitAria": "IKO を出て一般の面に戻る",
  "iko.liturgy.entering": "IKOを入力します",
  "iko.liturgy.returning": "戻る",
  "iko.liturgy.toIkognit": "IKOGNITへ",
  "iko.mode.private": "個人 IKO",
  "iko.mode.shared": "IKO",
  "manifest.blindServer": "サーバーは盲目です。",
  "manifest.keyWithYou": "鍵はあなたとともにあります。",
  "manifest.noAdsNoClouds": "広告はありません。外には雲がありません。",
  "manifest.noPublicProfiles": "公開プロフィールはありません。",
  "manifest.onlyYouRead": "ここを読んでいるのはあなただけです。",
  "manifest.yourIkoYourSpaces": "あなたの IKO 。あなたのスペース。",
  "media.confirmDelete": "この項目を削除しますか?回復することはできません。",
  "media.delete": "消去",
  "media.download": "ダウンロード",
  "media.empty.audio": "このIKOにはまだ音声がありません。",
  "media.empty.file": "このIKOにはまだファイルがありません。",
  "media.empty.photo": "このIKOにはまだ写真がありません。",
  "media.empty.video": "このIKOにはまだビデオがありません。",
  "media.noPreview": "このファイルタイプにはプレビューがありません。",
  "media.play": "遊ぶ",
  "media.upload.audio": "音声をアップロードする",
  "media.upload.file": "ファイルをアップロードする",
  "media.upload.photo": "写真をアップロードする",
  "media.upload.video": "ビデオをアップロードする",
  "media.uploadFailed": "ファイルをアップロードできませんでした。",
  "media.uploading": "アップロード中…",
  "mobile.tb.ikoActivate": "IKOをアクティブにする",
  "mobile.tb.ikoExit": "一般 IKOGNIT に戻る",
  "modal.freq.activate": "活性化",
  "modal.freq.deriving": "IKOを計算中…",
  "modal.freq.errCommon": "IKO は一般的すぎます。ユニークなものを選んでください。",
  "modal.freq.errRepeat": "単一の文字を繰り返し使用しないでください。",
  "modal.freq.errSeqAlpha": "アルファベットの並びは避けてください。",
  "modal.freq.errSeqNum": "明らかな数値シーケンスは避けてください。",
  "modal.freq.errShort": "IKO には少なくとも 8 文字が必要です。",
  "modal.freq.hint": "IKO は、IKOの 1 つの正確なIKOです。  IKO : 同じIKOを書き込んだ人に出会えます。個人的: たとえ他の人が同じものを書いていたとしても、あなたは目に見えない世界に到達します。ドメイン: 所有者に属し、所有者が登録した場合にのみアクセスできます。",
  "modal.freq.placeholder": "IKOを書いてください",
  "modal.freq.title": "IKOをアクティブにする",
  "modal.freq.warn": "IKOはどこにも保存されません。あなたがそれらを忘れてしまったら、そのIKOはあなたにとって存在しなくなります。",
  "modal.group.create": "グループの作成",
  "modal.group.hint": "名前を選択し、この IKO の連絡先からメンバーを選択します。",
  "modal.group.namePh": "グループ名",
  "modal.group.selected": "{0}を選択しました",
  "modal.group.title": "新しいグループ",
  "modal.remember.confirm": "PIN を繰り返します",
  "modal.remember.errMismatch": "PIN が一致しません。",
  "modal.remember.errShort": "PIN には少なくとも 4 文字が必要です。",
  "modal.remember.hint": "あなたのセッション、連絡先、グループ、メッセージは、あなただけが知っている PIN で暗号化されてこのデバイスに保存されます。アプリを再度開くと、PIN を入力してロックを解除します。",
  "modal.remember.pin": "PIN",
  "modal.remember.title": "このデバイスを覚えておいてください",
  "modal.remember.warn": "PIN を忘れた場合、保存したデータは復元できません。ユーザー名とパスワードを使用して再度サインインする必要があります。",
  "modal.share.btn": "共有",
  "modal.share.empty": "この IKO には連絡先がありません",
  "modal.share.filter": "連絡先をフィルタリング…",
  "modal.share.hint": "リストから連絡先を選択するか、ニックネームを手動で入力します。",
  "modal.share.manual": "または手動ニックネーム",
  "modal.share.title": "連絡先を共有する",
  "notes.autosaveHint": "ここにのみ、自動的に暗号化されて保存されます。",
  "notes.confirmDelete": "このメモを削除しますか?回復することはできません。",
  "notes.contentPlaceholder": "覚えておきたいことは何でも書いてください…",
  "notes.delete": "メモの削除",
  "notes.empty": "このIKOにはまだメモがありません。",
  "notes.emptyPreview": "（空の）",
  "notes.new": "新しいメモ",
  "notes.startHint": "このIKOにはメモはありません。最初のものを作成します。",
  "notes.titlePlaceholder": "タイトル",
  "notes.untitled": "無題",
  "notes.yesterday": "昨日",
  "orb.copy.line1": "あなたの IKO 。",
  "orb.copy.line2": "あなたのスペース。",
  "orb.mod.audios": "オーディオ",
  "orb.mod.chat": "チャット",
  "orb.mod.files": "ファイル",
  "orb.mod.notes": "注意事項",
  "orb.mod.photos": "写真",
  "orb.mod.vault": "フォルダ",
  "passwords.confirmDelete": "このエントリを削除しますか?回復することはできません。",
  "passwords.copied": "コピーしました ✓",
  "passwords.copy": "コピー",
  "passwords.delete": "消去",
  "passwords.edit": "編集",
  "passwords.empty": "このIKOにはまだエントリを保存していません。",
  "passwords.field.label": "名前",
  "passwords.field.label.ph": "銀行、口座、サービス…",
  "passwords.field.notes": "注意事項",
  "passwords.field.notes.ph": "役立つ詳細",
  "passwords.field.password": "パスワード",
  "passwords.field.password.ph": "保存したいパスワード",
  "passwords.field.url": "URL",
  "passwords.field.username": "ユーザー名",
  "passwords.field.username.ph": "メールアドレス、エイリアス、番号…",
  "passwords.hide": "隠れる",
  "passwords.new": "新規エントリー",
  "passwords.save": "保存",
  "passwords.show": "見せる",
  "passwords.startHint": "この世界にはパスワードはありません。最初のものを作成します。",
  "passwords.untitled": "無題",
  "piko.cat.all": "全て",
  "piko.cat.audios": "オーディオ",
  "piko.cat.cards": "カード",
  "piko.cat.custom": "ボールト",
  "piko.cat.agendas": "IKOディレクトリ",
  "piko.cat.storage": "ドライブとディスク",
  "piko.cat.files": "ファイル",
  "piko.cat.identities": "アイデンティティ",
  "piko.cat.notes": "注意事項",
  "piko.cat.passwords": "パスワード",
  "piko.cat.photos": "写真",
  "piko.cat.sshkeys": "SSHキー",
  "piko.cat.videos": "動画",
  "piko.rail.aria": "個人の IKO カテゴリ",
  "piko.rail.head": "個人的",
  "preview.audio": "🎙 オーディオ",
  "preview.image": "📷画像",
  "preview.video": "🎬 ビデオ",
  "private.badge": "個人的",
  "private.mod.audios": "オーディオ",
  "private.mod.audios.desc": "録音と音声メモ。",
  "private.mod.files": "ファイル",
  "private.mod.files.desc": "ドキュメント、シート、PDF。",
  "private.mod.iko": "私のIKO",
  "private.mod.iko.desc": "保存した IKO をアクティブ化する準備ができました。",
  "private.mod.notes": "注意事項",
  "private.mod.notes.desc": "メモ、手紙、日記。",
  "private.mod.photos": "写真",
  "private.mod.photos.desc": "あなたのプライベートギャラリー。",
  "private.mod.vault": "パスワード",
  "private.mod.vault.desc": "パスワード、カード、ID、SSH キーなど、必要なものはすべて揃っています。",
  "private.mod.videos": "動画",
  "private.mod.videos.desc": "あなたの個人的なビデオ。",
  "private.module.coming": "近日公開。",
  "private.module.comingHint": "このモジュールは間もなく利用可能になる予定です。 IKO の暗号化はすでに機能しています。間もなく、必要なものはすべてここに保存できるようになります。",
  "private.welcome.hint": "開始するセクションを選択してください。",
  "private.welcome.intro": "あなたは誰にも見られないIKOにいます。たとえ別の人が同じ IKO を書いたとしても、異なる世界に到達することになります。ここで持ち物を安全に保管します。",
  "private.welcome.title": "あなたの個人的な IKO",
  "push.btnDisable": "通知オン。クリックして無効にします。",
  "push.btnEnable": "通知はオフです。クリックして有効にします。",
  "push.btnOff": "通知オフ",
  "push.btnOn": "通知オン",
  "push.introBody": "プライバシーのため、IKOGNIT 通知は他のメッセージング アプリの通知とは異なります。",
  "push.introBullet1": "メッセージ内容は含まれません。",
  "push.introBullet2": "送信者の名前やニックネームは表示されません。",
  "push.introBullet3": "「新しいメッセージ」アラートのみを受け取ります。アプリを開いて、デバイス上で暗号化されたデータを読み取ります。",
  "push.introConfirm": "通知を有効にする",
  "push.introTitle": "通知を有効にする前に",
  "recovery.btn.back": "戻って単語を確認してください",
  "recovery.btn.cleared": "クリップボードがクリアされました",
  "recovery.btn.continue": "続く",
  "recovery.btn.copied": "コピーされました · {0} 秒で消去されます",
  "recovery.btn.copy": "コピー",
  "recovery.btn.copyAria": "リカバリフレーズをクリップボードにコピーします (自動消去されます)",
  "recovery.btn.done": "私は終わった",
  "recovery.btn.download": "ダウンロード",
  "recovery.btn.downloadAria": "フレーズをテキストファイルとしてダウンロード",
  "recovery.btn.need3": "正しい単語を 3 つ入力してください",
  "recovery.btn.show": "単語を表示する",
  "recovery.intro": "これらの**24の単語**は、パスワードを忘れた場合やデバイスを紛失した場合にアカウントと履歴を回復する唯一の方法です。 **それらを紙に書いて安全な場所に保管してください。** IKOGNIT の誰もそれらを回復することはできません。",
  "recovery.title": "回復キー",
  "recovery.verify.correct": "正しい",
  "recovery.verify.intro": "キーを保存したことを確認するには、次の単語を入力します。正しく理解しないと続行できません。",
  "recovery.verify.wordN": "単語番号 {0}",
  "recovery.verify.wrong": "正しくない",
  "recovery.warn": "**オフラインで書き留めてください。** スクリーンショットを撮らないでください。電子メールやメッセージで送信しないでください。これらの言葉を持っている人があなたのアカウント全体を支配します。",
  "savediko.activate": "IKOをアクティブにする",
  "savediko.add": "IKO を保存します",
  "savediko.confirmDel": "消去？",
  "savediko.descLabel": "説明",
  "savediko.descPh": "後でそれを認識するための説明",
  "savediko.empty": "IKO をまだ保存していません。",
  "savediko.errDesc": "説明を入力します。",
  "savediko.errIko": "IKO を書いてください.",
  "savediko.formEdit": "保存された IKO を編集します",
  "savediko.formNew": "IKO を保存します",
  "savediko.intro": "覚えておきたくない IKO はここに置いておく。ひとつ覚えれば、残りはその中にある。",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "IKO を書いてください",
  "settings.about.tech": "NaCl ボックス (X25519) を使用した E2E 暗号化。  IKO : Argon2id 導出 + 決定論的 HMAC。 PIN を介した Argon2id によるローカル暗号化永続化。",
  "settings.about.title": "IKOGNITについて",
  "settings.about.version": "バージョン",
  "settings.account.changePassword": "パスワードを変更する",
  "settings.account.confirmPw": "新しいものを繰り返します",
  "settings.account.currentPw": "現在のパスワード",
  "settings.account.email": "電子メール",
  "settings.account.emailPh": "email@example.com",
  "settings.account.errPwBad": "現在のパスワードが間違っています。",
  "settings.account.errPwMismatch": "パスワードが一致しません。",
  "settings.account.errPwShort": "新しいパスワードは 8 文字以上である必要があります。",
  "settings.account.newEmailPlaceholder": "new@email.com",
  "settings.account.newNickPlaceholder": "新しいニックネーム",
  "settings.account.newPw": "新しいパスワード (8 分以上)",
  "settings.account.saving": "保存中…",
  "settings.account.success": "パスワードが更新されました。",
  "settings.account.title": "アカウント",
  "settings.addYourName": "あなたの名前を追加してください",
  "settings.blocked.btn": "ブロック",
  "settings.blocked.empty": "誰もブロックしていません。",
  "settings.blocked.hint": "ブロックされたユーザーはあなたにメッセージを送信できません。メッセージを送信することもできません。",
  "settings.blocked.placeholder": "ブロックするニック",
  "settings.blocked.title": "ブロックされました",
  "settings.blocked.unblock": "ブロックを解除する",
  "settings.close": "近い",
  "settings.editProfile": "プロフィールの編集",
  "settings.language.hint": "インターフェースの言語を選びます。設定はこの端末に保存されます。",
  "settings.language.title": "言語",
  "settings.legal.cookies": "クッキーポリシー",
  "settings.legal.hub": "法務センター",
  "settings.legal.minors": "未成年者ポリシー",
  "settings.legal.notice": "法的通知",
  "settings.legal.privacy": "プライバシーポリシー",
  "settings.legal.report": "報告とモデレーション",
  "settings.legal.rules": "コミュニティルール",
  "settings.legal.terms": "利用規約",
  "settings.legal.title": "法的情報",
  "settings.messages.title": "メッセージ",
  "settings.messages.ttl": "デフォルトの有効期限",
  "settings.messages.ttlHint": "送信したメッセージはこの時間を過ぎるとサーバーから削除されます。ファイルを添付するときに別の値を選択できます。",
  "settings.notif.hint": "ブラウザーのプッシュ通知は、IKOGNIT 一般のメッセージに対してのみ、コンテンツや送信者名なしで (仕様により) 発行されます。",
  "settings.notif.preview": "メッセージのプレビューを表示する",
  "settings.notif.sound": "音",
  "settings.notif.title": "通知",
  "settings.notif.vibration": "振動（モバイル）",
  "settings.privacy.hintFreq": "これらのルールは、 {0} にいる場合にのみオーバーライドします。",
  "settings.privacy.hintGlobal": "デフォルトで各詳細を閲覧できるユーザーを設定します。",
  "settings.privacy.readReceipts": "開封確認",
  "settings.privacy.readReceiptsHint": "無効にすると、メッセージを読んだときに青いチェックマークは送信されません。他の人のものも表示されません。",
  "settings.privacy.showInfo": "私の情報/ステータスを見るのは誰ですか",
  "settings.privacy.showLastSeen": "私の最後のつながりを見るのは誰ですか",
  "settings.privacy.showOnline": "私がオンラインかどうかを誰が見るのか",
  "settings.privacy.showPhoto": "私の写真を見る人は誰ですか",
  "settings.privacy.title": "プライバシー",
  "settings.privacy.whoAdds": "私をグループに追加できる人",
  "settings.profile.adjustPhoto": "写真を調整する",
  "settings.profile.changePhoto": "画像を変更する",
  "settings.profile.displayName": "表示名",
  "settings.profile.displayNamePh.freq": "(グローバルから継承)",
  "settings.profile.displayNamePh.global": "(名前なし - あなたのニックネームが表示されます)",
  "settings.profile.hintFreq": "これらは、 {0} にいるときにグローバル プロファイルをオーバーライドします。ここで何かを定義しない場合は、global から継承されます。",
  "settings.profile.hintGlobal": "これらの値はデフォルトで使用され、すべての IKO に継承されます。",
  "settings.profile.info": "情報/ステータス",
  "settings.profile.infoPh": "こんにちは、私は IKOGNIT を使用しています",
  "settings.profile.photo": "プロフィール写真",
  "settings.profile.removeOverride": "{0} のオーバーライドを削除します",
  "settings.profile.removePhoto": "画像を削除する",
  "settings.profile.title": "プロフィール",
  "settings.profile.warn": "この IKO で残りの連絡先とやり取りすると、変更内容が自動的に連絡先に送信されます。",
  "settings.scope.freq": "{0} のみ",
  "settings.scope.global": "グローバル ( IKOGNIT )",
  "settings.session.remember": "アクティブ化された IKO を記憶します",
  "settings.session.rememberHint": "有効にすると、アクティブ化した IKO がサイドバーにショートカットとして表示されます。画面を見れば誰でも、どの IKO を入力したかがわかる可能性があるため、デフォルトでは無効になっています。オフにすると、すでに保存されているものは消去されます。",
  "settings.session.timeout": "非アクティブになったら IKO を閉じます",
  "settings.session.timeoutHint": "アプリに触れずにこの時間を過ごすと、アクティブな IKO が自動的に非アクティブ化され、 IKOGNIT に戻ります。 「決して」では、アプリを閉じるまで IKO が保持されます。",
  "settings.session.title": "セッション",
  "settings.tab.about": "ℹについて",
  "settings.tab.account": "🆔アカウント",
  "settings.tab.blocked": "🚫ブロックされました",
  "settings.tab.language": "🌐 言語",
  "settings.tab.legal": "法律上の",
  "settings.tab.messages": "✉ メッセージ",
  "settings.tab.notifications": "🔔 通知",
  "settings.tab.privacy": "🔒 プライバシー",
  "settings.tab.profile": "👤プロフィール",
  "settings.tab.session": "⏱セッション",
  "settings.title": "設定",
  "settings.vis.all": "みんな",
  "settings.vis.contacts": "私の連絡先",
  "settings.vis.none": "誰でもない",
  "sidebar.addContact": "ニックネームで連絡先を追加",
  "sidebar.exitFreq": "IKOGNIT に戻る",
  "sidebar.forget": "デバイスを忘れる",
  "sidebar.freq": "現在の IKO : {0}",
  "sidebar.freqPrivate": "個人 IKO : {0}",
  "sidebar.freqPsh": "ドメイン IKO : {0}",
  "sidebar.freqPublic": "IKO : {0}",
  "sidebar.general": "IKOGNIT",
  "sidebar.logout": "サインアウト",
  "sidebar.newGroup": "新しいグループ",
  "sidebar.notifications": "通知",
  "sidebar.remember": "デバイスを記憶する",
  "sidebar.savedFreq.tooltip": "{0}をアクティブにする",
  "sidebar.settings": "設定",
  "sidebar.tooltip.logout": "サインアウトしてローカルのすべてを消去します",
  "sidebar.tune": "IKOをアクティブにする",
  "stickers.animals": "動物",
  "stickers.faces": "顔",
  "stickers.food": "食べ物",
  "stickers.gestures": "ジェスチャー",
  "stickers.hearts": "ハート",
  "stickers.symbols": "記号",
  "timeout.15min": "15分",
  "timeout.30min": "30分",
  "timeout.5min": "5分",
  "timeout.never": "一度もない",
  "toast.group": "{0} (グループ)",
  "toast.newMessage": "新しいメッセージ",
  "totp.copyCode": "コードをコピーする",
  "totp.copySecret": "シークレットをコピーする",
  "totp.hideSecret": "秘密を隠す",
  "totp.invalid": "無効なシークレット",
  "totp.showSecret": "シークレットを表示",
  "ttl.12m": "12ヶ月",
  "ttl.1d": "1日",
  "ttl.1h": "1時間",
  "ttl.1m": "1ヶ月",
  "ttl.1w": "1週間",
  "ttl.6m": "6ヶ月",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "一般IKO",
  "uib.e2e.label": "ブラインドサーバー",
  "uib.e2e.title": "サーバーはコンテンツを読み取ることができません — キーによる E2E 暗号化",
  "uib.exitLabel": "出口",
  "uib.exitTitle": "一般IKOに戻る",
  "uib.modes.private": "個人 IKO",
  "uib.modes.shared": "IKO",
  "uib.nickTitle": "あなたのニックネーム",
  "uib.pseudoTitle": "この IKO 内のあなたのペンネーム",
  "vault.addField": "フィールドの追加",
  "vault.confirmDelete": "この項目を削除しますか?回復することはできません。",
  "vault.copied": "コピーしました ✓",
  "vault.copy": "コピー",
  "vault.delete": "消去",
  "vault.edit": "編集",
  "vault.empty": "フォルダは空です。最初のアイテムを作成します。",
  "vault.field.address": "住所",
  "vault.field.birthdate": "生年月日",
  "vault.field.cardBrand": "ブランド",
  "vault.field.cardCvv": "CVV",
  "vault.field.cardExpiry": "有効期限 (MM/YY)",
  "vault.field.cardHolder": "カード所有者",
  "vault.field.cardNumber": "番号",
  "vault.field.city": "市",
  "vault.field.country": "国",
  "vault.field.dni": "ID / SSN",
  "vault.field.email": "電子メール",
  "vault.field.firstname": "ファーストネーム",
  "vault.field.labelPh": "フィールドラベル",
  "vault.field.lastname": "苗字",
  "vault.field.name": "名前",
  "vault.field.name.ph": "なんと呼びますか？",
  "vault.field.newField": "分野",
  "vault.field.password": "パスワード",
  "vault.field.phone": "電話",
  "vault.field.sshFingerprint": "指紋",
  "vault.field.sshHost": "ホスト",
  "vault.field.sshPrivate": "秘密鍵",
  "vault.field.sshPublic": "公開鍵",
  "vault.field.totp": "TOTP",
  "vault.field.url": "URL",
  "vault.field.username": "ユーザー名",
  "vault.field.zip": "郵便番号",
  "vault.fieldPlural": "フィールド",
  "vault.fieldSingular": "分野",
  "vault.ft.date": "日付",
  "vault.ft.email": "電子メール",
  "vault.ft.number": "番号",
  "vault.ft.password": "パスワード",
  "vault.ft.text": "文章",
  "vault.ft.textarea": "長文",
  "vault.ft.url": "URL",
  "vault.hide": "隠れる",
  "vault.new": "新しいアイテム",
  "vault.noMatches": "検索に一致する項目はありません。",
  "vault.notes": "注意事項",
  "vault.removeField": "このフィールドを削除します",
  "vault.save": "保存",
  "vault.search": "検索…",
  "vault.sensitive": "センシティブ",
  "vault.sensitiveHint": "機密フィールドはデフォルトで非表示になっており、クリップボードにコピーできます。",
  "vault.show": "見せる",
  "vault.startHint": "左側から項目を選択するか、新しい項目を作成します。",
  "vault.tpl.confirmDelete": "このテンプレートを削除しますか?そこから作成されたアイテムが残ります。",
  "vault.tpl.edit": "テンプレートの編集",
  "vault.tpl.empty": "まだテンプレートがありません。独自の項目タイプを定義するために作成します。",
  "vault.tpl.manage": "テンプレートの管理",
  "vault.tpl.name": "テンプレート名",
  "vault.tpl.name.ph": "例: 暗号通貨ウォレット、ホテルの予約…",
  "vault.tpl.new": "新しいテンプレート",
  "vault.tpl.title": "テンプレート",
  "vault.tpl.yours": "あなたのテンプレート",
  "vault.type.card": "カード",
  "vault.type.custom": "カスタム",
  "vault.type.identity": "身元",
  "vault.type.login": "ログイン",
  "vault.type.sshkey": "SSHキー",
  "vault.untitled": "無題",
  "web.footer.line": "ライン",
  "web.footer.palette": "パレット",
  "web.footer.send": "送信",
  "welcome.btnContacts": "連絡先を追加",
  "welcome.btnFreq": "IKOをアクティブにする",
  "welcome.concept": "IKOGNIT では、ニックネームで識別される他のユーザーと会話します。別のスペースが必要な場合は、IKO をアクティブにしてIKOに入ります。それがパブリックであれば、それをアクティブにする人たちと出会うことになります。プライベートの場合は、あなただけが存在するIKOに入ります。",
  "welcome.multidevice": "IKO はどこにも保存されません。 IKO を忘れると、その IKO は存在しなくなります。",
  "welcome.step1": "IKO をアクティブにして、同じくIKOを知っている人たちと一緒にIKOに入りましょう。",
  "welcome.step2": "ここ IKOGNIT で、ニックネームを連絡先として追加し、会話を開始します。",
  "welcome.step3": "パーソナル IKO をアクティブにして、ファイル、写真、オーディオ、ビデオ、パスワード、メモ、手紙を保管する自分専用のIKOを開きます。",
  "welcome.title": "IKOGNIT へようこそ",

};

const ar: Catalog = {
  "auth.verify.notSent": "لم نتمكن من إرسال الرمز إليك. حسابك مُنشأ بالفعل: اضغط «إعادة إرسال الرمز» بعد قليل.",
  "lg.rotulo": "مراسلة بمساحات خاصة",
  "lg.btn.entrar": "الدخول",
  "lg.eyebrow": "مراسلة خاصة · Itrion Software",
  "lg.h1a": "محادثاتك المعتادة.",
  "lg.h1b": "ومكان لا يوجد إلا حين تستدعيه.",
  "lg.lead1": "تتحدث مع عائلتك وأصدقائك وفريقك، مثل أي تطبيق. الفرق يبدأ حين تفتح IKO: مساحة خاصة بك، تدخلها بكتابة سر لا يعرفه إلا من هم بداخلها.",
  "lg.lead2": "ما دمت لم تستدعِه، فتلك المساحة ليست على جهازك — لا في الهاتف ولا في اللوحي ولا في الحاسوب. ليست المسألة أنها مشفّرة.",
  "lg.lead2b": "المسألة أنها غير موجودة.",
  "lg.pruebalo": "جرّب بنفسك · اكتب سرًا وانظر ماذا يحدث",
  "lg.panel.plano": "المستوى العام",
  "lg.demo.hilos": "العائلة=أمي: نتعشّى الأحد عندنا؟=19:04|مارتا=أرسل لك صور السبت=17:52|الفريق=لويس: غدًا التاسعة إذن=أمس|خافي=ههه لا أصدق=أمس",
  "lg.demo.mundos": "نحن الاثنان فقط~هل وضعته حيث اتفقنا؟|نعم. العقد وجواز السفر>~عقد الشقة.pdf=2٫4 م.ب|صور خاصة=214|بطاقة · بنك=بيانات~~أمور البيت~أترك لك هنا عقد الإيجار>|ومفتاح الراوتر، فأنت تضيعه دائمًا~عقد الإيجار.pdf=1٫1 م.ب|نسخة الهوية=ملفان|مفاتيح البيت=بيانات~~ملاحظاتي~هذا لم أخبر به أحدًا>|ولا داعي لأن أخبر>~اليوميات=48 ملاحظة|صور=1٬207|حسابات السنة=بيانات~~مشروع لشبونة~العرض يخرج بـ180|ها هو، دون أي نسخة في الخارج>~العرض_v4.pdf=860 ك.ب|جهات الاتصال=12|بطاقة الشركة=بيانات~~غداء السبت~لا تقل شيئًا لمارتا بعد|اطمئن، هنا لا يعلم أحد>~الحجز.pdf=120 ك.ب|صور العام الماضي=63|قائمة المدعوين=بيانات",
  "lg.invocaLabel": "استدعِ الـIKO الخاص بك",
  "lg.invocaPlaceholder": "اكتب أي سر",
  "lg.invocaBtn": "استدعاء",
  "lg.invocaHint": "كل كلمة تقود إلى مساحة مختلفة. جرّب كلمة أخرى.",
  "lg.estela.vacio": "اكتب أي شيء: هذا عرض توضيحي.",
  "lg.estela.primero": "ظهر. لا يوجد إلا ما دمت بداخله.",
  "lg.estela.otro": "سر آخر، مساحة أخرى. ولا واحدة تعلم بالأخرى.",
  "lg.estela.salida": "اختفى. لم يبقَ أثر على الجهاز. جرّب كلمة أخرى.",
  "lg.ikoActivo": "IKO نشط",
  "lg.nadaEnDispositivo": "لا شيء من هذا موجود على الجهاز",
  "lg.salirIko": "الخروج من الـIKO",
  "lg.planos.h2a": "مستوى واحد ظاهر للعيان.",
  "lg.planos.h2b": "وتحته، ما تستدعيه أنت.",
  "lg.planos.lead": "لا يوجد «الـIKO». توجد تلك التي تفتحها: واحد لأمور البيت، وآخر للعمل، وآخر لا يعرفه سواكما، وآخر لم تخبر به أحدًا قط. كل سر يقود إلى الخاص به، ولا واحد منها يعلم بالبقية.",
  "lg.planos.unoRotulo": "المستوى العام · واحد",
  "lg.planos.unoH3": "حيث تتحدث مع الجميع",
  "lg.planos.unoP": "محادثات ومجموعات ومكالمات وصور وملفات، مشفّرة من طرف إلى طرف. ما تنتظره من تطبيق مراسلة، منفّذًا كما ينبغي. محادثاتك المعتادة تعيش هنا وتتصرف كما كانت دائمًا.",
  "lg.planos.nRotulo": "الـIKO · بالعدد الذي تريد",
  "lg.planos.nH3": "حيث لا يصل أحد سواك",
  "lg.planos.nP": "تكتب سرًا فتظهر المساحة التي تقابله. تتّسع بداخلها المحادثات وأشياؤك. وحين تخرج، تغادر الجهاز دون أثر. لا قائمة ولا عدد، ولا يستطيع أحد أن يعرف كم لديك منها، ولا حتى أن واحدًا منها موجود.",
  "lg.planos.chips": "أمور البيت|العمل|ما لا تعرفانه إلا أنتما|ملكك وحدك|ذاك الذي فتحته مرة ولم تعد إليه|ما تقرره غدًا",
  "lg.forense.h2a": "ليس مشفّرًا على جهازك.",
  "lg.forense.h2b": "ليس على جهازك أصلًا.",
  "lg.forense.lead": "التطبيقات الأخرى تحتفظ برسائلك في الجهاز وتشفّرها. فإن أخذه أحد، تعتمد خصوصيتك على صمود ذلك التشفير مدة كافية. هنا لا شيء عليه أن يصمد: ما يعيش داخل IKO لا يُكتب على أي جهاز. يُستدعى، ويُستخدم، ثم يذهب.",
  "lg.forense.multi": "الأمر نفسه في كل مكان: هاتف، لوحي، حاسوب البيت، حاسوب العمل، ويندوز، ماك، أو متصفح في مكان ليس لك. تدخل من حيث تشاء، وحين تخرج يعود ذلك المكان لا يعرف عنك شيئًا.",
  "lg.forense.caption": "ما يجده من يفحص أيًّا من أجهزتك",
  "lg.forense.filas": "رسائل الـIKO الخاصة بك=0|ملفات وصور الـIKO الخاصة بك=0|أسرار IKO محفوظة=0|قاعدة بيانات تضم الـIKO الخاصة بك=غير موجودة|أثر يدل على فتح IKO=لا شيء|كم IKO لديك=غير قابل للتحديد",
  "lg.escenas.h2": "ما يقلقك فعلًا.",
  "lg.escenas.filas": "«فقدت هاتفي.»=خصوصيتك لم تضع معه. ما كان داخل IKO لم يكن يومًا على ذلك الجهاز، فلا شيء لإنقاذه ولا شيء لتخشاه. تستدعيه من أي جهاز آخر فتجد كل شيء حيث كان.~«أخذوا حاسوبي المحمول.»=سيرى محادثاتك العادية، نفسها التي كان سيراها في أي تطبيق. أما البقية فلن يرى محتواها ولا اسمها ولا أي دليل على وجودها.~«فحصوا حاسوبي.»=التحليل الجنائي الرقمي يستعيد ما هو مكتوب على القرص، ولو كان مشفّرًا وممحوًا. هنا لا يوجد شيء مكتوب لاستعادته. الجواب ليس «لا يمكن فك التشفير»، بل ببساطة: لا يوجد شيء. والأمر ذاته في اللوحي وفي الهاتف وفي المتصفح الذي استخدمته ذات مساء.",
  "lg.ciego.h2": "لا نحن. ولا من يستضيف الخوادم.",
  "lg.ciego.p1": "الخادم يحفظ أشياء لا يستطيع قراءتها. ليس لديه سرّك، ولم يكن لديه يومًا، ولا توجد نسخة منه في أي مكان. ليست المسألة أننا نرفض تسليم ما بداخل الـIKO الخاصة بك: نحن لا نملكه، ولا سبيل لأن نملكه. ولا الشركة التي تستضيف الأجهزة، ولا من قد يضع يده عليها.",
  "lg.ciego.p2": "لهذا ثمن ومن الإنصاف قوله: إن فقدت سرّك، فلا أحد يعيده لك. السبب نفسه الذي يمنع أي شخص آخر من الدخول هو السبب الذي يمنعنا نحن أيضًا من مساعدتك على الدخول.",
  "lg.guardas": "صور العائلة|الملاحظات التي لا تُريها لأحد|البطاقات والبيانات البنكية|كلمات المرور|المستندات|محادثات لا تخص سواكم",
  "lg.nombre.esta": "موجود",
  "lg.nombre.noEsta": "غير موجود",
  "lg.nombre.h2": "من هنا جاء الاسم.",
  "lg.nombre.p": "في السواحيلية، iko تعني «موجود» وhaiko تعني «غير موجود». الـIKO موجود ما دمت تستدعيه. وبقية الوقت — أي أغلب الوقت — غير موجود: لا على أجهزتك، ولا أمام عين أحد، ولا حتى كشبهة.",
  "lg.cierre.h2": "ابدأ الحديث.",
  "lg.cierre.p": "يُستخدم كأي تطبيق مراسلة، على الهاتف واللوحي والحاسوب. والـIKO موجودة يوم تحتاج إليها.",
  "lg.cierre.btnCrear": "إنشاء حساب",
  "lg.cierre.btnEntrar": "لديّ حساب بالفعل",
  "lg.cierre.pago": "IKOGNIT منتج مدفوع. لا إعلانات ولا ملفات تعريف إعلانية ولا نسخة لدينا من أي شيء: نعيش من أن يستحق التطبيق ما تدفعه، لا مما قد تقوله بداخله.",
  "lg.pie.ciego": "خادم أعمى",
  "auth.hola": "أهلًا من جديد.",
  "auth.queEs": "ما هو IKOGNIT؟",
  "auth.btn.backToUnlock": "خلف",
  "auth.btn.createIdentity": "إنشاء حساب",
  "auth.btn.forget": "ننسى هذا الجهاز",
  "auth.btn.processing": "يعالج…",
  "auth.btn.unlock": "تسجيل الدخول",
  "auth.btn.unlocking": "تسجيل الدخول...",
  "auth.btn.useOther": "استخدم حسابًا آخر",
  "auth.confirmForget": "لن يعود هذا الجهاز يعرفك: يتلاشى الحساب المحفوظ وكل ما في الذاكرة المؤقتة. للدخول من جديد ستحتاج كلمة المرور.",
  "auth.confirmForget.warning": "من دون تدوين عبارة الاسترداد المكوّنة من 24 كلمة، لا رجعة: لا أحد يستطيع إعادتها إليك.",
  "invite.welcomeSub": "مراسلة ومساحة خاصة بك: ما تحفظه هنا مسجَّل باسمك. أنشئ حسابك وستصبحان على اتصال.",
  "auth.reset.warnNewIdentity": "يبقى حسابك لك، لكن الاسترداد عبر البريد يمنحك هوية جديدة: لن يعود بالإمكان قراءة الرسائل السابقة. إن كانت عبارة الاسترداد المكوّنة من 24 كلمة بحوزتك، فاسلك ذلك الطريق.",
  "recover.intro": "اكتب اسمك المستعار أو بريدك وكلمات الاسترداد الـ24 التي أُعطيت لك عند إنشاء الحساب. بعدها ستختار كلمة مرور جديدة.",
  "auth.error.badCreds": "النك/البريد الإلكتروني أو كلمة المرور خاطئة.",
  "auth.error.badPin": "مفتاح خاطئ.",
  "auth.error.cantConnect": "تعذر الاتصال بالخادم.",
  "auth.error.legalRequired": "يجب عليك قبول الشروط القانونية وتأكيد عمرك لإنشاء حسابك.",
  "auth.error.userNotFound": "لم يتم العثور على الحساب.",
  "auth.field.devicePin": "الجهاز PIN",
  "auth.field.emailPlaceholder": "you@email.com",
  "auth.field.nickPlaceholder": "على سبيل المثال user123",
  "auth.field.password": "كلمة المرور",
  "auth.footnote": "من يملك، يتحمّل.\nإن فقدت كلمة المرور،\nفلا أحد تطالبه.",
  "auth.legal.accept": "لقد قرأت وقبلت شروط <a href='https://ikognit.org/legal/en/terms.html' target='_blank' rel='noopener'> </a> وسياسة الخصوصية <a href='https://ikognit.org/legal/en/privacy.html' target='_blank' rel='noopener'> </a> وقواعد المجتمع <a href='https://ikognit.org/legal/en/community-rules.html' target='_blank' rel='noopener'> </a> .",
  "auth.legal.age": "أؤكد أنني أستوفي الحد الأدنى للسن الذي يتطلبه قانون بلدي لاستخدام IKOGNIT .",
  "auth.loading": "تحميل…",
  "auth.savedSession": "هذا الجهاز يعرف صاحبه بالفعل.",
  "auth.locked": "تلاشى بسبب الخمول. ادخل من جديد.",
  "auth.sessionExpired": "تلاشت الجلسة. ادخل من جديد.",
  "auth.subLogin": "أنت تدخل المستوى العام: محادثاتك المعتادة. الـIKO لا تُستدعى هنا — تُستدعى بالداخل، حين تحتاج إليها.",
  "auth.subRegister": "الحساب يُسجَّل باسمك. الاسم المستعار هو ما يراه الآخرون؛ والبريد يُستخدم فقط لاستعادة الوصول وللإشعارات.",
  "auth.tab.login": "تسجيل الدخول",
  "auth.tab.register": "حساب جديد",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "في السواحيلية، iko تعني «موجود»، وhaiko تعني «غير موجود».",
  "billing.manage": "يدير",
  "billing.needsUpgrade": "لقد وصلت إلى الحد الأقصى لعدد المقاعد في فئتك. الترقية لإضافة المزيد من المقاعد.",
  "billing.portal": "إدارة الدفع",
  "billing.renews": "يجدد",
  "billing.seats": "مقاعد",
  "billing.title": "الفواتير",
  "billing.upgradeTo": "ترقية الطبقة ({price} /مقعد)",
  "bubble.contact.label": "IKOGNIT إتصال",
  "bubble.edit": "يحرر",
  "bubble.edited": "تم تحريره",
  "bubble.forward": "إلى الأمام",
  "bubble.media.decrypting": "جارٍ فك التشفير…",
  "bubble.media.failed": "لا يمكن فك تشفير الملف.",
  "bubble.reply": "رد",
  "bubble.tick.delivered": "تم التسليم {0}",
  "bubble.tick.read": "قراءة {0}",
  "bubble.tick.sent": "مرسل",
  "call.accept": "يقبل",
  "call.audioOut": "إخراج الصوت",
  "call.audioOut.auto": "آلي",
  "call.calling": "جارٍ الاتصال…",
  "call.camera": "آلة تصوير",
  "call.connecting": "جارٍ الاتصال…",
  "call.ending": "إنهاء…",
  "call.error.notInFreq": "للاتصال يجب أن تكون داخل IKO .",
  "call.hangup": "يشنق",
  "call.incoming.audio": "مكالمة واردة",
  "call.incoming.video": "مكالمة فيديو واردة",
  "call.mic": "ميكروفون",
  "call.reject": "يرفض",
  "ccb.clock.title": "التوقيت المحلي",
  "ccb.identity.title": "الجلسة: @ {0}",
  "ccb.leave.aria": "خروج IKO",
  "ccb.leave.title": "الخروج من IKO (العودة إلى IKOGNIT )",
  "ccb.modes.personalPrefix": "شخصي ·",
  "ccb.settings.aria": "إعدادات",
  "ccb.settings.title": "الإعدادات · الملف الشخصي، المواضيع، الدورة",
  "ccb.tag.cipher.title": "التشفير المتماثل نشط",
  "ccb.tag.srv.title": "لا يمكن للخادم قراءة المحتوى الخاص بك",
  "ccb.tag.unread.title": "رسائل غير مقروءة",
  "ccb.universe.activate": "تفعيل IKO",
  "ccb.universe.changeOrExit": "قم بالتبديل IKO أو الخروج",
  "chat.action.call": "يتصل",
  "chat.action.videoCall": "مكالمة فيديو",
  "chat.attach.camera": "آلة تصوير",
  "chat.attach.file": "إرفاق الملف",
  "chat.attach.label": "نعلق",
  "chat.attach.voice": "صوت",
  "chat.attachPending": "في انتظار المرفق",
  "chat.backToIkognit.title": "العودة إلى العام IKOGNIT",
  "chat.blocked.text": "لقد قمت بحظر {0} . لا يمكنك إرسال رسائل أو الاتصال بهم.",
  "chat.btn.send": "يرسل",
  "chat.call.title": "يتصل",
  "chat.calls.callContact": "اتصل بجهة اتصال",
  "chat.calls.empty": "لا توجد مكالمات حتى الآن. ابدأ واحدة من محادثة مع جهة اتصال.",
  "chat.calls.historySoon": "سيكون سجل المكالمات متاحًا قريبًا.",
  "chat.calls.title": "المكالمات",
  "chat.cancel.title": "يلغي",
  "chat.composer.placeholder": "اكتب رسالة...",
  "chat.confirmContact": "إضافة إلى جهات الاتصال",
  "chat.contact.badgeBlocked": "محظور",
  "chat.contact.badgePending": "غير مؤكد",
  "chat.contacts.empty": "لا توجد اتصالات حتى الآن.",
  "chat.contacts.noResults": "لا توجد نتائج.",
  "chat.delete.aria": "يمسح",
  "chat.delete.title": "يمسح",
  "chat.deleteConv.forAll": "الحذف للجميع",
  "chat.deleteConv.forMe": "حذف بالنسبة لي",
  "chat.deleteConv.hint": "\\\"بالنسبة لي\\\" يحذف نسختك (جميع أجهزتك). \\\"للجميع\\\" يطلب أيضًا من جهة الاتصال حذفه من جانبهم.",
  "chat.deleteConv.titleMany": "حذف محادثات {0}",
  "chat.deleteConv.titleOne": "حذف المحادثة",
  "chat.editPlaceholder": "تحرير رسالتك...",
  "chat.editing": "تحرير الرسالة",
  "chat.empty": "حدد جهة اتصال أو أضفها",
  "chat.error.userBlocked": "لقد قمت بحظر هذا المستخدم.",
  "chat.filter.all": "الجميع",
  "chat.filter.groups": "المجموعات",
  "chat.filter.unread": "غير مقروءة",
  "chat.filters.aria": "مرشحات الدردشة",
  "chat.group.membersWord": "أعضاء",
  "chat.header.blocked": "محظور",
  "chat.lastSeen": "آخر ظهور {0}",
  "chat.media.delete": "يمسح",
  "chat.media.deleteConfirmBody": "لا يمكن التراجع عن هذا الإجراء.",
  "chat.media.deleteConfirmTitle": "هل تريد حذف الصورة؟",
  "chat.media.deleteForAll": "الحذف للجميع",
  "chat.media.deleteForMe": "حذف بالنسبة لي",
  "chat.media.download": "تحميل",
  "chat.media.forward": "إلى الأمام",
  "chat.media.forwardTo": "إلى الأمام ل",
  "chat.media.share": "يشارك",
  "chat.mediaFailed": "تعذر التحميل",
  "chat.mediaRetry": "أعد المحاولة",
  "chat.myContacts": "جهات الاتصال الخاصة بي",
  "chat.nav.aria": "الملاحة الرئيسية",
  "chat.newCall.empty": "لا توجد اتصالات حتى الآن. أضف واحدًا من علامة + في الدردشات.",
  "chat.newCall.title": "مكالمة جديدة",
  "chat.newChat.title": "دردشة جديدة",
  "chat.newMessages": "جديد",
  "chat.newMessagesBadge": "انتقل إلى {0} الرسائل الجديدة",
  "chat.online": "متصل",
  "chat.placeholder": "اكتب رسالة…",
  "chat.presence.online": "متصل",
  "chat.preview.audio": "صوتي",
  "chat.preview.image": "صورة",
  "chat.preview.video": "فيديو",
  "chat.preview.voice": "رسالة صوتية",
  "chat.remove.title": "يزيل",
  "chat.replyingTo": "الرد على {0}",
  "chat.search.clear": "مسح البحث",
  "chat.search.placeholder": "بحث في الدردشة",
  "chat.tab.calls": "المكالمات",
  "chat.tab.chats": "الدردشات",
  "chat.tab.contacts": "اتصالات",
  "chat.tab.settings": "إعدادات",
  "chat.toast.imageSaved": "تم حفظ الصورة في الصور",
  "chat.toast.saveError": "خطأ في الحفظ",
  "chat.toast.saveFailed": "لا يمكن الحفظ: {0}",
  "chat.toast.saved": "أنقذ",
  "chat.toast.updateTestflight": "قم بتحديث TestFlight إلى 1.0(10)+ للحفظ.",
  "chat.toast.videoSaved": "تم حفظ الفيديو في الصور",
  "chat.tooltip.attach": "إرفاق الملف",
  "chat.tooltip.callAudio": "مكالمة صوتية",
  "chat.tooltip.callVideo": "مكالمة فيديو",
  "chat.tooltip.paste": "لصق الصورة من الحافظة",
  "chat.tooltip.shareContact": "مشاركة الاتصال",
  "chat.tooltip.stickers": "ملصقات",
  "chat.unblock": "إلغاء الحظر",
  "chat.unconfirmedBanner": "لقد كتب هذا المستخدم إليك ولكنه ليس ضمن جهات الاتصال الخاصة بك. وإلى أن تقوم بإضافتهم، لن تكون صورتك ومعلوماتك مرئية لهم وفقًا لإعدادات الخصوصية الخاصة بك.",
  "chat.unread.aria": "رسائل غير مقروءة",
  "chat.uploading": "…",
  "chat.videoCall.aria": "مكالمة فيديو مع {0}",
  "chat.videoCall.title": "مكالمة فيديو",
  "chat.welcome.intro": "حدد محادثة لبدء التحدث باستخدام التشفير الشامل.",
  "common.add": "يضيف",
  "common.back": "خلف",
  "common.cancel": "يلغي",
  "common.close": "يغلق",
  "common.confirm": "يتأكد",
  "common.delete": "يمسح",
  "common.error.generic": "لم يتم. حاول مرة أخرى.",
  "common.exit": "مخرج",
  "common.more": "أكثر",
  "common.save": "يحفظ",
  "common.tagline": "السيادة الرقمية.",
  "contacts.alias.label": "الاسم المستعار",
  "contacts.alias.placeholder": "اسم مستعار للتعرف عليهم",
  "contacts.blockBtn": "حظر الاتصال",
  "contacts.confirmBlock.body": "كتلة {0} ؟ سوف تتوقف عن تلقي رسائلهم ومكالماتهم.",
  "contacts.confirmBlock.title": "حظر الاتصال",
  "contacts.confirmUnblock.body": "رفع الحظر {0} ؟ سوف تتلقى رسائلهم مرة أخرى.",
  "contacts.confirmUnblock.title": "إلغاء حظر جهة الاتصال",
  "contacts.edit.aria": "يحرر",
  "contacts.edit.title": "تحرير الاسم المستعار والملاحظة",
  "contacts.note.label": "ملاحظة خاصة",
  "contacts.notes.placeholder": "يمكنك أنت فقط رؤيته (مشفر على الخادم).",
  "contacts.search.placeholder": "البحث عن طريق الاسم المستعار أو معرف IKOGNIT",
  "contacts.unblockBtn": "إلغاء حظر جهة الاتصال",
  "ctx.action.contacts": "جهات الاتصال الخاصة بي",
  "ctx.action.newChat": "دردشة جديدة",
  "ctx.action.newGroup": "مجموعة جديدة",
  "ctx.aria": "معلومات IKO والملاحة",
  "ctx.liturgy.0": "الخادم أعمى.",
  "ctx.liturgy.1": "أنت فقط تقرأ هنا.",
  "ctx.liturgy.2": "لا أحد يعرف أنك هنا.",
  "ctx.liturgy.3": "IKO هو سر لا يعرفه أحد سواك.",
  "ctx.liturgy.4": "خصوصيتك هي الهندسة المعمارية.",
  "ctx.modes.private": "شخصي IKO",
  "ctx.modes.storage": "محرك أقراص",
  "ctx.modes.shared": "IKO",
  "ctx.nav.activateIko": "تفعيل IKO",
  "ctx.nav.backToIkognit": "العودة إلى IKOGNIT",
  "ctx.nav.changeIko": "التبديل IKO",
  "ctx.peer.message": "{0} رسالة",
  "ctx.peer.messages": "{0} رسائل",
  "ctx.peer.offline": "غير متصل",
  "ctx.peer.online": "متصل",
  "ctx.section.actions": "الإجراءات",
  "ctx.section.conversation": "محادثة",
  "ctx.section.nav": "ملاحة",
  "ctx.section.universe": "IKO الحالي",
  "ctx.status.e2e": "التشفير من النهاية إلى النهاية",
  "ctx.status.serverBlind": "الخادم الأعمى نشط",
  "ctx.universe.personal": "المساحة الشخصية الخاصة بك",
  "demo.edit": "يحرر",
  "error.blocked": "لقد قمت بحظر هذا المستخدم. قم بإلغاء الحظر في الإعدادات للتحدث مرة أخرى.",
  "error.cantAcceptCall": "لا يمكن قبول المكالمة: {0}",
  "error.cantPaste": "تعذر الوصول إلى الحافظة. حاول استخدام زر الإرفاق.",
  "error.cantStartCall": "تعذر بدء المكالمة: {0}",
  "error.clipboardUnsupported": "متصفحك لا يسمح بقراءة الحافظة. الصق باستخدام Ctrl+V أو استخدم زر الإرفاق.",
  "error.expired": "انتهت صلاحية الجلسة. قم بتسجيل الدخول مرة أخرى.",
  "error.gone": "لقد انتهت صلاحية الملف.",
  "error.invalid": "بيانات غير صالحة.",
  "error.network": "لا يوجد اتصال بالخادم.",
  "error.noImageInClipboard": "لا توجد صورة في الحافظة.",
  "error.notFound": "لم يتم العثور على المورد.",
  "error.notInFreq": "{0} ليس في هذا IKO بعد. اطلب منهم عبر قناة أخرى تفعيلها.",
  "error.push.activateFailed": "تعذر التنشيط ( {0} ).",
  "error.push.denied": "لقد رفضت إذن الإخطارات.",
  "error.push.iosNotStandalone": "لتلقي الإشعارات على iPhone، قم بتثبيت IKOGNIT على الشاشة الرئيسية: اضغط على مشاركة → إضافة إلى الشاشة الرئيسية.",
  "error.push.iosTooOld": "نظام iOS الخاص بك أقدم من 16.4. قم بتحديثه لتلقي الإخطارات.",
  "error.push.noPush": "هذا المتصفح لا يدعم دفع الإخطارات.",
  "error.push.noSw": "هذا المتصفح لا يدعم عمال الخدمة.",
  "error.push.noVapid": "لم يوفر الخادم مفتاح VAPID.",
  "error.selfContact": "لا يمكنك إضافة نفسك.",
  "error.server": "خطأ في الخادم. يرجى المحاولة مرة أخرى.",
  "explorer.filesNotProcessed": "الملف (الملفات) التي لم تتم معالجتها",
  "holo.card.cipher": "التشفير",
  "holo.card.contacts": "اتصالات",
  "holo.card.conversations": "المحادثات",
  "holo.card.server": "الخادم",
  "holo.claim.general": "مساحتك الشخصية في IKOGNIT . هنا تتحدث مع جهات الاتصال الخاصة بك.",
  "holo.claim.inIko": "يبقى هذا IKO غير مرئي لأي شخص لا يعرفه.",
  "holo.foot": "اختر محادثة، أو قم بتنشيط IKO، أو قم بإنشاء مساحة جديدة.",
  "holo.modes.general": "نيك + جهات الاتصال الخاصة بك",
  "holo.modes.private": "شخصي IKO",
  "holo.modes.shared": "IKO",
  "join.loginToAccept": "تسجيل الدخول / إنشاء حساب",
  "iko.banner.exitAria": "الخروج من الـIKO والعودة إلى المستوى العام",
  "iko.liturgy.entering": "الدخول IKO",
  "iko.liturgy.returning": "العودة",
  "iko.liturgy.toIkognit": "إلى IKOGNIT",
  "iko.mode.private": "شخصي IKO",
  "iko.mode.shared": "IKO",
  "manifest.blindServer": "الخادم أعمى.",
  "manifest.keyWithYou": "المفتاح يعيش معك.",
  "manifest.noAdsNoClouds": "لا إعلانات. لا توجد غيوم خارجية.",
  "manifest.noPublicProfiles": "لا توجد ملفات تعريف عامة.",
  "manifest.onlyYouRead": "أنت فقط تقرأ هنا.",
  "manifest.yourIkoYourSpaces": "الخاص بك IKO . مساحاتك.",
  "media.confirmDelete": "هل تريد حذف هذا العنصر؟ لا يمكن استعادتها.",
  "media.delete": "يمسح",
  "media.download": "تحميل",
  "media.empty.audio": "لا صوتيات في هذا IKO حتى الآن.",
  "media.empty.file": "لا توجد ملفات في هذا IKO حتى الآن.",
  "media.empty.photo": "لا توجد صور في هذا IKO حتى الآن.",
  "media.empty.video": "لا توجد مقاطع فيديو في هذا IKO حتى الآن.",
  "media.noPreview": "لا توجد معاينة لهذا النوع من الملفات.",
  "media.play": "يلعب",
  "media.upload.audio": "تحميل الصوت",
  "media.upload.file": "تحميل الملف",
  "media.upload.photo": "تحميل الصورة",
  "media.upload.video": "تحميل الفيديو",
  "media.uploadFailed": "تعذر تحميل الملف.",
  "media.uploading": "جارٍ التحميل…",
  "mobile.tb.ikoActivate": "تفعيل IKO",
  "mobile.tb.ikoExit": "العودة إلى العام IKOGNIT",
  "modal.freq.activate": "فعل",
  "modal.freq.deriving": "حساب IKO…",
  "modal.freq.errCommon": "هذا IKO شائع جدًا. اختر شيئًا فريدًا.",
  "modal.freq.errRepeat": "لا تستخدم حرفًا واحدًا متكررًا.",
  "modal.freq.errSeqAlpha": "تجنب التسلسل الأبجدي.",
  "modal.freq.errSeqNum": "تجنب التسلسلات الرقمية الواضحة.",
  "modal.freq.errShort": "يجب أن يحتوي IKO على 8 أحرف على الأقل.",
  "modal.freq.hint": "IKO هي IKO الدقيقة لأحد IKO.  IKO : تقابل من يكتب نفس IKO. شخصيًا: تصل إلى عالم تكون فيه غير مرئي، حتى لو كتب آخر نفس الشيء. النطاق: ينتمي إلى مالك ولا يمكنك الدخول إليه إلا إذا قام بتسجيلك.",
  "modal.freq.placeholder": "اكتب IKO",
  "modal.freq.title": "تفعيل IKO",
  "modal.freq.warn": "لا يتم تخزين IKO في أي مكان. إذا نسيتهم، فإن هذا IKO يتوقف عن الوجود بالنسبة لك.",
  "modal.group.create": "إنشاء مجموعة",
  "modal.group.hint": "اختر اسمًا وحدد الأعضاء من جهات الاتصال الخاصة بك في هذا IKO .",
  "modal.group.namePh": "اسم المجموعة",
  "modal.group.selected": "{0} تم التحديد",
  "modal.group.title": "مجموعة جديدة",
  "modal.remember.confirm": "كرر PIN",
  "modal.remember.errMismatch": "أرقام التعريف الشخصية غير متطابقة.",
  "modal.remember.errShort": "يجب أن يحتوي PIN على 4 أحرف على الأقل.",
  "modal.remember.hint": "سيتم حفظ جلستك وجهات اتصالك ومجموعاتك ورسائلك على هذا الجهاز، مشفرة باستخدام PIN أنت وحدك الذي تعرفه. عند إعادة فتح التطبيق، ستدخل إلى PIN لفتحه.",
  "modal.remember.pin": "PIN",
  "modal.remember.title": "تذكر هذا الجهاز",
  "modal.remember.warn": "إذا نسيت PIN، فلا يمكن استرداد البيانات المحفوظة. سيتعين عليك تسجيل الدخول مرة أخرى باستخدام اسم المستخدم وكلمة المرور الخاصة بك.",
  "modal.share.btn": "يشارك",
  "modal.share.empty": "لا توجد جهات اتصال في هذا IKO",
  "modal.share.filter": "تصفية جهات الاتصال...",
  "modal.share.hint": "اختر جهة اتصال من القائمة أو أدخل اللقب يدويًا.",
  "modal.share.manual": "أو نيك يدوي",
  "modal.share.title": "مشاركة الاتصال",
  "notes.autosaveHint": "تم الحفظ تلقائيًا، مشفرًا، هنا فقط.",
  "notes.confirmDelete": "هل تريد حذف هذه الملاحظة؟ لا يمكن استعادتها.",
  "notes.contentPlaceholder": "اكتب كل ما تريد أن تتذكره...",
  "notes.delete": "حذف الملاحظة",
  "notes.empty": "ليس لديك ملاحظات في هذا IKO حتى الآن.",
  "notes.emptyPreview": "(فارغ)",
  "notes.new": "ملاحظة جديدة",
  "notes.startHint": "لا توجد ملاحظات في هذا IKO. إنشاء أول واحد.",
  "notes.titlePlaceholder": "عنوان",
  "notes.untitled": "بدون عنوان",
  "notes.yesterday": "أمس",
  "orb.copy.line1": "الخاص بك IKO .",
  "orb.copy.line2": "مساحاتك.",
  "orb.mod.audios": "صوتيات",
  "orb.mod.chat": "محادثة",
  "orb.mod.files": "ملفات",
  "orb.mod.notes": "ملحوظات",
  "orb.mod.photos": "صور",
  "orb.mod.vault": "مجلد",
  "passwords.confirmDelete": "هل تريد حذف هذا الإدخال؟ لا يمكن استعادتها.",
  "passwords.copied": "منقول ✓",
  "passwords.copy": "ينسخ",
  "passwords.delete": "يمسح",
  "passwords.edit": "يحرر",
  "passwords.empty": "لم تقم بحفظ أي إدخال في هذا IKO حتى الآن.",
  "passwords.field.label": "اسم",
  "passwords.field.label.ph": "بنك، حساب، خدمة...",
  "passwords.field.notes": "ملحوظات",
  "passwords.field.notes.ph": "أي تفاصيل مفيدة",
  "passwords.field.password": "كلمة المرور",
  "passwords.field.password.ph": "كلمة المرور التي تريد حفظها",
  "passwords.field.url": "URL",
  "passwords.field.username": "اسم المستخدم",
  "passwords.field.username.ph": "البريد الإلكتروني، الاسم المستعار، الرقم…",
  "passwords.hide": "يخفي",
  "passwords.new": "دخول جديد",
  "passwords.save": "يحفظ",
  "passwords.show": "يعرض",
  "passwords.startHint": "لا توجد كلمات مرور في هذا IKO. إنشاء أول واحد.",
  "passwords.untitled": "بدون عنوان",
  "piko.cat.all": "الجميع",
  "piko.cat.audios": "صوتيات",
  "piko.cat.cards": "بطاقات",
  "piko.cat.custom": "خزائن",
  "piko.cat.agendas": "أدلة IKO",
  "piko.cat.storage": "محرك أقراص والأقراص",
  "piko.cat.files": "ملفات",
  "piko.cat.identities": "الهويات",
  "piko.cat.notes": "ملحوظات",
  "piko.cat.passwords": "كلمات المرور",
  "piko.cat.photos": "صور",
  "piko.cat.sshkeys": "مفاتيح SSH",
  "piko.cat.videos": "فيديوهات",
  "piko.rail.aria": "فئات IKO الشخصية",
  "piko.rail.head": "شخصي",
  "preview.audio": "🎙 الصوت",
  "preview.image": "📷 صورة",
  "preview.video": "🎬 فيديو",
  "private.badge": "شخصي",
  "private.mod.audios": "صوتيات",
  "private.mod.audios.desc": "التسجيلات والملاحظات الصوتية.",
  "private.mod.files": "ملفات",
  "private.mod.files.desc": "المستندات والأوراق وملفات PDF.",
  "private.mod.iko": "بلدي IKO",
  "private.mod.iko.desc": "IKO المحفوظة لديك، جاهزة للتنشيط.",
  "private.mod.notes": "ملحوظات",
  "private.mod.notes.desc": "الملاحظات والرسائل والمذكرات.",
  "private.mod.photos": "صور",
  "private.mod.photos.desc": "معرضك الخاص.",
  "private.mod.vault": "مجلد",
  "private.mod.vault.desc": "كلمات المرور والبطاقات والهويات ومفاتيح SSH وكل ما تحتاجه.",
  "private.mod.videos": "فيديوهات",
  "private.mod.videos.desc": "مقاطع الفيديو الشخصية الخاصة بك.",
  "private.module.coming": "قريباً.",
  "private.module.comingHint": "ستكون هذه الوحدة متاحة قريبًا جدًا. تشفير الـIKO الخاص يعمل بالفعل — قريبًا ستتمكن من حفظ كل ما تحتاجه هنا.",
  "private.welcome.hint": "اختر قسمًا للبدء.",
  "private.welcome.intro": "أنت في IKO حيث لا يمكن لأحد رؤيتك. حتى لو كتب شخص آخر نفس IKO، فسيصل إلى عالم مختلف. هنا يمكنك الحفاظ على الأشياء الخاصة بك آمنة.",
  "private.welcome.title": "شخصيتك IKO",
  "push.btnDisable": "الإخطارات على. انقر للتعطيل.",
  "push.btnEnable": "الإخطارات معطلة. انقر للتمكين.",
  "push.btnOff": "تم إيقاف الإشعارات",
  "push.btnOn": "الإخطارات قيد التشغيل",
  "push.introBody": "من أجل الخصوصية، تختلف إشعارات IKOGNIT عن إشعارات تطبيقات المراسلة الأخرى:",
  "push.introBullet1": "لم يتم تضمين محتوى الرسالة.",
  "push.introBullet2": "لا يظهر اسم المرسل أو لقبه.",
  "push.introBullet3": "سوف تتلقى فقط تنبيه \\\"رسالة جديدة\\\"؛ افتح التطبيق لقراءته مشفرًا على جهازك.",
  "push.introConfirm": "تمكين الإخطارات",
  "push.introTitle": "قبل تمكين الإخطارات",
  "recovery.btn.back": "ارجع لترى الكلمات",
  "recovery.btn.cleared": "تم مسح الحافظة",
  "recovery.btn.continue": "يكمل",
  "recovery.btn.copied": "منسوخ · يُمسح خلال {0} ثانية",
  "recovery.btn.copy": "ينسخ",
  "recovery.btn.copyAria": "نسخ عبارة الاسترداد إلى الحافظة (سيتم مسحها تلقائيًا)",
  "recovery.btn.done": "أنا انتهيت",
  "recovery.btn.download": "تحميل",
  "recovery.btn.downloadAria": "تحميل العبارة كملف نصي",
  "recovery.btn.need3": "اكتب 3 كلمات صحيحة",
  "recovery.btn.show": "عرض الكلمات",
  "recovery.intro": "هذه **24 كلمة** هي الطريقة الوحيدة لاستعادة حسابك وسجلك إذا نسيت كلمة المرور أو فقدت جهازك. **اكتبها على الورق واحتفظ بها في مكان آمن.** لا يمكن لأحد في IKOGNIT استعادتها لك.",
  "recovery.title": "مفتاح الاسترداد الخاص بك",
  "recovery.verify.correct": "صحيح",
  "recovery.verify.intro": "لتأكيد حفظ مفتاحك، اكتب هذه الكلمات. لا يمكنك الاستمرار دون تصحيح الأمور.",
  "recovery.verify.wordN": "كلمة # {0}",
  "recovery.verify.wrong": "غير صحيح",
  "recovery.warn": "**اكتبها دون اتصال بالإنترنت.** لا تلتقط لقطة شاشة. لا ترسلهم عن طريق البريد الإلكتروني أو الرسائل. من لديه هذه الكلمات يتحكم في حسابك بالكامل.",
  "savediko.activate": "تفعيل IKO",
  "savediko.add": "حفظ IKO",
  "savediko.confirmDel": "يمسح؟",
  "savediko.descLabel": "وصف",
  "savediko.descPh": "وصف للتعرف عليه لاحقا",
  "savediko.empty": "لم تقم بحفظ أي IKO حتى الآن.",
  "savediko.errDesc": "أدخل الوصف.",
  "savediko.errIko": "اكتب الـIKO.",
  "savediko.formEdit": "تم التعديل المحفوظ IKO",
  "savediko.formNew": "حفظ IKO",
  "savediko.intro": "احتفظ هنا بالـIKO التي لا تريد حفظها. تتذكر واحدًا فقط والباقي يعيش بداخله.",
  "savediko.ikoLabel": "الـIKO",
  "savediko.ikoPh": "اكتب الـIKO",
  "settings.about.tech": "E2E التشفير بصندوق NaCl (X25519).  IKO : اشتقاق Argon2id + HMAC الحتمية. الثبات المشفر المحلي باستخدام Argon2id عبر PIN .",
  "settings.about.title": "حول IKOGNIT",
  "settings.about.version": "إصدار",
  "settings.account.changePassword": "تغيير كلمة المرور",
  "settings.account.confirmPw": "كرر الجديد",
  "settings.account.currentPw": "كلمة المرور الحالية",
  "settings.account.email": "بريد إلكتروني",
  "settings.account.emailPh": "email@example.com",
  "settings.account.errPwBad": "كلمة المرور الحالية غير صحيحة.",
  "settings.account.errPwMismatch": "كلمات المرور غير متطابقة.",
  "settings.account.errPwShort": "يجب أن تتكون كلمة المرور الجديدة من 8 أحرف على الأقل.",
  "settings.account.newEmailPlaceholder": "new@email.com",
  "settings.account.newNickPlaceholder": "new_nick",
  "settings.account.newPw": "كلمة المرور الجديدة (8 دقائق على الأقل)",
  "settings.account.saving": "توفير…",
  "settings.account.success": "تم تحديث كلمة المرور.",
  "settings.account.title": "حساب",
  "settings.addYourName": "أضف اسمك",
  "settings.blocked.btn": "حاجز",
  "settings.blocked.empty": "ليس لديك أحد محظور.",
  "settings.blocked.hint": "لا يمكن للمستخدمين المحظورين إرسال رسائل إليك. لا يمكنك إرسال رسائل إليهم أيضًا.",
  "settings.blocked.placeholder": "نيك للحظر",
  "settings.blocked.title": "محظور",
  "settings.blocked.unblock": "إلغاء الحظر",
  "settings.close": "يغلق",
  "settings.editProfile": "تحرير الملف الشخصي",
  "settings.language.hint": "اختر لغة الواجهة. يتم حفظ تفضيلاتك على هذا الجهاز، وفي حالة تمكين المخزن، يتم حفظها أيضًا في جلستك.",
  "settings.language.title": "لغة",
  "settings.legal.cookies": "سياسة ملفات تعريف الارتباط",
  "settings.legal.hub": "المركز القانوني",
  "settings.legal.minors": "سياسة القاصرين",
  "settings.legal.notice": "إشعار قانوني",
  "settings.legal.privacy": "سياسة الخصوصية",
  "settings.legal.report": "التقارير والاعتدال",
  "settings.legal.rules": "قواعد المجتمع",
  "settings.legal.terms": "الشروط والأحكام",
  "settings.legal.title": "المعلومات القانونية",
  "settings.messages.title": "رسائل",
  "settings.messages.ttl": "انتهاء الصلاحية الافتراضية",
  "settings.messages.ttlHint": "سيتم حذف الرسائل التي ترسلها من الخادم بعد هذا الوقت. يمكنك اختيار قيمة مختلفة عند إرفاق ملف.",
  "settings.notif.hint": "يتم إصدار إشعارات المتصفح المؤقتة فقط للرسائل في IKOGNIT بشكل عام، بدون محتوى أو اسم المرسل (حسب التصميم).",
  "settings.notif.preview": "إظهار معاينة الرسالة",
  "settings.notif.sound": "صوت",
  "settings.notif.title": "إشعارات",
  "settings.notif.vibration": "الاهتزاز (المحمول)",
  "settings.privacy.hintFreq": "قم بتجاوز هذه القواعد فقط عندما تكون في {0} .",
  "settings.privacy.hintGlobal": "قم بتكوين من يمكنه رؤية كل التفاصيل الخاصة بك بشكل افتراضي.",
  "settings.privacy.readReceipts": "قراءة الإيصالات",
  "settings.privacy.readReceiptsHint": "إذا تم تعطيله، فلن يتم إرسال علامات تحديد زرقاء عند قراءة الرسائل. لن ترى الآخرين أيضًا.",
  "settings.privacy.showInfo": "من يرى معلوماتي / حالتي",
  "settings.privacy.showLastSeen": "الذي يرى اتصالي الأخير",
  "settings.privacy.showOnline": "من يرى إذا كنت متصلاً بالإنترنت",
  "settings.privacy.showPhoto": "من يرى صورتي",
  "settings.privacy.title": "خصوصية",
  "settings.privacy.whoAdds": "من يمكنه إضافتي إلى المجموعات",
  "settings.profile.adjustPhoto": "ضبط صورتك",
  "settings.profile.changePhoto": "تغيير الصورة",
  "settings.profile.displayName": "اسم العرض",
  "settings.profile.displayNamePh.freq": "(يرث من العالمي)",
  "settings.profile.displayNamePh.global": "(بدون اسم - سيتم عرض نكك)",
  "settings.profile.hintFreq": "يؤدي ذلك إلى تجاوز ملف التعريف العام عندما تكون في {0} . إذا لم تحدد شيئًا ما هنا، فإنه يرث من global.",
  "settings.profile.hintGlobal": "يتم استخدام هذه القيم افتراضيًا ويتم توريثها في جميع IKO .",
  "settings.profile.info": "معلومات / الحالة",
  "settings.profile.infoPh": "مرحبًا، أستخدم IKOGNIT",
  "settings.profile.photo": "صورة الملف الشخصي",
  "settings.profile.removeOverride": "إزالة التجاوز لـ {0}",
  "settings.profile.removePhoto": "إزالة الصورة",
  "settings.profile.title": "حساب تعريفي",
  "settings.profile.warn": "سيتم إرسال التغييرات إلى بقية جهات الاتصال الخاصة بك تلقائيًا عندما تتفاعل معهم في هذا IKO .",
  "settings.scope.freq": "فقط في {0}",
  "settings.scope.global": "عالمي ( IKOGNIT )",
  "settings.session.remember": "تذكر تفعيلها IKO",
  "settings.session.rememberHint": "في حالة تمكينه، يظهر IKO الذي قمت بتنشيطه كاختصارات في الشريط الجانبي. يمكن لأي شخص يرى شاشتك معرفة IKO التي أدخلتها، لذلك يتم تعطيلها افتراضيًا. يؤدي إيقاف تشغيله إلى مسح تلك المحفوظة بالفعل.",
  "settings.session.timeout": "أغلق IKO بعد عدم النشاط",
  "settings.session.timeoutHint": "إذا قضيت هذا الوقت دون لمس التطبيق، فسيتم إلغاء تنشيط IKO النشط تلقائيًا وستعود إلى IKOGNIT . \\\"أبدًا\\\" يحتفظ بـ IKO حتى تغلق التطبيق.",
  "settings.session.title": "حصة",
  "settings.tab.about": "ℹ حول",
  "settings.tab.account": "🆔 الحساب",
  "settings.tab.blocked": "🚫 محظور",
  "settings.tab.language": "🌐 اللغة",
  "settings.tab.legal": "قانوني",
  "settings.tab.messages": "✉ الرسائل",
  "settings.tab.notifications": "🔔 الإخطارات",
  "settings.tab.privacy": "🔒 الخصوصية",
  "settings.tab.profile": "👤 الملف الشخصي",
  "settings.tab.session": "⏱ الجلسة",
  "settings.title": "إعدادات",
  "settings.vis.all": "الجميع",
  "settings.vis.contacts": "جهات الاتصال الخاصة بي",
  "settings.vis.none": "لا أحد",
  "sidebar.addContact": "إضافة جهة اتصال عن طريق نيك",
  "sidebar.exitFreq": "العودة إلى IKOGNIT",
  "sidebar.forget": "ننسى الجهاز",
  "sidebar.freq": "الحالي IKO : {0}",
  "sidebar.freqPrivate": "الشخصية IKO : {0}",
  "sidebar.freqPsh": "المجال IKO : {0}",
  "sidebar.freqPublic": "IKO : {0}",
  "sidebar.general": "IKOGNIT",
  "sidebar.logout": "تسجيل الخروج",
  "sidebar.newGroup": "مجموعة جديدة",
  "sidebar.notifications": "إشعارات",
  "sidebar.remember": "تذكر الجهاز",
  "sidebar.savedFreq.tooltip": "تفعيل {0}",
  "sidebar.settings": "إعدادات",
  "sidebar.tooltip.logout": "قم بتسجيل الخروج ومسح كل شيء محليًا",
  "sidebar.tune": "تفعيل IKO",
  "stickers.animals": "الحيوانات",
  "stickers.faces": "وجوه",
  "stickers.food": "طعام",
  "stickers.gestures": "الإيماءات",
  "stickers.hearts": "قلوب",
  "stickers.symbols": "الرموز",
  "timeout.15min": "15 دقيقة",
  "timeout.30min": "30 دقيقة",
  "timeout.5min": "5 دقائق",
  "timeout.never": "أبداً",
  "toast.group": "{0} (مجموعة)",
  "toast.newMessage": "رسالة جديدة",
  "totp.copyCode": "نسخ الرمز",
  "totp.copySecret": "نسخ السر",
  "totp.hideSecret": "إخفاء السر",
  "totp.invalid": "سر غير صالح",
  "totp.showSecret": "أظهر السر",
  "ttl.12m": "12 شهرا",
  "ttl.1d": "يوم واحد",
  "ttl.1h": "1 ساعة",
  "ttl.1m": "شهر واحد",
  "ttl.1w": "1 أسبوع",
  "ttl.6m": "6 أشهر",
  "uib.context.coordTitle": "الـIKO",
  "uib.context.general": "IKO العام",
  "uib.e2e.label": "خادم أعمى",
  "uib.e2e.title": "لا يمكن للخادم قراءة المحتوى الخاص بك — تشفير E2E بمفتاحك",
  "uib.exitLabel": "مخرج",
  "uib.exitTitle": "العودة إلى IKO العام",
  "uib.modes.private": "شخصي IKO",
  "uib.modes.shared": "IKO",
  "uib.nickTitle": "نك الخاص بك",
  "uib.pseudoTitle": "اسمك المستعار في هذا IKO",
  "vault.addField": "إضافة حقل",
  "vault.confirmDelete": "هل تريد حذف هذا العنصر؟ لا يمكن استعادتها.",
  "vault.copied": "منقول ✓",
  "vault.copy": "ينسخ",
  "vault.delete": "يمسح",
  "vault.edit": "يحرر",
  "vault.empty": "مجلد الخاص بك فارغ. قم بإنشاء العنصر الأول الخاص بك.",
  "vault.field.address": "عنوان",
  "vault.field.birthdate": "تاريخ الميلاد",
  "vault.field.cardBrand": "ماركة",
  "vault.field.cardCvv": "CVV",
  "vault.field.cardExpiry": "انتهاء الصلاحية (شهر/سنة)",
  "vault.field.cardHolder": "حامل البطاقة",
  "vault.field.cardNumber": "رقم",
  "vault.field.city": "مدينة",
  "vault.field.country": "دولة",
  "vault.field.dni": "رقم الهوية / الضمان الاجتماعي",
  "vault.field.email": "بريد إلكتروني",
  "vault.field.firstname": "الاسم الأول",
  "vault.field.labelPh": "تسمية الحقل",
  "vault.field.lastname": "اسم العائلة",
  "vault.field.name": "اسم",
  "vault.field.name.ph": "كيف تسميها؟",
  "vault.field.newField": "مجال",
  "vault.field.password": "كلمة المرور",
  "vault.field.phone": "هاتف",
  "vault.field.sshFingerprint": "بصمة",
  "vault.field.sshHost": "يستضيف",
  "vault.field.sshPrivate": "مفتاح خاص",
  "vault.field.sshPublic": "المفتاح العام",
  "vault.field.totp": "TOTP",
  "vault.field.url": "URL",
  "vault.field.username": "اسم المستخدم",
  "vault.field.zip": "الرمز البريدي",
  "vault.fieldPlural": "الحقول",
  "vault.fieldSingular": "مجال",
  "vault.ft.date": "تاريخ",
  "vault.ft.email": "بريد إلكتروني",
  "vault.ft.number": "رقم",
  "vault.ft.password": "كلمة المرور",
  "vault.ft.text": "نص",
  "vault.ft.textarea": "نص طويل",
  "vault.ft.url": "URL",
  "vault.hide": "يخفي",
  "vault.new": "عنصر جديد",
  "vault.noMatches": "لا يوجد عنصر يطابق البحث.",
  "vault.notes": "ملحوظات",
  "vault.removeField": "قم بإزالة هذا الحقل",
  "vault.save": "يحفظ",
  "vault.search": "يبحث…",
  "vault.sensitive": "حساس",
  "vault.sensitiveHint": "يتم إخفاء الحقول الحساسة بشكل افتراضي ويمكن نسخها إلى الحافظة.",
  "vault.show": "يعرض",
  "vault.startHint": "حدد عنصرًا من اليسار أو قم بإنشاء عنصر جديد.",
  "vault.tpl.confirmDelete": "هل تريد حذف هذا القالب؟ تبقى العناصر التي تم إنشاؤها منه.",
  "vault.tpl.edit": "تحرير القالب",
  "vault.tpl.empty": "ليس لديك قوالب بعد. قم بإنشاء واحد لتحديد نوع العنصر الخاص بك.",
  "vault.tpl.manage": "إدارة القوالب",
  "vault.tpl.name": "اسم القالب",
  "vault.tpl.name.ph": "على سبيل المثال: محفظة العملات المشفرة، حجز الفنادق...",
  "vault.tpl.new": "قالب جديد",
  "vault.tpl.title": "قوالب",
  "vault.tpl.yours": "القوالب الخاصة بك",
  "vault.type.card": "بطاقة",
  "vault.type.custom": "مخصص",
  "vault.type.identity": "هوية",
  "vault.type.login": "تسجيل الدخول",
  "vault.type.sshkey": "مفتاح سش",
  "vault.untitled": "بدون عنوان",
  "web.footer.line": "خط",
  "web.footer.palette": "لوحة",
  "web.footer.send": "يرسل",
  "welcome.btnContacts": "أضف جهة اتصال",
  "welcome.btnFreq": "تفعيل IKO",
  "welcome.concept": "في IKOGNIT تتحدث مع مستخدمين آخرين تم تحديدهم بواسطة نكك. عندما تريد مساحة منفصلة، ​​يمكنك تنشيط IKO والدخول إلى IKO. إذا كان عامًا، فستلتقي بأولئك الذين يقومون بتنشيطه أيضًا. إذا كان خاصًا، فأنت تدخل عالمًا لا يوجد فيه أحد سواك.",
  "welcome.multidevice": "IKO لا يتم تخزينها في أي مكان أبدًا. إذا نسيت IKO، فإن IKO الخاص به سيتوقف عن الوجود بالنسبة لك.",
  "welcome.step1": "قم بتنشيط IKO وادخل إلى IKO مع أولئك الذين يعرفونه أيضًا.",
  "welcome.step2": "هنا في IKOGNIT، أضف كنية كجهة اتصال وابدأ في التحدث.",
  "welcome.step3": "قم بتنشيط IKO شخصي وافتح عالمًا مخصصًا لك فقط، حيث يمكنك الاحتفاظ بالملفات والصور والتسجيلات الصوتية ومقاطع الفيديو وكلمات المرور والملاحظات والرسائل.",
  "welcome.title": "مرحبًا بك في IKOGNIT",

};

const hi: Catalog = {
  "auth.verify.notSent": "हम आपको कोड नहीं भेज सके। आपका खाता बन चुका है: थोड़ी देर में «कोड दोबारा भेजें» दबाइए।",
  "lg.rotulo": "निजी जगहों वाला मैसेजिंग ऐप",
  "lg.btn.entrar": "लॉग इन करें",
  "lg.eyebrow": "निजी मैसेजिंग · Itrion Software",
  "lg.h1a": "आपकी हमेशा वाली बातचीत।",
  "lg.h1b": "और एक जगह जो तभी होती है जब आप उसे बुलाते हैं।",
  "lg.lead1": "आप अपने परिवार से, दोस्तों से और अपनी टीम से बात करते हैं, किसी भी ऐप की तरह। फ़र्क़ तब शुरू होता है जब आप एक IKO खोलते हैं: आपकी अपनी जगह, जिसमें वही राज़ लिखकर घुसा जाता है जो सिर्फ़ अंदर वालों को पता है।",
  "lg.lead2": "जब तक आप उसे नहीं बुलाते, वह जगह आपके डिवाइस पर होती ही नहीं — न फ़ोन में, न टैबलेट में, न कंप्यूटर में। बात यह नहीं कि वह एन्क्रिप्टेड है।",
  "lg.lead2b": "बात यह है कि वह है ही नहीं।",
  "lg.pruebalo": "खुद आज़माइए · एक राज़ लिखिए और देखिए क्या होता है",
  "lg.panel.plano": "सामान्य तल",
  "lg.demo.hilos": "परिवार=मम्मी: रविवार को अपने यहाँ खाना खाएँ?=19:04|मार्ता=शनिवार की तस्वीरें भेज रही हूँ=17:52|टीम=लुइस: तो कल नौ बजे=कल|खावी=हाहा यक़ीन नहीं होता=कल",
  "lg.demo.mundos": "सिर्फ़ हम दोनों~जहाँ तय किया था वहीं रखा?|हाँ। कागज़ात और पासपोर्ट>~मकान के कागज़ात.pdf=2.4 MB|निजी तस्वीरें=214|कार्ड · बैंक=डेटा~~घर की चीज़ें~किराए का अनुबंध यहाँ रख रहा हूँ>|और राउटर की चाबी, तुम हमेशा खो देती हो~किराया अनुबंध.pdf=1.1 MB|पहचान पत्र की कॉपी=2 फ़ाइलें|घर की चाबियाँ=डेटा~~मेरे नोट्स~यह मैंने किसी को नहीं बताया>|और बताने की ज़रूरत भी नहीं>~डायरी=48 नोट|तस्वीरें=1,207|साल का हिसाब=डेटा~~लिस्बन परियोजना~प्रस्ताव 180 पर आता है|यह रहा, बाहर कोई कॉपी नहीं>~प्रस्ताव_v4.pdf=860 KB|संपर्क=12|कंपनी का कार्ड=डेटा~~शनिवार का खाना~मार्ता को अभी कुछ मत कहना|आराम से, यहाँ किसी को पता नहीं चलता>~बुकिंग.pdf=120 KB|पिछले साल की तस्वीरें=63|मेहमानों की सूची=डेटा",
  "lg.invocaLabel": "अपना IKO बुलाइए",
  "lg.invocaPlaceholder": "कोई भी राज़ लिखिए",
  "lg.invocaBtn": "बुलाएँ",
  "lg.invocaHint": "हर शब्द किसी और जगह ले जाता है। कोई दूसरा आज़माइए।",
  "lg.estela.vacio": "कुछ भी लिखिए: यहाँ यह एक प्रदर्शन है।",
  "lg.estela.primero": "आ गया। यह सिर्फ़ तब तक है जब तक आप अंदर हैं।",
  "lg.estela.otro": "दूसरा राज़, दूसरी जगह। किसी को दूसरे का पता नहीं।",
  "lg.estela.salida": "चला गया। डिवाइस पर कोई निशान नहीं बचा। कोई दूसरा शब्द आज़माइए।",
  "lg.ikoActivo": "IKO सक्रिय",
  "lg.nadaEnDispositivo": "इसमें से कुछ भी डिवाइस पर नहीं है",
  "lg.salirIko": "IKO से बाहर निकलें",
  "lg.planos.h2a": "एक तल जो सबको दिखता है।",
  "lg.planos.h2b": "उसके नीचे, वे जिन्हें आप बुलाते हैं।",
  "lg.planos.lead": "«वह IKO» जैसा कुछ नहीं होता। वे होते हैं जिन्हें आप खोलते हैं: एक घर की चीज़ों के लिए, एक काम के लिए, एक जिसे सिर्फ़ आप दो जानते हैं, एक जिसके बारे में आपने किसी को कभी नहीं बताया। हर राज़ अपने वाले तक ले जाता है, और किसी को बाक़ी का पता नहीं होता।",
  "lg.planos.unoRotulo": "सामान्य तल · एक",
  "lg.planos.unoH3": "जहाँ आप सबसे बात करते हैं",
  "lg.planos.unoP": "बातचीत, समूह, कॉल, तस्वीरें और फ़ाइलें, एंड-टू-एंड एन्क्रिप्टेड। एक मैसेजिंग ऐप से आप जो उम्मीद करते हैं, ढंग से बनाया हुआ। आपकी हमेशा वाली चैट यहीं रहती हैं और हमेशा की तरह काम करती हैं।",
  "lg.planos.nRotulo": "IKO · जितने चाहें",
  "lg.planos.nH3": "जहाँ और कोई नहीं पहुँचता",
  "lg.planos.nP": "आप एक राज़ लिखते हैं और उससे जुड़ी जगह प्रकट हो जाती है। उसके भीतर बातचीत और आपकी चीज़ें समा जाती हैं। जब आप निकलते हैं, वह बिना निशान छोड़े डिवाइस से चली जाती है। न कोई सूची है, न कोई गिनती, और कोई पता नहीं लगा सकता कि आपके पास कितने हैं, या एक भी है या नहीं।",
  "lg.planos.chips": "घर की चीज़ें|काम|जो सिर्फ़ आप दो जानते हैं|सिर्फ़ आपका, और किसी का नहीं|जो एक बार खोला और फिर कभी नहीं|जो कल तय करेंगे",
  "lg.forense.h2a": "यह आपके डिवाइस पर एन्क्रिप्टेड नहीं है।",
  "lg.forense.h2b": "यह आपके डिवाइस पर है ही नहीं।",
  "lg.forense.lead": "बाक़ी ऐप आपके संदेश डिवाइस पर रखते हैं और उन्हें एन्क्रिप्ट करते हैं। अगर कोई डिवाइस ले जाए, तो आपकी निजता इस पर टिकी होती है कि वह एन्क्रिप्शन कितनी देर टिकता है। यहाँ कुछ ऐसा है ही नहीं जिसे टिकना पड़े: IKO के भीतर जो रहता है, वह किसी डिवाइस पर लिखा ही नहीं जाता। बुलाया जाता है, इस्तेमाल होता है, और चला जाता है।",
  "lg.forense.multi": "हर जगह एक जैसा: फ़ोन, टैबलेट, घर का कंप्यूटर, दफ़्तर का लैपटॉप, विंडोज़, मैक, या किसी पराई जगह का ब्राउज़र। जहाँ चाहें घुसिए, और निकलते ही वह जगह फिर से आपके बारे में कुछ नहीं जानती।",
  "lg.forense.caption": "आपका कोई भी डिवाइस जाँचने वाले को क्या मिलता है",
  "lg.forense.filas": "आपके IKO के संदेश=0|आपके IKO की फ़ाइलें और तस्वीरें=0|सहेजे गए IKO राज़=0|आपके IKO वाला डेटाबेस=मौजूद नहीं|IKO खुला होने का निशान=कोई नहीं|आपके पास कितने IKO हैं=पता नहीं लगाया जा सकता",
  "lg.escenas.h2": "जो सचमुच आपको चिंता में डालता है।",
  "lg.escenas.filas": "«मेरा फ़ोन खो गया।»=आपकी निजता उसके साथ नहीं गई। जो IKO के भीतर था वह उस डिवाइस पर कभी था ही नहीं, इसलिए न कुछ बचाना है और न डरना है। किसी भी दूसरे डिवाइस से उसे बुलाइए और सब कुछ वहीं है जहाँ था।~«कोई मेरा लैपटॉप ले गया।»=उसे आपकी सामान्य बातचीत दिखेगी, वही जो किसी भी ऐप में दिखती। बाक़ी का न उसे विषय दिखेगा, न नाम, न इस बात का कोई संकेत कि वह मौजूद है।~«उन्होंने मेरा कंप्यूटर जाँचा।»=फ़ोरेंसिक जाँच डिस्क पर लिखा हुआ सब निकाल लेती है, चाहे एन्क्रिप्टेड और मिटाया हुआ हो। यहाँ निकालने लायक़ कुछ लिखा ही नहीं होता। जवाब यह नहीं कि «खोला नहीं जा सकता»: जवाब यह है कि वहाँ कुछ है ही नहीं। यही बात टैबलेट, फ़ोन और उस ब्राउज़र पर भी लागू है जो आपने एक दोपहर इस्तेमाल किया था।",
  "lg.ciego.h2": "हम भी नहीं। और सर्वर रखने वाले भी नहीं।",
  "lg.ciego.p1": "सर्वर वे चीज़ें रखता है जिन्हें वह पढ़ नहीं सकता। उसके पास आपका राज़ नहीं है, कभी था भी नहीं, और कहीं कोई प्रति मौजूद नहीं है। बात यह नहीं कि हम आपके IKO का सामान देने से इनकार करते हैं: बात यह है कि वह हमारे पास है ही नहीं, और हो भी नहीं सकता। न उस कंपनी के पास जो मशीनें रखती है, न उसके पास जो उन तक पहुँच जाए।",
  "lg.ciego.p2": "इसकी क़ीमत है और उसे कहना ठीक है: अगर आपने अपना राज़ खो दिया, तो उसे लौटाने वाला कोई नहीं। ठीक वही वजह जिसके चलते कोई और अंदर नहीं आ सकता, वही वजह है कि हम भी आपको अंदर नहीं पहुँचा सकते।",
  "lg.guardas": "परिवार की तस्वीरें|वे नोट जो आप किसी को नहीं दिखाते|कार्ड और बैंक की जानकारी|पासवर्ड|दस्तावेज़|वे बातें जो सिर्फ़ आपसे जुड़ी हैं",
  "lg.nombre.esta": "है",
  "lg.nombre.noEsta": "नहीं है",
  "lg.nombre.h2": "नाम यहीं से आया।",
  "lg.nombre.p": "स्वाहिली में iko का अर्थ है «है» और haiko का «नहीं है»। IKO तब तक है जब तक आप उसे बुलाते हैं। बाक़ी समय — यानी लगभग हमेशा — वह नहीं है: न आपके डिवाइसों पर, न किसी की नज़र में, न शक के तौर पर भी।",
  "lg.cierre.h2": "बात करना शुरू कीजिए।",
  "lg.cierre.p": "इसे किसी भी मैसेजिंग ऐप की तरह इस्तेमाल कीजिए — फ़ोन पर, टैबलेट पर और कंप्यूटर पर। जिस दिन आपको IKO की ज़रूरत होगी, वे वहीं होंगे।",
  "lg.cierre.btnCrear": "खाता बनाएँ",
  "lg.cierre.btnEntrar": "मेरा खाता पहले से है",
  "lg.cierre.pago": "IKOGNIT एक सशुल्क उत्पाद है। न विज्ञापन, न विज्ञापन प्रोफ़ाइल, और हमारे पास किसी चीज़ की कोई प्रति नहीं: हम इस बात से चलते हैं कि ऐप आपके पैसे के लायक़ हो, न कि उससे जो आप उसके भीतर कहते हैं।",
  "lg.pie.ciego": "अंधा सर्वर",
  "auth.hola": "फिर से नमस्ते।",
  "auth.queEs": "IKOGNIT क्या है?",
  "auth.btn.backToUnlock": "पीछे",
  "auth.btn.createIdentity": "खाता बनाएं",
  "auth.btn.forget": "इस उपकरण को भूल जाओ",
  "auth.btn.processing": "प्रसंस्करण…",
  "auth.btn.unlock": "दाखिल करना",
  "auth.btn.unlocking": "इन कर रहे हैं…",
  "auth.btn.useOther": "दूसरे खाते का उपयोग करें",
  "auth.confirmForget": "यह डिवाइस तुम्हें पहचानना बंद कर देगा: सहेजा गया खाता और कैश में जो कुछ है, सब मिट जाएगा। दोबारा दाखिल होने के लिए पासवर्ड चाहिए होगा।",
  "auth.confirmForget.warning": "24 शब्दों का रिकवरी वाक्यांश लिखकर न रखा हो तो लौटने का रास्ता नहीं: कोई इसे वापस नहीं दे सकता।",
  "invite.welcomeSub": "संदेश और अपनी एक जगह: जो तुम यहाँ रखते हो वह तुम्हारे नाम दर्ज है। खाता बनाओ और आप जुड़ जाएँगे।",
  "auth.reset.warnNewIdentity": "खाता तुम्हारा ही रहेगा, पर ईमेल से रिकवरी तुम्हें नई पहचान देती है: पुराने संदेश फिर नहीं पढ़े जा सकेंगे। अगर 24 शब्दों का रिकवरी वाक्यांश तुम्हारे पास है, तो वही रास्ता लो।",
  "recover.intro": "अपना निक या ईमेल लिखो और वे 24 रिकवरी शब्द जो खाता बनाते समय दिए गए थे। उसके बाद नया पासवर्ड चुनोगे।",
  "auth.error.badCreds": "ग़लत उपनाम/ईमेल या पासवर्ड.",
  "auth.error.badPin": "ग़लत कुंजी.",
  "auth.error.cantConnect": "सर्वर से कनेक्ट नहीं हो सका.",
  "auth.error.legalRequired": "अपना खाता बनाने के लिए आपको कानूनी शर्तों को स्वीकार करना होगा और अपनी उम्र की पुष्टि करनी होगी।",
  "auth.error.userNotFound": "खाता नहीं मिला।",
  "auth.field.devicePin": "डिवाइस PIN",
  "auth.field.emailPlaceholder": "you@email.com",
  "auth.field.nickPlaceholder": "जैसे user123",
  "auth.field.password": "पासवर्ड",
  "auth.footnote": "जो मालिक है, वही ज़िम्मेदार है।\nपासवर्ड खो गया तो\nकिसी से कुछ नहीं माँगा जा सकता।",
  "auth.legal.accept": "मैंने <a href='https://ikognit.org/legal/en/terms.html' target='_blank' rel='noopener'> शर्तें </a>, <a href='https://ikognit.org/legal/en/privacy.html' target='_blank' rel='noopener'> गोपनीयता नीति </a> और <a href='https://ikognit.org/legal/en/community-rules.html' target='_blank' rel='noopener'> सामुदायिक नियम </a> पढ़ ली हैं और उन्हें स्वीकार कर लिया है।",
  "auth.legal.age": "मैं पुष्टि करता हूं कि मैं IKOGNIT का उपयोग करने के लिए अपने देश के कानून द्वारा आवश्यक न्यूनतम आयु को पूरा करता हूं।",
  "auth.loading": "लोड हो रहा है...",
  "auth.savedSession": "यह डिवाइस अपने मालिक को पहचानता है।",
  "auth.locked": "निष्क्रियता से ओझल हो गया। दोबारा दाखिल हो।",
  "auth.sessionExpired": "सत्र ओझल हो गया। दोबारा दाखिल हो।",
  "auth.subLogin": "आप सामान्य तल में आ रहे हैं: आपकी हमेशा वाली बातचीत। IKO यहाँ नहीं बुलाए जाते — वे अंदर बुलाए जाते हैं, जब आपको उनकी ज़रूरत हो।",
  "auth.subRegister": "खाता तुम्हारे नाम पर दर्ज होता है। निक वह है जो दूसरों को दिखता है; ईमेल सिर्फ़ पहुँच वापस पाने और सूचनाओं के लिए है।",
  "auth.tab.login": "दाखिल करना",
  "auth.tab.register": "नया खाता",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "स्वाहिली में iko का अर्थ है «है», और haiko का «नहीं है»।",
  "billing.manage": "प्रबंधित करना",
  "billing.needsUpgrade": "आपने अपने स्तर की सीट सीमा पार कर ली है। अधिक सीटें जोड़ने के लिए अपग्रेड करें।",
  "billing.portal": "भुगतान प्रबंधित करें",
  "billing.renews": "नवीनिकृत",
  "billing.seats": "सीटें",
  "billing.title": "बिलिंग",
  "billing.upgradeTo": "अपग्रेड टियर ({price} /सीट)",
  "bubble.contact.label": "[[टी0]] संपर्क करें",
  "bubble.edit": "संपादन करना",
  "bubble.edited": "संपादित",
  "bubble.forward": "आगे",
  "bubble.media.decrypting": "डिक्रिप्ट किया जा रहा है...",
  "bubble.media.failed": "फ़ाइल को डिक्रिप्ट नहीं किया जा सका.",
  "bubble.reply": "जवाब",
  "bubble.tick.delivered": "वितरित {0}",
  "bubble.tick.read": "Read {0}",
  "bubble.tick.sent": "भेजा",
  "call.accept": "स्वीकार करना",
  "call.audioOut": "ऑडियो आउटपुट",
  "call.audioOut.auto": "ऑटो",
  "call.calling": "कॉल किया जा रहा है...",
  "call.camera": "कैमरा",
  "call.connecting": "कनेक्ट हो रहा है...",
  "call.ending": "समाप्त हो रहा है...",
  "call.error.notInFreq": "कॉल करने के लिए आपको IKO के अंदर होना चाहिए।",
  "call.hangup": "लटकाओ",
  "call.incoming.audio": "एक फोन आ रहा है",
  "call.incoming.video": "इनकमिंग वीडियो कॉल",
  "call.mic": "माइक्रोफ़ोन",
  "call.reject": "अस्वीकार करना",
  "ccb.clock.title": "स्थानीय समय",
  "ccb.identity.title": "सत्र: @ {0}",
  "ccb.leave.aria": "बाहर निकलें IKO",
  "ccb.leave.title": "IKO से बाहर निकलें (IKOGNIT पर वापस जाएं)",
  "ccb.modes.personalPrefix": "निजी ·",
  "ccb.settings.aria": "सेटिंग्स",
  "ccb.settings.title": "सेटिंग्स · प्रोफ़ाइल, थीम, सत्र",
  "ccb.tag.cipher.title": "सममित सिफर सक्रिय",
  "ccb.tag.srv.title": "सर्वर आपकी सामग्री नहीं पढ़ सकता",
  "ccb.tag.unread.title": "अपठित संदेश",
  "ccb.universe.activate": "सक्रिय करें IKO",
  "ccb.universe.changeOrExit": "IKO स्विच करें या बाहर निकलें",
  "chat.action.call": "पुकारना",
  "chat.action.videoCall": "वीडियो कॉल",
  "chat.attach.camera": "कैमरा",
  "chat.attach.file": "फ़ाइल जोड़ें",
  "chat.attach.label": "संलग्न करना",
  "chat.attach.voice": "आवाज़",
  "chat.attachPending": "लंबित अनुलग्नक",
  "chat.backToIkognit.title": "सामान्य पर लौटें IKOGNIT",
  "chat.blocked.text": "आपने {0} को ब्लॉक कर दिया है। आप संदेश नहीं भेज सकते या उन्हें कॉल नहीं कर सकते.",
  "chat.btn.send": "भेजना",
  "chat.call.title": "पुकारना",
  "chat.calls.callContact": "किसी संपर्क को कॉल करें",
  "chat.calls.empty": "अभी तक कोई कॉल नहीं. किसी संपर्क के साथ चैट से शुरुआत करें।",
  "chat.calls.historySoon": "कॉल इतिहास जल्द ही उपलब्ध होगा.",
  "chat.calls.title": "कॉल",
  "chat.cancel.title": "रद्द करना",
  "chat.composer.placeholder": "एक संदेश टाइप करें...",
  "chat.confirmContact": "संपर्क के खाते में जोड़ दे",
  "chat.contact.badgeBlocked": "अवरोधित",
  "chat.contact.badgePending": "अपुष्ट",
  "chat.contacts.empty": "अभी तक कोई संपर्क नहीं.",
  "chat.contacts.noResults": "कोई परिणाम नहीं.",
  "chat.delete.aria": "मिटाना",
  "chat.delete.title": "मिटाना",
  "chat.deleteConv.forAll": "सभी के लिए हटाएँ",
  "chat.deleteConv.forMe": "मेरे लिए हटाएं",
  "chat.deleteConv.hint": "\\\"मेरे लिए\\\" आपकी प्रतिलिपि (आपके सभी उपकरण) हटा देता है। ''सभी के लिए'' संपर्क को अपनी ओर से इसे हटाने के लिए भी कहता है।",
  "chat.deleteConv.titleMany": "{0} वार्तालाप हटाएँ",
  "chat.deleteConv.titleOne": "बातचीत मिटाएं",
  "chat.editPlaceholder": "अपना संदेश संपादित करें...",
  "chat.editing": "संदेश संपादित करना",
  "chat.empty": "कोई संपर्क चुनें या जोड़ें",
  "chat.error.userBlocked": "आपने इस उपयोगकर्ता को ब्लॉक कर दिया है.",
  "chat.filter.all": "सभी",
  "chat.filter.groups": "समूह",
  "chat.filter.unread": "अपठित ग",
  "chat.filters.aria": "चैट फ़िल्टर",
  "chat.group.membersWord": "सदस्यों",
  "chat.header.blocked": "अवरोधित",
  "chat.lastSeen": "अंतिम बार देखा गया {0}",
  "chat.media.delete": "मिटाना",
  "chat.media.deleteConfirmBody": "इस एक्शन को वापस नहीं किया जा सकता।",
  "chat.media.deleteConfirmTitle": "फ़ोटो हटाएं?",
  "chat.media.deleteForAll": "सभी के लिए हटाएँ",
  "chat.media.deleteForMe": "मेरे लिए हटाएं",
  "chat.media.download": "डाउनलोड करना",
  "chat.media.forward": "आगे",
  "chat.media.forwardTo": "आगे प्रेषित",
  "chat.media.share": "शेयर करना",
  "chat.mediaFailed": "लोड नहीं हो सका",
  "chat.mediaRetry": "पुन: प्रयास करें",
  "chat.myContacts": "मेरे संपर्क",
  "chat.nav.aria": "मुख्य नेविगेशन",
  "chat.newCall.empty": "अभी तक कोई संपर्क नहीं. चैट में + से एक जोड़ें।",
  "chat.newCall.title": "नई कॉल",
  "chat.newChat.title": "नई चैट",
  "chat.newMessages": "नया",
  "chat.newMessagesBadge": "{0} नए संदेशों पर जाएं",
  "chat.online": "ऑनलाइन",
  "chat.placeholder": "एक सन्देश लिखिए…",
  "chat.presence.online": "ऑनलाइन",
  "chat.preview.audio": "ऑडियो",
  "chat.preview.image": "छवि",
  "chat.preview.video": "वीडियो",
  "chat.preview.voice": "स्वर संदेश",
  "chat.remove.title": "निकालना",
  "chat.replyingTo": "{0} को उत्तर दिया जा रहा है",
  "chat.search.clear": "स्पष्ट खोज",
  "chat.search.placeholder": "चैट खोजें",
  "chat.tab.calls": "कॉल",
  "chat.tab.chats": "चैट",
  "chat.tab.contacts": "संपर्क",
  "chat.tab.settings": "सेटिंग्स",
  "chat.toast.imageSaved": "छवि फ़ोटो में सहेजी गई",
  "chat.toast.saveError": "त्रुटि सहेजें",
  "chat.toast.saveFailed": "सहेजा नहीं जा सका: {0}",
  "chat.toast.saved": "सहेजा गया",
  "chat.toast.updateTestflight": "सहेजने के लिए TestFlight को 1.0(10)+ पर अपडेट करें।",
  "chat.toast.videoSaved": "वीडियो फ़ोटो में सहेजा गया",
  "chat.tooltip.attach": "फ़ाइल जोड़ें",
  "chat.tooltip.callAudio": "आवाज कॉल",
  "chat.tooltip.callVideo": "वीडियो कॉल",
  "chat.tooltip.paste": "क्लिपबोर्ड से छवि चिपकाएँ",
  "chat.tooltip.shareContact": "संपर्क साझा करें",
  "chat.tooltip.stickers": "स्टिकर",
  "chat.unblock": "अनब्लॉक",
  "chat.unconfirmedBanner": "इस उपयोगकर्ता ने आपको लिखा है लेकिन यह आपके संपर्कों में नहीं है। जब तक आप उन्हें नहीं जोड़ेंगे, आपकी गोपनीयता सेटिंग्स के अनुसार आपकी फ़ोटो और जानकारी उन्हें दिखाई नहीं देगी।",
  "chat.unread.aria": "अपठित संदेश",
  "chat.uploading": "…",
  "chat.videoCall.aria": "{0} के साथ वीडियो कॉल",
  "chat.videoCall.title": "वीडियो कॉल",
  "chat.welcome.intro": "एंड-टू-एंड एन्क्रिप्शन के साथ बातचीत शुरू करने के लिए एक चैट चुनें।",
  "common.add": "जोड़ना",
  "common.back": "पीछे",
  "common.cancel": "रद्द करना",
  "common.close": "बंद करना",
  "common.confirm": "पुष्टि करना",
  "common.delete": "मिटाना",
  "common.error.generic": "नहीं हो पाया। दोबारा कोशिश करो।",
  "common.exit": "बाहर निकलना",
  "common.more": "अधिक",
  "common.save": "बचाना",
  "common.tagline": "डिजिटल संप्रभुता।",
  "contacts.alias.label": "उपनाम",
  "contacts.alias.placeholder": "उन्हें पहचानने के लिए एक उपनाम",
  "contacts.blockBtn": "संपर्क अवरोधित करें",
  "contacts.confirmBlock.body": "ब्लॉक {0} ? आपको उनके मैसेज और कॉल आना बंद हो जाएंगे.",
  "contacts.confirmBlock.title": "संपर्क अवरोधित करें",
  "contacts.confirmUnblock.body": "{0} को अनब्लॉक करें? आपको उनके संदेश दोबारा प्राप्त होंगे.",
  "contacts.confirmUnblock.title": "संपर्क अनब्लॉक करें",
  "contacts.edit.aria": "संपादन करना",
  "contacts.edit.title": "उपनाम संपादित करें और नोट करें",
  "contacts.note.label": "निजी नोट",
  "contacts.notes.placeholder": "केवल आप ही इसे देख सकते हैं (सर्वर पर एन्क्रिप्टेड)।",
  "contacts.search.placeholder": "उपनाम या IKOGNIT आईडी से खोजें",
  "contacts.unblockBtn": "संपर्क अनब्लॉक करें",
  "ctx.action.contacts": "मेरे संपर्क",
  "ctx.action.newChat": "नई चैट",
  "ctx.action.newGroup": "नया समूह",
  "ctx.aria": "IKO की जानकारी और नेविगेशन",
  "ctx.liturgy.0": "सर्वर अंधा है.",
  "ctx.liturgy.1": "यहां सिर्फ आप ही पढ़ते हैं.",
  "ctx.liturgy.2": "कोई नहीं जानता कि तुम यहाँ हो.",
  "ctx.liturgy.3": "एक IKO एक रहस्य है जिसे केवल आप ही जानते हैं।",
  "ctx.liturgy.4": "आपकी गोपनीयता वास्तुकला है.",
  "ctx.modes.private": "व्यक्तिगत IKO",
  "ctx.modes.storage": "ड्राइव",
  "ctx.modes.shared": "[[टी0]]",
  "ctx.nav.activateIko": "एक IKO सक्रिय करें",
  "ctx.nav.backToIkognit": "IKOGNIT पर वापस जाएँ",
  "ctx.nav.changeIko": "स्विच IKO",
  "ctx.peer.message": "{0} message",
  "ctx.peer.messages": "{0} messages",
  "ctx.peer.offline": "ऑफलाइन",
  "ctx.peer.online": "ऑनलाइन",
  "ctx.section.actions": "कार्रवाई",
  "ctx.section.conversation": "बातचीत",
  "ctx.section.nav": "मार्गदर्शन",
  "ctx.section.universe": "वर्तमान IKO",
  "ctx.status.e2e": "एंड-टू-एंड एन्क्रिप्शन",
  "ctx.status.serverBlind": "ब्लाइंड सर्वर सक्रिय",
  "ctx.universe.personal": "आपका व्यक्तिगत स्थान",
  "demo.edit": "संपादन करना",
  "error.blocked": "आपने इस उपयोगकर्ता को ब्लॉक कर दिया है. दोबारा बात करने के लिए सेटिंग्स में अनब्लॉक करें।",
  "error.cantAcceptCall": "कॉल स्वीकार नहीं कर सका: {0}",
  "error.cantPaste": "क्लिपबोर्ड तक नहीं पहुंच सका. संलग्न बटन का उपयोग करने का प्रयास करें.",
  "error.cantStartCall": "कॉल प्रारंभ नहीं हो सका: {0}",
  "error.clipboardUnsupported": "आपका ब्राउज़र क्लिपबोर्ड पढ़ने की अनुमति नहीं देता है. Ctrl+V से चिपकाएँ या अटैच बटन का उपयोग करें।",
  "error.expired": "सत्र समाप्त हुआ। पुनः साइन इन करें.",
  "error.gone": "फ़ाइल समाप्त हो गई है.",
  "error.invalid": "अमान्य डेटा।",
  "error.network": "सर्वर से कोई कनेक्शन नहीं.",
  "error.noImageInClipboard": "क्लिपबोर्ड में कोई छवि नहीं है.",
  "error.notFound": "संसाधन नहीं मिला.",
  "error.notInFreq": "{0} अभी तक इस IKO में नहीं है। इसे सक्रिय करने के लिए किसी अन्य चैनल के माध्यम से उनसे पूछें।",
  "error.push.activateFailed": "सक्रिय नहीं किया जा सका ({0})।",
  "error.push.denied": "आपने अधिसूचना अनुमति अस्वीकार कर दी.",
  "error.push.iosNotStandalone": "iPhone पर सूचनाएं प्राप्त करने के लिए, होम स्क्रीन पर IKOGNIT इंस्टॉल करें: शेयर करें → होम स्क्रीन में जोड़ें टैप करें।",
  "error.push.iosTooOld": "आपका iOS 16.4 से पुराना है. सूचनाएं प्राप्त करने के लिए इसे अपडेट करें.",
  "error.push.noPush": "यह ब्राउज़र पुश नोटिफिकेशन का समर्थन नहीं करता है.",
  "error.push.noSw": "यह ब्राउज़र सेवा कर्मियों का समर्थन नहीं करता.",
  "error.push.noVapid": "सर्वर ने VAPID कुंजी प्रदान नहीं की.",
  "error.selfContact": "आप स्वयं को नहीं जोड़ सकते.",
  "error.server": "सर्वर त्रुटि. कृपया पुन: प्रयास करें।",
  "explorer.filesNotProcessed": "असंसाधित फ़ाइल",
  "holo.card.cipher": "सिफ़र",
  "holo.card.contacts": "संपर्क",
  "holo.card.conversations": "बात चिट",
  "holo.card.server": "सर्वर",
  "holo.claim.general": "IKOGNIT में आपका व्यक्तिगत स्थान। यहां आप अपने कॉन्टैक्ट्स से बात करते हैं.",
  "holo.claim.inIko": "यह IKO किसी भी ऐसे व्यक्ति के लिए अदृश्य रहता है जो इसे नहीं जानता है।",
  "holo.foot": "कोई वार्तालाप चुनें, IKO सक्रिय करें, या एक नया स्थान बनाएं।",
  "holo.modes.general": "आपका उपनाम + संपर्क",
  "holo.modes.private": "व्यक्तिगत IKO",
  "holo.modes.shared": "[[टी0]]",
  "join.loginToAccept": "साइन इन करें / खाता बनाएं",
  "iko.banner.exitAria": "IKO से बाहर निकलें और सामान्य तल पर लौटें",
  "iko.liturgy.entering": "IKO दर्ज करना",
  "iko.liturgy.returning": "रिटर्निंग",
  "iko.liturgy.toIkognit": "से IKOGNIT",
  "iko.mode.private": "व्यक्तिगत IKO",
  "iko.mode.shared": "[[टी0]]",
  "manifest.blindServer": "सर्वर अंधा है.",
  "manifest.keyWithYou": "चाबी आपके पास रहती है.",
  "manifest.noAdsNoClouds": "कोई विज्ञापन नहीं. कोई बाहरी बादल नहीं.",
  "manifest.noPublicProfiles": "कोई सार्वजनिक प्रोफ़ाइल नहीं.",
  "manifest.onlyYouRead": "यहां सिर्फ आप ही पढ़ते हैं.",
  "manifest.yourIkoYourSpaces": "आपका IKO . आपके स्थान.",
  "media.confirmDelete": "यह आइटम हटाएं? इसे पुनर्प्राप्त नहीं किया जा सकता.",
  "media.delete": "मिटाना",
  "media.download": "डाउनलोड करना",
  "media.empty.audio": "इस यूनिवर्स में अभी तक कोई ऑडियो नहीं है.",
  "media.empty.file": "इस यूनिवर्स में अभी तक कोई फ़ाइल नहीं है.",
  "media.empty.photo": "इस IKO में अभी तक कोई फ़ोटो नहीं है.",
  "media.empty.video": "इस यूनिवर्स में अभी तक कोई वीडियो नहीं है.",
  "media.noPreview": "इस फ़ाइल प्रकार के लिए कोई पूर्वावलोकन नहीं.",
  "media.play": "खेल",
  "media.upload.audio": "ऑडियो अपलोड करें",
  "media.upload.file": "फ़ाइल अपलोड करें",
  "media.upload.photo": "फोटो अपलोड करें",
  "media.upload.video": "वीडियो अपलोड करें",
  "media.uploadFailed": "फ़ाइल अपलोड नहीं हो सकी.",
  "media.uploading": "अपलोड हो रहा है...",
  "mobile.tb.ikoActivate": "सक्रिय करें IKO",
  "mobile.tb.ikoExit": "सामान्य पर वापस जाएँ IKOGNIT",
  "modal.freq.activate": "सक्रिय करें",
  "modal.freq.deriving": "कंप्यूटिंग IKO...",
  "modal.freq.errCommon": "वह IKO बहुत सामान्य है। कुछ अनोखा चुनें.",
  "modal.freq.errRepeat": "एक भी बार-बार दोहराए जाने वाले अक्षर का प्रयोग न करें.",
  "modal.freq.errSeqAlpha": "वर्णमाला क्रम से बचें.",
  "modal.freq.errSeqNum": "स्पष्ट संख्यात्मक अनुक्रमों से बचें.",
  "modal.freq.errShort": "IKO में कम से कम 8 अक्षर होने चाहिए।",
  "modal.freq.hint": "A IKO आपके किसी एक IKO का सटीक IKO है।  [[टी1]] : आप ऐसे व्यक्ति से मिलते हैं जो समान IKO लिखता है। व्यक्तिगत: आप एक ऐसे IKO में पहुँच जाते हैं जहाँ आप अदृश्य हैं, भले ही कोई दूसरा वही लिखता हो। डोमेन: यह एक मालिक का है और आप इसमें तभी शामिल हो सकते हैं जब उन्होंने आपको नामांकित किया हो।",
  "modal.freq.placeholder": "अपने IKO लिखें",
  "modal.freq.title": "IKO सक्रिय करें",
  "modal.freq.warn": "IKO कहीं भी संग्रहीत नहीं हैं. यदि आप उन्हें भूल जाते हैं, तो आपके लिए उस IKO का अस्तित्व समाप्त हो जाएगा।",
  "modal.group.create": "समूह बनाना",
  "modal.group.hint": "इस IKO में एक नाम चुनें और अपने संपर्कों में से सदस्यों का चयन करें।",
  "modal.group.namePh": "समूह नाम",
  "modal.group.selected": "{0} चयनित",
  "modal.group.title": "नया समूह",
  "modal.remember.confirm": "दोहराएँ PIN",
  "modal.remember.errMismatch": "पिन मेल नहीं खाते.",
  "modal.remember.errShort": "PIN में कम से कम 4 अक्षर होने चाहिए।",
  "modal.remember.hint": "आपका सत्र, संपर्क, समूह और संदेश इस डिवाइस पर सहेजे जाएंगे, जिसे PIN के साथ एन्क्रिप्ट किया जाएगा जिसे केवल आप जानते हैं। जब आप ऐप को दोबारा खोलेंगे तो आप अनलॉक करने के लिए PIN दर्ज करेंगे।",
  "modal.remember.pin": "[[टी0]]",
  "modal.remember.title": "इस डिवाइस को याद रखें",
  "modal.remember.warn": "यदि आप PIN भूल जाते हैं, तो सहेजा गया डेटा पुनर्प्राप्त नहीं किया जा सकता है। आपको अपने उपयोगकर्ता नाम और पासवर्ड के साथ फिर से साइन इन करना होगा।",
  "modal.share.btn": "शेयर करना",
  "modal.share.empty": "इसमें कोई संपर्क नहीं IKO",
  "modal.share.filter": "संपर्क फ़िल्टर करें…",
  "modal.share.hint": "सूची से एक संपर्क चुनें या मैन्युअल रूप से एक उपनाम दर्ज करें।",
  "modal.share.manual": "या एक मैनुअल निक",
  "modal.share.title": "संपर्क साझा करें",
  "notes.autosaveHint": "स्वचालित रूप से सहेजा गया, एन्क्रिप्टेड, केवल यहीं।",
  "notes.confirmDelete": "यह नोट हटाएं? इसे पुनर्प्राप्त नहीं किया जा सकता.",
  "notes.contentPlaceholder": "आपको जो कुछ भी याद रखना है उसे लिखें...",
  "notes.delete": "नोट हटाएँ",
  "notes.empty": "आपके पास अभी तक इस IKO में नोट्स नहीं हैं।",
  "notes.emptyPreview": "(खाली)",
  "notes.new": "नया नोट",
  "notes.startHint": "इस IKO में कोई नोट नहीं. पहला बनाएं.",
  "notes.titlePlaceholder": "शीर्षक",
  "notes.untitled": "शीर्षकहीन",
  "notes.yesterday": "कल",
  "orb.copy.line1": "आपका IKO .",
  "orb.copy.line2": "आपके स्थान.",
  "orb.mod.audios": "ऑडियो",
  "orb.mod.chat": "बात करना",
  "orb.mod.files": "फ़ाइलें",
  "orb.mod.notes": "टिप्पणियाँ",
  "orb.mod.photos": "तस्वीरें",
  "orb.mod.vault": "फ़ोल्डर",
  "passwords.confirmDelete": "यह प्रविष्टि हटाएं? इसे पुनर्प्राप्त नहीं किया जा सकता.",
  "passwords.copied": "कॉपी किया गया ✓",
  "passwords.copy": "प्रतिलिपि",
  "passwords.delete": "मिटाना",
  "passwords.edit": "संपादन करना",
  "passwords.empty": "आपने अभी तक इस यूनिवर्स में कोई प्रविष्टि सहेजी नहीं है.",
  "passwords.field.label": "नाम",
  "passwords.field.label.ph": "बैंक, खाता, सेवा...",
  "passwords.field.notes": "टिप्पणियाँ",
  "passwords.field.notes.ph": "कोई उपयोगी विवरण",
  "passwords.field.password": "पासवर्ड",
  "passwords.field.password.ph": "वह पासवर्ड जिसे आप सेव करना चाहते हैं",
  "passwords.field.url": "[[टी0]]",
  "passwords.field.username": "उपयोगकर्ता नाम",
  "passwords.field.username.ph": "ईमेल, उपनाम, नंबर...",
  "passwords.hide": "छिपाना",
  "passwords.new": "नई प्रविष्टि",
  "passwords.save": "बचाना",
  "passwords.show": "दिखाओ",
  "passwords.startHint": "इस IKO में कोई पासवर्ड नहीं। पहला बनाएं.",
  "passwords.untitled": "शीर्षकहीन",
  "piko.cat.all": "सभी",
  "piko.cat.audios": "ऑडियो",
  "piko.cat.cards": "कार्ड",
  "piko.cat.custom": "वॉल्ट",
  "piko.cat.agendas": "IKO निर्देशिकाएँ",
  "piko.cat.storage": "ड्राइव और डिस्क",
  "piko.cat.files": "फ़ाइलें",
  "piko.cat.identities": "पहचान",
  "piko.cat.notes": "टिप्पणियाँ",
  "piko.cat.passwords": "पासवर्डों",
  "piko.cat.photos": "तस्वीरें",
  "piko.cat.sshkeys": "एसएसएच कुंजी",
  "piko.cat.videos": "वीडियो",
  "piko.rail.aria": "व्यक्तिगत IKO श्रेणियाँ",
  "piko.rail.head": "निजी",
  "preview.audio": "🎙ऑडियो",
  "preview.image": "📷छवि",
  "preview.video": "🎬वीडियो",
  "private.badge": "निजी",
  "private.mod.audios": "ऑडियो",
  "private.mod.audios.desc": "रिकॉर्डिंग और वॉयस नोट्स.",
  "private.mod.files": "फ़ाइलें",
  "private.mod.files.desc": "दस्तावेज़, शीट, पीडीएफ़।",
  "private.mod.iko": "मेरा IKO",
  "private.mod.iko.desc": "आपका सहेजा गया IKO, सक्रिय होने के लिए तैयार है।",
  "private.mod.notes": "टिप्पणियाँ",
  "private.mod.notes.desc": "नोट्स, पत्र, डायरी.",
  "private.mod.photos": "तस्वीरें",
  "private.mod.photos.desc": "आपकी निजी गैलरी.",
  "private.mod.vault": "पासवर्ड",
  "private.mod.vault.desc": "पासवर्ड, कार्ड, पहचान, एसएसएच कुंजी और जो कुछ भी आपको चाहिए।",
  "private.mod.videos": "वीडियो",
  "private.mod.videos.desc": "आपके व्यक्तिगत वीडियो.",
  "private.module.coming": "जल्द आ रहा है।",
  "private.module.comingHint": "यह मॉड्यूल बहुत जल्द उपलब्ध होगा. प्राइवेट यूनिवर्स क्रिप्टो पहले से ही काम करता है - जल्द ही आप यहां वह सब कुछ सहेज सकेंगे जिसकी आपको आवश्यकता है।",
  "private.welcome.hint": "प्रारंभ करने के लिए एक अनुभाग चुनें.",
  "private.welcome.intro": "आप ऐसे IKO पर हैं जहां कोई भी आपको नहीं देख सकता। भले ही किसी अन्य व्यक्ति ने वही IKO लिखा हो, वे एक अलग IKO में पहुंच जाएंगे। यहां आप अपना सामान सुरक्षित रखते हैं.",
  "private.welcome.title": "आपका व्यक्तिगत IKO",
  "push.btnDisable": "सूचनाएं चालू. अक्षम करने के लिए क्लिक करें.",
  "push.btnEnable": "सूचनाएं बंद. सक्षम करने के लिए क्लिक करें.",
  "push.btnOff": "सूचनाएं बंद",
  "push.btnOn": "सूचनाएं चालू",
  "push.introBody": "गोपनीयता के लिए, IKOGNIT सूचनाएं अन्य मैसेजिंग ऐप्स से भिन्न हैं:",
  "push.introBullet1": "संदेश सामग्री शामिल नहीं है.",
  "push.introBullet2": "प्रेषक का नाम या उपनाम नहीं दिखाया गया है.",
  "push.introBullet3": "आपको केवल एक \\\"नया संदेश\\\" अलर्ट प्राप्त होगा; अपने डिवाइस पर एन्क्रिप्टेड पढ़ने के लिए ऐप खोलें।",
  "push.introConfirm": "सूचनाएं सक्षम करें",
  "push.introTitle": "सूचनाएं सक्षम करने से पहले",
  "recovery.btn.back": "शब्दों को देखने के लिए वापस जाएँ",
  "recovery.btn.cleared": "क्लिपबोर्ड साफ़ किया गया",
  "recovery.btn.continue": "जारी रखना",
  "recovery.btn.copied": "कॉपी किया गया · {0} s में साफ़ हो जाता है",
  "recovery.btn.copy": "प्रतिलिपि",
  "recovery.btn.copyAria": "पुनर्प्राप्ति वाक्यांश को क्लिपबोर्ड पर कॉपी करें (स्वतः साफ़ हो जाएगा)",
  "recovery.btn.done": "मेरा काम हो गया",
  "recovery.btn.download": "डाउनलोड करना",
  "recovery.btn.downloadAria": "वाक्यांश को टेक्स्ट फ़ाइल के रूप में डाउनलोड करें",
  "recovery.btn.need3": "3 सही शब्द टाइप करें",
  "recovery.btn.show": "शब्द दिखाओ",
  "recovery.intro": "यदि आप अपना पासवर्ड भूल जाते हैं या अपना डिवाइस खो देते हैं तो ये **24 शब्द** आपके खाते और इतिहास को पुनर्प्राप्त करने का एकमात्र तरीका हैं। **उन्हें कागज पर लिखें और उन्हें एक सुरक्षित स्थान पर रखें।** IKOGNIT पर कोई भी उन्हें आपके लिए पुनर्प्राप्त नहीं कर सकता है।",
  "recovery.title": "आपकी पुनर्प्राप्ति कुंजी",
  "recovery.verify.correct": "सही",
  "recovery.verify.intro": "यह पुष्टि करने के लिए कि आपने अपनी कुंजी सहेज ली है, ये शब्द टाइप करें। आप उन्हें ठीक किए बिना जारी नहीं रख सकते।",
  "recovery.verify.wordN": "शब्द # {0}",
  "recovery.verify.wrong": "ग़लत",
  "recovery.warn": "**उन्हें ऑफ़लाइन लिखें।** स्क्रीनशॉट न लें। उन्हें ईमेल या मैसेजिंग द्वारा न भेजें. जिसके पास भी ये शब्द हैं वो आपके पूरे अकाउंट को कंट्रोल करता है.",
  "savediko.activate": "सक्रिय करें IKO",
  "savediko.add": "एक IKO सहेजें",
  "savediko.confirmDel": "मिटाना?",
  "savediko.descLabel": "विवरण",
  "savediko.descPh": "बाद में इसे पहचानने का विवरण",
  "savediko.empty": "आपने अभी तक कोई IKO सहेजा नहीं है।",
  "savediko.errDesc": "विवरण दर्ज करें.",
  "savediko.errIko": "IKO लिखें.",
  "savediko.formEdit": "संपादित करें सहेजा गया IKO",
  "savediko.formNew": "एक IKO सहेजें",
  "savediko.intro": "जिन IKO को याद नहीं रखना चाहते, उन्हें यहाँ रखें। आपको एक याद रहता है और बाकी उसी के भीतर रहते हैं।",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "IKO लिखें",
  "settings.about.tech": "E2E NaCl बॉक्स (X25519) के साथ एन्क्रिप्शन।  IKO : आर्गन2आईडी व्युत्पत्ति + नियतात्मक एचएमएसी। PIN पर Argon2id के साथ स्थानीय एन्क्रिप्टेड दृढ़ता।",
  "settings.about.title": "IKOGNIT के बारे में",
  "settings.about.version": "संस्करण",
  "settings.account.changePassword": "पासवर्ड बदलें",
  "settings.account.confirmPw": "नया दोहराएँ",
  "settings.account.currentPw": "वर्तमान पासवर्ड",
  "settings.account.email": "ईमेल",
  "settings.account.emailPh": "email@example.com",
  "settings.account.errPwBad": "वर्तमान पासवर्ड ग़लत है.",
  "settings.account.errPwMismatch": "पासवर्ड मेल नहीं खाते.",
  "settings.account.errPwShort": "नए पासवर्ड में कम से कम 8 अक्षर होने चाहिए.",
  "settings.account.newEmailPlaceholder": "new@email.com",
  "settings.account.newNickPlaceholder": "new_nick",
  "settings.account.newPw": "नया पासवर्ड (न्यूनतम 8)",
  "settings.account.saving": "सहेजा जा रहा है...",
  "settings.account.success": "पासवर्ड अपडेट किया गया.",
  "settings.account.title": "खाता",
  "settings.addYourName": "अपना नाम जोड़ें",
  "settings.blocked.btn": "अवरोध पैदा करना",
  "settings.blocked.empty": "आपको किसी ने ब्लॉक नहीं किया है.",
  "settings.blocked.hint": "अवरोधित उपयोगकर्ता आपको संदेश नहीं भेज सकते. आप उन्हें संदेश भी नहीं भेज सकते.",
  "settings.blocked.placeholder": "ब्लॉक करने के लिए निक",
  "settings.blocked.title": "अवरोधित",
  "settings.blocked.unblock": "अनब्लॉक",
  "settings.close": "बंद करना",
  "settings.editProfile": "प्रोफ़ाइल संपादित करें",
  "settings.language.hint": "इंटरफ़ेस की भाषा चुनें। आपकी पसंद इसी डिवाइस पर सहेजी जाती है।",
  "settings.language.title": "भाषा",
  "settings.legal.cookies": "कूकी नीति",
  "settings.legal.hub": "कानूनी केंद्र",
  "settings.legal.minors": "अवयस्क नीति",
  "settings.legal.notice": "कानूनी नोटिस",
  "settings.legal.privacy": "गोपनीयता नीति",
  "settings.legal.report": "रिपोर्टिंग और मॉडरेशन",
  "settings.legal.rules": "सामुदायिक नियम",
  "settings.legal.terms": "नियम और शर्तें",
  "settings.legal.title": "कानूनी जानकारी",
  "settings.messages.title": "संदेशों",
  "settings.messages.ttl": "डिफ़ॉल्ट समाप्ति",
  "settings.messages.ttlHint": "इस समय के बाद आपके द्वारा भेजे गए संदेश सर्वर से हटा दिए जाएंगे। फ़ाइल संलग्न करते समय आप भिन्न मान चुन सकते हैं.",
  "settings.notif.hint": "ब्राउज़र पुश सूचनाएं केवल IKOGNIT सामान्य संदेशों के लिए उत्सर्जित होती हैं, बिना सामग्री या प्रेषक के नाम के (डिज़ाइन के अनुसार)।",
  "settings.notif.preview": "संदेश पूर्वावलोकन दिखाएँ",
  "settings.notif.sound": "आवाज़",
  "settings.notif.title": "सूचनाएं",
  "settings.notif.vibration": "कंपन (मोबाइल)",
  "settings.privacy.hintFreq": "इन नियमों को केवल तभी ओवरराइड करें जब आप {0} में हों।",
  "settings.privacy.hintGlobal": "कॉन्फ़िगर करें कि आपके प्रत्येक विवरण को डिफ़ॉल्ट रूप से कौन देख सकता है।",
  "settings.privacy.readReceipts": "रसीदें पढ़ें",
  "settings.privacy.readReceiptsHint": "अक्षम होने पर, जब आप संदेश पढ़ते हैं तो कोई ब्लू टिक नहीं भेजा जाता है। तुम्हें दूसरों का भी दर्शन नहीं होगा.",
  "settings.privacy.showInfo": "मेरी जानकारी/स्थिति कौन देखता है",
  "settings.privacy.showLastSeen": "मेरा आखिरी कनेक्शन कौन देखता है",
  "settings.privacy.showOnline": "कौन देखता है कि मैं ऑनलाइन हूं",
  "settings.privacy.showPhoto": "मेरी तस्वीर कौन देखता है",
  "settings.privacy.title": "गोपनीयता",
  "settings.privacy.whoAdds": "मुझे ग्रुप में कौन जोड़ सकता है",
  "settings.profile.adjustPhoto": "अपना चित्र समायोजित करें",
  "settings.profile.changePhoto": "चित्र बदलें",
  "settings.profile.displayName": "प्रदर्शित होने वाला नाम",
  "settings.profile.displayNamePh.freq": "(वैश्विक से विरासत में मिला)",
  "settings.profile.displayNamePh.global": "(कोई नाम नहीं - आपका उपनाम दिखाया जाएगा)",
  "settings.profile.hintFreq": "जब आप {0} में होते हैं तो ये वैश्विक प्रोफ़ाइल को ओवरराइड कर देते हैं। यदि आप यहां कुछ परिभाषित नहीं करते हैं, तो यह वैश्विक से विरासत में मिला है।",
  "settings.profile.hintGlobal": "ये मान डिफ़ॉल्ट रूप से उपयोग किए जाते हैं और सभी IKO में विरासत में मिलते हैं।",
  "settings.profile.info": "जानकारी/स्थिति",
  "settings.profile.infoPh": "नमस्ते, मैं IKOGNIT का उपयोग करता हूं",
  "settings.profile.photo": "प्रोफ़ाइल फोटो",
  "settings.profile.removeOverride": "{0} के लिए ओवरराइड हटाएँ",
  "settings.profile.removePhoto": "चित्र हटाएँ",
  "settings.profile.title": "प्रोफ़ाइल",
  "settings.profile.warn": "जब आप इस IKO में आपके बाकी संपर्कों के साथ बातचीत करेंगे तो परिवर्तन स्वचालित रूप से भेजे जाएंगे।",
  "settings.scope.freq": "केवल {0} में",
  "settings.scope.global": "वैश्विक (IKOGNIT )",
  "settings.session.remember": "सक्रिय याद रखें IKO",
  "settings.session.rememberHint": "यदि सक्षम किया गया है, तो आपके द्वारा सक्रिय किया गया IKO साइडबार में शॉर्टकट के रूप में दिखाई देगा। जो कोई भी आपकी स्क्रीन देखता है वह जान सकता है कि आपने कौन सा IKO दर्ज किया है, इसलिए यह डिफ़ॉल्ट रूप से अक्षम है। इसे बंद करने से पहले से सहेजे गए लोग मिट जाते हैं।",
  "settings.session.timeout": "निष्क्रियता के बाद IKO को बंद करें",
  "settings.session.timeoutHint": "यदि आप ऐप को छुए बिना यह समय बिताते हैं, तो सक्रिय IKO स्वचालित रूप से निष्क्रिय हो जाता है और आप IKOGNIT पर वापस आ जाते हैं। जब तक आप ऐप बंद नहीं करते तब तक \\\"कभी नहीं\\\" IKO रखता है।",
  "settings.session.title": "सत्र",
  "settings.tab.about": "ℹ के बारे में",
  "settings.tab.account": "🆔खाता",
  "settings.tab.blocked": "🚫अवरुद्ध",
  "settings.tab.language": "🌐 भाषा",
  "settings.tab.legal": "कानूनी",
  "settings.tab.messages": "✉ संदेश",
  "settings.tab.notifications": "🔔 सूचनाएं",
  "settings.tab.privacy": "🔒 गोपनीयता",
  "settings.tab.profile": "👤 प्रोफाइल",
  "settings.tab.session": "⏱ सत्र",
  "settings.title": "सेटिंग्स",
  "settings.vis.all": "सब लोग",
  "settings.vis.contacts": "मेरे संपर्क",
  "settings.vis.none": "कोई नहीं",
  "sidebar.addContact": "उपनाम द्वारा संपर्क जोड़ें",
  "sidebar.exitFreq": "IKOGNIT पर लौटें",
  "sidebar.forget": "डिवाइस भूल जाओ",
  "sidebar.freq": "वर्तमान IKO : {0}",
  "sidebar.freqPrivate": "Personal IKO: {0}",
  "sidebar.freqPsh": "डोमेन IKO : {0}",
  "sidebar.freqPublic": "IKO: {0}",
  "sidebar.general": "[[टी0]]",
  "sidebar.logout": "साइन आउट",
  "sidebar.newGroup": "नया समूह",
  "sidebar.notifications": "सूचनाएं",
  "sidebar.remember": "डिवाइस याद रखें",
  "sidebar.savedFreq.tooltip": "सक्रिय करें {0}",
  "sidebar.settings": "सेटिंग्स",
  "sidebar.tooltip.logout": "साइन आउट करें और सब कुछ स्थानीय मिटा दें",
  "sidebar.tune": "सक्रिय करें IKO",
  "stickers.animals": "पशु",
  "stickers.faces": "चेहरे",
  "stickers.food": "खाना",
  "stickers.gestures": "इशारों",
  "stickers.hearts": "दिल",
  "stickers.symbols": "प्रतीक",
  "timeout.15min": "15 मि",
  "timeout.30min": "30 मि",
  "timeout.5min": "5 मिनट",
  "timeout.never": "कभी नहीं",
  "toast.group": "{0} (समूह)",
  "toast.newMessage": "नया सन्देश",
  "totp.copyCode": "कोड कॉपी करें",
  "totp.copySecret": "प्रतिलिपि गुप्त",
  "totp.hideSecret": "रहस्य छिपाओ",
  "totp.invalid": "अमान्य रहस्य",
  "totp.showSecret": "रहस्य दिखाओ",
  "ttl.12m": "12 महीने",
  "ttl.1d": "1 दिन",
  "ttl.1h": "1 घंटा",
  "ttl.1m": "1 महीना",
  "ttl.1w": "1 सप्ताह",
  "ttl.6m": "6 महीने",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "सामान्य IKO",
  "uib.e2e.label": "अंधा सर्वर",
  "uib.e2e.title": "सर्वर आपकी सामग्री को नहीं पढ़ सकता - E2E आपकी कुंजी के साथ एन्क्रिप्शन",
  "uib.exitLabel": "बाहर निकलना",
  "uib.exitTitle": "सामान्य IKO को लौटें",
  "uib.modes.private": "व्यक्तिगत IKO",
  "uib.modes.shared": "[[टी0]]",
  "uib.nickTitle": "आपका निक",
  "uib.pseudoTitle": "इसमें आपका छद्म नाम IKO",
  "vault.addField": "क्षेत्र जोड़ें",
  "vault.confirmDelete": "यह आइटम हटाएं? इसे पुनर्प्राप्त नहीं किया जा सकता.",
  "vault.copied": "कॉपी किया गया ✓",
  "vault.copy": "प्रतिलिपि",
  "vault.delete": "मिटाना",
  "vault.edit": "संपादन करना",
  "vault.empty": "आपकी फ़ोल्डर खाली है. अपना पहला आइटम बनाएं.",
  "vault.field.address": "पता",
  "vault.field.birthdate": "जन्मतिथि",
  "vault.field.cardBrand": "ब्रांड",
  "vault.field.cardCvv": "सीवीवी",
  "vault.field.cardExpiry": "समाप्ति (एमएम/वाईवाई)",
  "vault.field.cardHolder": "कार्ड धारक",
  "vault.field.cardNumber": "संख्या",
  "vault.field.city": "शहर",
  "vault.field.country": "देश",
  "vault.field.dni": "आईडी/एसएसएन",
  "vault.field.email": "ईमेल",
  "vault.field.firstname": "पहला नाम",
  "vault.field.labelPh": "फील्ड लेबल",
  "vault.field.lastname": "उपनाम",
  "vault.field.name": "नाम",
  "vault.field.name.ph": "आप इसे कैसे कहते हैं?",
  "vault.field.newField": "मैदान",
  "vault.field.password": "पासवर्ड",
  "vault.field.phone": "फ़ोन",
  "vault.field.sshFingerprint": "अंगुली की छाप",
  "vault.field.sshHost": "मेज़बान",
  "vault.field.sshPrivate": "निजी चाबी",
  "vault.field.sshPublic": "सार्वजनिक कुंजी",
  "vault.field.totp": "टीओटीपी",
  "vault.field.url": "[[टी0]]",
  "vault.field.username": "उपयोगकर्ता नाम",
  "vault.field.zip": "ज़िप कोड",
  "vault.fieldPlural": "खेत",
  "vault.fieldSingular": "मैदान",
  "vault.ft.date": "तारीख",
  "vault.ft.email": "ईमेल",
  "vault.ft.number": "संख्या",
  "vault.ft.password": "पासवर्ड",
  "vault.ft.text": "मूलपाठ",
  "vault.ft.textarea": "लंबा पाठ",
  "vault.ft.url": "[[टी0]]",
  "vault.hide": "छिपाना",
  "vault.new": "नए वस्तु",
  "vault.noMatches": "कोई भी आइटम खोज से मेल नहीं खाता.",
  "vault.notes": "टिप्पणियाँ",
  "vault.removeField": "इस फ़ील्ड को हटाएँ",
  "vault.save": "बचाना",
  "vault.search": "खोजना…",
  "vault.sensitive": "संवेदनशील",
  "vault.sensitiveHint": "संवेदनशील फ़ील्ड डिफ़ॉल्ट रूप से छिपे होते हैं और उन्हें क्लिपबोर्ड पर कॉपी किया जा सकता है।",
  "vault.show": "दिखाओ",
  "vault.startHint": "बाईं ओर से एक आइटम चुनें या एक नया आइटम बनाएं।",
  "vault.tpl.confirmDelete": "यह टेम्प्लेट हटाएं? इससे बनी वस्तुएं बनी रहती हैं।",
  "vault.tpl.edit": "टेम्पलेट संपादित करें",
  "vault.tpl.empty": "आपके पास अभी तक टेम्पलेट नहीं हैं. अपना खुद का आइटम प्रकार परिभाषित करने के लिए एक बनाएं।",
  "vault.tpl.manage": "टेम्प्लेट प्रबंधित करें",
  "vault.tpl.name": "टेम्पलेट का नाम",
  "vault.tpl.name.ph": "जैसे: क्रिप्टो वॉलेट, होटल बुकिंग…",
  "vault.tpl.new": "नया टेम्पलेट",
  "vault.tpl.title": "टेम्पलेट्स",
  "vault.tpl.yours": "आपके टेम्पलेट",
  "vault.type.card": "कार्ड",
  "vault.type.custom": "रिवाज़",
  "vault.type.identity": "पहचान",
  "vault.type.login": "लॉग इन करें",
  "vault.type.sshkey": "एसएसएच कुंजी",
  "vault.untitled": "शीर्षकहीन",
  "web.footer.line": "रेखा",
  "web.footer.palette": "पैलेट",
  "web.footer.send": "भेजना",
  "welcome.btnContacts": "संपर्क जोड़ें",
  "welcome.btnFreq": "सक्रिय करें IKO",
  "welcome.concept": "IKOGNIT में आप अपने उपनाम से पहचाने गए अन्य उपयोगकर्ताओं से बात करते हैं। जब आप एक अलग स्थान चाहते हैं, तो आप एक IKO सक्रिय करते हैं और एक IKO में प्रवेश करते हैं। यदि यह सार्वजनिक है, तो आप उन लोगों से मिलते हैं जो इसे सक्रिय भी करते हैं। यदि यह निजी है, तो आप एक ऐसे IKO में प्रवेश करते हैं जहां केवल आप ही मौजूद हैं।",
  "welcome.multidevice": "IKO को कभी भी कहीं संग्रहीत नहीं किया जाता है। यदि आप IKO को भूल जाते हैं, तो आपके लिए उसके IKO का अस्तित्व समाप्त हो जाता है।",
  "welcome.step1": "IKO को सक्रिय करें और उन लोगों के साथ IKO में प्रवेश करें जो इसे जानते हैं।",
  "welcome.step2": "यहां IKOGNIT में, संपर्क के रूप में एक उपनाम जोड़ें और बात करना शुरू करें।",
  "welcome.step3": "एक व्यक्तिगत IKO सक्रिय करें और केवल आपके लिए एक यूनिवर्स खोलें, जहां आप फ़ाइलें, फ़ोटो, ऑडियो, वीडियो, पासवर्ड, नोट्स और पत्र रखते हैं।",
  "welcome.title": "IKOGNIT में आपका स्वागत है",

};

const ko: Catalog = {
  "auth.verify.notSent": "코드를 보내지 못했습니다. 계정은 만들어졌습니다. 잠시 후 「코드 다시 보내기」를 누르세요.",
  "lg.rotulo": "비공개 공간이 있는 메신저",
  "lg.btn.entrar": "로그인",
  "lg.eyebrow": "비공개 메신저 · Itrion Software",
  "lg.h1a": "늘 하던 대화 그대로.",
  "lg.h1b": "그리고 불러낼 때만 존재하는 장소.",
  "lg.lead1": "가족과, 친구와, 동료와 이야기합니다. 여느 앱과 같습니다. 차이는 IKO를 열 때부터 시작됩니다. 안에 있는 사람만 아는 비밀을 적어야 들어가는, 당신만의 공간입니다.",
  "lg.lead2": "불러내지 않는 동안 그 공간은 당신의 기기에 없습니다. 휴대폰에도, 태블릿에도, 컴퓨터에도 없습니다. 암호화되어 있는 것이 아닙니다.",
  "lg.lead2b": "아예 없습니다.",
  "lg.pruebalo": "직접 해보세요 · 비밀을 적고 무슨 일이 생기는지 보세요",
  "lg.panel.plano": "일반 평면",
  "lg.demo.hilos": "가족=엄마: 일요일에 집에서 저녁 먹을까?=19:04|마르타=토요일 사진 보낼게=17:52|팀=루이스: 그럼 내일 아홉 시에=어제|하비=하하 믿기지 않아=어제",
  "lg.demo.mundos": "우리 둘만~말한 데 넣어뒀어?|응. 등기랑 여권>~집 등기.pdf=2.4 MB|비공개 사진=214|카드 · 은행=자료~~집안일~임대차 계약서 여기 둘게>|그리고 공유기 키, 늘 잃어버리잖아~임대차 계약서.pdf=1.1 MB|신분증 사본=파일 2개|집 열쇠=자료~~내 메모~이건 아무한테도 말 안 했다>|말할 필요도 없고>~일기=메모 48개|사진=1,207|올해 장부=자료~~리스본 프로젝트~견적은 180으로 나옵니다|여기 있습니다. 밖에는 사본 없습니다>~견적_v4.pdf=860 KB|연락처=12|법인 카드=자료~~토요일 점심~마르타한테는 아직 말하지 마|걱정 마, 여기선 아무도 몰라>~예약.pdf=120 KB|작년 사진=63|초대 명단=자료",
  "lg.invocaLabel": "당신의 IKO를 불러내세요",
  "lg.invocaPlaceholder": "아무 비밀이나 적어보세요",
  "lg.invocaBtn": "불러내기",
  "lg.invocaHint": "단어마다 다른 공간으로 이어집니다. 다른 단어도 해보세요.",
  "lg.estela.vacio": "아무거나 적으세요. 여기서는 시연입니다.",
  "lg.estela.primero": "나타났습니다. 안에 있는 동안에만 존재합니다.",
  "lg.estela.otro": "다른 비밀, 다른 공간. 서로의 존재를 모릅니다.",
  "lg.estela.salida": "사라졌습니다. 기기에 흔적이 남지 않았습니다. 다른 단어도 해보세요.",
  "lg.ikoActivo": "IKO 활성",
  "lg.nadaEnDispositivo": "이 중 어느 것도 기기에 없습니다",
  "lg.salirIko": "IKO에서 나가기",
  "lg.planos.h2a": "눈에 보이는 평면 하나.",
  "lg.planos.h2b": "그 아래, 당신이 불러내는 것들.",
  "lg.planos.lead": "「그 IKO」라는 것은 없습니다. 당신이 여는 것들이 있을 뿐입니다. 집안일용 하나, 일용 하나, 두 사람만 아는 것 하나, 아무에게도 말한 적 없는 것 하나. 비밀마다 자기 것으로 이어지고, 어느 것도 나머지를 알지 못합니다.",
  "lg.planos.unoRotulo": "일반 평면 · 하나",
  "lg.planos.unoH3": "모두와 이야기하는 곳",
  "lg.planos.unoP": "대화, 그룹, 통화, 사진과 파일. 모두 종단 간 암호화됩니다. 메신저에 기대하는 것을 제대로 만들었습니다. 늘 쓰던 대화는 여기에 살고, 늘 그렇듯 동작합니다.",
  "lg.planos.nRotulo": "IKO · 원하는 만큼",
  "lg.planos.nH3": "다른 누구도 닿지 못하는 곳",
  "lg.planos.nP": "비밀을 적으면 그에 해당하는 공간이 나타납니다. 안에는 대화와 당신의 물건이 들어갑니다. 나가면 흔적 없이 기기에서 사라집니다. 목록도 없고 개수도 없으며, 몇 개를 가졌는지도, 하나라도 존재하는지도 아무도 알아낼 수 없습니다.",
  "lg.planos.chips": "집안일|일|둘만 아는 것|당신만의 것|한 번 열고 다시 열지 않은 것|내일 정할 것들",
  "lg.forense.h2a": "당신의 기기에서 암호화된 것이 아닙니다.",
  "lg.forense.h2b": "당신의 기기에 아예 없습니다.",
  "lg.forense.lead": "다른 앱은 메시지를 기기에 두고 암호화합니다. 누군가 기기를 가져가면, 당신의 프라이버시는 그 암호가 충분히 오래 버티는지에 달립니다. 여기에는 버텨야 할 것이 없습니다. IKO 안에 사는 것은 어떤 기기에도 기록되지 않습니다. 불러내고, 쓰고, 사라집니다.",
  "lg.forense.multi": "어디서나 같습니다. 휴대폰, 태블릿, 집 컴퓨터, 회사 노트북, 윈도우, 맥, 또는 당신 것이 아닌 곳의 브라우저. 원하는 곳에서 들어가고, 나가면 그곳은 다시 당신에 대해 아무것도 모릅니다.",
  "lg.forense.caption": "당신의 기기 중 아무거나 조사한 사람이 찾아내는 것",
  "lg.forense.filas": "당신의 IKO 메시지=0|당신의 IKO 파일과 사진=0|저장된 IKO 비밀=0|당신의 IKO를 담은 데이터베이스=존재하지 않음|IKO가 열렸던 흔적=없음|IKO를 몇 개 가졌는지=확인 불가",
  "lg.escenas.h2": "정말로 걱정되는 것.",
  "lg.escenas.filas": "「휴대폰을 잃어버렸어요.」=프라이버시는 함께 사라지지 않았습니다. IKO 안에 있던 것은 그 기기에 한 번도 있은 적이 없으므로, 건질 것도 두려워할 것도 없습니다. 다른 어떤 기기에서든 불러내면 모든 것이 그대로 있습니다.~「누가 제 노트북을 가져갔어요.」=평소 대화는 보게 됩니다. 어떤 앱에서든 보이는 것과 같습니다. 나머지는 내용도, 이름도, 존재한다는 낌새조차 보이지 않습니다.~「제 컴퓨터를 조사했어요.」=포렌식 분석은 디스크에 기록된 것을 복원합니다. 암호화되고 삭제되었더라도 마찬가지입니다. 여기에는 복원할 기록 자체가 없습니다. 답은 「복호화할 수 없다」가 아니라 「아무것도 없다」입니다. 태블릿도, 휴대폰도, 어느 오후에 쓴 브라우저도 마찬가지입니다.",
  "lg.ciego.h2": "우리도 아닙니다. 서버를 두는 쪽도 아닙니다.",
  "lg.ciego.p1": "서버는 읽지 못하는 것을 보관합니다. 당신의 비밀을 가지고 있지 않고, 가진 적도 없으며, 어디에도 사본이 없습니다. 당신의 IKO 안에 있는 것을 내주기를 거부하는 것이 아닙니다. 우리에게 없고, 가질 방법도 없습니다. 기계를 두고 있는 회사도, 그 기계를 손에 넣은 사람도 마찬가지입니다.",
  "lg.ciego.p2": "여기에는 대가가 있고, 그 말은 해야 합니다. 비밀을 잃으면 되돌려줄 사람이 없습니다. 다른 누구도 들어갈 수 없는 바로 그 이유가, 우리도 당신을 들여보내 줄 수 없는 이유입니다.",
  "lg.guardas": "가족사진|남에게 보이지 않는 메모|카드와 은행 정보|비밀번호|문서|당신들에게만 해당되는 대화",
  "lg.nombre.esta": "있다",
  "lg.nombre.noEsta": "없다",
  "lg.nombre.h2": "이름은 여기서 왔습니다.",
  "lg.nombre.p": "스와힐리어로 iko는 「있다」, haiko는 「없다」입니다. IKO는 당신이 불러내는 동안 있습니다. 나머지 시간에는 — 즉 거의 언제나 — 없습니다. 당신의 기기에도, 누군가의 눈앞에도, 의심으로조차 없습니다.",
  "lg.cierre.h2": "이야기를 시작하세요.",
  "lg.cierre.p": "여느 메신저처럼 씁니다. 휴대폰에서도, 태블릿에서도, 컴퓨터에서도. IKO는 필요해지는 날 그 자리에 있습니다.",
  "lg.cierre.btnCrear": "계정 만들기",
  "lg.cierre.btnEntrar": "이미 계정이 있습니다",
  "lg.cierre.pago": "IKOGNIT은 유료 제품입니다. 광고도, 광고용 프로필도 없고, 우리 쪽에 어떤 사본도 없습니다. 앱이 당신에게 값어치를 하는 것으로 먹고살지, 당신이 그 안에서 하는 말로 먹고살지 않습니다.",
  "lg.pie.ciego": "눈먼 서버",
  "auth.hola": "다시 만나서 반갑습니다.",
  "auth.queEs": "IKOGNIT이 무엇인가요?",
  "auth.btn.backToUnlock": "뒤쪽에",
  "auth.btn.createIdentity": "계정 만들기",
  "auth.btn.forget": "이 장치를 잊어버리세요",
  "auth.btn.processing": "처리 중…",
  "auth.btn.unlock": "로그인",
  "auth.btn.unlocking": "로그인 중…",
  "auth.btn.useOther": "다른 계정 사용",
  "auth.confirmForget": "이 기기는 더 이상 당신을 알아보지 못한다. 저장된 계정과 캐시에 남은 것은 사라진다. 다시 들어오려면 비밀번호가 필요하다.",
  "auth.confirmForget.warning": "24개 단어 복구 문구를 적어 두지 않았다면 돌아올 길은 없다. 누구도 되돌려 줄 수 없다.",
  "invite.welcomeSub": "메시지, 그리고 자기만의 공간. 여기에 둔 것은 당신 명의로 남는다. 계정을 만들면 서로 연결된다.",
  "auth.reset.warnNewIdentity": "계정은 그대로 당신 것이지만, 이메일로 복구하면 새 신원이 주어진다. 이전 메시지는 더 이상 읽을 수 없다. 24개 단어 복구 문구가 남아 있다면 그 길을 택하라.",
  "recover.intro": "닉네임 또는 이메일과, 계정을 만들 때 받은 24개의 복구 단어를 입력하라. 그다음 새 비밀번호를 정한다.",
  "auth.error.badCreds": "닉네임/이메일 또는 비밀번호가 잘못되었습니다.",
  "auth.error.badPin": "잘못된 키입니다.",
  "auth.error.cantConnect": "서버에 연결할 수 없습니다.",
  "auth.error.legalRequired": "계정을 만들려면 법적 조건에 동의하고 연령을 확인해야 합니다.",
  "auth.error.userNotFound": "계정을 찾을 수 없습니다.",
  "auth.field.devicePin": "장치 PIN",
  "auth.field.emailPlaceholder": "you@email.com",
  "auth.field.nickPlaceholder": "예를 들어 user123",
  "auth.field.password": "비밀번호",
  "auth.footnote": "주인이 그 책임을 진다.\n비밀번호를 잃으면\n따질 상대가 없다.",
  "auth.legal.accept": "나는 <a href='https://ikognit.org/legal/en/terms.html' target='_blank' rel='noopener'> 약관</a>, <a href='https://ikognit.org/legal/en/privacy.html' target='_blank' rel='noopener'> 개인정보 보호정책</a> 및 <a href='https://ikognit.org/legal/en/community-rules.html' target='_blank' rel='noopener'> 커뮤니티 규칙</a>을 읽고 이에 동의합니다.",
  "auth.legal.age": "IKOGNIT 을(를) 사용하기 위해 거주 국가의 법률에서 요구하는 최소 연령을 충족했음을 확인합니다.",
  "auth.loading": "로드 중…",
  "auth.savedSession": "이 기기는 이미 주인을 알고 있다.",
  "auth.locked": "가만히 두어 흩어졌다. 다시 들어오라.",
  "auth.sessionExpired": "세션이 흩어졌다. 다시 들어오라.",
  "auth.subLogin": "일반 평면으로 들어갑니다. 늘 하던 대화가 있는 곳입니다. IKO는 여기서 불러내지 않습니다. 필요할 때 안에서 불러냅니다.",
  "auth.subRegister": "계정은 당신 명의로 등록된다. 닉네임은 남들에게 보이는 이름이고, 이메일은 접근 복구와 알림에만 쓰인다.",
  "auth.tab.login": "로그인",
  "auth.tab.register": "새 계정",
  "auth.categoria": "iko · invisible knowledge object",
  "auth.tagline": "스와힐리어로 iko는 “있다”, haiko는 “없다”.",
  "billing.manage": "관리하다",
  "billing.needsUpgrade": "해당 등급의 좌석 한도에 도달했습니다. 더 많은 좌석을 추가하려면 업그레이드하세요.",
  "billing.portal": "결제 관리",
  "billing.renews": "갱신",
  "billing.seats": "좌석",
  "billing.title": "청구",
  "billing.upgradeTo": "업그레이드 등급({price} /좌석)",
  "bubble.contact.label": "IKOGNIT 연락처",
  "bubble.edit": "편집하다",
  "bubble.edited": "편집됨",
  "bubble.forward": "앞으로",
  "bubble.media.decrypting": "복호화 중…",
  "bubble.media.failed": "파일의 암호를 해독할 수 없습니다.",
  "bubble.reply": "회신하다",
  "bubble.tick.delivered": "{0} 전달됨",
  "bubble.tick.read": "{0} 읽기",
  "bubble.tick.sent": "전송된",
  "call.accept": "수용하다",
  "call.audioOut": "오디오 출력",
  "call.audioOut.auto": "자동",
  "call.calling": "부름…",
  "call.camera": "카메라",
  "call.connecting": "연결 중…",
  "call.ending": "종결…",
  "call.error.notInFreq": "전화하려면 IKO 안에 있어야 합니다.",
  "call.hangup": "끊으세요",
  "call.incoming.audio": "전화 수신",
  "call.incoming.video": "화상 통화 수신",
  "call.mic": "마이크로폰",
  "call.reject": "거부하다",
  "ccb.clock.title": "현지 시간",
  "ccb.identity.title": "세션: @ {0}",
  "ccb.leave.aria": "IKO 종료",
  "ccb.leave.title": "IKO 종료 (IKOGNIT로 돌아감)",
  "ccb.modes.personalPrefix": "개인의 ·",
  "ccb.settings.aria": "설정",
  "ccb.settings.title": "설정 · 프로필, 테마, 세션",
  "ccb.tag.cipher.title": "대칭 암호화 활성",
  "ccb.tag.srv.title": "서버가 콘텐츠를 읽을 수 없습니다.",
  "ccb.tag.unread.title": "읽지 않은 메시지",
  "ccb.universe.activate": "IKO 활성화",
  "ccb.universe.changeOrExit": "IKO 전환 또는 종료",
  "chat.action.call": "부르다",
  "chat.action.videoCall": "영상통화",
  "chat.attach.camera": "카메라",
  "chat.attach.file": "파일첨부",
  "chat.attach.label": "붙이다",
  "chat.attach.voice": "목소리",
  "chat.attachPending": "첨부 파일 보류 중",
  "chat.backToIkognit.title": "일반으로 돌아가기 IKOGNIT",
  "chat.blocked.text": "{0} 을(를) 차단하셨습니다. 메시지를 보내거나 전화를 걸 수 없습니다.",
  "chat.btn.send": "보내다",
  "chat.call.title": "부르다",
  "chat.calls.callContact": "연락처에 전화 걸기",
  "chat.calls.empty": "아직 전화가 없습니다. 연락처와의 채팅으로 시작하세요.",
  "chat.calls.historySoon": "통화 기록이 곧 제공될 예정입니다.",
  "chat.calls.title": "통화",
  "chat.cancel.title": "취소",
  "chat.composer.placeholder": "메시지를 입력하세요...",
  "chat.confirmContact": "연락처에 추가",
  "chat.contact.badgeBlocked": "막힌",
  "chat.contact.badgePending": "확인되지 않은",
  "chat.contacts.empty": "아직 연락처가 없습니다.",
  "chat.contacts.noResults": "결과가 없습니다.",
  "chat.delete.aria": "삭제",
  "chat.delete.title": "삭제",
  "chat.deleteConv.forAll": "모든 사람에 대해 삭제",
  "chat.deleteConv.forMe": "나를 위해 삭제",
  "chat.deleteConv.hint": "\\\"For me\\\"는 복사본(모든 장치)을 삭제합니다. \\\"모든 사람에게\\\"는 또한 상대방에게 자신의 쪽에서 해당 항목을 삭제하도록 요청합니다.",
  "chat.deleteConv.titleMany": "{0} 대화 삭제",
  "chat.deleteConv.titleOne": "대화 삭제",
  "chat.editPlaceholder": "메시지를 편집하세요...",
  "chat.editing": "메시지 편집 중",
  "chat.empty": "연락처 선택 또는 추가",
  "chat.error.userBlocked": "이 사용자를 차단했습니다.",
  "chat.filter.all": "모두",
  "chat.filter.groups": "여러 떼",
  "chat.filter.unread": "읽히지 않는",
  "chat.filters.aria": "채팅 필터",
  "chat.group.membersWord": "회원",
  "chat.header.blocked": "막힌",
  "chat.lastSeen": "마지막으로 본 {0}",
  "chat.media.delete": "삭제",
  "chat.media.deleteConfirmBody": "이 작업은 취소할 수 없습니다.",
  "chat.media.deleteConfirmTitle": "사진을 삭제하시겠습니까?",
  "chat.media.deleteForAll": "모든 사람에 대해 삭제",
  "chat.media.deleteForMe": "나를 위해 삭제",
  "chat.media.download": "다운로드",
  "chat.media.forward": "앞으로",
  "chat.media.forwardTo": "다음으로 전달",
  "chat.media.share": "공유하다",
  "chat.mediaFailed": "로드할 수 없습니다.",
  "chat.mediaRetry": "다시 해 보다",
  "chat.myContacts": "내 연락처",
  "chat.nav.aria": "메인 네비게이션",
  "chat.newCall.empty": "아직 연락처가 없습니다. 채팅의 + 중 하나를 추가하세요.",
  "chat.newCall.title": "새 통화",
  "chat.newChat.title": "새 채팅",
  "chat.newMessages": "새로운",
  "chat.newMessagesBadge": "{0}개의 새 메시지로 이동",
  "chat.online": "온라인",
  "chat.placeholder": "메시지를 작성하세요…",
  "chat.presence.online": "온라인",
  "chat.preview.audio": "오디오",
  "chat.preview.image": "영상",
  "chat.preview.video": "동영상",
  "chat.preview.voice": "음성 메시지",
  "chat.remove.title": "제거하다",
  "chat.replyingTo": "{0}에 답장",
  "chat.search.clear": "검색 지우기",
  "chat.search.placeholder": "채팅 검색",
  "chat.tab.calls": "통화",
  "chat.tab.chats": "채팅",
  "chat.tab.contacts": "콘택트 렌즈",
  "chat.tab.settings": "설정",
  "chat.toast.imageSaved": "포토에 이미지가 저장되었습니다.",
  "chat.toast.saveError": "저장 오류",
  "chat.toast.saveFailed": "저장할 수 없습니다: {0}",
  "chat.toast.saved": "저장됨",
  "chat.toast.updateTestflight": "저장하려면 TestFlight를 1.0(10)+으로 업데이트하세요.",
  "chat.toast.videoSaved": "포토에 저장된 동영상",
  "chat.tooltip.attach": "파일첨부",
  "chat.tooltip.callAudio": "음성통화",
  "chat.tooltip.callVideo": "영상통화",
  "chat.tooltip.paste": "클립보드에서 이미지 붙여넣기",
  "chat.tooltip.shareContact": "연락처 공유",
  "chat.tooltip.stickers": "스티커",
  "chat.unblock": "차단 해제",
  "chat.unconfirmedBanner": "이 사용자가 귀하에게 편지를 보냈지만 귀하의 연락처에는 없습니다. 귀하가 추가할 때까지 귀하의 개인 정보 보호 설정에 따라 귀하의 사진과 정보는 해당 사람들에게 표시되지 않습니다.",
  "chat.unread.aria": "읽지 않은 메시지",
  "chat.uploading": "…",
  "chat.videoCall.aria": "{0}님과 영상통화",
  "chat.videoCall.title": "영상통화",
  "chat.welcome.intro": "엔드투엔드 암호화로 대화를 시작하려면 채팅을 선택하세요.",
  "common.add": "추가하다",
  "common.back": "뒤쪽에",
  "common.cancel": "취소",
  "common.close": "닫다",
  "common.confirm": "확인하다",
  "common.delete": "삭제",
  "common.error.generic": "되지 않았다. 다시 시도하라.",
  "common.exit": "출구",
  "common.more": "더",
  "common.save": "구하다",
  "common.tagline": "디지털 주권.",
  "contacts.alias.label": "별명",
  "contacts.alias.placeholder": "이를 인식하기 위한 별칭",
  "contacts.blockBtn": "연락 차단",
  "contacts.confirmBlock.body": "{0} 차단 ? 해당 메시지와 전화 수신이 중단됩니다.",
  "contacts.confirmBlock.title": "연락 차단",
  "contacts.confirmUnblock.body": "{0} 차단을 해제하시겠습니까? 당신은 그들의 메시지를 다시 받게 될 것입니다.",
  "contacts.confirmUnblock.title": "연락처 차단 해제",
  "contacts.edit.aria": "편집하다",
  "contacts.edit.title": "별칭 및 메모 수정",
  "contacts.note.label": "비공개 메모",
  "contacts.notes.placeholder": "오직 본인만이 볼 수 있습니다(서버에서 암호화됨).",
  "contacts.search.placeholder": "별칭 또는 IKOGNIT ID로 검색",
  "contacts.unblockBtn": "연락처 차단 해제",
  "ctx.action.contacts": "내 연락처",
  "ctx.action.newChat": "새 채팅",
  "ctx.action.newGroup": "새 그룹",
  "ctx.aria": "IKO 정보 및 탐색",
  "ctx.liturgy.0": "서버가 장님입니다.",
  "ctx.liturgy.1": "여기서는 당신만 읽으세요.",
  "ctx.liturgy.2": "당신이 여기 있다는 것을 아무도 모릅니다.",
  "ctx.liturgy.3": "IKO은 당신만이 아는 비밀입니다.",
  "ctx.liturgy.4": "귀하의 개인 정보 보호는 아키텍처입니다.",
  "ctx.modes.private": "개인용 IKO",
  "ctx.modes.storage": "드라이브",
  "ctx.modes.shared": "IKO",
  "ctx.nav.activateIko": "IKO 활성화",
  "ctx.nav.backToIkognit": "IKOGNIT(으)로 돌아가기",
  "ctx.nav.changeIko": "스위치 IKO",
  "ctx.peer.message": "{0} 메시지",
  "ctx.peer.messages": "{0} 메시지",
  "ctx.peer.offline": "오프라인",
  "ctx.peer.online": "온라인",
  "ctx.section.actions": "행위",
  "ctx.section.conversation": "대화",
  "ctx.section.nav": "항해",
  "ctx.section.universe": "현재의 IKO",
  "ctx.status.e2e": "엔드투엔드 암호화",
  "ctx.status.serverBlind": "블라인드 서버 활성화",
  "ctx.universe.personal": "나만의 공간",
  "demo.edit": "편집하다",
  "error.blocked": "이 사용자를 차단했습니다. 다시 대화하려면 설정에서 차단을 해제하세요.",
  "error.cantAcceptCall": "전화를 받을 수 없습니다: {0}",
  "error.cantPaste": "클립보드에 액세스할 수 없습니다. 첨부 버튼을 사용해 보세요.",
  "error.cantStartCall": "통화를 시작할 수 없습니다: {0}",
  "error.clipboardUnsupported": "귀하의 브라우저는 클립보드 읽기를 허용하지 않습니다. Ctrl+V를 눌러 붙여넣거나 첨부 버튼을 사용하세요.",
  "error.expired": "세션이 만료되었습니다. 다시 로그인하세요.",
  "error.gone": "파일이 만료되었습니다.",
  "error.invalid": "데이터가 잘못되었습니다.",
  "error.network": "서버에 연결되어 있지 않습니다.",
  "error.noImageInClipboard": "클립보드에 이미지가 없습니다.",
  "error.notFound": "리소스를 찾을 수 없습니다.",
  "error.notInFreq": "{0}은(는) 아직 이 IKO에 없습니다. 활성화하려면 다른 채널을 통해 요청하세요.",
  "error.push.activateFailed": "활성화할 수 없습니다( {0} ).",
  "error.push.denied": "알림 권한을 거부했습니다.",
  "error.push.iosNotStandalone": "iPhone에서 알림을 받으려면 홈 화면에 IKOGNIT을 설치하세요. 공유 → 홈 화면에 추가를 탭하세요.",
  "error.push.iosTooOld": "귀하의 iOS는 16.4보다 오래되었습니다. 알림을 받으려면 업데이트하세요.",
  "error.push.noPush": "이 브라우저는 푸시 알림을 지원하지 않습니다.",
  "error.push.noSw": "이 브라우저는 서비스 워커를 지원하지 않습니다.",
  "error.push.noVapid": "서버가 VAPID 키를 제공하지 않았습니다.",
  "error.selfContact": "자신을 추가할 수 없습니다.",
  "error.server": "서버 오류입니다. 다시 시도해 주세요.",
  "explorer.filesNotProcessed": "처리되지 않은 파일",
  "holo.card.cipher": "암호",
  "holo.card.contacts": "콘택트 렌즈",
  "holo.card.conversations": "대화",
  "holo.card.server": "섬기는 사람",
  "holo.claim.general": "IKOGNIT 에 있는 개인 공간입니다. 여기서 당신은 당신의 연락처와 이야기합니다.",
  "holo.claim.inIko": "이 IKO은(는) 모르는 사람에게는 보이지 않는 상태로 남아 있습니다.",
  "holo.foot": "대화를 선택하고, IKO을 활성화하거나, 새 스페이스를 만드세요.",
  "holo.modes.general": "귀하의 닉네임 + 연락처",
  "holo.modes.private": "개인 IKO",
  "holo.modes.shared": "IKO",
  "join.loginToAccept": "로그인 / 계정 만들기",
  "iko.banner.exitAria": "IKO에서 나와 일반 평면으로 돌아가기",
  "iko.liturgy.entering": "IKO 입력",
  "iko.liturgy.returning": "돌아오는 중",
  "iko.liturgy.toIkognit": "IKOGNIT로",
  "iko.mode.private": "개인용 IKO",
  "iko.mode.shared": "IKO",
  "manifest.blindServer": "서버가 장님입니다.",
  "manifest.keyWithYou": "열쇠는 당신과 함께 살고 있습니다.",
  "manifest.noAdsNoClouds": "광고가 없습니다. 외부 구름이 없습니다.",
  "manifest.noPublicProfiles": "공개 프로필이 없습니다.",
  "manifest.onlyYouRead": "여기서는 당신만 읽으세요.",
  "manifest.yourIkoYourSpaces": "귀하의 IKO . 당신의 공간.",
  "media.confirmDelete": "이 항목을 삭제하시겠습니까? 복구할 수 없습니다.",
  "media.delete": "삭제",
  "media.download": "다운로드",
  "media.empty.audio": "이 IKO에는 아직 오디오가 없습니다.",
  "media.empty.file": "이 IKO에는 아직 파일이 없습니다.",
  "media.empty.photo": "이 IKO에는 아직 사진이 없습니다.",
  "media.empty.video": "이 IKO에는 아직 동영상이 없습니다.",
  "media.noPreview": "이 파일 형식에 대한 미리보기가 없습니다.",
  "media.play": "놀다",
  "media.upload.audio": "오디오 업로드",
  "media.upload.file": "파일 업로드",
  "media.upload.photo": "사진 업로드",
  "media.upload.video": "동영상 업로드",
  "media.uploadFailed": "파일을 업로드할 수 없습니다.",
  "media.uploading": "업로드 중…",
  "mobile.tb.ikoActivate": "IKO 활성화",
  "mobile.tb.ikoExit": "일반으로 돌아가기 IKOGNIT",
  "modal.freq.activate": "활성화",
  "modal.freq.deriving": "IKO 계산 중…",
  "modal.freq.errCommon": "IKO은 너무 흔합니다. 독특한 것을 선택하십시오.",
  "modal.freq.errRepeat": "단일 반복 문자를 사용하지 마십시오.",
  "modal.freq.errSeqAlpha": "알파벳 순서를 피하세요.",
  "modal.freq.errSeqNum": "명백한 숫자 시퀀스를 피하십시오.",
  "modal.freq.errShort": "IKO은 8자 이상이어야 합니다.",
  "modal.freq.hint": "IKO은 IKO 중 하나의 정확한 IKO입니다.  IKO : 같은 IKO를 쓰는 사람을 만나게 됩니다. 개인적: 다른 사람이 같은 글을 쓰더라도 당신은 보이지 않는 IKO에 도달합니다. 도메인: 소유자의 소유이며 소유자가 귀하를 등록한 경우에만 들어갈 수 있습니다.",
  "modal.freq.placeholder": "IKO를 쓰세요",
  "modal.freq.title": "IKO 활성화",
  "modal.freq.warn": "IKO는 어디에도 저장되지 않습니다. 당신이 그것들을 잊어버린다면, 그 IKO는 당신을 위해 존재하지 않게 됩니다.",
  "modal.group.create": "그룹 만들기",
  "modal.group.hint": "이름을 선택하고 이 IKO에 있는 연락처에서 구성원을 선택하세요.",
  "modal.group.namePh": "그룹 이름",
  "modal.group.selected": "{0} 선택됨",
  "modal.group.title": "새 그룹",
  "modal.remember.confirm": "반복 PIN",
  "modal.remember.errMismatch": "PIN이 일치하지 않습니다.",
  "modal.remember.errShort": "PIN은 4자 이상이어야 합니다.",
  "modal.remember.hint": "귀하의 세션, 연락처, 그룹 및 메시지는 귀하만 아는 PIN로 암호화되어 이 장치에 저장됩니다. 앱을 다시 열면 PIN을 입력하여 잠금을 해제하게 됩니다.",
  "modal.remember.pin": "PIN",
  "modal.remember.title": "이 장치를 기억하세요",
  "modal.remember.warn": "PIN을 잊어버리면 저장된 데이터를 복구할 수 없습니다. 사용자 이름과 비밀번호를 사용하여 다시 로그인해야 합니다.",
  "modal.share.btn": "공유하다",
  "modal.share.empty": "이 IKO에 연락처가 없습니다.",
  "modal.share.filter": "연락처 필터링…",
  "modal.share.hint": "목록에서 연락처를 선택하거나 수동으로 별명을 입력하세요.",
  "modal.share.manual": "아니면 수동 닉네임",
  "modal.share.title": "연락처 공유",
  "notes.autosaveHint": "여기에만 자동으로 암호화되어 저장됩니다.",
  "notes.confirmDelete": "이 메모를 삭제하시겠습니까? 복구할 수 없습니다.",
  "notes.contentPlaceholder": "기억해야 할 것은 무엇이든 쓰세요…",
  "notes.delete": "메모 삭제",
  "notes.empty": "이 IKO에는 아직 메모가 없습니다.",
  "notes.emptyPreview": "(비어 있는)",
  "notes.new": "새 메모",
  "notes.startHint": "이 IKO에는 메모가 없습니다. 첫 번째 항목을 만듭니다.",
  "notes.titlePlaceholder": "제목",
  "notes.untitled": "제목 없음",
  "notes.yesterday": "어제",
  "orb.copy.line1": "귀하의 IKO .",
  "orb.copy.line2": "당신의 공간.",
  "orb.mod.audios": "오디오",
  "orb.mod.chat": "채팅",
  "orb.mod.files": "파일",
  "orb.mod.notes": "메모",
  "orb.mod.photos": "사진",
  "orb.mod.vault": "폴더",
  "passwords.confirmDelete": "이 항목을 삭제하시겠습니까? 복구할 수 없습니다.",
  "passwords.copied": "복사됨 ✓",
  "passwords.copy": "복사",
  "passwords.delete": "삭제",
  "passwords.edit": "편집하다",
  "passwords.empty": "아직 이 IKO에 항목을 저장하지 않았습니다.",
  "passwords.field.label": "이름",
  "passwords.field.label.ph": "은행, 계좌, 서비스…",
  "passwords.field.notes": "메모",
  "passwords.field.notes.ph": "유용한 세부정보",
  "passwords.field.password": "비밀번호",
  "passwords.field.password.ph": "저장하고 싶은 비밀번호",
  "passwords.field.url": "URL",
  "passwords.field.username": "사용자 이름",
  "passwords.field.username.ph": "이메일, 별칭, 전화번호...",
  "passwords.hide": "숨다",
  "passwords.new": "신규 항목",
  "passwords.save": "구하다",
  "passwords.show": "보여주다",
  "passwords.startHint": "이 IKO에는 비밀번호가 없습니다. 첫 번째 항목을 만듭니다.",
  "passwords.untitled": "제목 없음",
  "piko.cat.all": "모두",
  "piko.cat.audios": "오디오",
  "piko.cat.cards": "카드",
  "piko.cat.custom": "볼트",
  "piko.cat.agendas": "IKO 디렉터리",
  "piko.cat.storage": "드라이브 및 디스크",
  "piko.cat.files": "파일",
  "piko.cat.identities": "신원",
  "piko.cat.notes": "메모",
  "piko.cat.passwords": "비밀번호",
  "piko.cat.photos": "사진",
  "piko.cat.sshkeys": "SSH 키",
  "piko.cat.videos": "비디오",
  "piko.rail.aria": "개인 IKO 카테고리",
  "piko.rail.head": "개인의",
  "preview.audio": "🎙 오디오",
  "preview.image": "📷 이미지",
  "preview.video": "🎬 비디오",
  "private.badge": "개인의",
  "private.mod.audios": "오디오",
  "private.mod.audios.desc": "녹음 및 음성 메모.",
  "private.mod.files": "파일",
  "private.mod.files.desc": "문서, 시트, PDF.",
  "private.mod.iko": "내 IKO",
  "private.mod.iko.desc": "저장한 IKO 을(를) 활성화할 준비가 되었습니다.",
  "private.mod.notes": "메모",
  "private.mod.notes.desc": "메모, 편지, 일기.",
  "private.mod.photos": "사진",
  "private.mod.photos.desc": "귀하의 개인 갤러리.",
  "private.mod.vault": "비밀번호",
  "private.mod.vault.desc": "비밀번호, 카드, ID, SSH 키 등 필요한 모든 것.",
  "private.mod.videos": "비디오",
  "private.mod.videos.desc": "귀하의 개인 비디오.",
  "private.module.coming": "곧 출시됩니다.",
  "private.module.comingHint": "이 모듈은 곧 제공될 예정입니다. IKO 암호화폐는 이미 작동하고 있습니다. 곧 필요한 모든 것을 여기에 저장할 수 있게 될 것입니다.",
  "private.welcome.hint": "시작할 섹션을 선택하세요.",
  "private.welcome.intro": "당신은 아무도 당신을 볼 수 없는 IKO에 있습니다. 다른 사람이 같은 IKO 을 쓴다고 해도 그들은 다른 세계에 도달할 것입니다. 여기에서는 물건을 안전하게 보관할 수 있습니다.",
  "private.welcome.title": "귀하의 개인 IKO",
  "push.btnDisable": "알림이 켜져 있습니다. 비활성화하려면 클릭하세요.",
  "push.btnEnable": "알림이 꺼져 있습니다. 활성화하려면 클릭하세요.",
  "push.btnOff": "알림 꺼짐",
  "push.btnOn": "알림 켜기",
  "push.introBody": "개인정보 보호를 위해 IKOGNIT 알림은 다른 메시징 앱의 알림과 다릅니다.",
  "push.introBullet1": "메시지 내용은 포함되지 않습니다.",
  "push.introBullet2": "보낸 사람의 이름이나 닉네임은 표시되지 않습니다.",
  "push.introBullet3": "\\\"새 메시지\\\" 알림만 받게 됩니다. 앱을 열어 기기에서 암호화된 내용을 읽으세요.",
  "push.introConfirm": "알림 활성화",
  "push.introTitle": "알림을 활성화하기 전에",
  "recovery.btn.back": "돌아가서 말씀을 보세요.",
  "recovery.btn.cleared": "클립보드가 삭제되었습니다.",
  "recovery.btn.continue": "계속하다",
  "recovery.btn.copied": "복사됨 · {0} 초에 지워짐",
  "recovery.btn.copy": "복사",
  "recovery.btn.copyAria": "복구 문구를 클립보드에 복사(자동으로 지워짐)",
  "recovery.btn.done": "난 끝났어",
  "recovery.btn.download": "다운로드",
  "recovery.btn.downloadAria": "문구를 텍스트 파일로 다운로드",
  "recovery.btn.need3": "올바른 단어 3개를 입력하세요.",
  "recovery.btn.show": "단어 표시",
  "recovery.intro": "이 **24개 단어**는 비밀번호를 잊어버리거나 기기를 분실한 경우 계정과 기록을 복구할 수 있는 유일한 방법입니다. **종이에 적어서 안전한 곳에 보관하세요.** IKOGNIT에 있는 누구도 대신 복구해 줄 수 없습니다.",
  "recovery.title": "복구 키",
  "recovery.verify.correct": "옳은",
  "recovery.verify.intro": "키를 저장했는지 확인하려면 다음 단어를 입력하세요. 제대로 하지 않으면 계속할 수 없습니다.",
  "recovery.verify.wordN": "단어 # {0}",
  "recovery.verify.wrong": "잘못된",
  "recovery.warn": "**오프라인으로 적어주세요.** 스크린샷을 찍지 마세요. 이메일이나 메시지로 보내지 마세요. 이 단어를 가진 사람이 귀하의 전체 계정을 제어합니다.",
  "savediko.activate": "IKO 활성화",
  "savediko.add": "IKO을 저장하세요",
  "savediko.confirmDel": "삭제?",
  "savediko.descLabel": "설명",
  "savediko.descPh": "나중에 인식하기 위한 설명",
  "savediko.empty": "아직 IKO을(를) 저장하지 않았습니다.",
  "savediko.errDesc": "설명을 입력하세요.",
  "savediko.errIko": "IKO를 쓰세요.",
  "savediko.formEdit": "저장된 IKO 편집",
  "savediko.formNew": "IKO을 저장하세요",
  "savediko.intro": "외우고 싶지 않은 IKO는 여기에 보관하세요. 하나만 기억하면 나머지는 그 안에 있습니다.",
  "savediko.ikoLabel": "IKO",
  "savediko.ikoPh": "IKO를 쓰세요",
  "settings.about.tech": "E2E NaCl 상자(X25519)를 사용한 암호화.  IKO : Argon2id 파생 + 결정론적 HMAC. PIN을 통한 Argon2id를 사용한 로컬 암호화 지속성.",
  "settings.about.title": "IKOGNIT에 대하여",
  "settings.about.version": "버전",
  "settings.account.changePassword": "비밀번호 변경",
  "settings.account.confirmPw": "새로운 것을 반복하세요",
  "settings.account.currentPw": "현재 비밀번호",
  "settings.account.email": "이메일",
  "settings.account.emailPh": "이메일@example.com",
  "settings.account.errPwBad": "현재 비밀번호가 올바르지 않습니다.",
  "settings.account.errPwMismatch": "비밀번호가 일치하지 않습니다.",
  "settings.account.errPwShort": "새 비밀번호는 8자 이상이어야 합니다.",
  "settings.account.newEmailPlaceholder": "new@email.com",
  "settings.account.newNickPlaceholder": "new_nick",
  "settings.account.newPw": "새 비밀번호(최소 8개)",
  "settings.account.saving": "절약…",
  "settings.account.success": "비밀번호가 업데이트되었습니다.",
  "settings.account.title": "계정",
  "settings.addYourName": "이름을 추가하세요",
  "settings.blocked.btn": "차단하다",
  "settings.blocked.empty": "차단한 사람이 없습니다.",
  "settings.blocked.hint": "차단된 사용자는 메시지를 보낼 수 없습니다. 그들에게 메시지를 보낼 수도 없습니다.",
  "settings.blocked.placeholder": "차단할 닉",
  "settings.blocked.title": "막힌",
  "settings.blocked.unblock": "차단 해제",
  "settings.close": "닫다",
  "settings.editProfile": "프로필 수정",
  "settings.language.hint": "인터페이스 언어를 선택하세요. 설정은 이 기기에 저장됩니다.",
  "settings.language.title": "언어",
  "settings.legal.cookies": "쿠키 정책",
  "settings.legal.hub": "법률센터",
  "settings.legal.minors": "미성년자 정책",
  "settings.legal.notice": "법적 고지",
  "settings.legal.privacy": "개인 정보 보호 정책",
  "settings.legal.report": "보고 및 조정",
  "settings.legal.rules": "커뮤니티 규칙",
  "settings.legal.terms": "이용약관",
  "settings.legal.title": "법률 정보",
  "settings.messages.title": "메시지",
  "settings.messages.ttl": "기본 만료",
  "settings.messages.ttlHint": "이 시간 이후에는 귀하가 보내는 메시지가 서버에서 삭제됩니다. 파일을 첨부할 때 다른 값을 선택할 수 있습니다.",
  "settings.notif.hint": "브라우저 푸시 알림은 (설계상) 내용이나 보낸 사람 이름 없이 IKOGNIT 일반 메시지에 대해서만 내보내집니다.",
  "settings.notif.preview": "메시지 미리보기 표시",
  "settings.notif.sound": "소리",
  "settings.notif.title": "알림",
  "settings.notif.vibration": "진동(모바일)",
  "settings.privacy.hintFreq": "{0} 에 있을 때만 이 규칙을 재정의하세요.",
  "settings.privacy.hintGlobal": "기본적으로 각 세부 정보를 볼 수 있는 사람을 구성하세요.",
  "settings.privacy.readReceipts": "읽음 확인",
  "settings.privacy.readReceiptsHint": "비활성화하면 메시지를 읽을 때 파란색 체크 표시가 전송되지 않습니다. 다른 사람의 것도 볼 수 없습니다.",
  "settings.privacy.showInfo": "내 정보/상태를 볼 수 있는 사람",
  "settings.privacy.showLastSeen": "내 마지막 연결을 볼 수 있는 사람",
  "settings.privacy.showOnline": "내가 온라인인지 누가 알 수 있나요?",
  "settings.privacy.showPhoto": "내 사진을 보는 사람",
  "settings.privacy.title": "은둔",
  "settings.privacy.whoAdds": "나를 그룹에 추가할 수 있는 사람",
  "settings.profile.adjustPhoto": "사진을 조정하세요",
  "settings.profile.changePhoto": "사진 변경",
  "settings.profile.displayName": "표시 이름",
  "settings.profile.displayNamePh.freq": "(전역에서 상속됨)",
  "settings.profile.displayNamePh.global": "(이름 없음 - 귀하의 닉네임이 표시됩니다)",
  "settings.profile.hintFreq": "이는 {0} 에 있을 때 전역 프로필을 재정의합니다. 여기서 무언가를 정의하지 않으면 전역에서 상속됩니다.",
  "settings.profile.hintGlobal": "이 값은 기본적으로 사용되며 모든 IKO 에 상속됩니다.",
  "settings.profile.info": "정보 / 상태",
  "settings.profile.infoPh": "안녕하세요. 저는 IKOGNIT를 사용합니다.",
  "settings.profile.photo": "프로필 사진",
  "settings.profile.removeOverride": "{0}에 대한 재정의 제거",
  "settings.profile.removePhoto": "사진 삭제",
  "settings.profile.title": "윤곽",
  "settings.profile.warn": "이 IKO에서 상호 작용하면 변경 사항이 나머지 연락처에 자동으로 전송됩니다.",
  "settings.scope.freq": "{0}에서만",
  "settings.scope.global": "전역( IKOGNIT )",
  "settings.session.remember": "활성화된 IKO 기억하기",
  "settings.session.rememberHint": "활성화하면 활성화한 IKO이 사이드바에 바로가기로 나타납니다. 화면을 보는 사람이라면 누구나 어떤 IKO을 입력했는지 알 수 있으므로 기본적으로 비활성화되어 있습니다. 끄면 이미 저장된 내용이 지워집니다.",
  "settings.session.timeout": "비활성 후 IKO을 닫습니다.",
  "settings.session.timeoutHint": "앱을 터치하지 않고 이 시간을 보내면 활성화된 IKO이 자동으로 비활성화되고 IKOGNIT으로 돌아갑니다. \\\"사용 안함\\\"은 앱을 닫을 때까지 IKO를 유지합니다.",
  "settings.session.title": "세션",
  "settings.tab.about": "ℹ 소개",
  "settings.tab.account": "🆔 계정",
  "settings.tab.blocked": "🚫 차단됨",
  "settings.tab.language": "🌐 언어",
  "settings.tab.legal": "합법적인",
  "settings.tab.messages": "✉ 메시지",
  "settings.tab.notifications": "🔔 알림",
  "settings.tab.privacy": "🔒 개인정보 보호",
  "settings.tab.profile": "👤 프로필",
  "settings.tab.session": "⏱ 세션",
  "settings.title": "설정",
  "settings.vis.all": "모든 사람",
  "settings.vis.contacts": "내 연락처",
  "settings.vis.none": "아무도",
  "sidebar.addContact": "닉으로 연락처 추가",
  "sidebar.exitFreq": "IKOGNIT로 돌아가기",
  "sidebar.forget": "기기 잊어버리기",
  "sidebar.freq": "현재 IKO : {0}",
  "sidebar.freqPrivate": "개인용 IKO : {0}",
  "sidebar.freqPsh": "도메인 IKO : {0}",
  "sidebar.freqPublic": "IKO : {0}",
  "sidebar.general": "IKOGNIT",
  "sidebar.logout": "로그아웃",
  "sidebar.newGroup": "새 그룹",
  "sidebar.notifications": "알림",
  "sidebar.remember": "장치 기억",
  "sidebar.savedFreq.tooltip": "{0} 활성화",
  "sidebar.settings": "설정",
  "sidebar.tooltip.logout": "로그아웃하고 로컬의 모든 항목을 삭제합니다.",
  "sidebar.tune": "IKO 활성화",
  "stickers.animals": "동물",
  "stickers.faces": "얼굴",
  "stickers.food": "음식",
  "stickers.gestures": "제스처",
  "stickers.hearts": "하트",
  "stickers.symbols": "기호",
  "timeout.15min": "15분",
  "timeout.30min": "30분",
  "timeout.5min": "5분",
  "timeout.never": "절대",
  "toast.group": "{0} (그룹)",
  "toast.newMessage": "새 메시지",
  "totp.copyCode": "코드 복사",
  "totp.copySecret": "비밀 복사",
  "totp.hideSecret": "비밀 숨기기",
  "totp.invalid": "잘못된 비밀",
  "totp.showSecret": "비밀 표시",
  "ttl.12m": "12개월",
  "ttl.1d": "1일",
  "ttl.1h": "1시간",
  "ttl.1m": "1개월",
  "ttl.1w": "1주",
  "ttl.6m": "6개월",
  "uib.context.coordTitle": "IKO",
  "uib.context.general": "일반 IKO",
  "uib.e2e.label": "블라인드 서버",
  "uib.e2e.title": "서버가 귀하의 콘텐츠를 읽을 수 없습니다. — 귀하의 키로 E2E 암호화",
  "uib.exitLabel": "출구",
  "uib.exitTitle": "일반 IKO로 돌아가기",
  "uib.modes.private": "개인용 IKO",
  "uib.modes.shared": "IKO",
  "uib.nickTitle": "당신의 닉네임",
  "uib.pseudoTitle": "이 IKO에 있는 귀하의 가명",
  "vault.addField": "필드 추가",
  "vault.confirmDelete": "이 항목을 삭제하시겠습니까? 복구할 수 없습니다.",
  "vault.copied": "복사됨 ✓",
  "vault.copy": "복사",
  "vault.delete": "삭제",
  "vault.edit": "편집하다",
  "vault.empty": "저장소가 비어 있습니다. 첫 번째 항목을 만듭니다.",
  "vault.field.address": "주소",
  "vault.field.birthdate": "생일",
  "vault.field.cardBrand": "상표",
  "vault.field.cardCvv": "이력서",
  "vault.field.cardExpiry": "만료(MM/YY)",
  "vault.field.cardHolder": "카드홀더",
  "vault.field.cardNumber": "숫자",
  "vault.field.city": "도시",
  "vault.field.country": "국가",
  "vault.field.dni": "아이디/SSN",
  "vault.field.email": "이메일",
  "vault.field.firstname": "이름",
  "vault.field.labelPh": "필드 라벨",
  "vault.field.lastname": "성",
  "vault.field.name": "이름",
  "vault.field.name.ph": "어떻게 부르나요?",
  "vault.field.newField": "필드",
  "vault.field.password": "비밀번호",
  "vault.field.phone": "핸드폰",
  "vault.field.sshFingerprint": "지문",
  "vault.field.sshHost": "주인",
  "vault.field.sshPrivate": "개인 키",
  "vault.field.sshPublic": "공개키",
  "vault.field.totp": "TOTP",
  "vault.field.url": "URL",
  "vault.field.username": "사용자 이름",
  "vault.field.zip": "우편 번호",
  "vault.fieldPlural": "전지",
  "vault.fieldSingular": "필드",
  "vault.ft.date": "날짜",
  "vault.ft.email": "이메일",
  "vault.ft.number": "숫자",
  "vault.ft.password": "비밀번호",
  "vault.ft.text": "텍스트",
  "vault.ft.textarea": "긴 텍스트",
  "vault.ft.url": "URL",
  "vault.hide": "숨다",
  "vault.new": "새 항목",
  "vault.noMatches": "검색어와 일치하는 항목이 없습니다.",
  "vault.notes": "메모",
  "vault.removeField": "이 필드 삭제",
  "vault.save": "구하다",
  "vault.search": "찾다…",
  "vault.sensitive": "예민한",
  "vault.sensitiveHint": "민감한 필드는 기본적으로 숨겨져 있으며 클립보드에 복사할 수 있습니다.",
  "vault.show": "보여주다",
  "vault.startHint": "왼쪽에서 항목을 선택하거나 새 항목을 만듭니다.",
  "vault.tpl.confirmDelete": "이 템플릿을 삭제하시겠습니까? 생성된 항목은 그대로 유지됩니다.",
  "vault.tpl.edit": "템플릿 편집",
  "vault.tpl.empty": "아직 템플릿이 없습니다. 자신만의 항목 유형을 정의하려면 항목을 만드세요.",
  "vault.tpl.manage": "템플릿 관리",
  "vault.tpl.name": "템플릿 이름",
  "vault.tpl.name.ph": "예: 암호화폐 지갑, 호텔 예약…",
  "vault.tpl.new": "새 템플릿",
  "vault.tpl.title": "템플릿",
  "vault.tpl.yours": "귀하의 템플릿",
  "vault.type.card": "카드",
  "vault.type.custom": "관습",
  "vault.type.identity": "신원",
  "vault.type.login": "로그인",
  "vault.type.sshkey": "SSH 키",
  "vault.untitled": "제목 없음",
  "web.footer.line": "선",
  "web.footer.palette": "팔레트",
  "web.footer.send": "보내다",
  "welcome.btnContacts": "연락처 추가",
  "welcome.btnFreq": "IKO 활성화",
  "welcome.concept": "IKOGNIT에서는 귀하의 닉네임을 식별하는 다른 사용자와 대화합니다. 별도의 공간을 원할 경우 IKO을 활성화하고 IKO로 들어가세요. 공개라면 활성화하는 사람도 만나게 됩니다. 비공개라면 당신만이 존재하는 IKO로 들어갑니다.",
  "welcome.multidevice": "IKO은 어디에도 저장되지 않습니다. IKO을 잊어버리면 해당 IKO는 더 이상 존재하지 않습니다.",
  "welcome.step1": "IKO을 활성화하고 그것을 아는 사람들과 함께 IKO에 들어가세요.",
  "welcome.step2": "여기 IKOGNIT 에 별명을 연락처로 추가하고 대화를 시작하세요.",
  "welcome.step3": "개인용 IKO을 활성화하고 파일, 사진, 오디오, 비디오, 비밀번호, 메모 및 편지를 보관할 수 있는 나만을 위한 IKO를 열어보세요.",
  "welcome.title": "IKOGNIT에 오신 것을 환영합니다",

};

const catalogs: Record<Locale, Catalog> = { es, en, pt, fr, it, de, nl, pl, cs, hu, ro, el, ru, uk, zh, ja, ar, hi, ko };

export function isRTL(loc?: Locale): boolean {
  return RTL_LOCALES.includes(loc ?? currentLocale);
}
export function getDir(loc?: Locale): 'rtl' | 'ltr' {
  return isRTL(loc) ? 'rtl' : 'ltr';
}

const STORAGE_KEY = 'ikognit_locale';
let currentLocale: Locale = detectLocale();
const listeners = new Set<() => void>();

function detectLocale(): Locale {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = (params.get('lang') || '').toLowerCase();
    if (fromUrl && fromUrl in catalogs) {
      try { localStorage.setItem(STORAGE_KEY, fromUrl); } catch (_e) { /* ignore */ }
      return fromUrl as Locale;
    }
  } catch (_e) { /* ignore */ }
  try {
    const saved = localStorage.getItem(STORAGE_KEY) as Locale | null;
    if (saved && saved in catalogs) return saved;
  } catch (_e) { /* ignore */ }
  const browser = (navigator.language || 'es').toLowerCase().slice(0, 2);
  if (browser in catalogs) return browser as Locale;
  return 'es';
}

export function getLocale(): Locale {
  return currentLocale;
}

export function setLocale(loc: Locale): void {
  if (!(loc in catalogs)) return;
  if (loc === currentLocale) return;
  currentLocale = loc;
  try { localStorage.setItem(STORAGE_KEY, loc); } catch (_e) { /* ignore */ }
  // Notificamos a los hooks reactivos por si la pantalla puede actualizarse
  // en caliente (settings, modales, etc).
  // Re-aplica strings que viven en CSS variables (footer atajos, etc).
  applyCssLocaleStrings();
  for (const l of listeners) {
    try { l(); } catch (_e) { /* ignore */ }
  }
}

export function onLocaleChange(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

// Aplica strings que viven en CSS (pseudo-elementos `::after content:`) como
// variables CSS dependientes del idioma. Necesario porque CSS no puede invocar
// t() y los pseudo-content son hardcoded por naturaleza. Llamado al cargar
// modulo y tras reload (setLocale dispara reload).
function applyCssLocaleStrings(): void {
  try {
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    // ⌘ solo existe en teclados Apple: en Windows/Linux el hint correcto es Ctrl.
    const isMacLike = /Mac|iPhone|iPad|iPod/.test(navigator.platform || '');
    const modKey = isMacLike ? '⌘' : 'Ctrl';
    const footer = `"${modKey} K ${t('web.footer.palette')}  ·  ↵ ${t('web.footer.send')}  ·  ⇧↵ ${t('web.footer.line')}"`;
    root.style.setProperty('--shortcuts-footer', footer);
    root.setAttribute('dir', getDir(currentLocale));
    root.setAttribute('lang', currentLocale);
  } catch (_e) { /* ignore */ }
}
// Disparamos al cargar el modulo (idioma ya esta resuelto).
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCssLocaleStrings, { once: true });
  } else {
    applyCssLocaleStrings();
  }
}

export function t(key: string, ...args: Array<string | number>): string {
  const cat = catalogs[currentLocale] || es;
  // Fallback chain: current locale → english (universal) → spanish (source) → key.
  // EN antes que ES porque para un usuario NL/PL/CS/etc el inglés es más útil
  // como red de seguridad que el español.
  let msg = cat[key] || en[key] || es[key] || key;
  if (args.length) {
    for (let i = 0; i < args.length; i++) {
      msg = msg.replace('{' + i + '}', String(args[i]));
    }
  }
  return msg;
}

import { useEffect, useState } from 'react';

export function useTranslation() {
  const [, force] = useState(0);
  useEffect(() => onLocaleChange(() => force((x) => x + 1)), []);
  return { t, locale: currentLocale, setLocale, locales: LOCALES };
}
